module.exports={
"label_emailtocloudcc_department":`แผนก`,
"label.wei.weiresearch":`เวยโพล`,
"message.error.appsecret.null":`รหัสความปลอดภัยต้องไม่ว่างเปล่า!`,
"label.file.orderbylastmodifydate":`จัดเรียงตามวันที่แก้ไขครั้งล่าสุด`,
"label.minus":`- ลบ`,
"label.horizontalbar":`แผนภูมิแท่งแนวนอน`,
"label.emailobject.emailsentfailed":`การส่งอีเมลล้มเหลว!`,
"assignedresource.check":`ทรัพยากรบริการนี้ได้จัดสรรให้กับการนัดหมายการบริการนี้แล้ว โปรดอย่าเพิ่มซ้ํา`,
"label.finish":`เสร็จสิ้น`,
"label.document.history":`ประวัติดาวน์โหลด`,
"label.customfields.number.numberLengthHelpText":`1. ใส่จำนวนตัวเลขและจุดทศนิยม เช่น ใส่ตัวเลขได้ 8 หลัก ทศนิยม 2 ตำแหน่ง จำนวนตำแหน่งมากสุดที่ยอมรับได้ คือ 12345678.90""`,
"label.standard.buttonandlink.info":`การเขียนปุ่มและลิงก์มาตรฐานใหม่ได้เปลี่ยน URL ของ CloudCC และความหมายของการเรียก URL ทั้งหมด (เช่น หน้า CloudCC, ทางลัดของเบราว์เซอร์, หรือระบบภายนอก) คุณสามารถใช้หน้าที่กำหนดเองของ CloudCC เพื่อแทนที่ปุ่มมาตรฐานหรือ URL ของ CloudCC`,
"front-epwechat-module-v1-contacts-desc":`หลังจากเปิดแล้ว จะเพิ่มออบเจ็กต์ผู้ติดต่อวีแชทขององค์กรลงในระบบ CloudCC และข้อมูลลูกค้าในวีแชทขององค์กรจะซิงค์กับออบเจ็กต์นี้`,
"label.mr.caption.contact.result":`ตรวจสอบซ้ำและผสาน: ผลลัพธ์ของการสืบค้นข้อมูลซ้ำของผู้ติดต่อ`,
"label.ems.selectaccount":`เลือกบัญชี`,
"label.group.no.activity":`ไม่มีกลุ่มกิจกรรมที่ตรงกัน`,
"label.call.for":`ผู้เชิญ`,
"label.newreportguide":`ตัวช่วยสร้างรายงานใหม่`,
"component.telerecord.label.name":`ชื่อ`,
"vue.add.dashboard.component":`เพิ่มส่วนเสริม{titleName}`,
"label.chatter.sendEmailToGroupMember.check.V":`ดูโพล`,
"UG.ST.002":`ยืนยัน`,
"label.setting.intergrationmanage":`การจัดการเชื่อมต่อแอป`,
"label.field.apiname.validate":`กรุณากรอกหนึ่งตัวเลขที่อยู่ระหว่าง 0-6`,
"label.emailmerge.list.deletefolder":`ลบโฟลเดอร์`,
"vue_label_pool_received":`ได้รับแล้ว`,
"label_emailtocloudcc_step1_case1":`Email to Case`,
"message.sumlength":`ความยาวรวมตำแหน่งทศนิยมต้องไม่เกิน 18 หลัก`,
"vue_label_approve_reassignapproval":`{name}มอบหมายการอนุมัติใหม่ให้กับ{people}`,
"label.specify.time":`เวลา: 21 มิถุนายน 2559 เวลา 13:00 น.`,
"vue_label_report_sortdown":`เรียงจากมากไปน้อย`,
"chatter.login.now":`กำลังอัปโหลด...`,
"label.import.page2.notsuited":`ไม่ได้แม็ป`,
"label.please.fill.out":`กรุณากรอก`,
"label.recordtype.edit.description":`เลือกหนึ่งรายการจาก "ค่าที่ใช้ได้" และเพิ่มลงในรายการ "ค่าที่เลือก" เพื่อใช้เป็นค่ารายการตัวเลือกสำหรับชนิดบันทึกนี้ โปรดทราบว่าการลบรายการออกจากรายการตัวเลือกจะไม่ลบออกจากบันทึกปัจจุบัน สุดท้ายให้เลือกค่ารายการตัวเลือกเริ่มต้นสำหรับชนิดบันทึก`,
"label.customer.tab.new":`แท็บแบบกำหนดเองใหม่`,
"label.sameas":`เช่นเดียวกับ`,
"front-filter-module-v1-filter-a-week-ago":`สัปดาห์ที่ผ่านมา`,
"label.processsetting.disable.process.failed":`ปิดการใช้งานกระบวนการล้มเหลว!`,
"label.summaryreport.2018.step4":`ขั้นตอนที่ 4: เลือกรายงานมาตรฐาน`,
"label.secrecyinfo":`ข้อมูลลับ-ห้ามเผยแพร่`,
"label.custom.page.component.general.settings":`การตั้งค่าทั่วไปของส่วนเสริม`,
"label.ccpeak.folder":`ประเภทโฟลเดอร์ที่ไม่ได้จัดเก็บถาวร`,
"vue_label_homepage_select_button_operation":`เลือกการทํางานของปุ่ม`,
"message.pleaseinputrightdistance":`กรุณากรอกจำนวนช่วงวันที่ถูกต้อง`,
"label.mobile.phone.required.short":`จำเป็นต้องระบุ`,
"vue_label_account_equityseructure":`โครงสร้างหุ้นทุน`,
"label.file.library.error1":`ไฟล์นี้เก็บเข้าไลบรารีเอกสารเรียบร้อยแล้ว`,
"fliter.nextmonth":`เดือนหน้า`,
"label.mr.descreption.oneGroupNote2":`กลุ่มข้อมูลธุรกิจ มีทั้งหมด`,
"label.allfolderdashboard":`โฟลเดอร์แดชบอร์ดทั้งหมด`,
"lable.opppdt.selPdt.bykeywords":`ตามคีย์เวิร์ด`,
"setup_layout_label_selectedfield":`เลือกฟิลด์`,
"label.file.preview.convert.firstpage.failure":`เกิดข้อผิดพลาดระหว่างการแสดงตัวอย่าง โปรดคลิกรายละเอียดการแสดงตัวอย่างหรือดาวน์โหลดเพื่อดู`,
"vue_label_systemSettings_companie":`การตั้งค่าบริษัท`,
"label.loginhis.recently":`ประวัติกาเข้าสู่ระบบล่าสุด`,
"label.permission.visualpagepermission.edit":`การกำหนดเพจที่กำหนดเอง`,
"label.ccservice.validate.email":`ค่าที่สอดคล้องกันของฟิลด์{1} ภายใต้ออบเจ็กต์ API {0} คือ{2} รูปแบบไม่ถูกต้อง กรุณาใส่ที่อยู่อีเมลที่ถูกต้อง!`,
"label.sms.companyname.gm":`อินเทอร์เฟซข้อความสั้นของเครือข่ายช่วงหมิง`,
"lable.opppdt.addpdt.table.discount":`ส่วนลด (%off)`,
"Lead.Scoring.Setting.LevelSetting":`การตั้งค่าความนิยมของลีด`,
"message.duplication.label.duplicationremark":`เป็นการสืบค้นข้อมูลซ้ำเมื่อบันทึกการสร้างใหม่หรือแก้ไขบันทึก`,
"label.file.preview.error":`เกิดข้อผิดพลาดระหว่างการดูตัวอย่าง กรุณาดาวน์โหลดเพื่อดู`,
"label.imgfield.type.input":`แทรกรูปภาพ`,
"label.file.share.email.content1":`ชื่อไฟล์：#filename`,
"vue_label_notice_batchedit_fail":`การปรับปรุงข้อมูล{0} id ล้มเหลวเนื่องจาก{1}`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`สัปดาห์ที่ 4`,
"label.view.sortview.printview":`ตัวอย่างการพิมพ์`,
"label.projectManagement.Addposttask":`เพิ่มงานถัดไป`,
"vue_label_commonobjects_view_fail":`การตั้งค่ามุมมองเริ่มต้นล้มเหลว`,
"label.dayinweek":`ของสัปดาห์`,
"label.layout.notexist":`ไม่พบเค้าโครง`,
"label.brief.total":`บันทึก {total} รายการ`,
"label.dashboardSetup.tz.bb":`ข้ามไปที่รายงาน`,
"label_emailtocloudcc_select3":`กรุณาเลือกเจ้าของบันทึก`,
"label.input.least.string":`กรุณาใส่อักขระอย่างน้อย {0} ตัว`,
"label.app.step2":`ขั้นตอนที่ 2. ใส่รายละเอียดข้อมูล`,
"lable.account.LastWeek":`สัปดาห์ที่แล้ว`,
"label.notifications":`การแจ้งเตือน`,
"label.tabpage.viewname":`ชื่อมุมมอง`,
"label.knowledge.language.italian":`ภาษาอิตาลี`,
"label.sendmail.step2.introduce":`กรุณาเลือกแม่แบบอีเมลที่ใช้`,
"label_enable_or_no":`เปิดการใช้งานหรือไม่`,
"pagecreator_button_save":`บันทึก`,
"template.chart.cplb":`ประเภทผลิตภัณฑ์`,
"label.knowledge.publish":`ไม่สามารถเผยแพร่ได้หากไม่สอดคล้องกับข้อกำหนด`,
"label.name.required":`ต้องระบุชื่อ`,
"component.chatter.label.myfans":`ผู้ติดตามของฉัน`,
"label.rejectoperate":`ปฎิเสธการดำเนินการ`,
"label.report.action.addtodashboard3":`เลือกแดชบอร์ด`,
"label.icon.101":`หนังสือเรียน`,
"label.data.exp.su.ok":`ระบบกำลังส่งออก`,
"label.appupload.component.type.layout":`เค้าโครงเพจ`,
"template.chart.yscb":`งบประมาณต้นทุน`,
"label.tabularreport.selectorder":`กำหนดลำดับการแสดงผลสำหรับแต่ละคอลัมน์รายงาน`,
"email.title.one":`ดึงรหัสผ่านกลับ`,
"label.case.copy.link":`คัดลอกลิงก์เว็บเพจ`,
"label.mr.descreption.oneGroupReData4":`กลุ่มที่เหลือ`,
"label.newprocess5.error.des":`ใส่ได้เฉพาะตัวเลขเท่านั้น`,
"label.partnerCloud.loginButton":`ปุ่มเข้าสู่ระบบ`,
"label.interfaceconstraint.adminonly":`เฉพาะผู้ดูแลระบบเท่านั้นที่สามารถใช้อินเทอร์เฟซนี้ได้`,
"label.campaign.channel.input.date":`2. โปรดตั้งค่าวันหมดอายุสําหรับช่องทางการขายของคุณ:`,
"label.clientwebsiteentranceprofile":`โปรไฟล์การเข้าเว็บไซต์ของลูกค้า`,
"UG.opportunity.011":`นำเข้าการเสนอขาย`,
"label.page.copy.value.paste.template":`คัดลอกและวางค่าฟิลด์ผสานลงในแม่แบบต่อไปนี้`,
"label.notselect":`ไม่ได้เลือก`,
"label.weixin.input.password":`กรุณาใส่รหัสผ่าน`,
"label.email.select.template":`เลือกแม่แบบ`,
"label_chatter_ok":`ยืนยัน`,
"permissionService.error":`การกำหนดชุดสิทธิ์ล้มเหลว โปรดตรวจสอบว่าสิทธิ์การใช้แอปหมดอายุหรือได้กำหนดถึงขีดจำกัดสูงสุดแล้ว`,
"label.webtocloudcc.sorry":`ขออภัย เกิดความผิดปกติบนหน้าเว็บไซต์โปรดลองอีกครั้งหรือติดต่อผู้ดูแลระบบ!`,
"UG.opportunity.007":`บทบาทผู้ติดต่อ`,
"label.manageAll.forapproval":`รอการอนุมัติ`,
"label.imgfield.type.ref":`รูปภาพสูตร`,
"label.profile.setcustomtab":`ตั้งค่าแท็บที่กำหนดเอง`,
"label.tabpage.datatyoez":`ประเภทข้อมูล`,
"label.partnerCloud.basicSetting.editPersonal":`อนุญาตให้ผู้ใช้พาร์ทเนอร์คลาวด์แก้ไขข้อมูลส่วนบุคคล`,
"label.mr.caption.account":`ตรวจสอบซ้ำและผสาน: เงื่อนไขการสืบค้นข้อมูลซ้ำของลูกค้า`,
"message.serviceterritoryMe.time.violation":`การละเมิดเวลาในการจัดส่ง: ช่วงเวลาการจัดส่งไม่ได้เกิดขึ้นในเวลาที่เป็นสมาชิกของภูมิภาค`,
"pagecreator_page_message_publish_success":`การเผยแพร่หน้าเพจสำเร็จ`,
"label.field.formula.timezonetip":`โปรดทราบว่าเพื่อรองรับหลายโซนเวลาสำหรับฟังก์ชันจัดการประเภทวันที่และเวลา เมื่อใช้ฟังก์ชันของระบบเช่น SYSDATE ในสูตรควรใช้ฟังก์ชันที่รองรับหลายโซนเวลาเพื่อรับเวลาปัจจุบัน เช่น CURRENT_DATE`,
"label.marketseamemset.specialuser":`สมาชิกพิเศษ`,
"label.staticresource.message":`รายละเอียดทรัพยากรแบบคงที่`,
"label.workflow.rulecondition":`เงื่อนไขกฎ`,
"component_salesperformance_label_nodata":`เพิ่มโอกาสทางธุรกิจของคุณ จากนั้นกลับมาที่นี่เพื่อดูกราฟผลการดำเนินงาน`,
"label.customfields.textarea.tip":`อนุญาตให้ผู้ใช้ป้อนข้อความหลายบรรทัดและป้อนอักขระได้สูงสุด 4,000 ตัว`,
"font-evaluate-module-v1-template":``,
"label.step3.total5":`ขั้นตอนที่ 3 จาก 5`,
"label.customfields.formula.percent.tip":`คำนวณเปอร์เซ็นต์ และเพิ่มเครื่องหมายเปอร์เซ็นต์ให้กับตัวเลขโดยอัตโนมัติ`,
"label.sortdesc":`จากมากไปน้อย`,
"lable.PowerProcess.edit":`การแก้ไขกระบวนการให้สิทธิ์`,
"label.dongshifang.description":`กำหนดค่าข้อมูลอินเทอร์เฟซข้อความสั้นของตงสือฟาง เพื่อตอบสนองความต้องการทางธุรกิจในการส่งและรับข้อความสั้นขององค์กร`,
"label.chatter.addressee":`ผู้รับ`,
"vue_label_systemSettings_obj2":`ตัวจัดการออบเจ็ต`,
"label.selectreporttype.tip":`เลือกประเภทข้อมูลที่คุณจะรวมไว้ในรายงาน`,
"label.version.enterprise":`รุ่นเอนเทอร์ไพรซ์`,
"label.area.add":`เพิ่มภูมิภาค`,
"label.h5.bookmarked":``,
"label.step5.total7":`ขั้นตอนที่ 5 จาก 7`,
"front-lightning-module-v1-title-quotation":`แสดงตัวอย่างใบเสนอราคา`,
"label.search.onlymyrecords":`จำกัดอยู่ในรายการที่ฉันมี`,
"vue_label_commonobjects_noduplication":`ซ้ำกับ{ฟิลด์}ใน{บันทึก}`,
"label.customerpage.edit":`แก้ไขเมนูเพจที่กำหนดเอง`,
"message.please.choose.user":`โปรดเลือกผู้ใช้`,
"label.approval.his.currentactor":`ผู้อนุมัติปัจจุบัน`,
"label.field.duplicate.error.msg3":`สร้างฟิลด์คุณสมบัติเฉพาะได้สูงสุดสามฟิลด์`,
"label.page_url":`ลิงก์เพจ`,
"label.permission.goback":`กลับไปที่ภาพรวมของชุดสิทธิ์`,
"vue_label_commonobjects_view_kanban_notice2":`หากต้องการดูบันทึกทั้งหมด โปรดใช้รายการหรือมุมมองแยกหน้าจอ`,
"label.group.no.recent.searchs":`ไม่มีกลุ่มที่ดูล่าสุดที่ตรงกัน`,
"label.event.fiducial.point":`จุดดัชนี`,
"label.integrations.mailchimp.addtolist":`นำลีดและผู้ติดต่อใน CloudCC ไปเพิ่มในรายการผู้รับ Mailchimp`,
"label.workflow.configrule.introduce":`ป้อนชื่อกฎ หมายเหตุ และเงื่อนไขทริกเกอร์กฎเวิร์กโฟลว์ ในขั้นตอนถัดไป เชื่อมโยงงานในเวิร์กโฟลว์กับกฎเวิร์กโฟลว์นี้`,
"label.icon.161":`กระเป๋าเดินทาง`,
"label.recordtype.enable":`เปิดการใช้งาน`,
"label_mailboxes_limit":`จํานวนอีเมลเกินขีดจํากัด`,
"label.notification.time3":`{0} ชั่วโมงก่อน`,
"label.setsharerule.step2":`ขั้นตอนที่ 2: เลือกเงื่อนไขการแบ่งปัน`,
"vue_label_homepage_somecomponents":`คําเตือน! หลังจากเพิ่มส่วนเสริมที่มีความสูงเกินทําให้แสดงผลได้ไม่เต็มจอ โปรดลบส่วนเสริมบางอย่าง`,
"label.icon.63":`ท่อน้ำใต้ดิน`,
"label.use.standard.sharerules":`ใช้กฎการแบ่งปันมาตรฐาน`,
"label.button.step2.select.required.field":`ขั้นตอนที่ 2: เลือกฟิลด์บังคับ`,
"lable.Confirm.collect.potential.customers":`ยืนยันรับลีด{name}`,
"label.version.sum.custompage":`เพจที่กำหนดเอง`,
"label.file.ccchat.changefile":`แก้ไขไฟล์`,
"label.mobile.phone.phone.call":`โทรศัพท์`,
"label.appupload.managed.img":`มีการจัดการ`,
"vue_label_chatter_comment":`แสดงความคิดเห็น`,
"label.central.european.time":`เวลายุโรปกลาง`,
"label.three.quarter":`ไตรมาสที่สาม`,
"label.service.newBuildDialog.filter.editor":`ตัวแก้ไขตัวกรอง`,
"pagecreator_systemstyle_funcpath":`/ตัวสร้าง/ไลบรารีรูปแบบแบรนด์`,
"label_chatter_collect":`บุ๊กมาร์ก`,
"label.custom.page.component.window.settings":`การตั้งค่าหน้าต่างส่วนเสริม`,
"component_chatter_file_label_title":`อัปโหลดไฟล์`,
"label.marketsea.button.discard":`ทิ้ง`,
"label.Batch.input":`การนำเข้าแบบกลุ่ม`,
"vue_label_campaign_market_members":`สมาชิกแคมเปญปัจจุบัน`,
"label.salescloud.salesdashboard":`คัมบังพนักงานขาย`,
"message.summaryconditionrepeated":`เงื่อนไขของการสรุปซ้ำ กรุณาเลือกใหม่!`,
"label.tianyancha.h5.companycode":`รหัสบริษัท`,
"label.quickbooks.description":`กําหนดค่าข้อมูลบัญชี QuickBooks เพื่อติดตามการชําระใบแจ้งหนี้ออนไลน์ของคุณ`,
"label.colombia.time":`เวลาโคลอมเบีย`,
"label.usermanage.unknown.license":`ใบอนุญาตที่ไม่รู้จัก ไม่สามารถสร้างผู้ใช้ได้ กรุณาติดต่อผู้ดูแลระบบ!`,
"label.operatedata.selectoperateandobject":`เลือกการดำเนินการ (นำเข้าหรือส่งออก) และเลือกออบเจ็กต์`,
"message.setup.field.picklist.valuerepeated":`ค่ารายการซ้ําไม่ได้ โปรดป้อนอีกครั้ง!`,
"label.editerror.list":`รายการข้อมูลที่ไม่ได้แก้ไข`,
"pagecreator_page_message_save_success":`การบันทึกหน้าเพจสำเร็จ`,
"label.icon.154":`คอมพิวเตอร์`,
"label.emailsync.setting":`การตั้งค่าอีเมลส่วนตัว`,
"label.startuploadfile.step2":`ขั้นตอนที่ 3. คลิกปุ่ม "เริ่มการอัปโหลด" เพื่ออัปโหลดไฟล์`,
"label.dashboard.notmeet.conditions":`ไม่มีข้อมูลที่สอดคล้องกับเงื่อนไข และยังไม่ได้กำหนดค่าแดชบอร์ด!`,
"label.temp.del.conf":`ยืนยันว่าจะลบหรือไม่?`,
"label.sms.authkey":`รหัสผ่านการพิสูจน์ตัวตน`,
"lable.oppt.jieduan.choosejieduan":`เลือกสเตจที่สิ้นสุดแล้ว`,
"label.tabpage.viewNamez":`กรุณาใส่ชื่อมุมมอง`,
"label.totalQuotation":`ยอดรวมใบเสนอราคา`,
"label.tabpage.hoursagoz":`ชั่วโมงก่อน`,
"label.receiveadminnews":`รับจดหมายข่าวจากผู้ดูแล`,
"label.field.is.lookup":`เชื่อมโยงฟิลด์กับฟิลด์ที่ค้นหาหรือไม่`,
"label.any_changes":`การเปลี่ยนแปลงใด ๆ ที่นี่จะได้รับการอัปเดตในส่วนท้ายด้านล่าง`,
"lable.products.to.assets":`ยืนยันว่าจะโอนผลิตภัณฑ์ไปยังสินทรัพย์?`,
"label.dashboard.compare":`เปรียบเทียบ`,
"vue_label_chatter_notice1":`การลบกลุ่มจะลบข้อมูลทั้งหมดในกลุ่ม แต่ไฟล์กลุ่มจะไม่ถูกลบ`,
"label_tabpage_exitz":`ออก`,
"label.potentialcustomerflow":`การไหลของลีด`,
"label.longtext":`กล่องข้อความยาว`,
"october":`เดือนตุลาคม`,
"label.customer.email":`อีเมล`,
"label.partnerCloud.productSet.addChildren":`เพิ่มระดับลูก`,
"label.defaultline.cannot.greater":`จำนวนแถวเริ่มต้นต้องไม่เกิน 30 แถว`,
"front-detail-module-v1-view-report":`ดูรายงาน`,
"label.knowledge.setting.hint.sixteen":`บันทึกความรู้เพื่อเผยแพร่ต่อไป`,
"label.page.use.merged.field":`ใช้ฟิลด์ผสาน`,
"label.salescloud.salescloud.continuerecover":`หากยังดำเนินการต่อจะทำการลบและไม่สามารถกู้คืนได้อีก:`,
"front-project-module-v1-from-template-create":`สร้างใหม่จากแม่แบบ`,
"label.exportall":`ส่งออกทั้งหมด`,
"label.weixin.recalculate.shared.results":`คำนวณผลลัพธ์ของกฎการแบ่งปันใหม่`,
"label.components.isTemplate":`เป็นข้อมูลแม่แบบใช่หรือไม่`,
"label_emailsync_status":`สถิติการใช้อีเมลของผู้ใช้งาน`,
"label.file.library.delete":`ยืนยันว่าต้องการลบ {librayrname} หรือไม่？`,
"label.integrations.username":`ชื่อผู้ใช้`,
"front-lightningset-module-v1-detail-page-report-chart":`แผนภูมิรายงานหน้ารายละเอียด`,
"label_tabular":`รายการตาราง`,
"label.approverecords":`บันทึกการอนุมัติ`,
"vue_label_helpcenter_topic":`การใช้และความช่วยเหลือรุ่น lightning`,
"label.h5.date.none":`-ไม่มี-`,
"lable.outlook.mcto.allrecord":`บันทึกทั้งหมด`,
"label.readandwrite":`อ่าน/เขียน`,
"label.allfold":`ยุบทั้งหมด`,
"AD":`ที่อยู่`,
"message.custom.field.donotdelete.reporttype":`ฟิลด์ข้อมูลนี้ถูกอ้างอิงโดยแหล่งข้อมูลรายงาน`,
"label.escalation.setup.newaction.title":`แก้ไขการดำเนินการเลื่อนขั้น`,
"label.dashboard.snapshot.settings":`การตั้งค่าสแนปชอตแดชบอร์ด`,
"label.attendance.inner":`ทำงานภายในบริษัท`,
"chatter.ns":`ข้อความใหม่`,
"label.validate.nowork":`ข้อผิดพลาด: ฟิลด์ไม่ถูกต้อง โปรดเลือกตำแหน่งที่ผิดพลาดอีกครั้ง`,
"label.custom.EmptyCanvas":`ล้างแคนวาส`,
"label.service.miniProgram.fillImageOrder":`กรุณากรอกลําดับภาพสไลด์`,
"label.icon.16":`ซ่อมบำรุง`,
"label.selected":`ที่เลือก`,
"component_chatter_link_label_name":`ชื่อลิงก์`,
"label.reportsSubscriptionPage.schedulereport.starttime":`เวลาเริ่มต้น`,
"label.file.uploadNewVersion":`อัปโหลดรุ่นใหม่`,
"chatter.group.theMembership":`สมาชิกสัมพันธ์`,
"label.knowledge.recommended.articles":``,
"label.appupload.install.parentobj":`ออบเจ็กต์พาเรนต์`,
"label.file.recent":`ล่าสุด`,
"vue_label_helpcenter_quote":`ใบเสนอราคาเป็นราคาที่แนะนำสำหรับผลิตภัณฑ์และบริการของบริษัทของคุณ คุณสามารถสร้างใบเสนอราคาจากโอกาสทางธุรกิจและผลิตภัณฑ์ของพวกเขาได้ <br>ที่มุมขวาบนของรายละเอียด คุณสามารถใช้ปุ่มเพื่อซิงค์ใบเสนอราคาจากโอกาสทางธุรกิจ หรือซิงค์ใบเสนอราคาจากโอกาสทางธุรกิจ เมื่อใบเสนอราคาถูกซิงค์กับโอกาสทางการขาย เมื่อเกิดการเปลี่ยนแปลงใดๆ ในใบเสนอราคา ผลิตภัณฑ์ของโอกาสทางการขายก็จะเปลี่ยนแปลงด้วย ในทางกลับกัน โอกาสทางธุรกิจแต่ละรายการสามารถเกี่ยวข้องกับหลายใบเสนอราคา ซึ่งหนึ่งในนั้นสามารถซิงค์กับโอกาสทางธุรกิจได้ <br>ที่มุมขวาบนของรายละเอียด คุณสามารถสร้างใบเสนอราคาเป็น pdf และดูตัวอย่าง และพิมพ์ ดาวน์โหลด หรือบันทึกได้โดยตรง`,
"message.error.field.default":`ค่าเริ่มต้นต้องเป็นจำนวนเต็มบวก`,
"label.campaignmember.main.importmember.contacts.desc":`นำเข้าข้อมูลในไฟล์ไปยังผู้ติดต่อของแคมเปญนี้`,
"vue_label_calendar_show_only_this_calendar":`แสดงเฉพาะปฏิทินนี้`,
"vue_label_quot_syncfrom":`ซิงค์จากโอกาสทางธุรกิจ`,
"label.data.expnode.e_desc2":`2. ส่งออกตามแม่แบบ: ผู้ใช้สามารถเลือกแม่แบบที่ใช้ในการส่งออกข้อมูล`,
"label.login.verification.mfa.desc1":`คุณต้องติดตั้งแอปพลิเคชัน MFA บนอุปกรณ์ของคุณก่อนดำเนินการ แอปพลิเคชันที่รองรับ MFA บนอุปกรณ์ได้แก่ Onion และ Google Authenticator`,
"label.jiandangfenpei.desc":`กําหนดสิทธิ์การเข้าถึงเพจแบบกําหนดเองปัจจุบันของโปรไฟล์ ผู้ดูแลระบบสามารถเข้าถึงเพจแบบกําหนดเองทั้งหมดได้`,
"label_tabpage_thisrecord":`บันทึกนี้`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`ยอดเก็บเงินสะสม`,
"message.error.object.notvalidcurrency":`สกุลเงินไม่ถูกต้อง`,
"label.edit.discount":`แก้ไขส่วนลด`,
"label.setup.mobile.offlinecache.setenable":`เปิดใช้งานฟังก์ชัน Mobile Offline`,
"UG.ST.005":`ฉันเข้าใจแล้ว ไม่ต้องแสดงหน้านี้อีกครั้งหน้าให้เข้าไปโดยตรง`,
"label.assignedapprover":`มอบหมายผู้อนุมัติแล้ว`,
"template.chart.htlx":`ประเภทสัญญา`,
"scope":`อยู่ในขอบเขต`,
"label.workmate.search":`ค้นหาเพื่อนร่วมงาน`,
"message.validation.isnotdigits":`ใส่ตัวเลขที่ถูกต้อง`,
"label.ccpeak.use.class.time.page":`หากเพจที่กำหนดเองเรียกใช้คลาสนี้ คุณต้องเรียกใช้เมธอด invoker () ในคลาส PageClsInvoker`,
"setup_mainpage_label_welcome27":`ในแพลตฟอร์มคลาวด์ CloudCC มีฟังก์ชันเกี่ยวกับข้อมูลทั้งหมด เช่น นําเข้า ส่งออก ลบข้อมูลแบบกลุ่ม โอนย้ายแบบกลุ่ม เป็นต้น`,
"front-epwechat-module-v1-epwechat-integrate":`การเชื่อมโยงวีแชทขององค์กร`,
"label.file.publiclink":`ลิงก์สาธารณะ`,
"front-epwechat-module-v1-input-name":`กรุณากรอกชื่อองค์กร`,
"lable.Number.of.columns":`จำนวนคอลัมน์`,
"message.error.dev.service.duplicateparameter":`พารามิเตอร์บริการซ้ำ!`,
"label.projectManagement.percent.complete":`เปอร์เซ็นต์เสร็จสมบูรณ์`,
"label.chatter.nextSevenday":`7 วันถัดไป`,
"chatter.feed.myfollowers":`ผู้ติดตามของฉัน`,
"label.bacchtransfer.pleaseselecttouser":`กรุณาเลือกโอนไปยังผู้ใช้`,
"label_partner_workspace_member_memo":`ผู้ใช้ทั้งหมดของโปรไฟล์และชุดสิทธิ์ที่เลือกสามารถเข้าถึงพาร์ทเนอร์คลาวด์นี้ได้`,
"label.marketsea.chosen.member":`สมาชิกที่เลือก`,
"label.marketsea.assignment.setup":`การตั้งค่าการมอบหมาย`,
"label.myaccount":`ลูกค้าของฉัน`,
"label.schedulejob.setup.schedule.executedate":`เวลาดำเนินการ`,
"label.uploadaccessory":`อัปโหลดไฟล์แนบ`,
"Homepage.News.004":`ไม่มีข่าว`,
"label.marketsea.name":`ชื่อฐานข้อมูล`,
"label.pending.task":`ภารกิจที่ต้องทำ`,
"label.report.details":`รายละเอียด`,
"UG.homepage.008":`ทำความเข้าใจสถานะของธุรกิจในปัจจุบัน (รายงานสรุปการขาย การจัดอันดับ กรวยการขาย เป็นต้น)  ตรวจสอบโอกาสทางธุรกิจที่อาจมีปัญหาอยู่ พยากรณ์ผลสำเร็จ รับพิจารณาและมอบหมายเรื่องสำคัญทันที ทำการตัดสินใจได้อย่างชาญฉลาด`,
"label.h5.similar.opportunity.clear.all":`ล้างทั้งหมด`,
"label.tabpage.noz":`ไม่`,
"label.report.recent.all.reports":`รายงานทั้งหมด`,
"vue_label_lead_to_score":`คลิกให้คะแนนเพื่อให้คะแนนลีดในมุมมองปัจจุบัน`,
"vue_label_normal_receivable_sf":`แผนการเก็บเงิน`,
"label.layout.edittabdistribute":`แก้ไขเค้าโครงแท็บ`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(field)`,
"label.salescloud.field.editoptionlist":`แก้ไขรายการตัวเลือก`,
"APPIntegration.Dropbox.01":`เลือกไฟล์จาก Dropbox`,
"label.campaign.channel.step2":`ขั้นตอนที่ 2: การตั้งค่าเริ่มต้นของฟิลด์ลีดของช่องทางการขาย`,
"label_partner_new_function":`คำอธิบายฟังก์ชัน`,
"vue_label_chat_no_search_results":`ไม่พบผลการค้นหา`,
"vue_label_commonobjects_detail_visitstate":`สถานะการเข้าพบ`,
"label.sendemail.send.testemail":`นี่คืออีเมลทดสอบ หากคุณได้รับอีเมลนี้ได้ แสดงว่าคุณสามารถใช้อีเมลนี้เพื่อส่งได้`,
"label.attendance.clear.position":`ล้างที่หมาย`,
"chatter.write.n":`เขียนคำอธิบายประกอบ...`,
"label_chatter_sendmail":`ส่งอีเมล`,
"label.remindertime":`เวลาแจ้งเตือน`,
"label.app.elegantgray":`สีเทาอ่อน`,
"label.tabpage.ownedz":`เป็นเจ้าของร่วม`,
"label.select.approval":`เลือกผู้อนุมัติ`,
"UG.Lead.007":`ซิงค์ Google`,
"chatter.emailSetUp":`ตั้งค่าการแจ้งเตือน CCChat ของฉัน`,
"label.default.censor":`ผู้ตรวจสอบเริ่มต้น`,
"vue_label_notice_uploadavatar_success":`อัปโหลดรูปโปรไฟล์สำเร็จ`,
"label.sms.title":`ข้อมูลอินเทอร์เฟซข้อความสั้น`,
"front-console-choose-contact":``,
"label.field.edit.des":`การให้คะแนนสูงสุดจะควบคุมจำนวนไอคอนรูปดาวที่แสดง คะแนนสูงสุดคือ 100`,
"label.pw.big.letter":`ตัวพิมพ์ใหญ่`,
"label.select.time.dimension":`โปรดเลือกมิติด้านเวลา`,
"UG_Campaign_004":`นำเข้าแคมเปญ`,
"label.dashboard.summary":`เมตริก`,
"label.ems.yahoo":`ยาฮู`,
"label.leadscore.rule.name":`ชื่อเกณฑ์การให้คะแนน`,
"vue_label_calendar_object_name":`ชื่อออบเจ็กต์`,
"label.icon.69":`เครื่องจักร`,
"label.reporttotal":`ทั้งหมด`,
"lable.SalesCommitmentKanBan.theActualContract":`จำนวนสัญญาจริง`,
"label.project.member.data":`ผู้ใช้นี้เป็นสมาชิกของโครงการปัจจุบันแล้ว!`,
"label.cloudccclass.list.viewremark":`ดูคู่มือการใช้งาน`,
"label.deleteObject.isNotAdministrator":`ไม่ใช่ผู้ดูแลระบบลบออบเจ็กต์ไม่ได้`,
"lable.edit.queue.nameandemail":`ชื่อคิวและอีเมลแอดเดรส`,
"label.recordtype.tabname":`ชนิดบันทึก`,
"label.file.is.ok":`ยืนยันหรือไม่`,
"label.knowledge.language.german":`ภาษาเยอรมัน`,
"label.layout.realityapprover":`ผู้อนุมัติจริง`,
"label.ems.with7day":`ภายใน 7 วัน`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`ติดตั้ง`,
"label.weixin.edit.polls":`แก้ไขโพล`,
"label.layout.mobile.default.tab":`เลือกแท็บเริ่มต้นของโทรศัพท์มือถือ`,
"vue_label_report_deletegroupcolumn":`ลบคอลัมน์กลุ่ม`,
"label.group.archived.success":`การจัดเก็บถาวรสำเร็จ`,
"label.customfields.formula.returntype":`ประเภทการส่งคืนของสูตร`,
"label.file.followers":`ผู้ติดตาม`,
"label.textmessage.new.templates.message1":`ชื่อแม่แบบข้อความสั้นไม่สามารถว่างเปล่า!`,
"label.selected.field.length":`ฟิลด์ที่เลือกต้องไม่เกิน 10 ฟิลด์`,
"ObjectDetailed_ViewKeyInformation_Layout":`แก้ไขข้อมูลคีย์`,
"label.paging.totalofpage":`ทั้งหมด {0} หน้า`,
"label.ccchat.message.new.error41":`อยากคุยกับคนให้มากขึ้นก็ลองใช้ทีม`,
"message.recordtype.detail.noselectlist":`ไม่มีรายการตัวเลือกที่จะแสดง`,
"label.conditiontag.lookup.title":`เลือกค่ารายการตัวเลือกที่จะเพิ่มด้านล่าง`,
"label_partner_setup":`การตั้งค่าพาร์ทเนอร์คลาวด์`,
"front-epwechat-module-v1-android-packname":`ชื่อแพ็กเกจแอป Android:`,
"lable.custom.Current.CY":`ปีที่กำหนดเองปัจจุบัน`,
"label.newprocess2.desc":`หากส่วนลดมากกว่า 0.3% แสดงว่าการประเมินเป็นจริง`,
"label.operatedata.selectobjectfields":`เลือกฟิลด์ออบเจ็กต์ส่งออก`,
"report_reportdatasource_label":`แหล่งข้อมูลรายงาน`,
"label.chosesubject.others":`กิจกรรมอื่นๆ`,
"label.list.desc2":`Web to CloudCC มีสองรุ่นคือ รุ่นสำหรับ  PC และรุ่นสำหรับอุปกรณ์มือถือ รุ่นสำหรับ PC สามารถเข้าทางคอมพิวเตอร์ และรุ่นสำหรับอุปกรณ์มือถือสามารถเข้าทางเข้าทางโทรศัพท์มือถือ เช่น วีแชท`,
"vue_group_several_groups":`{totalSize} กลุ่ม`,
"label.page.button.linkurl":`ปุ่มหรือลิงก์ URL`,
"show.week":`แสดงวันสุดสัปดาห์`,
"label.gotocalendar.new":`สร้างอิเวนต์ในปฏิทิน`,
"button.reset.advancedsearch":`ล้างเกณฑ์การค้นหาขั้นสูง`,
"label.h5.chatter.feedandcomnum":`โพสต์และแสดงความคิดเห็น`,
"lable.opppdt.addpdt.table.unitprice":`ราคาขาย`,
"label.dataimport.validate":`เลือกการทวนสอบที่ต้องการดำเนินการ`,
"label.lead.score":`การให้คะแนนลีด`,
"vue_label_help_product":`ผลิตภัณฑ์และสมุดราคา`,
"label.role.select":`บทบาทที่เลือก`,
"lable.opppdt.selPdt.searchproduct":`ค้นหาผลิตภัณฑ์`,
"component_event_label_newevent":`อิเวนต์ใหม่`,
"front-invoice-online-payment-setup-configure-button":``,
"label.stdashbord.xsld.business.img2":`ความน่าจะเป็นของยอดเงินรวมในสเตจ 1%-99%`,
"label.event.moveup.2week":`ล่วงหน้า 2 สัปดาห์`,
"label.partnerCloud.priceOfManual.allCustomer":`ลูกค้าทั้งหมด`,
"lable.account.dep":`คลิกปุ่ม "สร้างใหม่" เพื่อกำหนดปีงบประมาณใหม่`,
"label.dataimport.insertdata.error.null.update":`ค่าของ$ Schemefield_name $ในบันทึกนี้ว่างเปล่า ไม่สามารถดำเนินการอัพเดตได้ บันทึกนี้ถูกละเว้นสำหรับการนำเข้า`,
"label_component_helper_businesschange_0activity":`ไม่มีกิจกรรมใดในช่วง 30 วัน`,
"lable.account.NextbbDays":`60 วันถัดไป`,
"label_scope_length":`ความยาวของช่วง`,
"label.customfields.operation":`ดำเนินการส่งออกข้อมูล`,
"serviceappointment.save.workorder":`โปรดเลือกใบสั่งงานที่เกี่ยวข้องกับรายการบรรทัดใบสั่งงาน`,
"label.field.update.hide.editor":`ซ่อนตัวแก้ไขสูตร`,
"button.partner.new":`พาร์ทเนอร์คลาวด์ใหม่`,
"label.stdashbord.xsld.business.oppdetails":`ตารางรายละเอียดธุรกิจ`,
"message.pleasewaitingnextversion":`ฟังก์ชันนี้จะเปิดตัวในรุ่นถัดไป โปรดอดใจรอ!`,
"label_tabpage_potentialcustomersz":`ลีด`,
"label_emailtocloudcc_step2":`ขั้นตอนที่ 2`,
"label.weixin.username":`ชื่อ`,
"label.quickbooks.viewlist.type":`ประเภท`,
"front-kefu-moudle-v1-Select-seats":`เลือก Seat`,
"label.customsetting.manage":`จัดการ`,
"label.tabpage.field":`ฟิลด์`,
"label.custom.page.button.icon.URL":`ปุ่มไอคอน URL`,
"font-evaluate-module-v1-evaluation-link":``,
"vue_label_salesfunnel_notice3":`ความน่าจะเป็นของจำนวนรวมโอกาสทางธุรกิจ 1% -99%`,
"front-email-payment-describe":``,
"label.productsales.today.noevttskaddevt":`วันนี้ไม่มีอิเวนต์ที่ยังไม่ได้ดำเนินการหรือภารกิจที่ครบกำหนด คุณสามารถคลิก" "บนขวามือเพื่อเพิ่มอิเวนต์`,
"component.setup.iframe.label.memo":`คลิกไอคอนการตั้งค่า และป้อนที่อยู่ URL ที่จะฝัง`,
"front-email-payment-select-country":``,
"label.ems.starred":`ใส่ดาวให้กับอีเมล`,
"component_setup_label_object":`ออบเจ็กต์`,
"label.query.detail.viewpartneruser":`ดูผู้ใช้พาร์ทเนอร์`,
"this.year":`ปีนี้`,
"serviceresource.isactive.notactive":`ไม่ได้เปิดใช้งานทรัพยากรบริการนี้`,
"label.marketing.message.recipientisnull":`ผู้รับไม่สามารถว่างเปล่า`,
"label.unfold":`ขยาย`,
"label.service.assetBOM.view.tip":`โปรดติดต่อผู้ดูแลระบบ คุณไม่มีสิทธิ์ดู BOM สินทรัพย์`,
"label.validate.function.funcExplain.ISCHANGED":`ตรวจสอบว่าค่าฟิลด์ต่างกับค่าก่อนหน้าหรือไม่ หากต่างจะส่งกลับค่า TRUE มิฉะนั้นจะส่งกลับค่า FALSE`,
"label.validate.function.funcExplain.NOW":`ส่งกลับวันที่และเวลาปัจจุบัน`,
"label.phoenix.islands.time":`เวลาหมู่เกาะฟีนิกซ์`,
"vue_label_checkduplicate_complete_filter_rules":`กรุณากรอกข้อมูลเงื่อนไขตัวกรองให้ครบถ้วน`,
"vue_label_report_rowcount":`นับจำนวนแถว`,
"chatter.p":`ส่วนบุคคล`,
"label.umeng.activity.distributetask":`มอบหมายภารกิจให้คุณแล้ว`,
"UG_quota_05":`การซิงค์โอกาสทางธุรกิจแบบสองทาง`,
"june":`เดือนมิถุนายน`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`วันอังคาร`,
"vue_label_commonobjects_view_chart_upto5":`แสดงมากที่สุด 5 กลุ่ม`,
"vue_label_opportunity_contactrole_searchallcontacts":`ค้นหาในผู้ติดต่อทั้งหมด`,
"label.custom.field.task.notice":`แจ้งเตือนภารกิจ`,
"label.weixin.insert.address":`แทรกตำแหน่งที่ตั้ง`,
"label.attachementNew.desc":`จัดเก็บไฟล์แนบเข้าแฟ้มอย่างถาวร และไม่สามารถลบไฟล์แนบได้`,
"setup_mainpage_label_welcome18":`การตั้งค่าสิทธิ์ระดับองค์กรของ CloudCC ช่วยให้คุณสามารถควบคุมการเข้าถึงของผู้ใช้แต่ละรายเมื่อทํางานกับข้อมูลและโมดูล การตั้งค่าสิทธิ์ตามบทบาทยังรวมถึงตำแหน่ง กลุ่ม บทบาท กฎการแบ่งปันข้อมูล การควบคุมความปลอดภัยระดับเฟิลด์ของผู้ใช้ ตระหนักถึงการแบ่งปันข้อมูลระหว่างบุคคลและแผนกต่างๆ ขององค์กร`,
"front-kefu-instance-noarea":``,
"label.please.ChooseMax":`โปรดเลือกผลิตภัณฑ์ไม่เกิน {0} รายการ`,
"label.businesschance":`โอกาสทางธุรกิจ`,
"label.verticalline-group":`คอลัมน์แนวตั้ง-การจัดกลุ่ม`,
"label.ordering.platform":`แพลตฟอร์มการสั่งซื้อ`,
"label.product.pricebooks.ples":`โปรดเลือกสมุดราคา`,
"vue_label_norm_addcomponent":`เพิ่มส่วนเสริม`,
"label.ServiceCloud.Installation.address":`ที่อยู่การติดตั้ง`,
"vue_label_report_groupcolumn":`กลุ่มคอลัมน์`,
"label.ccchat.person.invite.notallsucc":`บันทึกที่อยู่อีเมลแล้ว {0} รายการ แต่ยังไม่ได้ส่ง ในส่วนของการส่งคำเชิญให้แก้ไขข้อผิดพลาดต่อไปนี้แล้วคลิกส่ง`,
"label.customfields.optionlist.tip":`อนุญาตให้ผู้ใช้เลือกค่าจากรายการที่กำหนด`,
"UG.activity.07":`สร้างภารกิจ`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`สัปดาห์สุดท้าย`,
"label.permission.accessname":`ชื่อกลุ่มสิทธิ์`,
"lable.custom.year.stadate":`วันเริ่มต้นปีที่กำหนดเอง`,
"label.ems.inputmails":`เซิร์ฟเวอร์อีเมลขาเข้า (I)`,
"label.cpq.quote.transfer.order.already":`ใบเสนอราคานี้แปลงเป็นใบสั่งซื้อแล้ว โปรดลบใบสั่งเดิมก่อนที่จะสร้างใบสั่งซื้อใหม่`,
"label.sendletter.status":`สถานะของสมาชิกแคมเปญ`,
"vue_label_commonobjects_view_save_as_view":`บันทึกเป็นมุมมอง`,
"message.mobilechooseatmostfive":`เลือกฟิลด์ได้มากที่สุดห้าฟิลด์`,
"label.errormessage.batchedit.nopermission":`ไม่มีบันทึกข้อมูลที่คุณแก้ไข`,
"label.dataoperate.tip":`กรุณาเลือกการดำเนินการ และออบเจ็กต์ที่จะใช้งาน`,
"label.enableoperate":`ใช้งานได้`,
"label.ems.usernamepassword.error":`ที่อยู่อีเมลหรือรหัสผ่านไม่ถูกต้อง`,
"label.campaignmember.selectmember.deletemember":`ลบสมาชิกจาก`,
"label.Tab":`แท็บ`,
"label.emailobject.template.message1":`โปรดเลือกฟิลด์และคลิก "แทรก" ตามด้วยป้ายกำกับ ">" ยังมีฟิลด์พร้อมใช้งานเพิ่มเติม`,
"label.approvalstep3.tip":`กำหนดผู้ใช้ที่จะบันทึกขั้นตอนนี้ สามารถเลือกได้ว่าจะอนุญาตให้ตัวแทนผู้อนุมัติสามารถอนุมัติคำขอเหล่านี้ได้เช่นกันหรือไม่`,
"label.inusing":`เปิดใช้งานแล้ว`,
"label.edit.select.tre":`รายการกล่องกาเครื่องหมาย`,
"label.appointmentconfirmail.wizard.title1":`สวัสดี{0}`,
"label.partnerCloud.financeSetting.setAlipay":`ตั้งค่าการชําระเงินผ่านอาลีเพย์`,
"lable.edit.queue.avobj":`ออบเจ็กต์ที่ใช้ได้`,
"vue_label_checkduplicate_verify_all_characters":`ยืนยันอักขระทั้งหมด`,
"label.huntingzone":`ขอบเขตการค้นหา`,
"label.request.approved":`คำขอได้รับการอนุมัติแล้ว โปรดอย่าอนุมัติซ้ำ`,
"label.sharerule.msgerror":`ข้อความแสดงข้อผิดพลาดภายในเซิร์ฟเวอร์`,
"front-epwechat-module-v1-tick-unbound":`กรุณาทำเครื่องหมายที่ตกลงและยอมรับข้อมูลที่ไม่ผูกข้างต้น`,
"label.console.step6":`ขั้นตอนที่ 6. เลือกเค้าโครงรายการ`,
"label.multilang.micropost.vote":`{0} คะแนน`,
"message.error.appid.null":`รหัสความปลอดภัยต้องไม่ว่างเปล่า!`,
"lable.product.delq":`ลบคำถาม`,
"label.h5.approval.leixing":`ประเภทการอนุมัติ`,
"label.edit.field.select.style1":`จอแสดงผลแบบเรียงต่อกัน`,
"label.passwordPolicy.setup.alpandnum":`ต้องใช้ตัวอักษรและตัวเลขผสมกัน`,
"label.ems.close2":`ปิด`,
"label.report.reporttypetitle":`ชื่อแหล่งข้อมูลรายงาน`,
"label.umeng.approval.approvalsuccess":`ส่งการอนุมัติแล้ว`,
"label.page.showamount":`จำนวนบันทึกที่แสดงต่อหน้า`,
"label.copy.asset.successfully":`คัดลอก BOM สินทรัพย์สำเร็จ`,
"vue_label_homepage_bigscreen_dark":`สีเข้ม`,
"vue_label_email_selected_members":`สมาชิกที่เลือก`,
"label.file.preview":`แสดงตัวอย่าง`,
"label.partner.new.step3.name":`ชื่อ`,
"label.forecast.settings.periods.ago":`รอบที่แล้ว`,
"label.evaluation.praise":``,
"label.cloudccsite.edit":`แก้ไขเว็บไซต์`,
"label.knowledgebase.advanced.filtering":`การกรองขั้นสูง`,
"label.knowledgebase.framework":`เฟรมเวิร์ก`,
"vue_label_pool_ownedpool":`ฐานข้อมูลที่อยู่`,
"label.exchange.sync.setting.license":`หลังจากเปิดการใช้งานฟังก์ชั่นนี้ ข้อมูลองค์กรบางอย่างอาจถูกบันทึกลงในเซิร์ฟเวอร์ Microsoft Exchange ในรูปแบบการดำเนินงานภายในหรือคลาวด์ และดำเนินการจัดการผ่านเซิร์ฟเวอร์ Microsoft Exchange CloudCC.com ไม่รับผิดชอบต่อความเป็นส่วนตัวและความปลอดภัยของแอปพลิเคชันของบุคคลที่สามหรือระบบ เช่น Exchange หรือ Office 365 เป็นต้น`,
"front-console-conversation-btn2":``,
"label.projectManagement.thelastone":`รายการสุดท้ายแล้ว`,
"message.duplication.confirmscript.mergeoperation":`รวมบันทึกเหล่านี้ให้เป็นบันทึกเดียวตามค่าที่เลือก 
หมายเหตุ: การผสานไม่สามารถยกเลิกได้ คุณต้องการผสานบันทึกต่อไปหรือไม่?`,
"lable.outlook.detail.nosyn":`ไม่ซิงค์`,
"label.iscopy":`อนุญาตให้คัดลอกหรือไม่`,
"message.matrixReportSetupStage.row":`โปรดเลือก [กำหนดหัวแถว] เกณฑ์ผลรวมย่อย  และเลือกเกณฑ์ผลรวมย่อยอย่างน้อยหนึ่งจากสองเกณฑ์`,
"label.forecast.forehistory.possibility":`ความน่าจะเป็น`,
"label.timetrigger.validate":`ค่าอินพุตต้องเป็นจำนวนเต็มบวก เมื่อถึงเวลาทริกเกอร์เวิร์กโฟลว์ ระบบจะดำเนินการเวิร์กโฟลว์ตามค่านั้นโดยอัตโนมัติ`,
"member.name.choice.field":`ชื่อสมาชิกเป็นฟิลด์บังคับนะจ๊ะ !`,
"label.undone_external page":`สิ่งนี้จะย้อนกลับไม่ได้ ดังนั้นโปรดแน่ใจว่า แบบฟอร์มนี้ไม่ได้ใช้สำหรับหน้าเข้าสู่ระบบใดๆ แต่สามารถใช้ที่อื่นได้ เช่น คุณอาจจะใช้ Embed code เพื่อแทรกลงในหน้าภายนอก`,
"UG_Lead_012":`นำเข้าลีด`,
"component_chatter_label_fans":`ผู้ติดตาม`,
"label.systeminfo":`ข้อมูลระบบ`,
"label.mr.descreption.oneGroupNote1":`โปรดเลือกข้อมูลอย่างน้อยสองรายการและคลิกปุ่ม [โหลดข้อมูลที่เลือก] เพื่อเข้าสู่หน้าการผสานข้อมูล ปัจจุบันเป็นครั้งที่`,
"label.wtd.changefields.selfields":`เลือกฟิลด์ที่จะรวมไว้ในเพจ web to CloudCC`,
"message.error.fileinfoid.null":`id ข้อมูลไฟล์ fileinfoid ต้องไม่ว่างเปล่า!`,
"label_tabpage_cownerz":`เปลี่ยนเจ้าของ`,
"setup_layout_button_save":`บันทึก`,
"Dashboard.View.Createdbyme":`แดชบอร์ดที่สร้างโดยฉัน`,
"label.escalation.setup.detail.order":`หมายเลขลำดับ`,
"button.partner.start":`เริ่มใช้งาน`,
"label.htyj.remark1":`รุ่นปัจจุบันของคุณไม่รองรับออบเจ็กต์สัญญา`,
"component.event.label.person":`ผู้ได้รับมอบหมาย`,
"label.appointmentconfirmail.wizard.subtitle3":`สถานที่`,
"label.emailtocloudcc.filed.username":`ชื่อผู้ใช้อีเมล`,
"label.vlidaterule.remark":`ระบุเงื่อนไขข้อผิดพลาดและข้อความแสดงข้อผิดพลาดที่เกี่ยวข้องเพื่อกำหนดเกณฑ์การทวนสอบ ผู้ใช้สามารถแก้ไขข้อผิดพลาดและลองอีกครั้ง`,
"message.duplication.label.insertoption":`ดำเนินการเมื่อสร้างใหม่`,
"front-web-module-v1-detail-comment-toast":``,
"label.import.page2.notsuitedfiledwillbenotimport":`หมายเหตุ: ระบบจะไม่นำเข้าฟิลด์ที่คุณไม่ได้แม็ป`,
"label.h5.similar.opportunity.enable":`เปิดการใช้งานโอกาสทางธุรกิจที่คล้ายกัน`,
"label.allunfold":`ขยายทั้งหมด`,
"component_setup_iframe_label_inputurl":`ป้อน URL`,
"label.manage.all":`จัดการทั้งหมด`,
"label.mobile.side.tab.cs":`ฟังก์ชันที่ใช้บ่อย`,
"label.datamanage.contact.information":`ข้อมูลผู้ติดต่อ`,
"lable.outlook.edit.sel":`เลือกค่า...`,
"label.imgfield.type.url.tip2":`ตัวอย่างเช่น http://www.cloudcc.com/images/logo.png&cimgSize=50,50`,
"setup.layout.label.areasetup":`ตั้งค่าคุณสมบัติภูมิภาค`,
"label.date":`วันที่`,
"vue_label_commonobjects_detail_openfilter":`ขยายตัวกรอง`,
"label.loginip.pagecue":`ป้อนช่วงที่อยู่ IP ที่ถูกต้องและระบุที่อยู่ซึ่งผู้ใช้ที่มีโปรไฟล์นี้สามารถเข้าสู่ระบบได้`,
"vue_label_email_not_valid":`อีเมลที่คุณป้อนไม่ถูกต้อง`,
"label.page.step5.add.application":`ขั้นตอนที่ 5: เพิ่มลงในแอปพลิเคชันที่กำหนดเอง`,
"label.dashboard.donot.delete":`มีแดชบอร์ดอยู่ในโฟลเดอร์แดชบอร์ดปัจจุบัน ไม่สามารถลบได้!`,
"label.visitAPPexchange":`เข้าไปที่ Appexchange (หน้าต่างใหม่)`,
"label.generate.location":`สร้างข้อมูลละติจูดและลองจิจูดของลูกค้า`,
"lable.quote.syncing.syncingbutton":`ซิงโครไนซ์`,
"label.pw.error.text":`รหัสผ่านที่กรอกทั้งสองครั้งไม่ตรงกัน!`,
"label_partner_setup_Enable":``,
"label.file.preview.unav":`ไม่สามารถดูตัวอย่างได้`,
"label.sms.tip":`มาจากเครือข่าย`,
"setup.mainpage.label.welcome21":`แพลตฟอร์มคลาวด์ CloudCC มีฟังก์ชันแม่แบบอีเมลที่ผู้ใช้สามารถกำหนดเองได้ ใช้งานง่าย ช่วยเพิ่มประสิทธิภาพในการทำงาน`,
"label.trigger.for.example":`เช่น: โอกาสทางธุรกิจถูกอัปเดตในทริกเกอร์ update ลูกค้า และลูกค้าถูกอัปเดตในทริกเกอร์ update โอกาสทางธุรกิจ และทริกเกอร์ update ลูกค้าก็จะทริกเกอร์ในเวลาเดียวกัน หากไม่มีเงื่อนไขควบคุมในทริกเกอร์ ระบบจะอนุญาตการปรับใช้แบบวนซ้ำได้สูงสุด 3 ครั้ง!`,
"setup.layout.button.layoutprop":`คุณสมบัติเค้าโครง`,
"component.chatter.label.fans":`ผู้ติดตาม`,
"lable.PowerProcess.event.edit":`การแก้ไขอิเวนต์สําคัญ`,
"label.detailintro":`คำอธิบายรายละเอียด`,
"vue_label_report_nosearchresults":`ไม่พบผลการค้นหา`,
"error.name.repeat":`ชื่อซ้ำไม่ได้`,
"label.emailEncoding":`รหัสไปรษณีย์`,
"label.partnerCloud.financeSetting.enableAccount":`เปิดใช้งานบัญชีเงินคืน`,
"label_emailtocloudcc_clear":`ล้าง`,
"setup_mainpage_label_welcome12":`ผู้ใช้สามารถกรอกข้อกำหนดของรายงานได้เพียงคลิกเมาส์และทำตามขั้นตอนคำแนะนำของระบบโดยไม่จำเป็นต้องแก้ไขโปรแกรม ระบบมีรายงานแบบตาราง รายงานสรุป และรายงานแบบเมทริกซ์ให้เลือกพร้อมใช้งาน นอกจากนี้ยังสามารถเลือกการแสดงผลสําหรับฟิลด์ทั้งหมดและลบฟิลด์ที่ไม่จําเป็นออก รวมทั้งมีแผนภูมิแท่ง แผนภูมิเส้น แผนภูมิโดนัท แผนภูมิรูปกรวย แผนภูมิวงกลม และแผนภูมิอีกหลายชนิดให้ผู้ใช้ใช้งานได้อย่างง่าย`,
"lable.SalesCommitmentKanBan.contractStartDate":`วันเริ่มต้นสัญญา`,
"front-starter-v1-potential-customer-tips-success":`เปิดฐานข้อมูลลีดสำเร็จ`,
"UG_Forcast_02":`การพยากรณ์เป็นการประมาณการยอดขายของสเตจที่กำหนด รูปแบบการพยากรณ์สามารถช่วยคุณกำหนดความต้องการผลิตภัณฑ์และรายได้จากการขายในช่วงระยะเวลาหนึ่ง ผู้ควบคุมสามารถใช้การพยากรณ์เพื่อกำหนดเป้าหมายและประเมินความก้าวหน้าของทีมได้ การพยากรณ์ทั้งหมดขององค์กรจะสามารถสะท้อนภาพรวมการขายของพนักงานขายได้ (โดยไม่คำนึงถึงความสมบูรณ์ระหว่างไปป์ไลน์และการปิดการขาย)`,
"label.escalation.setup.detail.ruleentries":`รายการเกณฑ์`,
"lable.SalesCommitmentKanBan.allComplete":`จำนวนที่สำเร็จทั้งหมด`,
"label.appupload.install.apicanuse":`ชื่อ API ใช้ได้`,
"label.organiza.field":`ฟิลด์องค์กร`,
"button.partner.workspace.manage":`จัดการ`,
"lable.PowerProcess.setevent":`ตั้งค่าอิเวนต์สําคัญ`,
"label.emailobject.groupemail.msg2":`ที่อยู่อีเมลขาดหายไปทําให้ส่งข้อความนี้ไปยังผู้รับไม่ได้`,
"label.h5.orderbyname":`เรียงลำดับตามชื่อ`,
"vue_label_salesadvance_opportunities":`จำนวนโอกาสทางธุรกิจ`,
"label.appointment.disable.cancel":`ปิดใช้งานการยกเลิกการนัดหมาย`,
"label.trigger.folder.edit":`หน้าทริกเกอร์: แก้ไขโฟลเดอร์`,
"label.customfields.new.step2.opration.unique.info.v2":`ถือว่า ABC" และ "abc" เป็นค่าที่ต่างกัน (ไวต่ออักษรใหญ่เล็ก)"`,
"label.icon.40":`ตำแหน่ง`,
"label.eventmenuandlink":`ปุ่มอีเวนต์และลิงก์`,
"label.service.gantt.candidate":`ผู้สมัคร`,
"label.top.userphoto":`รูปโปรไฟล์`,
"label.appointmentconfirmail.wizard.btn2":`ยกเลิกการประชุม`,
"label.print":`พิมพ์`,
"saveandreturn":`บันทึกและย้อนกลับ`,
"lable.account.CurrentandNextCY":`ปีปฏิทินนี้และถัดไป`,
"label.group.no.recent1":`คุณยังไม่ได้ดูกลุ่มที่เปิดใช้งาน`,
"lable.Asset.conversion":`เมื่อโอนสินทรัพย์ สินทรัพย์จะถูกสร้างขึ้นตามวิธี "การแปลงสินทรัพย์" ในผลิตภัณฑ์ที่สั่งซื้อ`,
"label.emailtocloudcc.button.sure":`ยืนยัน`,
"label.Path.List":`รายการของกระบวนการ`,
"label.please.rule.name":`โปรดป้อนชื่อกฎ`,
"label.knowledge.category.hint.six":`กลุ่มหมวดหมู่พร้อมใช้งาน`,
"setup_mainpage_label_welcome28":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าการจัดการ →การจัดการข้อมูล →การนำเข้าและส่งออกข้อมูล, การโอนย้ายแบบกลุ่ม, การลบแบบกลุ่ม`,
"vue_label_commonobjects_view_chart_editchart":`แก้ไขแผนภูมิ`,
"label.permission.detail.app.object":``,
"label.multilang.totalpage":`ทั้งหมด`,
"label.marketsea.button.return":`กลับ`,
"Click.to.load.more":`คลิกเพื่อโหลดเพิ่มเติม`,
"label.validate.globalvariable":`ตัวแปรแบบโกลบอล`,
"label.marketsea.iseditseabymanager":`อนุญาตให้ผู้ดูแลระบบเปลี่ยนฐานข้อมูลที่มีอยู่`,
"label.price.yuan":`ราคา (หยวน)`,
"label.service.resource.uesr.tip":`เลือกผู้ใช้เพื่อสร้างทรัพยากรบริการ ประเภททรัพยากรไม่สามารถเลือกทีมได้`,
"vue_label_help_viewusageguide":`ดูคู่มือการใช้งานรุ่น lightning`,
"label.autoRegister.changepwd.setpwd.too.long":`ยาวเกินไป`,
"label.campagin.roi.fwsl":`จำนวนการเข้าชม`,
"label.campaign.mobile":`อุปกรณ์มือถือ`,
"UG.Lead.012":`นำเข้าลีด`,
"link.recordtype.detail.backtoobject":`กลับไปยังออบเจ็กต์ที่กำหนดเอง`,
"front-kefu-moudle-callcentrt-hasclose":``,
"label.category.5":`IT เทคโนโลยีชั้นสูง`,
"label.import.page1.selectwayofdealdata":`เลือกวิธีการประมวลผลข้อมูล`,
"chatter.emailReceiveEmail":`รับการแจ้งเตือน CCChat`,
"vue_label_file_manage_lib_members":`จัดการสมาชิกไลบรารีเอกสาร`,
"label.appupload.upload.overview":`ภาพรวม`,
"label.service.miniProgram.inputNumber":`กรุณากรอกตัวเลข 0-999`,
"label.emailtemplate.finishdetailinfo":`รายละเอียดแม่แบบอีเมลเสร็จสมบูรณ์`,
"label.weixin.fmu.before.day":`ล่วงหน้า {0} วัน`,
"label.integrations.login":`เข้าสู่ระบบ`,
"label.dashboard.setUpHomePage":`ตั้งค่าการแสดงหน้าแรกแล้ว`,
"label_partner_common_webSit":`ชื่อโดเมน`,
"front-epwechat-module-v1-unbound-user":`รายชื่อผู้ใช้ที่ไม่ได้ผูกไว้`,
"label.partnerCloud.basicSetting.offline":`เปิดใช้งานการชําระเงินแบบออฟไลน์`,
"label.start.loginip":`ที่อยู่ IP เริ่มต้น`,
"label.projectManagement.delete.subtasks":``,
"label.message.batchapp":`การอนุมัติแบบกลุ่ม`,
"message.duplication.label.ruletitle":`กฎตัวกรองซ้ำ`,
"label.all_networks":`ทุกเครือข่าย`,
"label.select_columns":`เลือกคอลัมน์ที่คุณต้องการแสดงเมื่อส่งฟอร์ม`,
"vue_label_notice_uploadavatar_exceed":`รูปโปรไฟล์ที่อัปโหลดขนาดต้องไม่เกิน 2 MB`,
"message.error.get.failed":`การรับข้อมูลล้มเหลว!`,
"label.quickbooks.viewlist.duedate":`วันกำหนดส่ง`,
"label.ccchat.topic.search":`ค้นหาหัวข้อ`,
"label.forecast.shre.manager":`ผู้จัดการการแบ่งสรร`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`วันพฤหัสบดี`,
"lable.product.pricebooks.copy":`คัดลอกจากสมุดราคาที่มีอยู่`,
"label.instrumentPanel.minLabelname":`ค่าต้องเป็นค่าบวกและน้อยกว่าค่าเบรกพอยต์ 1`,
"front-market-form-createdsecond":``,
"label.submission_detail":`ส่งรายละเอียด`,
"label.customfields.checkbox.tip":`อนุญาตให้ผู้ใช้เลือกค่าจริง "(เลือก) หรือ"เท็จ " (ไม่เลือก)"`,
"label.escalation.setup.list.description":`เมื่อเคสที่มีเงื่อนไขไม่ได้รับการประมวลผลภายในเวลาที่กำหนด คุณสามารถดำเนินการอัตโนมัติผ่านเกณฑ์การเลื่อนขั้น เมื่อเลื่อนขั้นเคส คุณสามารถเลือกที่จะแจ้งผู้ใช้โดยอัตโนมัติและมอบหมายเคสใหม่ให้กับผู้ใช้รายอื่นได้`,
"UG.Forcast.05":`การตั้งค่าการพยากรณ์: ขั้นตอนที่ {0}/{1}`,
"label.data.import":`การนําเข้าข้อมูล`,
"label.upload.error.cause":`การอัปโหลดล้มเหลวเนื่องจาก`,
"label.search.change.remark":`นำไปใช้กับการตั้งค่าออบเจ็กต์ที่แสดงในส่วนการค้นหาของแถบด้านซ้ายของหน้าเว็บ`,
"serviceappointment.edit.status.limitwithstatus":`สถานะของการนัดหมายการบริการไม่สามารถเปลี่ยนจาก{0}เป็น{1}ได้`,
"label.department.operation":`ดำเนินการ`,
"label.textmessage.vonage.message3":`หากต้องการค้นหาคีย์ API และความลับของ API คุณสามารถเข้าสู่ระบบบัญชี API  Vonage ของคุณและไปที่ "การตั้งค่า" ใต้ชื่อบัญชี หากต้องการค้นหาหมายเลขโทรศัพท์ในบัญชี API  Vonage ของคุณ ให้ไปที่ "หมายเลข" ใต้ "ผลิตภัณฑ์" และคลิกที่ "หมายเลขของคุณ" เพื่อดูหมายเลขโทรศัพท์ทั้งหมดที่คุณเป็นเจ้าของ`,
"label.privacystatement.dialog":`คำชี้แจงสิทธิ์ส่วนบุคคล (หน้าต่างใหม่)`,
"label.datamanage.import.leadfield":`ในตารางด้านล่าง ให้เลือกฟิลด์ที่ควรนำเข้าไปยังลีดแต่ละรายในไฟล์นำเข้า หลังจากเสร็จสิ้นการดำเนินการ คลิกถัดไป:`,
"label.appupload.upload.install.failar":`การติดตั้งล้มเหลว`,
"label.viewall":`ดูทั้งหมด`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat ตอบกลับเวยเทียโปรด`,
"lable.custom.dp":`หน้านี้ช่วยให้คุณกำหนดปีเองได้`,
"label.mobile.more.share":`แบ่งปันกับกลุ่มหรือเพื่อนร่วมงาน`,
"lable.name.cannot.be.empty":`ชื่อไม่สามารถว่างเปล่า`,
"label.autoRegister.changepwd.setpwd.password":`รหัสผ่านของฉัน`,
"label.multipleactivity.aevents":`อิเวนต์`,
"label.many.dayline.lastday":`เมื่อวาน`,
"lable.Please.bind.the.QuickBooks.record.first":`โปรดผูกบันทึก quickbooks ก่อน`,
"vue_no_related_dashboards":`ไม่มีแดชบอร์ดที่เกี่ยวข้อง`,
"label.newdashboardpage.name":`ชื่อแดชบอร์ด`,
"vue_label_commonobjects_detail_network":`เครือข่าย`,
"label.tianyancha.reginstitute":`ผู้มีอำนาจลงทะเบียน`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`ขอบเขตล่างของแต่ละช่วงราคาต้องเท่ากับขอบเขตบนของช่วงก่อนหน้า`,
"label.chat.file.upload.info":`อัปโหลดไฟล์`,
"label.appexchange.vlidaterule":`เกณฑ์การทวนสอบ`,
"label.salescloud.salesdashboard.current.business":`โอกาสทางธุรกิจปัจจุบัน`,
"label.app.step4.homeisfrist":`หน้าแรกต้องเป็นแท็บแรกและลบไม่ได้!`,
"label.weixin.micro.research.optionname":`ชื่อตัวเลือกไมโครรีเสิร์ช`,
"label.paging.totalofnbsp":`ทั้งหมด {0} รายการ`,
"label.opportunity.perm.title":`ขอสิทธิ์การเข้าถึง`,
"front-kefu-moudle-v1-zhyzcw-reinput":`การยืนยันผู้เช่าผิดพลาด โปรดป้อนอีกครั้ง`,
"label.unsaved_changes":`หากคุณดำเนินการต่อ การเปลี่ยนแปลงที่ไม่ได้บันทึกจะสูญหายไป`,
"label_partner_all_description":`คำอธิบาย`,
"lable.account.Next.CQ":`ไตรมาสปฏิทินถัดไป`,
"chatter.feed.menutype.feed.me":`การอัปเดตที่เกี่ยวข้องกับฉัน`,
"label.sourcetranstemp":`แม่แบบแหล่งที่มาการแปล: แม่แบบการแปลว่าง คุณสามารถสร้างไฟล์ภาษาใหม่ได้หนึ่งไฟล์`,
"label.apply.newuser.validate":`รหัสยืนยันการลงทะเบียนผู้ใช้ใหม่ของ CloudCC:`,
"label.user.password.error":`ชื่อผู้ใช้และรหัสผ่านไม่ถูกต้อง หรือผู้ใช้ไม่มีผลบังคับใช้!`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`ขณะนี้ไม่มีรายการในกลุ่มบรรทัดใบเสนอราคา โปรดคลิกปุ่ม "เพิ่มผลิตภัณฑ์" เพื่อเพิ่มผลิตภัณฑ์`,
"lable.PowerProcess.time.filed":`ฟิลด์วันที่และเวลาตาม{detailInterestType}`,
"label.file.default.value.is.integer":`ใส่ได้เฉพาะจำนวนเต็ม`,
"label.processsetting.please.select.field":`กรุณาเลือกฟิลด์`,
"label.app.step3.introduce":`ขนาดไฟล์ของไอคอนแอปพลิเคชันที่กำหนดเองต้องน้อยกว่า 20K เพื่อให้ได้ผลลัพธ์ที่ดีที่สุดขนาดภาพสูงสุดควรกว้าง 300 พิกเซลและสูง 55 พิกเซล ระบบจะปรับขนาดรูปภาพขนาดอื่นและอาจมีความผิดเพี้ยน นอกจากนี้ภาพใหม่จะมีผลหลังจากบันทึกแล้วเท่านั้น`,
"button_partner_save":`บันทึก`,
"label.marketingmanagement":`การบริหารจัดการด้านการตลาด`,
"label.isEnableVisualpage_new.leftlist":`เพจที่กำหนดเองที่สามารถใช้ได้`,
"label.salescloud.teamrole.optionlist.choose.correct":`มีรายการแบบเดียวกันอยู่ในรายการ กรุณาแก้ไข`,
"System_ChangeUser_Info_001":`การเปลี่ยนเจ้าของสำเร็จ คุณไม่มีสิทธิ์ดูบันทึกนี้ คลิกเพื่อกลับไปยังหน้าก่อนหน้า`,
"front-console-no-contact":``,
"component.assistant.label.overduetask":`โอกาสทางธุรกิจที่ภารกิจเกินกำหนด`,
"label.roleofpartner":`บทบาทของพาร์ทเนอร์`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`คุณและ{0}`,
"front-template-V1-Please-select-a-picture":`กรุณาเลือกรูปภาพ`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`อัตราข้อผูกมัดที่ทำสัญญาทั้งหมด`,
"label.h5.similar.opportunity.step2.conment":`เลือก 3 ถึง 10 ฟิลด์ หรือรายการที่เกี่ยวข้องเพื่อจับคู่เมื่อมองหาโอกาสทางธุรกิจที่คล้ายกัน`,
"label.projectManagement.alert.frequency.will.not.work":`เมื่อคุณเลือก "ไม่" ความถี่ในการเตือนจะไม่ทำงาน!`,
"vue_label_fllscreen":`มุมมองแบบเต็มหน้าจอ`,
"label.customfields.selectcontainfieldlayout":`เลือกเค้าโครงเพจที่ควรมีฟิลด์นี้`,
"label.appointment.wizard.subtitle1-4":`45 นาที`,
"label.tianyancha.businessverify.unagree":`ไม่เห็นด้วย`,
"label.unique":`ไม่ซ้ำ`,
"setup_mainpage_label_welcome10":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าแอปพลิเคชัน → สร้าง → ออบเจ็กต์ → ชื่อออบเจ็กต์ → เค้าโครงที่กำหนดเอง`,
"vue_label_account_subsidiary":`บริษัทย่อย`,
"label.dataimport.format.error":`รูปแบบไม่ถูกต้อง กรุณาใช้รูปแบบ MM/DD/YYYY หรือ YYYY-MM-DD`,
"label.email.new":`อีเมลใหม่`,
"label.log.descri":`รายละเอียดการดำเนินการ`,
"vue_label_dashboard_componentname":`กรุณาใส่ชื่อส่วนเสริม`,
"label.weixin.quick.reply":`ตอบกลับอย่างรวดเร็ว`,
"label.productsales.payment.badversion":`รุ่นปัจจุบันของคุณไม่รองรับออบเจ็กต์สัญญา ไม่สามารถดูผลตอบแทนจากการขาย`,
"label.position":`ตำแหน่ง`,
"label.Annex.Conditions":`เพิ่มตัวกรองตรรกะสำหรับเงื่อนไขเพิ่มเติม (เช่น 1 And  Or 3)`,
"label_tabpage_endz":`สิ้นสุด`,
"label.setup.mobile.bottombutton.prompt":`คำเตือน: เมื่อคลิกบันทึกการตั้งค่านี้แล้วจะเขียนทับการตั้งค่าเพจระดับหนึ่งที่ผู้ใช้กำหนดบนอุปกรณ์มือถือ`,
"lable.Edit.template":`แก้ไขแม่แบบรายงานการบริการ`,
"vue_label_report_onlydisplay2000":`แสดงข้อมูลเพียง 2,000 รายการ`,
"label.salescloud.salesdashboard.sign.account.top5":`สัญญาลูกค้ารายใหญ่ top5`,
"label.weixin.ontime":`ตรงเวลา`,
"font-evaluate-module-v1-disappoint":``,
"chatter.sel.addre":`เลือกผู้รับได้มากที่สุด 5 คน!`,
"label.mobile.phone.month.summary":`สรุปของเดือนนี้`,
"label.partnerCloud.priceOfManual.selected":`ลูกค้าที่เลือก`,
"label.south.georgia.time":`เวลามาตราฐานเซาท์จอร์เจีย`,
"label.create.ccdocument":`เพิ่มไฟล์แนบ`,
"label.chatter.to":`ถึง`,
"label.ems.minute":`นาที`,
"label.mobile.phone.submit.tome":`รายงานที่ส่งให้ฉัน`,
"label.approvalstep1":`ขั้นตอนที่ 1: กรุณาใส่ชื่อและคำอธิบาย`,
"label.h5.similar.opportunity.last.months9":`6-9 เดือนล่าสุด`,
"Opportunity_Detailed_Phase_Label_003":`เปลี่ยนสเตจ`,
"lable.PowerProcess.time.input":`กรุณาระบุเวลา`,
"label.stdashbord.xsld.business.yqzsr":`พยากรณ์รายได้รวม`,
"label.icon.64":`ไฟฉาย`,
"label.data.choses.i_desc":`เลือกนำเข้าข้อมูลของออบเจ็กต์เดียวตามความต้องการของคุณ`,
"label.integrations.mainlandchinaleads":`ลีดในจีนแผ่นดินใหญ่`,
"vue_label_notice_savemenu_success":`การบันทึกเมนูสำเร็จ`,
"front-kefu-moudle-v1-xzhxzxkf-online":`เลือกบริการลูกค้าออนไลน์ Easemob`,
"label_chatter_name":`ชื่อ`,
"label.Viewon_Linkedin":`ดูใน LinkedIn`,
"lable.PowerProcess.chioce.event":`โปรดเลือกอิเวนต์สําคัญ`,
"component.chatter.file.label.maxsize":`ขนาดไฟล์สูงสุดคือ 20M`,
"label.validate.function.funcExplain.SECOND":`ส่งกลับวินาทีในฟิลด์วันที่/เวลา`,
"label.data.downpage.i.title.num4":`4. หากออบเจ็กต์ที่คุณต้องการนำเข้ามีฟิลด์ค้นหาและฟิลด์รายละเอียดหลัก ค่าที่สอดคล้องกับฟิลด์นี้ต้องเป็น ID มิฉะนั้นจะไม่มีผล`,
"label.icon.139":`สกุลเงิน`,
"label.app.step4.atleastone":`แท็บหน้าแรกไม่สามารถเคลื่อนย้ายได้!`,
"label.weixin.input.telephone":`กรุณาใส่หมายเลขโทรศัพท์มือถือ`,
"label.setup.mobile.bottombutton.remark":`องค์กรสามารถตั้งค่าเริ่มต้นของเพจระดับหนึ่งขององค์กรตามสถานการณ์ทางธุรกิจ`,
"label.file.searchs":`ค้นหาไฟล์`,
"vue_label_email_there_is_no_draft_yet":`ไม่มีแบบร่าง`,
"front-kefu-moudle-v1-bind-seats":`ผูก Seat`,
"label.customfields.lookupmuti.tip":`สร้างความสัมพันธ์ที่เชื่อมโยงออบเจ็กต์นี้กับออบเจ็กต์อื่น ฟิลด์ความสัมพันธ์อนุญาตให้ผู้ใช้คลิกไอคอนค้นหาเพื่อเลือกหลายค่าจากรายการป๊อปอัป ออบเจ็กต์อื่นคือแหล่งที่มาของค่าในรายการ`,
"label.integrations.password":`รหัสผ่าน`,
"label.data.newtemplate.t_conditions":`เงื่อนไขแม่แบบ`,
"message.error.repeatsubmit":`มีการส่งซ้ําหรือแก้ไขในหลายหน้าต่าง หากเป็นกรณีหลัง โปรดส่งในหน้าต่างที่เพิ่งเปิดใหม่`,
"label.umeng.approval.approvalreassign":`การอนุมัติ#obj ถูกมอบหมายใหม่ #objname`,
"lable.edit.queue.selobj":`ข้อผิดพลาด: ในคิวต้องเลือกอย่างน้อยหนึ่งออบเจ็กต์`,
"label.compact.layout.frame":`กรอบเค้าโครงเพจ`,
"label.sms.companyname.dsf.infor":`ข้อมูลอินเทอร์เฟซข้อความสั้นของตงสือฟาง`,
"template.report.individual.case.source":`ที่มาของเคส`,
"pagecreator.button.pcpage":`เว็บเพจสำหรับ PC`,
"vue_label_commonobject_selectdatatime":`เลือกวันที่และเวลา`,
"label.icon.181":`แฟ้ม`,
"label.loginip.setup.please":`โปรดระบุช่วง IP`,
"vue_label_dashboard_?secondarygroup":`กรุณาเลือกกลุ่มลำดับสอง`,
"lable.outlook.mcto.pleasedes":`โปรดป้อนโดเมนอีเมลที่คุณไม่ต้องการเชื่อมโยง โดยคั่นด้วยเครื่องหมายจุลภาค`,
"DetailedInfo_Activity_EmailMessage_01":`{0} ส่งอีเมลให้{1}แล้ว`,
"label.sendmail.step4":`ขั้นตอนที่ 4: คุณที่ส่งอีเมลเดำเนินการแล้ว`,
"label.monitorsys.delete.source":`คำอธิบายการดำเนินการ`,
"label.monitorsys.log.datetime":`ดาวน์โหลดล็อกการตรวจสอบการทำงานของคีย์ระบบที่อยู่ภายในช่วงการค้นหา (ไฟล์ Excel.xls)`,
"component_chatter_label_myfans":`ผู้ติดตามของฉัน`,
"label.tianyancha.h5.registereddate":`เวลาลงทะเบียน`,
"label.multilang.feedtrack.operatecreate":`สร้างบันทึก{0}`,
"label.console.step6.no":`เลือกเค้าโครงรายการ`,
"four":`สี่`,
"message.confirmsetpwdforuser":`ต้องการรีเซตรหัสผ่านสำหรับผู้ใช้หรือไม่?`,
"label.cape.verde.time":`เวลากาบูเวร์ดี`,
"label.queue.new":`คิวใหม่`,
"label.cloudccsite.start":`เปิดใช้งานหน้าแรกของไซต์`,
"label.data.exp.way":`วิธีการส่งออก`,
"label.lock.record.donot.delete":`ไม่อนุญาตให้ลบบันทึกที่ถูกล็อก`,
"label_emailtocloudcc_filed_type":`ชนิด`,
"frame_personinfo_label_minipic":`ภาพขนาดย่อ`,
"label.checkfield.choosetab":`เลือกฟิลด์ซ้ำ`,
"component.setup.tabs.label.default":`ค่าเริ่มต้นหน้า`,
"page.404.button.toknowmore":`เรียนรู้เพิ่มเติม`,
"vue_label_SMS_message_sent_cannot_be_empty":`เนื้อหาข้อมูลที่ส่งไม่สามารถว่างเปล่า`,
"label.lookupreplaceselectvalue":`ค้นหาและแทนที่ค่ารายการตัวเลือก`,
"pagecreator_layout_button_new":`เค้าโครงใหม่`,
"label.mobile.more.upload":`อัปโหลดรุ่นใหม่`,
"front-kefu-moudle-v1-Connection-failure":`การเชื่อมต่อล้มเหลว`,
"label.version.support.unlimited":`รองรับไม่จำกัด`,
"message.error.notmarketseamember":`ไม่ใช่สมาชิกของฐานข้อมูลนี้`,
"label.taskandincident":`ภารกิจและเหตุการณ์`,
"label.report.export.print.title":`พิมพ์มุมมองรายงาน`,
"label.file.publicview.error2":`ข้อมูลลิงก์สาธารณะไม่ถูกต้อง กรุณาใช้ลิงก์สาธารณะใหม่`,
"label_chatter_cancel":`ยกเลิก`,
"front-web-module-v1-detail-comment-satisfied":``,
"label.knowledge.delete.topic":`เกิดข้อผิดพลาดในการลบหัวข้อที่ใช้โดยบทความความรู้นี้`,
"label.forecast.forehistory.all":`ทั้งหมด`,
"label.displaybutton":`ปุ่มที่แสดง`,
"label.icon.148":`หุ่นยนต์`,
"label_tabpage_ok":`ยืนยัน`,
"label.checkfield.merge.mainrecord":`บันทึกหลัก`,
"label.notification.arketsea.restored":`{5}กู้คืน{2}{0}：{1}`,
"setup.mainpage.label.welcome31":`คำแนะนำการใช้งาน: คลิกที่เมนูด้านซ้ายของหน้า→ การตั้งค่าการจัดการ → สร้าง →แอปพลิเคชัน`,
"front-kefu-moudle-v1-jtrrt-connect":``,
"vue_label_calendar_please_select":`กรุณาเลือกฟิลด์ที่แสดง`,
"setup.layout.label.pagename":`ชื่อเค้าโครงเพจ`,
"template.chart.schdywjhz":`ค่าโอกาสทางธุรกิจของแคมเปญ`,
"label.access_report":`ใครสามารถดูรายงานนี้ได้บ้าง?`,
"label.assignment.layout.section.optional":`ตัวเลือก`,
"label_chatter_recently":`เมื่อเร็วๆ นี้`,
"lable.chat.advanced.setting":`การตั้งค่าขั้นสูง`,
"label.knowledge.category.hint.eight":`กลุ่มหมวดหมู่`,
"message.error.facebookuid.null":``,
"label.step5.total6":`ขั้นตอนที่ 5 จาก 6`,
"label.is.cancel.delete":`ยกเลิกการลบหรือไม่`,
"setup_mainpage_label_welcome11":`รายงานที่กำหนดเอง`,
"label.answers":`ตอบ`,
"label.approvalstep1.tip":`ใส่ชื่อ คำอธิบาย และหมายเลขขั้นตอนสำหรับขั้นตอนการอนุมัติใหม่`,
"template.chart.htjeph":`อันดับมูลค่าสัญญา`,
"label.campaigns.onsiteregistration":`การลงทะเบียนหน้างาน`,
"front-epwechat-module-v1-input-agentid":`โปรดป้อน agentId`,
"label.emailobject.wizard.desc2":`ติดตามว่าอีเมลถูกเปิดหรือไม่และเปิดกี่ครั้ง`,
"label.multilang.chatterdetial.vote":`{0} คะแนน`,
"label.customsetting.manage.value":`ข้อมูลที่กำหนดเอง`,
"front-electronic-export-listCount":``,
"label.dashboard.create.prompt":`รายงานแบบตารางไม่สามารถสร้างแดชบอร์ดได้`,
"label_tabpage_askz":`คุณต้องการถามอะไร`,
"label.ems.sentmail":`กล่องขาออก`,
"label.reportlist.untop":`เลิกตรึงหน้า`,
"label.owner.h5.plzchose":`กรุณาเลือกเจ้าของและคลิกปุ่มยืนยันอีกครั้ง`,
"label.callcenter.addup.10.pieces":``,
"label.ccdocument.save":`บันทึกเอกสาร`,
"label.productcannotnull":`ผลิตภัณฑ์ไม่สามารถว่างเปล่า`,
"label_tabpage_enabletomobile":`เปิดการใช้งานไปยังอุปกรณ์มือถือหรือไม่`,
"lable.account.CYAgo":`สองปีปฏิทินที่แล้ว`,
"lable.Select.the.returned.high.seas.pool":`เลือกฐานข้อมูลที่จะส่งคืน`,
"tuesday":`วันอังคาร`,
"label.partnerCloud.basicSetting.partnerPayment":`เปิดใช้งานบัญชีพาร์ทเนอร์`,
"label.validate.function.funcExplain.WEEKDAY":`ส่งกลับวันในสัปดาห์ 1 คือวันอาทิตย์ 7 คือวันเสาร์`,
"label.query.detail.manageexuser":`จัดการบัญชีผู้ใช้ภายนอก`,
"vue_label_systemSettings_environment":`สภาพแวดล้อม`,
"component_setup_tabs_label_delete":`ลบ`,
"label.weixin.delete.ccchat":`ยืนยันว่าจะลบเวยเทียนี้หรือไม่?`,
"label.lanxin.title":`Lanxin-มินิแอป H5`,
"label.layout.editcondition.morethanten":`เงื่อนไขการสืบค้นต้องไม่เกิน 10 เงื่อนไข`,
"label.project.hit.fourteen":`แจ้งเตือนการอัปเดตไมล์สโตน`,
"label.createby":`ผู้สร้าง`,
"label.moreoperation":`การดําเนินการเพิ่มเติม`,
"label.lock.tip":`ล็อกบันทึกเพื่อหลีกเลี่ยงการแก้ไข`,
"label.check.input.condition.three":``,
"label.quote.dingjia":`ราคาคงที่`,
"label.currentuseremail":`ที่อยู่อีเมลของผู้ใช้ปัจจุบัน`,
"UG_homepage_004":`กระบวนการอัตโนมัติ`,
"chatter.link":`ลิงก์`,
"label.new.zealand.standard.time":`เวลาออมแสงนิวซีแลนด์`,
"APPIntegration.Dropbox.setting.02":`ปิดการใช้งาน`,
"label.version.searchandmerge":``,
"label.allmenus.showmsg.nomenu":`ไม่พบเมนูที่คุณค้นหา!`,
"front-template-V1-Enable-disable":`เปิดใช้งาน|ปิดใช้งาน`,
"label.marketing.setting4":`ส่งคืนค่าเริ่มต้นของ URL หลังจากการลงทะเบียนสำเร็จ`,
"UG.Forcast.07":`อนุญาตให้พยากรณ์`,
"vue_label_systemSettings_correlation":`วิธีแสดงรายการที่เกี่ยวข้อง`,
"label.cloudccsite.remark.length":`คำอธิบายเว็บไซต์ต้องยาวไม่เกิน 255 อักขระ`,
"label.favorite":`โปรดปรานหน้านี้`,
"template.report.converted.leads":`เปลี่ยนเป็นลีด`,
"label.campaignmember.main.description":`ใช้หน้านี้เพื่อจัดการสมาชิกของแคมเปญนี้ สามารถเพิ่มสมาชิกใหม่หรืออัปเดตสถานะสมาชิกแคมเปญของสมาชิกปัจจุบัน`,
"label.salescloud.teamrole.account.organization":`ระดับการเข้าถึงลูกค้ารายนี้ของสมาชิกกลุ่มอาจจะสูงกว่าที่ระดับการเข้าถึงลูกค้าเริ่มต้นขององค์กรคุณ`,
"label.permission.modifyAppPermission.canselectapp":`แอปพลิเคชันเสริม`,
"front-epwechat-module-v1-self":`ตั้งค่าแอปที่สร้างขึ้นเอง`,
"message.duplication.label.matchexactletters":`เหมือนกัน`,
"label.appointmentdetail.wizard.title18":`แผนงานวันศุกร์`,
"label.area":`ภูมิภาค`,
"label.sso.saml.sp.username":`ชื่อผู้ใช้`,
"lable.outlook.new":`องค์ประกอบ Exchange Sync ใหม่`,
"label.custom.field.close.conversion":`ปิด-ข้ามสเตจแล้ว`,
"lable.outlook.detail.tmaping":`แม็ปฟิลด์ภารกิจ`,
"label.emailobject.emaildetail.nextactivity.event":`เพิ่มอิเวนต์`,
"vue_label_commonobjects_detail_date":`วันสิ้นสุดต้องไม่น้อยกว่าวันเริ่มต้น`,
"vue_label_email_mark?as":`ติดป้ายว่า`,
"label.guestgroup":`กลุ่มลูกค้า`,
"label_emailtocloudcc_filed_server":`เซิร์ฟเวอร์`,
"label.icon.186":`ปรึกษา`,
"label.department.user.edit":`แก้ไข`,
"label.custom.page.component.button.settings":`การตั้งค่าปุ่มส่วนเสริม`,
"label.partnerCloud.orderingPlatform.nextProduct":`คุณต้องการที่จะบันทึกการตั้งค่าปัจจุบันของผลิตภัณฑ์และปรับแต่งผลิตภัณฑ์ต่อไปหรือไม่?`,
"vue_label_appstore_cloud_platform":`แพลตฟอร์มทางการของ cloud`,
"label.page.previous":`หน้าก่อน`,
"label.direct.dashboard.week.report":`รายงานประจำสัปดาห์ใหม่`,
"label.ServiceCloud.prompt.warning":`ไม่มีการกระจายทรัพยากรตามสถิติที่อยู่!`,
"label.emailtocloudcc.position":`ตำแหน่ง`,
"vue_label_email_please_enter_the_message_content":`กรุณาใส่เนื้อหาอีเมล`,
"labal_About_to_jump":`จะกระโดด`,
"label_profile_mobile_setup_stand":`หน้าแรกมาตรฐาน`,
"label.visualpage.component.n3":`3. พารามิเตอร์ พารามิเตอร์ args, args = "name: 'zhang', age: 26" ระวังเรื่องเครื่องหมายคำพูดเดี่ยวและคู่`,
"vue_label_report_operationmode":`วิธีเรียกใช้รายงาน`,
"label.reportsSubscription.select.attached.file":`โปรดเลือกประเภทไฟล์แนบ!`,
"label.afghanistan.time":`เวลาอัฟกานิสถาน`,
"label.vlidaterule.formulatrue":`หากผลลัพธ์ของสูตรเป็นจริง จะแสดงข้อความที่กำหนดในพื้นที่ "ข้อมูลที่ผิดพลาด"`,
"label.ccchat.person.invite.erroremail":`รูปแบบที่อยู่อีเมลไม่ถูกต้อง`,
"label.viewDashboard":`ไปที่รายการแดชบอร์ด`,
"label.at":`ที่`,
"label.notification.arketsea.beforeretrieve":`{0}ของคุณ：{1} จะถูกนำไปยังถังขยะรีไซเคิล {2} เหลือเวลาอีก {6} วัน`,
"label.field.update.show.editor":`แสดงตัวแก้ไขสูตร`,
"label.weixin.polls.time":`ช่วงเวลาโหวต`,
"vue_label_commonobjects_detail_activity_nostarttime":`ไม่มีเวลาเริ่มต้น`,
"label.direct.dashboard.me.not.approval70":`รายการค้างอนุมัติของฉัน`,
"label.data.setok.t_desc3":`, ดําเนินการ`,
"label.view.edit.search.describe":`ป้อนคีย์เวิร์ดแล้วค้นหา`,
"label.importsourcefiletip":`โปรดตรวจสอบให้แน่ใจว่าไฟล์ตรงตามเงื่อนไขต่อไปนี้ก่อนนำเข้า : <span><ul><li>1.สร้างไฟล์ที่มีชื่อและคำแปลสำหรับภาษาที่คุณต้องการที่จะนำเข้าในแต่ละไฟล์ </li><li>2.ด้านบนของแต่ละไฟล์ต้องประกอบไปด้วยคุณสมบัติของภาษา (ไม่รองรับการนำเข้าภาษาจีน) คุณสมบัติของภาษาเช่น: Language=en_US。</li><li>3.ตรวจสอบให้แน่ใจว่าไฟล์ที่คุณนำเข้าอยู่ในรูปแบบการเข้ารหัสที่ถูกต้อง หากคุณไม่ระบุ ระบบจะใช้การเข้ารหัส UTF-8 </li><li>4.ตรวจสอบให้แน่ใจว่าส่วนท้ายของไฟล์ได้มีการ CR และ LF เรียบร้อยแล้ว </li></ul></span>`,
"UG.Case.01":`เคส`,
"label.weixin.report.filters":`ตัวกรอง`,
"vue_label_homepage_profilehomepageassignment":`การกำหนดหน้าแรกโปรไฟล์`,
"label_tabpage_editview":`แก้ไขมุมมอง`,
"label.tabpage.allpotentialcustomers":`ลีดทั้งหมด`,
"label.sendemail.send.standbyemail":`(กล่องขาออกสำรอง)`,
"errormessage.email.atleastonereceiver.z":`โปรดเลือกหรือกรอกที่อยู่ผู้รับอย่างน้อยหนึ่งรายการ`,
"workflow.action.tasks.assignortype.ownertype":`ประเภทของเจ้าของ`,
"label.list.userinterface.new.page.setup":`อินเทอร์เฟซรุ่นใหม่`,
"chatter.seladress":`กรุณาเลือกผู้รับอย่างน้อยหนึ่งคน`,
"Pagelayout_Setup_004":`ปรับแต่งได้มากที่สุด 4 ฟิลด์`,
"label.mobile.home.page.tenbig.opp":`โอกาสทางธุรกิจสิบอันดับแรกใน 30 วันข้างหน้า`,
"label.wtd.changefields.newpc":`สร้างหน้าเพจสำหรับรุ่น PC`,
"label.opportunity.perm.remark":`นี่คือโอกาสทางธุรกิจที่มีกรรมสิทธิ์ กรุณาติดต่อ"owneridccname"เจ้าของโอกาสทางธุรกิจ<br> เพื่อเข้าใช้งาน`,
"label.data.exp.tempdes":`คำอธิบายแม่แบบ`,
"label.appointment.wizard.subtitle2-1":`จาก`,
"lable.currencyManage.button.manageexchangeRate":`จัดการอัตราการแลกเปลี่ยนที่หมดอายุแล้ว`,
"label.file.viewinfo":`ดูรายละเอียดไฟล์`,
"label.integrations.mailchimp.export.failed":`ส่งออกข้อมูลล้มเหลว โปรดตรวจสอบการเชื่อมต่อเครือข่ายของคุณแล้วลองอีกครั้ง`,
"pagecreator_page_button_edit":`แก้ไข`,
"label.icon.86":`กระเป๋าเอกสาร`,
"label.exchange.sync.reset":`รีเซ็ตการซิงค์`,
"label.customfields.lookupfilter":`สามารถสร้างหนึ่งตัวกรองเพื่อจำกัดบันทึกที่ผู้ใช้สามารถใช้ในการค้นหาฟิลด์`,
"label.component.hotdeal.nopermission":`โปรดติดต่อผู้ดูแลระบบ CloudCC เพื่อขอรับข้อมูลเกี่ยวกับโอกาสทางธุรกิจ`,
"label.address.province":`จังหวัด/เขตเทศบาล`,
"lable.PowerProcess.3digit.input":`ต้องไม่เกินสามหลัก`,
"label.asset":`สินทรัพย์`,
"label.passwordPolicy.setup.nopwdremember":`ไม่บันทึก`,
"front-electronic-signature-setting-intro2":``,
"pagecreator.page.button.new":`หน้าเพจใหม่`,
"label.tabpage.step2":`ขั้นตอนที่ 2: ระบุเงื่อนไขการกรอง`,
"label_switch_two_column_or_responsive_layout":`สลับสองคอลัมน์หรือเค้าโครงแบบ Responsive`,
"label.batchDelete":`ลบแบบกลุ่ม`,
"chatter.edit.ct":`แก้ไขรายละเอียดการติดต่อของคุณ`,
"UG_ST_003":`คุณไม่ได้รับอนุญาตให้สร้าง{0} โปรดติดต่อผู้ดูแลระบบ คลิกยืนยันเพื่อเข้าสู่อินเทอร์เฟซ{0}โดยตรง`,
"label.timzone.tip.info2":`เมื่อใช้ SimpleDateFormat เพื่อจัดรูปแบบ Date คุณควรตั้งค่าโซนเวลาสำหรับอินสแตนซ์คลาส SimpleDateFormat เช่น: SimpleDateFormat myDateFormat=new SimpleDateFormat("YYYY-MM-DD, MM/DD/YYYY");myDateFormat.setTimeZone(TimeUtil. getUserTimeZone(userInfo )); หรือใช้วิธีเครื่องมือที่ TimeUtil จัดหาให้เพื่อรับอินสแตนซ์ SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("YYYY-MM-DD, MM/DD/YYYY",userInfo);`,
"label.ems.firstsynchistory":`การซิงค์อีเมลครั้งแรกต้องใช้เวลานานเท่าไหร่`,
"label.currency.invalid":`สกุลเงินไม่ถูกต้อง`,
"label.mask.custom":`ปรับแต่ง`,
"lable.opppdt.addpdt.title":`เลือกผลิตภัณฑ์`,
"label.appointment.wizard.subtitle3-3":`วันพุธ`,
"label.weixin.report.criteria":`เงื่อนไขการจัดกลุ่ม`,
"label.appupload.upload.install.uninstall":`ติดตั้งไม่ได้`,
"label.compact.layout.frame.split":`การแสดงผลแบบหลายหน้าจอ`,
"label.email.attach.complete.info":`หลังจากการอัปโหลดเสร็จสิ้น ไฟล์จะปรากฎในรายการไฟล์แนบด้านล่าง`,
"label.Receivables":`แผนการเก็บเงิน`,
"label.linkedin.title.setting":`ข้อมูลการเชื่อมต่อ LinkedIn`,
"label.companynotice":`ประกาศบริษัท`,
"label.emailobject.discard":`ยกเลิก`,
"label.selected.searchfield":`ฟิลด์ผลการค้นหาที่เลือก`,
"front-electronic-signature-explainDocusign":``,
"chatter.link.name":`ชื่อลิงก์`,
"label.low":`ต่ำ`,
"label.verticalline":`คอลัมน์`,
"label.approval.isallowed.reject.label":`เมื่ออนุมัติข้อมูลเดียว อนุญาตให้ปฏิเสธหรือไม่`,
"label.emailtocloudcc.button.enable":`เปิดการใช้งาน`,
"label.dashboardSetup.showdw.d5":`หน่วยจํานวนเต็ม`,
"label.usermanage.not.authority":`คุณมีสิทธิ์ไม่เพียงพอที่จะดำเนินการนี้`,
"label.customobjects.track.introduce0":`หน้านี้ช่วยให้คุณเลือกฟิลด์ที่จะติดตามในรายการที่เกี่ยวข้องกับ {0}"การติดตามฟิลด์" เมื่อผู้ใช้แก้ไขฟิลด์ที่เลือกด้านล่าง ค่าฟิลด์เก่าและใหม่ ไปจนถึงวันที่ เวลา ลักษณะการเปลี่ยนแปลง และผู้เปลี่ยนแปลงจะถูกเพิ่มลงในรายการที่เกี่ยวข้องของ "การติดตามฟิลด์"`,
"canlendarmonth":`เดือนปฏิทิน`,
"vue_label_dashboard_minimum":`โปรดใส่ค่าต่ำสุด`,
"label.salescloud.optionlist.inputname.linealone":`เพิ่มค่ารายการตัวเลือกด้านล่างหนึ่งค่าหรือมากกว่า แต่ละค่าควรอยู่ในบรรทัดของตัวเอง`,
"message.error.organuzation.information.null":`ไม่มีข้อมูลองค์กร`,
"label.tabpage.maxfilez":`ขนาดไฟล์ใหญ่ที่สุดคือ`,
"message.validation.apiname":`จำเป็นต้องเริ่มต้นด้วยตัวอักษร มีได้เฉพาะตัวอักษรตัวพิมพ์ใหญ่ตัวพิมพ์เล็ก ตัวเลข ขีดล่าง ความยาวมากที่สุด 50 หลัก และน้อยที่สุด 2 หลัก`,
"report.type.label.contractPayment":`สัญญาและการจ่ายเงิน`,
"label.limiting.choose.three.files":`ปัจจุบันเลือกได้สูงสุด 3 ไฟล์ ซึ่งถูกเลือกแล้ว`,
"label.reportTypeFocus":`ให้ความสนใจกับแหล่งข้อมูลรายงาน`,
"Report_Delete_Confirm_Title":`กรุณายืนยัน`,
"front-gantt-module-reorder-milestones":``,
"front-starter-v1-customer-tips-success":`เปิดฐานข้อมูลลูกค้าสำเร็จ`,
"label.tabpage.isdeleteview":`คุณยืนยันจะลบมุมมองนี้หรือไม่?`,
"label.favorite.title":`แพลตฟอร์ม CloudCC`,
"page.layout.sysinfo":`ข้อมูลระบบ`,
"label.tabpage.pleaseSelectz":`กรุณาเลือก`,
"label.smsnotice":`แจ้งเตือนข้อความสั้น`,
"label.forecast.customforecast.foretype.Pipeline":`Pipeline`,
"label.rejectbehaviour":`พฤติกรรมการปฏิเสธ`,
"label.searchlayout.view.example.new":`ดูตัวอย่าง (หน้าต่างใหม่)`,
"vue_label_homepage_notice2":`คุณสามารถกำหนดเค้าโครงหน้าแรกได้ด้วยตนเองเพื่อให้พนักงานทำภารกิจประจำวันได้มีประสิทธิภาพมากขึ้น`,
"label.import.index.chooseidorother":`3. คุณสามารถเลือกใช้ id หรือชื่อที่ตรงกับบันทึกและกรอกข้อมูลลงในฟิลด์การค้นหา หากต้องการรับบันทึก id ที่เกี่ยวข้องและข้อมูลอื่นๆ สามารถสร้างรายงาน และตั้งค่าชื่อบันทึกและ id บันทึกเป็นคอลัมน์กลุ่มและส่งออกรายงาน`,
"label.westem.european.summer.time":`เวลายุโรปตะวันตก`,
"label.brackets":`วงเล็บ`,
"asset.serialnumber.unique":`มีหมายเลขซีเรียลของสินทรัพย์อยู่แล้ว โปรดอย่าเพิ่มซ้ำ`,
"label.callcenter.access.keyID":``,
"label.calendar.month.view":`มุมมองรายเดือน`,
"label.realdelete":`ลบถาวร`,
"label.partnerCloud.orderingPlatform.amountPaid:":`จํานวนเงินที่ต้องชําระ:`,
"label.reportTypName":`ชื่อแหล่งข้อมูลรายงาน`,
"lable.newtabpage.opensearchresult":`เปิดผลการค้นหา`,
"front-kefu-moudle-v1-Session-duration":``,
"label.import.index.ignore":`เพิกเฉย`,
"label.customfields.url.tip":`อนุญาตให้ผู้ใช้ป้อน URL ที่ถูกต้องใดๆ หากลูกค้าคลิกฟิลด์นี้ จะเปิด URL ในหน้าต่างใหม่หรือหน้าต่างปัจจุบันของเบราว์เซอร์ตามโหมดที่ผู้ใช้เลือก ระบบจะเปิด URL ในหน้าต่างใหม่ของเบราว์เซอร์ตามค่าเริ่มต้น`,
"label.projectManagement.editMilestone":`แก้ไขไมล์สโตน`,
"front-gantt-module-v1-project-gantt-list":``,
"label.validate.remark":`การป้องกันไม่ให้ผู้ใช้บันทึกข้อมูลที่ไม่ถูกต้อง เกณฑ์การทวนสอบสามารถปรับปรุงคุณภาพข้อมูลได้ คุณสามารถกำหนดเกณฑ์การทวนสอบได้ตั้งแต่หนึ่งกฎขึ้นไป รวมถึงเงื่อนไขข้อผิดพลาดและข้อความแสดงข้อผิดพลาดที่เกี่ยวข้อง เกณฑ์การทวนสอบจะดำเนินการขณะทำการบันทึก หากสอดคล้องกับเงื่อนไขข้อผิดพลาด การบันทึกจะถูกยกเลิกและข้อความแสดงข้อผิดพลาดจะปรากฏขึ้น`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`รูปแบบโทรศัพท์ไม่ถูกต้อง กรุณาป้อนอีกครั้ง`,
"label.channel.name":`ชื่อช่องทาง`,
"label.weixin.cloudcc.user.message":`ข้อมูลผู้ใช้ CloudCC`,
"label.icon.59":`โรงงาน`,
"label.ccpeak.function":`เมธอด`,
"lable.opppdt.selPdt.leastten.fields":`โปรดเลือกมากสุดห้าฟิลด์`,
"label.deadline":`เวลาสิ้นสุด`,
"label.product.sel":`เลือกสมุดราคา`,
"vue_label_helpcenter_detail2":`กิจกรรมทั้งหมด: แสดงกิจกรรมทั้งหมดที่คุณมีสิทธิ์เข้าถึงได้, ถึงแม้ว่าคุณจะไม่ได้เข้าร่วม<br>คุณยังสามารถกรองบันทึกกิจกรรมที่คุณต้องการดูตามช่วงวันที่และประเภทกิจกรรมได้อีกด้วย <br>4. ความเคลื่อนไหว<br>พนักงานทั้งหมดที่สามารถดูบันทึกนี้สามารถโพสต์ความคิดเห็นที่ใต้หัวข้อ “ความเคลื่อนไหว” ของบันทึกนี้ และคุณยังสามารถดูความเปลี่ยนแปลงของข้อมูล กิจกรรมล่าสุด และโพสต์ความคิดเห็นของคนอื่นๆ ที่เกี่ยวกับบันทึกนี้ได้อีกด้วย หัวข้อนี้ช่วยให้คุณ<br>และเพื่อนร่วมงานสามารถสื่อสารและทำงานร่วมกันทางออนไลน์ได้อย่างสะดวก<br>การเผยแพร่โพสต์<br>ขั้นตอนที่ 1: คลิกที่ช่องเผยแพร่โพสต์, ป้อนเนื้อหาของโพสต์<br>ขั้นตอนที่ 2: คลิกปุ่มไฟล์/ลิงก์ เพื่อเพิ่มไฟล์/ลิงก์ตามต้องการ<br>ขั้นตอนที่ 3: คลิก "แบ่งปัน" เพื่อสิ้นสุดการโพสต์. <br>การดูโพสต์<br>หลังจากเผยแพร่โพสต์สำเร็จแล้ว คุณจะเห็นโพสต์ที่คุณเพิ่งโพสต์ที่ด้านล่าง ในโพสต์จะประกอบด้วยส่วนต่างๆ ดังต่อไปนี้: รูปโปรไฟล์, ชื่อพนักงาน, เนื้อหาของโพสต์และวิธีการโต้ตอบ (ถูกใจ/แสดงความคิดเห็น/แก้ไข/ลบโพสต์) <br>การจัดเรียงและค้นหาโพสต์<br> สามารถเปลี่ยนวิธีการจัดเรียงโพสต์ได้ โดยคลิก "จัดเรียง" ที่รายการเลื่อนลงทางด้านขวา<br>เรียงลำดับ "กิจกรรมล่าสุด": จัดเรียงตามเวลาโต้ตอบล่าสุดของโพสต์<br>เรียงลำดับ "เผยแพร่ล่าสุด": จัดเรียงตามเวลาเผยแพร่ของโพสต์ <br>ดูโพสต์ประเภทต่างๆ <br>ข้อความโพสต์ธรรมดา: สามารถเรียกดูเนื้อหาทั้งหมดได้โดยตรงในพื้นที่เผยแพร่โพสต์ <br>โพสต์ที่มีไฟล์: คลิกปุ่มดาวน์โหลดของไฟล์ เพื่อดาวน์โหลดไฟล์ลงในเครื่องเพื่อดู <br>โพสต์ที่มีลิงก์: คลิกลิงก์ในโพสต์เพื่อเปิด <br>แสดงความคิดเห็นและกดถูกใจบนโพสต์<br>แสดงความคิดเห็น<br>ขั้นตอนที่ 1: คลิก "แสดงความคิดเห็น" ใต้โพสต์แต่ละรายการ<br>ขั้นตอนที่ 2: ป้อนเนื้อหาของความคิดเห็นในกล่องข้อความ<br>ขั้นตอนที่ 3: เพิ่มไฟล์/ลิงก์ในความคิดเห็นตามความต้องการ<br>ขั้นตอนที่ 4: คลิก "แสดงความคิดเห็น" ใต้กล่องข้อความเพื่อสำเร็จการดำเนินการ<br>ลบความคิดเห็น<br>ผู้เขียนความคิดเห็นสามารถลบเนื้อหาของความคิดเห็นได้โดยคลิกปุ่มทางด้านขวาของความคิดเห็นในช่องเลื่อนลงให้เลือก "ลบ"`,
"pagecreator_layout_button_mergecell":`ผสานเซลล์`,
"Lead_Scoring_Setting_Rule_Setup_Active":`เปิดใช้งานหรือไม่`,
"label.query.detail.loginbypartneruser":`เข้าสู่ระบบเว็บไซต์พาร์ทเนอร์คลาวด์ในฐานะผู้ใช้`,
"label.view.selectrenderfields":`เลือกฟิลด์ที่จะให้แสดง`,
"label.code.add":`เพิ่มลิงก์ข้อมูลรหัสคิวอาร์`,
"label.appointmentconfirmpage.wizard.title1":`นัดประชุมแล้ว`,
"label.timzone.tip.title":`รองรับหลายโซนเวลาสำหรับข้อมูลวันที่และเวลา เมื่อใช้ new Date() หรือ Calendar เพื่อประมวลผลวันที่ คุณควรให้ระวังปัญหาเกี่ยวกับหลายโซนเวลา นอกจากนี้คลาสเครื่องมือ TimeUtil ยังมีวิธีเครื่องมือมากมายที่รองรับหลายโซนเวลา`,
"label.tag.addtags.visibility":`การมองเห็น`,
"label.appointmentconfirmpage.wizard.title3":`คุณยืนยันว่าต้องการยกเลิกการนัดหมายที่มีอยู่และสร้างใหม่หรือไม่?`,
"lable.outlook.detail.oldest":`เก่าที่สุด`,
"label.account.custom.quarter.timeerror":`วันเริ่มต้นหรือวันสิ้นสุดไตรมาสที่กำหนดเองอยู่ภายในช่วงไตรมาสที่กำหนดเองในอดีต โปรดตรวจสอบและตั้งค่าอีกครั้ง!`,
"label.sendsms.idea":`ที่เคารพ`,
"label.manageAll.pagenum2":`นี่เป็นหน้าสุดท้ายแล้ว`,
"serviceterritory.isactive.notactive":`ไม่ได้เปิดใช้งานภูมิภาคให้บริการนี้`,
"label.userinfo.newpwd.notnull":`รหัสผ่านใหม่ไม่สามารถว่างเปล่า!`,
"vue_label_dashboard_nolinkagedashboard":`ไม่ได้เชื่อมต่อแดชบอร์ด`,
"message.cannotdeleteapproval":`ไม่สามารถลบกระบวนการอนุมัติได้`,
"label.wtd.detail.m":`รุ่นสำหรับอุปกรณ์มือถือ`,
"label.app.step4.introduce":`เลือกเมนูที่จะรวมไว้ในแอปพลิเคชันที่กำหนดเองนี้`,
"label.ccchat.error.permission":`ไม่มีสิทธิ์`,
"UG_opportunity_009":`หรือ`,
"label.Receivables.TheActualAmountOfMoney":`ยอดเก็บเงินจริง`,
"label.callcenter.no.search":`ไม่พบข้อมูลที่เกี่ยวข้อง`,
"label.user.introduce":`ผู้ใช้`,
"message.datalocked.addpdt":`โอกาสทางธุรกิจถูกล็อก ไม่สามารถเพิ่มสินค้าได้อีก`,
"label.sendsms.step1":`ขั้นตอนที่ 1: กำหนดผู้รับข้อความสั้น`,
"label.brief.contracts":`จำนวนสัญญา`,
"label.setup.mini.swap":`การตั้งค่าภาพสไลด์`,
"label.emailobject.wizard.desc1":`เชื่อมโยงอีเมลส่วนตัวของคุณเพื่อส่งอีเมลที่นี่และซิงค์กับบันทึกโดยอัตโนมัติ`,
"label.login.verification.mfa.desc2":`หากคุณไม่สามารถดำเนินการยืนยันได้ด้วยเหตุผลบางประการ (เช่น ทำโทรศัพท์หายหรือลบแอปพลิเคชัน MFA โดยไม่ได้ตั้งใจ เป็นต้น) คุณสามารถยกเลิกการผูก MFA ผ่านผู้ดูแลระบบได้`,
"label.notification.receiveSms.message":`คุณมีข้อความสั้นจาก{!fromaddress} โปรดคลิกเพื่อดู`,
"label.emailmerge.mergeFolder.publicfolder":`แม่แบบจดหมายเวียนสาธารณะที่ไม่ได้จัดเก็บถาวร`,
"label.password.update.false":`การเปลี่ยนรหัสผ่านล้มเหลว โปรดติดต่อผู้ดูแลระบบ!`,
"label_tabpage_systemz":`ระบบ`,
"label.dataimport.objectid.null":`ออบเจ็กต์ ID ว่างเปล่า ระบบไม่อนุญาตให้นําเข้า`,
"label.currency.type":`ประเภทสกุลเงิน`,
"component_setup_button_appurl":`URL ของระบบ`,
"label.appointmentconfirmail.wizard.title2":`คุณนัดหมาย{0}สำเร็จแล้ว`,
"lable.product.please.enter":`โปรดระบุ`,
"label.escalation.setup.title":`เกณฑ์การเลื่อนขั้นเคส`,
"label.create_failure":`การสร้างฟอร์มล้มเหลว`,
"label.weixin.brand.model":`ป้ายฉลากผลิตภัณฑ์`,
"label.layout.nameoftestobj2":`ชื่อออบเจ็กต์ทดสอบ 2`,
"vue_label_filters_number":`รายงานแต่ละรายงานรองรับตัวกรองได้สูงสุด 10 ตัว`,
"label.file.following":`กำลังติดตาม`,
"vue_label_account_all_contracts":`โอนย้ายสัญญาทั้งหมดของลูกค้าทุกคน`,
"label.service.please.select.cycle.type":`กรุณาเลือกประเภทวงจร`,
"label.weixin.weipoll.optionname":`ชื่อตัวเลือกเวยโพล`,
"label.data.newtemplate.null":`ไม่มีค่า`,
"message.passwordPolicy.validate.complexReq1":`ข้อผิดพลาด: รหัสผ่านต้องเป็นตัวเลขและตัวอักษรผสมกัน`,
"label.forecast.shre.editmanager":`ผู้จัดการบรรณาธิการ`,
"label.emailtemplate.tip":`แม่แบบอีเมลทั้งหมดในโฟลเดอร์ที่เลือกแสดงอยู่ด้านล่าง คลิกปุ่มสร้างใหม่"เพื่อสร้างข้อความหรือแม่แบบอีเมล HTML ใหม่ คุณสามารถใช้แม่แบบอีเมลเหล่านี้เมื่อส่งอีเมล คลิกลิงก์บทบาทเพื่อดูข้อมูลโดยละเอียด"`,
"label.tag.manage.button":`จัดการป้ายกำกับ`,
"label.changepw":`เปลี่ยนรหัสผ่าน`,
"label.sso.saml.sp.idsource.nameid":`ข้อมูลประจำตัวอยู่ในองค์ประกอบ NameIdentifier ของประกาศ "หัวเรื่อง"`,
"label.salescloud.teamrole.addmember":`เพิ่มสมาชิกทีมโอกาสทางธุรกิจ CloudCC`,
"label.h5.similar.opportunity.last.months6":`3-6 เดือนล่าสุด`,
"message.save.opportunity.role.save.failed":`การบันทึกบทบาทผู้ติดต่อล้มเหลว`,
"vue_label_report_formulainformation":`ข้อมูลสูตร`,
"label.area.assignuser.remark":`กำหนดผู้ใช้ให้กับภูมิภาค`,
"label.multilang.viewlist.total":`เลือกทั้งหมด {0} รายการบันทึก`,
"label.newprocessstep4":`ขั้นตอนที่ 4: เลือกแม่แบบการแจ้งเตือนอีเมล`,
"label.permission.objectpermission.open":`เปิด`,
"label.service.gantt.close.list":`ปิดรายการ`,
"label.standarduserfield":`ฟิลด์ผู้ใช้มาตรฐาน`,
"vue_label_commonobjects_detail_the_administrator":`บันทึกนี้ถูกล็อก โปรดติดต่อผู้ดูแลระบบ`,
"label.exchange.sync.account":`ข้อมูลรับรองบัญชีบริการ Exchange`,
"label.mr.title.button.back":`ย้อนกลับ และตั้งค่าเงื่อนไขการสืบค้นใหม่`,
"label.notsetup.operation":`เงื่อนไขไม่ถูกต้อง ไม่ได้ตั้งค่าตัวดำเนินการ!`,
"label.notifications_center":`ศูนย์การแจ้งเตือน`,
"label.event.moveup.5hour":`ล่วงหน้า 5 ชั่วโมง`,
"report_label_pleaseinput":`กรุณาใส่เนื้อหาที่ต้องการค้นหา`,
"label.batchadd.newbatchpage.errorlist":`การเพิ่มข้อมูลล้มเหลว`,
"label.quickbooks.invoices":`ใบแจ้งหนี้`,
"chatter.feed.usingchatter":`หลังจากเปิดใช้งาน CCChat จะสามารถติดตามพนักงานและบันทึก และสามารถโพสต์ได้`,
"label.all.marketing.activities":`เจ้าของแคมเปญ`,
"label.lookup.finish":`ค้นหาโดยอัตโนมัติ`,
"label.weixin.unbind":`ยกเลิกการผูก`,
"front-console-closeTime":``,
"label.service.rest.time":`เวลาที่เหลือ`,
"label.mr.descreption.condition1":`โปรดป้อนขอบเขตและเกณฑ์การสืบค้นข้อมูลซ้ำแล้วคลิกปุ่ม [สืบค้นข้อมูลซ้ำ] เพื่อรับข้อมูลซ้ำที่สอดคล้องกับเงื่อนไข`,
"label.group.new":`กลุ่มใหม่`,
"vue_label_SMS_sending_please_wait":`กำลังส่ง กรุณารอสักครู่`,
"label.Standardobj.tab":`แท็บออบเจ็กต์มาตรฐาน`,
"label_chatter_pastEvents":`กิจกรรมที่ผ่านมา`,
"label.chatter.priority":`ลำดับความสำคัญ`,
"select.nullvalue":`--ไม่มีค่า--`,
"setup_layout_group_pagecomponent":`องค์ประกอบเพจ`,
"label.dataimport.dataerror.check":`ข้อมูลผิดพลาด กรุณาตรวจสอบข้อมูลนี้อย่างละเอียด`,
"label.permission.detail.app.pagesetting.tip":`ดำเนินการตั้งค่าสิทธิ์เพจที่กำหนดเอง`,
"label.knowledge.language.polish":`ภาษาโปแลนด์`,
"label.project.hit.two":`แจ้งเตือนงานย่อยถึงกำหนด`,
"label.customerapp":`แอปพลิเคชันแบบกำหนดเอง`,
"label.reportsSubscriptionPage.condition.value":`ค่า`,
"label.tabpage.no2z":`ไม่ 2`,
"lable.system.administrator":`ขออภัย คุณไม่มีสิทธิ์ดําเนินการ โปรดติดต่อผู้ดูแลระบบ`,
"homepage.layout.buttion":`กำหนดเค้าโครงเพจ`,
"label.notification.event.overlapEvent":`ผู้ที่ได้รับมอบหมาย ณ {begintime}-{endtime} ได้จัดเตรียม{subject} ต้องการสร้างต่อหรือไม่？`,
"label.customfields":`ฟิลด์ที่กำหนดเอง`,
"label.data.downpage.e.title":`ขั้นตอนการส่งออกข้อมูล:`,
"label.notification.serviceappointment.remove":``,
"label.campagin.roi.zhuangtai":`สถานะแคมเปญ`,
"label.applt.updown":`ดาวน์โหลดรหัสคิวอาร์ของมินิโปรแกรม`,
"label.customfields.new.step1.tip":`ระบุประเภทของข้อมูลที่จะรวมในฟิลด์ที่กำหนดเอง`,
"label.staticresource.upload.limit":`อัปโหลดได้แค่รูปแบบไฟล์ต่อไปนี้: png, jpg, gif, js, css, zip`,
"chatter.edit.user.p":`เปลี่ยนรูปโปรไฟล์`,
"label.icon.32":`คอมพิวเตอร์`,
"vue_label_homepage_notice_cantset":`ไม่ได้กำหนดค่าหน้าแรกโปรไฟล์นี้ ไม่สามารถแก้ไขหน้าแรกเริ่มต้นของโปรไฟล์ได้`,
"front-epwechat-module-v1-agree-unbound":`ตกลงและยอมรับข้อมูลที่ไม่ผูกข้างต้น`,
"label.version.chatter.cooperation":`CCChat`,
"label.customer.tab.step1.selectstyle":`โปรดเลือกรูปแบบแท็บ`,
"label.select.an.asset":`กรุณาเลือกสินทรัพย์`,
"label.search.sizer.field":`ค้นหาฟิลด์ตัวกรอง`,
"label.emailmerge.mergeFolder.lastone":`โปรดเลือกอย่างน้อยหนึ่งแม่แบบ!`,
"label_tabpage_step2":`ขั้นตอนที่ 2: ระบุเงื่อนไขการกรอง`,
"label.version.lead.automatic.allocation":`จัดสรรลีดโดยอัตโนมัติ`,
"label.projectManagement.update.succeeded":`อัปเดตสำเร็จ`,
"label_tabpage_bar":`กราฟแท่ง`,
"label.appupload.component.type.tab":`เมนู`,
"label.pigeonhole.sel.f":`เลือกโฟลเดอร์ที่ต้องการจัดเก็บถาวร`,
"homepage.components.status":`สถานะส่วนเสริม`,
"label.currency.edit.new":`การแก้ไขสกุลเงิน: สกุลเงินใหม่`,
"label.input.new.password":`โปรดป้อนรหัสผ่านใหม่ที่ถูกต้อง`,
"chatter.group.membersName":`ชื่อสมาชิก`,
"label.myinfo.modify":`แก้ไขข้อมูลของฉัน`,
"label_tabpage_next":`ขั้นตอนถัดไป`,
"vue_label_homepage_card_closedopportunities":`โอกาสทางธุรกิจที่ค้างชำระ`,
"label.permission.edit":`แก้ไขคุณสมบัติ`,
"message.error.searchfield.objid.null":`id ออบเจ็กต์ที่จําเป็นสําหรับฟิลด์แบบสอบถามต้องไม่ว่างเปล่า`,
"label.partnerCloud.productSet":`การตั้งค่าผลิตภัณฑ์`,
"label.emailtocloudcc.filed.emailto":`Email to`,
"label.service.miniProgram.uploadingImage":`กรุณาอัปโหลดภาพสไลด์`,
"label.sso.saml.idp.description1":`แอปพลิเคชันที่เชื่อมต่อ`,
"label.event.moveup.10minutes":`ล่วงหน้า 10 นาที`,
"label.quote.createby":`ผู้จัดเตรียม`,
"label.workflow.baseontimeoparate":`ดำเนินการเวิร์กโฟลว์ตามเวลา`,
"label.searchall.r":`ค้นหาอีกครั้ง`,
"vue_label_homepage_differentprofiles":`กำหนดหน้าแรกที่แตกต่างกันสำหรับโปรไฟล์ที่แตกต่างกัน`,
"label.campaign.channel.step1":`ขั้นตอนที่ 1: ข้อมูลพื้นฐาน`,
"label.event.moveup.2hour":`ล่วงหน้า 2 ชั่วโมง`,
"font-evaluate-module-v1-cancle-reply":``,
"message.datalocked.delete":`บันทึกถูกล็อก: บันทึกที่คุณพยายามลบถูกล็อก หากต้องดำเนินการนี้ โปรดติดต่อผู้ดูแลระบบ`,
"label.sso.listOfKey":`รายการคีย์`,
"label_chatter_newtask":`ภารกิจใหม่`,
"label_emailsync_form_seversetting":`การตั้งค่า`,
"label.partner.new.function":`คำอธิบายฟังก์ชัน`,
"vue_label_notice_homepage_pleaceentername":`กรุณาใส่ชื่อหน้าแรก`,
"message.please.choose.opportunity":`โปรดเลือกโอกาสทางธุรกิจ`,
"label_file_use_most_user":`ผู้ใช้ที่ใช้พื้นที่เก็บข้อมูลมากที่สุด`,
"label.htyj.remark2":`ไม่สามารถดูผลสำเร็จของสัญญา`,
"label.formula.message":`เมื่อสูตรถูกประเมินว่าเป็นเท็จ ข้อความความล้มเหลวที่ส่ง`,
"UG_Case_04":`การจัดสรรเคส`,
"label.displaycolumn":`แสดงคอลัมน์`,
"vue_label_campaign_selected_member_status":`อัปเดตเป็นสถานะสมาชิกที่เลือก`,
"label.workflow.operate":`การดำเนินการเวิร์กโฟลว์`,
"label_chatter_mail":`อีเมล`,
"label.setup.mini.setting":`การตั้งค่าหลังบ้านมินิโปรแกรม`,
"vue_label_chat_invitetojoin":`คุณได้เชิญ"{invite}"เข้าร่วมกลุ่มสนทนา`,
"setup.object.field.dependency.label.linkedfieldvalue":`ค่าฟิลด์พึ่งพา`,
"vue_label_email_update_template":`อัปเดตแม่แบบ`,
"label.email.template.private.mail":`โฟลเดอร์แม่แบบอีเมลส่วนตัว`,
"lable.Confirm .potential.customers":`ยืนยันการรีไซเคิลลีด{name}`,
"vue_label_leadpool":`ฐานข้อมูลลีด`,
"label.ems.hostorpost.error":`การปรับแต่งเซิร์ฟเวอร์และพอร์ตผิดพลาด โปรดตรวจสอบ`,
"label.search.saveok":`การบันทึกสำเร็จ`,
"label.custom.field.cannot.maping":`ไม่สามารถแม็ปกับฟิลด์นี้มากกว่าหนึ่งครั้ง`,
"label.projectManagement.dispatched":`จัดส่ง`,
"time":`เวลา`,
"label.choose_socialnetwork":`เลือกเครือข่ายทางสังคมเพื่อเริ่มต้น`,
"label.vlidaterule.checkedtrue":`หากเป็นกล่องกาเครื่องหมายจะตัดสินแบบนี้โดยไม่ต้องเพิ่มเครื่องหมายอัญประกาศ`,
"label.appointmentconfirmail.wizard.btn1":`นัดหมายอีกครั้ง`,
"front-kefu-moudle-v1-maxchars-input":`ป้อนได้สูงสุด {0} อักขระ`,
"setup.mainpage.label.welcome10":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าแอปพลิเคชัน → สร้าง → ออบเจ็กต์ → ชื่อออบเจ็กต์ → เค้าโครงที่กำหนดเอง`,
"label.ems.company.setup.title":`ตั้งค่ากล่องขาออกของบริษัท`,
"label.channel":`ช่องทางการขาย`,
"label.textmessage.groupsms":`ส่งข้อความสั้นแบบกลุ่ม`,
"label.asset.deleted.successfully":`ลบ BOM สินทรัพย์สำเร็จ`,
"label.knowledgebase.new.workspace":`เวิร์คสเปซใหม่`,
"label.ServiceCloud.diliweizhi":`ตำแหน่งที่ตั้ง`,
"label.private_me":`สําหรับทุกคนเท่านั้น (ฉัน)`,
"label.service.miniProgram.imageLink":`ลิงก์ภาพสไลด์`,
"label.area.assigned":`ผู้ใช้ที่ได้รับมอบหมาย`,
"label.weixin..xsld.name":`ชื่อโอกาสทางธุรกิจ`,
"label.campaign.matchway.select.name":`ชื่อ`,
"label.installedsoft":`ติดตั้งโปรแกรมสำเร็จรูปแล้ว`,
"label.projectManagement.spare.time":`เวลาว่าง`,
"label.user.select.custom.text.sendemail":`เลือกรูปแบบข้อความที่กำหนดเองเพื่อส่งอีเมลโดยตรง`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`ดำเนินการอนุมัติ`,
"startdate.enddate.time.illegal":`วันที่เริ่มต้นควรน้อยกว่าหรือเท่ากับวันที่สิ้นสุด`,
"label.project.hit.eight":`แจ้งเตือนงานโครงการทุกวัน`,
"message.duplication.label.uncheck":`ไม่ตรวจสอบ`,
"label.allocation.role":`กำหนดผู้ใช้`,
"label.sendemail.lead.scoreinfo":`#userNameที่เคารพ: \ r \ n ระบบได้ใช้เกณฑ์การให้คะแนนลีดเพื่อให้คะแนนลีดทั้งหมดในมุมมองลีด"#viewlabel"ที่คุณเลือก ซึ่งจะใช้เวลา #timestr \ r \ n โปรดเข้าสู่ระบบ และเปิดมุมมองเพื่อดู \ r \ n โปรดทราบ: \ r \ n 
หากคุณไม่เห็นคะแนนของลีด คุณสามารถแก้ไขมุมมองและเพิ่ม "การให้คะแนนลีด" ลงในฟิลด์ที่จะแสดงเพื่อดูผลการให้คะแนน \ r \ n ขอบคุณที่ใช้! \ r \ n

#orgName \ r \ n`,
"lable.oppt.jieduan.closejieduan":`ปิดโอกาสทางธุรกิจนี้`,
"label.ems.verify":`ยืนยัน`,
"message.error.startdate":`วันเริ่มต้นต้องน้อยกว่าวันสิ้นสุด`,
"label.campaignmember.main.deletelead":`ลบสมาชิก-ลีด`,
"label.partnerCloud.financeSetting.account":`เมื่อเปิดใช้งาน ออบเจ็กต์บัญชีพาร์ทเนอร์และกระแสบัญชีจะถูกเพิ่มเข้ามา และเมื่อสั่งซื้อ ผู้ใช้พาร์ทเนอร์จะสามารถชําระเงินผ่านบัญชีในระบบ CloudCC ได้`,
"message.datalocked":`บันทึกถูกล็อก: <br> บันทึกที่คุณพยายามแก้ไขถูกล็อก หากคุณต้องดำเนินการนี้ โปรดติดต่อผู้ดูแลระบบของคุณ`,
"lable.opppdt.selPbk.pricebook":`สมุดราคา`,
"label.knowledgebase.restore.article":`เรียกคืนบทความ?`,
"label.object.batchadd":`เพิ่ม{objName}แบบชุด`,
"label.what_happen":`หน้าเพจที่ผู้เข้าชมเห็นหลังจากส่งฟอร์มนี้`,
"label.roleandunderling":`บทบาทและผู้ใต้บังคับบัญชา`,
"label.knowledge.language.russian":`ภาษารัสเซีย`,
"front-electronic-signature-explain-first":``,
"component.sendmail.label.subject":`หัวข้อ`,
"month":`เดือน`,
"label_chatter_save":`บันทึก`,
"label.view.sortview.sectiontitle":`มุมมองจะถูกส่งออกตามลำดับที่เลือก`,
"label.mobile.home.page.major.project":`โครงการหลัก`,
"label.weixin.input.filename":`โปรดระบุชื่อไฟล์`,
"label.pagelayout.remark":`ใช้หน้านี้เพื่อสร้างเค้าโครงเพจต่างๆ ที่จะแสดง`,
"label.service.miniProgram.store":`เรื่องราวของแบรนด์`,
"label.recordtype.edit.selected":`ค่าที่เลือก`,
"message.selectgroupcondition":`กรุณาเลือกเงื่อนไขการจัดกลุ่ม`,
"label.y.axis.cannot.empty":`แกน Y ไม่สามารถว่างเปล่า!`,
"label.textmessage.vonage.connected.count":`นับเป็นการติดต่อ`,
"setup.layout.label.readonly":`อ่านอย่างเดียว`,
"front-kefu-moudle-service-agent":``,
"message.login.mfaverification.page.invalid":`เพจใช้งานไม่ได้ โปรดรีเฟรชอีกครั้ง`,
"label.central.standard.time":`เวลามาตรฐานกลาง`,
"label.processnoticepic":`รูปแจ้งเตือนกระบวนการอนุมัติ`,
"vue_label_helpcenter_calendar1.2":`เกณฑ์การแสดงรายการปฏิทิน: รายการที่บันทึกไว้ในปฏิทินจะแสดงอยู่ในตารางปฏิทินโดยช่วงเวลาบันทึกจะแสดงในพื้นที่กริด ด้านบนสุดของของมุมมองรายวัน รายสัปดาห์ และความพร้อมใช้งานจะแสดงรายการที่มีระยะเวลาเกินกว่า 24 ชั่วโมง หากมีหลายรายการในมุมมองรายเดือนคุณสามารถกด "  เพิ่มเติม" เพื่อดูรายการเหล่านี้ ด้านซ้ายหรือขวาของรายการที่ปรากฏรูปทรงคล้ายครึ่งวงกลมแสดงว่าไม่มีบันทึกใดๆ ในวันก่อนหน้าหรือวันถัดไปในตาราง หากปรากฏมุมฉากแสดงว่ามีบันทึกในวันก่อนหน้าหรือวันถัดไปในตาราง <br>ค้นหาวันที่ของมุมมองปฏิทินอย่างรวดเร็ว: คุณสามารถค้นหาช่วงวันที่ที่แสดงในมุมมองปฏิทินทางด้านซ้ายโดยเลือกเวลาบนปฏิทินขนาดเล็กทางด้านขวาของหน้าปฏิทิน คุณยังสามารถคลิกไอคอน "<"และ">" ที่ด้านขวาบนของหน้าปฏิทินเพื่อสลับระหว่างวันที่ได้อย่างรวดเร็ว หากมุมมองปฏิทินของคุณไม่ใช่เวลาปัจจุบัน คุณสามารถคลิกไอคอน "วันนี้" ที่ด้านขวาบนของหน้าปฏิทินเพื่อเปลี่ยนกลับมาเป็นวันนี้อย่างรวดเร็ว <br> มุมมองรายการ<br>เปลี่ยนจากมุมมองปฏิทินเป็นมุมมองรายการ: คลิกไอคอน "ปฏิทิน" ที่ด้านบนขวาของมุมมองแล้วเลือก "ตาราง" เพื่อสลับไปยังมุมมองรายการอิเวนต์ <br>การใช้มุมมองรายการ: หากต้องการดูอิเวนต์แบบเจาะจงหรือหลายอิเวนต์พร้อมกัน ให้เปิดมุมมองตาราง จะมีมุมมองรายการที่ตั้งไว้ล่วงหน้า คลิกไอคอน "ปุ่มแบบดึงลง" ที่มุมบนซ้ายของมุมมองรายการเพื่อแสดงมุมมองรายการทั้งหมดที่คุณมีสิทธิ์เข้าถึง คุณยังสามารถไปที่ตั้งค่ามุมมองรายการ เพื่อปรับแต่งมุมมองให้ตรงกับความต้องการของคุณ <br>2. ปฏิทินของฉันและปฏิทินอื่นๆ<br>ปฏิทินของฉัน<br>ปฏิทินของฉันรวมถึงปฏิทินกิจกรรมและปฏิทินออบเจ็กต์ของฉัน <br>ปฏิทินอิเวนต์ของฉัน: แสดงบันทึกอิเวนต์ทั้งหมดที่คุณได้รับมอบหมายจากผู้อื่นในมุมมองปฏิทิน ปฏิทินอิเวนต์ของฉันไม่สามารถลบ แก้ไข หรือเปลี่ยนสีได้ คุณสามารถแบ่งปัน "ปฏิทินกิจกรรมของฉัน" กับเพื่อนร่วมงานของคุณ`,
"label.approval.end":`จบกระบวนการ`,
"vue_label_report_notice_cannotdelete":`มีรายงานในโฟลเดอร์นี้ไม่สามารถลบได้`,
"label.sso.saml.idp.loginurl":`URL เข้าสู่ระบบผู้พิสูจน์และยืนยันตัวตน`,
"label.emailtocloudcc.filed.port":`พอร์ต`,
"label.directdashboard.righttitle":`แดชบอร์ดวิเคราะห์การขาย`,
"label.knowledge.case.suggest.article":`แนะนำบทความที่เกี่ยวข้องกับเคส`,
"label.version.maxcount":`, เกินขีดจำกัดแล้ว!`,
"label.weixin..xsld.yjqyrq":`วันที่ทำสัญญาคาดการณ์`,
"front-project-module-v1-unmarket-is-template":`ยกเลิกแท็กแม่แบบ`,
"label.mobile.quickcreate.default.map":`ลงทะเบียนเข้า`,
"chatter.click.p":`คลิกแสดงตัวอย่าง`,
"label.chat.topic.all.topic":`หัวข้อทั้งหมด`,
"label.channel.head":`หัวหน้าช่องทาง`,
"lable.edit.queue.emaildes":`ป้อนชื่อคิวและที่อยู่อีเมลที่จะใช้ในการส่งการแจ้งเตือน (เช่น เมื่อใส่เคสลงในคิว) ที่อยู่อีเมลอาจเป็นที่อยู่เดียวหรือรายชื่อแจกจ่ายก็ได้ เมื่อกำหนดออบเจ็กต์ให้กับคิว ระบบจะแจ้งเฉพาะสมาชิกคิวเท่านั้น`,
"label.tag.filter":`กรองป้ายกำกับ`,
"label_chatter_filterTimeLine":`ตัวกรองไทม์ไลน์`,
"label.dashboard.show.value":`แสดงมูลค่า`,
"vue_label_normal_solution_sf":`โซลูชัน`,
"label.customfields.location.tip":`อนุญาตให้ผู้ใช้กำหนดตำแหน่ง รวมถึงส่วนเสริมลองจิจูดและละติจูดซึ่งสามารถใช้ในการคำนวณระยะทาง`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com, inc. สงวนลิขสิทธิ์ Beijing CloudCC.com Technology Co.,ltd.`,
"label.icon.33":`คอมพิวเตอร์`,
"label.mr.title.opportunityName":`ชื่อโอกาสทางธุรกิจ`,
"template.report.sales.month":`ยอดขายเดือนนี้`,
"chatter.group.lookingForPeople":`ค้นหาพนักงาน...`,
"label_tabpage_userz":`ผู้ใช้`,
"label.reportsSubscriptionPage.email.formatselection":`กรุณาเลือกแบบฟอร์มรายงานที่ต้องการใช้ในการส่งอีเมล`,
"lable.product.plist":`ราคาปลีก`,
"label.multilang.activity.monthline":`สัปดาห์ที่ {0}`,
"label.ccchat.whose.name.contains2":`ของสมาชิกกลุ่มกิจกรรมใดๆ`,
"label.mobile.phone.day.report":`รายงานประจำวัน`,
"label.processsetting.set.files":`ตั้งค่าฟิลด์`,
"label.systemlog.s":`สำเร็จ`,
"label.tabpage.uploadsz":`อัปโหลด`,
"serviceterritory.member.time.conflict":`ในช่วงเวลานี้ ทรัพยากรการบริการเป็นสมาชิกภูมิภาคให้บริการอื่น`,
"label_chatter_startDate":`วันที่เริ่มต้น`,
"label.search.at.least.two":`คำค้นหาต้องยาวไม่น้อยกว่า 2 อักขระ`,
"label.approval.ressign.project":`รายการที่จะมอบหมาย`,
"lable.custom.Previous.CY":`ปีที่กำหนดเองก่อนหน้า`,
"label_chatter_link":`ลิงก์`,
"label.weixin.group.name":`ชื่อ`,
"label.partnerCloud.basicSetting.domainName":`การดำเนินการนี้ไม่สามารถย้อนกลับได้ และชื่อโดเมนจะไม่สามารถแก้ไขได้หลังจากที่เริ่มต้น คุณแน่ใจหรือไม่?`,
"lable.SalesCommitmentKanBan.targetContract":`จำนวนทำสัญญาเป้าหมาย`,
"label.currency.new":`สกุลเงินใหม่ของบริษัท`,
"message.passwordPolicy.validate.complexReq3":`ข้อผิดพลาด: รหัสผ่านจะต้องประกอบด้วยตัวเลข ตัวอักษรพิมพ์ใหญ่พิมพ์เล็กและสัญลักษณ์`,
"label.icon.127":`หมอ`,
"label.customfields.fieldname.tip":`ชื่อฟิลด์"ถูกใช้สำหรับการเชื่อมต่อ API ภายใน`,
"chatter.feed.menutype.feed":`บทคัดย่อ`,
"label.home.standard.dashboard.role":`คุณไม่มีข้อมูลบทบาท ไม่สามารถดูคัมบังข้อผูกมัดการขายได้`,
"label.customfields.fielddependency.button":`คลิกปุ่มเพื่อรวมหรือแยกค่าที่เลือกจากรายการตัวเลือกการพึ่งพา`,
"label.recentprojects":`บันทึกการเข้าล่าสุด`,
"label.appupload.logo.introduce":`ขนาดไฟล์ไอคอนของโปรแกรมสำเร็จรูป AppExchange ต้องเล็กกว่า 20K เพื่อให้ได้ผลลัพธ์ที่ดีที่สุด ขนาดภาพที่แนะนำ คือ กว้าง 60 พิกเซลและสูง 60 พิกเซล หากเป็นขนาดอื่นระบบจะทำการปรับขนาดรูปภาพและภาพอาจผิดเพี้ยนจากที่เป็นจริง นอกจากนี้ภาพใหม่จะมีผลหลังจากบันทึกแล้วเท่านั้น`,
"label.integrations.northamericanleads":`ลีดในทวีปอเมริกาเหนือ`,
"label.sms.balance":`ยอดคงเหลือ (หยวน)`,
"label.ccchat.message.num":`ข้อความ`,
"label.embed_website":`เพียงคัดลอกและวางโคดต่อไปนี้ลงในโคด HTML ของหน้าเว็บเพื่อฝังฟอร์มนี้`,
"label.trigger.check.error":`การตรวจสอบทริกเกอร์ไวยากรณ์ล้มเหลว`,
"label.bmap.baidu.maps":`แผนที่ไป่ตู้`,
"label.nextapproverauto":`วิธีการกำหนดผู้อนุมัติคนถัดไปแบบอัตโนมัติ`,
"label.customfields.date.tip":`อนุญาตให้ผู้ใช้ใส่วันที่หรือเลือกวันที่จากปฏิทินที่ปรากฎ`,
"button.partner.back":`ย้อนกลับ`,
"label.layout.editcondition.tip":`เลือกฟิลด์ที่จะใช้เป็นเงื่อนไขการค้นหา หมายเหตุ สามารถเลือกได้มากสุด 10 ฟิลด์`,
"label.stacked.area":`กราฟพื้นที่แบบเรียงซ้อน`,
"font-evaluate-module-v1-case-closed":``,
"label_emailsync_status_log":`เชื่อมต่อล็อก`,
"label.version.area.and.sales":`ทีมบริหารและทีมขายระดับภูมิภาค`,
"label.service.booking.sessions":`เวลานัดหมายบริการ`,
"label.untransfile":`ไฟล์ภาษาที่ไม่ได้แปล`,
"label.textmessage.sentfail":`การส่งล้มเหลว`,
"label.emailtemplate.detailinfo":`รายละเอียดแม่แบบอีเมล`,
"setup_mainpage_label_welcome13":`คำแนะนำการใช้งาน: คลิกที่เมนูด้านบน → รายงาน → สร้างใหม่`,
"label.ccchat.error.nullid":`ID ไม่สามารถว่างเปล่า`,
"label.partnerCloud.partnerAccount.rebate":`รายได้เงินคืน`,
"label.appupload.component.type.scheme":`ฟิลด์`,
"front-kefu-moudle-phonein":``,
"label.emailmerge.list.description":`แม่แบบจดหมายเวียนเป็นเอกสาร Microsoft Word ที่ฟิลด์ผสานหมายถึงฟิลด์ CloudCC  คลิกที่ 'แม่แบบใหม่' เพื่ออัปโหลดแม่แบบจดหมายเวียนใหม่`,
"vue_label_commonobjects_detail_select_first":`โปรดเลือกรายการที่เกี่ยวข้องก่อน`,
"label_emailsync_form_action":`ดำเนินการ`,
"label.customfieldrelation":`ฟิลด์ที่กำหนดเองและความสัมพันธ์`,
"label.ems.other.msg":`โปรดติดต่อผู้ดูแลระบบ Cloudcc (<a href='mailto:admin@cloudcc.com' style='text-decoration: underline;'> admin@cloudcc.com </a>) เพื่อเปิดใช้งานบริการซิงค์อีเมล`,
"label.appointment.wizard.subtitle4-3-4":`1 ชั่วโมง`,
"label.service.miniProgram.isOpen":``,
"equal":`เท่ากับ`,
"label.partnerCloud.financeSetting.merchantInformation":`พาธการรับ: แพลตฟอร์มร้านค้า - ศูนย์จัดการล็อกอิน - ข้อมูลร้านค้า`,
"vue_label_calendar_displayed_field_name":`ชื่อฟิลด์ที่แสดง`,
"UG_opportunity_002":`กำหนดวงจรการขายและปรับแต่งสเตจของคุณ`,
"label.tag.addtags.button1":`ยืนยัน`,
"label.explain":`อธิบาย`,
"label.icon.166":`ศาลา`,
"label.exchange.sync.setting.use":`เปิดการใช้งาน Exchange Sync`,
"label.chatter.assignPerson":`ผู้ได้รับมอบหมาย`,
"lable.PowerProcess.event.condition":`เงื่อนไขอิเวนต์สำคัญ`,
"label.addattachment.step1":`ขั้นตอนที่ 1. เลือกไฟล์`,
"label.account.fiscal.quarter.timeerror":`กรุณาตรวจสอบและตั้งค่าวันเริ่มต้นหรือวันสิ้นสุดไตรมาสงบประมาณให้อยู่ในช่วงเวลาไตรมาสงบประมาณที่ผ่านมาใหม่อีกครั้ง!`,
"label.URL":`พาธของ URL`,
"label.icon.134":`ข้อมูล`,
"label.forecast.customforecast.foredis.sq":`พัน`,
"label.custom.field.number.decimal":`ตำแหน่งตัวเลขไม่ถูกต้อง`,
"label.version.history.track.error":`รุ่นปัจจุบันของคุณรองรับเฉพาะการเลือก <=5 ฟิลด์ ไม่สามารถเลือกเพิ่มเติมได้`,
"label.log.os":`ระบบปฏิบัติการ`,
"label.partner.workspace.tab.option":`ตัวเลือกแท็บ`,
"label.partnerCloud.partnerAccount.accountWater":`กระแสบัญชี`,
"setup_layout_label_norelatedlist":`ไม่มีรายการที่เกี่ยวข้อง`,
"label.import.page1.nextstep":`ขั้นตอนถัดไป`,
"label.emailobject.view.attached":`มีไฟล์แนบ`,
"label.SalesCommitmentKanBan.allTask":`ภารกิจทั้งหมด`,
"label.eastem.daylight.time":`เวลาออมแสงตะวันออก`,
"label.create_engaging":`สร้างโพสต์ที่น่าสนใจเพื่อเชื่อมต่อกับโลก`,
"label.area.adduser":`เพิ่มหรือลบผู้ใช้`,
"label.timezone.importtimezone.user":`ใช้โซนเวลาปัจจุบันของผู้ใช้`,
"label.passwordPolicy.setup.pwdremember1":`จำ 1 รหัสผ่าน`,
"label.query.detail.openpartneruser":`เปิดใช้งานผู้ใช้พาร์ทเนอร์`,
"label.senduser":`ผู้ส่ง`,
"Pagelayout_Setup_001":`เลือกรายการที่เกี่ยวข้องเพื่อแสดงบนเค้าโครงหน้าโฮเวอร์`,
"label.mobile.parameter.setup":`ตั้งค่าพารามิเตอร์อุปกรณ์มือถือ`,
"message.device.not.bound.mfa":`อุปกรณ์ MFA เด้งหลุด`,
"setup.layout.label.buttonarea":`พื้นที่ปุ่ม`,
"chatter.email.reply.like":`เมื่อตอบกลับโพสต์ที่ฉันชื่นชอบ`,
"label.chatter.day":`วัน`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat ตอบกลับเวยเทียที่ชื่นชอบ`,
"label.field.remark2":`ฟิลด์ที่แสดงหน้าเพจ`,
"label.ggReleaseRange.release":`ขอบเขตการเผยแพร่`,
"lebel.alreadyback":`เรียกคืนแล้ว`,
"label.appupload.install.appname":`ชื่อแอปพลิเคชัน`,
"label.selectnewadeckertag":`เลือกป้ายกำกับสำหรับฟิลด์ลำดับชั้นใหม่`,
"label.cliententrancewebsiteadmin":`ผู้ดูแลพอร์ทอลสำหรับลูกค้า`,
"label.checkbox.checked":`ที่ถูกเลือก`,
"UG.Case.03":`การเลื่อนขั้นเคสแบบอัตโนมัติ`,
"vue_label_dashboard_group":`กรุณาเลือกกลุ่มลำดับหนึ่ง`,
"label.import.index.preparedata":`เตรียมข้อมูลที่คุณต้องการนำเข้า`,
"vue_label_member_notice1":`คุณสามารถอัปโหลดไฟล์ JPG GIF หรือ PNG ขนาดไฟล์สูงสุดคือ 2M`,
"message.modify.success":`การแก้ไขสำเร็จ`,
"label.userquotas":`โควตา`,
"label.appointmentpage.wizard.subtitle3-1":`ชื่อ`,
"label.import.index.maxdata2":`2. ก่อนนำเข้าโปรดตรวจสอบให้แน่ใจว่าได้นำเข้าบันทึกที่เกี่ยวข้องทั้งหมดแล้ว เช่น หากมีความสัมพันธ์การค้นหาระหว่างออบเจ็กต์ที่คุณกําลังนําเข้าและผู้ติดต่อ โปรดนำเข้าผู้ติดต่อเหล่านี้ก่อนแล้วจึงนำเข้าข้อมูลของคุณ หากต้องการรับข้อมูล เช่น id บันทึกที่เกี่ยวข้อง เป็นต้น คุณสามารถสร้างรายงาน ตั้งชื่อบันทึกและ id บันทึกเป็นกลุ่มคอลัมน์แล้วส่งออกรายงาน`,
"label.pc.sectionpart":`ส่วน PC`,
"template.chart.wcldqzkh":`ลีดที่ยังไม่ได้จัดการ`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`บันทึกข้อมูลการตั้งราคาแบบแยกส่วนของสมุดราคาปัจจุบันหรือไม่？`,
"label.partnerCloud.financeSetting.payments":`อนุญาตให้ชำระเงินออนไลน์`,
"lable.account.ThisWeek":`สัปดาห์นี้`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(text, num_chars)`,
"label.app.select.bgcolor":`เลือกสีพื้นหลัง`,
"label.planned.work":`งานที่วางแผนไว้`,
"label.passwordPolicy.setup.nolimit":`ไม่จำกัด`,
"label.vlidaterule.s":`หากคุณปิดใช้งานสกุลเงินของผู้ใช้ สกุลเงินของผู้ใช้จะถูกตั้งค่าเป็นสกุลเงินของบริษัท`,
"label.paging.totalofrecords":`รวมทั้งหมด {0} รายการบันทึก`,
"label.customobjects.behaviour":`พฤติกรรม`,
"vue_label_ccchat_notice_deletecommentsuccess":`การลบความคิดเห็นสำเร็จ`,
"label.lock.record.dele":`บันทึกปัจจุบันถูกล็อก ไม่สามารถลบได้!`,
"label.data.expnode.e.desc3":`3. การสร้างแม่แบบ: ผู้ใช้สามารถสร้างฟิลด์และเงื่อนไขที่ต้องการส่งออกเป็นแม่แบบได้ตามความต้องการ ซึ่งจะสะดวกสำหรับการใช้งานครั้งต่อไป`,
"label.button.step3.create.page":`ขั้นตอนที่ 3: สร้างหน้าเพจ`,
"label.sharer":`ผู้แบ่งปัน`,
"label.service.cycle.type":`ประเภทระยะเวลา`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`อัตราข้อผูกมัดที่เก็บเงินได้ทั้งหมด`,
"label.formuladate":`รูปแบบวันที่: YYYY-MM-DD hh: mm: ss หรือ MM / DD / YYYY hh: mm: ss ตัวอย่างเช่น: 2007-12-25 12:25:30 หรือ 12/25/2007 12:25:30 สามารถใช้ today() หรือ now();`,
"front-template-V1-addImg":`เพิ่มรูปภาพ`,
"label.basecontrol":`สิทธิ์พื้นฐาน`,
"label.forecast.settings.lable1":`การรวมข้อมูลพยากรณ์`,
"message.error.file.null":``,
"label.multiply":`* คูณ`,
"message.duplication.label.targetobject":`ออบเจ็กต์เป้าหมาย`,
"label.addattachment":`เพิ่มไฟล์แนบ`,
"vue_label_dashboard_notice_editcertification":`ยืนยันว่าจะแก้ไขส่วนเสริม{name}หรือไม่?`,
"label.notification.tip2":`คุณไม่มีการแจ้งเตือนใหม่ในขณะนี้`,
"lable.quote.syncingfrom.firstsync":`การซิงค์ขั้นแรก: ซิงค์โอกาสทางธุรกิจกับใบเสนอราคา`,
"label.createtasktip":`สร้างภารกิจที่หนึ่งสัมพันธ์กับกฎเวิร์กโฟลว์ กระบวนการอนุมัติ หรือกระบวนการให้สิทธิ์ หนึ่งความสัมพันธ์หรือมากกว่า หากภารกิจมีการเปลี่ยนแปลง การแก้ไขใดๆ จะถูกนำไปใช้กับกฎเกณฑ์ การอนุมัติ หรือกระบวนการให้สิทธิ์ทั้งหมดที่สัมพันธ์กับงานนั้น`,
"label.leave":`ออกจากระบบ`,
"front-invoice-online-payment-setup-china":``,
"label.appointment.wizard.subtitle4-1-2":`30 นาที`,
"label.projectManagement.the.person.not.be.informed":`เมื่อคุณเลือก ไม่ คุณจะไม่สามารถแจ้งผู้รับผิดชอบได้!`,
"label.campagin.roi.name":`ชื่อแคมเปญ`,
"label.import.page1.newcreate":`สร้างใหม่`,
"label.data.downpage.i.title.num2":`2. ก่อนเริ่มการนำเข้า โปรดแน่ใจว่าชื่อฟิลด์ที่คุณต้องการนำเข้าตรงกับชื่อฟิลด์ออบเจ็กต์ในระบบ CloudCC`,
"label.callcenter.call.in":``,
"label.weixin.activity.phone":`กิจกรรม: โทรศัพท์`,
"label.forecast.customforecast.type.role":`ตามบทบาท`,
"label.moscow.standard.time":`เวลามาตรฐานมอสโก`,
"label.profile.setcustomobjectrecordtype":`กําหนดการตั้งค่าชนิดบันทึกออบเจ็กต์เอง`,
"lable.edit.queue.new":`คิวใหม่`,
"label.newAPPexchange":`แอปพลิเคชันใหม่...`,
"message.custom.field.donotdelete.fieldupdate":`ฟิลด์นี้ถูกอ้างอิงโดยการอัปเดตฟิลด์ในเวิร์กโฟลว์หรือกระบวนการอนุมัติอื่นๆ`,
"label.chatter.state":`สถานะ`,
"label.subject_line":``,
"template.report.folder.active":`การวิเคราะห์กิจกรรมและพฤติกรรม`,
"label.icon.114":`บ้าน`,
"label.assignment.setup.newentries.step3":`ขั้นตอนที่ 3: เลือกผู้ใช้ที่จะมอบหมาย`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`ส่วนบุคคล-อินโฟกราฟิกพฤติกรรม`,
"label.weixin.optiontwo":`ตัวเลือกที่สอง`,
"label.sso.saml.idp.config.sp":`ผู้ให้บริการ`,
"System_TimeField_Description":`อนุญาตให้ผู้ใช้ป้อนเวลาท้องถิ่น เช่น "2:40 PM", "14:40" และ "14:40:00" ทั้งหมดเป็นเวลาที่ถูกต้องสำหรับฟิลด์นี้`,
"label.knowledgebase.draft":`ฉบับร่าง`,
"label.chat.topic.no.more.suggestions":`ไม่มีข้อเสนอแนะอื่นๆ`,
"label.quote.product":`ผลิตภัณฑ์`,
"label.cryptographictext":`ข้อความเข้ารหัส`,
"label.custom.unlock":`ปลดล็อค`,
"label.assignment.setup.newentries.step2":`ขั้นตอนที่ 2: เลือกเงื่อนไขของรายการเกณฑ์นี้`,
"label.tabularreport.selectline":`เลือกคอลัมน์ที่จะรวมในรายงาน`,
"label.exchange.sync.state.contact.m2":`บันทึกที่ซิงค์เมื่อ 60 นาทีที่ผ่านมา:`,
"label.codeType":`ประเภทโคด`,
"saturday":`วันเสาร์`,
"label.mask.type":`ประเภทตัวพราง`,
"label.schedulejob.setup.schedule.Monthly":`ทุกเดือน`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`ฟิลด์ในโฟลเดอร์ทั้งหมด {{20}} ฟิลด์ ยังไม่ได้แม็ป {{20}} ฟิลด์`,
"label.projectManagement.delete.item":`การลบโครงการจะลบข้อมูลทั้งหมดที่เกี่ยวข้องกับโครงการและโครงการ และข้อมูลจะไม่สามารถกู้คืนได้ คุณแน่ใจหรือไม่ว่าต้องการลบมัน`,
"label.page.general.us.and.western.europe":`ใช้ภาษาอังกฤษและภาษายุโรป`,
"label.reportsSubscription.status":`อ่านแล้ว`,
"label.discount.baifenbi":`ส่วนลด (%)`,
"font-evaluate-module-v1-web-page-evaluation-settings":``,
"message.error.searchwork":`คำค้นหาต้องไม่น้อยกว่า 2 ตัวอักษร`,
"label.weixin.option.setting":`การตั้งค่าตัวเลือก (ตั้งค่ามากสุด 10 ตัวเลือก)`,
"label.lead.score.prompt1":`สำหรับลีดหนึ่งราย ระบบสามารถให้คะแนนอัตโนมัติเมื่อสร้างและแก้ไข แต่หากเป็นการนำเข้าเป็นจำนวนมาก หรือการสร้างผ่านอินเทอร์เฟซต้องดำเนินการด้วยตนเองผ่านการให้คะแนนแบบกลุ่ม`,
"label.exception.must.try.throw":`ข้อยกเว้นจะต้องถูกโยนลงในบล็อกคำสั่ง!`,
"label.activity.plan":`แผน`,
"label.partnerCloud.productSet.editor":`ตัวเลือกการแก้ไข`,
"label.mobile.quickcreate.default.signinnew":`ลงทะเบียนเข้า`,
"label.summaryreport.2018.step6.new":`ขั้นตอนที่ 6: เลือกประเภทกราฟและสิ่งที่รายงานจะแสดง`,
"vue_label_homepage_owner":`หน้าแรกของ`,
"vue_label_dashboard_editfoldersuccessfully":`การแก้ไขโฟลเดอร์สำเร็จ`,
"label.quickbooks.view.overdueinvoices":`Invoices เกินกำหนดชำระ`,
"label.emailtocloudcc.redmessage4":`กรุณากรอกข้อมูลพอร์ต`,
"label.tabpage.equalz":`เท่ากับ`,
"lable.quote.syncing.firstsync":`การซิงค์ขั้นแรก: ซิงค์ใบเสนอราคากับโอกาสทางธุรกิจ`,
"label.download.CloudCCAPP":`ดาวน์โหลด CloudCC App`,
"label.icon.6":`สกุลเงิน`,
"label.list.serial.number":`หมายเลข`,
"label.profile.setstandardobjectrecordtype":`การตั้งค่าชนิดบันทึกออบเจ็กต์มาตรฐาน`,
"label.customize.memory.function.sorting.error":`ใช้เวลาสืบค้นนานเกินไปทําให้หน้าเพจเกินเวลาที่กำหนด อาจเป็นเพราะคุณเปิดใช้งานฟังก์ชั่นหน่วยความจําการเรียงลําดับส่วนหัวของมุมมอง โปรดไปที่การตั้งค่าส่วนบุคคลและปิดใช้งานฟังก์ชั่นนี้เพื่อลองอีกครั้ง`,
"message.view.addtoallusers":`พนักงานที่เกี่ยวข้องสามารถมองเห็น`,
"label.globaloperation.operationtype.record.phone":`บันทึกการโทร`,
"lable.opppdt.selPdt.searchresult":`ผลการสืบค้น`,
"label.import":`นำ  เข้า`,
"label.service.gantt.work.based.resources":`ทรัพยากรตามชั่วโมง`,
"label_partner_template_detailimage":`ภาพแบบละเอียด`,
"label.cpq.product.feature.option.count":`จำนวนตัวเลือกผลิตภัณฑ์ขั้นต่ำต้องไม่เกินจำนวนตัวเลือกผลิตภัณฑ์สูงสุด`,
"label.chatter.newtask":`ภารกิจใหม่`,
"font-trade-module-v1-invoice-total-price":``,
"setup_mainpage_label_welcome29":`API มาตรฐานเชื่อมต่อกับผลิตภัณฑ์ของบุคคลที่สาม`,
"label.data.exportall.all.btn":`ส่งออกข้อมูลทั้งหมด`,
"front-epwechat-module-v1-unbound-WeChat":`ไม่ผูกวีแชทขององค์กร`,
"label.salescloud.salesdashboard.performance.rankings":`ภาพรวม-การจัดอันดับผลสำเร็จของสัญญาขาย`,
"label.import.page1.newcreateandupdate":`อัปเดตและสร้างใหม่`,
"component.chatter.post.button.file":`เพิ่มไฟล์แนบ`,
"label.partnerCloud.orderingPlatform.createOrder":`สร้างใบสั่งซื้อ`,
"label.lookup.multiple.data":`เรียกคืนข้อมูลหลายรายการ โปรดเลือกด้วยตนเอง`,
"button.partner.save":`บันทึก`,
"label.service.add.timeslot":`เพิ่มช่วงเวลา`,
"label.campaign.matchway.select.email":`อีเมล`,
"front-sales-button-fromQB":``,
"label.icon.108":`ลูกศร`,
"lable.outlook.edit.efmapping":`แก้ไขการแม็ปฟิลด์`,
"label_tabpage_refreshz":`รีเฟรช`,
"chatter.follow.cancel":`เลิกติดตาม`,
"label.totals.sum":`สถิติทั้งหมด`,
"label.noRequest":`ไม่มีคำร้อง`,
"vue_label_homepage_fixedcomponent":`โปรดเลือกส่วนเสริมมาตรฐาน`,
"label.knowledge.delete.case":`เกิดข้อผิดพลาดในการลบบทความเคส`,
"label.weixin..xsld.yjwc":`รายได้ที่คาดหวัง`,
"label.customcomponent.page.index.console.btn":`คอนโซลของนักพัฒนา`,
"label.sendsms.batch":`ส่งข้อความสั้นแบบกลุ่ม`,
"vue_label_chat_onlychosechat":`เลือกสนทนากับผู้ใช้ที่ใช้กลยุทธ์กลุ่มเท่านั้น`,
"label.tabpage.page":`หน้า`,
"label.cyen.note":`เปิดการใช้งานสกุลเงิน โปรดทราบว่าเมื่อเปิดใช้สกุลเงินแล้วจะไม่สามารถผันกลับได้`,
"label.weixin.againsend":`ส่งใหม่อีกครั้ง`,
"label.processnumber":`หมายเลขขั้นตอน`,
"label.emailobject.to":`ผู้รับ:`,
"label.event.today":`อิเวนต์ของวันนี้`,
"label.dashboard.dispalyPosition":`แสดงตำแหน่ง`,
"message.error.recalculate.dupoperate":`อยู่ระหว่างการคำนวณใหม่ โปรดอย่าดำเนินการซ้ำ!`,
"vue_label_email_linkrecordsuccess":`การเชื่อมบันทึกสำเร็จ`,
"label.updateoutboundnews":`อัปเดตข้อมูลขาออก`,
"label_emailtocloudcc_exists2":`อีเมลถูกตั้งค่าเป็น Email to Case กรุณาอย่าตั้งค่าซ้ำ`,
"label.tag.addtags.button2":`ยกเลิก`,
"label.stdashbord.xsld.business.role":`บทบาทนี้นำมาจากบทบาทของผู้ใช้ที่เปิดใช้งานลำดับชั้นการพยากรณ์`,
"label.commonnew":`ใหม่ทั่วไป`,
"label.validate.remark2":`ตัวอย่างการใช้งาน:`,
"label.reportsSubscriptionPage.condition.checkbox":`เพิ่มเงื่อนไขในรายงานนี้`,
"label.globalselect":`ชุดค่ารายการตัวเลือกระดับโกลบอล`,
"label.partnerCloud.partnerAccount.available":`วงเงินที่พร้อมใช้งาน`,
"label_tabpage_nothingz":`ไม่มี`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`แผนภูมิความร้อน`,
"message.error.pleasecorrectdata":`โปรดตรวจสอบข้อความแสดงข้อผิดพลาดด้านล่างทั้งหมดเพื่อแก้ไขข้อมูล`,
"label.hight.tip":`เมื่อปิดใช้งานตัวกรองขั้นสูง ให้เขียน "และ" ขั้นระหว่างเงื่อนไข นั่นคือจะสอดคล้องกับบันทึก 1 และ 2 ที่มีคุณสมบัติเหมือนกัน`,
"label.workflow.estimatecondition3":`ทุกครั้งที่สร้างหรือแก้ไขบันทึก`,
"AssetRelationship.time.limit.error":`วันที่เริ่มต้นควรน้อยกว่าหรือเท่ากับวันครบกําหนด`,
"label.multilang.workflow.dayinmonth":`วันที่ {1} ทุก {0} เดือน`,
"label.reportsSubscriptionPage.schedulereport.daily":`ทุกวัน`,
"label.emailtocloudcc.step1.name":`เลือกฟังก์ชัน`,
"label.follow_up":`อีเมลติดตาม`,
"label.price.list.price.cannot.be.empty":`ราคาปลีกต้องไม่ว่างเปล่า`,
"label.chatter.link":`ลิงก์`,
"label.ccpeak.condition.return.record":`ส่งกลับบันทึกตามเงื่อนไขและสนับสนุนเงื่อนไข where ที่ใช้กันทั่วไป`,
"pagecreator.layout.message.canntdelete":`ไม่อนุญาตให้ลบเค้าโครงปัจจุบัน`,
"label.compact.layout.main":`เค้าโครงข้อมูลสำคัญหลัก`,
"label.testandupdate":`ตรวจสอบและอัปเดต`,
"button_partner_cancel":`ยกเลิก`,
"label.activity":`กิจกรรม`,
"label.knowledge.setting.hint.fourteen":`คุณพร้อมที่จะเขียนแล้ว!`,
"vue_label_commonobjects_view_open_from_list":`เปิดจากรายการเพื่อเริ่มต้นใช้งาน`,
"front-electronic-export-intro":``,
"label.chosen.all":`ฟิลด์ทั้งหมด`,
"label.file.extension":`นามสกุลไฟล์`,
"vue_label_systemSettings_server_miniprogram":`มินิโปรแกรมการบริการ`,
"label.weixin.no.pending.wdgz.qin.today":`วันนี้ไม่มีงาน`,
"label_tabpage_issuez":`ปัญหา`,
"label.staticresource.tip":`ใช้ทรัพยากรแบบคงที่เพื่ออัปโหลดเนื้อหาที่คุณต้องการอ้างอิงในเพจแบบกําหนดเอง รวมไปถึง zip รูปภาพ สไตล์ชีต โปรแกรม JavaScript และไฟล์อื่นๆ`,
"label.approvalstep":`ขั้นตอนการอนุมัติ`,
"label.china.standard.time":`เวลามาตราฐานจีน`,
"label.appexchange.download.tiaoguo":`ข้าม`,
"label.callcenter.link.Amazon.connect":``,
"vue.dashboard.notRequired.notConformToTheRules":`มีรายการที่จําเป็นไม่ได้กรอกข้อมูลหรือไม่สอดคล้องกับกฎ ไม่สามารถส่งได้!`,
"label.appointment.wizard.title1":`โปรดตั้งค่าเวลาว่างของคุณ`,
"label.chat.remove.bookmark":`ยกเลิกบุ๊กมาร์ก`,
"label.tabpage.advancedsearch":`ค้นหาขั้นสูง`,
"batch.ranf.f":`การโอนย้ายแบบกลุ่มล้มเหลว!`,
"label.appointment.wizard.subtitle4-1-4":`1 ชั่วโมง`,
"label.brief.account":`ลูกค้า`,
"component.chatter.link.label.url":`ลิงก์ URL`,
"label_emailtocloudcc_redmessage8":`พารามิเตอร์ไม่ถูกต้อง โปรดติดต่อผู้ดูแลระบบ`,
"label.object.create.two.number.field":`แต่ละออบเจ็กต์สามารถสร้างฟิลด์ตัวเลขอัตโนมัติที่กำหนดเองได้มากสุดสองฟิลด์`,
"label.salecommit.not.roleinformation":`คุณไม่มีข้อมูลบทบาท ไม่สามารถดูคัมบังข้อผูกมัดการขายได้`,
"label.defautline.cannot.less":`จำนวนบรรทัดเริ่มต้นต้องไม่น้อยกว่า 1 บรรทัด`,
"label.selectedproducts":`จำนวนผลิตภัณฑ์ที่เลือก`,
"label.productsales.today.notskadd":`วันนี้ไม่มีภารกิจที่ถึงกำหนด คุณสามารถคลิก " " ที่มุมขวาบนเพื่อเพิ่มภารกิจได้!`,
"lable.account.year.stadate":`วันเริ่มต้นปีงบประมาณ`,
"label.mobile.phone.month.plan2":`แผนของเดือนนี้`,
"label.ccpeakfolder":`คลาสโฟลเดอร์`,
"setup_mainpage_label_welcome21":`แพลตฟอร์มคลาวด์ CloudCC มีฟังก์ชันแม่แบบอีเมลที่ผู้ใช้สามารถกำหนดเองได้ ใช้งานง่าย ช่วยเพิ่มประสิทธิภาพในการทำงาน`,
"label.modify.layout":`แก้ไขเค้าโครง`,
"report.label.folder":`โฟลเดอร์`,
"label.tianyancha.businessverify.rewritename":`เขียนแก้ชื่อลูกค้า`,
"lable.currencyAdv.dao":`ถึง`,
"label.mobilelayout":`เค้าโครงสำหรับอุปกรณ์มือถือ`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`แบบจำลองเปิดใช้งานอยู่ ไม่สามารถแก้ไขได้`,
"label_partner_all_disable":`ปิดการใช้งาน`,
"label.ownerapproverfield":`เจ้าของฟิลด์ผู้อนุมัติ`,
"label.emailobject.template.message4":`มีค่าว่างในฟิลด์ที่แทรกในเนื้อหาของอีเมลปัจจุบัน ขอแนะนำให้แก้ไขและส่งอีกครั้ง!`,
"label.productsales.today.notsk":`วันนี้ไม่มีงานที่ต้องทำ!`,
"label.multilang.document.upload.success":`การอัปโหลดสำเร็จ {0} ไฟล์ และล้มเหลว {1} ไฟล์`,
"label.manageAll.sta3":`การอนุมัติถูกปฏิเสธ`,
"vue_label_calendar_week_view":`ปฏิทิน-มุมมองรายสัปดาห์`,
"setup_layout_label_nocustompage":`ไม่มีเพจที่กำหนดเอง`,
"label.weixin.wdyj.jxdcl":`ส่วนบุคคล-อัตราความสำเร็จของงาน`,
"label.donot.update":`คุณไม่มีสิทธิ์เปลี่ยนแปลง!`,
"setup.mainpage.label.welcome14":`การปรับแต่งเวิร์กโฟลว์ และการจัดการกระบวนการอนุมัติ`,
"UG_Campaign_002":`วางแผน ดำเนินการและติดตามผลของแคมเปญ`,
"label.layout2":`เค้าโครง 2`,
"label.app.looup":`ค้นหาแอปพลิเคชัน`,
"label.projectManagement.selectitem":`โปรดเลือกโครงการ`,
"label.field.relating.rule":`ค้นหากฎความสัมพันธ์ของฟิลด์`,
"vue_label_commonobjects_detail_selectname":`กรุณาเลือกชื่อก่อน`,
"front-email-payment-Invoice-select-pay":``,
"label.customfields.formula.numberexample":`Fahrenheit（องศาฟาเรนไฮต์）= 1.8 * Celsius__c   32`,
"component_event_label_enddate":`*เวลาสิ้นสุด`,
"label.partnerCloud.partnerAccount.lineOfCredit":`วงเงินสินเชื่อ`,
"label.chatter.newpost":`โพสต์ล่าสุด`,
"label.report_dashboard":`รายงานนี้จะถูกบันทึกไว้ในรายงานทั้งหมดของคุณ คุณสามารถเพิ่มรายงานลงในแดชบอร์ดได้`,
"label.assigned":`ผู้ได้รับมอบหมาย`,
"Homepage_News_002":`บริการเสริมข่าวสารไม่สามารถใช้งานได้ขณะนี้`,
"label.approval.select.relatedobj":`คุณต้องเลือกประเภทเพื่อเลือกรายการที่เกี่ยวข้อง`,
"label.service.miniProgram.isTop":`ปักหมุดหรือไม่`,
"message.error.object.datatoolang":`ข้อมูลยาวเกินไป ความยาวสูงสุด คือ {! length} อักขระ`,
"label.importsourcetip":`นำเข้าเพื่อปรับแต่งไฟล์ส่งออกแล้วจึงนำเข้าสู่ระบบอีกครั้ง หากยังไม่ได้ส่งออก กรุณากลับไปที่หน้าส่งออกเพื่อทำการส่งออก`,
"label.select.deadlineplease.deadline":`โปรดเลือกเวลาสิ้นสุด`,
"vue_label_account_equityrelationship":`ความสัมพันธ์ผู้ถือหุ้น`,
"label.account.Calendar.month":`เดือนปฏิทิน`,
"label.appointment.wizard.subtitle3-4":`วันพฤหัสบดี`,
"font-evaluate-module-v1-smaller-500":``,
"label.reportsSubscriptionPage.email.tome":`ส่งให้ฉันเท่านั้น`,
"label.ccchat.person.invite.existpers":`ติดตามแล้ว:`,
"label.appointment.wizard.subtitle1-3":`30 นาที`,
"front-kefu-moudle-connected":``,
"label.campaignmember.main.duplicatelist.tip":`ระบบจะเปิดการใช้งานการลบลีดและสมาชิกแคมเปญที่ซ้ำตามการตั้งค่าที่นี่`,
"label.visualpage.such.tags.double":`รอให้ป้ายกำกับที่มีลักษณะเป็นคู่ปรากฏ`,
"label.sendsms.batch.step2.introduce":`ส่งด้วยแม่แบบข้อความสั้น: โปรดเลือกแม่แบบข้อความสั้นที่คุณต้องการใช้`,
"Account_News_Setting_002":`ใช้การตั้งค่าลูกค้าด้านล่างเพื่อระบุพฤติกรรมของลูกค้าเริ่มต้นสำหรับองค์กร`,
"message.encryptchange.alert":`คุณกำลังจะแปลง {{! fieldapi}} จากฟิลด์ที่เข้ารหัส (การเข้ารหัสการจัดเก็บข้อมูล) "เป็น" ข้อความที่เข้ารหัส (แสดงว่าเข้ารหัส) "หลังจากการแปลงสำเร็จ ฟิลด์นี้จะถูกเก็บไว้ในฐานข้อมูลในรูปแบบข้อความธรรมดา โดยจะสามารถแสดงเป็นข้อความธรรมดาหรือเข้ารหัส และสามารถค้นหาฟิลด์ได้ตามการตั้งค่าโปรไฟล์ \\ r การดำเนินการนี้ไม่สามารถย้อนกลับได้ โปรดยืนยันว่าจะดำเนินการต่อหรือไม่?`,
"label.mainpageset.description":`ปรับเพจหน้าแรกขององค์กรตามสถานการณ์จริง<br>คุณสามารถปิดใช้งานหรือปิดส่วนเสริมที่ไม่เกี่ยวข้องกับธุรกิจขององค์กรได้จากการกำหนดค่าเริ่มต้น <br>เปิดใช้งาน: โมดูลที่เปิดใช้งานจะปรากฏบนหน้าแรกของสมาชิกทั้งหมด <br>ปิดการใช้งาน: โมดูลที่ปิดใช้งานจะไม่แสดงบนหน้าแรกของสมาชิกทั้งหมด และไม่สนับสนุนให้แสดงในรายการ "กำหนดค่าหน้าแรกของฉัน" บนอุปกรณ์มือถือ <br>ปิด: โดยค่าเริ่มต้น โมดูลจะไม่แสดงบนหน้าแรกของสมาชิกทั้งหมดขององค์กร ผู้ใช้สามารถเปิดโมดูลผ่าน "กำหนดค่าหน้าแรกของฉัน" บนอุปกรณ์มือถือ`,
"label_tabpage_linknamez":`ชื่อลิงก์`,
"label.companyname":`Beijing CloudCC.com Technology Co.,ltd.`,
"label.currency.current":`สกุลเงินปัจจุบันของบริษัท`,
"label.campaignmember.main.duplicatelist.html.title":`สแกนรหัสและรีเซ็ตการตั้งค่า`,
"label.sendsms.batch.step3.plan":`แผนวันที่ส่ง`,
"label.profile":`โปรไฟล์`,
"label.canceluploadfile.step":`คลิกปุ่ม "ยกเลิกการอัปโหลด" เพื่อยกเลิกไฟล์ด้านบนทั้งหมด`,
"message.newreport":`รายงานใหม่`,
"label.service.newBuildDialog.date.selection":`การเลือกวันที่`,
"label.lookup":`ค้นหา`,
"label.file.editinfo":`แก้ไขรายละเอียดไฟล์`,
"component_assistant_label_nodata":`ไม่มีรายการสำหรับวันนี้ โปรดตรวจสอบในภายหลัง`,
"label.tianyancha.businessverify.msg4":`ฟังก์ชันนี้ใช้อินเทอร์เฟซการสอบถามข้อมูลที่บริการโดยบุคคลที่สามซึ่งขณะนี้สามารถใช้งานได้โดยไม่เสียค่าใช้จ่าย แต่ CloudCC ไม่รับประกันว่าบุคคลที่สามจะให้บริการแบบไม่เสียค่าใช้จ่ายอย่างต่อเนื่อง หากว่าบุคคลที่สามเรียกเก็บค่าใช้จ่าย CloudCC มีสิทธิ์ในการเรียกเก็บค่าใช้จ่ายจากผู้ใช้หรือให้ผู้ใช้หยุดใช้งานฟังก์ชันนี้ได้`,
"label.noequal":`! = ไม่เท่ากับ`,
"vue_label_metric_column":`ตารางต้องมีคอลัมน์การประเมินอย่างน้อย 1 คอลัมน์`,
"label_reportType_chose_and_form":`เลือกแหล่งข้อมูลรายงานและรูปแบบรายงาน`,
"vue_label_pool_reasondescription":`คำอธิบายเหตุผล{0}`,
"label.isusing":`เปิดการใช้งานใช่หรือไม่`,
"label.passwordPolicy.setup.pwdremember5":`จำ 5 รหัสผ่าน`,
"label.cancel":`ยกเลิก`,
"vue_label_helpcenter_detail1.1":`ในหน้ารายละเอียดของรุ่น Lightning คุณสามารถดูข้อมูลพื้นฐาน กิจกรรมที่เกี่ยวข้อง และการเปลี่ยนแปลงของบันทึกเดียว และขยายหรือยุบข้อมูลที่เกี่ยวข้องได้ที่มุมขวาบนของโมดูล คุณยังสามารถดูและจัดการข้อมูลที่เชื่อมโยงกับบันทึกผ่านรายการที่เกี่ยวข้องได้ <br>1. ดูและจัดการข้อมูลเดี่ยว<br>ด้วยปุ่มที่มุมบนขวา คุณสามารถแก้ไข คัดลอก ลบ หรือแบ่งปันสิทธิ์ข้อมูลกับพนักงานคนอื่นๆ <br>ดูข้อมูลโดยละเอียดของผู้ใช้ และคุณสามารถแก้ไขบางฟิลด์บนเพจได้โดยตรงเพื่อเปลี่ยนเจ้าของหรือชนิดบันทึกข้อมูล <br>ดูและจัดการข้อมูลที่เกี่ยวข้องกับบันทึกผ่านรายการที่เกี่ยวข้อง ในรายการที่เกี่ยวข้องกับไฟล์ อัปโหลดไฟล์ที่บันทึก หรือคลิกชื่อไฟล์เพื่อดาวน์โหลดและดูไฟล์ที่เกี่ยวข้อง <br>2. รายการที่เกี่ยวข้อง<br>เชื่อมต่ออย่างรวดเร็วผ่านรายการที่เกี่ยวข้อง และใช้หน้าต่างลอยเพื่อดูบันทึกที่เกี่ยวข้องสูงสุด 10 รายการ คลิกเพื่อเข้าสู่มุมมองรายการ ดูบันทึกที่เกี่ยวข้องทั้งหมด และแก้ไขแบบอินไลน์ <br>ใช้การ์ดเพื่อดูและจัดการบันทึกที่เกี่ยวข้องด้านล่าง <br>3. กิจกรรม<br> ในหน้ารายละเอียดบันทึก รุ่น Lightning จะไม่แสดงรายการที่เกี่ยวข้องสองรายการของ "กิจกรรมที่ยังไม่ได้ดำเนินการ" หรือ "ประวัติกิจกรรม" แต่จะแสดงไทม์ไลน์ของกิจกรรมแทน <br>ไทม์ไลน์ของกิจกรรมแสดงเนื้อหา<br> ไทม์ไลน์ของกิจกรรมสามารถแสดงกิจกรรมทั้งหมดที่ไม่เคยมีมาก่อนในบันทึกปัจจุบัน ภารกิจที่เกินกำหนดและภารกิจที่กำลังจะเกิดขึ้ จะแสดงในโมดูล "เกินกำหนดและกำลังจะถึง" ของไทม์ไลน์ของกิจกรรม ภารกิจ อิเวนต์ บันทึกการโทร อีเมล และข้อความสั้นที่ผ่านไปแล้วหรือปัจจุบันสิ้นสุดแล้วจะแสดงในเดือนที่เกี่ยวข้อง <br>`,
"registration.page.preview":`ตัวอย่างหน้าลงทะเบียน`,
"label.quickbooks.search":`ค้นหา`,
"label.setup.mobile.bottombutton.tab.show":`แสดง Tab ด้านล่าง`,
"lable.want.to.delete.tem":`ยืนยันว่าจะลบแม่แบบรายงานการบริการ{currentTelmplateName}หรือไม่`,
"label.multilang.fielddtrack.dealkey":`นำ {0} จาก {1} เปลี่ยนเป็น {2}`,
"vue_label_pool_return":`ส่งคืน`,
"vue_label_calendar_failed_to_share_calendar":`การแบ่งปันปฏิทินล้มเหลว`,
"label.less":`< น้อยกว่า`,
"label.email.form.html":`HTML`,
"label.tag.nodata":`ไม่มีข้อมูลป้ายกำกับ`,
"label.setarticlecon":`ระบุเงื่อนไขรายการ`,
"label.searchlayout.displayrow":`คอลัมน์ที่แสดง`,
"label.change.task":`เปลี่ยนเป็นมุมมองภารกิจ`,
"lable.quote.editqtpdt.title":`แก้ไขรายละเอียดใบเสนอราคา`,
"label.appointment.wizard.subtitle4-4":`นัดหมายล่วงหน้าได้นานที่สุด`,
"label.custom.page.button.css":`ปุ่ม CSS`,
"label.input.documentmessage":`ป้อนรายละเอียด`,
"vue_label_commonobjects_detail_email_address":`ที่อยู่ผู้รับ`,
"label.chatter.filterTimeLine":`ตัวกรองไทม์ไลน์`,
"label.must.select.twoorthree.records":`ต้องเลือกสองหรือสามบันทึกเพื่อผสาน`,
"label.mobile.setup":`การตั้งค่าเว็บเพจสำหรับโทรศัพท์มือถือ`,
"vue_label_commonobjects_detail_key_field":`ฟิลด์สำคัญ`,
"label.chatter.relateitem":`รายการที่เกี่ยวข้อง`,
"label.customobjects.tip":`เมื่อคุณสร้างออบเจ็กต์แบบกำหนดเอง คุณสามารถสร้างแท็บเมนูแบบกำหนดเอง รายการที่เกี่ยวข้องแบบกำหนดเอง รายงานและแดชบอร์ดเพื่อให้ผู้ใช้สามารถโต้ตอบกับข้อมูลออบเจ็กต์ที่กำหนดเองได้ คุณยังสามารถเข้าถึงข้อมูลออบเจ็กต์ที่กำหนดเองผ่าน API CloudCC.com`,
"label.sso.saml.idp.config":`การตั้งค่าผู้พิสูจน์และยืนยันตัวตน`,
"label.knowledgebase.affect.article.version":`การเปลี่ยนแปลงนี้จะส่งผลต่อการแปลปัจจุบันของบทความนี้หรือไม่? หากใช่ คุณสามารถติดป้ายคำแปลก่อนหน้าว่า "หมดอายุ" เช่นนี้คุณก็สามารถสร้างรายการบทความที่ต้องปรับปรุงโดยผู้แปลได้`,
"message.error.record":`ไม่พบบันทึกที่เกี่ยวข้อง!`,
"message.duplication.label.fieldname":`ฟิลด์เป้าหมาย`,
"setup.layout.button.cancel":`ยกเลิก`,
"label_radar_map_function":`ใช้กราฟเรดาร์และหลายตัวชี้วัดเพื่อวัดบทบาทของผู้ติดต่อในห่วงโซ่การตัดสินใจขาย`,
"label.campagin.roi.fss":`จำนวนที่ส่ง`,
"label.emailobject.template.giveup":`ยอมแพ้`,
"label.apiname.exists":`มีชื่อ Api นี้แล้ว`,
"message.failtoreaddata":`การอ่านข้อมูลล้มเหลว`,
"label.file.versionedit":`ผู้แก้ไขเนื้อหา`,
"template.report.lost.business.opportunity":`โอกาสทางธุรกิจที่ปิดการขายไม่สำเร็จ`,
"label.ccchat.group.allowgd":`อนุญาตให้จัดเก็บกลุ่มอย่างถาวร`,
"label.fieldaccesslimit":`การเข้าถึงฟิลด์`,
"label_target_model":`แบบจำลองเป้าหมาย`,
"message.validation.isnoturl":`ใส่ URL ที่ถูกต้อง`,
"servicecrew.member.time.conflict":`ในช่วงเวลานี้ ทรัพยากรบริการเป็นสมาชิกของทีมบริการอื่น`,
"label.knowledgebase.delete.details":`รายละเอียดการจัดสรรจะถูกลบ`,
"vue_label_normal_bottom":`ส่วนท้าย`,
"label.custombutton.editerror":`การแก้ไขล้มเหลว`,
"label.dashboardSetup.showdw.d6":`อัตโนมัติ`,
"message.error.field.decimalPlaces":`รูปแบบตำแหน่งทศนิยมไม่ถูกต้อง`,
"label.tabpage.busoppnamez":`ชื่อโอกาสทางธุรกิจ`,
"label.insertfield.intro":`โปรดเลือกฟิลด์และคลิก "แทรก" ตามด้วยป้ายกำกับ ">" ยังมีฟิลด์พร้อมใช้งานเพิ่มเติม`,
"setup.layout.label.nocustompage":`ไม่มีเพจที่กำหนดเอง`,
"front-gantt-module-project-has-only":``,
"label.weixin.fmu.am":`{0} โมงเช้า`,
"label.emailsync.status.connectaccounts":`เชื่อมต่อบัญชีอีเมล`,
"label.customcomponent.check.name.same":`มีชื่อนี้อยู่แล้ว`,
"label.validate.function.funcFormat.HOUR":`HOUR(date)`,
"label.approvepagelayout4":`คัดลอกเค้าโครงก่อนหน้านี้`,
"label.knowledge.category.hint.nine":`เปิดใช้งานกลุ่มหมวดหมู่`,
"label.report.sorting.column":`จัดเรียงแถว`,
"label.hours":`ชั่วโมง`,
"label.email.clearAllemail":`จะล้างข้อความที่ซิงค์ทั้งหมดของอีเมลนี้หรือไม่`,
"font-evaluate-module-v1-satisfaction":``,
"label.service.hide.more.info":`ซ่อนข้อมูลเพิ่มเติม`,
"label.area.list.intro":`คุณสามารถจัดการข้อมูลภูมิภาคได้ที่นี่`,
"label.sendemail.chat.addPostat":`#nameที่เคารพ:\n\n สวัสดี ! #userName กล่าวถึงคุณในเวยเทีย`,
"label.data.newtemplate.e_seltype.desc":`วิธีการส่งออกข้อมูลมีสองวิธี : </li><li class="titledesc1">1. รูปแบบ CSV（ค่าเริ่มต้น）</li><li class="titledesc1">2.รูปแบบการบีบอัด รูปแบบการบีบอัดสำหรับการส่งออกมีสองประเภท：</li><li class="titledesc1">2.1.สร้างรหัสผ่านไฟล์บีบอัดโดยอัตโนมัติ รหัสผ่านที่สร้างโดยอัตโนมัติจะถูกส่งไปที่อีเมลผู้ใช้หลังจากนำออกข้อมูลสำเร็จ</li><li class="titledesc1"> 2.2.ใส่รหัสผ่านไฟล์บีบอัดด้วยตนเอง รหัสผ่านที่ใส่ด้วยตนเองจะไม่สามารถส่งไปที่อีเมลผู้ใช้ได้ ดังนั้นผู้ใช้จำเป็นต้องจำรหัสผ่านที่ใส่เอง หากไม่ใส่ จะไม่มีรหัสเป็นค่าเริ่มต้น`,
"message.passwordPolicy.validate.minlengths":`ข้อผิดพลาด: รหัสผ่านต้องยาวไม่น้อยกว่า`,
"message.save":`ยืนยันว่าต้องการบันทึกหรือไม่?`,
"label.marketsea.notfollowdays1":`หลังจากได้รับ`,
"label.app.step1":`ขั้นตอนที่ 1. เลือกประเภท`,
"message.error.pageid.null":``,
"label.weixin.input.lookupfield":`ป้อนคีย์เวิร์ดเพื่อค้นหาเวยโพลที่ตรงกัน`,
"label.whChatAccount":`บัญชีวีแชท`,
"label.tabpage.groupingitem":`การจัดกลุ่มรายการ`,
"label.callboard.introduce":`ประกาศทั้งหมดจากบริษัทของคุณแสดงอยู่ด้านล่าง`,
"label.financial.services.seminar":`สัมมนาการบริหารการเงิน`,
"label.data.file.i_title.num1":`1. ไฟล์ที่นำเข้าต้องเป็นรูปแบบ CSV และต้องมีหัวข้อ หากไม่มีหัวข้อจะไม่สามารถนำเข้าได้`,
"label.visualpage.filename.exist":`มีชื่อไฟล์นี้แล้ว`,
"front-kefu-moudle-v1-new-chats":`Seat ใหม่`,
"label.console.step5.tab":`เปิดแท็บ`,
"vue_label_opportunity_contactrole_edit":`จัดการบทบาทผู้ติดต่อ`,
"label.projectManagement.delete.return":`ข้อมูลนี้เป็นรายการสุดท้าย หลังจากลบจะกลับไปยังหน้าก่อนหน้า`,
"registration.page.designs":`การตั้งค่า page appearance ของหน้าลงทะเบียน`,
"label.console.step6.heigth":`ความสูง`,
"label.objectRelationshipAtLeast":`มีการบันทึกที่เกี่ยวข้องอย่างน้อย 1 รายการ`,
"label.knowledge.delete.viewstat":`เกิดข้อผิดพลาดในการลบข้อมูลการเรียกดูบทความความรู้`,
"label.direct.dashboard.month.report":`รายงานประจำเดือนใหม่`,
"label_tabpage_lookatmorez":`ดูเพิ่มเติม`,
"label.setup.rights.management":`การจัดการสิทธิ์`,
"label.campaign.channel.clear.img":`ล้างรูปภาพ`,
"label.calendar":`ปฏิทิน`,
"label.biaoqingfaxian.username":`บัญชี`,
"label.weixin.wdyj.jxht":`ส่วนบุคคล-ประสิทธิภาพการขาย-สัญญา`,
"label.emailtocloudcc.exists1":`อีเมลนี้ถูกตั้งค่าเป็น Email to Lead กรุณาอย่าตั้งค่าซ้ำ`,
"label.emailtocloudcc.filed.password":`รหัสผ่านอีเมล`,
"label.what_create":`คุณต้องการสร้างฟอร์มชนิดใด？`,
"vue_label_report_onlydisplaypart":`แสดงข้อมูลมากที่สุด 50 รายการ แสดงข้อมูลทั้งหมดหลังจากรัน`,
"label.up":`ขึ้น`,
"label.addattachment.edit":`แก้ไขไฟล์แนบ`,
"label.ccchat.message.search.desc5":`คำค้นหาต้องไม่น้อยกว่า 2 อักขระ`,
"label.chose.nonotice":`โปรดเลือกบันทึกที่จะไม่แจ้งเตือนอีกต่อไป`,
"UG_activity_06":`ต้องการติดตามลูกค้า`,
"label.set_contactsmarketing":`ตั้งเป็นผู้ติดต่อด้านการตลาด`,
"pagecreator.layout.button.horizontal":`แยกตามแนวนอน`,
"label.brief.opportunity2":`โอกาสทางการขายที่คาดว่าจะปิด`,
"label.ems.nomsg":`ไม่ได้ตั้งค่า`,
"label.fieldupdate.tip":`การอัปเดตฟิลด์อนุญาตให้คุณเปลี่ยนค่าฟิลด์เป็นค่าที่ระบุโดยอัตโนมัติ การอัปเดตฟิลด์เป็นการดำเนินการที่เกี่ยวข้องกับกฎเวิร์กโฟลว์และกระบวนการอนุมัติ`,
"label.sso.saml.sp.federationid":`ID พันธมิตร`,
"label.import.page2.suited":`แม็ปแล้ว`,
"message.error.appexchange.integrity":`โปรดตรวจสอบความสมบูรณ์ของส่วนประกอบในแพ็กเกจการอัปโหลด!`,
"label.fielddatatype":`ประเภทข้อมูลฟิลด์`,
"message.approval.cannotsubmit.detail2":`บันทึกต้องสอดคล้องกับหนึ่งในเงื่อนไขต่อไปนี้หรือประเมินแล้วสูตรเป็นจริง มิฉะนั้นจะไม่สามารถเสนอขออนุมัติได้ กรุณาแก้ไขและเสนอใหม่`,
"vue_label_commonobjects_detail_cloud_as_a_user":`เข้าสู่พาร์ทเนอร์คลาวด์ในฐานะผู้ใช้`,
"label.summaryreport.selectlinetogroup":`เลือกคอลัมน์ที่จะจัดกลุ่มรายงาน`,
"label.tabpage.norecordtypez":`ชนิดบันทึกไม่พร้อมใช้งาน`,
"label.icon.141":`สกุลเงิน`,
"label.addattachment.step3.intruduce":`การดําเนินการนี้จะยกเลิกการอัปโหลดที่กําลังดําเนินการอยู่`,
"label.trigger.recursive.call.three":`ทริกเกอร์สามารถวนซ้ําได้และถูกจํากัดไว้ที่สามรอบ หากเกินสามรอบระบบจะแสดงข้อความแสดงข้อผิดพลาด!`,
"maintenanceplan.workorder.type.asset.workorder":`วิธีการสร้างใบสั่งงาน โปรดเลือก "สร้างใบสั่งงานหนึ่งรายการต่อสินทรัพย์"`,
"label.emailtocloudcc.select1":`กรุณาเลือก`,
"label.system.log":`ล็อกตรวจสอบการตั้งค่าระบบ`,
"vue_homepage_dashboard_not_support_fullscreen":`ขออภัย เบราว์เซอร์ของคุณไม่รองรับการใช้แบบเต็มหน้าจอ`,
"label.projectManagement.nodata.resource":`ยังไม่มีส่วนร่วมในโครงการใดๆ เพิ่มข้อมูลโครงการของ 'ฉัน' ลงในสมาชิกเพื่อดูการมอบหมายเวลาของสมาชิกในทีม`,
"label.exchange.sync.state.contact":`ผู้ติดต่อ`,
"label.field.type":`ประเภทฟิลด์`,
"label.selected.object":`ออบเจ็กต์ที่เลือก`,
"label.customfields.new.step2":`ขั้นตอนที่ 2. ใส่รายละเอียด`,
"label.monitorsys.delete.style":`ประเภทการดำเนินการ`,
"label.projectcondition":`เงื่อนไขโครงการ`,
"potential.customers.field.default":`การตั้งค่าเริ่มต้นของฟิลด์ลีด`,
"message.password.nosame":`รหัสผ่านที่ใส่ทั้งสองครั้งไม่เหมือนกัน กรุณาใส่ใหม่อีกครั้ง!`,
"label.validate.function.funcExplain.MONTH":`ส่งกลับเดือน คือตัวเลขระหว่าง 1 (มกราคม) ถึง 12 (ธันวาคม)`,
"label.project.user.project.count":``,
"chatter.to":`เปลี่ยนเป็น`,
"vue_label_commonobjects_detail_activity_owntask":`มีภารกิจ`,
"label.generate.mobile.page":`การสร้างหน้าเพจอุปกรณ์มือถือเสร็จสมบูรณ์แล้ว`,
"label.escalation.setup.newentries.step1":`ขั้นตอนที่ 1: ตั้งค่าลำดับการประมวลผลรายการเกณฑ์นี้`,
"label.email_footer":`ส่วนท้ายของอีเมล`,
"label_partner_workspace_member_profile":`ตัวเลือกโปรไฟล์`,
"label.loginhis.between":`เวลาเริ่มต้นต้องห่างจากเวลาสิ้นสุดไม่เกิน 2 เดือน`,
"label.user.verficationcode.error":`รหัสยืนยันไม่ถูกต้อง`,
"label.email_notifications":`แจ้งเตือนการส่งอีเมล`,
"APPIntegration_Dropbox_01":`เลือกไฟล์จาก Dropbox`,
"label.projectManagement.Selectweek":`เลือกสัปดาห์`,
"wednesday":`วันพุธ`,
"message.atleastonereceiver":`ต้องมีผู้รับอย่างน้อยหนึ่งคน`,
"label.applt.link.text":`เราได้ผูกบริษัทคุณกับมินิโปรแกรมแล้ว คัดลอกที่อยู่มินิโปรแกรมพอร์ทัลของบริษัทคุณ และวางที่อยู่ใน Jump Link ของพาธมินิโปรแกรมของเมนูบัญชีสาธารณะบริษัท ลูกค้าจะสามารถคลิกเมนูบัญชีสาธารณะเพื่อใช้งานมินิโปรแกรม (เมนูกำหนดเองของบัญชีสาธารณะ <ข้ามไปที่มินิโปรแกรม <พาธของมินิโปรแกรม)`,
"label.wait.for.a.moment":`กำลังตั้งค่า โปรดรอสักครู่...`,
"vue_label_chatter_only_group_members_look":`เฉพาะสมาชิกในกลุ่มเท่านั้นที่มีสิทธิ์ดู คุณสามารถทดลองสมัครเข้าร่วมกลุ่มได้`,
"label.knowledgebase.last.release":`เผยแพร่ล่าสุด`,
"component.setup.label.pagesize":`จำนวนรายการที่แสดงต่อหน้า`,
"label.paging.totalofpages":`ทั้งหมด {0} หน้า`,
"label.globaloperation.successmessage":`ข้อความที่สำเร็จ`,
"label.logout":`ออกจากระบบ`,
"label.partner.common.enable":`เปิดการใช้งานพาร์ทเนอร์คลาวด์`,
"label.permission.objectpermission.goback":`ส่งกลับรายการของออบเจ็กต์ชุดสิทธิ์`,
"label.approvalstep5.required":`จำเป็น`,
"component_chatter_label_to":`ถึง`,
"message.please.choose.role":`กรุณาเลือกบทบาท`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`คุณต้องเลือกรายการบรรทัดสัญญาของสัญญาการบริการที่เชื่อมโยงกับแผนการบํารุงรักษา`,
"label.projectManagement.Resource.usage.view":`มุมมองการใช้ทรัพยากร`,
"label.smsmainbody":`ข้อความ`,
"label.ccchat.error.nullname":`ชื่อไม่สามารถว่างเปล่า`,
"label.appupload.upload.version":`หมายเลขรุ่น`,
"label.data.setok.t_desc2":`กลับไปที่หน้าแม่แบบข้อมูล`,
"vue_label_pool_allocationstatus":`สถานะการแจกจ่าย`,
"label.tianyancha.orgapprovedinstitute":`หน่วยงานที่อนุมัติ`,
"label.quickbooks.searchlist.startdate":`วันที่เริ่มต้น`,
"label.setapp":`ตั้งค่าแอปพลิเคชัน`,
"chatter.about":`เกี่ยวกับฉัน`,
"label.layoutname":`ชื่อเค้าโครงเพจ`,
"label.icon.160":`โลก`,
"label.tabpage.Rolesz":`บทบาทและผู้ใต้บังคับบัญชา`,
"label.console.step5.introduce":`เลือกวิธีการแสดงด้านล่าง`,
"label.customfields.totalsummary.gettogetherfield":`ฟิลด์ที่ต้องการจะรวม`,
"message.appexchange.addtopackage.profile":`อนุญาตให้เพิ่มส่วนโปรไฟล์ได้สูงสุดแพ็กเกจละหนึ่งรายการ!`,
"vue_label_file_user_header_pic":`รูปโปรไฟล์`,
"font-trade-module-v1-invoice-detail-price":``,
"homepage.components.three":`ขั้นตอนที่ 3: กรอกส่วนเสริมที่กำหนดเองเพื่อแสดงเนื้อหา`,
"nine":`เก้า`,
"label.marketsea.button.restore":`กู้คืน`,
"label.forecast.editshrepage.desc2":`การแบ่งปันส่วนบุคคลสามารถใช้เพื่อให้ขยายสิทธิ์การเข้าถึงข้อมูลเท่านั้น ไม่ใช่เพื่อจำกัดการเข้าถึง`,
"label.cloudccsite.list":`เว็บไซต์`,
"label.icon.35":`เมฆ`,
"vue_label_pricebook_price":`เพิ่มราคามาตรฐาน`,
"label.version.sum.addressfield":`ฟิลด์ที่อยู่`,
"label.projectManagement.Gotomilestone":`ไปที่ไมล์สโตน`,
"label.dataimport.name.length":`เกิดข้อผิดพลาด : ความยาวของ name เกินกำหนด`,
"label_alculation_method":`วิธีการคำนวน`,
"label.uploadfile":`อัปโหลดไฟล์`,
"label.ems.otheraccount":`บัญชีอื่นๆ`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`ยืนยันที่จะเข้าร่วมกลยุทธ์กลุ่มโอกาสนี้หรือไม่`,
"message.error.chatter.img.nodata":`ไม่มีไฟล์ภาพ ไม่สามารถจับภาพรูปโปรไฟล์ที่หน้าจอได้!`,
"component.chatter.file.button.files":`เลือกไฟล์`,
"label.salescloud.teamrole.optionlist.choose.null":`ชื่อบทบาทไม่สามารถว่างเปล่า`,
"label.yourexportsuc":`คำขอส่งออกของคุณได้รับการดำเนินการแล้ว โปรดตรวจสอบอีเมลของคุณ`,
"pagecreator_systemstyle_label_modifycolor":`แก้ไขสี`,
"label_partner_setup_title":`การตั้งค่า`,
"label.chat.topic.topic":`หัวข้อ`,
"file.error.nottype":`ข้อผิดพลาด: ประเภทไฟล์ไม่ถูกต้อง ประเภทไฟล์ที่สามารถอัปโหลดได้ คือ txt, doc, excel, ppt, pdf, jpg, jpeg!`,
"label.all_time":`เวลาทั้งหมด`,
"homepage_componet_approval_label":`ศูนย์การอนุมัติ`,
"label.partnerCloud.financeSetting.merchantNumber":`หมายเลขร้านค้าวีแชทเพย์`,
"label.user.resetpw":`รีเซตรหัสผ่าน`,
"label.exchange.sync1":`หลังจากที่ผู้ใช้ตั้งค่าบัญชีบริการที่มีสิทธิ์การเลียนแบบใน Microsoft Exchangeแล้ว ใส่ข้อมูลรับรองบัญชีบริการเพื่ออนุญาตให้ CloudCC สื่อสารกับเซิร์ฟเวอร์บริการของ Exchange`,
"label.import.index.editfield":`แก้ไขแม็ปฟิลด์`,
"and":`และ`,
"label.partnerCloud.cloudInfrastructure":`การตั้งค่าพื้นฐานระบบพาร์ทเนอร์คลาวด์`,
"label.escalation.setup.newentries.createdate":`อ้างอิงตามเวลาสร้างเคส`,
"Pagelayout.Setup.002":`คุณเลือกรายการที่เกี่ยวข้องแล้ว 3 รายการ หากยังเลือกอีกจะส่งผลต่อเค้าโครงเพจ`,
"label.customfields.file.tip":`อนุญาตให้ผู้ใช้อัปโหลด 1-N ไฟล์`,
"label.tianyancha.businessverify.accname":`สืบค้นชื่อลูกค้าแบบเรียลไทม์`,
"label.Additional.Conditions":`กรองนัดหมายการบริการตามเงื่อนไขเพิ่มเติม`,
"label.emailtocloudcc.filed.type":`ประเภท`,
"vue_label_homepage_fixedcomponents":`ส่วนเสริมมาตรฐาน`,
"label.visualpage.delerror":`การลบผิดพลาด กรุณาลองอีกครั้งภายหลัง`,
"label.tabpage.filetypez":`ประเภทไฟล์`,
"label.emailobject.search.input":`กรุณาใส่เนื้อหาที่ต้องการค้นหา`,
"label.createprocessstep2":`ขั้นตอนที่ 2 กำหนดเงื่อนไขรายการ`,
"label.weixin.inhead":`อยู่ระหว่างการประมวลผล`,
"component.recdetail.label.title":`รายละเอียด`,
"label.weixin.telephone":`หมายเลขโทรศัพท์มือถือ`,
"label.web.link":`ลิงก์เว็บ`,
"label.partnerCloud.paySuccess":`ชําระเงินสําเร็จ`,
"label.case.adress.link":`ที่อยู่เว็บพอร์ทัลบริการลูกค้า`,
"label.emailobject.view.connectopp":``,
"front-kefu-moudle-think-again":``,
"label.Button":`ปุ่ม`,
"chatter.pt.most":`ขนาดไฟล์สูงสุดคือ 20M`,
"label.service.newBuildDialog.numberdays.horizontal":`จำนวนวันก่อนวันที่แนวนอน`,
"label.ems.relatedobj":`บันทึกที่เกี่ยวข้อง`,
"label.notification.insert.approval":``,
"label.setting.codeSet":`ชุดโคด`,
"vue_label_report_rowlevelformula":`สูตรระดับแถว`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`© สงวนลิขสิทธิ์ 2008-2022 CloudCC Inc. ทั้งหมดเป็นลิขสิทธิ์ของบริษัท สายด่วนบริการลูกค้า: 400-642-2008`,
"component.setup.button.save":`บันทึก`,
"label.emailsync.button.sure":`ยืนยัน`,
"label.multilang.dupicatecheck.getdatalist":`ข้อมูลที่ซ้ำกันกลุ่มที่ {0} รวมทั้งหมด {1} รายการบันทึก`,
"label.ccchat.person.invite.tochat":`เชิญพนักงานเข้าสู่ CCChat`,
"label_partner_all_maxNum":`ข้อมูลที่ใหญ่ที่สุดของพาร์ทเนอร์คลาวด์:`,
"label.checkfield":`ตั้งค่าการตรวจสอบฟิลด์ซ้ำ`,
"label.sales.dashboard.income":`เป้าหมายรายได้`,
"label.setup":`ตั้งค่า`,
"label.dashboardSetup.center":`กึ่งกลาง`,
"lable.quote.syncing.finished":`การซิงค์เสร็จสิ้น`,
"vue_label_helpcenter_dashboard1":`เพื่อช่วยให้คุณแสดงข้อมูลทางสถิติได้ง่ายขึ้น CloudCC Sales Cloud Lightning Dashboard มอบความสามารถในการสร้างแผนภูมิที่มีประสิทธิภาพให้กับคุณ <br> แดชบอร์ดของ CloudCC Sales Cloud Lightning มีคุณสมบัติดังต่อไปนี้<br>•สามารถใช้หลายแหล่งข้อมูล: คุณสามารถเลือกข้อมูลต้นฉบับในมุมมองเฉพาะภายใต้ออบเจ็กต์เป็นแหล่งข้อมูล หรือเลือกข้อมูลจากรายงานที่ประมวลผลแล้วเป็นแหล่งข้อมูล<br>•มีแม่แบบแผนภูมิให้คุณเลือกมากถึง 13 แบบ: รองรับกรวยการขาย แผนภูมิมาตรวัด แผนภูมิวงกลม แผนภูมิแท่งแบบกลุ่ม  เป็นต้น<br>• ลากและวางเพื่อเปลี่ยนขนาดและตำแหน่งของแผนภูมิได้อย่างอิสระ: แดชบอร์ดสามารถวางตําแหน่งและขนาดของแผนภูมิต่างๆ เพื่อจัดพื้นที่ข้อมูลหลักและข้อมูลรองตามใจคุณ<br>•ตัวกรองแดชบอร์ด: แดชบอร์ดรองรับการกรองข้อมูลแผนภูมิในตัว พร้อมตัวกรองตามช่วงเวลาและผู้ใช้<br> •การแคชข้อมูล: ข้อมูลแผนภูมิแดชบอร์ดสามารถแคชตอนสร้างครั้งแรกซึ่งจะช่วยลดเวลาในการโหลดสำรอง <br>•การเจาะส่วนเสริม: สามารถคลิกที่ส่วนเสริมเพื่อข้ามไปยังรายละเอียดรายงานที่เกี่ยวข้อง หรือรายการบันทึกในมุมมองที่เกี่ยวข้องกับออบเจ็กต์<br>•การเชื่อมโยงส่วนเสริม: ในแดชบอร์ดเดียวกันสามารถตั้งค่าเชื่อมโยงกับส่วนเสริมอื่นๆ ที่มีแหล่งข้อมูลเดียวกัน เมื่อคลิกพื้นที่ข้อมูลในส่วนเสริม คุณสามารถตั้งค่าส่วนเสริมอื่นเพื่อจัดสถิติข้อมูลใหม่ตามเงื่อนไขตัวกรองข้อมูล<br>1. สร้างแดชบอร์ดใหม่ <br> ในฐานะพนักงานขายหรือผู้จัดการฝ่ายขาย คุณสามารถสร้างแดชบอร์ดเพื่อแสดงข้อมูลการขายของคุณ CloudCC Sales Cloud Lightning มีความสามารถมากมายในการสร้างแดชบอร์ด<br> หมายเหตุ: ข้อมูลแดชบอร์ดรุ่น Lightning และแดชบอร์ดรุ่นเก่าทำงานร่วมกันไม่ได้ <br> คลิกแท็บ "แดชบอร์ด" คลิก "แดชบอร์ดใหม่" กรอกชื่อแดชบอร์ดและเลือกโฟลเดอร์ที่คุณต้องการบันทึก และเข้าสู่แดชบอร์ดใหม่ <br>`,
"label.layout.availabletab.trackrecord":`บันทึกการติดตาม`,
"label.campaignmember.main.deletecontact":`ลบสมาชิก-ผู้ติดต่อปัจจุบัน`,
"lable.outlook.mcto.emaltoc":`เมื่ออีเมลถูกส่งไปที่ CloudCC.com`,
"label.setup.mobile.offlinecache.savesuccess":`บันทึกการตั้งค่าแคชออฟไลน์สำหรับอุปกรณ์มือถือสำเร็จ`,
"label.timezone.default":`ค่าเริ่มต้นโซนเวลา`,
"label.noRules.have.been.enabled":`ยังไม่มีกฎที่เปิดใช้งาน`,
"label.ccchat.person.invite.existsend":`ที่อยู่อีเมลบางส่วนที่คุณป้อนตรงกับผู้ใช้ที่มีอยู่`,
"label.work":`ทำงาน`,
"actualstarttime.actualendtime.time.illegal":`เวลาเริ่มต้นจริงของการนัดหมายบริการควรน้อยกว่าหรือเท่ากับเวลาสิ้นสุดจริง`,
"lable.product.stsp":`กำหนดราคามาตรฐาน`,
"vue_label_normal_account_sf":`ลูกค้า`,
"label.finishpic":`สร้างกราฟแล้ว`,
"label.h5.similar.opportunity.step3":`ขั้นตอนที่ 3: เลือกฟิลด์ที่จะแสดงโอกาสทางธุรกิจที่คล้ายกัน`,
"label.relateobjDefault":`ค่าเริ่มต้นความสัมพันธ์ออบเจ็กต์`,
"label.customcomponent.check.tag.endwith":`ส่วนเสริมจะต้องลงท้ายด้วยป้ายกำกับ</cc:component>`,
"label.related.organization":`โอกาสที่เกี่ยวข้อง`,
"label.recordtype.edit.selectvalue.orderby":`เรียงลำดับค่ารายการตัวเลือก`,
"vue_label_homepage_enter_name":`กรุณาใส่ชื่อ`,
"label.permission.group":`กลุ่มสิทธิ์`,
"label.emailobject.send":`ส่ง`,
"label.ralateuser":`ผู้ใช้ที่เกี่ยวข้อง`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(date,num)`,
"label.tablayoutedit.remark2":`เลือกฟิลด์ที่ต้องการให้แสดงในหน้าเพจเมนู`,
"setup_mainpage_label_welcome3":`การสร้างฟอร์มใน CloudCC Cloud บนแพลตฟอร์ม CloudCC จะอาศัยฐานข้อมูลที่กําหนดเอง (ออบเจ็กต์) ซึ่งผู้ใช้กําหนดเป็นตารางฐานข้อมูลที่จัดเก็บข้อมูลเฉพาะองค์กรของคุณ ความสัมพันธ์ระหว่างตารางและตารางยังสามารถสร้างขึ้นได้อย่างง่ายดายโดยไม่ต้องพัฒนาโปรแกรมใดๆ`,
"label.user.notallowed.login.scope":`คุณไม่ได้อยู่ในช่วงเวลาการเข้าสู่ระบบที่อนุญาต หรือ IP เข้าสู่ระบบของคุณถูกจำกัด`,
"label.tel.ten.case":`คุณสามารถป้อนหมายเลขโทรศัพท์มือถือได้สูงสุด 10 หมายเลขเพื่อใช้ส่งการแจ้งเตือนระหว่างหมายเลข`,
"front-kefu-moudle-v1-user-info":`ข้อมูลผู้ใช้`,
"label.aboutme":`เกี่ยวกับฉัน`,
"label.setfieldediting.tip":`เมื่อกำหนดขั้นตอนการอนุมัติ สามารถกำหนดคำขออนุมัติให้กับผู้ใช้อื่นได้  ตัวเลือกหนึ่งคือการใช้ฟิลด์ผู้ใช้เพื่อส่งคำขอเหล่านี้โดยอัตโนมัติ หากคุณต้องการใช้ตัวเลือกนี้สำหรับขั้นตอนการอนุมัติใดๆ กรุณาเลือกฟิลด์ที่อยู่ในรายการตัวเลือกด้านล่างนี้ นอกจากนี้เมื่อบันทึกอยู่ระหว่างการอนุมัติจะถูกล็อก--มีเพียงผู้ดูแลระบบเท่านั้นที่จะแก้ไขได้ แต่คุณสามารถเลือกที่จะอนุญาตให้ผู้อนุมัติที่มอบหมายไว้ในปัจจุบันมาแก้ไขบันทึกได้`,
"label.existing_dashboard":`เพิ่มลงในแดชบอร์ดที่มีอยู่`,
"label.sendemail.spotsign":`#nameที่เคารพ: โปรดทราบ ลูกค้าที่คุณเชิญมากิจกรรม#activityactivity #  #customerได้ลงทะเบียนเข้างานเรียบร้อยแล้ว`,
"UG_solution_01":`เสนอโซลูชัน`,
"label.tianyancha.estiblishtime":`เวลาก่อตั้ง`,
"label.pc.lightningpage":`แอปขนาดจิ๋ว (Beta)`,
"label.saveAndSync":`บันทึกและซิงค์`,
"label.state.end":`สิ้นสุดแล้ว`,
"label.sendemail.queue.assigninfo":`คิว : [#queueName] กำหนด #objectName：#recordName`,
"label.approvalprocessname":`ชื่อกระบวนการอนุมัติ`,
"label.view.conditions.message":`กรองตาม{!conditions}`,
"label.partnerCloud.financeSetting.alipayCorporate":`บัญชีธุรกิจอาลีเพย์`,
"label.forecast.detailforecast.de":`ของ`,
"label.savepayset.failure.nopay":`โปรดกําหนดค่าบัญชีชําระเงินออนไลน์อย่างน้อยหนึ่งบัญชีก่อน`,
"label.step1.total6":`ขั้นตอนที่ 1 จาก 6`,
"label.appointment.wizard.subtitle4-1-3":`45 นาที`,
"label.emailobject.markasread":``,
"message.error.orgid.null":`orgid ต้องไม่ว่างเปล่า!`,
"label.emailtemplate.mergefield":`ผสานค่าฟิลด์`,
"label.weixin.recent.list":`รายการที่ดูล่าสุด`,
"label.emailsync.form.email":`อีเมล`,
"label.funnel":`กรวย`,
"label.logintime.clear":`ล้างเวลา`,
"label.chatter.followed":`กำลังติดตาม`,
"label.ccpeak.function.field.spack":`ฟิลด์ในฟังก์ชันทั้งสองด้านจะต้องมีช่องว่าง`,
"label.setup.mobile.offlinecache.remark":`หลังจากเปิดการใช้งานฟังก์ชั่นนี้ สมาชิกในองค์กรจะสามารถสร้าง  ตรวจสอบ แก้ไข หรือลบบันทึกเมื่อไม่มีเครือข่ายอินเทอร์เน็ตบนอุปกรณ์มือถือได้`,
"label.product.function":`คุณสมบัติของสินค้า`,
"label.icon.14":`ค้อน`,
"message.report.nodata":`รายงานไม่ได้ส่งข้อมูลกลับคืน`,
"label.please.ChooseMin":`โปรดเลือกตัวเลือกผลิตภัณฑ์อย่างน้อย {0} รายการ`,
"label.tabpage.releaseTourz":`เผยแพร่ทัวร์`,
"vue_label_chat_opportunity":`กลยุทธ์กลุ่มโอกาส`,
"vue_label_chatter_refucecertification":`ยืนยันว่าจะปฏิเสธ '{name}' ให้เป็นสมาชิกของกลุ่มหรือไม่`,
"label.version.unlimited":`อันลิมิเต็ด`,
"label.processsetting.enable.prompt":`เมื่อเปิดใช้งาน พาธที่ตั้งค่าไว้จะอยู่ในหน้ารายละเอียดที่สอดคล้องกับรุ่น lightning นอกจากนี้คุณยังสามารถบันทึกการตั้งค่าก่อนแล้วค่อยเปิดใช้งานในภายหลังได้`,
"label.page.display.property":`แสดงคุณสมบัติ`,
"label.service.appointmentList.thisOption":`ไม่เลือก`,
"label.register.date":`วันที่ลงทะเบียน`,
"label.brief.contract.amount":`จำนวนเงินในสัญญา`,
"setup.object.field.dependency.label.actionfieldnotnull":`โปรดเลือกฟิลด์ควบคุมสำหรับการตั้งค่าก่อน`,
"UG_homepage_009":`เข้า CRM`,
"label.icon.98":`โฟลเดอร์`,
"label.weixin.datacount":`ข้อมูลทั้งหมด`,
"label.mobile.hasbind":``,
"label.emailtemplate.choosemorecontacts":`โปรดเลือกคนที่คุณต้องการส่งให้มากกว่านี้`,
"setup_layout_button_deleteitem":`ลบรายการที่เลือก`,
"vue_label_account_collection_plan":`แผนเก็บเงินที่ยังไม่ได้ดำเนินการ`,
"label_chatter_maturiyDate":`วันครบกำหนดไถ่ถอน`,
"label.emailtocloudcc.license":`การอนุญาตใช้สิทธิ์`,
"vue_label_checkduplicate_complete_check_rules":`โปรดใส่เกณฑ์การตรวจสอบซ้ำให้ครบถ้วน`,
"chatter.up.type":`คุณสามารถอัปโหลดไฟล์ JPG, GIF หรือ PNG`,
"label.attendance.nocheckout":`ยังไม่ได้บันทึกเวลาออกงาน`,
"label.setup.mobile.offlinecache.remark2":`เมนูที่เลือกจะถูกใช้เป็นเมนูแคชแบบออฟไลน์เริ่มต้นบนอุปกรณ์มือถือของทั้งองค์กร และผู้ใช้แต่ละรายสามารถตั้งค่าบนอุปกรณ์มือถือเพื่อปิดการแคชแบบออฟไลน์ของเมนูที่ตั้งค่าไว้บนอุปกรณ์มือถือ หรือสลับเพื่อเปิดใช้งานเมนูอื่นๆ ที่ต้องการ`,
"template.report.count.marketing.activities":`แคมเปญทั้งหมด`,
"label.multilingual.tip4":`การปิดใช้งานหลายภาษาจะทําให้ภาษาเริ่มต้นของบริษัทเป็นภาษาจีนหรือภาษาอังกฤษตามที่อยู่ของบริษัท และตั้งค่าภาษาของผู้ใช้ทั้งหมดเป็นภาษาเริ่มต้นของบริษัท`,
"label.settings_area":``,
"label_assessment_content":`เนื้อหาการประเมิน`,
"label.top":`ด้านบน`,
"UG.Account.06":`สร้างลูกค้า`,
"label.emailtocloudcc.step1.case2":`หลังจากกำหนดค่า อีเมลที่จะได้รับจะสามารถสร้างเคสได้โดยอัตโนมัติ และจะจับคู่ผู้ติดต่อและลูกค้าในกล่องขาออก ทั้งจะแขวนเคสไว้กับลูกค้าและผู้ติดต่อที่เกี่ยวข้องเพื่ออํานวยความสะดวกในการตอบรับและการติดตามบริการ Case`,
"label.forecast.forehistory.best.remark":`หมายเหตุประสิทธิภาพยอดเยี่ยม`,
"label.project.problem.date":`วันที่ของปัญหาต้องอยู่ในช่วงวันที่ของไมล์สโตนหรือโครงการ`,
"label.forecast.customforecast.foredis.wzs":`จำนวนสมบูรณ์`,
"message.setup.field.name.value.notexists":`ไม่มีค่ารายการบทบาทกลุ่มที่ป้อน โปรดป้อนอีกครั้ง!`,
"label.salescloud.teamrole.opportunity.organization":`สมาชิกในทีมมีสิทธิ์ในการเข้าถึงโอกาสทางธุรกิจนี้ อาจจะมากกว่าค่าเริ่มต้นการเข้าถึงโอกาสทางธุรกิจขององค์กรคุณ`,
"label.sms.message.input":`กรุณาใส่เนื้อหาข้อความสั้น`,
"label.document.type.not.allow":`ไม่รองรับประเภทเอกสารนี้`,
"label.customfields.totalsummary.tip":`ฟิลด์แบบอ่านอย่างเดียวที่แสดงค่าสรุป ค่าต่ำสุดหรือสูงสุดของฟิลด์ในรายการที่เกี่ยวข้อง หรือจำนวนบันทึกทั้งหมดที่อยู่ในรายการที่เกี่ยวข้อง`,
"label.tabpage.filesizez":`ขนาดไฟล์`,
"label.import.page2.filedname":`ชื่อไฟล์`,
"label.same.analyze":`การวิเคราะห์การเสนอลูกค้าทับซ้อนของฉัน`,
"label.service.gantt.refreshData":`อัปเดตข้อมูลหลังจากรีเฟรชหน้า`,
"label.sendsms.batch.step2.sendbycontext":`ส่งตามเนื้อหาข้อความสั้นที่กำหนดเอง`,
"UG_Account_05":`แผนผังผู้ติดต่อ`,
"label_emailtocloudcc_step1total3":`ขั้้นตอนที่ 1 จาก 3`,
"label.weixin.no.history":`ไม่มีประวัติ`,
"label.datamanage.queryfield.error":`ฟิลด์แบบสอบถามเกิดข้อผิดพลาด`,
"label.emailmerge.mergeFolder.emailmerge":`ผสานแม่แบบอีเมล`,
"label.workflow.estimatecondition":`เงื่อนไขการประเมิน`,
"label.autonumberfield.wrong":`กรุณาใส่ตัวเลขระหว่าง 0-{0}`,
"label.data.setok.t.desc1":`ถ้าต้องการใช้แม่แบบนี้ในการส่งออกข้อมูล โปรดคลิก`,
"label.data.downpage.i.title":`ขั้นตอนการนำเข้าข้อมูล:`,
"label.data.downpage.i_list.desc2":`หลังจากนำเข้าข้อมูลแล้ว คุณจะได้รับอีเมลเพื่อแจ้งคุณว่าการนำเข้าสำเร็จหรือไม่`,
"label.opportunity.jieduan":`สเตจปัจจุบัน`,
"vue_label_commonobjects_view_sumby":`วิธีการสรุป`,
"label.knowledge.setting.hint.three":`เราจะช่วยคุณเตรียมและดำเนินการ นี่คือการตั้งค่าที่คุณต้องทำให้เสร็จ:`,
"page.activity.history":`ประวัติกิจกรรม`,
"label.cancelQuoteLineGroup":`ยกเลิกกลุ่มบรรทัดใบเสนอราคา`,
"label.addattachment.batch.step3":`ขั้นตอนที่ 3. คลิกปุ่ม“เสร็จสิ้น”เพื่อกลับไปยังหน้าก่อนหน้า`,
"label.chat.topic.follow":`ติดตาม`,
"label.import.page1.uploadcsvfiled":`ลากและวางหรือคลิกเพื่ออัปโหลดไฟล์ CSV`,
"label.batchtransfer.datetype.tip":`สำหรับฟิลด์วันที่ให้ป้อนค่าในรูปแบบต่อไปนี้:`,
"vue_label_systemSettings_application_util":`ตัวจัดการแอปพลิเคชัน`,
"label.partner.workspace.member.selectedpermission":`ชุดสิทธิ์ที่เลือก`,
"label.service.appointmentList.plansToEnd":`สิ้นสุดแผน`,
"label.industrialandcommercialverification.contactinformation":`ต้องการสั่งซื้อหรือสอบถามข้อมูล กรุณาติดต่อ 400-642-2008`,
"chatter.del.p":`ลบโพสต์นี้`,
"label.forecast.customforecast.replacefirst":`ฉันก่อน`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`ชื่อเกณฑ์การให้คะแนน`,
"label.weixin.appr.applicant":`ผู้ริเริ่ม`,
"component_event_label_calendar":`ดูปฏิทิน`,
"step":`ขั้นตอน`,
"label.attendance.setting.position.alert":`ต้องตั้งค่าที่หมายสำหรับการทำงานภายในบริษัท`,
"label.end":`สิ้นสุดแล้ว`,
"label.mobile.change.owner.success":`เปลี่ยนเป็นเจ้าของใหม่แล้ว`,
"label.chinese":`ภาษาจีน`,
"label.textmessage.vonage.account":`ข้อมูลเกี่ยวกับบัญชี`,
"front-console-no-related-contact":``,
"label.dashboardSetup.seltype":`ตัวเลือกประเภทส่วนเสริม`,
"chatter.follow.user":`ติดตามผูใช้นี้`,
"label.textmessage.sentsuccess":`การส่งสำเร็จ`,
"label.australian.gentral.standard.time":`เวลาออมแสงกลาง (เซาท์ออสเตรเลีย)`,
"label.validate.function.funcFormat.AND":`AND(logical1,logical2,...)`,
"lable.SalesCommitmentKanBan.contract":`สัญญา`,
"label.processsetting.basic.settings":`การตั้งค่าพื้นฐาน`,
"label.escalation.setup.newentries.ifcondtions":`หากสอดคล้องกับเงื่อนไขด้านล่างให้เรียกใช้เกณฑ์นี้`,
"label.lookup.nofound.data":`ไม่มีค่านี้ หรือเงื่อนไขการกรองไม่ตรงกัน`,
"vue_label_commonobjects_view_chart_chartname":`ชื่อแผนภูมิ`,
"label.dashboard.show.percent":`แสดง %`,
"label.sso.saml.sp.userid":`ID ผู้ใช้`,
"label_tabpage_minutesagoz":`นาทีที่แล้ว`,
"vue_label_chatter_comment_content":`กรุณากรอกความคิดเห็น`,
"label.campaign.channel.step6.mobilepc":`สร้างหน้าเพจสำหรับอุปกรณ์มือถือและคอมพิวเตอร์`,
"vue_label_homepage_editprofilepage":`แก้ไขชื่อ`,
"label.tabpage.crecordtypez":`เปลี่ยนชนิดบันทึก`,
"label.social.posts.type.null":`ประเภทโพสต์ต้องไม่ว่างเปล่า`,
"label.projectManagement.groupbyuser":`จัดกลุ่มตามผู้ใช้`,
"vue_label_email_new_template":`บันทึกเป็นแม่แบบใหม่`,
"label.ems.close":`ยกเลิก`,
"label.ccdocument.noauthority.folder":`คุณไม่มีสิทธิ์ในการจัดการโฟลเดอร์นี้!`,
"message.filterconditionerror":`<strong>ข้อผิดพลาด: </strong> ตัวกรองของคุณอ้างอิงเงื่อนไขการกรองที่ไม่ถูกต้อง:`,
"label.User.Interface":`อินเทอร์เฟซผู้ใช้`,
"label_tabpage_greaterz":`มากกว่า`,
"vue_label_CCChat_unfollow":`เลิกติดตาม`,
"label.selectandcontinue":`เลือกและทำต่อ`,
"vue_label_commonobjects_detail_influence":`อิทธิพล`,
"label.total.have.priority":`ลำดับความสำคัญของ`,
"label.manageAll.sta4":`เรียกคืน`,
"label.setup.mobile.offlinecache.setup":`การตั้งค่าแคชออฟไลน์สำหรับอุปกรณ์มือถือ`,
"vue_label_chatter_cancel_adding":`ยกเลิกการเพิ่ม`,
"vue_label_lead_select_existing":`เลือกที่มีอยู่`,
"front-epwechat-module-v1-contacts-sync":`การซิงค์ผู้ติดต่อวีแชทขององค์กร`,
"label.appupload.component.type.recordtype":`ชนิดบันทึก`,
"label.layout.hint":`ยังไม่รองรับการดูผลในหน้าปัจจุบัน โปรดไปที่หน้าเพจเพื่อดูหลังจากบันทึก`,
"label.change":`เปลี่ยน`,
"setup_layout_label_detailpage":`หน้ารายละเอียด`,
"label.imgfield.use.tip":`img(docid,width,height),ฟังก์ชันนี้ใช้เพื่อส่งออกรูปภาพ docid คือ id เอกสาร width กำหนดความกว้างของรูปภาพ (ประเภทInteger สามารถเว้นว่างได้) height กำหนดความสูงของรูปภาพ (ประเภท Integer สามารถเว้นว่างได้)`,
"pagecreator.systemstyle.button.edit":`แก้ไขรูปแบบ`,
"label.delete_externalpage":`'ที่คุณกําลังจะลบไม่สามารถเรียกคืนได้ ดังนั้นโปรดแน่ใจว่า ฟอร์มนี้ไม่ได้ใช้สำหรับหน้าเข้าสู่ระบบใดๆ แต่สามารถใช้ที่อื่นได้ เช่น คุณอาจจะใช้ Embed code เพื่อแทรกลงในหน้าภายนอก`,
"font-evaluate-module-v1-open-case":``,
"label_not_adjust":`ไม่มีการปรับ`,
"vue_label_title_ordernow":`สั่งซื้อทันที`,
"label.notification.serviceappointment.allocation":``,
"label.objectRelationshipDescription2":`รายงาน โดยการเลือกออบเจ็กต์ที่มีความสัมพันธ์กับรายงาน คุณสามารถกําหนดออบเจ็กต์อื่นว่าจะส่งกลับบันทึกใดไปยังผลลัพธ์ของรายงาน`,
"vue_label_calendar_notice_createfail":`การสร้างปฏิทินล้มเหลว`,
"label.ems.step1":`ขั้นตอนที่ 1`,
"label.ems.password":`รหัสผ่าน`,
"label.icon.143":`กระปุกออมสิน`,
"label.select.year":`เลือกปี`,
"label.termsforusage.dialog":`ข้อกำหนดการใช้งาน (หน้าต่างใหม่)`,
"label.tag.addtags.create":`เพิ่มใหม่`,
"label.emailobject.groupemail.msg4":`ไม่มีที่อยู่อีเมลจึงส่งอีเมลนี้ไปยังผู้รับรายนี้ไม่ได้`,
"label.version.sum.autonumberfield":`ฟิลด์ตัวเลขอัตโนมัติ`,
"label.projectManagement.unallocated.time":`เวลาที่ยังไม่ได้จัดสรร`,
"PageLayout.Search.MultiSearch.002":`ฟิลด์การค้นหาถูกกระจายเพื่อแสดง (การค้นหาฟิลด์เดียว)`,
"label.icon.150":`VR`,
"label.SMS.edit":`แก้ไขการแจ้งเตือนข้อความสั้น`,
"Opportunity.Detailed.Phase.Label.003":`เปลี่ยนสเตจ`,
"vue_label_helpcenter_all":`1. ค้นหาระดับโกลบอล<br> เครื่องมือที่ช่วยให้คุณค้นหาสิ่งที่คุณต้องการได้อย่างรวดเร็ว <br>ป้อนคีย์เวิร์ดในช่องค้นหาในแถบนำทางที่ด้านบนของหน้า ระบบจะแนะนำเนื้อหาที่เกี่ยวข้องในคุณแบบเรียลไทม์ <br>คลิก "ค้นหา" หรือกด Enter ที่แป้นพิมพ์เพื่อเปิดหน้าผลการค้นหา <br>ในหน้าผลการค้นหา คุณสามารถใช้ตัวกรองทางด้านซ้ายเพื่อดูรายการผลการค้นหาภายใต้ออบเจ็กต์นั้น โดยจะแสดงบันทึกที่แนะนำได้ถึง 10 รายการ คุณสามารถคลิก "ดูเพิ่มเติม" เพื่อดูผลการค้นหาเพิ่มเติมในหน้ารายการ <br>หมายเหตุ: 10 ออบเจ็กต์เริ่มต้นในการค้นหา คือ  "ใบเสนอราคา" "ลูกค้า"  "ลีด" "โอกาสทางธุรกิจ" "แคมเปญ" "สัญญา" "ผลิตภัณฑ์" "คำขอบริการ" "ภารกิจ" และ "อิเวนต์" <br>2. สร้างด่วน <br> คลิก " " ในแถบนำทาง และคุณสามารถเลือกวัตถุที่คุณต้องการสร้างในหน้าต่างแบบดึงลง <br>3. ศูนย์ส่วนบุคคล<br> คลิกที่รูปโปรไฟล์ที่ด้านขวาของแถบนำทางเพื่อเปิดหน้าต่างศูนย์ส่วนบุคคล  มีฟังก์ชั่นให้คุณดังต่อไปนี้:: <br>เข้าสู่หน้าการตั้งค่าส่วนบุคคลอย่างรวดเร็ว การนำเข้าแบบกลุ่ม และเข้าสู่ถังขยะรีไซเคิล <br>หากคุณอยู่ระหว่างทดลองใช้งาน ให้คลิก "สั่งซื้อทันที" เพื่อเข้าสู่หน้าสั่งซื้อ cloudcc อย่างรวดเร็ว <br >คลิกที่รุ่นจะสามารถเปลี่ยนได้อย่างรวดเร็ว <br>ออกจากระบบ <br>4. เมนู<br> ในแถบเมนูมีเมนูแนะนำสำหรับคุณ คุณสามารถคลิกที่เมนูเพื่อเข้าสู่หน้าได้อย่างรวดเร็ว คุณยังสามารถดูเมนูทั้งหมดและตั้งค่าเมนูที่ใช้บ่อยให้แสดงในแถบเมนูได้อีกด้วย <br>เมนูทั้งหมด: คลิก "เพิ่มเติม" และคลิก "เมนูทั้งหมด" ที่ด้านล่างของช่องแบบดึงลง <br>ปรับแต่งเมนูของฉัน:  คลิกปุ่มทางด้านขวาของเมนู เปิดหน้าต่างเมนูที่กำหนดเอง และตั้งค่าเมนูทั่วไปที่คุณต้องแสดงในแถบเมนูในเมนูทั้งหมด <br>5. ศูนย์เปิดตัวโปรแกรม<br> คลิกไอคอนทางด้านขวาของแถบเมนู สามารถเปลี่ยนเป็นผู้ดูแลระบบเพื่อที่คุณสามารถตั้งค่าบริการโปรแกรมอื่นๆได้อย่างรวดเร็ว<br>หมายเหตุ: แอปพลิเคชันชุดโมดูลการทำงาน (เช่น การจัดการลีด โอกาสทางธุรกิจ การจัดการสัญญา เป็นต้น) สามารถใช้เพื่อตอบสนองความต้องการทางธุรกิจที่เฉพาะเจาะจง`,
"label.summaryreport.2018.step5.new":`ขั้นตอนที่ 5: เลือกมาตรฐานรายงาน`,
"label.weixin.id":`ID`,
"chatter.pu.mess":`โพสต์และความคิดเห็น`,
"label.weixin.lookup.record":`ค้นหาบันทึก`,
"label.ServiceCloud.statistics.by.address":`สถิติตามที่อยู่`,
"label.jixiaoswitchoff":``,
"label.savealipay.failure":`บันทึกข้อมูลร้านค้าอาลีเพย์ล้มเหลว`,
"template.chart.khdqfb":`การกระจายพื้นที่ของลูกค้า`,
"front-email-payment-immediate-payment":``,
"label.dashboard.unit5":`หน่วย: ร้อยล้าน`,
"label.tabpage.greaterz":`มากกว่า`,
"vue_label_calendar_stop_sharing_calendar":`หยุดการแบ่งปันปฏิทิน`,
"label.projectManagement.allhours":`ทั้งหมด (ชั่วโมง)`,
"label.currency":`สกุลเงิน`,
"label_vue_create_edit_obj_create_event_dialog_title":`การแจ้งเตือนซ้ำสำหรับสิ่งที่ต้องทำ`,
"front-template-V1-templateSetting":`การตั้งค่าแม่แบบ`,
"label.dashboard.away.condition":``,
"label.replacelayout":`แทนที่เค้าโครงเพจ`,
"label.permission.detail.system.setting.tip":`การดำเนินการที่ใช้กับแอปพลิเคชัน เช่น "สิทธิ์การแก้ไขข้อมูลทั้งหมด"`,
"label.customfield.delete.prompt":`ป้ายกำกับฟิลด์ที่กำหนดเอง`,
"label.add":`เพิ่ม`,
"label.deputationalsoapprove":`ผู้แทนก็อนุมัติคำร้องนี้ได้`,
"label.leave_nosave":`หลังจากออกจากระบบ ข้อมูลปัจจุบันจะไม่ถูกบันทึก`,
"label.tianyancha.title":`เทียนเหยี่ยนฉา`,
"vue_label_pool_restore":`กู้คืน`,
"chatter.feed.menutype.feed.markcom":`เวยเทียที่บุ๊กมาร์ก`,
"label.query.data.error":`การสืบค้นข้อมูลรายการที่เกี่ยวข้องล้มเหลว`,
"label.pc.ui.2018.unpin":`เลิกปักหมุด`,
"label.partner.template.memo":`บันทึกข้อความ`,
"label.weixin.cannot.gain.userinformation":`ไม่สามารถรับข้อมูลของผู้ใช้`,
"label.stdashbord.xsld.department":`หน่วยงาน`,
"label.service.ganttBaiduMap.scheduled.starttime":`กําหนดเวลาเริ่มต้น`,
"label.documentforms":`เอกสาร`,
"label.operator.insert":`แทรกตัวดำเนินการ`,
"label.processsetting.select.five.fields":`สามารถเลือกได้สูงสุด 5 ฟิลด์`,
"label.weixin.password":`รหัสผ่าน`,
"vue_label_chatter_share_followers":`แบ่งปันกับผู้ติดตาม`,
"label.brief.baifang":`ลงชื่อเข้าพบลูกค้า`,
"label.emailobject.track.unopen":`ไม่ได้เปิด`,
"label.sendmail.immediately":`ส่งทันที`,
"label.partnerCloud.payTheAmount":`จํานวนเงินที่ชําระ`,
"label.integrations.mailchimp.connect":`เชื่อมต่อ CloudCC ไปยังบัญชีของคุณ`,
"label.datamove.record.sucessfully":`รายการบันทึกโอนย้ายสำเร็จ!`,
"lable.outlook.edit.allocation":`กำหนดผู้ใช้และโปรไฟล์`,
"label.chosesubject.talk":`นัดพบเจรจา`,
"label.escalation.setup.entrydetail.escalation.time":`เวลาเลื่อนขั้น`,
"label.projectManagement.must.be.less.than.24.hours":`ต้องน้อยกว่า 24 ชั่วโมง`,
"setup_mainpage_label_welcome15":`กฎเวิร์กโฟลว์แพลตฟอร์มคลาวด์ CloudCC ทําให้กระบวนการสนับสนุนการขาย การตลาด และอื่นๆ ของคุณเป็นไปโดยอัตโนมัติ คุณสามารถกําหนดบันทึกให้กับผู้ใช้โดยอัตโนมัติ หรือแปลงจากผู้ใช้หนึ่งไปยังอีกผู้ใช้หนึ่งได้ด้วยเกณฑ์ที่กำหนดไว้ล่วงหน้า ประโยชน์หลักของการจัดการเวิร์กโฟลว์คืกำจัดกระบวนการดำเนินการที่ไม่จำเป็นออกไป เพิ่มประสิทธิภาพการทำงานขณะทำการอัปเดตบันทึก ด้วยวิธีการทำงานที่ได้มาตรฐาน ลดภาระการดำเนินงานมาเพิ่มระดับการจัดการด้านธุรกิจ และปรับเปลี่ยนระบบควบคุมการทำงานให้เหมาะสม สนับสนุนการอนุมัติออบเจ็กต์แบบไม่จำกัด ในขณะเดียวกันก็สามารถเรียกข้อความแจ้งเตือนทางอีเมล ข้อความสั้น ภารกิจ อัปเดตฟิลด์ และอื่นๆ`,
"label.mobile.phone.week.plan2":`แผนของสัปดาห์นี้`,
"label.add.newAsset":`สินทรัพย์ใหม่`,
"vue_label_salesadvance_losts":`จำนวนการสูญเสีย`,
"vue_label_report_editcolumn":`แก้ไขคอลัมน์`,
"vue_label_homepage_assignedtasks":`มอบหมายภารกิจแล้ว`,
"label.posting_from":`ผู้เผยแพร่`,
"year":`ปี`,
"label.autoRegister.changepwd.setpwd.tip.letter":`อย่างน้อยหนึ่งตัวอักษร`,
"label.version.nonsupport.feature.staticresource":`ไม่รองรับฟังก์ชันนี้! โปรดรอการอัปเกรดฟังก์ชันเพื่อใช้งาน!`,
"label.toleadmyclientandlinkman":`นำเข้าลูกค้าของฉันและผู้ติดต่อ`,
"label.appupload.install.processcrash":`จัดการความขัดแย้ง`,
"label.profile.setstandardtab":`การตั้งค่าแท็บมาตรฐาน`,
"template.chart.khhyfx":`การวิเคราะห์อุตสาหกรรมของลูกค้า`,
"label.reportTypcrtC":`ออบเจ็กต์ที่เกี่ยวข้อง (C) คลิกเพื่อเลือกออบเจ็กต์ที่เกี่ยวข้อง`,
"vue_label_report_mayormaynothave":`ออบเจ็กต์พาเรนต์อาจมีหรือไม่มีบันทึกที่เกี่ยวข้องกับออบเจ็กต์นี้`,
"label.service.gantt.plan.recommendation":`แผนได้รับการแนะนําแล้ว`,
"label.version.sum.lookupfield":`ฟิลด์ค้นหา`,
"label.builder":`ตัวสร้างเพจ`,
"label.sharerule.remark":`ระบุการแบ่งปันบันทึกนี้ คุณสามารถแบ่งปันบันทึกนี้และข้อมูลที่เกี่ยวข้องกับผู้ใช้ บทบาท บทบาทและผู้ใต้บังคับบัญชา ภูมิภาค ผู้ใช้ที่เกี่ยวข้องกับภูมิภาคย่อย การแบ่งปันส่วนบุคคลสามารถใช้เพื่อขยายสิทธิ์การเข้าถึงข้อมูลเท่านั้น ไม่รวมถึงการจำกัดการเข้าถึง`,
"vue_label_email_benn_added":`เพิ่มอีเมลแล้ว`,
"label.version.allow.sum":`ถึงขีดจำกัดแล้ว! หากมีความจำเป็น กรุณาอัปเกรดรุ่น CloudCC!`,
"label.icon.130":`สกุลเงิน`,
"label.custom.new":`ใหม่`,
"label.see_allfields":`ดูฟิลด์ทั้งหมด`,
"front-marketing-module-v1-share-poster":`แบ่งปันโปสเตอร์`,
"label.service.one":`ตัวกรองของคุณอ้างถึงเงื่อนไขการกรองที่ไม่ได้กำหนดไว้:`,
"lable.outlook.edit.alprec":`เลือก CloudCC.com ก่อนเสมอ`,
"Account_News_Setting_001":`การตั้งค่าลูกค้า`,
"label.mr.caption.opportunity.result":`ตรวจสอบซ้ำและผสาน: ผลของการสืบค้นข้อมูลโอกาสทางธุรกิจที่ซ้ำกัน`,
"label.forbidden":`ห้ามใช้`,
"label.query.detail.openpartner":`เปิดใช้งานในฐานะพาร์ทเนอร์`,
"label.session_date":`วันที่เซสชัน`,
"label.forecast.customforecast.submit.deyuce":`การพยากรณ์ของ`,
"label.emailtocloudcc.filed.server":`เซิร์ฟเวอร์`,
"label.emailtocloudcc.tip2":`หลังจากลบแล้ว Email to CloudCC จะไม่สามารถใช้ผ่านทางอีเมลนี้ได้ ยืนยันการลบ?`,
"pagecreator_layout_message_delete_fail":`การลบเค้าโครงล้มเหลว`,
"front-lightning-module-v1-dashborad-export-PDF":`ส่งออก PDF`,
"lable.quote.syncing.syncingto":`รายละเอียดใบเสนอราคาซิงค์กับผลิตภัณฑ์ที่มีโอกาสทางธุรกิจแล้ว`,
"message.error.view.lastview.update":`ไม่สามารถลบมุมมองรายการสาธารณะสุดท้ายได้ </br>คุณไม่สามารถเปลี่ยนมุมมองรายการสุดท้ายที่ผู้ใช้ทุกคนสามารถมองเห็นเป็นมองเห็นได้เฉพาะบุคคลเท่านั้น<br><br>`,
"label.weixin.select.one":`เลือกอย่างน้อยหนึ่งรายการ`,
"label.projectManagement.Pleaseenterprojectname":`กรุณาป้อนชื่อโครงการ...`,
"label.data.downpage.e_list.desc1":`ข้อมูลที่แสดงในหน้านี้เป็นไฟล์ที่ส่งออกสำเร็จแล้ว โปรดดาวน์โหลดไฟล์ที่ส่งออกให้ทันเวลาตามข้อมูลที่แจ้งในอีเมล`,
"label_tabpage_notexceed25":`บันทึกที่เลือกต้องไม่เกิน 25 รายการ`,
"label.campaign.channel.step5.remark":`คุณตั้งค่าหน้าลงทะเบียนของคุณเรียบร้อยแล้ว`,
"label.setup.mobile.bottombutton.profile.prompt":`คำเตือน: เมนูด้านล่างของโปรไฟล์ที่กำหนดเองจะเขียนทับการตั้งค่าแบบรวมของเมนูด้านล่างของบริษัท`,
"label.stdashbord.xsld.business.knx":`ความน่าจะเป็น`,
"label.setemailtip":`สร้างการแจ้งเตือนทางอีเมลเพื่อเชื่อมโยงกฎเวิร์กโฟลว์และกระบวนการอนุมัติหนึ่งกฎขึ้นไป หากการเปลี่ยนแปลงแจ้งเตือนทางอีเมลหรือมีการแก้ไขใดๆ จะถูกนำไปใช้กับกฎและการอนุมัติทั้งหมดที่เกี่ยวข้อง`,
"report.button.go":`ไปที่`,
"lable.the.united.arab.emirates":`ได้รับบันทึกแล้ว`,
"label.writer. name.file":`กรุณากรอกชื่อไฟล์ใบเสนอราคา`,
"label.validate.function.funcExplain.ADDMONTHS":`ขณะที่ป้อนวันที่ date (ฟิลด์วันที่) เพิ่ม num (จำนวนเดือน) จะส่งกลับวันที่ใหม่ จำนวนวันในเดือนเดิมเท่ากับวันสุดท้ายของเดือนนี้ หรือ เมื่อจำนวนวันในเดือนของวันที่ใหม่น้อยกว่าจำนวนวันของเดือนทีป้อนครั้งแรก จะเปลี่ยนจำนวนวันในหนึ่งเดือนเป็นวันที่ใหม่ในวันสุดท้ายของเดือน`,
"vue_label_chatter_enter_shared_content":`กรุณาระบุเนื้อหาที่ต้องการแบ่งปัน`,
"message.lookup.condition":`เงื่อนไขการค้นหาต้องใส่อักขระหนึ่งตัวขึ้นไป`,
"vue_label_commonobjects_detail_customers":`ลูกค้าที่ปิดใช้งานผู้ใช้ภายนอกอย่างถาวรจะป้องกันไม่ให้ผู้ใช้ภายนอกทั้งหมดที่เชื่อมโยงกับลูกค้าถูกลบออกจากชุมชน ทีม กลุ่ม ชุดสิทธิ์ และกฎการแบ่งปันทั้งหมดที่เชื่อมโยงกับผู้ใช้นั้น ขณะเดียวกันบทบาทและกลุ่มที่เชื่อมโยงกับบัญชีก็จะถูกลบอย่างถาวร และจะไม่ปรากฏในถังขยะรีไซเคิล คุณยืนยันหรือไม่?`,
"label.emailobject.view.all":`ทั้งหมด`,
"vue_label_file_size_limit_new":`ไฟล์แนบมีขนาดใหญ่กว่า {size}M การอัปโหลดล้มเหลว`,
"front-gantt-module-please-reorder-milestones":``,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`อีเมล`,
"label.namespaceprefix":`คำนำหน้าเนมสเปซ`,
"label.ems.delete.success":`การลบสำเร็จ`,
"label.partnerCloud.financeSetting.setWechatPay":`ตั้งค่าวีแชทเพย์`,
"front-epwechat-module-v1-input-token":`กรุณากรอก Token`,
"setup_object_field_dependency_button_setdependency":`ตั้งค่าการพึ่งพาของฟิลด์`,
"chatter.group.request01":`คำร้อง`,
"message.error.field.number.length":`รูปแบบการป้อนข้อมูลความยาวผิดพลาด`,
"label.tabpage.lessz":`น้อยกว่า`,
"vue_label_notice_uploadavatar_format":`รูปโปรไฟล์ที่อัปโหลดต้องอยู่ในรูปแบบ JPG/PNG/GIF เท่านั้น`,
"label.project.hit.thirteen":`แจ้งเตือนไมล์สโตนทุกวัน`,
"frame_personinfo_label_usethisimage":`เราจะใช้แผนที่รูปขนาดย่อนี้ในแอปพลิเคชัน`,
"label.startuploadfile.step":`มิฉะนั้นไฟล์ที่ยังอัปโหลดไม่สำเร็จจะแสดงขึ้นที่ด้านบนพร้อมข้อความแจ้ง คุณต้องล้างข้อมูลทั้งหมดก่อนจึงจะเลือกได้ไฟล์อีกครั้ง`,
"component_assistant_label_overduetask":`โอกาสทางธุรกิจที่ภารกิจเกินกำหนด`,
"label.partnerCloud.financeSetting.information":`วิธีการตั้งค่าข้อมูลการสมัครใช้งานของอาลีเพย์`,
"label.appupload.install.package.component":`ส่วนเสริมของโปรแกรมสำเร็จรูป`,
"label.emailobject.emaildetail.nextactivity.task":``,
"vue_label_chatter_edit_post":``,
"label.appupload.upload.logo":`ไอคอน`,
"label.role.selecteduser":`ผู้ใช้ที่เลือก`,
"label.letter.assign":`ระบุเนื้อหาจดหมายเชิญ`,
"label.forecast.shrepage.title":`รายละเอียดการแบ่งปันการพยากรณ์`,
"lable.Generate.service.appointment":`การนัดหมายการบริการที่สร้างโดยรายการบรรทัดใบสั่งงาน`,
"label.productsales.nodata":`ไม่มีข้อมูล`,
"vue_label_email_Please_select_at_least_one_email":`กรุณาเลือกอย่างน้อยหนึ่งอีเมล`,
"label.data.downpage.i_title.num4":`4. หากออบเจ็กต์ที่คุณต้องการนำเข้ามีฟิลด์ค้นหาและฟิลด์รายละเอียดหลัก ค่าที่สอดคล้องกับฟิลด์นี้ต้องเป็น ID มิฉะนั้นจะไม่มีผล`,
"label.new.exchagecurrency":`อัตราแลกเปลี่ยนใหม่`,
"label.layout.listtip":`ตารางต่อไปนี้แสดงการกำหนดเค้าโครงหน้าของโปรไฟล์ที่แตกต่างกัน`,
"label.icon.2":`กระเป๋าสตางค์`,
"label.chat.topic.delete.prompt3":`ยืนยันว่าจะลบหัวข้อนี้หรือไม่?`,
"UG_Lead_008":`สแกนนามบัตร`,
"label.multilang.databatchadd.fail":`เพิ่ม {0} รายการข้อมูลล้มเหลว`,
"front-kefu-moudle-v1-chzx-confirm":`ยืนยันว่าจะลบ Seat หรือไม่?`,
"label.import.page1.matchlabel":`วิธีการจับคู่{{$store.state.labelName}}`,
"label.dashboardSetup.showdw.d3":`ล้าน`,
"label.version.ifnecessary":`หากมีความจำเป็น กรุณาอัปเกรดรุ่น CloudCC!`,
"label.confirm.delete.default.tab":`ยืนยันว่าต้องการลบแท็บเข้าสู่ระบบเริ่มต้นหรือไม่?`,
"label.emailtemplate.mergefields.tip":`เมื่อออกแบบเนื้อหาอีเมลสามารถเพิ่มฟิลด์ผสานแทนที่ข้อความในเนื้อหาได้ เมื่ออีเมลถูกใช้ ระบบจะแทนที่เป็นข้อความ ตัวอย่างเช่น {!Contact.name} เมื่อใช้อีเมล ข้อความจะกลายเป็นชื่อผู้ติดต่อ`,
"vue_label_chatter_decline_members_join":`ปฏิเสธสมาชิกเข้าร่วมกลุ่ม`,
"label.role.no":`ไม่มีบทบาท`,
"label.service.gantt.resources":`ทรัพยากร`,
"label.knowledge.language.simplified":`ภาษาจีนตัวย่อ`,
"label.eidt.queue.length.cannot.than":`ชื่อต้องยาวไม่เกิน 50`,
"label.mobile.quickcreate.default.tasks":`ภารกิจ`,
"label.discount.yuan":`ส่วนลด (หยวน)`,
"message.error.delete.pending":`บันทึกอยู่ระหว่างการอนุมัติ ไม่สามารถลบได้<br>คลิก<a href='javascript:history.back();'>ที่นี่</a>เพื่อกลับไปยังหน้าก่อนหน้า`,
"chatter.show.mostnews":`แสดงข่าวสารเพิ่มเติม`,
"label.optionlist":`รายการตัวเลือก`,
"template.chart.cpdj":`ราคาผลิตภัณฑ์`,
"label.user.usernamepassword.error":`ชื่อผู้ใช้หรือรหัสผ่านผิด`,
"label.file.sharetype.check":`ผู้ตรวจสอบ`,
"label.completed.generated.page":`สร้างหน้าเพจสำหรับคอมพิวเตอร์สำเร็จ`,
"label.martrixcross":`ผลคูณเชิงเวกเตอร์`,
"label_tabpage_entercusnamez":`กรุณาใส่ชื่อลูกค้า`,
"lable.account.NextwDays":`30 วันถัดไป`,
"label.list.userinterface.dashboard.hint":`แผนภูมิแดชบอร์ดใหม่รองรับการแสดงผลบนเทอร์มินัลเช่น โทรศัพท์มือถือ แท็บเล็ต เป็นต้น และสามารถนำเสนอได้อย่างรวดเร็ว`,
"message.fieldtrack.operatecreate":`สร้างแล้ว`,
"label.service.gantt.available.plan":`ช่องว่างเวลาที่สามารถวางแผนได้:`,
"label.activity.setting":`การตั้งค่ากิจกรรม`,
"label.tag.manage.record":`จำนวนบันทึก`,
"label.customcomponent.page.edit.title":`แก้ไขส่วนเสริมที่กำหนดเอง`,
"label.import.index.creationrecord":`สร้างบันทึก`,
"label.tabpage.printz":`พิมพ์`,
"label.appointment.wizard.subtitle4-1-5":`1.5 ชั่วโมง`,
"label.partnerCloud.orderingPlatform.discountUnit":`หน่วยส่วนลด:`,
"label.weixin.micro.message.profile.associated":`ความสัมพันธ์ระหว่างบัญชีวีแชทสาธารณะและโปรไฟล์บริษัท`,
"label.cpq.opportunity.pricebook.change":`โอกาสทางธุรกิจนี้เชื่อมโยงกับใบเสนอราคาหลัก ไม่สามารถเปลี่ยนแปลงสมุดราคาได้`,
"vue_label_opportunity_business_opportunity":`ผลลัพธ์คือโอกาสทางธุรกิจปิดการขายสำเร็จที่ประกอบด้วยบันทึกที่มีฟิลด์เหมือนกับโอกาสทางธุรกิจปัจจุบันตั้งแต่หนึ่งฟิลด์ขึ้นไป`,
"message.standardreport":`รายงานมาตรฐาน`,
"vue_label_account_outstanding_business":`โอนย้ายโอกาสทางธุรกิจที่ยังไม่ได้ดำเนินการของผู้อื่น`,
"vue_label_commonobjects_detail_field":`เลือกฟิลด์ตัวกรอง`,
"pagecreator_page_button_delete":`ลบ`,
"label.leadconvers.permisson":`ไม่มีสิทธิ์{!operator}สำหรับ{!objectname}โปรดติดต่อผู้ดูแลระบบ!`,
"vue_label_systemSettings_customcode":`โคดที่กําหนดเอง`,
"button.partner.cancel":`ยกเลิก`,
"label.whChatBindingState":`สถานะการผูกบัญชีวีแชท`,
"label.appointmentconfirmail.wizard.subtitle6":`หมายเลขโทรศัพท์`,
"label.recycle.dis.tip2":`ผู้ใช้สามารถล้างถังขยะรีไซเคิลโดยคลิกปุ่มล้างถังขยะรีไซเคิลของคุณหรือล้างถังขยะรีไซเคิลขององค์กร การล้างถังขยะรีไซเคิลใช้ระยะเวลา ระบบจะส่งการแจ้งเตือนทางอีเมลหลังจากดำเนินการเสร็จสิ้น`,
"batch.transfer.succ":`จำนวนข้อมูลที่โอนย้ายแบบกลุ่มสำเร็จคือ:`,
"label.chat.add.bookmark":`บุ๊กมาร์ก`,
"label.mr.object.contact":`ผู้ติดต่อ`,
"component_setup_label_parentobject":`ออบเจ็กต์พาเรนต์`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`วันอังคาร`,
"vue_label_report_list":`เลือกฟิลด์ที่จะแสดงในส่วนหัวของรายการ`,
"label.checkbox.false":`ไม่`,
"label.chatter.followers":`ถูกติดตาม`,
"label.mr.loadReDate":`โหลดข้อมูลที่เลือก`,
"label.versiontype.Essential":`รุ่นเอสเซนเชียล`,
"front-project-module-v1-input-actual_working_hours":`กรุณาป้อนชั่วโมงทำงานจริง`,
"label.visualpage.staticresource.p2":`2. โปรดทราบว่า ประเภทไฟล์ทรัพยากรแบบคงที่ที่รองรับมี png, jpg, gif, js, css`,
"label.query.clone.detail.choose":`โปรดเลือกบันทึกรายละเอียดที่ต้องการจะคัดลอก`,
"component.assistant.label.30daysnoact":`ไม่มีกิจกรรมใดๆ ใน 30 วัน`,
"label.tianyancha.businessverify.relation":`แม็ปแล้ว`,
"vue_label_email_havent_received_the_email_yet":`ยังไม่ได้รับอีเมล`,
"label.isEnableVisualpage_new.title":`เปิดใช้งานการเข้าถึงเพจแบบกำหนดเอง`,
"lable.SalesCommitmentKanBan.allContractAmount":`จำนวนสัญญาทั้งหมด`,
"label.searchall":`ค้นหาทั้งหมด`,
"label.h5.similar.opportunity.select.all":`เลือกทั้งหมด`,
"label.area.tree.intro":`คุณสามารถตรวจสอบความสัมพันธ์ระหว่างภูมิภาคได้โดยตรงที่นี่`,
"label.select.up.three.fields":`หมายเหตุ: เลือกได้สูงสุดสามฟิลด์`,
"label.leadscore.doing":`อยู่ระหว่างการให้คะแนน กรุณาอย่าให้คะแนนซ้ำ`,
"message.choosereportobj":`โปรดเลือกออบเจ็กต์รายงาน`,
"button_partner_start":`เริ่มใช้งาน`,
"label.quote.print":`พิมพ์ใบเสนอราคา`,
"label.workflowoperateselect":`ขั้นตอนที่ 3: ระบุการดำเนินการเวิร์กโฟลว์`,
"label.greate":`> มากกว่า`,
"lable.setting.qrcodeOrbarcode.rule":`การตั้งค่ากฎรหัสคิวอาร์/บาร์โคด`,
"label.partnerCloud.orderingPlatform.discounts":`แผนส่วนลด`,
"label.ems.save2draft":`บันทึกแบบร่าง`,
"vue_label_homepage_editname":`แก้ไขชื่อหน้าแรก`,
"label.ccdocument.save.error":`การบันทึกล้มเหลว รหัสข้อผิดพลาดคือ`,
"label.samoa.standard.time":`เวลามาตรฐานเกาะซามัว`,
"label.tianyancha.businessverify.msg7":`3: ขอบเขตการให้บริการข้อมูล:`,
"vue_label_commonobjects_view_up_to_data":`การดำเนินการนี้รองรับข้อมูลได้มากที่สุด 200 รายการ`,
"label.manage":`จัดการ`,
"label.tooltip":`มีการใช้แหล่งข้อมูลรายงานและไม่สามารถแก้ไขความสัมพันธ์ของออบเจ็กต์ได้!`,
"vue_label_calendar_edit_calendar":`แก้ไขปฏิทิน`,
"label.attendance.keywords":`กรุณาใส่คีย์เวิร์ด`,
"label.otherinfo":`ข้อมูลอื่นๆ`,
"System_TAB_SeeViewAmount":`ดูจำนวนรวม`,
"label.recordtype.remark":`คำอธิบาย`,
"label.object.cannot.delete":`ไม่สามารถลบออบเจ็กต์ได้ เนื่องจากมีความเกี่ยวข้องกับความสัมพันธ์ต่อไปนี้กับออบเจ็กต์อื่นๆ`,
"label.setup.mobile.bottombutton.saveprompt":`กรุณาเลือกหน้าเพจระดับหนึ่ง 4 หน้า`,
"label.department.lastpage":`หน้าสุดท้ายแล้ว`,
"label.emailtemplate.mergefield.use":`คัดลอกและวางค่าฟิลด์ผสานลงในเนื้อหาของอีเมล`,
"vue_label_salesfunnel_notice8":`สัดส่วนความสำเร็จในการเปลี่ยนจากสเตจนี้ไปสู่สเตจต่อไป`,
"lable.opppdt.addpdt.table.product":`ผลิตภัณฑ์`,
"vue_label_helpcenter_report2.2":`ขั้นตอนที่2: เลือกวิธีสรุปคอลัมน์: ผลรวม เฉลี่ย สูงสุด ต่ำสุด <br>•เรียงลำดับข้อมูลขึ้นและลงในรายงาน<br>คลิกเครื่องหมาย “↑” หรือ“↓” ถัดจากฟิลด์ในหัวรายงานตัวอย่าง ข้อมูลในรายงานจะถูกจัดเรียงตามฟิลด์นี้ <br>•แสดงหรือซ่อนแถวข้อมูล<br>หลังจากจัดกลุ่ม คุณสามารถแสดงหรือซ่อนรายละเอียดบรรทัด ผ่านสวิตช์ "บรรทัดรายละเอียด" ที่ด้านขวาบนของรายงานตัวอย่าง สวิตช์ "บรรทัดรายละเอียด" จะปิดโดยค่าเริ่มต้น <br> •เปิดหรือปิดการแสดงตัวอย่างการอัปเดตอัตโนมัติ<br> การอัปเดตอัตโนมัติผ่านสวิตช์ "แสดงตัวอย่างการอัปเดตอัตโนมัติ" ที่ด้านขวาบนของรายงานตัวอย่าง เมื่อเปิด ผลกระทบของการดำเนินการแต่ละขั้นตอนของคุณที่มีต่อข้อมูลจะแสดงโดยอัตโนมัติในรายงานตัวอย่าง หากต้องการกรองบันทึกรายงาน คลิกที่ตัวกรอง<br>ตัวกรองแบ่งเป็นตัวกรองมาตรฐานและตัวกรองฟิลด์ <br>ตัวกรองมาตรฐานประกอบด้วยตัวกรอง "บทบาท", ตัวกรอง "แสดงให้เจ้าของเห็น", และตัวกรอง "วันที่"<br>A. ตัวกรอง "บทบาท" คลิกชื่อบทบาทเพื่อสลับระหว่างบทบาทต่างๆ ผ่านการแบ่งข้อมูลตามบทบาทปัจจุบันและบทบาทผู้ใต้บังคับบัญชาโดยตรง <br>B. ตัวกรอง "แสดงให้เจ้าของเห็น" แบ่งข้อมูล "แสดงให้เจ้าของเห็น" และ "แสดงให้ทุกคนเห็น" "แสดงให้เจ้าของเห็น" แสดงข้อมูลผู้ใช้ปัจจุบันเป็นเจ้าของ "แสดงให้ทุกคน" แสดงข้อมูลทั้งหมดที่ผู้ใช้ปัจจุบันมีสิทธิ์ดู <br>C.ตัวกรอง "ช่วงวันที่" แบ่งข้อมูลภายในช่วงเวลาตามวันที่เช่น "วันที่สร้าง" และ "วันสิ้นสุด" <br>ซึ่งตัวกรองฟิลด์ประกอบด้วยตัวกรองฟิลด์และตัวกรองขั้นสูง<br>`,
"label.validate.function.funcFormat.YEAR":`YEAR(date)`,
"label.service.gantt.timeScale":`เลือกระยะห่างช่วงเวลาที่แสดงในแผนภูมิแกนต์`,
"label.data.dataexptemplate.desc1":`1. การส่งออกข้อมูลมีสองวิธี วิธีหนึ่งอยู่ในรูปแบบ CSV และอีกวิธีอยู่ในรูปแบบบีบอัด ค่าเริ่มต้นคือรูปแบบ CSV`,
"template.chart.btjbkhqk":`สถานการณ์ของลูกค้าในขั้นต่างๆ`,
"label.role.assign.select":`การลบผู้ใช้ออกจากรายชื่อ <b>ผู้ใช้ที่เลือก</b> จะกำหนดผู้ใช้รายนั้นให้กับบทบาทที่เลือกด้านบน`,
"label.event.lookupmulti.assigner":`ผู้ได้รับมอบหมาย`,
"label.appexchange.fieldupdata":`อัปเดตฟิลด์เวิร์กโฟลว์`,
"label.lookup.page.notexists":`ไม่พบหน้าเพจ`,
"label.appupload.install.error.choice3":`ผสานส่วนเสริมที่ขัดแย้งกันให้เป็นส่วนเสริมเดียว`,
"vue_label_commonobjects_detail_team":`ทีมบริหาร`,
"label.approvereqiest":`คำขออนุมัติ`,
"message.error.id.replace":`ไม่พบข้อมูล{0}ที่สอดคล้องกับปฏิทิน`,
"font-evaluate-module-v1-general":``,
"vue_label_report_whatweek":`วันไหน`,
"vue_label_chatter_img_upload":`คุณสามารถอัปโหลดไฟล์ JPG GIF หรือ PNG ขนาดไฟล์สูงสุดคือ 2M`,
"label.checkbox":`กล่องกาเครื่องหมาย`,
"label.visualpage.component.n5":`5. ตัวอย่าง เรียก: &lt:component:c1 args="name:sqlName,age=18, sex='man'" /&gt; ใช้: &lt;cc:component>&lt;cc>String myName = name; int myAge = age; String sex = sex;&lt;/cc>&lt;/cc:component>`,
"chatter.updat":`เวลาอัปโหลด`,
"label.ems.emailaccount":`บัญชีอีเมล`,
"label.autoRegister.changepwd.setpwd.tip1":`ตั้งรหัสผ่านบัญชี CloudCC`,
"label.import.step1.matchway":`วิธีจับคู่{labelNameshow}`,
"label.manageAll.sel.one4":`รายการที่ฉันเคยปฏิเสธ`,
"label.tabpage.lookatmorez":`ดูเพิ่มเติม`,
"label_tabpage_addadvancedoptions":`เพิ่มตัวเลือกขั้นสูง`,
"message.validation.accept":`ป้อนรูปแบบที่ถูกต้อง`,
"label.handlingnooperate":`ข้อมูลอยู่ระหว่างการประมวลผล โปรดอย่าดำเนินการอื่น มิฉะนั้นการประมวลผลจะล้มเหลว`,
"label.mobile.buttom.homepage":`หน้าแรก`,
"lable.account.LastaDays":`7 วันที่ผ่านมา`,
"label.user.notexists":`ไม่พบผู้ใช้!`,
"front-electronic-signature-isclose":``,
"label.optional.groups":`ตัวเลือกกลุ่มบรรทัดใบเสนอราคา`,
"pagecreator.layout.label.layoutname":`ชื่อเค้าโครง`,
"label.error404":`ไม่มีหน้าเว็บที่คุณจะเยี่ยมชม <br /> โปรดกลับมาใหม่ในภายหลัง ...`,
"label.eventtrigger":`ทริกเกอร์อิเวนต์`,
"label.projectManagement.next.page":`หน้าถัดไป`,
"vue_label_SMS_chosen":`เลือกแล้ว`,
"label.part.cannot.empty":`สเตจไม่สามารถว่างเปล่า!`,
"label.call.center.jilu":`บันทึกการโทร`,
"front-kefu-moudle-v1-tenant-reinput":`กรุณาป้อน ID ผู้เช่า`,
"label.projectManagement.you.want.to.delete.this.data":`ยืนยันว่าจะลบข้อมูลนี้หรือไม่`,
"label.projectManagement.nocharge":`ไม่เรียกเก็บเงิน`,
"System_TAB_SeeViewPageAmount":`ดูจำนวนหน้า`,
"label.password.query.error":`เกิดข้อผิดพลาดในการสืบค้นผู้ใช้`,
"message.chooseatleastone":`โปรดเลือกอย่างน้อยหนึ่งค่า`,
"label.sortasc":`เรียงจากน้อยไปมาก`,
"label.stdashbord.xsld.business.jinezhb":`สัดส่วนจำนวนเงิน`,
"label.attendance.add":`เพิ่มบันทึกเวลาทำงาน`,
"vue_label_account_invoices":`โอนใบแจ้งหนี้ทั้งหมดของเจ้าของลูกค้า`,
"label_delete _model":`การลบแบบจำลองจะลบข้อมูลออบเจ็กต์เป้าหมายที่เกี่ยวข้องด้วยเช่นกัน และจะยกเลิกไม่ได้ ยืนยันจะลบใช่หรือไม่?`,
"label.folder.sort。discreption":`โฟลเดอร์จะถูกส่งออกตามลำดับที่เลือก`,
"label.partnerCloud.financeSetting.merchantPlatform":`พาธการรับ: แพลตฟอร์มร้านค้า - ศูนย์จัดการล็อกอิน - API Security - คีย์ API`,
"label.equal":`= เท่ากับ`,
"lable.PowerProcess.Workorder":`ใบสั่งงาน`,
"front-docusign-setting-error-tips":``,
"template.report.lead.status":`สถานะลีด`,
"label.create.remark":`เพิ่มหมายเหตุ`,
"font-evaluate-module-v1-one-points":``,
"label.validate.function.funcExplain.DATETIMEVALUE":`ส่งกลับปี เดือน วัน และเวลา GMT (ฟิลด์วันที่/เวลา)`,
"label.report.select.group.mode":`เลือกวิธีการจัดกลุ่ม`,
"label.h5.editmydetails":`แก้ไขข้อมูลส่วนตัว`,
"front-epwechat-module-v1-authorize":`โดเมนการย้อนกลับที่ได้รับอนุญาต`,
"label.tabpage.kanban":`การตั้งค่าคัมบัง`,
"label.emailobject.emaildetail.button.addtocontact":`เพิ่มไปที่ผู้ติดต่อ`,
"lable.opppdt.selPbk.description":`เลือกสมุดราคาสำหรับโอกาสทางธุรกิจนี้ คุณสามารถเพิ่มสินค้าได้จากสมุดราคาเดียวเท่านั้น การเปลี่ยนสมุดราคาที่เลือกไว้จะทำให้ผลิตภัณฑ์ทั้งหมดถูกลบออกจากโอกาสทางธุรกิจนี้`,
"component.event.button.save":`บันทึก`,
"vue_label_homepage_homepage_assigned_success":`การกําหนดหน้าแรกสําเร็จ`,
"message.duplication.label.blankmatch":`จับคู่ช่องที่ว่างหรือไม่`,
"label.icon.24":`ชุดปฐมพยาบาล`,
"label.mobile.same":``,
"label.file.library.managemembers.addmember":`เพิ่มสมาชิก`,
"chatter.sp":`แสดงเวยเทีย`,
"label.user.notlogin.range":`ไม่อยู่ในช่วงเวลาเข้าสู่ระบบ`,
"label.step3.total7":`ขั้นตอนที่ 3 จาก 7`,
"label.user.fullname":`ชื่อเต็ม`,
"label.button.menubar":`แถบเมนู`,
"#label.importfilestep3":`ขั้นตอนที่ 3: เลือกและอัปโหลดไฟล์ของคุณ #`,
"label.appointment.wizard.subtitle6":`คำอธิบาย`,
"message.lostnextapprover":`การส่งนี้ต้องการผู้อนุมัติรายถัดไปที่กำหนดโดยฟิลด์ผู้ใช้ที่เกี่ยวข้อง ค่านี้ว่างเปล่า สำหรับรายละเอียดโปรดติดต่อผู้ดูแลระบบของคุณ`,
"label.sso.saml.sp.logoutUrl":`URL Single Logout ผู้พิสูจน์และยืนยันตัวตน`,
"label.weixin.isgoon":`ข้อมูลสมาชิกของคุณมีอยู่แล้ว หากยังทำต่อ บัญชีวีแชทที่เคยผูกไว้กับหมายเลขโทรศัพท์มือถือนี้จะไม่สามารถใช้บัญชีวีแชทสาธารณะของ aid-max ได้ ต้องการทำต่อหรือไม่?`,
"vue_label_notice_homepage1":`โปรดป้อนค่าเป้าหมายที่ถูกต้องภายใน 12 บิต`,
"label.umeng.activity.event.will":`เร็วๆ นี้`,
"label.insertURL":`แทรก URL`,
"label.partnerCloud.orderingPlatform.administrator":`ไม่มีสมุดราคา โปรดติดต่อผู้ดูแลระบบของต้นน้ำ`,
"vue_label_systemSettings_emailtemplate":`แม่แบบอีเมล`,
"template.dashboard.market.analysis":`การวิเคราะห์แคมเปญ`,
"message.deleteapproval.tip":`คุณลบได้เฉพาะกระบวนการอนุมัติที่เกี่ยวข้องกับบันทึกที่ไม่มีข้อมูลเท่านั้น`,
"pagecreator_page_message_delete":`ต้องการลบเพจที่เลือกหรือไม่?`,
"component.telerecord.label.message":`ความคิดเห็น`,
"front-email-payment-Invoice-preview-opening":``,
"noless":`มากกว่าหรือเท่ากับ`,
"label_emailtocloudcc_button_back":`ยกเลิก`,
"lable.Please.select.a.template":`โปรดเลือกแม่แบบที่มีอยู่`,
"front-lightning-module-v1-details-page-chart-relevant":`เมื่อออบเจ็กต์ปัจจุบันรวมอยู่ในออบเจ็กต์ที่เกี่ยวข้องกับรายงานที่เลือก คุณสามารถกรองข้อมูลในรายงานเพิ่มเติมตามบันทึกปัจจุบัน และสามารถเลือกว่าจะอนุญาตให้ผู้ใช้รีเฟรชข้อมูลที่แคชในรายงานด้วยตนเองหรือไม่`,
"label.object.page.head":`ด้านบนของหน้า`,
"label.notification.time1":`เพิ่งจะ`,
"label.weixin.optionnine":`ตัวเลือกที่เก้า`,
"label.approval.content.tolang":`เนื้อหาที่ป้อนยาวเกินไป โปรดป้อนใหม่!`,
"label.leadconvers":`ลีดข้ามสเตจ`,
"label.compact.layout.frame.tabseq":`แสดงลำดับหน้า TAB:`,
"label.permission":`ชุดสิทธิ์`,
"vue_label_notice_new_success":`สร้างใหม่สำเร็จ`,
"label.money":`สกุลเงิน`,
"label.ccchat.person.invite.unsuppem":`ที่อยู่อีเมลที่คุณป้อนไม่รองรับ{0}`,
"message.profile.del":`โปรไฟล์นี้เป็นโปรไฟล์ผู้ดูแลระบบ ไม่สามารถลบได้!`,
"vue_label_report_savelocation":`บันทึกตำแหน่งที่ตั้ง`,
"label.knowledgebase.select.lighting.target":`โปรดเลือก lighting เป้าหมาย`,
"label.visualpage.labelname":`ชื่อป้ายกำกับหน้าเพจ`,
"label.notification.ccchat2":`[ชื่อผู้ใช้ที่กดถูกใจ] ถูกใจเวยเทียของคุณ`,
"label.htyj.wanchenglv":`อัตราความสำเร็จ`,
"label.weixin.report.generatedchart":`สร้างแผนภูมิแล้ว`,
"label.customer.tab.please.label":`กรุณาใส่ป้ายกำกับแท็บ`,
"label.template.lookup":`ค้นหาแม่แบบ`,
"label.attendance.setting.wucha":`คลาดเคลื่อนไม่เกิน 200 เมตร`,
"vue_label_opportunity_product_addproduct":`เพิ่มผลิตภัณฑ์`,
"label.data.setok.t.desc3":`, ดําเนินการ`,
"label.emailobject.template.public":`สาธารณะ`,
"label.setsubmit":`ส่งการติดตั้ง`,
"chatter.feed.menutype.feed.companycom":`เวยเทียทั้งหมด`,
"label.Generate.Document":`สร้างเอกสาร`,
"label.knowledge.setting.hint.six":`จัดระเบียบบทความโดยการจำแนกข้อมูล`,
"label.dashboard.show.total":`แสดงผลรวม`,
"attachment.select.warning.001":`เลือกไฟล์แนบที่จะจัดเก็บถาวร ปุ่มจัดเก็บถาวรไม่พร้อมใช้งาน  โปรดเลือกไฟล์แนบใหม่อีกครั้ง`,
"message.schedulejob.error.delete":`เกิดข้อผิดพลาดระหว่างการลบไลบรารี Job`,
"setup.layout.group.pagecomponent":`องค์ประกอบเพจ`,
"label_partner_new_step3_meno":`ไม่แน่ใจว่าต้องป้อนอะไร? ไม่ต้องกังวล คุณสามารถเปลี่ยนแปลงได้ทุกเมื่อในภายหลัง`,
"label.partnerCloud.orderingPlatform.mutex":`ไม่เกิดพร้อมกัน`,
"label.subtotalrely":`ผลรวมย่อยตาม`,
"label.file.library.selectFile2Lib":`เพิ่มไฟล์`,
"label.lock.record":`ได้ทำการล็อกบันทึก（`,
"label.multilang.addcustomreporttypestage2.description":`แหล่งข้อมูลนี้จะสร้างรายงานที่เกี่ยวกับ{0} โดยการเลือกออบเจ็กต์ที่มีความสัมพันธ์กับออบเจ็กต์นั้น และสามารถกำหนดได้ว่าจะส่งคืนบันทึกที่เกี่ยวข้องใดในออบเจ็กต์อื่นไปยังผลลัพธ์ของแหล่งข้อมูล`,
"message.duplication.errorinscript.greaterthan10":`เลือกบันทึกที่จะผสานได้มากสุด 10 รายการเท่านั้น!`,
"label.encd":`แสดงการเข้ารหัส`,
"UG.Account.03":`ตรวจสอบลูกค้าซ้ำแบบเชิงรุกและผสาน`,
"label.salescloud.teamrole.main2":`หลัก`,
"label.email.to":`ผู้รับ`,
"label.members.sign.notify":``,
"template.report.individual.case.priority":`ลำดับความสำคัญของเคส`,
"vue_label_report_selectfolder":`เลือกโฟลเดอร์`,
"label_partner_all":`พาร์ทเนอร์คลาวด์ทั้งหมด`,
"lable.custom.year":`ปีที่กำหนดเอง`,
"label.ispigeonhole":`จัดเก็บไฟล์แนบอย่างถาวร`,
"label.campaignmember.selectmember.steptotal":`ขั้นตอนที่ 2 จาก 2`,
"label.userphoto.save":`บันทึก`,
"label.knowledgebase.published.version.online":`เวอร์ชันที่เผยแพร่จะยังคงออนไลน์อยู่จนกว่าคุณจะเผยแพร่ฉบับร่างนี้`,
"template.report.customer.level.statistics":`สถิติระดับลูกค้า`,
"label.mobile.phone.day.plan":`แผนของวันพรุ่งนี้`,
"label.icon.95":`การสอน`,
"label.recordphone":`บันทึกการโทร`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`ถ้าคุณปิดใช้งานการจัดการสกุลเงินขั้นสูง คุณจะไม่สามารถใช้อัตราแลกเปลี่ยนที่หมดอายุได้ สกุลเงินของรายงานที่เกี่ยวข้องกับโอกาสทางธุรกิจ ผลิตภัณฑ์ที่มีโอกาสทางธุรกิจ และออบเจ็กต์ทั้งสองจะไม่แม็ปอัตราแลกเปลี่ยนในช่วงวันที่ที่ระบุอีกต่อไป ฟิลด์สกุลเงินทั้งหมดจะใช้อัตราแลกเปลี่ยนคงที่`,
"label.service.gantt.is.candidate":`ผู้สมัครของ`,
"label.ruleofchecktask":`เกณฑ์การตรวจสอบภารกิจ`,
"label.whole.page.show":`การแสดงผลแบบเต็มหน้าจอ`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(expression)`,
"label.ccdocument.template.set":`ฟังก์ชันแม่แบบตัวหนังสือสีแดง`,
"label.icon.103":`กำหนดการ`,
"lable.no.products.to.assets":`ไม่มีผลิตภัณฑ์ที่สามารถแปลงเป็นสินทรัพย์ได้`,
"label.fristname":`ชื่อ`,
"label.appointmentconfirmail.wizard.subtitle5":`ผู้ริเริ่ม/ผู้จัดงาน`,
"label.partner.workspace.myspace":`เวิร์คสเปซของฉัน`,
"label.tabpage.optionsz":`ตัวเลือก`,
"component_chatter_link_button_save":`เผยแพร่`,
"label.validate.function.funcFormat.NOW":`NOW()`,
"label.discountPlanEditor":`ตัวแก้ไขแผนส่วนลด`,
"label.weixin.fmu.pm":`บ่าย {0} โมง`,
"front-gantt-module-milestone-sorting":``,
"label.partnerCloud.maximumNumber":`จำนวนสูงสุดของเว็บไซต์พาร์ทเนอร์：`,
"label.mobile.place.record.interval.setup":``,
"label.visiblelinenumber":`จำนวนแถวที่สามารถมองเห็นได้`,
"front-kefu-moudle-nopower-calluser":``,
"label.field":`ฟิลด์`,
"label.projectManagement.groupbydate":``,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`จัดการแล้ว`,
"label.operation.monitoring.history":`ประวัติการตรวจสอบงาน`,
"label.data.dataexpalltype.all_desc1":`1. รหัสผ่านสำหรับการส่งออกไฟล์บีบอัดทั้งหมดสามารถสร้างโดยอัตโนมัติหรือป้อนด้วยตนเอง รหัสผ่านที่สร้างขึ้นแบบอัตโนมัติจะถูกส่งไปยังอีเมลของผู้ใช้หลังจากส่งออกข้อมูลสำเร็จ รหัสผ่านที่ป้อนด้วยตนเองจะไม่ถูกส่งไปยังอีเมลของผู้ใช้ ดังนั้นผู้ใช้จำเป็นต้องจำรหัสผ่านที่ป้อนด้วยตัวเอง หากคุณไม่ป้อนจะไม่มีรหัสผ่านตามค่าเริ่มต้น`,
"front-web-module-v1-detail-comment-proposal":``,
"label_partner_workspace_member_selectedpermission":`ชุดสิทธิ์ที่เลือก`,
"vue_label_helpcenter_view1":`ในมุมมอง lighting คุณสามารถดูและจัดการข้อมูลที่คุณสามารถเข้าถึงได้อย่างง่ายและยืดหยุ่น ฟังก์ชันพื้นฐาน เช่น มุมมองการจัดประเภทข้อมูล การแสดงข้อมูลหลายวิธี การเพิ่ม การแก้ไข และการลบข้อมูล และคุณยังสามารถดูรายงานและแผนภูมิเพื่อวิเคราะห์ข้อมูลเพิ่มเติมได้อย่างสะดวก <br>1. จัดการมุมมอง<br> ในเมนูแบบเลื่อนลงที่มุมซ้ายบนของมุมมอง เลือกมุมมองที่คุณต้องการดู และเลือกมุมมองเริ่มต้นผ่านการตั้งค่าคงที่ <br> ใช้เมนูควบคุมมุมมองรายการเพื่อสร้าง แก้ไข ลบ หรือจัดเรียงมุมมอง ขณะเดียวกัน คุณสามารถแก้ไขและสร้างมุมมองใหม่ได้อย่างรวดเร็วโดยใช้ฟังก์ชันตัวกรองที่ด้านบนขวา <br>2. ดูข้อมูลผ่านหลายมุมมอง<br> คุณสามารถดูข้อมูลได้หลายวิธี ที่มุมขวาบน คุณสามารถเปลี่ยนรายการ คัมบัง และแบ่งหน้าจอเพื่อดูข้อมูลได้<br> ในมุมมองรายการ ฟิลด์บางประเภทสามารถแก้ไขข้อมูลหนึ่งหรือหลายรายการได้โดยตรง คลิกสองครั้งที่เซลล์ที่ต้องการแก้ไข หรือคลิกปุ่มแก้ไข คุณสามารถแก้ไขข้อมูลได้โดยตรงในหน้าต่างป๊อปอัป หากคุณต้องการแก้ไขข้อมูลหลายรายการ คุณจะต้องเลือกข้อมูลเหล่านั้นแล้วเลือก "ใช้กับข้อมูลที่เลือก" ในหน้าต่างป๊อปอัปการแก้ไข <br> ในมุมมองรายการ คุณสามารถแก้ไขคอลัมน์ให้แสดงที่มุมซ้ายบนได้โดยตรง คลิกหัวตารางเพื่อจัดเรียง หรือเลือกคอลัมน์ที่จะล็อกผ่านหน้าต่างลอยแบบเลื่อนลง <br> หลังจากตั้งค่ามุมมองคัมบังแล้ว คุณสามารถดูข้อมูลเป็นกลุ่มและดูค่าสรุปของแต่ละกลุ่มได้ ในการตั้งค่ามุมมองคัมบัง คุณสามารถแก้ไขเกณฑ์การจัดกลุ่ม ข้อมูลสรุป และวิธีการสรุปของมุมมองคัมบัง โดยคุณเลือกฟิลด์ที่จะแสดงได้สูงสุดสี่ฟิลด์ คุณสามารถเปลี่ยนการจัดกลุ่มข้อมูลได้อย่างรวดเร็วด้วยการลากและวาง <br>`,
"component.task.label.priority":`ลำดับความสำคัญ`,
"label.datamanage.field.error":`เกิดข้อผิดพลาดในฟิลด์ออบเจ็กต์แบบสอบถาม`,
"label.console.step3":`ขั้นตอนที่ 3. เลือกแหล่งที่มาของภาพโลโก้คอนโซล`,
"label.ems.emailsyncsetup":`ตั้งค่าการซิงค์อีเมล`,
"label_tabpage_placeenterz":`โปรดระบุ`,
"label.getontocolumn":`ไปที่คอลัมน์:`,
"label.file.down.e":`ประเภทไฟล์ปัจจุบันไม่อนุญาตให้ดาวน์โหลด`,
"vue_label_notificationcenter_unreadonly":`แสดงเฉพาะยังไม่ได้อ่าน`,
"label.login.access.change":`เปลี่ยน`,
"label.globaloperation.operationtype.send_e-mail":`ส่งอีเมล`,
"label.dashboard.refresh.hint":`การรีเฟรชแดชบอร์ดจะเรียกใช้รายงานแหล่งที่มาทั้งหมดอีกครั้ง ดังนั้นจะต้องใช้เวลาพอสมควร ต้องการทำต่อหรือไม่?`,
"front-kefu-moudle-open-free":``,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`จัดการการสั่งซื้อผลิตภัณฑ์`,
"label.chatter.maturiyDate":`วันครบกำหนดไถ่ถอน`,
"message.mobilechooseatmostthree":`แท็บหน้ามือถือเลือกได้สูงสุดสามฟิลด์`,
"label.customfields.formula.tip":`ตามที่ฟิลด์แบบอ่านอย่างเดียวมีค่าแตกแขนงจากนิพจน์สูตรที่คุณกำหนด ถ้าแหล่งฟิลด์ใดมีการเปลี่ยนแปลง ฟิลด์สูตรนี้ก็จะได้รับการอัปเดต`,
"lable.PowerProcess.start.time":`โปรดเลือกเวลาเริ่มต้น`,
"label.mr.title.button.group2":`กลุ่มข้อมูลที่ซ้ำกันมีทั้งหมด`,
"label.atlantic.standard.time":`เวลามาตรฐานแอตแลนติก`,
"label.account.LengthofTime":`ระยะเวลา`,
"label.ccchat.message.search.desc2":`ข้อความของ`,
"label.pigeonhole.desc":`การเก็บไฟล์แนบถาวรจะใช้ได้เฉพาะกับไฟล์แนบที่ยังไม่ได้เก็บถาวรเท่านั้น <br/>เมื่อไฟล์แนบถูกเก็บถาวรแล้วจะไม่สามารถลบได้`,
"label.partnerCloud.orderingPlatform.sure":`การเปลี่ยน {alias} จะล้างตะกร้าสินค้า คุณแน่ใจหรือไม่?`,
"label.default.value.is.positive.integer":`ค่าเริ่มต้นต้องเป็นจำนวนเต็มบวก!`,
"label.partnerCloud.selectOne":`เลือกอย่างน้อยหนึ่งเมนู`,
"label.dashboard.more.condition":`เงื่อนไขเพิ่มเติม`,
"component.event.label.enddate":`*เวลาสิ้นสุด`,
"label.forecast.settings.type":`ประเภทการพยากรณ์`,
"com.cloudcc.login.error.message.licensenotstart":`สิทธิ์การใช้งานยังไม่เริ่มต้น`,
"lable.list.queue":`คิว`,
"label.mobile.app.isdisablum":`ห้ามเลือกรูปภาพจากอัลบั้มโทรศัพท์ขณะลงทะเบียนใช่หรือไม่`,
"label.service.gantt.filter":`เมื่อใช้การกรองทักษะ เฉพาะทรัพยากรที่มีทักษะที่เลือกเท่านั้นที่จะแสดงบนแผนภูมิแกนต์`,
"label.potentialcustomeronline":`ลีดออนไลน์`,
"label.campaignmember.main.deletecontactdesc":`ลบผู้ติดต่อทั้งหมดจากหลายแคมเปญพร้อมกัน`,
"label.list.desc1":`สร้างเพจ web ผ่านฟังก์ชั่น web to CloudCC เก็บข้อมูลไปยังระบบ CloudCC ผ่านการเข้า web`,
"label.generatepage.title.desc3":`ชื่อต้องเป็นชื่อเฉพาะและขึ้นต้นด้วยตัวอักษร มีได้เฉพาะตัวอักษรตัวพิมพ์ใหญ่ตัวพิมพ์เล็ก ตัวเลข ขีดล่าง และความยาวต้องไม่เกิน 30`,
"label.emailtocloudcc.step2total3":`ขั้นตอนที่ 2 จาก 3`,
"label.movablemenu":`ปุ่มแบบไดนามิก`,
"label.partnerCloud.partnerAccount.topUp":`เติมเงิน`,
"label.data.standobject":`ออบเจ็กต์มาตรฐาน`,
"label.frequency":`ความถี่`,
"label.schedulejob.setup.schedule.end":`สิ้นสุด`,
"label.chat.topic.following":`กำลังติดตาม`,
"label.martrixreport.2018.step2":`ขั้นตอนที่ 2: เลือกข้อมูลที่จะสรุป`,
"label.event.moveup.11hour":`ล่วงหน้า 11 ชั่วโมง`,
"label.forecast.customforecast.directorcommit":`ข้อผูกมัดของผู้ใต้บังคับบัญชาโดยตรง`,
"vue_label_homepage_card_view":`มุมมองการ์ด`,
"vue_labenl_applauncher_notice_closecertification":`ข้อมูลจะหายหลังปิด ยืนยันการปิดหรือไม่`,
"component_setup_button_weburl":`URL ภายนอก`,
"label_emailtocloudcc_button_addemailaddress":`เพิ่มอีเมลธุรกิจ`,
"vue_label_campaign_added_campaign_members":`การเพิ่มสมาชิกแคมเปญสำเร็จ`,
"label_tabpage_rtemptyz":`ชนิดบันทึกไม่สามารถว่างเปล่า`,
"label.martrixreport.2018.step5":`ขั้นตอนที่ 5: เลือกประเภทแผนภูมิและไฮไลต์รายงาน`,
"label.moverecord":`ย้ายบันทึก`,
"pagecreator_layout_label_layoutdesc":`คำอธิบายเค้าโครง`,
"label.knowledge.setting.data.nine":`ใช่ ฉันต้องการลบกลุ่มหมวดหมู่นี้และหมวดหมู่`,
"label.icon.90":`คน`,
"label.weixin.micro.research.name":`ชื่อไมโครรีเสิร์ช`,
"label.ccchat.micropost.allowedit":`อนุญาตให้ผู้ใช้แก้ไขโพสต์และแสดงความคิดเห็น`,
"vue_label_homepage_fixed_components":`ส่วนเสริมมาตรฐาน`,
"label.version.document":`ไลบรารีเอกสาร`,
"label_assessment":`การประเมิน (โอกาสทางธุรกิจ-ยอดเงิน)`,
"label.appupload.component.type.lookuplayout":`เค้าโครงการค้นหา`,
"label_chatter_loadmore":`โหลดเพิ่มเติม`,
"component_setup_tabs_label_memo":`ตั้งค่าชื่อป้ายกำกับTab`,
"label.icon.167":`เข็มทิศ`,
"vue_label_chatter_enter_content_sharing":`กรุณาป้อนเนื้อหาการแบ่งปันและกลุ่มการแบ่งปัน`,
"vue_label_notice_modify_success":`การแก้ไขสำเร็จ`,
"label.sharerules":`กฎการแบ่งปัน`,
"label.field.api.exists":`มีฟิลด์ API นี้แล้ว`,
"label.icon.83":`ทาสี`,
"label.file":`ไฟล์`,
"vue_label_report_foldernameisrequired":`ต้องระบุชื่อโฟลเดอร์`,
"label.emailobject.wizard.btn2":`เชื่อมต่อแล้ว ไปส่งอีเมล`,
"label.data.downpage.i_title.num3":`3. ก่อนนำเข้าโปรดตรวจสอบให้แน่ใจว่าได้นำเข้าบันทึกที่เกี่ยวข้องทั้งหมดแล้ว เช่น หากมีความสัมพันธ์การค้นหาระหว่างออบเจ็กต์ที่คุณกําลังนําเข้าและผู้ติดต่อ โปรดนำเข้าผู้ติดต่อเหล่านี้ก่อนแล้วจึงนำเข้าข้อมูลของคุณ`,
"label.email.original.content":`เนื้อหาต้นฉบับ`,
"vue_label_campaign_add_to_campaign":`เพิ่มลงในแคมเปญ`,
"label.dashboard.new":`แดชบอร์ดใหม่`,
"label.console.detail":`ดูคอนโซล`,
"label.view.desc":`เมื่อฟิลด์วันที่เท่ากัน คุณสามารถใช้ "เมื่อวาน", "วันนี้", "พรุ่งนี้", "เดือนที่แล้ว", "เดือนนี้", "เดือนหน้า", "สัปดาห์ที่แล้ว", "สัปดาห์นี้", "สัปดาห์หน้า "หรือรูปแบบ" YYYY-MM-DD, MM / DD / YYYY "`,
"label.emailobject.template.insert.continue":`เพิ่มต่อ`,
"label.notification.appointment.overlapEvent":`ช่วงเวลานี้ถูกจองแล้ว โปรดเลือกอีกครั้ง`,
"label.console.step6.top":`ตรึงที่ส่วนหัวจะเห็นรายการได้เสมอ`,
"label.data.file.the_trigger":`ดำเนินการทริกเกอร์`,
"message.report.error.operation":`การดำเนินการล้มเหลว โปรดตั้งค่ารายงานใหม่อีกครั้ง!`,
"vue_label_helpcenter_detail3":`<br> ถูกใจและเลิกถูกใจ<br> คุณสามารถกดถูกใจเวยเทียหรือความคิดเห็นของเวยเทีย หลังจากกดถูกใจ คุณสามารถดูจำนวนถูกใจของโพสต์ หรือจะเลิกถูกใจก็ได้ <br>แก้ไขและลบโพสต์<br> ผู้เผยแพร่โพสต์สามารถแก้ไขหรือลบโพสต์ <br> ขั้นตอนที่ 1: คลิกปุ่มทางด้านขวาของโพสต์ และเลือกแก้ไขหรือลบในช่องแบบดึงลง<br> ขั้นตอนที่ 2: เปิดหน้าต่างป๊อปอัปแก้ไข/ลบ<br> ขั้นตอนที่ 3: คลิกบันทึก /ยืนยันเพื่อเสร็จสิ้นการดำเนินการ<br> >5. ประวัติการอนุมัติ<br>ส่งเพื่อขออนุมัติ<br> เมื่อมีการสร้างบันทึกใหม่ เรียกคืนคำขออนุมัติ หรือคำขอถูกปฏิเสธขั้นสุดท้าย ปุ่ม "ส่งเพื่อขออนุมัติ" จะปรากฏขึ้น <br> ขั้นตอนที่ 1: คลิก "ส่งเพื่อขออนุมัติ" ระบบจะพิจารณาว่าบันทึกและผู้เสนอมีคุณสมบัติสอดคล้องกับรายการที่กำหนดโดยกระบวนการอนุมัติและเงื่อนไขของผู้เสนอตั้งต้นหรือไม่ หากสอดคล้องเงื่อนไขข้างต้น แสดงว่าการส่งสำเร็จ <br> หากขั้นตอนการอนุมัติถัดไปกำหนดค่าให้เลือกผู้อนุมัติด้วยตนเอง ให้ไปที่ขั้นตอนที่ 2 หลังจาก "ส่งเพื่อขออนุมัติ" <br> ขั้นตอนที่ 2: เลือกผู้อนุมัติรายถัดไปเพื่อเสร็จสิ้นการเสนอ <br>ประวัติการอนุมัติ<br> A. ก่อนส่ง: <br> คลิก "แสดงตัวอย่างขั้นตอนการอนุมัติ" ระบบจะพิจารณาว่าบันทึกและผู้เสนอมีคุณสมบัติสอดคล้องกับรายการที่กำหนดโดยกระบวนการอนุมัติและเงื่อนไขของผู้เสนอตั้งต้นหรือไม่ หากสอดคล้องเงื่อนไขข้างต้น กระบวนการอนุมัติจะปรากฏขึ้น <br> B. หลังจากส่ง: <br> ในประวัติการอนุมัติ คุณไม่เพียงแต่สามารถดูขั้นตอนประวัติการอนุมัติและสถานะการอนุมัติปัจจุบันของบันทึกเท่านั้น แต่ยังแสดงตัวอย่างกระบวนการอนุมัติถัดไปอีกด้วย <br>เรียกคืนคำขออนุมัติ<br> หากกระบวนการอนุมัติถูกตั้งค่าให้เรียกคืนคำขออนุมัติ คุณสามารถยกเลิกได้ตลอดเวลาหลังจากที่คุณส่ง <br> ขั้นตอนที่ 1: คลิก "เรียกคืนคำขออนุมัติ" ในหน้ารายละเอียดบันทึก <br> ขั้นตอนที่ 2: เปิดหน้าคำขออนุมัติการเรียกคืน คลิก "เรียกคืนคำขออนุมัติ" เพื่อเสร็จสิ้น`,
"Opportunity_Detailed_Phase_Label_004":`วัน`,
"PageLayout_Search_MultiSearch_001":`คุณเลือกได้มากที่สุด 3 ฟิลด์เท่านั้น`,
"vue_label_systemSettings_set_business":``,
"label.compact.layout.frame.select":`โปรดเลือกกรอบเค้าโครงเพจ`,
"label.tabpage.rolez":`บทบาท`,
"label.weixin.appr.currentauditor":`ผู้ได้รับมอบหมาย`,
"label.knowledgebase.verification.status":`สถานะการยืนยัน`,
"UG_Case_05":`สร้างเคส`,
"label.service.marking.completed":`ติดป้ายเสร็จแล้ว`,
"label.notification.ccchat1":`[ชื่อผู้ใช้ที่ @] กล่าวถึงคุณ`,
"label.knowledgebase.no.action.available":`ไม่มีการดำเนินการใดๆ`,
"label.tabpage.newlybuildz":`แหล่งข้อมูลรายงานที่กำหนดเองใหม่`,
"label.appupload.install.error.choice2":`เปลี่ยนชื่อส่วนเสริมที่ขัดแย้งกับโปรแกรมสำเร็จรูป`,
"label_tabpage_as":`เช่น`,
"Opportunity.Detailed.Phase.Label.Popup.001":`ใส่วันที่`,
"vue_label_homepage_singlepage":`เพิ่มส่วนเสริมได้มากสุด 10 รายการต่อหน้า`,
"font-evaluate-module-v1-fair-and-bad":``,
"label.partnerCloud.orderingPlatform.orderInformation":`ยืนยันข้อมูลการสั่งซื้อ`,
"label.custom.lead.conversion.notice":`แจ้งเตือนการข้ามสเตจของลีด`,
"label.re.upload":`อัปโหลดใหม่`,
"label.knowledgebase.top.window":`หน้าต่างบนสุด`,
"label.h5.allmarkedasread":`ทำเครื่องหมายว่าอ่านแล้วทั้งหมด`,
"vue_label_SMS_open_record_from_start_activation":`เปิดบันทึกจากรายการเพื่อเริ่มใช้งาน`,
"label.customer.tab.step2":`ขั้นตอนที่ 2: เพิ่มลงในโปรไฟล์`,
"label.campaign.channel.input.owner.select2":`เชิญโดยใช้ช่องทางการขายนี้`,
"component.task.button.save":`บันทึก`,
"front-kefu-moudle-v1-phone-type":``,
"label.wedge-shapearrows":`ลูกศรหางลิ่ม`,
"vue_label_homepage_todaysevent":`อิเวนต์วันนี้`,
"label.data.exp.way.sel":`เลือกวิธีการส่งออก`,
"label.setting.intergrationlist.status1":`ยังไม่ได้ติดตั้งการเชื่อมต่อนี้`,
"button_partner_workspace_disable":`ปิดการใช้งาน`,
"label.customfields.reference":`อาจถูกอ้างอิงโดยฟิลด์อื่นๆ เช่น สูตร รายการตัวเลือก การค้นหา เป็นต้น`,
"label.publicgroups.new":`กลุ่มสาธารณะใหม่`,
"label.data.setok.e_desc3":`ดาวน์โหลดข้อมูลที่คุณส่งออก`,
"vue_label_commonobjects_view_chart_countmode":`วิธีการรวม`,
"label.service.appointmentList.earliest.allowedStart":`เวลาเริ่มต้นที่อนุญาตเร็วที่สุด`,
"label.data.choses.e.desc":`สามารถเลือกส่งออกข้อมูลทั้งหมดหรือเลือกส่งออกข้อมูลออบเจ็กต์เดียวได้ตามความต้องการของคุณ`,
"label.multilang.common.fieldlist.fieldremark":`ใช้กับฟิลด์ที่แสดงในหน้า{0}`,
"label.umeng.activity.event":`อิเวนต์`,
"label.project.hit.ten":`แจ้งเตือนการอัปเดตปัญหา`,
"label.c_d_least":`บันทึก C" แต่ละบันทึก ต้องมีความสัมพันธ์กับบันทึก "D" อย่างน้อยหนึ่งรายการ`,
"label.emailobject.wizard.btn1":`เชื่อมต่ออีเมลส่วนตัว`,
"lable.product.pricebooks.info":`รายละเอียดสมุดราคา`,
"component_telerecord_label_message":`ฝากข้อความ`,
"lable.total.of.estimates":`รวม 0 ประมาณการ`,
"label.stdashbord.xsld.business.oppcounts":`จำนวนโอกาส`,
"vue_label_commonobject_duplicatewith":`{1}ซ้ำกับ{0}`,
"label.setpicandreport":`ตั้งค่าแผนภูมิ`,
"label.category.2":`ทั่วไป`,
"label.emailtocloudcc.reauthorization":`ให้สิทธิ์อีกครั้ง`,
"label.chatter.vote":`โหวต`,
"label_emailtocloudcc_edit":`แก้ไข`,
"label.pleaseinput":`ป้อน`,
"vue_label_homepage_user_particular_application":`หน้าแรกที่ใช้เมื่อผู้ใช้ใช้แอปพลิเคชันหนึ่งใดเหล่านี้จะแทนที่หน้าแรกมาตรฐาน`,
"label.allianceID":`ID พันธมิตร`,
"label.h5.homepage.cannot.applied.mobile.terminal":``,
"label.appointmentpage.wizard.notif2":`กรุณากรอกชื่อ`,
"label_emailsync_status_email":`อีเมล`,
"label.icon.179":`คน`,
"UG_Contract_03":`สร้างสัญญา`,
"label.cy.new":`สกุลเงินใหม่`,
"label.version.setup.controllist":`รายการควบคุมการตั้งค่าหลังบ้าน`,
"label.vlidaterule":`เกณฑ์การทวนสอบ`,
"label.customer.tab.name":`ชื่อแท็บ`,
"label.recentview.seloption1":`ที่ฉันดูล่าสุด`,
"vue_label_report_notice_nameisrequired":`จำเป็นต้องระบุชื่อรายงาน`,
"label.createapproveprocessstep":`<li>1. อ่านหัวข้อช่วยเหลือ </li> <li> 2. สร้างแม่แบบอีเมล </li> <li> 3. สร้างแม่แบบข้อความสั้น </li> <li> 4. ใช้ตัวช่วยสร้างทันใจหรือตัวช่วยสร้างมาตรฐานสร้างกระบวนการอนุมัติ</ li> <li> 5. เพิ่มรายการประวัติการอนุมัติที่เกี่ยวข้องให้กับเค้าโครงเพจทั้งหมด </li> <li> 6. เปิดใช้งานกระบวนการและปรับใช้กับผู้ใช้ </li>`,
"label.gotocalendar":`ไปที่ปฏิทิน`,
"label.import.page1.pleaseselectobj":`โปรดเลือกออบเจ็กต์ก่อน`,
"label_tabpage_messagez":`กรุณาใส่ความคิดเห็น`,
"vue_label_homepage_profilepage":`หน้าแรกโปรไฟล์`,
"label.tabpage.choose":`เลือก`,
"label.campaignmember.setup.lead.field":`ฟิลด์ลีด`,
"label.setalipay.null":`ข้อมูลที่จำเป็นในการกำหนดค่าอาลีเพย์ว่างเปล่า`,
"label.custom.Current.and.NextCQ":`ไตรมาสที่กําหนดเองนี้และถัดไป`,
"label.knowledgebase.needto.publish.articles":`การเรียกคืนบทความที่เก็บถาวรจะสร้างเวอร์ชันฉบับร่าง คุณต้องการเผยแพร่บทความเพื่อให้พร้อมใช้งานหรือไม่`,
"pagecreator.layout.message.save.success":`การบันทึกเค้าโครงสำเร็จ`,
"homepage.componet.approval.label":`ศูนย์การอนุมัติ`,
"label.last_submission":`เวลาส่งล่าสุด`,
"lable.outlook.detail.prefo":`เลือก Exchange ก่อน`,
"label.projectManagement.new.subtask":`งานย่อยใหม่`,
"label.service.appointmentList.checkThe":`เลือก`,
"message.error.searchlayoutselectdefields":`ไม่สามารถลบได้ และต้องเป็นฟิลด์แรกในเค้าโครงการค้นหา`,
"label.ems.normal":`ปกติ`,
"vue_label_notice_pleaseselectobject":`โปรดเลือกออบเจ็กต์`,
"component.sendmail.button.send":`ส่ง`,
"label.relevant.records":`บันทึกที่เกี่ยวข้อง`,
"label.weixin.login.CloudCC":`เข้าสู่ระบบ CloudCC`,
"label.tag.addtags.private":`เอกชน`,
"label.appointment.disable.remark":`ขออภัย ฟังก์ชันนี้ถูกปิดใช้งาน หากคุณต้องการยกเลิกหรือนัดหมายอีกครั้ง โปรดติดต่อผู้รับผิดชอบของคุณทางอีเมล: {ที่อยู่อีเมล}`,
"label.campaignmember.main.addMember1":`เพิ่มสมาชิก`,
"message.error.objectnofound":`ไม่ได้กำหนดออบเจ็กต์`,
"label.employeenum":`หมายเลขพนักงาน`,
"label.search.applyfilter":`ปรับใช้ตัวกรอง`,
"label.version.history.track.nonsupport":`เฉพาะรุ่นอันลิมิเต็ดเท่านั้นที่รองรับฟังก์ชันประวัติการติดตามฟิลด์`,
"label.ccpeak.direction.for.use.time":`คู่มือการใช้คลาสตัวจับเวลาของแพลตฟอร์ม CloudCC [รุ่น 2.0]`,
"label.ems.settings":`การตั้งค่า`,
"label_tabpage_arecordtypez":`ชนิดบันทึกพร้อมใช้งาน`,
"vue_label_pool_assign1":`{0}{1}`,
"label.customcomponent.direction.for.use":`คู่มือการใช้งานสำหรับส่วนเสริมที่กำหนดเองของแพลตฟอร์ม [รุ่น 2.0]`,
"label.appupload.appname":`ชื่อโปรแกรมสำเร็จรูป`,
"label.cpq.order.status.no.active":`เฉพาะใบสั่งซื้อที่มีสถานะเปิดใช้งานเท่านั้นที่สามารถสร้างสัญญาได้`,
"label.dashboard.maxlength":`กรุณาใส่อักขระไม่เกิน 255 ตัว`,
"label.customize.memory.function.sorting.title2":`หน่วยความจำการจัดเรียงส่วนหัว`,
"label.report.chose.obj":`เลือกความสัมพันธ์ของออบเจ็กต์และแหล่งข้อมูลรายงาน`,
"label.partner.step3":`ขั้นตอนที่ 3: ข้อมูลพื้นฐาน`,
"message.report.type.error.fail":`แหล่งข้อมูลรายงานผิดพลาด!`,
"pagecreator.page.message.publish.fail":`การเผยแพร่หน้าเพจล้มเหลว`,
"label.minimun":`ค่าต่ำสุด`,
"label.state":`สถานะ`,
"label.customcomponent.referencetype":`ชนิดการอ้างอิง`,
"label.nameandemailtemplate":`ใส่ชื่อขั้นตอนในช่องด้านล่าง หลังจากนั้นเลือกหนึ่งแม่แบบอีเมลสำหรับแจ้งผู้อนุมัติ (ตัวเลือก)`,
"label.customobjects.track.introduce":`หน้านี้อนุญาตให้คุณสามารถเลือกที่จะ    ที่`,
"label.campaign.matchway.label":`วิธีการจับคู่:`,
"label.redistribution":`มอบหมายใหม่`,
"label.groupmanage":`การจัดการกลุ่ม`,
"label.icon.157":`เว็บแคม`,
"label.quickbooks.viewlist.total":`ทั้งหมด`,
"label.file.copy.file.fail":`การคัดลอกล้มเหลว โปรดคัดลอกด้วยตนเอง`,
"label.outline.selectfield":`สรุปฟิลด์ที่เลือก：`,
"label.datetime.maxsize":`ช่วงการสืบค้นต้องไม่เกิน 3 เดือน`,
"label.dashboard.CustomDashboardMyHomePage":`ปรับแต่งแดชบอร์ดหน้าแรกของฉัน`,
"label.data.customobject":`ออบเจ็กต์ที่กำหนดเอง`,
"vue_label_SMS_noselected":`บันทึกที่ไม่ได้เลือก`,
"label_tabpage_value":`ค่า`,
"label.quote.qianming":`เซ็นชื่อ`,
"label.view.source":`ดูรหัสต้นฉบับ`,
"label_popup_infoz":`แจ้งเตือน`,
"label.emailtocloudcc.redmessage8":`พารามิเตอร์ไม่ถูกต้อง โปรดติดต่อผู้ดูแลระบบ`,
"label.tianyancha.Search.business":`ค้นหาข้อมูลการจดทะเบียนธุรกิจ`,
"vue_label_systemSettings_server":`บริการ`,
"vue_label_homepage_dashboard_components":`ส่วนเสริมแดชบอร์ด`,
"label.search.listview":`มุมมองรายการ`,
"label.service.gantt.distribution.success":`มอบหมายสำเร็จ`,
"label.icon.4":`กระเป๋าสตางค์`,
"label.partnerCloud.orderingPlatform.calculate":`คํานวณราคา`,
"label.forecast.edittotal.ycyx":`พยากรณ์ก่อน`,
"vue_label_commonobjects_detail_to_precise_search":`ไปยังการค้นหาแบบแม่นยํา`,
"label.order.number":`หมายเลขคำสั่งซื้อ`,
"setup.mainpage.label.welcome7":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้→การตั้งค่าแอปพลิเคชัน→สร้าง→ออบเจ็กต์→ชื่อออบเจ็กต์→ฟิลด์ที่กำหนดเอง`,
"label.weixin.user.binding":`การผูกผู้ใช้`,
"label.custom.canvas.size":`ขนาดแคนวาส`,
"label.projectManagement.recent.projects":`โครงการล่าสุด`,
"vue_label_helpcenter_lead":`จัดการลีดของคุณด้วยการติดตาม Cloud CC ใช้เกณฑ์ที่กําหนดค่าไว้เพื่อให้คะแนน มอบหมาย และเปลี่ยนลีดเป็นลูกค้า ผู้ติดต่อ และโอกาสทางธุรกิจที่สอดคล้องกันในเวลาที่เหมาะสม <br>การให้คะแนน<br>ให้คะแนนลีดได้ในมุมมองนี้ด้วยปุ่มการให้คะแนนแบบกลุ่มที่มุมขวาบนของมุมมอง  <br>การมอบหมาย<br>เมื่อสร้างหรือแก้ไขลีด ให้เลือกการมอบหมายที่ด้านล่างของหน้า เพื่อมอบหมายลีดให้กับบุคคลที่เหมาะสมตามเกณฑ์ที่มีอยู่ <br>การข้ามสเตจ<br> ในเวลาที่เหมาะสม คุณสามารถเปลี่ยนลีดให้เป็นลูกค้าและผู้ติดต่อได้โดยคลิกที่ปุ่ม การข้ามสเตจที่มุมขวาบนของหน้ารายละเอียด และสามารถสร้างโอกาสทางธุรกิจและภารกิจที่เกี่ยวข้องเพื่อสะดวกต่อการติดตามโอกาสทางการค้าได้อย่างต่อเนื่อง`,
"label.enabledprocess":`เปิดใช้กระบวนการอนุมัติแล้ว`,
"label.emailobject.noemail":`ยังไม่มีอีเมล รีบไปส่งสักฉบับเลย!`,
"label.validate.remark3":`กำหนดเงื่อนไขว่าฟิลด์จะต้องยึดตามค่าของฟิลด์อื่นหรือไม่`,
"vue_label_salesadvance_retention":`การรักษาสายสัมพันธ์`,
"label.product.managep":`จัดการสมุดราคา`,
"font-evaluate-module-v1-not-report":``,
"label.emailmerge.mergepage.step1":`1. เลือกบันทึกที่จะผสาน:`,
"front-epwechat-module-v1-epwechat-describe":`CloudCC มอบความสามารถในการผสานรวมวีแชทขององค์กร ด้วยการรวมฟังก์ชันอันทรงพลังของวีแชทองค์กรเข้ากับระบบ CloudCC รุ่น H5 ที่มีน้ำหนักเบา<br/> เพื่อช่วยให้คุณจัดการความสัมพันธ์กับลูกค้าได้อย่างสะดวก ดำเนินการทราฟฟิกโดเมนส่วนตัว และเพิ่มความสามารถในการสร้างรายได้ขององค์กร`,
"label.partner.template.detailimage":`ภาพรายละเอียด`,
"label.recycle.clearall":`ล้างถังขยะรีไซเคิลขององค์กร`,
"chatter.error.nottype":`ข้อผิดพลาด: ประเภทไฟล์ไม่ถูกต้อง ประเภทไฟล์ที่สามารถอัปโหลดได้คือ JPG GID และPNG!`,
"pagecreator.button.cancel":`ยกเลิก`,
"front-market-form-quired-ziduan":``,
"vue_label_report_columnname":`ชื่อคอลัมน์`,
"message.notdelete.type":`ไม่สามารถลบชนิดบันทึกนี้ได้เนื่องจากโปรไฟล์ต่อไปนี้ใช้เป็นค่าเริ่มต้น`,
"label.ccpeak.folder.all.time":`โฟลเดอร์คลาสตัวจับเวลาทั้งหมด`,
"label.quickbooks.searchlist.total3":`พบบันทึกประมาณการ {0} รายการที่ไม่ได้เชื่อมโยง ยอดรวมคือ {1}`,
"label.forecast.detailforecast.quantity":`การพยากรณ์เชิงปริมาณ`,
"label.knowledge.language.british":`ภาษาอังกฤษแบบบริติช`,
"label.vlidaterule.example.messagelocation":`ข้อความแสดงข้อผิดพลาดสามารถปรากฎที่ด้านบนของหน้าหรือด้านล่างฟิลด์เฉพาะในหน้า`,
"front-kefu-moudle-chf-success":``,
"vue_label_jihui_yi":`โอกาสที่ 1`,
"label.import.step1.null":`ไม่มีตัวเลือก`,
"label.console.step5.tab.subtab":`เป็นแท็บรอง`,
"batch.edit.permission":`ไม่มีสิทธิ์แก้ไข`,
"label.weixin.fmu.before.min":`ล่วงหน้า {0} นาที`,
"chatter.up.file":`การอัปโหลดไฟล์อาจใช้เวลาสักครู่ขึ้นอยู่กับขนาดไฟล์ โปรดรอเพื่ออัปโหลด`,
"setup.layout.group.field":`ฟิลด์`,
"label.chat.unlike":`เลิกถูกใจ`,
"vue_label_dashboard_updatefrequency":`อัปเดตความถี่`,
"label.trigger.folder.new":`หน้าทริกเกอร์: สร้างโฟลเดอร์`,
"label.process.des.app":`หากต้องการดูรายละเอียดของบันทึกปัจจุบัน ให้คลิกลิงก์ทางด้านขวาเพื่อเข้าชม`,
"vue_label_pool_assignselect":`เลือกกำหนดสมาชิก`,
"label.lookup.user":`ค้นหาผู้ใช้`,
"label.mobilescreentablayoutedit.remark2":`เลือกฟิลด์ที่จะแสดงในหน้าเพจเมนูของโทรศัพท์มือถือ`,
"label.data.exp.objtemp":`คุณจะสร้างแม่แบบสำหรับการส่งออกออบเจ็กต์นี้ตามเงื่อนไขต่อไปนี้`,
"label.weixin.moreselect.error":`สามารถเลือกบันทึกได้เพียง 10 รายการ`,
"label.icon.25":`ทำแผล`,
"lable.sample.text":`ข้อความตัวอย่าง`,
"label.most.setup.obj":`ตั้งค่าออบเจ็กต์ได้มากที่สุด 10 รายการ`,
"label.weixin.coming":`กำลังมา`,
"label.editdescription":`แก้ไขหมายเหตุ`,
"label.multipleactivity.multiple":`ผู้ใช้หลายคน`,
"label.sso.saml.idp.entityid":`ID เอนทิตี้`,
"label.SMS.pho.filed":`ฟิลด์โทรศัพท์`,
"message.serviceabsence.violation":`การละเมิดเวลาในการจัดส่ง: ขัดแย้งกับบันทึกการขาดงานในรอบเวลานี้`,
"label.forecast.settings.type.clist":`ใช้สายผลิตภัณฑ์`,
"label.state.noend":`ยังไม่จบ`,
"label.sourcetemp":`แม่แบบการแปลแหล่งที่มา`,
"vue_label_chatter_name_link":`กรุณากรอกชื่อและลิงก์`,
"label.emailobject.attach":`เพิ่มไฟล์แนบ`,
"label.everyother":`ทุก`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`ยังไม่ได้เปิดบัญชีสนทนา ต้องการเปิดบัญชีทันนี้หรือไม่?`,
"pagecreator_layout_button_delete":`ลบเค้าโครง`,
"label.transfer.temporarily":`โอน`,
"label.service.dispatchingUnits.search.services":`ค้นหาการนัดหมายการบริการ`,
"customer.message.fail.chat":``,
"label.apiname.toolong":`ชื่อ Api ยาวเกินไป`,
"label.empty.filter":`ล้างตัวกรอง`,
"label_tabpage_personalCenterz":`ศูนย์ส่วนบุคคล`,
"label.minutes":`นาที`,
"label.multipleactivity.atasks":`ภารกิจ`,
"label_tabpage_deleteview":`ลบมุมมอง`,
"pagecreator_layout_message_save_success":`การบันทึกเค้าโครงสำเร็จ`,
"label.reportlineorder":`เรียงลำดับคอลัมน์รายงาน`,
"label.total.forecast.have.priority":`การพยาการณ์ใดๆ ก่อน แต่ยอมรับการพยากรณ์ของผู้ใต้บังคับบัญชาคนอื่นๆ ก่อน`,
"label.custom.quarter.subtitle":`ไตรมาสที่กำหนดเอง`,
"label.icon.79":`พิมพ์`,
"label.hiddenoperate":`ปฏิบัติการที่ซ่อนอยู่`,
"label.project.hit.six":`แจ้งเตือนการมอบหมายงานโครงการ`,
"label.visualpageaction.errordesc":`คุณไม่มีสิทธิ์เพียงพอที่จะดำเนินการตามที่ร้องขอ หากต้องการเข้าถึง โปรดติดต่อเจ้าของบันทึกหรือผู้ดูแลระบบ`,
"label.chat.unmute":`ยกเลิกปิดการแจ้งเตือน`,
"label.zhaiyao":`บทคัดย่อ`,
"vue_label_commonobjects_detail_bcc":`สำเนาลับ`,
"label.customcomponent.page.index.table.version":`รุ่น API`,
"UG.quota.06":`สร้างใบเสนอราคา`,
"label.icon.152":`หุ่นยนต์`,
"label.partnerCloud.partnerAccount.account":``,
"label.file.sharewith":`ผู้แบ่งปัน`,
"label.data.dataexptemplate.desc2":`2. รูปแบบการบีบอัดสำหรับการส่งออกมีสองประเภท: ประเภทที่หนึ่งสร้างรหัสผ่านไฟล์บีบอัดโดยอัตโนมัติ รหัสผ่านที่สร้างโดยอัตโนมัติจะถูกส่งไปที่อีเมลผู้ใช้หลังจากนำออกข้อมูลสำเร็จ；อีกประเภทหนึ่งคือใส่รหัสผ่านไฟล์บีบอัดด้วยตนเอง รหัสผ่านที่ใส่ด้วยตนเองจะไม่สามารถส่งไปที่อีเมลผู้ใช้ได้ ดังนั้นลูกค้าจำเป็นต้องจำรหัสผ่านที่ใส่เอง หากไม่ระบุจะไม่มีรหัสผ่านค่าเริ่มต้น`,
"vue_label_dashboard_newfoldersuccessfully":`โฟลเดอร์ใหม่สำเร็จ`,
"label.campaignmember.main.importmember":`นำเข้าสมาชิกแคมเปญแบบกลุ่ม`,
"label.htyj.completed":`สำเร็จแล้ว`,
"label.reportTypeLabel":`ป้ายกำกับรายงาน`,
"label.customer.tab.label":`ป้ายกำกับแท็บ`,
"label.dashboard.component":`ส่วนเสริม`,
"label.safetystatement.dialog":`ประกาศด้านความปลอดภัย (หน้าต่างใหม่)`,
"label.forecast.settings.data":`วันที่พยากรณ์`,
"label.knowledgebase.modifiedby":`ผู้แก้ไข`,
"label.batchadd.remark":`สามารถเพิ่มบันทึกได้หลายรายการ`,
"button.partner.delete":`ลบ`,
"Pagelayout_Setup_005":`ชื่อต้องวางไว้ตำแหน่งแรกสุด`,
"label.forecast.edit.wcpxl":`ไม่มีสายผลิตภัณฑ์`,
"lable.PowerProcess.seq.input":`กรุณาใส่ลําดับ`,
"pagecreator.layout.message.delete.fail":`การลบเค้าโครงล้มเหลว`,
"label.emailobject.edit":`แก้ไข`,
"label.weixin.million":`หมื่นหยวน`,
"setup.mainpage.button.manageobject":`การจัดการออบเจ็กต์`,
"label.weixin.participants.perfect.information":`ต้องการให้ผู้เข้าร่วมกรอกข้อมูลเพิ่มเติมหรือไม่`,
"vue_label_campaign_campaign_members":`เพิ่มสมาชิกแคมเปญ`,
"label.ccchat.person.invite.emplaceholder":`ใส่ที่อยู่อีเมลโดยใช้เครื่องหมายอัฒภาคคั่นแต่ละที่อยู่อีเมล`,
"label.mobile.phone.new":`เพิ่มใหม่`,
"font-evaluate-module-v1-small-program-evaluation-settings":``,
"UG.opportunity.005":`กระบวนการขายมากมาย`,
"vue_label_report_polymerization":`รวมตัวกัน`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`เงื่อนไขของแถวที่ {0} ไม่ถูกต้อง  ประเภทฟิลด์ไม่ตรงกัน！`,
"label.knowledgebase.delete.draft":`ลบฉบับร่าง？`,
"label.mr.descreption.condition3":`กฏ-ใช่คู่ที่เหมือนกันหรือไม่ เลือกตัวเลือกนี้เพื่อสืบค้นข้อมูลซ้ำตามข้อมูลที่เหมือนกันของฟิลด์ หลังจากเลือกตัวเลือกนี้ การป้อนอักขระกี่ตัวแรกจะล้มเหลว`,
"Lead.Auto.Scoring.Setting":`การตั้งค่าการให้คะแนนลีดแบบอัตโนมัติ`,
"label.marketing.channel.default":``,
"front-project-module-v1-select-projecttemplate":`เลือกแม่แบบโครงการ`,
"front-email-payment-select-area":``,
"lable.PowerProcess.message":`ข้อมูลกระบวนการให้สิทธิ์`,
"label.weixin.free.get.captcha":`รับรหัสยืนยันฟรี`,
"label.projectManagement.please.select.task.or.question":`โปรดเลือกงาน/ปัญหา`,
"label.pacific.daylight.time":`เวลาออมแสงมหาสมุทรแปซิฟิก`,
"label.sendsms.batch.step1.introduce":`เลือกมุมมองใดมุมมองหนึ่งต่อไปนี้ (ซึ่งมีผู้รับข้อความสั้นนี้)`,
"label.same.analyze.account.name":`ชื่อลูกค้า`,
"Homepage.Contract.FieldMissed.DoesntSupport":`ไม่พบฟิลด์ "qdrq" และ "htje" ในออบเจ็กต์สัญญา และแสดงข้อมูลไม่ได้`,
"label.partnerCloud.orderingPlatform.noProduct":`ขณะนี้ผลิตภัณฑ์ไม่มีตัวเลือกผลิตภัณฑ์ที่จะกําหนดค่า`,
"label.totalsummary":`ยอดรวมสะสม`,
"label.partner.workspace.tab":`แท็บ`,
"label.entitlement.process.name.unique":`มีชื่ออยู่แล้ว กรุณากรอกใหม่อีกครั้ง`,
"report.label.norole":`คุณไม่มีสิทธิ์นี้ โปรดติดต่อผู้ดูแลระบบ!`,
"label.password.old.error":`รหัสผ่านเก่าไม่ถูกต้อง`,
"lable.account.quarter.stadate":`วันที่เริ่มต้นไตรมาสบัญชี`,
"label.salescloud.contactrole.choose.correct":`ผู้ติดต่อที่ซ้ำกัน กรุณาแก้ไข`,
"label.schedulejob.setup.schedule.day":`วัน`,
"label.communalusergroup":`กลุ่มผู้ใช้สาธารณะ`,
"label.Display.Fields":`ฟิลด์ที่จะแสดงในรายการการนัดหมายบริการ`,
"label.marketsea":`ฐานข้อมูล`,
"label_partner_setup_address":`ที่อยู่พาร์ทเนอร์คลาวด์`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`การส่งออกข้อมูลและการสร้างแม่แบบ`,
"label.pc.ui.2018":`แท็บแนวตั้ง`,
"label.version.free":`รุ่นสำหรับใช้ฟรี`,
"label.dataimport.contact.length":`เกิดข้อผิดพลาด: ชื่อผู้ติดต่อยาวเกินไป`,
"label.cy.vlidate":`หลังการเปิดใช้สกุลเงินจะย้อนกลับไม่ได้ คุณยืนยันจะเปิดใช้ฟังก์ชันการจัดการสกุลเงินหรือไม่?`,
"label.recycle.all":`ถังขยะรีไซเคิลทั้งหมด`,
"label.message.changeaccount.isnot":`ผู้ติดต่อถูกเปิดใช้งานในฐานะผู้ใช้พาร์ทเนอร์และไม่สามารถเปลี่ยนแปลงข้อมูลลูกค้าได้`,
"label.searchlayout.exactsearch":`คำเตือน: การทำเครื่องหมายที่ช่องหลังฟิลด์ค้นหาจะทำให้ฟิลด์ค้นหาแบบแม่นยำ`,
"label.file.size.limit":`หมายเหตุ: อนุญาตให้ใช้ไฟล์ได้สูงสุด 10M`,
"label.mobileapp.modelsetting1":`การตั้งค่าโมดูลฟังก์ชันมาตรฐานสำหรับอุปกรณ์มือถือ`,
"template.report.overall.sales.opportunities":`ระยะเวลาการขายโดยรวม (ตามประเภทโอกาสทางธุรกิจ)`,
"label.password.update.success":`การเปลี่ยนรหัสผ่านสำเร็จ!`,
"label.import.page3.gobackhome":`กลับไปที่หน้าแรก`,
"label.phone":`โทรศัพท์`,
"label.detail.vlidaterule":`ดูเกณฑ์การทวนสอบ`,
"label.weixin.input.usernames":`กรุณาใส่ชื่อผู้ใช้`,
"label.icon.85":`หม้อแปลงไฟฟ้า`,
"vue_label_systemSettings_partner":`พาร์ทเนอร์`,
"label.processsetting.new.process":`กระบวนการใหม่`,
"Lead_Scoring_Setting_Rule_Setup_01":`รายการเกณฑ์การให้คะแนนลีด`,
"setup.layout.component.area":`พื้นที่`,
"label.createnewpwdinformuser":`สร้างรหัสผ่านใหม่และแจ้งให้ผู้ใช้ทราบทันที`,
"label.pwinfo":`ข้อมูลรหัสผ่าน`,
"label.imgfield.type.url":`อ้างอิงรูปภาพ`,
"label.attendance.sxccheckincy":`สมาชิกแคมเปญลงทะเบียนเข้า`,
"lable.PowerProcess.condition.input":`โปรดเลือกเงื่อนไข`,
"label.partnerCloud.partnerAccount.topUpFailure":`เติมเงินล้มเหลว`,
"label.document.size.too.long":`ขนาดเอกสารเกินกำหนด`,
"label.link":`ลิงก์`,
"label.partnerproduct.sort.repeat":`ชื่อสายผลิตภัณฑ์ซ้ำ`,
"label.data.setok.e_desc2":`หน้ารายการข้อมูลส่งออก`,
"front-project-module-v1-plase-input-project-name":`กรุณาใส่ชื่อโครงการ`,
"label.export":`ส่ง&nbsp;&nbsp;ออก`,
"label.icon.45":`หม้อไอน้ำ`,
"label.autoRegister.changepwd.title":`ตั้งรหัสผ่านเข้าสู่ระบบของคุณ`,
"label_clear_adjust":`ล้างการปรับ`,
"front-kefu-moudle-return-visit":``,
"label.ems.compose":`เขียนอีเมล`,
"Pagelayout_Setup_002":`คุณเลือกรายการที่เกี่ยวข้องแล้ว 3 รายการ หากยังเลือกอีกจะส่งผลต่อเค้าโครงเพจ`,
"label.service.gantt.skill.screening":`ใช้การกรองทักษะ`,
"label.partnerCloud.basicSetting.enable":`เมื่อคุณปิดการใช้งานระบบคลาวด์พาร์ทเนอร์ ระบบจะปิดการเข้าสู่ระบบคลาวด์พาร์ทเนอร์และฟังก์ชันการปรับเปลี่ยนใหม่ขององค์กรคุณโดยอัตโนมัติ!`,
"label.workbanch.setup.description":`คุณสามารถตั้งค่าว่าจะแสดงมุมมองต่อไปนี้ในเวิร์คแบนซ์ของฉันหรือไม่`,
"label.category.1":`ทั้งหมด`,
"label.foldername":`ชื่อโฟลเดอร์`,
"label.forecast.settings.shuliang":`พยากรณ์ปริมาณ`,
"label.emailmerge.newtemplate.word":`กรุณาอัปโหลดไฟล์ word!`,
"message.error.type":`type ต้องไม่ว่างเปล่า ต้องผ่าน public ประเภทสาธารณะ หรือ พนักงาน private！`,
"label.manualallocation":`จัดสรรด้วยตนเอง`,
"label.addattachment.step2":`ขั้นตอนที่ 3. คลิกปุ่ม "อัปโหลดไฟล์" เพื่ออัปโหลดไฟล์`,
"label.company":`บริษัท`,
"label_emailsync_status_export":`ส่งออกเป็นไฟล์รูปแบบ Excel_csv`,
"label.eventreminder":`การแจ้งเตือนอิเวนต์`,
"label.emailtemplate.lookup":`ค้นหาแม่แบบอีเมล`,
"label.customsetting.touse.getCustomSetting":`สืบค้นข้อมูลการตั้งค่าแบบกำหนดเองของประเภท "ลำดับขั้น" และส่งคืนข้อมูลชุดเดียวที่เกี่ยวข้องกับ apiName และสิทธิ์ (id คือ id โปรไฟล์หรือ id ผู้ใช้) Map map = cs.getCustomSetting (String apiName, String id);`,
"label.projectManagement.Resourceuse":`การใช้ทรัพยากร`,
"label.appointment.wizard.subtitle4":``,
"label.donot.close.your.browser":`ระหว่างขั้นตอนนี้ โปรดอย่าคลิกลิงก์อื่นหรือปิดเว็บเบราว์เซอร์ของคุณ`,
"label.multilang.customforcast.target":`เป้าหมายของ{0}`,
"setup_layout_label_newarea":`ภูมิภาคใหม่`,
"component.timeline.button.more":`ขั้นตอนเพิ่มเติม`,
"label.appointmentdetail.wizard.title3":`ระยะเวลา`,
"label.help.new.features.pc":`คู่มือการใช้งานฟังก์ชันใหม่บน PC`,
"label.mr.record":`บันทึก`,
"label.trigger.wgd":`ทริกเกอร์ที่ยังไม่ได้จัดเก็บถาวร`,
"label.icon.72":`กล่องเครื่องมือ`,
"setup.layout.label.detailpage":`หน้ารายละเอียด`,
"frame.personinfo.label.usethisimage":`เราจะใช้แผนที่รูปขนาดย่อนี้ในแอปพลิเคชัน`,
"label.multilingual.confirm.open":`ยืนยันการเปิดใช้งานหรือไม่ เมื่อเปิดใช้งานแล้ว คุณจะใช้งานหลายภาษาได้`,
"label.recordcreater":`ผู้สร้างบันทึก`,
"label.afterfinish":`หลังเสร็จสิ้นให้คลิก "บันทึกและสร้างใหม่" เพื่อสร้างฟิลด์ที่กำหนดเองเพิ่มเติม หากคุณดำเนินการสร้างเสร็จสิ้นให้คลิก "บันทึก"`,
"label.companyinformation":`ข้อมูลบริษัท`,
"step1":`ขั้นตอนที่ 1`,
"label.sales.page.dashboard.add":`เพิ่มแดชบอร์ดหน้าแรก`,
"label.processsetting.process.enabled.failed":`ลบกระบวนการล้มเหลว!`,
"label.document.history.date":`วันที่`,
"label.linkedin.title":`Linkedin-มินิแอป H5`,
"label.foldervisitlimit1":``,
"april":`เดือนเมษายน`,
"label_emailsync_form_disconnect":`ยกเลิกการเชื่อมต่อ`,
"label.appointment.wizard.subtitle4-2-6":`2 วัน`,
"vue_label_notice_follow_success":`การติดตามสำเร็จ`,
"label.startuploadfile.success":`หลังจากคลิกปุ่ม "เริ่มการอัปโหลด" หากแถบความคืบหน้าแสดงถึง 100% หมายความว่าการอัปโหลดไฟล์สำเร็จและจะหายไปจากด้านบน`,
"message.accesstoken.acquisition.failed":`ไม่สามารถรับ Access Token!`,
"label.quickbooks.fieldlabel.fistname":`ชื่อ`,
"label.appointment.wizard.subtitle1-5":`1 ชั่วโมง`,
"2018UI.Homepage.DataNoAccess.Info":`คุณไม่ได้รับอนุญาตให้เข้าถึงบันทึกนี้ คลิกเพื่อกลับไปที่ขั้นตอนก่อนหน้า`,
"label.batchaddattachments":`เพิ่มไฟล์แนบเป็นชุด`,
"label.ems.next":`ขั้นตอนถัดไป`,
"label.quote.zhekou":`ส่วนลด`,
"lable.product.notdel":`ลบเนื่องจากยังคงมีความสัมพันธ์กับบันทึกในสมุดราคาอื่น บันทึกที่เกี่ยวข้องมีดังนี้`,
"label.ems.action":`ปฏิบัติการ`,
"message.error.chart.type":`ประเภทแผนภูมิไม่สามารถว่างเปล่า!`,
"label.conditiontag.lookup.value":`มูลค่า`,
"label.chatter.allactivity":`กิจกรรมทั้งหมด`,
"label.summaryreport":`รายงานสรุป`,
"label.textmessage.vonage.action":`ดำเนินการ`,
"label.ccpeak.must.result":`ต้อง as จึงสามารถนำนามแฝงออกจากผลลัพธ์ได้`,
"label.data.newtemplate.savetemp.desc":`กรุณากรอกชื่อและคำอธิบายแม่แบบเพื่อความสะดวกในการใช้งานของคุณ`,
"label.projectManagement.search.for.users":`ค้นหาผู้ใช้`,
"component.milestones.label.title":`ไมล์สโตน`,
"vue_label_applauncher_description_accountpool":`ใช้ฐานข้อมูลลูกค้าในการจัดการสถานะการติดตามลูกค้าภายในองค์กรได้อย่างสะดวกสบาย ทั้งยังกระตุ้นให้พนักงานปิดการขายให้เสร็จสมบูรณ์`,
"label.import.index.startimport":`เริ่มนำเข้า`,
"page.field.masterinput2":`มาสเตอร์อินพุต`,
"label.mobile.change.owner.permission":`เจ้าของใหม่ต้องมีสิทธิ์อ่านบันทึกชนิดนี้`,
"label_partner_common_enable":`เปิดการใช้งานพาร์ทเนอร์คลาวด์`,
"label.log.browser":`เบราว์เซอร์`,
"label.app.step4":`ขั้นตอนที่ 4. เลือกแท็บ`,
"lable.quote.syncing.opportunity":`โอกาสทางธุรกิจ`,
"label.forecast.customforecast.foredis.jqz":`ค่าที่แน่นอน`,
"label.forecast.forecastroleuserpage.title":`การกำหนดผู้จัดการการพยากรณ์`,
"label.starting.quarter":`ไตรมาสเริ่มต้น`,
"label-combination-record":`บันทึก{index}`,
"label.here":`ที่นี่`,
"label.weixin.underfind.error":`ข้อผิดพลาดที่ไม่รู้จัก`,
"label.cloudccclass.list.tip.time":`นักพัฒนาสามารถพัฒนาคลาสตัวจับเวลาบนแพลตฟอร์ม CloudCC.com คลาสตัวจับเวลาเหล่านี้สามารถใช้กับโปรแกรมตัวจับเวลาได้`,
"label.data.setok.t_desc1":`ถ้าต้องการใช้แม่แบบนี้ในการส่งออกข้อมูล โปรดคลิก`,
"label.service.gantt.break.rules":`ละเมิดกฎ`,
"label.weixin.no.pending.ywjh.qin":`ไม่มีข้อมูลเกี่ยวกับโอกาสทางธุรกิจใน 30 วันข้างหน้า`,
"label.view.atleastone":`เลือกอย่างน้อยหนึ่งรายการ`,
"label.attendance.sxccheckin":`ลงทะเบียนเข้าหน้างานแคมเปญ`,
"label.custom.split":`แยก`,
"front-kefu-moudle-v1-yesorno-delete-templete":`ยืนยันว่าจะลบแม่แบบนี้หรือไม่?`,
"label_chatter_theme":`หัวข้อ`,
"label.partner.new.step1":`ขั้นตอนที่ 1: เลือกแม่แบบที่คุณชอบ`,
"vue_label_commonobjects_view_settings":`การตั้งค่ามุมมองคัมบัง`,
"UG_Contract_02":`สัญญาคือข้อตกลงเป็นลายลักษณ์อักษรของคู่สัญญา หลายบริษัทใช้สัญญาเพื่อกำหนดเงื่อนไขในการทำธุรกิจกับบริษัทอื่นๆ ใช้ CloudCC เพื่อสร้างและจัดทำเอกสารสัญญาที่มีอยู่กับลูกค้าและโอกาสทางธุรกิจ ติดตามสัญญาผ่านขั้นตอนการอนุมัติ ใช้การแจ้งเตือนเวิร์กโฟลว์เพื่อเตือนให้คุณทราบถึงการขยายเวลาของสัญญา`,
"label.setup.mobilesetup.isenableh5newandedit":`ต้องการเปิดใช้งานการสร้างใหม่และการแก้ไข H5 บนอุปกรณ์มือถือหรือไม่`,
"label.attendance.edit":`แก้ไขบันทึกเวลาทำงาน`,
"label.service.miniProgram.fillImageLink":`กรุณากรอกลิงก์ภาพสไลด์`,
"label.b.c.without":`บันทึกB"อาจจะมีหรือไม่มีความเกี่ยวข้องกับบันทึก"C" "`,
"label.sso.key":`รหัสการให้สิทธิ์`,
"label.star_click":`คลิกเพื่อล้าง`,
"vue_label_SMS_name_or_phone_number_lookup":`ค้นหาชื่อบันทึก`,
"label.case.copre.text":`คุณยังสามารถดาวน์โหลดรหัสคิวอาร์ของเว็บพอร์ทัลบริษัทคุณ และใส่รหัสคิวอาร์บนเว็บไซต์ทางการหรืออุปกรณ์ ลูกค้าสามารถสแกนรหัสคิวอาร์เพื่อใช้พอร์ทัลเว็บลูกค้า`,
"label.salescloud.forbidden.confirm":`ยืนยันว่าจะปิดการใช้การขายแบบทีมต่อไปหรือไม่?`,
"vue_label_chat_conformactivation":`ยืนยันการเปิดใช้งาน`,
"label.emailtocloudcc.redmessage9":`ฐานข้อมูลผิดพลาด กรุณาติดต่อผู้ดูแลระบบ`,
"label.sahreto":`แบ่งปันไปยัง`,
"label.recordtype.sort":`ชนิดบันทึกจะแสดงตามลำดับที่บันทึก`,
"label.allreport":`รายงานทั้งหมด`,
"front-gantt-module-drag-and-drop-subtask":``,
"label.permission.objlist.nopermission":`ไม่มีสิทธิ์ในการเข้าถึง`,
"label_file_num":`จำนวน`,
"chatter.mostword":`คุณสามารถป้อนอักษรได้สูงสุด 500 ตัว โปรดตัดลดก่อนเผยแพร่`,
"label.h5.chatter.comment":`ความคิดเห็น`,
"vue_label_calendar_notice_havecreated":`คุณสร้างปฏิทินแล้ว`,
"label.tabpage.loadz":`กำลังโหลดหน้าเพจ กรุณารอสักครู่...`,
"chatter.w.p":`โทรศัพท์ที่ทำงาน`,
"label.chat.topic.name.desc":`คุณเปลี่ยนได้เฉพาะขนาดและระยะห่างของชื่อหัวข้อเท่านั้น`,
"label_partner_template_name":`ชื่อแม่แบบ`,
"label.mobile.phone.required.examines.people":`ต้องมีผู้ตรวจสอบ`,
"message.error.view.notexists":`ไม่มีมุมมอง</br>มุมมองอาจถูกบุคคลอื่นแก้ไข คลิก <a href='javascript:history.back();'> ที่นี่ </a> เพื่อกลับไปยังหน้าก่อนหน้า`,
"label.custom_time":`เวลาที่กําหนดเอง`,
"label_partner_workspace_member_all":`ทั้งหมด`,
"lable.custom.year.name":`ชื่อปีที่กำหนดเอง`,
"label.account.previous.M":`เดือนก่อน`,
"vue_label_commonobjects_detail_locking":`ล็อก`,
"label.brief.lead":`ลีด`,
"label.linkedin.setting.appsecret":`รหัสความปลอดภัย`,
"label.query.detail.closepartner":`ปิดพาร์ทเนอร์`,
"label.isEnableVisualpage_new.rightlist":`เพจที่กำหนดเองที่เปิดใช้งานแล้ว`,
"front-epwechat-module-v1-unbound-item3":`- ข้อมูลการให้สิทธิ์`,
"label.exchange.sync.setting.info":`หลังจากที่ผู้ใช้ตั้งค่าบัญชีบริการที่มีสิทธิ์การเลียนแบบใน Microsoft Exchangeแล้ว ใส่ข้อมูลรับรองบัญชีบริการเพื่ออนุญาตให้ CloudCC สื่อสารกับเซิร์ฟเวอร์บริการของ Exchange หากบันทึกข้อมูลบัญชีบริการแล้วแต่ผู้ใช้ยังไม่สามารถซิงค์บันทึกได้ ตรวจสอบให้แน่ใจว่าคุณได้ตั้งค่า Exchange Sync อย่างถูกต้อง`,
"label.emailobject.groupemail.fail.title":`CloudCC ล้มเหลวในการส่งอีเมลแบบกลุ่มไปยังอีเมล`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`ขอบเขตบนของส่วนลดที่แก้ไขทุกขั้นต้องมากกว่าขอบเขตล่าง`,
"label.visualpage.list.vpname":`ชื่อเพจที่กำหนดเอง`,
"label.mask.length.error.message":`ฟิลด์ข้อความที่เข้ารหัสต้องยาวไม่เกิน 255`,
"label.h5.approval.actorname":`ผู้ริเริ่ม`,
"label.knowledgebase.view.translation":`ดูการแปล`,
"label.ems.edit":`แก้ไข`,
"vue_label_commonobjects_view_reset_width":`รีเซ็ตความกว้างคอลัมน์`,
"label.version.feature.controllist":`รายการควบคุมฟังก์ชัน`,
"label.setuppagelayout":`เค้าโครงเพจ`,
"vue_label_commonobjects_view_new_view":`มุมมองใหม่`,
"label_tabpage_queuez":`คิว`,
"label.direct.dashboard.wait.me.approval":`รายการที่รอฉันอนุมัติ`,
"message.report.error.noRelatedField":`ไม่พบฟิลด์ที่เกี่ยวข้องในรายงาน และอาจถูกลบไปแล้ว กรุณาติดต่อผู้ดูแลระบบ`,
"label.ccchat.person.invite.notme":`คุณไม่สามารถส่งคำเชิญไปยังที่อยู่อีเมลของคุณเองได้`,
"label.weixin.jieduan.finish":`ทำเครื่องหมายให้สเตจปัจจุบันว่าเสร็จสิ้น`,
"vue_label_commonobjects_detail_?enter_subject":`กรุณาใส่หัวข้อ`,
"label_starting_month":`เดือนเริ่มต้น`,
"label.address_linetwo":`ที่อยู่บรรทัดที่สอง`,
"message.error.select.contiguous.item":`รายการเกี่ยวข้องที่เลือกมีสัมพันธ์กับ`,
"vue_label_pricebook_enterbookname":`กรุณากรอกชื่อสมุดราคา`,
"label.cycleworkflowoperate":`รอบการดำเนินการของเวิร์กโฟลว์`,
"label.ems.withoneday":`วันเดียวกัน`,
"component.todaytask.label.notask":`ไม่มีงานที่มีกำหนดเสร็จวันนี้ - ถือโอกาสเอาเวลานี้ ไปดื่มกาแฟสักแก้วเถอะ`,
"label.tianyancha.id":`ID บริษัท`,
"label.user.illegal.login":`การเข้าสู่ระบบที่ผิดกฎหมาย!`,
"label.withgathercondition":`ตามเงื่อนไขของการสรุป`,
"label.foldervisitlimit":`สิทธิ์การเข้าถึง`,
"label.ccchat.search.conversation":`ค้นหาการสนทนานี้`,
"lable.annual.project.report":``,
"template.chart.qzkhzhfx":`การวิเคราะห์การข้ามสเตจของลีด`,
"label.my":`ของฉัน`,
"label.sendsms.batch.chosetemplate":`ส่งข้อความสั้นแบบกลุ่ม: เลือกแม่แบบหรือแก้ไขเนื้อหาข้อความสั้น`,
"label.callcenter.enterprise.number":``,
"label_last_modified_by_time":`ผู้แก้ไขล่าสุด&เวลา`,
"message.fieldtrack.operaterecord":`เปลี่ยน <b>operatefield</b> จาก <b>operateold</b> เป็น <b>operatenew</b>`,
"label.mobile.more.openin":`วิธีการเปิด`,
"label.multilingual.tip2":`คุณสามารถเปิดและปิดใช้งานหลายภาษาได้`,
"label.datamanage.lead.novalue":`หมายเหตุ: การนำเข้าครั้งนี้ไม่ได้กำหนดค่าให้กับฟิลด์ "ชื่อลีด" บันทึกผู้ติดต่อจะไม่ถูกนำเข้า!`,
"label.custom.revoke":`ยกเลิก`,
"label_chatter_leaveword":`ฝากข้อความ`,
"vue_label_ccchat_group_deletedgroup":`กลุ่มนี้ถูกลบแล้ว`,
"label.tabpage.operationz":`ฟิลด์ และการดำเนินการไม่สามารถว่างเปล่า`,
"label.user.organization.permit.overdue":`ใบอนุญาตองค์กรของคุณหมดอายุแล้ว กรุณาติดต่อผู้ดูแลระบบ!`,
"label.log.datetimeoruser.value":`กรุณาใส่เวลาสอบถามและชื่อผู้ใช้!`,
"lable.product.stsp.noavailable":`ไม่มีราคามาตรฐาน`,
"label.appservice.cannot.delete.app":`ไม่สามารถลบแอปพลิเคชันที่กำหนดเองได้ บางโปรไฟล์กำลังใช้แอปพลิเคชันนี้เป็นแอปพลิเคชันเริ่มต้น`,
"component.event.label.newevent":`อิเวนต์ใหม่`,
"label.view.sortview.exportview":`ส่งออกมุมมอง`,
"label.uploadfilemaxsize":`ขนาดไฟล์ที่อัปโหลดได้สูงสุดคือ`,
"label.event.weekview":`มุมมองรายสัปดาห์`,
"label.conversion_rate":`อัตราการเปลี่ยนแปลง`,
"label.partnerCloud.partnerAccount.useWechat":`ชําระเงินผ่านการสแกนวีแชท`,
"UG_Forcast_05":`การตั้งค่าการพยากรณ์: ขั้นตอนที่ {0}/{1}`,
"label.service.gantt.jobresour":`แสดงเฉพาะทรัพยากรงานเท่านั้น`,
"vue_label_campaign_fromopprotunities":`โอกาสทางธุรกิจจาก{dsrjine}`,
"label.app.skyblue":`สีฟ้าคราม`,
"label.chinacloudcc":`China CloudCC`,
"label.connectOtherFinalNumber":`ถึงขีดจำกัดของออบเจ็กต์<br />คุณสามารถเชื่อมโยงออบเจ็กต์กับแหล่งข้อมูลรายงานที่กำหนดเองได้สูงสุด 4 รายการ`,
"label.redistributionrequest":`มอบหมายคำขออนุมัติใหม่`,
"label.knowledge.category.button.one":`เพิ่มหมวดหมู่ย่อย`,
"label.campagin.pcandmo":`PC และอุปกรณ์มือถือ`,
"label.project.milestone.date":`วันที่ของไมล์สโตนต้องอยู่ในช่วงวันที่ของโครงการ`,
"assetbom.transfer.notpermission":`โปรดติดต่อผู้ดูแลระบบ คุณไม่มีสิทธิ์โยกย้าย BOM สินทรัพย์`,
"label.marketing.setting1":`ช่องทางการขายของแคมเปญ`,
"label.select.file":`เลือกไฟล์`,
"message.error.object.contactadministrators":``,
"label.custom.quarter.title":`ไตรมาสที่กำหนดเอง`,
"label.knowledge.case.settings":`การตั้งค่าเคส`,
"front-service-cloud-transfer-title":``,
"label.group.search.searchthisfeed":`กรุณาใส่เนื้อหาที่ต้องการค้นหา`,
"label.report.action.addtodashboard5":`เพิ่มลงในแดชบอร์ดใหม่`,
"label.mobile.side.tab.remark2":`เมื่อตั้งค่าแถบด้านข้าง คุณสามารถเอารายการที่ใช้บ่อยที่สุดมาวางไว้ตำแหน่งด้านหน้าได้ ; บันทึกการโทรและรายการแท็บสามารถใช้ได้ใน CloudCC รุ่นสำหรับอุปกรณ์มือถือ Android เท่านั้น`,
"contain":`ประกอบด้วย`,
"label.select.template":`เลือกแม่แบบ`,
"label.addattachment.step3.weixin":`ขั้นตอนที่ 3. คลิกปุ่ม“เสร็จสิ้น”เพื่อกลับไปยังหน้าก่อนหน้า`,
"lable.Order.successfully":`ผลิตภัณฑ์ที่สั่งซื้อถูกโอนไปยังสินทรัพย์เรียบร้อยแล้ว`,
"label.user.title":`ตำแหน่งงาน`,
"label.weixin.check.agreement":`กรุณาเลือกข้อตกลงที่เกี่ยวข้อง`,
"label.SMS.pfi":`ฟิลด์หมายเลขโทรศัพท์มือถือ`,
"label.weixin.micro.research":`ไมโครรีเสิร์ช`,
"label.projectManagement.assigned.work":`งานที่ได้รับมอบหมาย`,
"label.document.login.error":`การเข้าสู่ระบบล้มเหลว โปรดลองเข้าสู่ระบบอีกครั้ง`,
"label.mobile.phone.examines.people":`ผู้ตรวจสอบ`,
"label.safetyset":`การตั้งค่าความปลอดภัย`,
"label_function_tip":`ขณะนี้ฟังก์ชั่นไม่รองรับผู้ใช้ในจีนแผ่นดินใหญ่ ขอขอบคุณสําหรับความเข้าใจ!`,
"label.app.sort":`การเรียงลำดับแอปพลิเคชัน`,
"component.sendmail.label.cc":`สำเนา`,
"label.titlename":`หัวข้อ`,
"label.event.moveup.3day":`ล่วงหน้า 3 วัน`,
"label.condition":`เงื่อนไข`,
"label.description.message":`จํานวนคําในหมายเหตุต้องไม่เกิน 500 คํา`,
"label.ems.detailedsettings":`การกำหนดค่าโดยละเอียด`,
"label.repeat.condition.field.prompt":`กรุณากรอกตัวเลขในฟิลด์ "อักขระกี่ตัวแรก" ของปุ่ม!`,
"label.validate.function.funcExplain.OR":`ตรวจสอบว่าพารามิเตอร์ใดเป็นจริงและส่งกลับค่า TRUE หรือ FALSE ส่งกลับค่า FALSE ก็ต่อเมื่อพารามิเตอร์ทั้งหมดเป็นเท็จ`,
"label.salecommit.allow.prediction.query":`คุณยังไม่ได้เลือกการอนุญาตให้พยากรณ์ใน [การตั้งค่า]> [ข้อมูลส่วนตัวของฉัน]> [ข้อมูลส่วนตัว] คุณไม่สามารถดูคัมบังข้อผูกมัดการขายได้`,
"front-kefu-moudle-soft-phone":``,
"label.view":`มุมมอง`,
"front-gantt-module-quick-create-task":``,
"label.all_forms":`ฟอร์มทั้งหมด`,
"front-lightning-module-v1-dashborad-statistical-dimension":`มิติทางสถิติ`,
"label.forecast.settings.data.chanpin":`วันที่ผลิตภัณฑ์`,
"label.appointment.wizard.subtitle4-2-7":`3 วัน`,
"front-web-module-v1-detail-comment-please":``,
"label_chatter_nextSevenday":`7 วันถัดไป`,
"homepage.components.desctiption":`ในหน้านี้คุณสามารถสร้างหรือแก้ไขส่วนเสริมที่แสดงในเค้าโครงหน้าแรก`,
"label.customcomponent.page.index.table.namespace":`คำนำหน้าเนมสเปซ`,
"label_emailtocloudcc_exists":`มีอีเมลอยู่แล้ว`,
"label_tabpage_save":`บันทึก`,
"label.mergeRechecking":``,
"vue_label_helpcenter_view2":`ในมุมมองแยกหน้าจอ คุณสามารถสลับเพื่อดูข้อมูลโดยละเอียดของข้อมูลแต่ละส่วนได้อย่างรวดเร็ว <br>3. วิเคราะห์ข้อมูลการขายอย่างรวดเร็ว<br>ที่มุมขวาบนของมุมมอง สามารถเปิดแผนภูมิในมุมมอง เพื่อทำการวิเคราะห์ข้อมูลอย่างง่าย  ในขณะเดียวกันก็สามารถดูแดชบอร์ดและรายการรายงานที่เกี่ยวข้องเพื่อวิเคราะห์เพิ่มเติมได้ <br>กดปุ่มแผนภูมิที่มุมขวาบนเพื่อดู สร้าง และแก้ไขแผนภูมิอย่างง่ายที่สร้างด้วยข้อมูลมุมมอง หรือดูแดชบอร์ดที่เกี่ยวข้องกับมุมมองปัจจุบัน <br>ขั้นตอนที่ 1: กดปุ่มแผนภูมิที่มุมขวาบนเพื่อขยายแผนภูมิในหน้า คุณสามารถตรวจสอบและจัดการแผนภูมิที่มีอยู่ตามสิทธิ์ และดูรายการแดชบอร์ดที่เกี่ยวข้องกับข้อมูลมุมมอง <br>ขั้นตอนที่ 2: กดปุ่มตั้งค่าเพื่อสร้าง แก้ไข ลบแผนภูมิตามสิทธิ์ และสามารถสร้างแผนภูมิได้ 4 รูปแบบ เช่น แผนภูมิแท่งแนวตั้ง แผนภูมิแท่งแนวนอน แผนภูมิวงกลม และแผนภูมิทรงกรวย  <br> คลิกปุ่มรายงานเพื่อดูรายงานที่เกี่ยวข้องกับมุมมองปัจจุบัน <br>4. จัดการข้อมูลในมุมมอง<br>สามารถเพิ่ม แก้ไข ลบ และเปลี่ยนเจ้าของข้อมูลตามสิทธิ์จากปุ่มที่ด้านขวาบนของมุมมองหรือปุ่มที่อยู่ด้านข้างข้อมูล<br> ใช้ป้ายกำกับจัดการข้อมูลของคุณ คลิกปุ่มทางด้านขวาเพื่อขยายรายการการจัดการป้ายกำกับ และคุณสามารถกรองข้อมูลในมุมมองตามป้ายกำกับได้ หลังจากคลิกจัดการป้ายกำกับจะสามารถดูแลและจัดการไลบรารีป้ายกำกับของคุณได้ หลังจากเลือกข้อมูลแล้ว ให้กดปุ่มเพิ่มป้ายกำกับที่มุมบนขวา เพื่อเพิ่มป้ายกำกับให้กับข้อมูลเป็นกลุ่ม`,
"label.app.ismobile":`ใช้กับจอแสดงผลบนอุปกรณ์เคลื่อนที่`,
"chatter.group.changeTheGroupPicture":`เปลี่ยนรูปโปรไฟล์กลุ่ม`,
"label.mr.descreption.reDataList2":`พบข้อมูลซ้ำที่สอดคล้องกับเงื่อนไขในบันทึก`,
"vue_label_chatter_agree_join":`อนุญาตเข้าร่วม`,
"label.planned.nextrun":`เรียกใช้แผนครั้งต่อไป`,
"Homepage.News.003":`ไม่มีข้อมูลลูกค้าและไม่สามารถแสดงข่าวได้ คุณสามารถแสดงข่าวลูกค้าที่นี่หลังจากสร้างลูกค้าแล้ว`,
"label.summaryreport.selectpictype":`เลือกประเภทแผนภูมิและตัวเลือกแผนภูมิอื่นๆ`,
"label.app":`แอปพลิเคชัน`,
"label.trigger.name":`ชื่อทริกเกอร์`,
"vue_label_email_private_template":`แม่แบบส่วนตัว`,
"label.appointmentpage.wizard.subtitle1":`กรุณาเลือกวันที่และเวลาที่เจาะจง โซนเวลาของผู้เชิญคือ{0}`,
"label.partnerCloud.orderingPlatform.payment":`การชำระเงิน`,
"label.stdashbord.xsld.title":`กรวยการขาย`,
"vue_label_pool_poolname":`ชื่อฐานข้อมูล`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`แผนภูมิการนัดหมายการบริการ`,
"front-lightning-module-v1-dashborad-target-value":`ค่าเป้าหมาย`,
"label.reportsSubscriptionPage.email.keywords":`ป้อนคีย์เวิร์ดแล้วค้นหา`,
"label.appointmentconfirmail.wizard.subtitle1":`ชื่ออิเวนต์`,
"label.limited_scanning":`บัตรเข้างานจำกัดเฉพาะสถานการณ์ที่ต้องลงทะเบียนด้วยการสแกนหน้างานเท่านั้น`,
"label.weixin.nomore":`หมดแล้ว`,
"february":`เดือนกุมภาพันธ์`,
"label.view.filterbyowner":`กรองตามเจ้าของ`,
"label.contentType":`นามสกุลของไฟล์`,
"label.customobjdel.master.hsiang":`มีฟิลด์ความสัมพันธ์หลัก-รองในออบเจ็กต์ ไม่สามารถลบได้`,
"lable.Removal.succeeded":`ลบสำเร็จ`,
"label.weixin.end.incorrect":`รูปแบบวันสิ้นสุดไม่ถูกต้อง`,
"label.email.cc.recipients":`ผู้รับสำเนา`,
"label.taskevent.list":`รายการภารกิจและอิเวนต์`,
"label.formula":`สูตร`,
"label.h5.new.errorheader":`ตรวจสอบข้อผิดพลาดในหน้านี้`,
"label.emailobject.template.private":`ส่วนตัว`,
"label.visualpage.component.n4":`4. ตัวแปร สามารถใช้ตัวแปรได้โดยตรง ระวังอย่าให้มีเครื่องหมายอัญประกาศเดี่ยว`,
"label.newemailnotice.step1":`ขั้นตอนที่ 1: เลือกออบเจ็กต์`,
"label.chatter.file":`ไฟล์`,
"vue_label_checkduplicate_rules":`ตั้งค่าเกณฑ์การตรวจสอบซ้ำ`,
"label.appointment.wizard.subtitle1-6":`1.5 ชั่วโมง`,
"label.customReportType":`แหล่งข้อมูลรายงานที่กำหนดเอง`,
"vue_label_email_with_accessories":``,
"label_efine_assessment_cycle":`กำหนดรอบการประเมิน`,
"label_emailtocloudcc_button_sure":`ยืนยัน`,
"label.forecast.userenablepage.isusing":`ผู้ใช้ถูกเปิดใช้งาน`,
"lable.goal.description":`คำอธิบายเป้าหมาย`,
"message.error.serviceresource.relatedrecordid":`ผู้ใช้แต่ละรายสามารถเพิ่มเป็นทรัพยากรบริการประเภท{0}ได้หนึ่งรายการเท่านั้น`,
"label.weixin.addbus.information":`เพิ่มข้อมูลยานพาหนะ`,
"label.emailtocloudcc.button.view":`มุมมอง`,
"label.detail.workflow":`ดูเวิร์กโฟลว์`,
"label.standardfilter":`ตัวกรองมาตรฐาน`,
"label.mobile.phone.results":`ผลการดำเนินงาน`,
"chatter.feed.unavailabled":`ปิดการใช้งาน`,
"label.view.sortview":`เรียงลำดับมุมมอง`,
"label.availabilityobject.wizard.title":`เวลาว่าง`,
"Main_Menu_Mobiledownload":`สามารถใช้สำหรับ`,
"chatter.sticker":`ติดตาม`,
"label.workflow.intruduce":`ปรับแต่ค่าเวิร์กโฟลว์ขององค์กรโดยการสร้างกฎเวิร์กโฟลว์ กฎเวิร์กโฟลว์แต่ละข้อประกอบด้วย:`,
"label.customfields.richtext.tip":`อนุญาตให้ผู้ใช้ป้อนข้อความที่จัดรูปแบบ เพิ่มรูปภาพ และลิงก์`,
"label.new.cy.select":`เลือกสกุลเงินใหม่จากรายการตัวเลือก`,
"template.chart.schdzqzkhzhqk":`การเปลี่ยนแปลงของลีดในแคมเปญ`,
"label.forecast.customforecast.cpxl":`สายผลิตภัณฑ์`,
"front-electronic-signature-open-service":``,
"label.datamanage.import.field":`นําเข้าฟิลด์`,
"chatter.email.sendMessageToMe":`เมื่อส่งข้อความถึงฉัน`,
"message.cannotusebefore":`โปรดจำไว้ว่าคุณไม่สามารถใช้กระบวนการอนุมัตินี้ได้จนกว่าจะเปิดใช้งาน`,
"label.textmessage.vonage.api.secret":`ความลับของ API`,
"label_chatter_newEvent":`อิเวนต์ใหม่`,
"label.ji.year":`{a} ปี`,
"label.sendmail.step2":`ขั้นตอนที่ 2: เลือกแม่แบบอีเมล`,
"label.console.step5.record":`เปิดบันทึก`,
"label.customfields.totalsummary.gettogetherfield.isnull":`โปรดเลือกฟิลด์ที่จะรวบรวม`,
"vue_label_commonobjects_detail_current_recorder":`เจ้าของใหม่จะกลายเป็นเจ้าของบันทึกที่เกี่ยวข้องกับรายการ และเจ้าของบันทึกปัจจุบันเป็นเจ้าของบันทึกเหล่านี้`,
"label.SMS":`แจ้งเตือนข้อความสั้น`,
"label.reconfigure.bundle":`กำหนดค่าชุดผลิตภัณฑ์ใหม่`,
"front-kefu-select-region":``,
"chatter.feed.deletefeeds":`ยืนยันว่าต้องการลบโพสต์นี้และความคิดเห็นหรือไม่?`,
"label.customsetting.manage.introduce.h":`ถ้าการตั้งค่าแบบกำหนดเองเป็นแบบลำดับชั้น คุณสามารถเพิ่มข้อมูลสำหรับผู้ใช้และโปรไฟล์ได้ 
 เช่น คุณอาจต้องการแสดงค่าต่างๆ โดยขึ้นอยู่กับว่าเป็นผู้ใช้รายใดรายหนึ่ง โปรไฟล์เฉพาะ หรือผู้ใช้ทั่วไปที่ใช้แอปพลิเคชัน`,
"label.product.name":`ชื่อผลิตภัณฑ์`,
"vue_label_commonobjects_view_saveas":`บันทึกเป็น`,
"label.group.my.archived":`กลุ่มที่เก็บถาวรแล้วของฉัน`,
"vue_label_pool_coflictmethods":`ขัดกับวิธีการขายปัจจุบัน`,
"label.appupload.upload":`อัปโหลด`,
"lable.SalesCommitmentKanBan.signedTaskRate":`อัตราภารกิจที่ทำสัญญา`,
"label.dashboardStandard":`แดชบอร์ดมาตรฐาน`,
"label.niboer.time":`เวลาเนปาล`,
"label.emailtocloudcc.filed.email":`อีเมล`,
"market.name.social.post":`โพสต์โซเชียล`,
"evaluation.detail.notfound":`ไม่พบรายละเอียดการประเมิน`,
"label.layoutoftestobj":`เค้าโครงออบเจ็กต์ทดสอบ`,
"label.example":`ตัวอย่าง`,
"label.campaign.channel.step6.remark6":`กรุณาเข้าไปที่นี่`,
"chatter.emailLike":`ชื่นชอบ`,
"label.knowledge.category.button.two":`แก้ไขหมวดหมู่`,
"label.alluser":`ผู้ใช้ทั้งหมด`,
"addadvancedconditions":`เพิ่มตัวเลือกขั้นสูง`,
"message.selectgsummarycondition":`โปรดเลือกเงื่อนไขของการสรุป`,
"message.duplication.label.sectionremar2":`หมายเหตุ: หมายเหตุ ไฟล์แนบ และกิจกรรมใดๆ ที่เกี่ยวข้องกับบันทึกจะเชื่อมโยงกับบันทึกที่ผสานใหม่`,
"vue_label_helpcenter_product&pricebook":`ผลิตภัณฑ์ คือบัญชีรายชื่อพื้นฐานสำหรับสินค้า การบริการ และราคามาตรฐานของคุณ สมุดราคาช่วยให้คุณสามารถกำหนดการรวบรวมเพื่อสร้างผลิตภัณฑ์สุดพิเศษสำหรับลูกค้า ไปจนถึงการตั้งราคาที่เหมาะสม`,
"message.duplication.label.isprofile":`อนุญาตหรือไม่`,
"component_setup_label_milestonesfield":`ฟิลด์ไมล์สโตน`,
"setup_layout_label_required":`จำเป็นต้องระบุ`,
"component_chatter_label_title":`เวยเทียล่าสุด`,
"label.assignment.setup.detail.order":`หมายเลขลำดับ`,
"vue_label_pool_unassigned":`ยกเลิกการมอบหมาย`,
"UG_Lead_007":`ซิงค์ Google`,
"label.knowledge.record":`ไม่มีข้อมูลที่เกี่ยวข้อง`,
"label_tabpage_filetypez":`ประเภทไฟล์`,
"label.ccpeak.if.error.message":`ถ้าส่งกลับข้อความแสดงข้อผิดพลาด: ใช้`,
"label.intialsubmitter":`ผู้เสนอตั้งต้น`,
"label.wei.icon":`ไอคอน`,
"label.mask.show.last.4":`ตัวพรางแสดงตัวเลข 4 หลักสุดท้าย`,
"lable.PowerProcess.time.trigger":`ทริกเกอร์เวลา (นาที)`,
"july":`เดือนกรกฎาคม`,
"label.usestandardwizard":`ใช้ตัวช่วยแนะนำการติดตั้งมาตรฐาน`,
"label.two.quarter":`ไตรมาสที่สอง`,
"label.size":`ขนาด`,
"label.integrations.mailchimp.massage4":`ยังไม่ได้กำหนดค่า MailChimp โปรดไปที่การตั้งค่าการเชื่อมต่อเพื่อตั้งค่าการอนุญาต Mailchimp`,
"label_emailtocloudcc_step2total3":`ขั้นตอนที่ 2 จาก 3`,
"vue_label_chat_customer_group_strategy":`กลยุทธ์กลุ่มลูกค้า`,
"label.searchvalue":`ค้นหาค่า`,
"label.sendemail.birthday.title":`การแจ้งเตือนวันเกิด`,
"label.projectManagement.planned.days":`จํานวนวันที่วางแผนไว้ (วัน)`,
"label.service.gantt.workhours":`ขึ้นอยู่กับชั่วโมงการทํางาน`,
"label.notification.approval5":`การอนุมัติแทน:  [ผู้เสนอ]กำลังขอการอนุมัติ[ออบเจ็กต์]`,
"label.service.miniProgram.bindAddressDesc":`ที่อยู่มินิโปรแกรมพอร์ทัลการบริการลูกค้ามาตรฐาน CloudCC:`,
"chatter.error.wt":`ข้อผิดพลาด: ประเภทไฟล์ไม่ถูกต้อง!`,
"vue_label_calendar_my_calendar":`ปฏิทินของฉัน`,
"label.customername":`ชื่อลูกค้า`,
"label.salescloud.salesdashboard.huikuan.rankings":`ภาพรวม-การจัดอันดับผลตอบแทนจากการขาย`,
"message.query.opportunity.contactrole.error":`การสืบค้นบทบาทเริ่มต้นของผู้ติดต่อโอกาสทางธุรกิจล้มเหลว โปรดติดต่อผู้ดูแลระบบ`,
"noequal":`ไม่เท่ากับ`,
"label.document.searchcustominfo":`ป้อนตีย์เวิร์ดเพื่อค้นหาเอกสารที่เหมือนกัน`,
"label.account.PreviousFQ":`ไตรมาสบัญชีก่อนหน้า`,
"label.file.f":`ไฟล์`,
"label.dashboard":`แดชบอร์ด`,
"label.report.folder":`โฟลเดอร์รายงาน`,
"batch.edit.permission.list":`รายการข้อมูลที่แก้ไขไม่ได้`,
"label.file.orderbyowner":`เรียงลำดับตามเจ้าของ`,
"label.exchange.sync.account.password":`รหัสผ่านบัญชีบริการ:`,
"pagecreator.button.publish":`เผยแพร่`,
"label.modify":`แก้ไข`,
"label.exchange.sync4":`สถานะ`,
"label.remark.information":`หมายเหตุ`,
"label.service.without.major.event":`ไม่มีอิเวนต์สําคัญที่จะแสดง`,
"label.knowledgebase.release.status":`สถานะการเผยแพร่`,
"label.tabpage.ok":`ยืนยัน`,
"label_screening_assessment_content":`กรองเนื้อหาการประเมิน`,
"label_partner":`พาร์ทเนอร์คลาวด์`,
"label.user.detail":`ดูผู้ใช้`,
"front-kefu-moudle-or-this":``,
"label.unselect.object":`ตัวเลือกออบเจ็กต์`,
"label.quote.contactfax":`แฟกซ์`,
"label.weixin.appmanage.alert":`กด{0}เพื่อลบออกจากแอปของฉัน กด{1}เพื่อเพิ่มลงในแอปของฉัน`,
"vue_label_dashboard_thisfolder":`เพิ่มแดชบอร์ดสาธารณะในโฟลเดอร์นี้`,
"label.delete":`ลบ`,
"label.appexchange.installedpage.message1":`บน CloudCC.com AppExchange คุณสามารถเรียกดู ดาวน์โหลดแอปพลิเคชัน และติดตั้งลงใน CloudCC.com ของคุณได้โดยตรง`,
"label.mobile.phone.required.summary":`ต้องสรุป`,
"label.batchadd.newbatchpage.addtr":`เพิ่มบันทึกได้สูงสุดแค่ 30 รายการ`,
"label.partnerCloud.partnerAccount.lockLine":`ล็อกวงเงิน`,
"label.emailsync.status.connectstatus":`สถานะการเชื่อมต่อ`,
"label.campaignmember.main.importmember.lead":`นำเข้าสมาชิก-ลีด`,
"message.username.isnull":`ชื่อผู้ใช้ไม่สามารถว่างเปล่า!`,
"label.forecast.tree.enableuser":`เปิดใช้งานผู้ใช้`,
"label.multilang.view.viewmessage":`มุมมองนี้ถูกเลือกให้แสดงบนอุปกรณ์มือถือ คุณสามารถเลือกฟิลด์ได้มากถึง 10 ฟิลด์ ขณะนี้มีแล้วทั้งหมด {0} ฟิลด์`,
"friday":`วันศุกร์`,
"label.sendemail.activity.neweventtitle":`การแจ้งเตือนอิเวนต์ใหม่`,
"label.page.addtabto.user":`แนบแท็บไปยังการตั้งค่าการปรับแต่งส่วนบุคคลที่มีอยู่ของผู้ใช้`,
"front-kefu-moudle-v1-connect-phone":``,
"label.wei.pollis":`โหวตให้`,
"lable.opppdt.editPdt.title":`แก้ไขผลิตภัณฑ์ที่มีโอกาสทางธุรกิจ`,
"label.permission.objectpermission.recordfenpei":`กำหนดชนิดบันทึก`,
"pagecreator.layout.message.delete.success":`การลบเค้าโครงสำเร็จ`,
"label.dataimport.isdupecatcher":`ดำเนินการตัวกรองซ้ำ`,
"label.deletelayout.tip":`หากต้องการลบเค้าโครงเพจ คุณจะต้องเลือกเค้าโครงเพจอื่นมาแทนที่`,
"label.projectManagement.No.matching.data":`ไม่มีข้อมูลที่ตรงกัน`,
"pagecreator_page_message_delete_success":`การลบหน้าเพจสำเร็จ`,
"label_tabpage_equalz":`เท่ากับ`,
"label.ems.emailsetup":`ตั้งค่าอีเมล`,
"label.decimaldigits":`ตำแหน่งทศนิยม`,
"component.chatter.button.delete":`ลบ`,
"label.isallowreport":`อนุญาตรายงานหรือไม่`,
"label.view.appliedMobile.message":`เลือกตัวเลือกนี้ ขั้นตอนที่ 3. เลือกฟิลด์ที่จะแสดงสูงสุด 6 ฟิลด์`,
"label.must.positive.integer":`ต้องเป็นจำนวนเต็มบวก`,
"label.preview.print.template":`แสดงตัวอย่างแม่แบบการพิมพ์`,
"label.schedulejob.setup.schedule.start":`เริ่มต้น`,
"UG.Case.04":`การจัดสรรเคส`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`เปิดการใช้งานรายละเอียดโฮเวอร์`,
"vue_label_email_alltemplates":`แม่แบบทั้งหมด`,
"label_report_chose_obj":`เลือกความสัมพันธ์ของออบเจ็กต์และแหล่งข้อมูลรายงาน`,
"label.partnerCloud.productSet.del":`ลบตัวเลือก`,
"label.quote.shrdz":`ที่อยู่ผู้รับ`,
"page.approval.history":`ประวัติการอนุมัติ`,
"lable.outlook.detail.prefc":`เลือก CloudCC.com ก่อน`,
"label.translation.unable.display.view":`ไม่สามารถแสดงมุมมอง`,
"label.encrypt.change":`เปลี่ยนฟิลด์เข้ารหัส`,
"button.partner.workspace.login.logo.upload":`อัปโหลดรูปภาพ`,
"label.batchadd.mustinput2":`เป็นรายการที่จำเป็น ถ้าไม่กรอกบันทึกจะไม่ถูกบันทึก`,
"label.dataimport.update.error.check":`มีข้อผิดพลาดในการอัปเดตข้อมูล โปรดตรวจสอบข้อมูลนี้อย่างรอบคอบ`,
"label.staticresource.name.already.exists":`มีชื่อเฉพาะทรัพยากรแบบคงนี้แล้ว`,
"label.appupload.upload.install.success":`การติดตั้งสำเร็จ`,
"label.conditiontag.lookup.true":`จริง`,
"label.quickbooks.viewlist.customer":`ลูกค้า`,
"label.field.edit.change2":`คะแนนสูงสุดอย่างน้อย 1`,
"label.fianalrejectoperate":`ดำเนินการปฏิเสธขั้นสุดท้าย`,
"label.ccpeak.wgd":`คลาสที่ยังไม่ได้จัดเก็บถาวร`,
"label.reportsSubscriptionPage.condition.emailreport":`สรุป รายงาน`,
"label.detailinf":`รายละเอียด`,
"label.eastem.standard.time":`เวลามาตรฐานตะวันออก`,
"chatter.group.manager":`ผู้จัดการ`,
"label.manage_columns":`จัดการส่วนหัว`,
"label.daylight.time":`เวลาออมแสง`,
"label.weixin.mycar.information":`ข้อมูลยานพาหนะของฉัน`,
"label.ccpeak.help":`ตัวช่ายคลาส`,
"lable.outlook.detail.match":`เงื่อนไขการจับคู่`,
"label.version.nonsupport.approval":`ไม่รองรับขั้นตอนการอนุมัติ`,
"label.custom-tailor":`การปรับแต่งลูกค้า`,
"label.showoperate":`แสดงการดำเนินงาน`,
"label.view_edit":`ดูและแก้ไข`,
"label.lead.score.prompt2":`โปรดเลือกช่วงที่ต้องการให้คะแนนลีด และคลิกปุ่ม [การให้คะแนนลีด] และระบบจะให้คะแนนลีดที่เลือกตามเกณฑ์การให้คะแนนที่เปิดใช้งานในปัจจุบัน`,
"label.datamanage.savetemplate.error":`การบันทึกแม่แบบล้มเหลว!`,
"label.source":`แหล่งที่มา`,
"label.multilang.customfieldsetup.reference":`ฟิลด์นี้ถูกอ้างถึงที่{0}:`,
"chatter.poll.option7":`ตัวเลือกที่ 7`,
"label.login.access.day":`วัน`,
"label.icon.66":`อุปกรณ์`,
"label.tabpage.kanbansetup":`การตั้งค่าคัมบัง`,
"label_emailtocloudcc_step1_lead2":`หลังจากกำหนดค่า อีเมลที่ได้รับจะสร้างบันทึกลีดโดยอัตโนมัติ เพื่อให้แน่ใจว่าจะไม่พลาดโอกาสทางธุรกิจ`,
"label.partnerCloud.partnerAccount.numericValue":`ยอดเติมเงินต้องเป็นค่าตัวเลข`,
"label.permission.detail.app.object.tip":`สิทธิ์การเข้าถึงออบเจ็กต์และฟิลด์และการตั้งค่าความพร้อมใช้งานของเมนู`,
"label.emailobject.template.subject":`หัวข้อ:`,
"template.report.month.customer":`ลูกค้าของเดือนนี้`,
"label.weixin.formerly":`ก่อนหน้า`,
"label.contract":`สัญญา`,
"label.help":`ช่วยเหลือ`,
"vue_label_homepage_setdefault":`ตั้งเป็นค่าเริ่มต้นหน้าแรก`,
"label.icon.52":`ผลิตกระแสไฟฟ้า`,
"label.customfields.file.count":`จำนวนไฟล์`,
"UG_Account_07":`ชักนำลูกค้าเข้ามา`,
"label.addattachment.ntko":`การแก้ไขออนไลน์`,
"label.service.ganttBaiduMap.assign.service":`มอบหมายการนัดหมายการบริการให้เขา`,
"vue_label_file_my_file":`ไฟล์ของฉัน`,
"label.custom.page.hide":`ซ่อน`,
"label.addexistoperate":`เพิ่มการดำเนินการที่มีอยู่`,
"label.already.startdate":`เวลาเริ่มต้นแล้ว`,
"label.partnerCloud.financeSetting.alipay":`ต้องเปิดบัญชีธุรกิจอาลีเพย์เพื่อเป็นบัญชีสาธารณะขององค์กรที่ใช้สำหรับการรับเงินโดยเฉพาะ อาลีเพย์จะเรียกเก็บค่าธรรมเนียมการทําธุรกรรมจากผู้รับเงิน`,
"label.dashboard.summary.editPageFooter":`แก้ไขส่วนท้าย`,
"label.category.8":`สินค้าอุปโภคบริโภค`,
"label.forecast.customforecast.foretype.best":`ประสิทธิภาพยอดเยี่ยม`,
"message.validation.isnull":`ป้อนค่า`,
"label.savewxpay.failure":`การบันทึกข้อมูลร้านค้าวีแชทเพย์ล้มเหลว`,
"label.file.stop.sharing.desc1":`หยุดที่`,
"label.opportunity.setting.showstage。read.info":`หลังจากเลือกสเตจของโอกาสทางธุรกิจจะไม่สามารถแก้ไขได้ด้วยตนเอง`,
"UG_Campaign_003":`สร้างแคมเปญ`,
"label.edit.field.select.showoptions":`แสดงตัวเลือกทั้งหมด`,
"message.inputplatformpwd":`ใส่รหัสผ่านผู้ดูแลแพลตฟอร์ม`,
"vue_label_systemSettings_mobel_set":``,
"label.projectManagement.thefirstone":`รายการแรกแล้ว`,
"label.data.newtemplate":`สร้างแม่แบบส่งออกข้อมูล`,
"label.monitorsys.delete.log":`ล็อกตรวจสอบการทำงานของคีย์ระบบ`,
"label.template":`แม่แบบ`,
"Lead.Auto.Scoring.Setting.001":`ให้คะแนนลีดโดยอัตโนมัติเมื่อบันทึกหรือแก้ไข (ไม่รวมการนำเข้าแบบกลุ่มและการสร้างอินเทอร์เฟซ)`,
"label.operatesuccess":`การดำเนินการสำเร็จ`,
"label.send":`ส่ง`,
"chatter.yp":`ซ่อนเวยเทีย`,
"label.overall_responses":`การตอบสนองโดยรวม`,
"vue_label_systemSettings_server_report":`รายงานการบริการ`,
"label.icon.113":`บ้าน`,
"label.partnerCloud.basicSetting.domainSet":`ตั้งค่าชื่อโดเมน`,
"label.login.access.text":`เพื่อช่วยแก้ไขปัญหาด้านการสนับสนุน คุณสามารถให้สิทธิ์ผู้ดูแลระบบของคุณในการลงชื่อเข้าใช้และเข้าถึงข้อมูลของคุณได้`,
"vue_label_report_addrowlevelformula":`เพิ่มสูตรระดับแถว`,
"message.duplication.label.mergeTitle":`ผสาน   ของฉัน`,
"label.event.add":`เพิ่มอิเวนต์`,
"vue_label_homepage_bigscreen_light":`สีอ่อน`,
"setup.chatter.enabled":`ปิดการใช้งาน โปรดติดต่อผู้ดูแลระบบเพื่อเปิดใช้งานเวยเทีย`,
"label.inputreceiver":`คุณสามารถใส่ที่อยู่อีเมลที่ต้องการจะส่งได้มากสุด 5 รายการ ให้ใช้ “;” แยกแต่ละที่อยู่อีเมล`,
"label.custom.page.custom.page":`เพจที่กำหนดเอง`,
"label.data.exp.csv":`รูปแบบ CSV`,
"label.searchlayout.view.example":`ตัวอย่าง`,
"label_tabpage_fullscreenz":`เต็มหน้าจอ`,
"label.tabpage.last":`ขั้นตอนก่อนหน้า`,
"lable.outlook.mcto.accepemail":`ที่อยู่อีเมลที่ยอมรับได้ของฉัน`,
"front-electronic-signature-isopen":``,
"vue_label_commonobjects_detail_earlier":`ดูก่อนหน้านี้`,
"label.name.cannot.greater.str":`ชื่อต้องไม่ยาวเกิน 255 อักขระ`,
"label.weixin.activity.email":`กิจกรรม : อีเมล`,
"label.tabpage.unequalz":`ไม่เท่ากับ`,
"label_calendar_year":`ปีปฏิทิน`,
"label.appupload.upload.installor":`ผู้ติดตั้ง`,
"label.jixiaoswitchon":`ขยายประสิทธิภาพ`,
"label.user.congratulations.send.finish":`ยินดีด้วย การเสนอขอส่งอีเมลแบบกลุ่มสำเร็จแล้ว`,
"label.customsetting.touse.getListCustomSetting2":`สืบค้นข้อมูลการตั้งค่าแบบกำหนดเองของประเภท "รายการ" และส่งคืนข้อมูลชิ้นเดียวที่เกี่ยวข้องกับ apiName และ Name Map map = cs.getListCustomSetting (String apiName);`,
"label.recordtype.masterrecordtype.selectedTip":`คุณไม่สามารถกำหนดชนิดบันทึกหลักให้กับโปรไฟล์ที่มีการกำหนดชนิดบันทึกอื่นให้แล้ว`,
"label.tippage.li3":`ทำให้ส่วนเสริมแดชบอร์ดที่เกี่ยวกับรายงานที่ลบใช้การไม่ได้`,
"label.weixin.no.name":`ไม่มีหัวข้อ`,
"label.tabpage.viewz":`พิมพ์มุมมองปัจจุบัน`,
"label.create_contacts":`สร้างรายชื่อผู้ติดต่อ`,
"vue_label_homepage_operationitem":`โปรดเลือกปุ่มปฏิบัติการ`,
"label.pc.ui.2018.switch.version":`สลับรุ่น`,
"label.salescloud.teamrole.main":`ใช่ผู้ติดต่อหลักหรือไม่`,
"label.reportsSubscription.format.report":`รูปแบบรายงาน (รูปแบบ Excel .xlsx)`,
"label.forecast.customforecast.total":`จำนวนรวม`,
"label.quickbooks.fieldlabel.lastname":`นามสกุล`,
"label.appointment.wizard.title2":`รายละเอียดการประชุม`,
"label.project.template.one":`การสร้างโครงการจากแม่แบบโครงการอาจใช้เวลา 2 - 3 นาที โปรดอดทนรอ`,
"label.timetrigger.workflow":`เมื่อเวิร์กโฟลว์เปิดใช้งาน`,
"label.projectManagement.creator":`ผู้สร้าง`,
"label.customfields.formula.selectreturnfieldtype":`กรุณาเลือกฟิลด์ส่งกลับของสูตร`,
"label.list.userinterface.dashboard.enable":`เปิดใช้ส่วนเสริมแดชบอร์ดใหม่`,
"label.email.delete.html.format":`การดำเนินการนี้จะลบรูปแบบ HTML ทั้งหมด คุณแน่ใจหรือไม่?`,
"label.appupload.install.modifyapi":`แก้ไขชื่อ api ที่ขัดแย้งกัน:`,
"label.chat.add.topics":`เพิ่มหัวข้อ`,
"label.savepartner.fail":`การบันทึกการตั้งค่าระบบคลาวด์พาร์ทเนอร์ล้มเหลว`,
"label.pc.query.new":`ดู    ล่าสุดของคุณ`,
"message.duplication.label.editfiltertitle":`แก้ไขตัวกรองซ้ำ`,
"label.task":`ภารกิจ`,
"label.emailobject.emaildetail.title.toaddress":`ส่งถึง:`,
"label.setup.mobile.bottombutton.select":`เลือกหน้าเพจระดับหนึ่งที่จะแสดงบนอุปกรณ์มือถือ 4 หน้า`,
"label.loginip.pagecue.invalido":`ที่อยู่ Internet ไม่ถูกต้อง`,
"label_tabpage_listshow":`แสดงรายการ`,
"component.newrecords.label.10records":`บันทึก 10 รายการ`,
"label_chatter_file":`ไฟล์`,
"pagecreator.systemstyle.label.detailcolor":`สีของรายละเอียด`,
"label.forecast.userenablepage.title":`พยากรณ์ผู้ใช้`,
"front-project-module-v1-actual_working_hours":`ชั่วโมงทำงานจริง`,
"vue_label_systemSettings_Security":`การควบคุมความปลอดภัย`,
"label.processsetting.two.select.key.fields":`ขั้นตอนที่ 2: เลือกฟิลด์สำคัญสำหรับแต่ละขั้นตอนในกระบวนการและให้คำแนะนำ`,
"label.page.display1":`บันทึก`,
"label.appointmentpage.wizard.subtitle1.2":`โซนเวลาของผู้เชิญคือ{0}`,
"label.ggReleaseRange.searchTeam":`ค้นหากลุ่มสาธารณะ`,
"chatter.group.searchGroup":`ค้นหากลุ่ม`,
"label_card_type":`ชนิดของบัตร`,
"label.appupload.managed.tip":`ถูกจัดการ คุณสามารถแก้ไขได้บางคุณสมบัติเท่านั้น`,
"label.changemyshow":`เปลี่ยนการแสดงผลของฉัน`,
"label.custom.CustomQuarter":`ไตรมาสที่กำหนดเอง`,
"label.tobedelete":`ที่จะลบ`,
"label.newPage.unuse":`หน้าเพจของคุณสูญหาย`,
"label.product.pricebooks":`สมุดราคา`,
"label.mobile.layout":`เค้าโครงเพจสำหรับอุปกรณ์มือถือ`,
"label.multilang.file.items":`{0} รายการ：`,
"label.app.step4.tabused":`แท็บที่เลือก`,
"label_ccchat_create_account":`เปิดบัญชี`,
"message.startusingprocess":`หลังจากเปิดการใช้งานกระบวนการอนุมัตินี้ คุณจะไม่สามารถเพิ่มหรือลบขั้นตอนการอนุมัติได้ คุณลักษณะขั้นตอนการอนุมัติบางอย่างก็จะไม่สามารถแก้ไขได้ ต้องการทำต่อหรือไม่?`,
"vue_label_email_please_add_a_theme":`โปรดเพิ่มหัวข้อก่อนบันทึกเป็นแม่แบบ`,
"label.please.create.a.target.record.first.":`โปรดสร้างบันทึกเป้าหมายก่อน`,
"label.processsetting.set.objandfile":`ขั้นตอนที่ 1: เลือกออบเจ็กต์และฟิลด์ที่คุณต้องการตั้งค่ากระบวนการ`,
"label.newreport.group.data":`กลุ่ม`,
"label.notcreatenew":`โปรดอย่าสร้างโอกาสทางธุรกิจใหม่ในขณะที่กำลังเปลี่ยนแปลง`,
"lable.custom.CurrentandPreviousCY":`ปีที่กําหนดเองนี้และก่อนหน้า`,
"front-epwechat-module-v1-input-androidschema":`กรุณาใส่ Android schema`,
"label.projectManagement.unfinished.quantity":`จำนวนที่ยังไม่เสร็จ`,
"label.visualpage.idandname":`id เพจและชื่อ name คือ:`,
"label.approvingprojects":`รายการที่รออนุมัติ`,
"label.partnerCloud.financeSetting.weChat":`คุณต้องเปิดบัญชีบริการวีแชท และสมัครใช้บริการเรียกเก็บเงินกับเทนเซ็นต์ โดยเทนเซ็นต์จะเรียกเก็บค่าธรรมเนียมการทำธุรกรรมจากผู้รับเงิน`,
"label.quickbooks.viewlist.view":`มุมมอง`,
"label.knowledge.category.hint.ten":`ไม่ได้เปิดใช้งานกลุ่มหมวดหมู่`,
"report_type_label_productPricebooks":`ผลิตภัณฑ์และสมุดราคา`,
"label.fenbeitong.description":`เลือกเปิดใช้งานแบบฟอร์มคำขอเดินทางเพื่อไปทำธุรกิจผ่านเฟินเป้ยทงจะช่วยให้พนักงานส่งคำขอและเบิกค่าใช้จ่ายในการเดินทางได้`,
"label.ccchat.upload.change":`มีการเปลี่ยนแปลงอะไร? (ตัวเลือก)`,
"label.emailsync.status.log":`เชื่อมต่อล็อก`,
"label.addnew":`เพิ่มใหม่`,
"UG_contact_05":`สร้างผู้ติดต่อ`,
"label.appupload.componet.queryerror":`เกิดข้อผิดพลาดระหว่างการสืบค้นส่วนเสริม โปรดติดต่อผู้ดูแลระบบ`,
"label.salescloud.setting":`การตั้งค่าการขายแบบทีม`,
"label.recurrencetimetriggeroperate":`ดำเนินการทริกเกอร์วงจร`,
"label.event.moveup.4day":`ล่วงหน้า 4 วัน`,
"No.Hisitory.Activity":`ไม่มีประวัติกิจกรรม`,
"label.validate.function.funcFormat.MINUTE":`MINUTE(date)`,
"label.recentview.seloption3":`ที่ฉันแก้ไขล่าสุด`,
"label.login.access.nopermission":`--ไม่มีสิทธิ์การเข้าถึง--`,
"label.taskmenuandlink":`ปุ่มภารกิจและลิงก์`,
"label.forecast.customforecast.foredis.sbw":`ล้าน`,
"lable.PowerProcess.created.event":`สร้างอิเวนต์สําคัญ`,
"label.stdashbord.xsld.funnelchat":`แผนภูมิกรวยการขาย`,
"label.step1.total7":`ขั้นตอนที่ 1 จาก 7`,
"label.sendsms.batch.chosepersion":`ส่งข้อความสั้นแบบกลุ่ม: เลือกผู้รับข้อความสั้น`,
"Lead.Scoring.Setting.Rule.Setup.Value":`คะแนน`,
"label.ccdocument.isdel.folder":`ต้องการลบโฟลเดอร์นี้หรือไม่?`,
"label.discard_change":``,
"label.knowledgebase.assign":`มอบหมาย`,
"PersonalInfo_LoginHistory_001":`ลิงก์ของเบราว์เซอร์ยืนยันการลงทะเบียนอีเมล`,
"label.globalselect.deletedvlaue":`ลบชุดค่าระดับโกลบอลแล้ว`,
"label.ems.lookup2":`ค้นหา`,
"label.dataimport.system.unable.determine":`ระบบไม่สามารถระบุได้ว่าหายไปไหน`,
"label.weixin.invitation.consultant":`เชิญที่ปรึกษา`,
"label.salescloud.salesdashboard.phone.rankings":`การจัดอันดับโทรศัพท์`,
"label.knowledgebase.plan.release":`กําหนดการเผยแพร่`,
"label.integrations.first.half":``,
"label.icon.123":`ชุดปฐมพยาบาล`,
"label.leadscore.isactivity":`เปิดใช้งานหรือไม่`,
"front-epwechat-module-v1-corpid":`ID วีแชทขององค์กร (Corpld)`,
"label.createnewcustomer":`สร้างลูกค้าใหม่`,
"front-lightning-module-v1-details-page-chart-tittle":`คุณสามารถเพิ่มโมดูลแผนภูมิในหน้ารายละเอียดบันทึกและแทรกแผนภูมิรายงานได้สูงสุด 10 แผนภูมิ เช่น คุณสามารถเพิ่มโมดูลแผนภูมิรายงานสําหรับบันทึกของตัวแทนจำหน่ายในออบเจ็กต์ลูกค้า เพิ่มแผนภูมิของสถิติยอดขายผลิตภัณฑ์ของตัวแทนจําหน่าย เพิ่มรายงานยอดขายรายไตรมาสของตัวแทนจําหน่ายลงในโมดูล และกรองโดยใช้ชื่อลูกค้าเพื่อดูข้อมูลที่เกี่ยวข้องโดยตรงในหน้ารายละเอียดลูกค้าของตัวแทนจําหน่าย`,
"label.customobjects.fieldsrelation":`ฟิลด์ที่กำหนดเองและความสัมพันธ์ที่เกี่ยวข้อง`,
"label.dashboardSetup.left":`ซ้าย`,
"label.mobile.app.sectionpart":`ส่วนของเว็บเพจอุปกรณ์มือถือ`,
"setup.mainpage.label.welcome25":`คําแนะนําการใช้งาน:  คลิกเมนูด้านซ้ายของหน้านี้→การตั้งค่าการจัดการ→การควบคุมความปลอดภัย→การตั้งค่าการแบ่งปัน`,
"label.custombutton.edit.error":`ข้อผิดพลาด: ชื่อนี้ถูกใช้งานอยู่หรือเคยใช้ก่อนหน้านี้ โปรดเลือกชื่ออื่น`,
"label.icon.48":`พัดลมดูดอากาศ`,
"label.tabularreport.step2":`ขั้นตอนที่ 2: เลือกคอลัมน์รายงาน`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`สัปดาห์ที่สอง`,
"UG_quota_01":`จัดการใบเสนอราคาของลูกค้า`,
"label.customcomponent.btn.usewhere":`ใช้ที่ไหน?`,
"label.quickbooks.searchresault.email":`อีเมล`,
"label.emailobject.appointment.urltext2":`เลือกเวลาที่เหมาะสม`,
"label.tianyancha.field.relation.error":`กรุณาตั้งค่าความสัมพันธ์ระหว่างฟิลด์เทียนเหยี่ยนฉาและฟิลด์ลูกค้าก่อน`,
"APPIntegration_Social_facebookerror":`ต้องเป็น URL ของ facebook.com ที่ถูกต้องตามกฎหมาย`,
"label.notification.arketsea.transfer":`{5}โอน{0}: {1}จาก{2}ไป{3}`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`อัตราการชำระเงินทั้งหมด`,
"UG.Account.04":`คิวรีการกรองลูกค้าแบบพาสซีฟ`,
"this.week":`สัปดาห์นี้`,
"label.email.track.attachment.num.control1":`ปัจจุบันจำนวนไฟล์ที่อัปโหลดเกิน 10 ไฟล์ และอัปโหลดไม่ได้แล้ว`,
"label.exchange.sync.state.event":`อิเวนต์`,
"vue_label_systemSettings_websitesetting":`การตั้งค่าเว็บไซต์`,
"vue_label_file_replace_reason":`เหตุผลในการแทนที่`,
"label.version.feature":`ฟังก์ชัน`,
"E":`อีเมล`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`แม่แบบการแจ้งเตือน`,
"label.chosesubject.meet":`การประชุม`,
"UG.ST.003":`คุณไม่ได้รับอนุญาตให้สร้าง{0} โปรดติดต่อผู้ดูแลระบบ คลิกยืนยันเพื่อเข้าสู่อินเทอร์เฟซ{0}โดยตรง`,
"label.authorization.failure":`การให้สิทธิ์ผู้ใช้ social ล้มเหลว โปรดให้สิทธิ์อีกครั้ง`,
"label.newprocessstep3":`ขั้นตอนที่ 3 กำหนดฟิลด์ผู้อนุมัติและบันทึกการแก้ไขคุณสมบัติ`,
"lable.outlook.mcto.mostrecord":`บันทึกที่มีกิจกรรมมากที่สุด`,
"vue_label_normal_select":`เลือก`,
"label.partner.workspace.login.buttontext":`ปุ่มข้อความ`,
"template.chart.ydschdtj":`สถิติแคมเปญรายเดือน`,
"label.ServiceCloud.zichanmingcheng":`ชื่อสินทรัพย์`,
"label.productsales.oppor.nooverdue":`เจ๋งมาก ไม่มีโอกาสทางธุรกิจที่ค้างชำระ`,
"label.appointment.wizard.subtitle3-5":`วันศุกร์`,
"label.payment.the.current.version":`รุ่นปัจจุบัน`,
"label.reportlist.top":`ตรึงไว้ส่วนบน`,
"label.emailobject.emaildetail.prompt":`แจ้งเตือน`,
"label.weixin.endst":`เวลาสิ้นสุดต้องอยู่หลังจากเวลาเริ่มต้น`,
"report_label_knowcreatehighlevelreport":`เรียนรู้เกี่ยวกับการสร้างรายงานขั้นสูง`,
"label.quickbooks.view.openestimates":`ประมาณการที่กําลังดําเนินอยู่`,
"label.url.cannot.empty":`URL ไม่สามารถว่างเปล่า!`,
"label.emailnoticetemplate":`แม่แบบการแจ้งเตือนอีเมล`,
"calendar.tips.task":``,
"label_partner_all_operate":`ดำเนินการ`,
"message.duplication.label.cancelbutton":`ยกเลิก`,
"vue_label_SMS_addcontact":`เพิ่มผู้ติดต่อ`,
"label.martrixreport.setsumfield2":`เลือกฟิลด์ที่จะใช้เป็นคอลัมน์สรุปในรายงานเมตริกซ์ของคุณ`,
"approval_request_email_body":`สวัสดี โปรดอนุมัติรายการต่อไปนี้：\n      คลิกที่ลิงก์：\n`,
"label.emailobject.emaildetail.field.record":`บันทึก`,
"label.tab.page":`หน้าเพจ`,
"label_tabpage_prepagez":`แต่ละหน้าแสดง`,
"label.iran.daylight.time":`เวลามาตรฐานอิหร่าน`,
"label.event.nextweek":`สัปดาห์หน้า`,
"fliter.lastmonth":`เดือนที่แล้ว`,
"label.group.no.recent.search":`ไม่มีกลุ่มที่ดูล่าสุดที่ตรงกัน`,
"label.h5.act.confirm":`ยืนยัน`,
"label_tabpage_mypotentialcustomers":`ลีดของฉัน`,
"label.tabpage.queuez":`คิว`,
"label.batch.edit.description":`เลือกฟิลด์ที่ต้องการแก้ไขอย่างน้อยหนึ่งฟิลด์และอย่างมากห้าฟิลด์`,
"label.batchadd.newbatchpage.deltr":`เก็บอย่างน้อยหนึ่งแถว`,
"label.industrialandcommercialverification.instructions2":`รุ่นสำหรับใช้ฟรีที่คุณใช้อยู่ในปัจจุบัน จำนวนอินเทอร์เฟซการสอบถามจำกัดที่ 10,000 ครั้งต่อวัน  หากคุณต้องการเพิ่มจำนวนการสอบถาม แนะนำให้ซื้อการบริการ หลังจากซื้อการบริการแล้วให้รับ token จากบริษัทและมากำหนดค่าในหน้านี้ บริษัทให้บริการการชำระเงินที่เกี่ยวข้อง`,
"label.rejectrequestbehaviour":`ปฏิเสธขั้นตอนนี้ทั้งหมด <strong> และ </strong> ปฏิเสธขั้นสุดท้ายทั้งหมด (ปฏิเสธขั้นสุดท้าย)`,
"label.batchCopy":`คัดลอกแบบชุด`,
"label.service.two":`มีบางเงื่อนไขการกรองที่กำหนดแล้วแต่ไม่ถูกอ้างถึงใน \"เงื่อนไขการกรองขั้นสูง\"`,
"label.data.import.setup.detail.remark":`หากเลือกตัวเลือกต่อไปนี้ จะดำเนินการเมื่อนำเข้าข้อมูล`,
"vue_label_file_delete_lib":`ลบไลบรารีเอกสาร`,
"label.integerdigit":`จำนวนหลักทางด้านซ้ายของจุดทศนิยม`,
"label.profile.standardobjcontrol":`สิทธิ์ออบเจ็กต์มาตรฐาน`,
"label.reportrecords":`รายการบันทึก`,
"label.noplan":`คุณไม่มีกําหนดการสำหรับเจ็ดวันข้างหน้า`,
"label.visualpage.ytype":`แดชบอร์ด`,
"label.branch":`;`,
"label.knowledgebase.new.article":`บทความใหม่`,
"label.Addressbook":`บัญชีที่อยู่`,
"label.delete.reward.groups":`ลบกลุ่มบรรทัดใบเสนอราคา`,
"label.appexchange.uninstallpage.message1":`ลบส่วนเสริมทั้งหมดในโปรแกรมสำเร็จรูปนี้อย่างถาวร (ตามรายการด้านล่าง)`,
"chatter.group.everyone":`ผู้ใช้ทั้งหมด`,
"label.cooperation":`ความร่วมมือ`,
"label.uploadfail":`การอัปโหลดล้มเหลว`,
"to":`ถึง`,
"button_partner_delete":`ลบ`,
"attachment_select_warning_001":`ไฟล์แนบที่จะจัดเก็บถาวร ปุ่มจัดเก็บถาวรไม่พร้อมใช้งาน  โปรดเลือกไฟล์แนบใหม่อีกครั้ง`,
"label.step4.total4":`ขั้นตอนที่ 4 จาก 4`,
"label.login.access.avalid":`หมดอายุวันนี้`,
"label.defaultview2":`ค่าเริ่มต้นมุมมอง`,
"vue_label_commonobjects_detail_style":`สไตล์การซื้อ`,
"label.selectfield":`เลือกฟิลด์`,
"label.report.select.column.collect":`เลือกคอลัมน์ที่จะสรุป`,
"lable.currencyAdv.newdaterate.existeddate":`มีเวลานี้แล้ว`,
"pagecreator_systemstyle_button_new":`รูปแบบใหม่`,
"label.ccchat.person.invite":`คําเชิญจากเพื่อนร่วมงาน`,
"label.sendemail.recycle.clear":`ดำเนินการล้างถังขยะรีไซเคิล`,
"label.usermanage.view.notexist":`ไม่มีมุมมอง`,
"setup_chatter_enabled":`ปิดการใช้งาน โปรดติดต่อผู้ดูแลระบบเพื่อเปิดใช้งานเวยเทีย`,
"UG.Contract.01":`จัดการสัญญา`,
"label.martrixreport.2018.step4":`ขั้นตอนที่ 4: เลือกรายงานมาตรฐาน`,
"message.errorinscript":`เกิดปัญหาในการเรียกใช้สคริปต์!`,
"label.knowledgebase.modification.date":`วันที่แก้ไข`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`ค่าใช้จ่ายสามารถป้อนได้สูงสุด 10 หลัก`,
"label.list.isActiveNewApproval":`ต้องการเปิดใช้งานหน้าแรกการอนุมัติใหม่หรือไม่`,
"label.mobile.main.page.icon.setup":`การตั้งค่าไอคอนเดสก์ท็อปสำหรับอุปกรณ์มือถือ`,
"label.select.customer":`เลือกลูกค้า`,
"label.sharerule":`ตั้งค่าการแบ่งปัน`,
"label.fiscal.FY":`ปีงบประมาณ`,
"label.appupload.component.type.customfield":`ฟิลด์ที่กำหนดเอง`,
"label.emailobject.emailsend.sendindividually":`ส่งแยก`,
"label.new_formname":`ชื่อฟอร์มใหม่`,
"label.appointment.wizard.notif1":`เวลาสิ้นสุดไม่ควรมาก่อนเวลาเริ่มต้น`,
"front-console-conversation-evaluate-desc":``,
"homepage.components.lasttime":`เวลาแก้ไขล่าสุด`,
"vue_label_commonobjects_view_chart_deletechart":`ลบแผนภูมิ`,
"label.multilang.document.upload.fail":`อัปโหลดสำเร็จ {0} ไฟล์ และล้มเหลว {1} ไฟล์`,
"UG_contact_03":`ติดตามผู้ติดต่อและสัญญาณการขายในที่เดียว`,
"label.marketsea.istoseafromother":`อนุญาตให้ฐานข้อมูลอื่นโอนเข้าได้`,
"label.datamanage":`จัดการข้อมูล`,
"label.globaloperation.operationtype.create.data":`สร้างบันทึก`,
"label.customer.tab.step2.see":`แท็บที่มองเห็น`,
"label.wtd.changefields.desc":`หลังจากผู้ใช้ส่งแบบฟอร์มแล้วจะเห็น URL ย้อนกลับตามที่กำหนด เช่น หน้า "ขอบคุณ"`,
"label.ems.eamilinfo":`ข้อมูลอีเมล`,
"label.recordtypeselect.new":`ชนิดบันทึกใหม่`,
"vue_label_report_output":`ประเภทผลลัพธ์ของสูตร`,
"label.emailnotice":`การแจ้งเตือนอีเมล`,
"label.icon.196":`กระดาษชำระ`,
"label.emailsync.status.disabel":`ปิดการใช้งาน`,
"label.tabpage.isdeleterecord":`ลบบันทึกที่เลือกหรือไม่`,
"message.selectoneoftypes":`โปรดเลือกหนึ่งประเภทจากตัวเลือกดังต่อไปนี้`,
"label.import.index.createid":`สร้าง ID`,
"vue_label_systemSettings_social2":`การตั้งค่าบัญชีโซเชียลมีเดีย`,
"label.ccpeak.sel.time":`คลาสตัวจับเวลาในโฟลเดอร์นี้`,
"label.data.downpage.i_list.desc1":`ระหว่างการนำเข้า เนื่องด้วยรูปแบบข้อมูลไม่ถูกต้อง หรือเนื่องด้วยทริกเกอร์หรือเกณฑ์การทวนสอบตรวจสอบล้มเหลว ข้อมูลทั้งหมดที่นำเข้าไม่สำเร็จจะถูกสร้างเป็นไฟล์ csv และแสดงในหน้าปัจจุบัน ส่วนข้อมูลที่นำเข้าสำเร็จจะไม่แสดงในหน้าปัจจุบัน`,
"label_adjust_forecast":`ปรับการพยากรณ์`,
"vue_label_normal_lead_sf":`ลีด`,
"vue_label_report_notice1":`รายงานมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก ซึ่งถ้าปิดรายงานจะสูญหายไป และสามารถบันทึกการเปลี่ยนแปลงได้ด้วยการคลิกปุ่ม "บันทึกและปิด" ด้านล่าง`,
"label.notfiledpublicreport":`รายงานสาธารณะที่ไม่ได้จัดเก็บถาวร`,
"one":`หนึ่ง`,
"UG.Lead.008":`สแกนนามบัตร`,
"label.archived":`จัดเก็บถาวรแล้ว`,
"label.standardabstractfield":`ฟิลด์บทคัดย่อมาตรฐาน`,
"vue_label_notice_add_fail":`การเพิ่มล้มเหลว`,
"label.sendemail.registIMUser.addresserror":`ที่อยู่ผู้รับอีเมลไม่ถูกต้อง`,
"label.ccdocument.toolbar.switch":`เปลี่ยนแถบเครื่องมือ`,
"first":`ลำดับที่หนึ่ง`,
"label.icon.147":`เมาส์`,
"vue_label_jihui_er":`โอกาสที่ 2`,
"label.ccchat.micropost.isedit":`การแก้ไขโพสต์และความคิดเห็น`,
"label.department.next":`หน้าถัดไป`,
"front-kefu-moudle-confirm-disable-phone-user":``,
"label.reportsSubscription.time.meets.subscription.frequency":`วันที่สิ้นสุดและเริ่มต้นไม่สอดคล้องกับความถี่ในการสมัครสมาชิก!`,
"lable.account.NextpDays":`120 วันถัดไป`,
"UG_opportunity_007":`บทบาทผู้ติดต่อ`,
"label.encrypt":`เข้ารหัส`,
"label.knowledge.category.hint.three":`การลบหรือแทนที่กลุ่มหมวดหมู่ที่มีอยู่จะลบหมวดหมู่ทั้งหมดที่เกี่ยวข้องกับบทความ`,
"label.customcomponent.usewhere.info":`ด้านล่างเป็นการอ้างอิงถึงส่วนเสริมนี้ทั้งหมด คลิกป้ายอ้างอิงเพื่อดูคำจำกัดความ`,
"vue_label_import_addandupdate":`เพิ่มและอัปเดต`,
"label.email.all.members":`ส่งอีเมลถึงสมาชิกในทีมทั้งหมด`,
"component_task_button_save":`บันทึก`,
"label.file.deleted.unavailable.desc":`ไฟล์นี้ถูกลบ ไม่มีอยู่ หรือไม่สามารถดูตัวอย่างได้`,
"label.emailsync.status.viewlog":`ดูล็อก`,
"label.marketsea.othersetup":`การตั้งค่าอื่นๆ`,
"label.data.exp.newtemppage":`หน้าการสร้างแม่แบบ`,
"vue_label_lead_score_successsful":`การให้คะแนนสำเร็จ`,
"label.sendemail.activity.newtask":`#belongtoidccnameที่เคารพ สวัสดี: \ r \ n
เพื่อนร่วมงานของคุณ #createbyidccname มอบหมายงานใหม่ให้คุณเมื่อ #createdate เนื้อหา มีดังนี้: \ r \ n 
หัวข้อ: #subject \ r \ n 
วันหมดอายุ: #expireDate \ r \ n 
รายการที่เกี่ยวข้อง : #relatedstr \ r \ n 
เนื้อหา: #remark \ r \ n 
สำหรับรายละเอียด โปรดไปที่ลิงก์นี้: \ r \ n #path \ r \ n 
#orgNameCRM system`,
"component.event.label.soon":`ทันที`,
"label.forecast.shrepage.getlist":`กลับไปที่ลำดับชั้นการพยากรณ์`,
"UG.solution.02":`โซลูชันคือโซลูชันภายในสำหรับแก้ไขปัญหาที่ลูกค้าพบ`,
"label.weixin.data.approval":`บันทึกอยู่ระหว่างการตรวจสอบ`,
"label.build.pagelist":`รายการหน้าตัวสร้างเพจ`,
"label.customsetting.type.hiberarchy":`แผนผังลำดับขั้น`,
"label.forecast.ccfh":`เล่นยาวเป็นพิเศษ`,
"label.Current.Window":`หน้าต่างปัจจุบัน`,
"label.appointmentdetail.wizard.title20":`แผนงานวันอาทิตย์`,
"label.emailaddress":`ที่อยู่อีเมล`,
"label.qetting_notifications":`ไม่ได้รับอีเมลจากเรา? โปรดตรวจสอบให้แน่ใจว่าคุณได้เพิ่มที่อยู่อีเมล CloudCC ลงในไวท์ลิสต์ของคุณและอนุญาตให้ส่งออกการแจ้งเตือน`,
"Homepage.News.001":`ข่าวสาร`,
"label.runreport":`เรียกใช้รายงาน`,
"label.customer.tab.step3":`ขั้นตอนที่ 3 เพิ่มลงในแอปพลิเคชันที่กำหนดเอง`,
"label.dashboard.snapshot.refresh":`รีเฟรช`,
"label.approvepagelayout3":`ปรับแต่งเค้าโครง`,
"vue_label_SMS_send_messages":`ส่งข้อความสั้น`,
"label.executestate.old":`ดำเนินการแล้ว`,
"label.approvalstep3":`ขั้นตอนที่ 3 เลือกผู้อนุมัติที่ได้รับมอบหมาย`,
"label.step3.total6":`ขั้นตอนที่ 3 จาก 6`,
"front-kefu-moudle-v1-delete-templete":`ลบแม่แบบ`,
"label.data.downpage.e.title.num3":`3. ผู้ใช้สามารถสร้างแม่แบบการส่งออกตามความต้องการของตนเอง เมื่อส่งออกข้อมูลก็อย่างง่ายดายโดยกดเลือกการส่งออกตามแม่แบบ`,
"label.attendance.outer":`ทำงานนอกสถานที่`,
"setup_layout_button_selectall":`เลือกทั้งหมด`,
"chatter.photo.img":`ขนาดไฟล์สูงสุดคือ 2M`,
"front-dynamiclayout-module-v1-required":`ฟิลด์ {required} ถูกตั้งค่าเป็นฟิลด์บังคับ`,
"label.mytask":`ภารกิจของฉัน`,
"label.edit.customerinfo":`อัปเดตโปรไฟล์บริษัท`,
"label.processsetting.process.explain":`ด้วยขั้นตอนการตั้งค่าและการใช้งาน ผู้ใช้สามารถมุ่งเน้นไปที่เรื่องที่สำคัญที่สุด แสดงคีย์เวิร์ดและเคล็ดลับสำหรับผู้ใช้ในเวลาที่เหมาะสม และช่วยให้ผู้ใช้ดำเนินการตามกระบวนการให้เสร็จสิ้น`,
"label.emailobject.subject":`หัวข้อ`,
"label.mobileapp.scansetting.message":`เลือกว่าจะบันทึกนามบัตรที่สแกนในรูปแบบภาพลงในรายการที่เกี่ยวข้อง "หมายเหตุและไฟล์แนบ" ของบันทึกหรือไม่ <br>เมื่อเลือก เปิดใช้งาน: นามบัตรจะถูกบันทึกโดยอัตโนมัติในไฟล์แนบของบันทึกตอนที่บันทึก <br>เมื่อเลือก ปิดการใช้งาน: จะบันทึกเฉพาะบันทึกเท่านั้น`,
"front-epwechat-module-v1-android-autograph":`ลายเซ็นแอป Android:`,
"label_component_helper_potentialcustom":`ลีดที่มอบหมายให้คุณวันนี้`,
"label.projectManagement.nodata.week.work":`มาเพิ่มงานเพื่อให้งานของสัปดาห์นี้สมบูรณ์ยิ่งขึ้นกันเถอะ`,
"label_tabpage_rolez":`บทบาท`,
"label.importsourcestep4":`ขั้นตอนที่ 3: นำเข้าไฟล์ของคุณ`,
"label.icon.50":`เข็มทิศ`,
"lable.service.prompt":`จำนวนฟิลด์เกินขีดจำกัดไม่สามารถสร้างฟิลด์ได้`,
"label.campaign.channel.input.page":`หน้าเว็บที่กำหนด โดยทั่วไปสามารถตั้งค่าหน้าแรกของกิจกรรมเป็นหน้าขอบคุณได้`,
"UG.homepage.001":`ปิดการขายสำเร็จมากขึ้นในเวลาที่สั้นลง`,
"label.step4.total6":`ขั้นตอนที่ 4 จาก 6`,
"label.partner.required":`ข้อผิดพลาด: ชื่อโดเมนไม่สามารถว่างเปล่า`,
"label.tag.manage.title":`จัดการป้ายกำกับ-{0}`,
"label.data.downpage.i_title.num1":`1. ระบบรองรับเฉพาะรูปแบบ CSV ทั่วไป`,
"label.custom.quarter.end":`วันสิ้นสุดไตรมาสที่กำหนดเอง`,
"label.layout.distribute":`กำหนดเค้าโครงเพจ`,
"label.version.allsms":`ส่งข้อความสั้นแบบกลุ่ม`,
"label.tolead":`นำเข้า`,
"label.texttemplate.usemergefields":`ใช้ฟิลด์ผสานในแม่แบบข้อความสั้น`,
"label.emailobject.sure":`ยืนยัน`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`ต้องการเปิดใช้งานการสร้างใหม่และการแก้ไข H5 บนอุปกรณ์มือถือหรือไม่`,
"label.tabpage.messagez":`กรุณาใส่ความคิดเห็น`,
"label.mobile.phone.write.day.report":`เขียนรายงานประจำวัน`,
"label.data.setok.e.desc2":`หน้ารายการข้อมูลส่งออก`,
"label.emailsync.message":`แจ้งเตือน`,
"label.sales.page.mubiao":`บรรลุเป้าหมาย`,
"label.ccdocument.list":`ดูเอกสารล่าสุดของคุณ`,
"label.tabpage.userGuidez":`คู่มือผู้ใช้`,
"label.report.fields":`ฟิลด์ที่รายงานสามารถใช้ได้`,
"vue_label_checkduplicate_at_same_time":`พร้อมกันทั้งหมด`,
"label.sms.phone":`เกตเวย์ข้อความสั้นบริการลูกค้าผ่านทางเครือข่ายโทรศัพท์`,
"UG_ST_004":`คุณไม่มีสิทธิ์ในการจัดการ-》และการนำเข้าข้อมูล กรุณาติดต่อผู้ดูแลระบบ คลิกตกลงและเข้าสู่อินเทอร์เฟซ{0}โดยตรง`,
"label.mobile.nobindmobile":``,
"label.partnerCloud.basicSetting.intro":`CloudCC ช่วยให้คุณสามารถสร้างไซต์หลายไซต์สําหรับพาร์ทเนอร์ประเภทต่างๆ โดยการกําหนดค่าหน้าลงชื่อเข้าใช้ แท็บที่ใช้ได้ สิทธิ์การใช้งาน เพื่อตอบสนองความต้องการทางธุรกิจที่หลากหลายของบริษัท ตัวอย่างเช่น ผู้ค้าปลีกสามารถสร้างไซต์ต่างๆ สําหรับตัวแทนจําหน่ายในท้องถิ่น และพันธมิตรด้านโฆษณา`,
"label.trigger.targetobject":`ออบเจ็กต์เป้าหมาย`,
"label.ems.emailsyncperiod":`ช่วงเวลาการซิงค์อีเมล`,
"lable.Transformation.mode":`วิธีการแปลง`,
"label.emailobject.new.template":`สร้างแม่แบบ`,
"label.System.Setting":`การตั้งค่าระบบ`,
"label.emailtocloudcc.button.addemailaddress":`เพิ่มอีเมลธุรกิจ`,
"lable.a.total.of.invoices":`รวม 0 invoice`,
"label.multilang.customforcast.forecasthistory":`ประวัติการพยากรณ์ของ{0}`,
"label.role":`บทบาท`,
"advancedconditions":`เงื่อนไขตัวกรองขั้นสูง`,
"label.tabpage.beginz":`เริ่มต้น`,
"label.campagin.roi.khzhsl":`จำนวนลูกค้าข้ามสเตจ`,
"chatter.poll.option5":`ตัวเลือกที่ 5`,
"label.weixin.horse.club.registered":`ลงทะเบียนผู้ใช้ aid-max`,
"frame_personinfo_label_resizeimage":`หากต้องการปรับภาพขนาดย่อของคุณ กรุณาลากและวางรูปโปรไฟล์บนเส้นประ`,
"label.file.share.select.warning":`ตั้งค่าการแบ่งปันแล้ว!`,
"label.event.this.week":`อิเวนต์ของสัปดาห์นี้`,
"label.data.import.object.label":`ป้ายกำกับออบเจ็กต์`,
"label.visualpage.folder":`โฟลเดอร์หน้าเพจที่ไม่ได้จัดเก็บถาวร`,
"vue_label_report_saveandclose":`บันทึกและปิด`,
"label.newdashboardpage.saveto":`บันทึกไปยัง`,
"label.partnerCloud.financeSetting.developerIDTwo":`ID นักพัฒนา`,
"lable.PowerProcess.created.ago.please":`ก่อนสร้างกระบวนการ โปรด`,
"label.chatter.myfollowers":`ผู้ติดตามของฉัน`,
"label.campaignmember.main.duplicatelist.title":`สมาชิกแคมเปญ: สแกนรหัสและรีเซ็ตการตั้งค่า`,
"label.group.no.recent2":`ค้นหากลุ่มที่เข้าร่วมแล้ว`,
"label.icon.110":`หนังสือ`,
"label.merge.my.account":`ผสานลูกค้าของฉัน`,
"setup.layout.button.quicksave":`บันทึกด่วน`,
"pagecreator.page.message.canntdelete":`ไม่อนุญาตให้ลบหน้าเพจปัจจุบัน`,
"label.report.printable.view":`มุมมองที่พิมพ์ได้`,
"ccchat_fieldtrack_fieldchange":`เปลี่ยนจาก {0} เป็น {1}`,
"label.email.bcc":`สำเนาลับ`,
"label.sso.saml.sp.idpcert":`ใบรับรองผู้พิสูจน์และยืนยันตัวตน`,
"label.step2.total2":`ขั้นตอนที่ 2 จาก 2`,
"lable.product.pricebooks.isn":`สมุดราคาที่เปิดใช้งาน`,
"labal.emailtemplate.namemassage":`มีชื่อเฉพาะของแม่แบบอีเมลนี้แล้ว โปรดแก้ไขอีกครั้ง`,
"only.one.field":`สามารถเลือกได้เพียงหนึ่งฟิลด์เท่านั้น`,
"label.weixin.appr.audittime":`เวลาตรวจสอบ`,
"pagecreator.page.button.delete":`ลบ`,
"front-kefu-moudle-v1-Session-start-time":``,
"label_chatter_state":`สถานะ`,
"vue_label_systemSettings_lightningcustom":`UI แบบกำหนดเองของ Lighting`,
"label.searchs":`ค้นหา`,
"label.mobile.phone.not.read":`ยังไม่ได้อ่าน`,
"label_chatter_allweather":`ทุกโอกาส`,
"label.enter.number":`กรุณาใส่จำนวนเต็มระหว่าง 0 ถึง 6`,
"front-epwechat-module-v1-addressbook-desc":`เมื่อคุณเปิดการซิงค์ บุคคลและแผนกในรายชื่อวีแชทขององค์กรจะซิงค์กับผู้ใช้และบทบาทใน CloudCC โดยอัตโนมัติ`,
"label.emailfield":`ฟิลด์อีเมล`,
"pagecreator_button_next":`ขั้นตอนถัดไป`,
"label.more.select.merge.records":`เลือกบันทึกที่จะผสานได้สูงสุดสามรายการเท่านั้น`,
"lable.edit.queue.selobjct":`ออบเจ็กต์ที่เลือก`,
"label.reportsSubscription.editsubscribe":`แก้ไขการสมัครสมาชิก`,
"label.selectfieldtoautotransmit":`เลือกฟิลด์สำหรับการส่งการอนุมัติอัตโนมัติ`,
"label.ccpeak.need.topass":`ต้องผ่าน`,
"label.checkfield.merge":`ผสาน`,
"front-lighting-module-v1-detail-file-downlaodInfo":`บันทึกถูกล็อกและไม่สนับสนุนการดาวน์โหลดไฟล์ โปรดติดต่อผู้ดูแลระบบเพื่อปลดล็อก`,
"vue.please.enter.a.chart.name":`กรุณาใส่ชื่อแผนภูมิ`,
"label.data.dataexptemplate.desc3":`3. วิธีการส่งออกมีผลกับข้อมูลที่ส่งออกเท่านั้น ไม่มีผลกับแม่แบบการส่งออก ไฟล์ของแม่แบบการส่งออกเป็นรูปแบบ CSV`,
"label.setup.mobile.homepageshortcuts.setting":`การตั้งค่าฟังก์ชันทางลัดของหน้าแรกอุปกรณ์มือถือ`,
"label.ems.connect.success":`ตรวจพบอีเมล`,
"label.applet.text":``,
"label.knowledgebase.parent.window":`หน้าต่างหลัก`,
"label_file_size":`ใช้พื้นที่`,
"label.allocation.department":`กำหนดผู้ใช้`,
"label.browser":`เบราว์เซอร์`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`วันพุธ`,
"label.integrations.description1":`ส่งออกข้อมูลทั้งหมดในมุมมองปัจจุบัน`,
"label.project360":`โครงการ 360`,
"label.choose_formtype":`เลือกประเภทฟอร์มของคุณ`,
"label_emailsync_status_connectstatus":`สถานะการเชื่อมต่อ`,
"label.bmap.beijing.city":`กรุงปักกิ่ง`,
"label.mask.encryption.scheme":`รูปแบบการเข้ารหัสลับ`,
"label.imgfield.type":`ประเภทรูปภาพ`,
"label.person.target.responsible":`เลือกผู้รับผิดชอบเป้าหมาย`,
"label.appexchange.installedpage.installdate":`วันที่ติดตั้ง`,
"label.partnerCloud.orderingPlatform.partnerUsers":`ฟังก์ชั่นนี้มีไว้สําหรับผู้ใช้พาร์ทเนอร์เท่านั้น`,
"label.profile.customfieldsafety":`ความปลอดภัยระดับฟิลด์ที่กำหนดเอง`,
"label.no.target.models.available.":`ไม่มีแบบจำลองเป้าหมาย โปรดสร้างแบบจําลองเป้าหมายก่อน หรือติดต่อผู้ดูแลระบบ`,
"label.process.execute.tip":`คำขอของคุณได้รับการดำเนินการแล้ว การอนุมัติแบบชุดต้องใช้ระยะเวลา ระบบจะส่งอีเมลแจ้งให้คุณทราบหลังจากการดำเนินการเสร็จสิ้น`,
"label.app.step2.introduce":`กรอกข้อมูลในฟิลด์ด้านล่างเพื่อกำหนดแอปพลิเคชันที่กำหนดเอง`,
"label.loginip.cue":`ไม่ได้ระบุช่วง IP สำหรับการเข้าสู่ระบบ อนุญาตให้ผู้ใช้เข้าสู่ระบบจากที่อยู่ IP ใดก็ได้`,
"label.step1.select.tablayout":`ขั้นตอนที่ 1: เลือกเค้าโครงแท็บ`,
"mainpage.setup.chosecomponent.leastone":`ต้องวางอย่างน้อยหนึ่งส่วนเสริมในหน้าแรก`,
"label.custom.quarter.name":`ชื่อไตรมาสที่กำหนดเอง`,
"chatter.ptup.link":`เผยแพร่ลิงก์`,
"label.compact.layout.frame.error2":`รายละเอียดและรายการที่เกี่ยวข้องจะต้องอยู่ด้านซ้ายของหน้าจอ`,
"vue_label_salesfunnel_notice7":`ความน่าจะเป็นของจำนวนโอกาสทางธุรกิจทั้งหมด 100% /ความน่าจะเป็นของจำนวนโอกาสทางธุรกิจทั้งหมด 0% หรือ 100%`,
"label.multilang.datamanage.dataimport.lostmsg":`ความยาวของหัวข้อคือ&nbsp;{0}&nbsp แต่ความยาวของข้อมูลคือ&nbsp;{1}&nbsp ระบบไม่สามารถระบุได้ว่าฟิลด์&nbsp;{2}&nbspใดที่หายไป`,
"label.owner.notnull":`เจ้าของไม่สามารถว่างเปล่า`,
"label.logintime.pagecue.invalidt":`เวลาเริ่มต้นต้องไม่มากกว่าเวลาสิ้นสุด`,
"vue_label_file_checked_num_limit":`จำนวนไฟล์ที่เลือกเกินขีดจำกัด`,
"front-email-payment-repayments":``,
"template.report.today.prospects":`ลีดในวันนี้`,
"label.weixin.appr.status":`สถานะการอนุมัติ`,
"label.knowledge.language.japanese":`ภาษาญี่ปุ่น`,
"label.event.reminder.lead.time":`ช่วงเวลานำการแจ้งเตือนอิเวนต์`,
"lable.custom.dep":`คลิกปุ่ม "สร้างใหม่" เพื่อกำหนดปีที่กำหนดเองใหม่`,
"Dashboard_View_Createdbyme":`แดชบอร์ดที่สร้างโดยฉัน`,
"label.file.upload.fail":`การอัปโหลดไฟล์ล้มเหลว`,
"label.manager":`ผู้จัดการ`,
"label.stdashbord.xsld.business.jine":`ยอดเงินรวม`,
"label.tag.manage.tag":`ป้ายกำกับ`,
"chatter.nlk":`ไม่ชอบ`,
"label.file.search.people":`ค้นหาพนักงาน`,
"message.error.domain.format":`ชื่อโดเมนสามารถประกอบด้วยภาษาอังกฤษและอาร์เรย์`,
"label.firstisdefault":`ใช้ค่าแรกเป็นค่าเริ่มต้น`,
"label.discount":`ส่วนลด`,
"label.mobile.phone.have.read":`เปิดอ่านแล้ว`,
"label.field_selected":`ฟิลด์นี้ถูกเลือกแล้ว`,
"label.payment.renew.now":`ต่ออายุตอนนี้`,
"label.multilang.lookfiltercondition.notsetup":`เงื่อนไขแถวที่ {0} ไม่ถูกต้อง ไม่ได้ตั้งค่าตัวดำเนินการ!`,
"label.projectManagement.Selectionday":`เลือกวัน`,
"label.user.organization.permit.licensenotstart":`ใบอนุญาตขององค์กรคุณยังไม่ถึงเวลาเปิดใช้งาน กรุณาลองอีกครั้งหลังจากใบอนุญาตเปิดใช้งานแล้ว`,
"label.download.save.attachment":`ดาวน์โหลดและบันทึกลงในไฟล์แนบ`,
"lable.outlook.mcto.must":`ต้องอยู่ในรูปแบบอีเมล`,
"vue_label_notice_unfollow_success":`การเลิกติดตามสำเร็จ`,
"label.taskinfo":`ข้อมูลภารกิจ`,
"label.other.SMS":`หมายเลขโทรศัพท์มือถืออื่นๆ`,
"label_partner_workspace_login_logo":`โลโก้ส่วนหัว`,
"label.weixin.data.lock":`บันทึกถูกล็อก`,
"label.Yaxis":`แกน Y`,
"lable.edit.queue.selobjdes":`เลือกออบเจ็กต์ที่จะกำหนดให้กับคิวนี้ จากนั้นคิวนี้จะเป็นของบันทึกของออบเจ็กต์เหล่านี้ได้`,
"label.campagin.roi.dcfezb":`สัดส่วนการเข้าร่วม`,
"label.marketseamemset.maximum":`จำนวนมากที่สุด`,
"label.owner":`เจ้าของ`,
"label.reportsubscribe.error.noview":`โปรดเลือกมุมมองเพื่อเรียกใช้รายงานใน"เรียกใช้รายงานจากมุมมองของผู้ใช้ต่อไปนี้"`,
"label.icon.133":`โฟลเดอร์`,
"vue_label_file_share_files":`แบ่งปันไฟล์`,
"label.searchlayoutfilterfields.remark":`เลือกฟิลด์เงื่อนไขการกรองที่จะแสดงเมื่อค้นหาในแท็บหรือแถบด้านซ้ายของหน้าเว็บ`,
"vue_label_help_contract":`สัญญาและแผนการเก็บเงิน`,
"component.chatter.button.message":`ความคิดเห็น`,
"label.marketsea.recyclereminddays2":`วันแจ้งเตือน (ต้องน้อยกว่าจำนวนวันที่ไม่มีการติดตามหลังจากได้รับ)`,
"label.webtocloudcc.input.information":`กรุณากรอกข้อมูล!`,
"vue_label_chatter_exit_group":`ออกจากกลุ่ม`,
"vue_label_lead_notcreatetask":`ไม่สร้างภารกิจ`,
"front-lightning-module-v1-dashborad-date-dimension":`มิติวันที่`,
"setup.layout.label.fieldlist":`ฟิลด์พร้อมใช้งาน`,
"label.leadscore.charname":`ชื่อฟิลด์`,
"label.forecast.customforecast.mybest":`ประสิทธิภาพยอดเยี่ยมของฉัน`,
"setup_mainpage_label_welcome24":`แพลตฟอร์มคลาวด์ CloudCC ให้การตั้งค่าการเข้าถึงอย่างปลอดภัยสำหรับข้อมูลออบเจ็กต์ทั้งหมดในระบบซึ่งสามารถควบคุมการแบ่งปันข้อมูลและสิทธิ์การเข้าถึงโดยการตั้งค่ากฎเกณฑ์และเงื่อนไขต่างๆ`,
"label.queue":`คิว`,
"label.icon.159":`ชิป`,
"label.path":`ต้องการอ้างอิงพาธ`,
"label.app.message.failtoget":`การรับรายการแอปพลิเคชันล้มเหลว`,
"label.returntoprocess":`กลับไปที่รายการกระบวนการอนุมัติ`,
"vue_label_commonobjects_detail_more_data":`ไม่มีข้อมูลเพิ่มเติม`,
"label.number":`ตัวเลข`,
"label.product.find":`ค้นหาสมุดราคา`,
"label.legend":`คำอธิบายสัญลักษณ์`,
"label.partner.workspace.member.profile":`ตัวเลือกโปรไฟล์`,
"label.service.gantt.sum.appointments":`จํานวนการนัดหมายการบริการที่เสร็จสิ้น / จํานวนการนัดหมายการบริการทั้งหมด`,
"label.partnerCloud.financeSetting.paymentAllowed":`อนุญาตให้เติมเงินออนไลน์`,
"label.integrations.upgrate":`อัพเกรด`,
"label.timzone.tip.info3":`เมื่อใช้คลาส Calendar จัดการวันที่ ควรตั้งค่าโซนเวลาอินสแตนซ์ให้กับ Calendar วิธี get ออบเจ็กต์ Calendar สามารถเลือกจากสองประเภทต่อไปนี้ Calendar cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo)) และ Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`เพิ่มบัญชีอีเมล`,
"label.partneruser":`ผู้ใช้พาร์ทเนอร์`,
"label.validate.globalvariable.user.roleId":`ID บทบาท`,
"pagecreator.layout.button.mergecell":`ผสานเซลล์`,
"label.evacuantvalue":`ค่าการรั่วไหล`,
"label.setup.mini.msg":`การตั้งค่าเรื่องราวของแบรนด์/ข้อความ`,
"label.icon.178":`คน`,
"vue_label_pricebook_notice_cantbedeleted":`ไม่สามารถลบสมุดราคาเนื่องจากมีบันทึกที่ใช้สมุดราคานี้อยู่ คุณสามารถติดป้ายสมุดราคาว่าปิดการใช้งานแทนได้`,
"vue_label_appstore_application_recommendation":`แนะนำแอปยอดนิยม`,
"label.version.createlimit":`CloudCC รุ่นปัจจุบันของคุณ คือ{0} สามารถสร้าง{2)ได้ {1} ถึงขีดจำกัดแล้ว! หากมีความจำเป็น กรุณาอัปเกรดรุ่น CloudCC!`,
"message.duplication.label.sectionremar1":`โปรดเลือกค่าที่คุณต้องการเก็บไว้ในบันทึกที่ผสาน บรรทัดที่ไฮไลต์บ่งชี้ว่าฟิลด์มีข้อมูลที่ขัดแย้งกัน บันทึกหลักที่เลือกจะเก็บค่าฟิลด์แบบอ่านอย่างเดียวและค่าฟิลด์ที่ซ่อนไว้`,
"label.icon.1":`เมฆ`,
"label.salescloud.salesdashboard.sales.performance":`ภาพรวม-ผลสำเร็จของสัญญาขาย`,
"System_AddressFieldType_Post":`รหัสไปรษณีย์`,
"setup_object_field_dependency_label_mustone":`กรุณาตั้งค่าฟิลด์พึ่งพาอย่างน้อยหนึ่งค่า`,
"label.appointmentdetail.wizard.title6":`สถานที่`,
"label.layout.testobj2":`ออบเจ็กต์ทดสอบ 2`,
"label.searchlayout.dupcacher.field":`คลิกลิงก์ตรวจสอบซ้ำและผสานที่แท็บด้านล่างเพื่อแสดงฟิลด์ซ้ำ`,
"label.attendance.persons.title":`โปรดเลือกพนักงานที่เหมาะสมสำหรับบันทึกเวลาทำงาน`,
"template.report.product.sales":`ยอดขายผลิตภัณฑ์`,
"label.editCustomReportType":`แก้ไขแหล่งข้อมูลรายงานที่กำหนดเอง`,
"label.multilang.ui.setup.profile.alltime":`เวลาทั้งหมดคือ {0}`,
"label.service.dispatchingUnits.noservice.booking":`ไม่มีการนัดหมายการบริการ`,
"label.validate.remark4":`ตรวจสอบให้แน่ใจว่าตัวเลขอยู่ในช่วงที่กำหนด เช่น ส่วนลดมากกว่า 30%`,
"front-kefu-moudle-v1-Waiting-time":``,
"label.weipagelayout.remark":`ใช้เป็นเค้าโครงสำหรับวีแชทบทเบราว์เซอร์ และโทรศัพท์มือถือ`,
"vue_label_wang_er":`หวังเอ้อร์`,
"label.pw.text":`โปรดป้อนรหัสผ่านสําหรับ{user}โปรดตรวจสอบให้แน่ใจว่ามีจำนวนคำสอดคล้องตามขั้นต่ำ`,
"message.error.user.data.null":`ข้อมูลผู้ใช้ต้องไม่ว่างเปล่า!`,
"chatter.like.p":`ชื่นชอบโพสต์นี้`,
"label.page.double.column.style.cloudcc":`เนื้อหาของฟังก์ชัน CloudCC ที่นิยมใช้รูปแบบสองคอลัมน์ในหน้าเดียวกัน เช่น "ค้นหา" และ "รายการล่าสุด"`,
"label.h5.iscloseaccount":`ยืนยันว่าจะออกจากระบบหรือไม่`,
"label.dataimport.insertdata.id.error":`รูปแบบผิดพลาด กรุณาใช้ตัวเลขและตัวอักษรผสมกัน`,
"label_tabpage_sum":`รวม`,
"front-epwechat-module-v1-addressbook-sync":`ซิงค์บัญชีที่อยู่`,
"label.setup.mobile.offlinecache.mostsave":`แพลตฟอร์มสามารถตั้งค่าเริ่มต้นของเมนูแบบออฟไลน์บนบนอุปกรณ์มือถือไปมากที่สุด 10 เมนู`,
"label.weixin.quickcreate":`สร้างด่วน`,
"label.forecast.edittotal.de.mubiao":`เป้าหมายของ`,
"label.icon.144":`รับประกัน`,
"label.icon.155":`รูปภาพ`,
"label.In.the.search":`กำลังค้นหา`,
"message.validation.isnotdateISO":`ป้อนวันที่แบบมาตรฐาน (ISO)`,
"label.service.appointmentList.send.successfully":`ส่งสำเร็จ`,
"label.dynamicpage.error.exist":`ไม่มีข้อมูลเค้าโครงเพจแบบไดนามิกอยู่`,
"vue_label_SMS_otherpeople":`รอ {0} คน`,
"label.cloudccsite.url":`URL เว็บไซต์`,
"label.tabpage.contactsz":`ผู้ติดต่อ`,
"vue_label_commonobject_notice_clickthename":`หากต้องการดาวน์โหลดไฟล์ที่อัปโหลด โปรดคลิกที่ชื่อไฟล์`,
"vue_label_file_new_lib":``,
"label.chatter.card":`การ์ด`,
"chatter.feed.menutype.user.allusercom":`พนักงานทุกคน`,
"label.exchange.sync2":`ติดตั้ง`,
"template.report.year.income":`รายได้ปีนี้`,
"label.partner.template.detail":`คำอธิบายฟังก์ชัน`,
"label.setup.service.template":`แม่แบบรายงานการบริการ`,
"label.dataimport.insertdata.id.length":`รูปแบบผิดพลาด ความยาวน้อยกว่า 20 หลัก โปรดตรวจสอบบันทึกนี้อย่างละเอียดและแก้ไข`,
"label.partnerCloud.financeSetting.collaborator":`ไอดีผู้ร่วมงาน`,
"label.processskipwizard":`ตัวช่วยเริ่มต้นทันใจกระบวนการอนุมัติ`,
"label.weixin.inputbusnumber":`กรุณาใส่หมายเลขทะเบียนรถ`,
"label.dashboardSetup.d1":`ค่าเบรกพอยต์ 1`,
"template.report.conversions.number.industry":`จำนวนลีดข้ามสเตจ (ตามอุตสาหกรรม)`,
"vue_label_chat_group_chat":`กลุ่มสนทนา`,
"label.file.publicview.error":`ไฟล์นี้ถูกลบไปแล้ว ไม่มีอยู่ หรือไม่สามารถดูตัวอย่างได้`,
"label.customfields.location.locationHelpText":`โปรดป้อนชื่อสถานที่เช่น "สำนักงานใหญ่" โปรดระบุรายละเอียดและเฉพาะเจาะจงและโปรดจำไว้ว่าบันทึกอาจมีที่อยู่หลายแห่งเช่น "สำนักงานขายฝั่งตะวันตก" และ "สำนักงานขายฝั่งตะวันออก"`,
"message.duplication.label.blankmatchtip":`ตั้งค่าให้ค่าว่างเข้าร่วมการจับคู่ใช่หรือไม่ ค่าเริ่มต้นคือ false`,
"message.appexchange.addtopackage":`โปรดเลือกส่วนเสริมอย่างน้อยหนึ่งอย่างเพื่อเพิ่มลงในแพ็กเกจนี้!`,
"label.ems.return2query":`กลับไปหน้าสอบถามเพิ่มบัญชี`,
"label_model_name":`ชื่อแบบจำลอง`,
"label.apiname.retainapi":`name ถูกสงวนไว้สำหรับระบบ โปรดใช้ชื่อ Api ฟิลด์อื่น!`,
"lable.Cancel.the.search":`ยกเลิกการค้นหา`,
"label.custom.viewport":`วิวพอร์ต`,
"label.weixin.polls.type":`ประเภทโพล`,
"label.opportunity.setting.showstage.label":`ขับเคลื่อนอัตโนมัติ`,
"label_component_helper_businesschange_expiredtask":`โอกาสทางธุรกิจที่ภารกิจเกินกำหนด`,
"label.operator":`ตัวดำเนินการ`,
"label.ccpeak.use.class.time.listmap":`เข้าถึงได้ทาง List<Map>`,
"component_timeline_label_past":`กิจกรรมที่ผ่านมา`,
"label.mobile.phone.submit":`รายงานที่ฉันส่ง`,
"message.recordtype.new.subtip":`ป้อนชื่อและหมายเหตุสำหรับชนิดบันทึกใหม่ ชนิดบันทึกใหม่จะรวมค่ารายการตัวเลือกทั้งหมดในชนิดบันทึกที่มีอยู่ด้านล่าง หลังจากบันทึกชนิดบันทึกใหม่แล้ว คุณจะสามารถปรับแต่งค่ารายการที่เลือกได้`,
"UG_product_05":`นำเข้าผลิตภัณฑ์`,
"label.validate.globalvariable.user.id":`ID ผู้ใช้`,
"label.umeng.activity.distribute":`คุณมอบหมายให้`,
"label.weixin.avote":`เริ่มโพล`,
"label.weixin.already.sign":`เคยลงทะเบียนเข้าแล้ว`,
"label.emailmerge.mergepage.generator":`สร้าง`,
"label.batchtransfer.transferto":`โอนไปที่`,
"label.tianyancha.industry":`อุตสาหกรรม`,
"label.addattachment.name":`ชื่อไฟล์`,
"label.customfields.formula.date.tip":`คำนวณวันที่ เช่น เพิ่มหรือลบจำนวนวันที่กำหนดในวันที่อื่น`,
"label.partnerCloud.orderingPlatform.noPayment":`ไม่มีการชําระเงินค้างอยู่`,
"label.emailobject.failedtosend":`การส่งล้มเหลว`,
"label.knowledge.setting.data.three":`ข้อมูลกลุ่มหมวดหมู่มากที่สุด {count} รายการ`,
"label.weixin.input.maxlength.langtext":`โปรดป้อนข้อมูลที่นี่ โดยป้อนได้มากที่สุด 32,000 อักขระ`,
"vue_label_calendar_delete_calendar":`ลบปฏิทิน`,
"vue_label_commonobjects_detail_filter":``,
"setup.layout.group.custompage":`เพจที่กำหนดเอง`,
"component_sendmail_label_subject":`หัวข้อ`,
"label_tabpage_maxfilez":`ขนาดไฟล์ใหญ่ที่สุดคือ`,
"label.logintime.pagecue":`เลือกวันที่และเวลาที่ผู้ใช้ที่มีโปรไฟล์นี้สามารถลงชื่อเข้าใช้ได้ โปรดทราบว่าเวลาทั้งหมดจะใช้เวลาตามจริงของโซนเวลาที่ระบุ แม้ว่าผู้ใช้จะอยู่ในโซนเวลาอื่นแต่เวลาเข้าสู่ระบบจะใช้เวลาตามจริงเหล่านี้`,
"label.salescloud.salesdashboard.datetime":`เวลาทำสัญญาคาดการณ์`,
"label.format":`รูปแบบ`,
"label.newfoundland.daylight.time":`เวลาออมแสงเกาะนิวฟันด์แลนด์`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`คัดลอกและวางค่าฟิลด์ที่ผสานลงในข้อความ`,
"message.chooseatleastoneforshare":`โปรดเลือกอย่างน้อยหนึ่งผู้ใช้เพื่อแบ่งปัน`,
"label.multilang.datamanage.importobjfield":`คอลัมน์ที่ {0}`,
"label.denglu":`เข้าสู่ระบบ`,
"label.popup.infoz":`แจ้งเตือน`,
"label.schedulejob.setup.schedule.onday":`ในทุกเดือน`,
"label.appointmentdetail.wizard.title16":`แผนงานวันพุธ`,
"label.userphoto.dragtoadjust":`ลากและปรับขนาดภาพขนาดย่อ`,
"label.product.series":`สายผลิตภัณฑ์`,
"message.view.kanban.not.set.group.summary.field":`มุมมองคัมบังไม่ได้ตั้งค่าฟิลด์การจัดกลุ่มและฟิลด์สรุป`,
"page.un.activities":`กิจกรรมที่ยังไม่ดำเนินการ`,
"label.exchange.sync3":`ปรับแต่ง`,
"label.login.activityExpired":`อัตราจำนวนผู้ใช้ที่ใช้งานหมดอายุ กรุณาติดต่อผู้ดูแลระบบ`,
"component_chatter_file_button_files":`เลือกไฟล์`,
"message.onlydelete.type":`ลบได้เฉพาะชนิดบันทึกที่ไม่ได้ใช้งานเท่านั้น ปิดใช้งานเพื่อลบ`,
"message.recordtype.selectlayouttouse":`เลือกเค้าโครงเพจที่ต้องการจะใช้`,
"label.knowledgebase.unable.restore.draft":`คุณไม่สามารถกู้คืนฉบับร่างที่ถูกลบ`,
"label.shangqing.name":`ข้อมูลธุรกิจ`,
"label.weixin.target.payment":`เป้าหมายการรับชำระหนี้`,
"label.chatter.sendEmailToGroupMember.check":`ดูโพสต์`,
"front-kefu-moudle-v1-input-single-login-area":``,
"vue_label_zhang_yi":`จางอี`,
"label.icon.190":`ไดร์เป่าผม`,
"label.quickbooks.fieldlabel.company":`ชื่อลูกค้า`,
"vue_label_email_are_you_sure_to_delete":`ยืนยันว่าจะลบอีเมลใช่หรือไม่`,
"Pagelayout.Setup.005":`ชื่อต้องวางไว้ตำแหน่งแรกสุด`,
"label.object.name.two":`ชื่อออบเจ็กต์ 2`,
"label.tabpage.completez":`ทำเครื่องหมายสถานะที่เลือกว่าสำเร็จ`,
"label.setup.mobile.bottombutton.saveerror":`การตั้งค่าหน้าเพจระดับหนึ่งบนอุปกรณ์มือถือล้มเหลว`,
"label.report.action.addtodashboard8":`เลือกโฟลเดอร์แดชบอร์ด`,
"label.data.downpage.i_list.desc3":`หลังจากผู้ใช้ดาวน์โหลดสามารถดูสาเหตุของการนำเข้าล้มเหลวที่คอลัมน์สุดท้ายของไฟล์`,
"label.layout":`เค้าโครง`,
"label.marketsea.button.assign":`มอบหมาย`,
"UG.solution.03":`สร้างโซลูชันใหม่`,
"label.ccchat.person.invited":`เชิญเพื่อนร่วมงาน`,
"label.ccchat.person.invite.address":`ผู้รับ`,
"label.displaytype1":`ลิงก์หน้ารายละเอียด`,
"label.tianyancha.h5.ziranrengudong":`ผู้ถือหุ้นที่เป็นบุคคลธรรมดา`,
"lable.SalesCommitmentKanBan.targetReceipts":`ยอดเก็บเงินเป้าหมาย`,
"message.error.getitems.type":`getItems:type ไม่สามารถว่างเปล่า`,
"label.addattachment.list":`อัปโหลดไฟล์ต่อไปนี้แล้ว`,
"label.datamanage.export.false":`เกิดความผิดพลาดขณะส่งออก`,
"pagecreator.systemstyle.label.buttonfontcolor":`ข้อความของปุ่ม`,
"label.emailtocloudcc.redmessage1":`กรุณากรอกที่อยู่อีเมลที่ถูกต้อง`,
"label.weixin.polls.closed":`หมดเวลา การโหวตสิ้นสุด`,
"label.icon.165":`หมวก`,
"vue_label_report_detailsonly":`แสดงรายละเอียดเท่านั้น`,
"component.salesperformance.label.100finish":`สิ้นสุดแล้ว`,
"november":`เดือนพฤศจิกายน`,
"label.data.file.generatejwd":`ดำเนินการบริการสร้างละติจูดและลองจิจูดตามที่อยู่`,
"label.salescloud.opportunity.access":`สิทธิ์ในการเข้าถึงโอกาสทางธุรกิจ`,
"label.isremider.remider":`แจ้งเตือน`,
"vue_label_total":`ทั้งหมด`,
"label.email.prompt.using.lightning.link":`ลิงก์อีเมลในการแจ้งเตือนระบบใช้ลิงก์รุ่น lightning`,
"label.knowledgebase.cancel.attached.articles":`ยกเลิกบทความเพิ่มเติม`,
"label.version.custom.xslc":`กระบวนการขายที่สามารถกำหนดเอง`,
"component_setup_button_save":`บันทึก`,
"label.ems.cc":`เพิ่มสำเนา`,
"label.edit.user":`อัปเดตผู้ใช้`,
"label.emailtocloudcc.select2":`กรุณาเลือกประเภท`,
"label.industrialandcommercialverification.fieldnumber":`ฟิลด์ที่แม็ป: 4 ฟิลด์`,
"label.ccchat.havenot.joined.group":`คุณไม่ได้เข้าร่วมกลุ่มกิจกรรมใดๆ`,
"pagecreator_page_label_pagename":`ชื่อหน้าเพจ`,
"setup.layout.button.save":`บันทึก`,
"label.campaignmember.main.updatestatus":`อัปเดตสถานะของสมาชิกแคมเปญแบบกลุ่ม`,
"label.tab.web.edit":`แก้ไขแท็บ Web`,
"label.ring_chart":`แผนภูมิโดนัท`,
"label.usermanage.resetpwd.error":`การรีเซตรหัสผ่านล้มเหลว ไม่พบผู้ใช้`,
"label.Xaxisscope":`ช่วงแกน X`,
"label.app.new":`แอปพลิเคชันใหม่`,
"message.modifythereport":`แดชบอร์ดใช้รายงานนี้ หากเปลี่ยนแปลงอาจส่งผลให้แดชบอร์ดของรายงานนี้ล้มเหลว`,
"label.component.helper.businesschange.0activity":`ไม่มีกิจกรรมใดในช่วง 30 วัน`,
"label.weixin.fmu.noon":`กลางวัน{0}`,
"label.enter.rule.name":`ป้อนชื่อกฎ`,
"lable.Confirm.recovery.potential.customers":`ยืนยันการกู้คืนลีด{name}`,
"lable.PowerProcess.type.created":`คุณต้องการสร้างกระบวนการให้สิทธิ์ประเภทใด？`,
"front-lightning-module-v1-dashbord-rectangle-size":`ขนาดสี่เหลี่ยม`,
"label.projectManagement.new.service.appointment":`การนัดหมายการบริการใหม่`,
"label.multilang.totalpage2":`รวม`,
"pagecreator.systemstyle.label.styledesc":`คำอธิบายรูปแบบ`,
"chatter.up":`กำลังอัปโหลด`,
"2018UI_Homepage_DataDeleted_Info":`ข้อมูลถูกลบแล้ว คลิกเพื่อกลับไปขั้นตอนก่อนหน้า`,
"label.knowledge.draft.recordid":`ID ฉบับร่างต้องไม่ว่างเปล่า`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`ดูการเชื่อมต่อทั้งหมด`,
"vue_label_file_num_limit_tip":`จำนวนไฟล์เกินจำนวนที่ตั้งไว้ หากคุณต้องการเปลี่ยนไฟล์ โปรดลบไฟล์ที่อัพโหลดก่อน`,
"vue_label_commonobjects_view_refreshat":`รีเฟรชก่อน {timeInterval}`,
"laebe.data.exp.save.success":`หากคุณจำเป็นต้องใช้แม่แบบนี้เพื่อส่งออกข้อมูล โปรดกลับไปกดปุ่มส่งออกแม่แบบเพื่อดำเนินการ`,
"label.mr.caption.contact":`ตรวจสอบซ้ำและผสาน: เงื่อนไขการสืบค้นข้อมูลซ้ำของผู้ติดต่อ`,
"label.webtocloudcc.submit.error":`การส่งล้มเหลว`,
"label.multilang.datadelete.delmessage":`บันทึกถูกล็อก ({0} รายการ) ไม่อนุญาตให้ลบ`,
"label.quickbooks.searchlist.total2":`พบ {0} บันทึกการจ่ายเงินที่ไม่มีการเชื่อมโยง มียอดเงินรวม {1}`,
"label.createnew":`สร้างใหม่...`,
"component.milestones.label.choicestate":`ยืนยันสถานะนี้`,
"lable.outlook.edit.exist":`มีชื่อฟิลด์นี้อยู่แล้ว โปรดป้อนชื่อฟิลด์อื่นที่ไม่ซ้ำกัน`,
"vue_label_dashboard_eachother":``,
"label.new.role":`บทบาทใหม่`,
"message.error.operationType":`เมื่อใช้บริการพบว่าตัวดำเนินการไม่ได้ถูกกำหนดไว้;`,
"label.fenbeitong.name":`เฟินเป้ยทง`,
"label.choose.person":`โปรดเลือกพนักงานที่ต้องการจะส่ง`,
"label.attendance.thanks":`ขอบคุณสำหรับการมีส่วนร่วมของคุณ!`,
"label.invoice.message.statusupdatefailed":`การอัปเดตสถานะ Invoice ล้มเหลว โปรดลองอีกครั้งในภายหลัง`,
"template.chart.yzhqzkhlyfx":`การวิเคราะห์ที่มาของลีดที่ข้ามสเตจแล้ว`,
"chatter.feed.menutype.user.alluser":`พนักงานทุกคน`,
"UG_Forcast_04":`เริ่มใช้`,
"label.appupload.upload.tips.profile":`หมายเหตุ: เพิ่มส่วนเสริม "โปรไฟล์" ลงในแพ็กเกจเกจนี้แล้ว และไม่สามารถเพิ่มได้อีก (อนุญาตให้เพิ่มส่วนเสริมโปรไฟล์ลงในแพ็กเกจได้รายการเดียว)`,
"lable.PowerProcess.leave.the.process":`{describeName}ออกจากกระบวนการ`,
"template.report.sales.cycle.opportunities":`ระยะเวลาของวงจรการขาย (สถิติตามประเภทโอกาสทางธุรกิจ)`,
"vue_label_calendar_please_fill_in_the_calendar":`กรุณากรอกชื่อปฏิทิน`,
"label.salescloud.unit.wanyuan":`หน่วย (หยวน)`,
"label.fileAPI":`ชื่อเฉพาะของโปรไฟล์`,
"label.weixin.link":`เชื่อมต่อ`,
"label.service.seconds":`วินาที`,
"label.encd.visible":`สามารถมองเห็นค่าฟิลด์ที่เข้ารหัสได้`,
"label.tianyancha.regstatus":`สถานะการดำเนินกิจการ`,
"label.event.moveup.18hour":`ล่วงหน้า 18 ชั่วโมง`,
"label.upper.bound":`ขอบเขตบน`,
"label.please.insertURL":`กรุณาใส่ URL ที่คุณต้องการแทรก`,
"label.approval.notallowed.reject":`ไม่อนุญาตให้ปฏิเสธ`,
"label.permission.fieldpermission":`การตั้งค่าสิทธิ์ฟิลด์`,
"label.customcomponent.page.index.title":`ส่วนเสริมที่กำหนดเอง`,
"label.quickbooks.viewlist.number":`หมายเลข`,
"lable.list.queue.sendemail":`ส่งอีเมลถึงสมาชิก`,
"label.productsales.today.noevtadd":`วันนี้ไม่มีอิเวนต์ที่ยังไม่ได้ดำเนินการ คุณสามารถคลิก " " ที่มุมขวาบน เพื่อเพิ่มอิเวนต์!`,
"label.report.line.daixuan":`คอลัมน์รายงานที่รอเลือก`,
"label.reportsSubscription.select.start.endtime":`โปรดเลือกเวลาเริ่มต้นและเวลาสิ้นสุด!`,
"template.chart.schdyscb":`งบประมาณต้นทุนแคมเปญ`,
"label.sendemail.chat.addPostatsubject":`เวยเทียของ CloudCC CCChat กล่าวถึงฉัน`,
"label.RelatedList":`รายการที่เกี่ยวข้อง`,
"label.knowledgebase.delete.translation.associated.with.draft":`การแปลฉบับร่างที่มีอยู่จะเชื่อมโยงกับบทความภาษาหลักที่เผยแพร่ก่อนหน้า หากไม่มีเวอร์ชันที่เผยแพร่ การแปลจะถูกลบออก`,
"vue_label_chatter_submitted_review":`คุณได้ส่งใบสมัครเข้าร่วมแล้ว กรุณารอผู้ดูแลตรวจสอบ`,
"label.layout.list2":`รายการ 2`,
"label.manage.area":`จัดการภูมิภาค`,
"label.manageapproveprocess":`จัดการกระบวนการอนุมัติ`,
"workflow.action.tasks.assignortype.created":`ผู้สร้าง`,
"label.custombutton.nonsupport.operation":`รุ่นปัจจุบันไม่รองรับปุ่มมาตรฐานและลิงก์`,
"label.ip":`ที่อยู่ IP`,
"label.chat.topic.desc.error.info":`คำอธิบายหัวข้อต้องยาวไม่เกิน 1,000 อักขระ ลองใช้คำอธิบายที่สั้นกว่านี้`,
"label_tabpage_cue":`ข้อความแจ้งเตือน`,
"label.integrations.mailchimp1":`หลังจากได้รับอนุญาตให้เชื่อมต่อ สมาชิกขององค์กรจะสามารถนำเข้าลีดและผู้ติดต่อไปยัง Mailchimp`,
"label.email.track.required":`ข้อมูลจำเป็น`,
"label.set.case":`โปรดตั้งเจ้าของเคสก่อน`,
"label.weixin.newspaper.coverage.number":`เลขที่กรมธรรม์`,
"vue_label_approve_submitreason":`ส่งเหตุผล`,
"message.oppdt.noenabledpricebook":`ไม่มีสมุดราคาที่เปิดใช้งาน!`,
"label.partner.workspace.setup":`ตั้งค่า`,
"label.version.nonsupport.feature":`ไม่รอบรับฟังก์ชันนี้! หากมีความจำเป็น กรุณาอัปเกรดรุ่น CloudCC!`,
"com.cloudcc.login.error.message.licenseexpired":`สิทธิ์การใช้งานหมดอายุแล้ว`,
"label.emailsync.form.signin":`เข้าสู่ระบบ`,
"label.campaign.channel.input.to.chooselanguage":`กรุณาเลือกภาษา`,
"label.tabpage.gotit":`ทราบแล้ว`,
"front-console-no-contact-tip":``,
"label.approval.apiname":`ชื่อเฉพาะที่ใช้โดย API และแพ็กเกจที่มีการจัดการ ต้องขึ้นต้นด้วยตัวอักษร และใช้ได้เพียงอักขระที่เป็นตัวเลขและตัวอักษรและเครื่องหมายขีดล่างเท่านั้น ไม่สามารถลงท้ายด้วยเครื่องหมายขีดล่างหรือมีเครื่องหมายขีดล่างติดกันสองตัว`,
"label_emailtocloudcc_filed_ssl":`การเชื่อมต่อที่ปลอดภัย`,
"component_sendmail_label_fromuser":`ผู้ส่ง`,
"front-kefu-moudle-v1-new-online-chats":`Seat ออนไลน์ใหม่`,
"label.searchlayout.merge.duplicated.results":`ต้องการเปิดใช้งานการตรวจสอบซ้ำและผสานหรือไม่`,
"label.weixin.input.maxlength.remark":`กรุณาระบุที่นี่ สามารถระบุอักขระมากสุด 500 ตัว`,
"component.telerecord.label.related":`รายการที่เกี่ยวข้อง`,
"label.note":`คำอธิบายประกอบ`,
"message.duplication.label.nletters":`อักขระ`,
"label.productsales.payment.phb":`การจัดอันดับการรับชำระหนี้`,
"label.forecast.editshrepage.desc":`Forecast: ระบุการแบ่งปันบันทึกนี้ คุณสามารถแบ่งปันบันทึกนี้และข้อมูลที่เกี่ยวข้องกับผู้ใช้รายเดียว ผู้ใช้ในบทบาทเฉพาะ หรือผู้ใช้ทั้งหมดในบทบาทภายใต้บทบาทเฉพาะ`,
"vue.dashboard.setPenetrationSuccessful":`ตั้งค่าการเจาะสำเร็จ !`,
"label.tabpage.noOperationz":`เนื้อหานี้เป็นรายการคงที่ ไม่สามารถดำเนินการได้!`,
"label.email.jump":`ข้ามไปยังลิงก์ของบุคคลที่สาม ···`,
"label.appointmentpage.wizard.btn1":`ยืนยันการนัดหมาย`,
"label.umeng.approval.pass":`#approverอนุมัติ#objแล้ว`,
"label.project.hit.twelve":`แจ้งเตือนไมล์สโตนถึงกำหนด`,
"two":`สอง`,
"label.approvedinfo":`อนุมัติข้อมูล`,
"label.import.step1.choosecsv":`กรุณาเลือกไฟล์ csv`,
"vue.please.select.the.expansion.method":`โปรดเลือกวิธีการขยาย`,
"UG.homepage.005":`ระบบการขายอัจฉริยะ`,
"Account.News.Setting.003":`การตั้งค่าทั่วไป`,
"label.quickbooks.button.actions":`ปฏิบัติการ`,
"lable.list.queue.email":`คิวอีเมล`,
"label.name.lastname":`นามสกุล`,
"message.confirm":`คุณยืนยันหรือไม่?`,
"Opportunity.Detailed.Phase.Label.Popup.002":`วันที่ออกจากสเตจ`,
"label.knowledge.setting.title":`การตั้งค่าคลังความรู้`,
"label.helptocreateprocess":`กระบวนการอนุมัติที่ถูกต้องและไม่ถูกต้อง ในการสร้างกระบวนการอนุมัติ คลิกสร้างกระบวนการอนุมัติใหม่" จากนั้นเลือก "ใช้ตัวช่วยเริ่มต้นทันใจ" เพื่อตั้งค่ากระบวนการอนุมัติของคุณในไม่กี่ขั้นตอนหรือเลือก "ใช้ตัวช่วยสร้างมาตรฐาน" เพื่อกำหนดค่าตัวเลือกการอนุมัติทั้งหมด`,
"label.batcheditor.remark":`สามารถแก้ไขบันทึกได้หลายรายการ`,
"label.page":`หน้า`,
"label.newfolder":`สร้างโฟลเดอร์ใหม่`,
"label.version.interceptor.api":`API อินเทอร์เฟซ`,
"label.sms.toaddress":`ได้รับข้อความสั้น`,
"front-kefu-moudle-noopen-callcenter":``,
"label.data.exp.zip":`รูปแบบการบีบอัด`,
"lable.account.LastcDays":`60 วันที่ผ่านมา`,
"label.import.index.starttime":`เวลาเริ่มต้น`,
"label.dashboardall":`แดชบอร์ดทั้งหมด`,
"label.create_socialpost":``,
"label.searchlayoutedit.remark":`เลือกฟิลด์และปุ่มที่จะแสดงเมื่อคลิกค้นหาหรือเมนูค้นหาด้านซ้ายของหน้าเว็บ`,
"message.servicecrew.violation":`การละเมิดการปันส่วนทรัพยากร: แหล่งทรัพยากรบริการเป็นสมาชิกของทีมบริการในช่วงเวลานี้`,
"label.email.attrach.file":`แนบไฟล์`,
"report.label.folderandreport":`รายงานและโฟลเดอร์`,
"label.list.userinterface.sales.setup":`การตั้งค่าหน้าแรกของระบบการขาย`,
"label.martrixreport.2018.step1":`ขั้นตอนที่ 1: เลือกวิธีการจัดกลุ่มที่ใช้ในการคำนวณข้อมูลสรุป`,
"label.campaignmember.selectmember.memberstatus":`สถานะของสมาชิกแคมเปญ`,
"label.textmessage.vonage.api.key":`คีย์ API`,
"label.tabpage.next":`ขั้นตอนถัดไป`,
"UG_Lead_006":`ผู้เข้าชมเว็บไซต์`,
"label.salescloud.salesdashboard.visit.rankings":`จัดอันดับการเข้าพบลูกค้า`,
"label.myevent":`อิเวนต์ของฉัน`,
"label.activity.history":`ประวัติ`,
"label_tabpage_kanban":`การตั้งค่าคัมบัง`,
"label.weixin.allapp":`แอปพลิเคชันทั้งหมด`,
"label.query.clone.detail.choose.choosed":`ออบเจ็กต์รายละเอียดที่เลือก`,
"message.error.view.errvalid":`ข้อผิดพลาด: ฟิลด์ชื่อเฉพาะมุมมองสามารถมีได้เฉพาะขีดล่างและอักขระที่เป็นตัวอักษรและตัวเลข
ชื่อต้องไม่ซ้ำ เริ่มต้นด้วยตัวอักษร ห้ามเว้นวรรค ต้องไม่ลงท้ายด้วยขีดล่าง และต้องไม่มีเครื่องหมายขีดล่างติดกันสองตัว`,
"label.customfields.searchrelation.dependobject.tip":`เลือกอีกออบเจ็กต์ที่เกี่ยวข้องกับออบเจ็กต์นี้`,
"label.appointment.wizard.subtitle4-4-3":`สามสัปดาห์`,
"label.setup.mobile.offlinecache.saveerror":`บันทึกการตั้งค่าแคชออฟไลน์สำหรับอุปกรณ์มือถือล้มเหลว`,
"label.planned.started":`เริ่มแล้ว`,
"label.page.step4.of.step5":`ขั้นตอนที่ 4 จาก 5`,
"label.tabpage.value":`มูลค่า`,
"label.reportlist.allfolder":`โฟลเดอร์ทั้งหมด`,
"label.callcenter.sure.disable.center":``,
"vue_label_commonobjects_detail_activity_tocalendar":`ไปที่ปฏิทิน`,
"label.setup.mobile.bottombutton.recovery.default":`คืนค่าเริ่มต้น`,
"label.appointmentdetail.wizard.title15":`แผนงานวันอังคาร`,
"label.icon.15":`ซ่อมบำรุง`,
"component_sendmail_label_touser":`ผู้รับ`,
"template.report.all.owner":`เจ้าของลีด`,
"front-Partner-email-tips":``,
"vue_label_systemSettings_mobelhomepagesetting":`การตั้งค่าหน้าเพจอุปกรณ์มือถือ`,
"label.service.newBuildDialog.aswellas":`รวมไปถึง`,
"label.name":`ชื่อ`,
"label.tag.search.taglist":`รายการป้ายกำกับ`,
"label.partnerCloud.priceOfManual.theOnly":`ขอแนะนำให้ตั้งค่าสมุดราคาเฉพาะสำหรับลูกค้าพาร์ทเนอร์แต่ละราย หากมีการตั้งค่าสมุดราคาหลายรายการ พาร์ทเนอร์จะต้องเลือกสมุดราคาที่ใช้สำหรับคำสั่งซื้อนี้เมื่อทำการสั่งซื้อ หากไม่ได้ตั้งค่าไว้ ระบบจะใช้สมุดราคามาตรฐาน`,
"label.knowledge.field.update":`เปลี่ยน{1}จาก{2}เป็น{3}`,
"label.emailobject.save":`บันทึก`,
"label.top.changeVersion":`แท็บแนวนอน`,
"label.recordtype.edit.unselected":`ค่าที่ใช้ได้`,
"label.knowledgebase.additional.articles":`บทความเพิ่มเติม`,
"label.lead.score.confirm":`กรุณาเลือกขอบเขตที่ต้องการกำหนดให้กับลีด คลิกปุ่ม【ให้คะแนนลีด】แล้วระบบจะให้คะแนนกับลีดที่เลือกตามเกณฑ์การให้คะแนน<br><br>การให้คะแนนนั้นอาจต้องใช้เวลานานสักหน่อย คุณจะได้รับอีเมลยืนยันหลังจากการให้คะแนนเสร็จสิ้น <br><br>`,
"label.projectManagement.pleaseselectadate":`กรุณาเลือกวันที่`,
"label.appointment.wizard.subtitle5":`ชื่อการประชุม`,
"label_setup_failed":`การตั้งค่าล้มเหลว`,
"label.chatter.collect":`บุ๊กมาร์ก`,
"label.appointment.cancelappointment":`ยกเลิกการนัดหมาย`,
"front-console-response":``,
"message.delete":`ยืนยันว่าจะลบหรือไม่?`,
"label.dataimport.type.selected":`โปรดเลือกประเภทการนำเข้า`,
"label.new.target":`เป้าหมายใหม่`,
"vue_label_report_autoupdatepreview":``,
"label.knowledgebase.guidance":`ชี้แนะ`,
"label.chatter.mail":`อีเมล`,
"label.login.verification.scan.code.acquisition":`สแกนเพื่อรับ:`,
"label.customsetting.changefieldtype":`เปลี่ยนประเภทฟิลด์`,
"label.data.dataexpalltype.all_desc2":`2. การส่งออกข้อมูลทั้งหมดจำเป็นต้องใช้เวลาระยะหนึ่ง หลังจากการส่งออกเสร็จสมบูรณ์ ระบบจะส่งอีเมลแจ้ง`,
"label.opportunity.contactisnull":`ข้อมูลลูกค้าว่างเปล่า ไม่สามารถแสดงได้`,
"pagecreator_layout_button_upload":`อัปโหลดเค้าโครง`,
"label.dashboard.noRecord":`ไม่มีบันทึก`,
"label.SMS.template":`ชื่อแม่แบบข้อความสั้น`,
"label.c.d.without":`บันทึก C" อาจจะมีหรือไม่มีความเกี่ยวข้องกับบันทึก  "D" "`,
"UG.Case.05":`สร้างเคส`,
"front-epwechat-module-v1-edit-selfapp":`แก้ไขแอปที่สร้างขึ้นเอง`,
"label.role.createrole.tip":`คุณสามารถสร้างต่อไปตามลำดับชั้นบทบาทที่มีอยู่ที่แสดงในเพจนี้ หากต้องการแทรกบทบาทใหม่ ให้คลิก <b>เพิ่มบทบาท</b>`,
"label.grouping":`การจัดกลุ่ม`,
"vue_label_email_upload_new_file":`อัปโหลดไฟล์ใหม่`,
"label.notification.event3":`อิเวนต์ของคุณจะเริ่ม ณ [เวลาเริ่มต้น]`,
"labe_benchmark_objects":`ออบเจ็กต์อ้างอิง`,
"component.chatter.button.collect":`บุ๊กมาร์ก`,
"front-QBtoCC-sinchronies":``,
"message.submitpage.sms":`ยินดีด้วย! คำขอส่งข้อความสั้นสำเร็จ!`,
"label.imgfield.width":`ความกว้าง`,
"label.send_email":`ส่งอีเมลแจ้งการส่งข้อมูลไปที่`,
"label.queue.list":`รายการคิว`,
"label.tabpage.fieldoptions":`ฟิลด์ชนิดบันทึก ฟิลด์รายการตัวเลือกและฟิลด์รายการตัวเลือก (หลายตัวเลือก) ขอแนะนำให้ป้อนคีย์เวิร์ดไม่เกิน 10 คำโดยคั่นด้วยเครื่องหมายจุลภาคหรือความสัมพันธ์ เช่น "ปักกิ่ง,เซี่ยงไฮ้,กว่างโจว"`,
"component.chatter.post.button.save":`เผยแพร่`,
"chatter.group.groupDescriptionInformation":`ข้อมูลคำอธิบายกลุ่ม`,
"label_setup_mobilesetup_isenableh5newandedit":`ต้องการเปิดใช้งานการสร้างใหม่และการแก้ไข H5 บนอุปกรณ์มือถือหรือไม่`,
"lable.Confirm.recallpotential.customers":`ยืนยันรีไซเคิลลีด {num} ราย`,
"label.knowledge.setting.hint.seven":`เลือกจากชื่อต่อไปนี้และให้สิทธิ์ในการเขียนเพื่อมอบพลังอันน้อยนิดแก่ตัวคุณเอง`,
"label.emailtocloudcc.redmessage2":`กรุณากรอกรหัสผ่านอีเมลที่ถูกต้อง`,
"message.validation.equalTo":`ป้อนค่าที่เหมือนกัน`,
"vue_label_help_golbal":`ระบบนำทางแบบโกลบอล`,
"vue_label_chatter_delete_group_title":`ลบกลุ่ม`,
"label.user.login.success":`การเข้าสู่ระบบสำเร็จ`,
"label.chatham.standard.time":`เวลาออมแสงหมู่เกาะแชทัม`,
"label.vlidaterule.example.percent":`เปอร์เซ็นต์ส่วนลดต้องไม่เกิน 30%`,
"label.group.field":`ระบุฟิลด์การจัดกลุ่ม`,
"label.trigger.operation.sharetab":`ตารางแบ่งปันของการดำเนินการทริกเกอร์:`,
"label.mobile.phone.write.month.report":`เขียนรายงานประจำเดือน`,
"label.statusofconvers":`สถานะข้ามสเตจแล้ว`,
"label.version.emailtemplate.track":`แม่แบบอีเมล`,
"label.customobjects.onlytrackforupdate":`ติดตามการอัปเดตเท่านั้น`,
"label_tabpage_enterviewname":`ขั้นตอนที่ 1: กรุณาใส่ชื่อมุมมอง`,
"label.processsetting.three.enable":`ขั้นตอนที่ 3: เปิดใช้งาน`,
"label.service.show.more.info":`แสดงข้อมูลเพิ่มเติม`,
"front-epwechat-module-v1-input-iosschema":`กรุณาใส่ iOS schema`,
"label.dataimport.datatype.error":`ประเภทข้อมูลไม่ถูกต้อง โปรดตรวจสอบอย่างละเอียดว่าข้อมูลและชื่อตรงหรือกันหรือไม่`,
"label.staticresource":`ทรัพยากรแบบคงที่`,
"label.weixin.customize":`ปรับแต่ง`,
"label.product.edit.sel":`แก้ไขที่เลือก`,
"label.appointmentpage.wizard.notif5":`รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง`,
"label.marketsea.basicsetup":`การตั้งค่าพื้นฐาน`,
"label.workflow.supplyintruduce":`1. เงื่อนไขสำหรับการใช้กฎเวิร์กโฟลว์<br/>2. การดำเนินการทันทีเมื่อบันทึกตรงกับเงื่อนไข เช่น หลังจากสร้างโอกาสทางธุรกิจใหม่แล้ว CloudCC สามารถส่งอีเมลแจ้งเตือนไปยังกลุ่มลูกค้าโดยอัตโนมัติ<br/>3. การดำเนินการที่ขึ้นกับเวลาจะถูกจัดคิวเมื่อบันทึกตรงกับเงื่อนไข แล้วดำเนินการตามเวลาทริกเกอร์`,
"label_report_line_tuozhuai":`กรุณาลากวางหรือดับเบิลคลิกเมาส์เพื่อเลือกคอลัมน์รายงานและปรับลำดับคอลัมน์`,
"label.add.new.rule":`กฎใหม่`,
"label.marketing.setting2":`การตั้งค่าช่องทาง`,
"vue_label_chatter_delete_some_group":`ยืนยันต้องการลบกลุ่ม"{groupInfoList}"หรือไม่`,
"label.appupload.uploading.wait":`กรุณารอสักครู่`,
"label.linecondition.error":`เงื่อนไขบรรทัดไม่ถูกต้อง ประเภทฟิลด์ไม่ตรงกัน！`,
"chatter.group.request":`ร้องขอ`,
"label.recordtype.tabname.remark":`ใช้หน้านี้เพื่อสร้างและรักษาชนิดบันทึกสำหรับองค์กรของคุณ เค้าโครงเพจและค่ารายการตัวเลือกที่แตกต่างกันสามารถแสดงได้ตามชนิดบันทึก ต้องการใช้ชนิดบันทึกกรุณาเพิ่มฟิลด์ "ชนิดบันทึก" ในเค้าโครงเพจ`,
"setup_mainpage_label_welcome4":`คําแนะนําการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าแอปพลิเคชัน → สร้าง→ออบเจ็กต์`,
"vue_label_salesadvance":`ขั้นตอนการส่งเสริมการขาย`,
"vue_label_campaign_of_existing_campaign_members":`โปรดตั้งค่าสถานะสมาชิกแคมเปญที่มีอยู่`,
"label.report.object.detail.no.permission":`ประเภทรายงานมีการเปลี่ยนแปลงหรือถูกย้าย โปรดติดต่อผู้ดูแลระบบ`,
"label.weixin.untreated":`ไม่ได้จัดการ`,
"label.service.miniProgram.bindSetOwnerDesc":``,
"label.autoassigntoapprover":`มอบหมายให้ผู้อนุมัติโดยอัตโนมัติ`,
"label.marketseamemset.containself":`รวมบันทึกที่สร้างเอง`,
"vue_label_report_drill":`เจาะ`,
"label.order.products.to.assets":`ผลิตภัณฑ์ที่สั่งซื้อถูกโอนเป็นสินทรัพย์`,
"label.recordtype.list":`ชนิดบันทึกที่มีอยู่`,
"lable.outlook.detail.conflict":`พฤติกรรมความขัดแย้ง`,
"pagecreator.page.label.layoutpreview":`แสดงตัวอย่างเค้าโครง`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`Seat แชทสนับสนุนโดย Easemob โปรดซื้อบัญชี Easemob ก่อน`,
"label.convers":`ย้าย`,
"serviceappointment.worktype.isnot.father.worktype":`การนัดหมายการบริการนี้ต้องเลือกชนิดงานที่เกี่ยวข้องกับบันทึกหลัก`,
"lable.tianyancha.h5.relatedcom":`บริษัทที่เกี่ยวข้อง`,
"label.reportsSubscriptionPage.schedulereport":`กำหนดเวลารายงาน`,
"label.workbanch.setup.showinworkbanch":`แสดงในเวิร์คแบนซ์ของฉันหรือไม่`,
"label_emailsync_connectaccount":`เชื่อมต่อบัญชีอีเมล`,
"label.usermanage.license.not.qualified":``,
"component_setup_label_displayfield":`แสดงฟิลด์`,
"setup_layout_label_buttonarea":`พื้นที่ปุ่ม`,
"label.weixin.input.content":`กรุณาใส่เนื้อหา`,
"label.operatedata.importsuc":`การนำเข้าสำเร็จ กรุณาเปิดออบเจ็กต์เพื่อตรวจสอบสถานะการนำเข้า`,
"label_tabpage_yes1z":`ใช่ 1`,
"front-electronic-signature-describe":``,
"label.event.this.month":`อิเวนต์ของเดือนนี้`,
"label.document.replaces":`แทนที่`,
"label.email.cc":`สำเนา`,
"chatter.feed.sticker":`การติดตามเวยเทีย`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`กรุณาเพิ่มแผนภูมิ`,
"label.cpq.main.quote.transfer.order":`เฉพาะใบเสนอราคาหลักเท่านั้นที่สร้างใบสั่งซื้อได้`,
"label.partnerCloud.partnerAccount.topUpSuccess":`เติมเงินสําเร็จ`,
"label.appexchange.uninstallpage.uninstall":`ถอนการติดตั้ง`,
"label.campagin.roi.channel":`ช่องทางการขาย`,
"label.multilang.versioncontrol.checkversion":`CloudCC รุ่นปัจจุบันของคุณคือ{0}อนุญาตให้สร้าง{2} {1} อัน ได้ถึงขีดจำกัดแล้ว! หากมีความจำเป็น กรุณาอัปเกรดรุ่น CloudCC!`,
"label.emailobject.my.template":`แสดงเฉพาะแม่แบบของฉัน`,
"label.edittimetrigger":`แก้ไขทริกเกอร์เวลา`,
"label.setup.mobile.homepageshortcuts.saveerror":`บันทึกการตั้งค่าฟังก์ชันทางลัดของหน้าแรกอุปกรณ์มือถือล้มเหลว`,
"label.address.street":`ถนน`,
"label.workflow.estimatecondition2":`เมื่อสร้างบันทึกเท่านั้น`,
"label.wei.expiresdate":`วันหมดอายุ`,
"label.quickbooks.viewlist.date":`วันที่`,
"label.page.select.field.type":`เลือกประเภทฟิลด์`,
"label.tabpage.mypotentialcustomers":`ลีดของฉัน`,
"label.file.library.editlib":`แก้ไขรายละเอียดไลบรารีเอกสาร`,
"label.weixin.message.operateexception":`ข้อความแจ้งเตือน`,
"label.visualpage.staticresource.p1":`1. วิธีการเรียกใช้ เลือกทรัพยากรแบบคงที่โดยใช้ปุ่มนำเข้าทรัพยากรแบบคงที่`,
"label.icon.175":`ตั๋วเครื่องบิน`,
"chatter.edit.r":`เขียนตอบกลับ...`,
"label.examinationandapproval.flow":`ขั้นตอนการอนุมัติ`,
"label.mr.descreption.reDataList5":`กลุ่มข้อมูล`,
"label.edit.field.select.showstyle":`รูปแบบการแสดงผล`,
"label.reportsSubscriptionPage.condition.and":`และ`,
"label.please.associations":`โปรดเลือกอบเจ็กต์ที่เกี่ยวข้อง`,
"label.service.dispatchingUnits.displays.service.appointments":`แสดงการนัดหมายการบริการที่ไม่ได้เชื่อมโยงกับภูมิภาค`,
"label.addcurrent":`เพิ่มที่มีอยู่ปัจจุบัน`,
"label.search.change":`การตั้งค่าออบเจ็กต์ที่ค้นหาได้`,
"message.schedulejob.error.modify":`งานที่กําหนดจะไม่ถูกทริกเกอร์ตามกําหนดการ โปรดตรวจสอบข้อมูลแล้วส่งอีกครั้ง`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0}โพสต์ลิงก์ให้สมาชิกทุกคนในกลุ่ม{1}`,
"label.weixin.micro.oldid":`ID เดิมของบัญชีสาธารณะวีแชท`,
"label.employees.only.invitation.code":`ระบบจะสร้างรหัสเชิญเฉพาะสำหรับพนักงาน พนักงานสามารถใช้รหัสนี้ในการเชิญ และสามารถนับเป็นผลงานส่วนบุคคลได้ โปรดทราบว่า เจ้าของลีดคือเจ้าของแคมเปญปัจจุบันหรือผู้เชิญของช่องทางการขาย คุณสามารถกำหนดเกณฑ์การมอบหมายใหม่ทางเกณฑ์การมอบหมายลีด`,
"lable.PowerProcess.event.msg":`คุณสามารถเพิ่มการดําเนินการเวิร์กโฟลว์ตามเวลาที่เกิดขึ้นในทุกขั้นตอน (อิเวนต์สําคัญ) ในกระบวนการให้สิทธิ์ เช่น คุณสามารถตั้งค่าให้ส่งอีเมลไปยังเจ้าของเคสหนึ่งชั่วโมงก่อนที่อิเวนต์จะหมดอายุ หรืออัปเดตฟิลด์เคสเฉพาะโดยอัตโนมัติเมื่ออิเวนต์สําคัญเสร็จสิ้นครั้งแรก`,
"label.file.share.email.content2":`การแบ่งปันข้อมูล: สิทธิ์ #sharerole ได้แบ่งปันไปที่ไฟล์ปัจจุบันของคุณ`,
"label.querydetailservice.datalayout.notexist":`ไม่มีเค้าโครงที่ตรงกับบันทึก`,
"label.group.items":`จัดกลุ่มรายการ`,
"label.istouse":`ใช้ได้หรือไม่`,
"front-electronic-signature-explain":``,
"label.partner.template.thumbnail":`ภาพขนาดย่อ`,
"registration.page.selected.fields":`การเลือกฟิลด์บังคับสําหรับหน้าลงทะเบียน`,
"label.reportTypeCategoryLabel":`แหล่งข้อมูล`,
"vue_label_email_You_have_not_activated_the_mailbox":`คุณยังไม่ได้เปิดใช้งานอีเมล`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`อัตราส่วนภารกิจที่สำเร็จ`,
"label.forecast.detailforecast.program":`โปรแกรมการพยากรณ์`,
"label.page.display":`แต่ละหน้าแสดง`,
"label.passwordPolicy.setup.minute":`นาที`,
"label.emailtocloudcc.step1total3":`ขั้้นตอนที่ 1 จาก 3`,
"label.file.title":`หัวข้อ`,
"label.callcenter.private.key":``,
"com.cloudcc.login.error.message.loginerror":`ชื่อผู้ใช้หรือรหัสผ่านผิด`,
"UG_Lead_004":`Web ฟอร์ม`,
"label_tabpage_recordsz":`บันทึก`,
"label.shangqing.discovery":`ค้นพบข้อมูลธุรกิจ`,
"vue_label_notice_change_success":`การเปลี่ยนแปลงสำเร็จ`,
"label.ems.other":`อื่นๆ`,
"loading":`กำลังโหลดข้อมูล`,
"label.committedtoapprove":`ส่งคำร้องขออนุมัติเรียบร้อย`,
"label.category.4":`การเงิน`,
"template.report.folder.customer.situation":`การวิเคราะห์สถานการณ์ของลูกค้า`,
"label.quickbooks.searchresault.phone":`โทรศัพท์`,
"label.ccpeak.ccobj.save":`ต้องการนำ CCobject เก็บลงในฐานข้อมูล และเรียกใช้เมธอด`,
"label.knowledge.delete.linked":`เกิดข้อผิดพลาดในการลบบทความที่เกี่ยวข้อง`,
"label.forecast.settings.future2":`2 รอบถัดไป`,
"message.error.displaytype.detail":`รูปแบบการแสดงผลต้องไม่ว่างเปล่า วัน：day，เดือน：month，สัปดาห์：week，ความพร้อมใช้งาน：availability！`,
"front-template-V1-search-template-name":`ป้อนชื่อออบเจ็กต์และค้นหาอย่างรวดเร็ว`,
"label.sendsms.batch.step3.introduce":`จัดเก็บทุกกิจกรรมของข้อความสั้น`,
"UG.Forcast.08":`ขั้นตอนก่อนหน้า`,
"label.inputnameandintro":`กรุณาใส่ชื่อและคำอธิบาย`,
"label.redistributioned":`มอบหมายใหม่`,
"label.service.dispatchingUnits.left.right.total":`ข้อมูลปัจจุบัน {left}-{right} รายการ ข้อมูลทั้งหมด {totalCount} รายการ`,
"label.projectManagement.Pleaseentertheactualworkinghours":`กรุณาระบุเวลาทำงานจริง`,
"label.exporttemplate":`แม่แบบการส่งออก`,
"label.data.downpage":`หน้าดาวน์โหลดข้อมูล`,
"message.please.choose.contact":`โปรดเลือกผู้ติดต่อ`,
"message.error.dataformat.error":`รูปแบบข้อมูลไม่ถูกต้อง`,
"label.customsetting.changefieldtype.losevalue":`การเปลี่ยนเป็นประเภทข้อมูลที่เลือกจะทำให้ข้อมูลที่มีอยู่ทั้งหมดในฟิลด์นี้จะหายไป`,
"label.sendemail.chat.chattype":`ประเภทของโพสต์หลัก:`,
"label.ccdocument.upload.error":`เกิดข้อผิดพลาดในการอัปโหลดไฟล์!`,
"label.quickbooks.view.all":`ทั้งหมด`,
"label.data.downpage.e_title":`ขั้นตอนการส่งออกข้อมูล:`,
"lable.data.lock":`ข้อมูลถูกล็อก โปรดปลดล็อกก่อนดำเนินการ`,
"label.locked":`ล็อก`,
"label.customfields.beforedeletedata":`ก่อนจะลบฟิลด์ที่กำหนดเอง แนะนำให้คลิกการตั้งค่า "|" การจัดการข้อมูล "|"`,
"label.productsales.oppor.noapproach":`โอกาสทางธุรกิจไม่มีวันที่ทำสัญญาคาดการณ์ที่ <30 วัน`,
"label.input.notmore.than.number":`กรุณาใส่ตัวเลขที่น้อยกว่าหรือเท่ากับ {0}`,
"label.list.userinterface.isenable":`เปิดใช้งานการแก้ไขอินไลน์`,
"label.listofshare":``,
"label.emailsync.status.role":`บทบาท`,
"label.staticresource.useful.realtion":`ตำแหน่งที่ใช้ทรัพยากรแบบคงที่นี้`,
"label.sharerule.tip":`หน้านี้แสดงการตั้งค่าการแบ่งปันขององค์กรของคุณ การตั้งค่าเหล่านี้ระบุระดับการเข้าถึงข้อมูลของผู้ใช้แต่ละคน`,
"label.qrcodelogin.message.expired":`รหัสคิวอาร์หมดอายุแล้ว`,
"label.marketing.setting3":`การตั้งค่ช่องทางการขายของแคมเปญ`,
"vue_label_statistical_field":`ฟิลด์สถิติ`,
"message.view.addtomyhomepage":`เพิ่มไปยังหน้าแรกเวิร์คแบนซ์`,
"label.customfields.percent.tip":`อนุญาตให้ผู้ใช้ป้อนตัวเลขเปอร์เซ็นต์ (เช่น 10") และเพิ่มเครื่องหมายเปอร์เซ็นต์ให้กับตัวเลขโดยอัตโนมัติ"`,
"component_newrecords_label_10records":`10 รายการบันทึก`,
"Lead_Scoring_Warning_001":`สำหรับลีดหนึ่งราย ระบบสามารถให้คะแนนอัตโนมัติเมื่อสร้างและแก้ไข แต่หากเป็นการนำเข้าเป็นจำนวนมาก หรือการสร้างผ่านอินเทอร์เฟซต้องดำเนินการด้วยตนเองผ่านการให้คะแนนแบบกลุ่ม`,
"label.project.planing":``,
"label.data.exp.pwdverif":`รหัสผ่านต้องเป็นตัวอักษรหรือตัวเลขเท่านั้น`,
"coderules.notEnable":`ติดต่อผู้ดูแลระบบเพื่อเปิดกฎสําหรับการสร้างรหัสคิวอาร์หรือบาร์โคด`,
"label.weixin.wdyj.jxhk":`ส่วนบุคคล-ประสิทธิภาพการขาย-การรับชำระหนี้`,
"label.data.expnode.e_desc3":`3. การสร้างแม่แบบ: ผู้ใช้สามารถสร้างฟิลด์และเงื่อนไขที่ต้องการส่งออกเป็นแม่แบบได้ตามความต้องการ ซึ่งจะสะดวกสำหรับการใช้งานครั้งต่อไป`,
"chatter.group.join":`เข้าร่วม`,
"vue_label_systemSettings_monitoring":`การติดตาม`,
"front-kefu-moudle-v1-yesorno-delete-folder":`ยืนยันจะลบโฟลเดอร์นี้หรือไม่?`,
"label.exchange.sync.state.info":`ตรวจสอบสถานะของระบบเพื่อให้แน่ใจว่าบันทึกซิงค์ระหว่าง Exchange และ CloudCC`,
"lable.outlook.mcto.emaildes":`ใส่ที่อยู่อีเมลทั้งหมดที่คุณใช้ในการส่งอีเมลถึงลีดและผู้ติดต่อ คั่นด้วยเครื่องหมายจุลภาพ อีเมลที่ส่งจากที่อยู่อีเมลที่คุณระบุด้านล่างเท่านั้นที่จะสามารถเพิ่มประวัติกิจกรรมเข้าในบันทึกที่เกี่ยวข้องได้`,
"label.ems.save":`บันทึก`,
"vue_label_dashboard_maximumvalue":`กรุณาใส่ค่าสูงสุดที่แสดง`,
"label.passwordPolicy.setup.norestriction":`ไม่มีข้อจำกัด`,
"label.multilang.customforcast.total":`ยอดสะสมของ{0}`,
"label_partner_all_memo":`รายการแสดงทุกพาร์ทเนอร์คลาวด์ในองค์กร คลิก URL เพื่อตรงไปที่หน้าเข้าสู่ระบบ`,
"Account.News.Setting.002":`ใช้การตั้งค่าลูกค้าด้านล่างเพื่อระบุพฤติกรรมของลูกค้าเริ่มต้นสำหรับองค์กร`,
"label.essential":`จำเป็น`,
"label.nonotice":`ไม่ต้องแจ้งเตือนอีก`,
"vue_label_calendar_calendar_deleted_successfully":`การลบปฏิทินสำเร็จ`,
"message.huanxinagent.disable":`ไม่ได้เปิดใช้งาน Seat`,
"label.goto":`ไปที่`,
"label.chat.topic.add.favorite":`เพิ่มไปยังรายการโปรด`,
"label.trigger.targetobj":`ออบเจ็กต์เป้าหมาย`,
"label.form_fields":`ฟิลด์ฟอร์ม`,
"this.month":`เดือนนี้`,
"vue_label_homepage_select_view":`เลือกมุมมอง`,
"label.weixin.input.subject":`กรุณากรอกหัวข้อ`,
"label.ems.emailType":`ประเภทอีเมล`,
"vue_label_file_safe_type_file":`โปรดยืนยันว่าไฟล์ไม่มีข้อมูลที่ละเอียดอ่อน พิจารณาการแบ่งปันไฟล์กับผู้ใช้หรือบันทึกเฉพาะ`,
"label.version.case.automatic.upgrade":`เลื่อนขั้น Case อัตโนมัติและจัดสรร`,
"label.input.invalid.credit.card.number":`กรุณาใส่หมายเลขบัตรเครดิตที่ถูกต้อง`,
"component_timeline_label_future":`ขั้นตอนถัดไป`,
"label.emailtemplate.cannotsupporthtml":`ขณะนี้ยังไม่รองรับ HTML`,
"label.appupload.install.error.info2":`{1} "{0}"  ขัดแย้งกับส่วนเสริมปัจจุบัน`,
"label.custom.field.maping":`แม็ปกับฟิลด์นี้`,
"encd":`ข้อความที่เข้ารหัส (แสดงการเข้ารหัส)`,
"label.service.newBuildDialog.filter.logic":`ตรรกะตัวกรอง`,
"label.customerinfo":`โปรไฟล์บริษัท`,
"vue_label_applauncher_notice_activepoolsuccess":`เปิดการใช้ฐานข้อมูลลูกค้าสำเร็จ`,
"label.partner.workspace.member.choicepermission":`เลือกชุดสิทธิ์`,
"front-gantt-module-this-task-of-other-tasks":``,
"label_chatter_publish":`เผยแพร่`,
"label.forecast.settings.mrfw":`ค่าเริ่มต้นของจุดเริ่มต้นช่วง`,
"label.Named.Filter":`ตั้งชื่อตัวกรอง`,
"label.department.email":`ที่อยู่อีเมล`,
"label.updatingfield":`ฟิลด์ที่ต้องการอัปเดต`,
"label_partner_template_detail":`คำอธิบายฟังก์ชัน`,
"front-epwechat-module-v1-unbound-item":`- การผูกสัมพันธ์ของทั้งองค์กร`,
"vue_label_file_lib_name":``,
"label.notification.arketsea.distribution":`5}จะ{2}{0}: {1} ถูกกำหนดให้กับคุณ`,
"vue_label_norm_removecomponent":`ลบส่วนเสริม`,
"component.event.label.begindate":`*เวลาเริ่มต้น`,
"chatter.note":`ความคิดเห็นที่ได้รับ`,
"label.forecast.settings.type.all":`ใช้การพยากรณ์ภาพรวม`,
"label.compact.layout.frame.full":`แสดงผลเต็มหน้าจอ`,
"label.approvalstep3intro":`ใช้ตัวเลือกดังต่อไปนี้เพื่อระบุผู้ใช้ที่ควรมอบหมายคำอนุมัติ`,
"label.notification.approval6":`[ชื่อผู้แทน]อนุมัติ[ออบเจ็กต์][ชื่อออบเจ็กต์]ที่[ผู้เสนอ]ร้องขอแทนคุณ`,
"setup.object.field.dependency.label.actionfieldvalue":`ค่าฟิลด์ควบคุม`,
"label.multilang.page2":`หน้า`,
"vue_label_email_submitted":`ส่งสำเร็จ`,
"label.Standard.button":`ปุ่มมาตรฐาน`,
"vue_label_report_emailchoose":`อีเมล`,
"page.field.masterinput.list":`รายการข้อมูลมาสเตอร์อินพุต`,
"label.martrixdown":`เมทริกซ์แบบบนลงล่าง`,
"vue_label_helpcenter_opportunity":`คุณสามารถคลิกไอคอนกรวยการขายที่มุมขวาบนของมุมมองเพื่อข้ามไปดูกรวยการขายได้ <br> ติดตามความคืบหน้าของโอกาสทางธุรกิจแต่ละรายผ่านแถบความคืบหน้าที่ใช้งานง่าย และสามารถติดป้ายเสร็จสิ้นให้กับสเตจปัจจุบัน หรือปรับสเตจปัจจุบันได้ด้วยการคลิกปุ่ม หากเกิดอุปสรรคในการผลักดันโอกาสทางธุรกิจ ก็สามารถขยายแถบความคืบหน้าเพื่อดูสิ่งที่ควรติดตามและคำเตือนต่างๆ ที่เกี่ยวกับสเตจปัจจุบันได้<br>คุณสามารถแบ่งปันข้อมูลของโอกาสทางธุรกิจผู้นี้กับผู้อื่นที่ไม่ได้รับอนุญาตให้ดูเพื่ออำนวยความสะดวกในการทำงานร่วมกันผ่านรายการที่เกี่ยวข้องกับกลุ่มโอกาสทางธุรกิจ <br> บทบาทของรายชื่อผู้ติดต่อกับโอกาสทางธุรกิจ เพิ่มชื่อผู้ติดต่อของลูกค้าที่เหมาะสมอย่างรวดเร็วเพื่อเพิ่มโอกาสในการขาย จากนั้นค้นหาชื่อผู้ที่เกี่ยวข้องกับผู้ติดต่อทั้งผู้บังคับบัญชาและผู้อยู่ใต้บังคับบัญชาผ่านเครือข่ายความสัมพันธ์ พร้อมประเมินค่าผู้ติดต่อจากโอกาสในปัจจุบันด้วยกราฟเรดาร์ ติดตามสถานการณ์ กำหนดผู้ที่สามารถตัดสินใจได้ตรวจสอบบทบาทของผู้ติดต่อ สถานะการเข้าพบ ระดับความสัมพันธ์ รูปแบบการซื้อและจำนวนครั้งที่เข้าพบ <br>คุณสามารถเพิ่มผลิตภัณฑ์ที่มีโอกาสทางธุรกิจในสมุดราคาเดียวกัน แก้ไขราคา และจำนวนของผลิตภัณฑ์ผ่านรายการที่เกี่ยวข้องกับผลิตภัณฑ์ที่มีโอกาสทางธุรกิจ`,
"label.sso.ssoKeyMan":`SSO ตัวจัดการคีย์`,
"label.forecast.edit.desc":`ตั้งค่าโควตาให้ผู้ใช้ตามระยะเวลาต่อไปนี้`,
"label.weixin.newspaper.coverage.time":`ระยะเวลาประกัน`,
"label.pleaseselectpro":`โปรดเลือกผลิตภัณฑ์`,
"label.bottonandlink":`ปุ่มและลิงก์`,
"label.donot.know.error":`เกิดข้อผิดพลาดที่ไม่รู้จัก โปรดติดต่อผู้ดูแลระบบ`,
"label.account_noordab":`บัญชีของคุณมีรายงานที่กําหนดเอง 0 รายการ และแดชบอร์ด 2 รายการ`,
"label.partnerCloud.orderingPlatform.toPay":`ชําระเงินผ่านบัญชี`,
"label.many.dayline.nextday":`วันถัดไป`,
"lable.showmorerecords":`แสดงบันทึกเพิ่มเติม`,
"front-lightning-module-v1-details-page-chart-record-type":`โปรดเลือกประเภทบันทึก`,
"label.ccpeak.query.record":`สืบค้นบันทึก:`,
"pagecreator.systemstyle.message.save.fail":`การบันทึกรูปแบบล้มเหลว`,
"label.weixin.share.file":`แบ่งปันไฟล์`,
"errormessage.email.relatedorreceivermusthaveone.z":`เลือกผู้รับและรายการที่เกี่ยวข้องอย่างน้อยหนึ่งรายการ`,
"chatter.save.f":`การบันทึกล้มเหลว`,
"button.partner.create":`สร้าง`,
"label.marketseamemset.lead.title2":`โปรดกำหนดขีดจำกัดสูงสุดที่ส่งผลต่อจำนวนลีดที่สมาชิกทุกคนเป็นเจ้าของ ขีดจำกัดนี้ไม่เกี่ยวข้องกับฐานข้อมูล`,
"label.service.major.event.new":`อิเวนต์สําคัญใหม่`,
"label.version.custom.site":`เว็บไซต์แบบกำหนดเอง`,
"label.permission.visualpagepermission":`เพจแบบกำหนดเองที่กำหนด`,
"lable.product.zongjia":`มูลค่ารวม`,
"label.viewchart":`ดูแผนภูมิ`,
"label.alaska.daylight.time":`เวลาออมแสงอะแลสกา`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`ทำให้ผู้ใช้เป็น Seat ให้มากขึ้นเพื่อจะได้ให้บริการผู้เข้าชมมากขึ้น และยกระดับความพึงพอใจด้านการบริการของลูกค้า`,
"component_assistant_label_todaylead":`ลีดที่มอบหมายให้คุณในวันนี้`,
"label.sendemail.chat.addComentsfavorite":`#nameที่เคารพ:\n\n ;   สวัสดี!  #userName ตอบกลับเวยเทียโปรดของคุณ`,
"label.smstemplate.tip":`แม่แบบข้อความสั้นทั้งหมดในโฟลเดอร์ที่เลือกแสดงอยู่ด้านล่าง คลิกปุ่มสร้างใหม่"เพื่อสร้างข้อความใหม่หรือแม่แบบข้อความสั้น HTML คุณสามารถใช้แม่แบบข้อความสั้นเหล่านี้เมื่อส่งข้อความสั้น คลิกลิงก์บทบาทเพื่อดูรายละเอียดเพิ่มเติม"`,
"label.documentname":`ชื่อเอกสาร`,
"label.icon.162":`ทิวทัศน์`,
"label.salescloud.wanyuan":`หยวน`,
"label.view.desc1":`ฟิลด์ชนิดบันทึก ฟิลด์รายการตัวเลือกและฟิลด์รายการตัวเลือก (หลายตัวเลือก) ขอแนะนำให้ป้อนคีย์เวิร์ดไม่เกิน 10 คำโดยคั่นด้วยเครื่องหมายจุลภาคหรือความสัมพันธ์ เช่น "ปักกิ่ง,เซี่ยงไฮ้,กว่างโจว"`,
"label.searchlayout.lookup.newfield":`คลิกปุ่มใหม่ในกล่องโต้ตอบ "ค้นหา" เพื่อแสดงฟิลด์`,
"label.emailobject.bcc":`สำเนาลับถึง:`,
"label.manageAll.pagenum1":`อยู่ที่หน้าแรกแล้ว`,
"vue_label_appstore_crm_used_companies":`บริษัทจดทะเบียนที่ใช้ crm`,
"label.document.replace":`แทนที่`,
"label.assignment.setup.newrule.title":`เกณฑ์การมอบหมายเคสใหม่`,
"component.chatter.label.mygroup":`กลุ่มของฉัน`,
"lable.currencyAdv.exchangedate":`ช่วงวันที่`,
"label.quickbooks.button.viewinqb":`ดูที่ QuickBooks`,
"UG.homepage.004":`กระบวนการอัตโนมัติ`,
"label.currencyName":`ชื่อสกุลเงิน`,
"Homepage_News_001":`ข่าวสาร`,
"front-lightning-module-v1-details-page-chart-refresh-button":`แสดงปุ่มรีเฟรช`,
"label.list.projectSetting.isenable":`เปิดใช้งานตัวจับเวลาโครงการ: (ประกอบไปด้วย: ไมล์สโตน งาน งานย่อย ปัญหา)`,
"setup.layout.message.relatedlistbutton":`เลือกปุ่มมาตรฐานที่แสดงในรายการที่เกี่ยวข้อง`,
"vue_label_homepage_homepageassignment":`การกำหนดหน้าแรกของแอปพลิเคชัน`,
"label.pending":`รอดำเนินการ`,
"component.timeline.label.today":`วันนี้`,
"front-kefu-moudle-free-hasexpire":``,
"homepage.layout.customlayout":`เค้าโครงหน้าแรกที่กำหนดเอง`,
"label.service.miniProgram.content":`กรุณากรอกข้อมูล`,
"label.defaultline.must.int":`จำนวนแถวเริ่มต้นเป็นจำนวนเต็มบวกเท่านั้น`,
"label.mirror_issues":`ถ้าฟอร์มไม่สะท้อนเนื้อหา กรุณาอ่านบทความช่วยเหลือเกี่ยวกับวิธีแก้ไขปัญหาการแสดงผลทั่วไป`,
"label.edit.select.two":`รายการปุ่มวิทยุ`,
"label.emailmerge.mergeFolder.tip":`การผสานแม่แบบต้องใช้เวลา กรุณาอย่าคลิกลิงก์อื่น หรือปิด web เบราว์เซอร์ของคุณ หรือรีเฟรชหน้าระหว่างดำเนินการ`,
"label.ServiceCloud.zichan.distributionMap":`แผนภูมิสินทรัพย์`,
"label.selectfile":`เลือกไฟล์`,
"vue_label_account_equitymanage":`จัดการความสัมพันธ์ผู้ถือหุ้น`,
"label.email.clearAll":`ล้างทั้งหมด`,
"label.selecting.parent.assets":`เลือกสินทรัพย์หลัก`,
"component.setup.tabs.label.delete":`ลบ`,
"label.visualpage.top.must.is":`แถวแรกของส่วนหัวหน้าเพจจะต้องเป็น:`,
"label.SalesCommitmentDashboard":`แดชบอร์ดข้อผูกมัดการขาย`,
"chatter.group.changeTheRole":`เปลี่ยนบทบาท`,
"label.dataimport.insertdata.error":`ข้อมูลใหม่ที่แทรกเกิดข้อผิดพลาด โปรดตรวจสอบข้อมูลนี้อย่างละเอียด`,
"label.partner":`พาร์ทเนอร์คลาวด์`,
"label.process.async.execute.tip":`การอนุมัติของคุณอยู่ในคิวแล้ว และจะแจ้งให้คุณทราบทางอีเมลในภายหลังหากการอนุมัติล้มเหลว`,
"label.service.newBuildDialog.additional.conditions":`เงื่อนไขเพิ่มเติม`,
"label.name_copy":`คุณจะคัดลอกฟอร์มนี้ กรุณาตั้งชื่อสําเนาของฟอร์ม`,
"label.integrations.install":`การอนุญาต`,
"label.edit.ccpeakfolder.time":`คลาสตัวจับเวลา: แก้ไขโฟลเดอร์`,
"label.knowledgebase.filing.time":`เวลาเก็บถาวร`,
"vue_label_chatter_success_exit_group":`การออกจากกลุ่มสำเร็จ`,
"font.market.module.v1.save.name":`กรุณากรอกชื่อการประชุม`,
"label.a.b.without":`บันทึกA"อาจจะมีหรือไม่มีความเกี่ยวข้องกับบันทึก"B" "`,
"label.chat.topic.desc":`คำอธิบาย`,
"label.field.editoptionlist.introduce":`ป้อนชื่อของค่ารายการตัวเลือกด้านล่าง & nbsp; เลือกกล่องกาเครื่องหมายนี้เพื่อใช้ค่านี้เป็นค่าเริ่มต้น`,
"label.versiontype.Enterprise":`รุ่นเอนเทอร์ไพรซ์`,
"message.selectrulecondition":`โปรดระบุเงื่อนไขกฎ!`,
"label.custombutton.unknown.operation":`การดำเนินการที่ไม่รู้จัก`,
"label.pricecannotnull":`ราคาไม่สามารถว่างเปล่า`,
"component_salesperformance_label_target":`เป้าหมาย`,
"pagecreator.page.message.delete.success":`การลบหน้าเพจสำเร็จ`,
"label.help.new.features":`คู่มือการใช้งานฟังก์ชั่นใหม่`,
"label.weixin.vehicle.owner.information":`ข้อมูลเจ้าของยานพาหนะ`,
"label.exchange.sync.state.user.info":`ตรวจสอบสถานะการซิงค์ของผู้ใช้เพื่อให้แน่ใจว่าบันทึกของผู้ใช้ได้ซิงค์ระหว่าง Exhange และ CloudCC หากผู้ใช้มีปัญหาในการซิงค์ระหว่าง Exchange และ CloudCC คุณสามารถรีเซตกระบวนการซิงค์ของผู้ใช้ได้ การรีเซตสามารถล้างข้อมูลที่ใช้โดย CloudCC for Exchange เท่านั้นและจะไม่ลบข้อมูลออกจากเซิร์ฟเวอร์ Microsoft Exchange หรือ CloudCC ของคุณ`,
"label.batcheditor":`การแก้ไขเป็นชุด`,
"report.label.knowcreatehighlevelreport":`เรียนรู้เกี่ยวกับการสร้างรายงานขั้นสูง`,
"label.dataimport.title.length":`ความยาวของหัวข้อคือ`,
"label_model_description":`คำอธิบายแบบจำลอง`,
"label.tabpage.ctbtsftcz":`คลิกที่ด้านหลังเพื่อค้นหาเนื้อหาที่เลือก`,
"label.channel.activity.member.owner":`เจ้าของสมาชิกกิจกรรมช่องทาง`,
"label.ems.serverinfo":`ข้อมูลเซิร์ฟเวอร์`,
"tjinvilid":`เงื่อนไขไม่ถูกต้อง`,
"label.nameofreport":`ชื่อรายงาน`,
"label.ifapproverreject":`หากผู้อนุมัติปฏิเสธคำขอนี้จะเป็นอย่างไร?`,
"label.wtd.changefields.title.desc2":`หากคุณต้องการบันทึกที่เกี่ยวข้องกับลีดใน Web to CloudCC บนอุปกรณ์มือถือ คุณต้องสร้างฟิลด์ค้นหาลีดในออบเจ็กต์ปัจจุบันและ API ของฟิลด์คือ lead_wtd "`,
"label_emailsync_form_connecttime":`เวลาเชื่อมต่อ`,
"label.visualpage":`เพจที่กำหนดเอง`,
"label.customlink":`ลิงก์ที่กำหนดเอง`,
"label.lead.score.doing.remark":`ได้ดำเนินการตามคำขอของคุณแล้ว การให้คะแนนลีดจะใช้เวลาระยะหนึ่ง ระบบจะแจ้งให้คุณทราบทางอีเมลหลังจากการดำเนินการเสร็จสิ้น`,
"label.h5.act.details":`รายละเอียดกิจกรรม`,
"label.profile.setrecordtype":`ตั้งค่าชนิดบันทึก`,
"label.processsetting.process.enabled.successfully":`เปิดใช้งานกระบวนการสำเร็จ!`,
"label.campaign.url.overtime":`ลิงก์นี้หมดอายุแล้ว`,
"label.structureChart.notFiled":`ไม่ได้กรอกข้อมูล`,
"label.h5.chatter.something":`คุณอยากพูดอะไรไหม`,
"label.pm":`บ่าย`,
"template.chart.rwlx":`ชนิดของงาน`,
"label.icon.42":`เมฆ`,
"label.project.hit.one":`แจ้งเตือนการมอบหมายงานย่อย`,
"label.martrixreport.2018.step3":`ขั้นตอนที่ 3: เลือกคอลัมน์รายงาน`,
"label.wtd.changefields.newmo":`สร้างเพจอุปกรณ์มือถือ`,
"label.downloadTheTemplate":`ดาวน์โหลดแม่แบบ`,
"label_chatter_assignPerson":`ผู้ได้รับมอบหมาย`,
"label_emailtocloudcc_license":`การอนุญาตใช้สิทธิ์`,
"label.willdeletedlayout":`เค้าโครงเพจที่ต้องการจะลบ`,
"label.projectManagement.delete.question":``,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`เปิดใช้งานเกณฑ์การทวนสอบสำหรับการสแกนนามบัตรหรือไม่`,
"label.salescloud.opportunity.addandedit.contactrole.note":`หมายเหตุ: คลิกสองครั้งที่ผู้ติดต่อว่าง เพื่อเพิ่มบันทึกเปล่า`,
"label.step6.total6":`ขั้นตอนที่ 6 จาก 6`,
"label.knowledge.setting.hint.one":`Knowledge ช่วยให้ลูกค้าและเจ้าหน้าที่บริการลูกค้าสามารถใช้ประโยชน์จากบทความ Knowledge ที่หลากหลายและให้ข้อมูลได้อย่างเต็มที่`,
"label.usefieldautoassign":`ใช้ฟิลด์ลำดับขั้นมาตรฐานหรือแบบกำหนดเองเพื่อกำหนดผู้อนุมัติแบบอัตโนมัติ:`,
"label.partnerCloud.orderingPlatform.orderAmount":`ยอดการสั่งซื้อ:`,
"chatter.fieldtrack.operateupdate":`เปลี่ยนแปลงแล้วหนึ่งรายการ`,
"chatter.del.com":`ลบความคิดเห็นนี้`,
"report.reportdatasource.label":`แหล่งข้อมูลรายงาน`,
"label.text":`ข้อความ`,
"label.marketsea.select.member":`ตัวเลือกสมาชิก`,
"label.typeofreceivers":`ประเภทผู้รับ`,
"label.knowledgebase.affect.existing.translations":`ใช่ การเปลี่ยนแปลงของฉันจะส่งผลต่อการแปลที่มีอยู่ ติดป้ายว่า "หมดอายุ"`,
"label.marketing.invitationmail":`ยินดีต้อนรับคุณเข้าร่วมกิจกรรมของเรา ลิงก์บัตรเชิญของคุณคือ:`,
"label.version.quotation.management":`การจัดการใบเสนอราคา`,
"label.dataimport.insertdata.error.unique":`ตอนแทรกข้อมูลใหม่ $fieldName$มีค่าข้อมูลที่ซ้ำกัน`,
"label.emailmerge.list.newtemplate":`แม่แบบใหม่`,
"label.salescloud.salescloud.allteam":`ทุกทีมในโอกาสทางธุรกิจ`,
"vue_label_commonobjects_detail_record_changes":`ฟิลด์จะบันทึกการเปลี่ยนแปลง`,
"label.file.delete.info":`ลบไฟล์`,
"vue_label_calendar_name":`ชื่อปฏิทิน`,
"label.version.support":`สนับสนุน`,
"label.event":`อิเวนต์`,
"label.searchlayout.lookup.searchdialog":`คลิกลิงก์ค้นหาในฟิลด์ "ค้นหา" และกล่องโต้ตอบ "ค้นหา" จะปรากฏขึ้น`,
"label.data.downpage.e_list.desc2":`คุณจะได้รับอีเมลหลังจากการส่งออกข้อมูลสำเร็จเพื่อแจ้งการส่งออกข้อมูลสำเร็จ`,
"label.partnerCloud.productSet.delIsTrue":`ยืนยันว่าจะลบผลิตภัณฑ์นี้หรือไม่?`,
"label.tianyancha.businessverify.msg2":`"ข้อตกลง" นี้เป็นข้อตกลงระหว่างคุณ (ต่อไปนี้เรียกว่า "ผู้ใช้") และ CloudCC ที่ลงนามเกี่ยวกับการใช้ฟังก์ชันทวนสอบข้อมูลธุรกิจ "ข้อตกลงไ นี้อธิบายถึงหน้าที่สิทธิที่เกี่ยวข้องกับการใช้ฟังก์ชันทวนสอบข้อมูลธุรกิจและด้านบริการระหว่าง CloudCC และผู้ใช้ "ข้อตกลง" นี้สามารถอัปเดตโดย Cloud CC ได้ตลอด เมื่อมีการประกาศข้อตกลงที่อัปเดตแล้วข้อตกลงดังกล่าวจะแทนที่เงื่อนไขข้อตกลงเดิม 
โดยไม่ต้องแจ้งให้ทราบล่วงหน้า`,
"label.customobjects.cancleselectallfield":`ยกเลิกการเลือกฟิลด์ทั้งหมด`,
"image.up.maxsize":`ไฟล์ที่อัปโหลดใหญ่เกินไป ขนาดห้ามเกิน 2M`,
"label.icon.8":`แฟ้ม`,
"label.donot.delete":`คุณไม่มีสิทธิ์ลบ!`,
"label.version.profile.and.layoutpage":`โปรไฟล์และเค้าโครงเพจ`,
"chatter.coll.s":`ลบบุ๊กมาร์กโพสต์นี้`,
"label.icon.163":`โลก`,
"label_chatter_myfollowers":`ผู้ติดตามของฉัน`,
"label.multilang.customforecast.refuse":`ปฎิเสธการพยาการณ์ใดๆ ของ{0}ก่อน แต่ยอมรับการพยากรณ์ของผู้ใต้บังคับบัญชาคนอื่นๆ ก่อน`,
"label.tabpage.findz":`ค้นหา`,
"label.smstemplate.detailinfo":`รายละเอียดแม่แบบข้อความสั้น`,
"label.knowledge.setting.hint.nineteen":`มาเริ่มกันเลย`,
"label.mr.tip":`โปรดกรอกกฎในบรรทัดที่ {0} ให้ครบถ้วน`,
"label.icon.132":`รับประกัน`,
"label.customobjects.track.introduce2":`"การติดตามฟิลด์" ในรายการที่เกี่ยวข้องของฟิลด์ที่ติดตาม เมื่อผู้ใช้แก้ไขฟิลด์ที่เลือกด้านล่าง ค่าฟิลด์เก่าและค่าฟิลด์ใหม่ ไปจนถึงวันที่ เวลา คุณลักษณะการเปลี่ยนแปลงและผู้เปลี่ยนแปลงจะถูกเพิ่มลงในรายการที่เกี่ยวข้องของ "การติดตามฟิลด์"`,
"label_emailtocloudcc_redmessage5":`ไม่ทราบสถานะ โปรดติดต่อผู้ดูแลระบบ`,
"label.must.select.field":`เงื่อนไขแถวไม่ถูกต้อง ต้องเลือกหนึ่งฟิลด์`,
"label.tag.manage.modifiedby":`ผู้แก้ไขล่าสุด`,
"label.translation.start1":`เลือกหนึ่งภาษา (หากคุณเป็นผู้แปลหลายภาษา)`,
"label.ccchat.topic.searchs":`ค้นหาหัวข้อ`,
"label.mask.custom.example":`{AAAA}{****}{AAAA} หมายถึงการแสดงรหัสตั้งแต่อักขระตัวที่ 5 ถึง ตัวที่ 8`,
"setup_object_field_dependency_label_addtolist":`เพิ่มค่าที่เลือก`,
"label.view.total.record":`เลือกทั้งหมด 0 รายการบันทึก`,
"label.service.without.right":`ไม่มีสิทธิ์ที่เกี่ยวข้อง`,
"template.chart.wxqzkhyy":`เหตุผลของลีดไม่ถูกต้อง`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`กรุณาป้อนค่าเบรกพอยต์ 1`,
"message.pleaseinputmouthdistance":`กรุณากรอกช่วงเดือนให้ถูกต้อง`,
"label.forgetPsd.tip":`ลืมรหัสผ่าน โปรดติดต่อผู้ดูแลระบบ`,
"label.projectManagement.planned":`วางแผน`,
"lable.Product.conversion.asset.operation":`แปลงผลิตภัณฑ์เป็นสินทรัพย์`,
"label.search_forms":`ค้นหาฟอร์ม`,
"label.sendemail.chat.addPostmainPagesubject":`ฝากข้อความที่หน้าแรก CloudCC CCChat`,
"label_tabpage_viewNamez":`กรุณาใส่ชื่อมุมมอง`,
"label_chatter_addresser":`ผู้ส่ง`,
"Opportunity_Detailed_Phase_Change_Text_001":`เปลี่ยนสเตจโอกาสทางธุรกิจ`,
"label.what":`ที่`,
"vue_label_systemSettings_set_android":``,
"label.sell":`การขาย`,
"template.report.folder.case":`การวิเคราะห์เคส`,
"label.customfields.profilefieldsafety":`ความปลอดภัยระดับฟิลด์ของโปรไฟล์`,
"label.industrialandcommercialverification.label.token":`Token`,
"label.finished":`เสร็จสิ้น`,
"label.sendmail.step3.introduce1":`เลือกอยู่ในปัจจุบัน`,
"vue_label_calendar_other_calendars":`ปฏิทินอื่นๆ`,
"label.donot.know.validate.field":`ฟิลด์ทวนสอบที่ไม่รู้จัก`,
"label.exportdetail":`รายละเอียดการส่งออก`,
"label.step.filter":`กำหนดเงื่อนไขตัวกรอง`,
"label.campaignmember.main.hasMember":`สมาชิกปัจจุบัน`,
"label.updown.suess":`ดาวน์โหลดสำเร็จ`,
"label.ems.browse":`ค้นหา`,
"front-email-payment-Invoice-login-account-describe":``,
"label.copyCustomReportType":`คัดลอกแหล่งข้อมูลรายงานที่กำหนดเอง`,
"label.visualpage.write.class":`การเขียนรหัส Class ที่หน้าเพจ ไวยากรณ์ของรหัสต้องเหมือนกับ Java`,
"label.setsharerule.tip":`ใช้กฎการแบ่งปันเพื่อแบ่งปันข้อมูลที่สอดคล้องกับเงื่อนไขที่กำหนดให้กับบทบาทที่กำหนด <br>  หมายเหตุ: บทบาทและผู้ใต้บังคับบัญชา "รวมถึงผู้ใช้ทั้งหมดในบทบาทเฉพาะและบทบาทภายใต้บทบาทนั้น"`,
"label.report.action.addtodashboard9":`หน้ารายการแดชบอร์ด`,
"label.cloudccsite.remark":`คำอธิบายไซต์`,
"label_tabpage_noz":`ไม่`,
"chatter.up.limit":`ไฟล์ที่อัปโหลดมีขนาดใหญ่เกินไป โปรดอัปโหลดไฟล์ที่มีขนาดไม่เกิน`,
"label.leadmarketsea.grouplist.title":`การตั้งค่าการจัดกลุ่มลีดในฐานข้อมูล`,
"label.pc.user.help":`คู่มือผู้ใช้`,
"label.partnerCloud.orderingPlatform.relyOn":`พึ่งพา`,
"label.appointmentpage.wizard.subtitle2":`เลือกเวลา`,
"label.deleteoneormore":`ลบหนึ่งรายการขึ้นไป`,
"january":`เดือนมกราคม`,
"label.delete.profile":`ลบโปรไฟล์`,
"label.appointment.wizard.subtitle1-7":`2 ชั่วโมง`,
"label.icon.188":`เครื่องสำอาง`,
"vue_label_file_already_in_lib":`มีอยู่แล้วในไลบรารีเอกสารนี้`,
"label.icon.151":`VR`,
"label.withvalue":`ตามค่า`,
"label.tianyancha.businseeverify.opererror":`การเปิดข้อมูลธุรกิจล้มเหลว โปรดลองอีกครั้งหรือติดต่อผู้ดูแลระบบ!`,
"label.tabpage.individual":`เลือกได้ข้อเดียว`,
"label.layout.editdistribute":`แก้ไขการกำหนดเค้าโครงเพจ`,
"label.smstemplate.lookup":`ดูแม่แบบข้อความสั้น`,
"pagecreator.systemstyle.button.delete":`ลบรูปแบบ`,
"label.customer.tab.step2.same.option1":`เปิดค่าเริ่มต้น`,
"label.knowledgebase.no.results.knowledge":`ไม่มีผล""ใน Knowledge`,
"label.data.exp.newtemporexp":`เลือกวิธีการส่งออกข้อมูลหรือสร้างแม่แบบ`,
"vue_label_chatter_refuse_join":`ปฏิเสธการเข้าร่วม`,
"Homepage.News.002":`บริการเสริมข่าวสารไม่สามารถใช้งานได้ขณะนี้`,
"label.log.requesttype":`วิธีการร้องขอ`,
"vue_label_dashboard_generatefromreport":`สร้างจากรายงาน`,
"label.knowledge.create.version":`สร้างเวอร์ชัน`,
"label.emailtocloudcc.description2":`เชื่อมต่ออีเมลธุรกิจของคุณ`,
"label.partnerCloud.partnerAccount.recharge":`จำนวนเงินที่เติมต้องอยู่ระหว่าง 0.1 ถึง {upperlimit}`,
"label.customobjects":`ออบเจ็กต์ที่กำหนดเอง`,
"label.schedulableprg.endtime":`วันที่สิ้นสุดต้องมากกว่าวันที่ปัจจุบันของระบบ`,
"message.error.viewreport.confirmdelete":`มีแผนภูมิที่ใช้มุมมอง/รายงานปัจจุบันเป็นแหล่งข้อมูล จะลบไปพร้อมกับแผนภูมิหรือไม่`,
"label.marketing.social.seting":`การตั้งค่าโซเชียลมีเดีย`,
"chatter.follow.stop":`เลิกติดตามผูใช้นี้`,
"label.notification.arketsea.return":`{5}จะ{0}：{1}ย้อนกลับไป{2}`,
"label.conditionsofnextapprover":`คำขออนุมัติที่คุณเลือกมีหนึ่งรายการหรือมากกว่า จำเป็นต้องมีการแต่งตั้งผู้อนุมัติคนถัดไป ใช้ช่องค้นหาด้านล่างระบุผู้อนุมัติคนถัดไป`,
"label.partner.all.state":`สถานะ`,
"mobel_web_closed":`ปิด`,
"label.icon.65":`อุปกรณ์`,
"label.stdashbord.xsld.business.jinehj":`จำนวนเงินทั้งหมด`,
"label.selectobject":`เลือกออบเจ็กต์`,
"label.account.CurrentFQ":`ไตรมาสบัญชีนี้`,
"label.workflow.estimaterule":`เกณฑ์การประเมินผล`,
"label.list.userinterface.shownewrecordssetup":`การตั้งค่าบันทึกล่าสุด`,
"label.tianyancha.businessverify.msg3":`1: ค่าใช้จ่าย:`,
"label.weixin..xsld.jieduan":`สเตจ`,
"label.first.quarter":`ไตรมาสที่หนึ่ง`,
"Opportunity.Detailed.Phase.Label.002":`คงอยู่ในสถานะปัจจุบันแล้ว {0} วัน`,
"label_tabpage_page":`หน้า`,
"label_emailsync_status_time":`เวลา`,
"label.pleaseselectaapprover":`โปรดเลือกผู้อนุมัติ`,
"label.emailtocloudcc.redmessage5":`ไม่ทราบสถานะ โปรดติดต่อผู้ดูแลระบบ`,
"label.four.quarter":`ไตรมาสที่สี่`,
"label_chatter_relateList":`รายการที่เกี่ยวข้อง`,
"label.customfields.new.step2.opration.exid.info":`ตั้งค่าฟิลด์นี้เป็นค่าเอกลักษณ์ของระบบภายนอก`,
"label.projectManagement.nodata.overdue.tasks":`เยี่ยมมาก ไม่มีงานล่าช้า`,
"label.sendemail.activity.task.statuscompleted":`#createbyidccnameที่เคารพ สวัสดี: \ r \ n  
คุณได้มอบหมายภารกิจให้ #belongtoidccname เมื่อ#createdate ข้อมูลเฉพาะของภารกิจ มีดังนี้: \ r \ n หัวข้อ: #subject \ r \ n
วันหมดอายุ: #expireDate \ r \ n 
รายการที่เกี่ยวข้อง : #Relatedstr \ r \ n 
เนื้อหา: #remark \ r \ n 
สำหรับรายละเอียดเฉพาะ โปรดไปที่ลิงก์นี้: \ r \ n #path \ r \ n 
โปรดทราบ #belongtoidccnameถูกทำเครื่องหมายว่าเสร็จสมบูรณ์แล้ว  \ r \ n 
#ระบบorgNameCRM`,
"label.sso.saml.idp.config.issuer":`ผู้ออก`,
"label.cannot.delete":`รายการ) ไม่อนุญาตให้ลบ`,
"label.pigeonhole.sel_f":`เลือกโฟลเดอร์ที่ต้องการจัดเก็บถาวร`,
"label.customfields.text.tip":`อนุญาตให้ผู้ใช้ใส่ตัวอักษรและตัวเลขใดๆ ผสมกัน`,
"message.error.user.service.common":`การดำเนินการล้มเหลว โปรดติดต่อผู้ดูแลระบบเพื่อขอรับความช่วยเหลือ!`,
"label.datamanage.account.information":`ข้อมูลลูกค้า`,
"vue_label_homepage_deleteprofilepage":`ลบหน้าแรกโปรไฟล์`,
"label.sendmail.step3.introduce3":`ผู้ที่ได้รับข้อความสั้นนี้`,
"label.pc.ui.2018.recentitem":`รายการล่าสุด`,
"label.report.loading":`กำลังโหลดอย่างเต็มที่`,
"vue_label_globalsearch_adjustment":`วิธีการปรับ`,
"label_report_line_yixuan":`คอลัมน์รายงานที่เลือก`,
"label.h5.similar.opportunity.only.view":`แสดงผลเท่านั้น`,
"label.marketactivitymember":`สมาชิกแคมเปญ`,
"label.recycle.execute.tip":`คำขอของคุณได้รับการดำเนินการแล้ว การล้างถังขยะรีไซเคิลจะต้องใช้เวลา ระบบจะส่งอีเมลแจ้งให้คุณทราบหลังจากเสร็จสิ้น`,
"label.permission.detail.system.setting":`การตั้งค่าระบบสิทธิ์`,
"label.RecordType":`ชนิดบันทึก`,
"label.custom.error.between":`วันเริ่มต้นปีที่กำหนดเองหรือวันสิ้นสุดปีที่กำหนดเองอยู่ภายในช่วงปีที่กำหนดเองในอดีต โปรดตรวจสอบและตั้งค่าอีกครั้ง!`,
"vue_label_dashboard_selectview":`เลือกมุมมอง`,
"label.tianyancha.businessverify.cancel":`ปิดการใช้งานการทวนสอบข้อมูลธุรกิจ`,
"label.partnerCloud.financeSetting.MD5":`คีย์ MD5`,
"label.multilang.messagedetail.new.error":`เราไม่พบผู้ใช้ Chat ใดที่ชื่อประกอบด้วย{0}`,
"label.callcenter.pleaseenter.private.key":``,
"label.umeng.activity.youdistribute":`คุณมอบหมายให้`,
"label.weixin.nickname":`ชื่อเล่น`,
"label.customerinfo.mailusername":`ส่งชื่อผู้ใช้ทางอีเมล`,
"label.partnerCloud.orderingPlatform.discountPlan":`ชื่อแผนส่วนลด:`,
"lable.account.year":`ปีงบประมาณ`,
"T":`เวลา`,
"System.Email.Template.Title":`ยินดีต้อนรับสู่แฟลตฟอร์ม CloudCC CRM`,
"label.login.type":`ประเภทการเข้าสู่ระบบ`,
"label.notification.evaluation":`{0}แสดงความคิดเห็น{2}ในเคส{1}`,
"label.turntolist":`ไปที่รายการ`,
"label.sort":`จัดเรียง`,
"vue_label_commonobject_notice_clickcross":`หากคุณต้องการแทนที่ไฟล์ที่อัปโหลด กรุณาคลิกปุ่ม【X】และอัปโหลดใหม่อีกครั้ง`,
"label.Select.maximumecords.operate":`เลือกได้ถึง 200 รายการเพื่อดำเนินการ`,
"label.submission_rate":`อัตราการส่ง`,
"label.datadelete.record.sucessfully":`รายการบันทึกลบสำเร็จ!`,
"label.version.standard.dashboard":`แดชบอร์ด`,
"label.task.postunsolve":`ภารกิจที่เลยกำหนดเวลา`,
"label.Receivables.name":`ชื่อแผนการเก็บเงิน`,
"label_tabpage_noOperationz":`เนื้อหานี้เป็นรายการคงที่ ไม่สามารถดำเนินการได้!`,
"label.attendance.onrecord":`เลือกบันทึกอย่างน้อยหนึ่งรายการ`,
"label.partner.error2":`ข้อผิดพลาด: ชื่อโดเมนต้องใช้ภาษาอังกฤษหรือตัวเลขเท่านั้น`,
"label.account.map":`แผนที่ลูกค้า`,
"label.dashboardSetup.reference.legend":`คําอธิบายข้อมูลอ้างอิง`,
"label.Yaxisscope":`ช่วงแกน Y`,
"label.hierarchy.tree.tip":`แผนภูมิลำดับชั้นที่สร้างขึ้นจากการเลือกบันทึกในฟิลด์การค้นหาตัวเองในแต่ละเมนู แผนภูมิลำดับชั้นมีดังนี้:`,
"label.permission.objlist.columnsize":`จำนวนฟิลด์ทั้งหมด`,
"label.setup.mobile.bottombutton.savesuccess":`การตั้งค่าหน้าเพจระดับหนึ่งบนอุปกรณ์มือถือสำเร็จ`,
"label.mobile.side.tab.selected":`เลือกแล้ว`,
"label.partner.donotdel.cause":`ถูกลบเนื่องจากเชื่อมโยงกับผู้ใช้พาร์ทเนอร์ต่อไปนี้`,
"label.ccchat.message.new.error4":`คำเตือน:`,
"vue_label_systemSettings_setorganization":`ตั้งค่าแอปพลิเคชันขององค์กร และตั้งค่าแท็บแอปพลิเคชันที่แตกต่างกันสําหรับกลุ่มต่างๆ`,
"label.umeng.approval.approvalmes4obj1":`โปรดอนุมัติภายในเวลา`,
"UG_opportunity_010":`เปิดการเสนอขายใหม่`,
"label.tag.addtags.public":`สาธารณะ`,
"System.TAB.SeeViewPageAmount":`ดูจำนวนหน้า`,
"label.filterconditions":`เงื่อนไขตัวกรอง`,
"front-personalEmailBox-module-v12-clear-not-associated":`ยกเลิกการเชื่อมต่อจะล้างอีเมลทั้งหมดที่ไม่ได้เชื่อมโยงกับกล่องจดหมาย ยืนยันว่าจะยกเลิกการเชื่อมโยงหรือไม่`,
"label.assign":`มอบหมาย`,
"label.layout.clone.tip":`สามารถเลือกเค้าโครงที่มีอยู่เพื่อคัดลอก`,
"label.choose.relatedlist":`เลือกรายการที่เกี่ยวข้องเพื่อถ่ายโอน`,
"label_chatter_recordcall":`บันทึกการโทร`,
"label.product.proofOne":`โปรดเลือกตัวเลือกผลิตภัณฑ์ไม่เกิน {1} รายการใน{0}`,
"label.layout.availablefield.relatedlist":`ฟิลด์ / รายการที่เกี่ยวข้องพร้อมใช้งาน`,
"label.campaignmember.main.updateleadstatus":`อัปเดตสถานะ-ลีด`,
"label.custom.buttonandlink":`ปุ่มหรือลิงก์ที่กำหนดเอง`,
"label.view.manage":`การจัดการมุมมอง`,
"label.search.exp":`เลือกไฟล์ที่คุณต้องการเปิดใช้งานฟังก์ชันต่อไปนี้แล้วคลิก "บันทึก":`,
"vue_label_appstore_apply_to":`ใช้กับ`,
"label.dashboard.message.refreshfail":`การรีเฟรชแดชบอร์ดล้มเหลว`,
"UG_Case_02":`เคสจะช่วยให้คุณสามารถตอบสนองและแก้ไขปัญหาของลูกค้าได้ เคสเป็นบันทึกที่มีฟังก์ชันทรงพลังของ Cloud CC ที่ไม่เพียงแต่สามารถติดตามปัญหาของลูกค้าได้ แต่ยังสามารถแสดงมุมมองของลูกค้าที่สมบูรณ์ได้ด้วย`,
"label.project.hit.three":`แจ้งเตือนงานย่อยทุกวัน`,
"label.tianyancha.businessverify.tip":`เลือกเปิดใช้งานการทวนสอบข้อมูลธุรกิจ เมื่อผู้ใช้กรอกข้อมูลบริษัทของลูกค้า จะช่วยให้ผู้ใช้สามารถกรอกข้อมูลการลงทะเบียนธุรกิจของลูกค้าที่ถูกต้อง`,
"label_emailsync_status_disconnect":`ยกเลิกการเชื่อมต่อ`,
"label.rule.disabled.successfully":`ปิดใช้งานกฎเรียบร้อยแล้ว`,
"label.custombutton.queryerror":`การสืบค้นล้มเหลว กรุณาดำเนินการอีกครั้ง`,
"label.customfields.deletecannotresume":`ข้อมูลที่เกี่ยวข้องจะถูกลบอย่างถาวรและไม่สามารถกู้คืนได้ โปรดดำเนินการด้วยความระมัดระวัง`,
"label.account.current.M":`เดือนนี้`,
"label.under.approve.data":`บันทึกที่อยู่ระหว่างการอนุมัติ (`,
"vue_label_title_remainingdays":`จำนวนวันที่เหลือ`,
"label.partnerCloud.orderingPlatform.refundable":`มีเงินคืนสำหรับใบสั่งซื้อนี้`,
"label.lookup.iscover":`แก้ไขว่าจะอนุญาตให้ซิงค์หรือไม่`,
"label.recordtype.detail.selectlist":`สามารถใช้เป็นรายการตัวเลือกสำหรับการแก้ไข`,
"label.sso.isActiveYes":`ใช่`,
"label.service.appointmentList.canceltheSuccess":`ยกเลิกสําเร็จ`,
"label.escalation.setup.newentries.createfirst":`ขึ้นอยู่กับเวลาที่สร้างเคสและปิดใช้งานหลังจากที่เคสถูกแก้ไขครั้งแรก`,
"label.new.ccpeakfolder":`คลาส: สร้างโฟลเดอร์ใหม่`,
"lable.currencyAdv.exchagecurrency.after":`หลังจาก`,
"label.majoranddetailrelation":`ความสัมพันธ์แบบข้อมูลหลัก-ข้อมูลรอง`,
"label.appointment.wizard.subtitle4-2-1":`1 ชั่วโมง`,
"label.projectManagement.working.hours":`เวลาทำการ`,
"label.forecast.customforecast.button.forehistory":`ประวัติการพยากรณ์`,
"label.mymasterplate":`แม่แบบของฉัน`,
"component.setup.tabs.label.memo":`ตั้งค่าชื่อป้ายกำกับTab`,
"label.customfields.longtextarea.tip":`อนุญาตให้ผู้ใช้ป้อนข้อความได้หลายบรรทัด จำนวนอักขระสูงสุด 32,000 ตัว และแต่ละออบเจ็กต์จะรองรับฟิลด์ได้สูงสุด 10 ประเภท`,
"label.service.miniProgram.fillJumpLink":`กรุณากรอก Jump link`,
"label.british.summer.time":`เวลามาตรฐานกรีนิช`,
"label.nogreate":`<= น้อยกว่าหรือเท่ากับ`,
"label.assignment.setup.detail.sameuser":`ผู้ใช้เดียวกัน`,
"mesage.error.profile.delate.user":`ไม่สามารถลบโปรไฟล์ได้ เนื่องจากขณะนี้โปรไฟล์ได้กำหนดผู้ใช้แล้ว`,
"label.tabpage.cownerz":`เปลี่ยนเจ้าของ`,
"label.multilang.dupicatecheck.processedcount":`ประมวลผลข้อมูลที่ซ้ำกันแล้ว {0} ชุด ยังเหลืออีก {1} ชุดที่ยังไม่ได้ประมวลผล`,
"vue_label_report_notice_leavecertification":`คุณยืนยันว่าจะออกจากหน้านี้หรือไม่ ข้อมูลที่คุณป้อนอาจจะไม่ได้ถูกบันทึกไว้`,
"label.master.required":`ในบันทึกมีรายการบังคับที่ยังไม่ได้กรอก`,
"label.chatter.follow":`ติดตาม`,
"label.dataimport.insertdata.error.repeat":`ข้อมูลในบันทึกและฐานข้อมูลเดิมซ้ำกัน บันทึกนี้จะถูกละเว้นการนำเข้า`,
"label.sms.cgid":`หมายเลขกลุ่มช่องทาง`,
"label.knowledge.article.rator":`เราไม่สามารถเก็บบทความถาวรได้เนื่องจากความขัดแย้ง`,
"label.datamanage.object.field":`ฟิลด์ออบเจ็กต์`,
"label.forecast.editshrepage.quanxian":`ระดับการเข้าถึงสิทธิ์การแบ่งปัน`,
"label.weixin.interactive.log":`ล็อกแบบโต้ตอบ`,
"label.batchedit.remark":`สามารถแก้ไขบันทึกได้หลายรายการ`,
"label.user.permissions.message":`ไม่มีสิทธิ์ตั้งค่าข้อมูลผู้ใช้`,
"label.mobile.phone.month":`เดือน`,
"chatter.sel.u":`เลือกผู้ที่ต้องการ @ หรือ @[ชื่อผู้ใช้] ที่หน้าชื่อผู้ใช้โดยตรง`,
"label.service.gantt.assigned.work":`งานที่ได้รับมอบหมาย`,
"UG_ST_001":`แจ้งเตือน`,
"label.edit.select.one":`รายการแบบเลื่อนลง`,
"label.forecast.shrepage.desc0":`หน้านี้จะแสดงรายชื่อผู้ใช้ บทบาท และภูมิภาคที่มีสิทธิ์เข้าถึง{0}ร่วมกัน`,
"label.multilingual.confirm.close":`ยืนยันการปิดใช้งานหรือไม่ เมื่อปิดใช้งานคุณจะไม่สามารถใช้งานหลายภาษาและภาษาของผู้ใช้จะถูกเปลี่ยนเป็นภาษาเริ่มต้นของบริษัท`,
"label.setting.intergrationlist.integration":`การเชื่อมต่อ`,
"label.leadscore.rule.list":`รายการเกณฑ์การให้คะแนนลีด`,
"component_telerecord_button_save":`บันทึก`,
"label.weixin.save.log":`บันทึกล็อก`,
"label.validate.function.funcExplain.DAY":`ส่งกลับวันที่ของเดือน คือตัวเลขระหว่าง 1 และ 31`,
"label.appointmentdetail.wizard.title1":`ชื่อการประชุม`,
"label.multilang.feedtrack.dealkey":`นำ {0} จาก {1} เปลี่ยนเป็น {2}`,
"label.optional.features":`ตัวเลือกฟังก์ชัน`,
"vue_label_email_no_email":`ไม่มีอีเมล`,
"label.sendemail.chat.messagecontent":`เนื้อหาของข้อความ:`,
"label.tabpage.lessequalz":`น้อยกว่าหรือเท่ากับ`,
"setup.layout.label.setupfield":`ตั้งค่าคุณสมบัติฟิลด์`,
"label.approved.receiveApprovalEmail.option1":`หากฉันเป็นผู้อนุมัติหรือเป็นผู้จัดสรรผู้อนุมัติ`,
"label.chatter.relateList":`รายการที่เกี่ยวข้อง`,
"component.sendmail.label.fromuser":`ผู้ส่ง`,
"label.projectManagement.problem.status":`สถานะปัญหา`,
"label.weixin.fmu.before.hour":`ล่วงหน้า {0} ชั่วโมง`,
"chatter.feed.menutype.feed.mark":`เวยเทียที่ฉันบุ๊กมาร์ก`,
"label.addQuoteLineGroup":`เพิ่มกลุ่มบรรทัดใบเสนอราคา`,
"label.report.action.addtodashboard6":`เพิ่ม`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`ไตรมาสปฏิทินนี้และก่อนหน้า`,
"label.tabpage.emptyz":`ล้าง`,
"less":`น้อยกว่า`,
"label.h5.selectmostphotos":`คุณเลือกได้สูงสุด 9 รูปภาพ`,
"UG.activity.04":`อีเมล Outlook/Gmail บันทึกอีเมลขาออก`,
"template.chart.qbhtje":`ยอดเงินสัญญาทั้งหมด`,
"label.tabpage.endz":`สิ้นสุด`,
"label.partner.workspace.member":`สมาชิก`,
"label.filter.error.filedvaluetoolong":`ข้อผิดพลาด: ค่าฟิลด์เกินขีดจํากัดสูงสุด`,
"label.months":`ของเดือน`,
"button.partner.workspace.disable":`ปิดการใช้งาน`,
"label.visualpage.checkpinyin.grammar":`กรุณาตรวจสอบการสะกดและไวยากรณ์`,
"label.dashboardSetup.geshihua":`รูปแบบ`,
"label.belongto":`เป็นของ`,
"label.upload.cannot.empty":`ไฟล์อัปโหลดต้องไม่ว่างเปล่า!`,
"label.number.MaxCheck":`จํานวนสูงสุดของ{0}คือ {1} โปรดแก้ไขจำนวนแล้วคลิกบันทึก`,
"pagecreator.page.message.save.fail":`การบันทึกหน้าเพจล้มเหลว`,
"label.edit.SMS":`แก้ไขการแจ้งเตือนข้อความสั้น`,
"UG_Lead_002":`มีหลายวิธีในการระบุ "ลีด" สําหรับผลิตภัณฑ์หรือบริการของคุณ`,
"label.quickcreate.active.quickcreate":`เปิดใช้งานการสร้างด่วน`,
"label.recordtypeselect.tip":`หากในอนาคตต้องการข้ามหน้านี้ โปรดเปลี่ยนการตั้งค่าชนิดบันทึกในหน้าการตั้งค่าส่วนบุคคล`,
"label.form_content":`เนื้อหาฟอร์ม`,
"workflow.action.tasks.assignortype.related":`ผู้ใช้ที่เกี่ยวข้อง`,
"vue_label_allsearch_set_more_items":`คุณสามารถตั้งค่าคําค้นหาเพิ่มเติมในช่องเลื่อนลงด้านซ้ายของช่องค้นหาเพื่อค้นหาต่อไปได้`,
"label.tianyancha.businessverify.title":`การทวนสอบธุรกิจ`,
"label.errormessage.batchedit.norecord":`ไม่มีข้อมูล`,
"label.permission.appname":`ชื่อแอปพลิเคชัน`,
"label.report.action.addtodashboard7":`ยกเลิก`,
"label.generated.transfer.product":`สินทรัพย์จะถูกสร้างขึ้นเมื่อโอนสินทรัพย์ตาม "การแปลงสินทรัพย์" ของผลิตภัณฑ์`,
"vue_label_commonobjects_detail_you":`คุณ`,
"label.user.captcha":`ทวนสอบรหัสยืนยันของผู้ใช้`,
"label.notification.event4":`อิเวนต์ที่คุณมอบหมายให้ [ผู้ได้รับมอบหมาย] จะเริ่ม ณ [เวลาเริ่มต้น]`,
"label.version.setup":`การตั้งค่าหลังบ้าน`,
"setup.object.layout.message.selectedlayoutandrecordtype":`กรุณาเลือกเค้าโครงและชนิดบันทึก`,
"label.role.add":`เพิ่มบทบาท`,
"label.versiontype.Unlimited":`รุ่นอันลิมิเต็ด`,
"label.partnerCloud.financeSetting.developerID":`โปรดป้อน ID ผู้พัฒนา`,
"front-invoice-online-payment-setup-global":``,
"vue_label_commonobjects_view_basis":`จำแนกตาม`,
"label.decimaldigits.tip":`จำนวนตัวเลขด้านขวาของจุดทศนิยม`,
"vue_label_commonobjects_detail_selected":`ทำเครื่องหมายว่า{labelname}ที่เลือก`,
"label.data.export.page":`เข้าสู่หน้าการส่งออกข้อมูล`,
"message.error.serviceresource.servicecrewid":`แต่ละทีมบริการสามารถเพิ่มเป็นหนึ่งรายการในบันทึกทรัพยากรบริการของประเภททีมเท่านั้น`,
"label.loginttime.alltime":`เวลาทั้งหมดคือ`,
"label.requiredinfo":`ข้อมูลจำเป็น`,
"label.forecast.edit.di":`ที่`,
"vue_label_calendar_failed_to_remove_calendar":`การลบปฏิทินล้มเหลว`,
"pagecreator_systemstyle_button_delete":`ลบรูปแบบ`,
"label.import.page3.continueimport":`นำเข้าต่อไป`,
"label.page.width":`หน้ากว้างเต็มรูปแบบ`,
"label.campaignmember.selectmember.addmember":`เพิ่มสมาชิกใน`,
"label.finalreject":`การปฏิเสธขั้นสุดท้าย`,
"label.isend":`สิ้นสุดหรือไม่`,
"front-console-conversation":``,
"label.mr.theLastGroupOfThisPage":`นี่เป็นกลุ่มสุดท้ายในหน้านี้แล้ว กรุณาคลิก [ย้อนกลับไปดูรายการข้อมูลที่ซ้ำกัน] เพื่อค้นหาข้อมูลที่ซ้ำกัน`,
"label.data.dataexpalltype.all_desc":`ส่งออกข้อมูลของออบเจ็กต์ทั้งหมดที่ผู้ใช้ปัจจุบันมีสิทธิ์ดู`,
"label_emailtocloudcc_redmessage7":`การตั้งค่าหลังบ้านผิดพลาด โปรดติดต่อผู้ดูแลระบบ`,
"label.forecast.shrepage.classdes.all":`สิทธิ์การเข้าถึงแบบเต็มรูปแบบ - ผู้ใช้จะสามารถดูและเขียนทับข้อมูลที่พยากรณ์ ผู้ใช้ยังสามารถแบ่งปันการเข้าถึงให้แก่ผู้ใช้รายอื่นได้`,
"market.contacts":`ผู้ติดต่อด้านการตลาด`,
"label.weixin.polls.voter":`รายการผู้เข้าร่วมโหวต`,
"template.report.industry.distribution.customers":`การกระจายอุตสาหกรรมของลูกค้า`,
"front-electronic-signature-setup":``,
"vue_label_chatter_removecertification":`ยืนยันว่าจะลบสมาชิกกลุ่ม"{name}"หรือไม่`,
"label.appointment.wizard.subtitle1-2":`15 นาที`,
"label.sso.saml.idp.config.custattr":`คุณสมบัติที่กำหนดเอง`,
"label_tabpage_totalTeamz":`ทีมทั้งหมด`,
"lable.outlook.detail.assigned":`ผู้ใช้และโปรไฟล์ที่กำหนด`,
"label.department.user.delete":`ลบ`,
"label.customcomponent.check.label.same":`มีชื่อป้ายกำกับนี้แล้ว`,
"label.partner.error1":`ข้อผิดพลาด: ชื่อโดเมนยาวเกินไป`,
"label.escalation.setup.entrydetail.escalation.notify":`แจ้งเตือน`,
"component_todaytask_label_choicestate":`เลือกสถานะ`,
"label.customfields.fielddependency.new.step1":`<b> ขั้นตอนที่ 1: </b> เลือกฟิลด์ควบคุมหนึ่งฟิลด์และฟิลด์พึ่งพาหนึ่งฟิลด์ เมื่อเสร็จสิ้นคลิก "ดำเนินการต่อ"`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`ทุกคนสามารถดูและขอเข้าร่วมกลุ่มนี้ได้`,
"label.custom.pixel":`พิกเซล`,
"label.quicksave":`บันทึกด่วน`,
"label.approved.persion":`ผู้ได้รับอนุญาต`,
"lable.info.queue.member":`สมาชิกคิว`,
"label.addattachment.step2.weixin":`ขั้นตอนที่ 2. คลิกปุ่ม "อัปโหลดไฟล์" เพื่ออัปโหลดไฟล์`,
"label.forecast.customforecast.title":`การพยากรณ์`,
"mainpage_setup_chosecomponent_leastone":`ต้องวางอย่างน้อยหนึ่งส่วนเสริมในหน้าแรก`,
"label.appointmentconfirmpage.wizard.title2":`ส่งรายละเอียดกำหนดการนัดหมายนี้ไปที่อีเมลของคุณแล้ว`,
"label.useallselectedapprover":`ผู้อนุมัติที่เลือกทั้งหมดต้องอนุมัติ <strong> อย่างสม่ำเสมอ </strong>`,
"label.ccpeak.current.line.return":`จะกลับจากบรรทัดปัจจุบัน และจะไม่ดำเนินการลงอีกต่อไป!`,
"label_new_target_model":`แบบจำลองเป้าหมายใหม่`,
"label.saving":`กำลังบันทึก...`,
"label.mobile.phone.write":`เขียน`,
"label.applt.updown.text":`นอกจากนี้คุณยังสามารถดาวน์โหลดรหัสคิวอาร์มินิโปรแกรมพอร์ทัลของบริษัทคุณ และวางรหัสคิวอาร์ลงในหน้าเว็บหรือบทความสาธารณะ ซึ่งลูกค้าจะสามารถสแกนรหัสคิวอาร์เพื่อใช้มินิโปรแกรมได้`,
"label.partner.common.manageSetup":`การตั้งค่าการจัดการพาร์ทเนอร์คลาวด์`,
"label.quickbooks.new":`ลูกค้าใหม่`,
"message.error.color":`color ไม่สามารถว่างเปล่า!`,
"label.project.template.two":`แต่ละออบเจ็กต์ของแต่ละประเภทบันทึกสามารถกําหนดค่าได้เพียงชุดเดียว!`,
"label.approval.input.des1":`การอนุมัติตามระดับที่มีระดับสูงสุดคือ:`,
"label.x.axis.cannot.empty":`แกน X ไม่สามารถว่างเปล่า!`,
"label.solomon.isiands.time":`เวลาหมู่เกาะโซโลมอน`,
"label.login.access.duedate":`ระยะเวลาการเข้าถึง`,
"label.service.dispatch.booking.order":`มอบหมายการนัดหมายการบริการ`,
"label_shareme_forecast":`แบ่งปันไปยังการพยากรณ์ของฉัน`,
"label.custom.page.cuspage.height":`ความสูงของหน้า (พิกเซล)`,
"label.quote.line.group.":`คุณแน่ใจหรือว่าต้องการลบกลุ่มบรรทัดใบเสนอราคา {groupName} หลังจากลบ รายการใบเสนอราคาในกลุ่มจะถูกลบไปพร้อมกัน`,
"label.data.downpage.i_title.num6":`แนะนำคุณว่าให้นำเข้าบันทึก 5 รายการเพื่อทดสอบก่อนจึงนำเข้าข้อมูล เพื่อให้แน่ใจว่าไฟล์ที่นำเข้านั้นถูกต้อง`,
"label.\u2019s":`ของ`,
"label.version.contact.management":`การจัดการสัญญา`,
"label.document.history.user":`ผู้ใช้`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`กรุณาระบุจำนวนเงินที่ถูกต้องโดยทศนิยมต้องไม่เกินสองตำแหน่ง`,
"label.weixin.target.contract.jine":`จำนวนเงินเป้าหมายในสัญญา`,
"lable.common":`รวม ¥ 0`,
"front-kefu-moudle-sendemail-success":``,
"label.service.no.operation.time":`บันทึกปัจจุบันไม่มีเวลาดำเนินการที่เกี่ยวข้อง!`,
"label.info":`ข้อมูล`,
"label.ccchat.zw":`กลางวัน`,
"label.assignment.setup.newentries.title":`แก้ไขรายการเกณฑ์`,
"label.weixin.report.timeline":`กรอบเวลา`,
"UG.quota.04":`พิมพ์ใบเสนอราคา`,
"label.social.user.exception":`ข้อมูลผู้ใช้ social ผิดปกติ`,
"label.import.index.failed":`ล้มเหลว`,
"label.common.settings":`การตั้งค่าทั่วไป`,
"label.nullvalue":`ค่าว่าง`,
"PageLayout_Search_MultiSearch_002":`ฟิลด์การค้นหาถูกกระจายเพื่อแสดง (การค้นหาฟิลด์เดียว)`,
"message.myselfreport":`รายงานของฉัน`,
"label.productsales.today.noevttskaddtsk":`วันนี้ไม่มีอิเวนต์ที่ยังไม่ได้ดำเนินการหรือภารกิจที่ครบกำหนด คุณสามารถคลิก" "บนขวามือเพื่อเพิ่มภารกิจ`,
"lable.oppdt.noconditionrecrods":`ไม่มีบันทึกที่สอดคล้องกับเงื่อนไข`,
"label.campaignmember.selectmember.deletelead":`แคมเปญ: ลบสมาชิกออกจากลีด`,
"label.marketingactivity":`แคมเปญ`,
"vue_label_pool_self-built":`สร้างเอง`,
"message.textareamaxlength":`ต้องยาวไม่เกิน 4,000`,
"label.valadate.must.value":`ต้องป้อนค่า`,
"label.tabpage.groupsVisiblez":`ผู้ใช้บางกลุ่มมองเห็น`,
"component.button.cancel":`ยกเลิก`,
"label.emailobject.list.inbox":`กล่องขาเข้า`,
"label.app.step1.error.labelexist":`ข้อผิดพลาด: มีป้ายกำกับนี้แล้ว`,
"front-calendar-V1-Unable-to-display":`บันทึกไม่สามารถแสดงในปฏิทินเนื่องจากมีหนึ่งบันทึกขึ้นไปที่ฟิลด์สิ้นสุดเร็วกว่าฟิลด์เริ่มต้น`,
"label.forecast.settings.prompt1":`ต้องเลือกพยากรณ์อย่างน้อย 1 ตัวเลือก: รายได้หรือจำนวน`,
"front-kefu-moudle-callout-missphone":``,
"label.tabpage.editz":`แก้ไข`,
"vue_label_chatter_label_new_team":`กลุ่มใหม่`,
"label.version.formulafield":`ฟิลด์สูตร`,
"label.partner.step1":`ขั้นตอนที่ 1: เลือกแม่แบบ`,
"label.weixin.perfect.url":`URL การกรอกข้อมูลเพิ่มเติม`,
"label.appointmentconfirmail.wizard.subtitle4":`คำอธิบาย`,
"label.step7.total7":`ขั้นตอนที่ 7 จาก 7`,
"setup.object.layout.label.selectedprofile":`โปรไฟล์ที่เลือก`,
"label.payments.paytip5":`โปรดป้อนจำนวนที่ถูกต้อง`,
"label.visualpage.open.type":`ประเภทเพจที่กำหนดเองสำหรับเปิด`,
"lable.Sort.field.tips":`กำหนดลำดับของบันทึกในรายการที่เกี่ยวข้องโดยการเลือกฟิลด์ที่จะเรียงลำดับ คุณสามารถเรียงลำดับตามฟิลด์ตัวเลขหรือวันที่ในออบเจ็กต์ได้`,
"label.nosharerules":`ไม่ได้กำหนดกฎการแบ่งปัน`,
"label.service.miniProgram.bindSetOwner":`ตั้งค่าเจ้าของเคส`,
"report_label_highlevelreport":`รายงานขั้นสูงสามารถช่วยคุณสร้างรายงานที่เกี่ยวข้องกับออบเจ็กต์ได้มากที่สุด 4 รายการ`,
"S":`ข้อความ`,
"label.lastmodifyby":`ผู้แก้ไขล่าสุด`,
"label.customerinfo.mailaddress":`ที่อยู่อีเมลขาออก`,
"vue_label_pool_converted":`ข้ามสเตจแล้ว`,
"UG.ST.004":`คุณไม่มีสิทธิ์ในการจัดการ-》และการนำเข้าข้อมูล กรุณาติดต่อผู้ดูแลระบบ คลิกตกลงและเข้าสู่อินเทอร์เฟซ{0}โดยตรง`,
"label.view.application.mobile.terminal.filed":`มุมมองนี้ถูกปรับใช้กับอุปกรณ์มือถือ สามารถเลือกได้สูงสุด 10 ฟิลด์ ขณะนี้มีแล้ว`,
"chatter.feed.limitentity500":`คุณติดตามได้มากที่สุด 500 คนและบันทึก`,
"label.starttime":`เวลาเริ่มต้น`,
"chatter.emailToMe":`เมื่อเกิดสถานการณ์ดังต่อไปนี้ให้ส่งการแจ้งเตือน CCChat ถึงฉัน`,
"label.custom.Current.and.PreviousCQ":`ไตรมาสที่กำหนดเองนี้และก่อนหน้า`,
"label.my.logout":`ของฉัน`,
"label.quickbooks.searchlist.enddate":`วันที่สิ้นสุด`,
"label.ccservice.validate.length":`ค่าที่สอดคล้องกันของฟิลด์{1} ภายใต้ออบเจ็กต์ API {0} คือ{2} ยาวเกินขีดจำกัด กรุณาตั้งค่าใหม่!`,
"label.integrations.installed":`ได้รับอนุญาต`,
"label.integrations.mailchimplist":`รายการ Mailchimp`,
"label.checkfield.matchothers":`จับคู่บันทึกอื่นๆ`,
"label.umeng.activity.event.distributewillbegin":`อิเวนต์ที่คุณมอบหมายให้กับ#name #eventจะเริ่มหลังจาก #time`,
"pool.notice.gotolightning":`หากต้องการใช้ฟังก์ชันนี้ โปรดไปที่รุ่น Lightning`,
"label.batchtransfer.pleaseselecttransferreddata":`กรุณาเลือกข้อมูลที่ต้องการโอนย้าย`,
"label.mr.title.mailingAddress":`ที่อยู่ทางไปรษณีย์`,
"vue_label_approve_no_response":`ไม่ตอบสนอง`,
"component.event.label.title":`อิเวนต์ที่จะเกิดขึ้น`,
"label.mobile.setup.confirm":`คุณกำลังเปลี่ยนข้อมูลตำแหน่งของไอคอนเมนูเริ่มต้นบนอุปกรณ์มือถือ หลังจากการเปลี่ยนแปลงสำเร็จ ไอคอนเมนูบนอุปกรณ์มือถือที่กำหนดค่าไว้บนเมนูก่อนหน้านี้จะถูกล้างออกทั้งหมดเว้นแต่คุณจะตั้งค่าใหม่ มิฉะนั้นระบบตั้งค่าเริ่มต้นเป็นค่าที่คุณตั้งโดยสุ่มเลือกจากแค็ตตาล็อก`,
"label.tianyancha.approvaltime":`เวลาอนุมัติ`,
"label.download_merge_file":`ดาวน์โหลดไฟล์ที่ผสาน`,
"label_display_quota":`แสดงโควตา`,
"label.publishreadonly":`เปิดแบบอ่านอย่างเดียว`,
"label.campagin.roi.query.roi":`ROI ของแคมเปญ`,
"label.dashboardSetup.lookup":`ค้นหาแดชบอร์ด`,
"vue_label_notificationcenter_nomessages":`ไม่มีข้อความที่ยังไม่ได้อ่าน`,
"label.create.object":`สร้างออบเจ็กต์ใหม่`,
"label.social.campaign.null":`ข้อมูลแคมเปญต้องไม่ว่างเปล่า`,
"label.console.step6.left":`ตรึงที่ด้านซ้ายจะมองเห็นรายการได้เสมอ`,
"label.line":`บรรทัด`,
"label.bottonandlink.introduce":`ด้านล่างคือปุ่มหรือรายการลิงก์ หากต้องการเพิ่มปุ่มหรือรายการลิงก์ กรุณาแก้ไขเค้าโครงเพจ <br/> ปุ่มสามารถแสดงในหน้ารายละเอียดข้อมูล รายการที่เกี่ยวข้อง และมุมมองรายการ：<br/>      1. หากต้องการกำหนดปุ่มหรือลิงก์ในหน้ารายละเอียดด้วยตนเอง กรุณาแก้ไขเค้าโครงเพจ <br/>      2. หากต้องการกำหนดปุ่มหรือลิงก์ในรายการที่เกี่ยวข้องด้วยตนเอง กรุณาแก้ไขคุณลักษณะรายการที่เกี่ยวข้องในตำแหน่งที่ปรากฎในรายการที่เกี่ยวข้องของเค้าโครงเพจ <br/>      3. หากต้องการกำหนดปุ่มหรือลิงก์ในมุมมองรายการด้วยตนเอง กรุณาแก้ไขเค้าโครงมุมมองรายการใน "เค้าโครงการค้นหา"`,
"label.layout.list1":`รายการ 1`,
"label.mr.title.customerName":`ชื่อลูกค้า`,
"label.user.text":`ข้อความ`,
"label.nolastestrecord":`ไม่มีบันทึกล่าสุด`,
"label.emailobject.appointment.urltext1":`นี่คือตารางเวลาของฉัน โปรด`,
"label.chat.topic.my.favorites":`รายการโปรดของฉัน`,
"label.select.dashboar.cd0":`ฟิลด์การจัดกลุ่มไม่สามารถว่างเปล่า`,
"label.data.downpage.e_title.num2":`2. หากคุณเลือกที่จะส่งออกข้อมูลออบเจ็กต์เดียว คุณต้องเลือกวิธีการส่งออกข้อมูล ได้แก่ การส่งออกแบบกำหนดเอง การส่งออกตามแม่แบบ และแม่แบบส่งออก`,
"message.error.user.service.login.unconn":`เซิร์ฟเวอร์เกิดความผิดพลาด โปรดรอ`,
"label.escalation.setup.newentries.title":`แก้ไขรายการเกณฑ์`,
"label.import.step1.above2000":`เมื่อเรียกใช้ทริกเกอร์จะนำเข้าได้สูงสุด 2,000 รายการ โปรดแยกไฟล์ออกเป็นหลายไฟล์ และนําเข้าเป็นส่วนๆ`,
"label.ccchat.person.allowinvite":`อนุญาตให้เพื่อนร่วมงานเชิญ`,
"label.input.number.between":`กรุณาป้อนตัวเลขระหว่าง {0} และ {1}`,
"label.forecast.shrepage.wpfmanager":`ผู้จัดการการพยากรณ์ที่ได้รับการแต่งตั้ง`,
"label_server_is_time_out":`เซิร์ฟเวอร์หมดเวลา ลองอีกครั้งในภายหลัง`,
"label.indochina.standard.time":`เวลามาตรฐานอินเดีย`,
"label.cpq.quote.sync.opportunity.failure":`เฉพาะใบเสนอราคาหลักเท่านั้นที่จะซิงค์กับโอกาสทางธุรกิจได้ โปรดเลือกใบเสนอราคาหลักแล้วค่อยเริ่มการซิงค์`,
"label.emailobject.send100emails":`ขออภัย คุณส่งอีเมลได้เพียง 100 ฉบับต่อวัน โปรดเลือกอีกครั้ง!`,
"label.dashboard.snapshot.end":`จบ`,
"label.jiandangfenpei.rightlist":`โปรไฟล์ที่กำหนด`,
"label.input.string.length.between":`กรุณาป้อนสตริงที่มีความยาวระหว่าง {0} และ {1}`,
"label.multilang.lookfiltercondition.select":`เงื่อนไขของแถวที่ {0} ไม่ถูกต้อง จำเป็นต้องเลือกหนึ่งฟิลด์!`,
"label.datamanage.lead.namenull":`หมายเหตุ: หากไม่กำหนดค่าให้กับฟิลด์ "ชื่อลีด" จะไม่นำเข้าบันทึก!`,
"label.forecast.detailforecast.button.saveandfresh":`บันทึกและรีเฟรช`,
"label.venezuela.time":`เวลาเวเนซุเอลา`,
"label.same.analyze.miaoshu1":`หากคุณต้องการกฎเพิ่มเติม กรุณาใช้ "`,
"label.twomb":``,
"label.event.moveup.7hour":`ล่วงหน้า 7 ชั่วโมง`,
"label.weixin.forgot.password":`ลืมรหัสผ่านใช่ไหม?`,
"label.import.page1.diledsizelimited":`2. อัปโหลดไฟล์ได้สูงสุด 100M`,
"label.file.foldername":`ชื่อโฟลเดอร์`,
"label.multilingual.open":`เปิดใช้งานการจัดการหลายภาษา`,
"label.dashboard.snapshot.refresh.failed":`การรีเฟรชสแนปชอตของแดชบอร์ดล้มเหลว`,
"label.marketsea.memberfieldselectone":`ฟิลด์ค้นหาและฟิลด์ที่สมาชิกสามารถดูได้ โปรดเลือกอย่างน้อยหนึ่งฟิลด์`,
"label.trigger.createdate":`สร้างเวลา`,
"label.ccpeak.operation.sharetab":`ดำเนินการตารางแบ่งปัน:`,
"label.partner.message.admin.access":`เฉพาะผู้ดูแลระบบเท่านั้นที่เข้าสู่ระบบได้`,
"label.emailsync.status.email":`อีเมล`,
"chatter.error":`ข้อผิดพลาด: โปรดเลือกไฟล์ที่ต้องการอัปโหลดก่อน!`,
"label.role.viewinlist":`แสดงในมุมมองรายการ`,
"label.tag.addtags.title":`ป้ายกำกับ`,
"setup.mainpage.label.welcome6":`ผู้ใช้สามารถสร้างฟิลด์ประเภทต่างๆ ในออบเจ็กต์ทั้งหมดของระบบ CloudCC โดยไม่ต้องมีความรู้ด้านการเขียนโปรแกรมหรือการพัฒนารหัสของฟิลด์ ประเภทของฟิลด์ ได้แก่ ค้นหาความสัมพันธ์ เลือกฟิลด์เดี่ยว เลือกฟิลด์คู่ สูตร หมายเลขอัตโนมัติ URL โทรศัพท์ โทรสาร อีเมล กล่องกาเครื่องหมาย วันที่ เวลา ตัวเลข ข้อความ กล่องข้อความ รายการตัวเลือก (ตัวเลือกเดียว/หลายตัวเลือก) สกุลเงิน ฯลฯ`,
"label.delete.rule.successfully":`ลบกฎสําเร็จ`,
"label.field.duplicate.error.msg6":`ค่าฟิลด์ซ้ํากัน บันทึกที่มีอยู่:`,
"label.stdashbord.xsld.business.jhzsl":`โอกาสทั้งหมด`,
"label.compact.layout":`เค้าโครงข้อมูลสำคัญ`,
"label.checkfield.merge.introduce":`โปรดเลือกค่าที่จะเก็บไว้ในบันทึกที่ผสาน`,
"earlieststarttime.duedate.time.illegal":`เวลาเริ่มต้นที่อนุญาตเร็วที่สุดสําหรับการนัดหมายการบริการควรน้อยกว่าหรือเท่ากับวันหมดอายุ`,
"label.dataimport.validate.prompt":`แจ้งเตือนเกณฑ์การทวนสอบ`,
"message.setuptip":`หลังจากสร้างแล้วสามารถลบได้`,
"template.report.customer.collection.statistics":`สถิติการชําระหนี้ของลูกค้า`,
"vue_label_homepage_dashboardcomponents":`แก้ไขส่วนเสริมแดชบอร์ด`,
"setup.mainpage.label.welcome30":`แพลตฟอร์ม CloudCC เป็นแพลตฟอร์มการประมวลผลใน clound ที่แท้จริง มีคุณลักษณะแพลตฟอร์มแบบเปิด โดยบูรณาการอย่างมีมาตรฐาน ปรับแต่งได้อย่างยืดหยุ่นสำหรับทุกแขนงอาชีพ สามารถร่วมมือกับซอฟต์แวร์ของบุคคลที่สาม เพื่อรวบรวมข้อมูลการบริหารจัดการองค์กรแบบเรียลไทม์และเป็นหนึ่งเดียว  ตอบสนองความต้องการการจัดการเชิงลึกของลูกค้าในระดับสูงสุด แพลตฟอร์ม CloudCC สามารถรวมเข้ากับแอปพลิเคชันหรือระบบขององค์กรใดก็ได้ รวมถึง SAP, Kingdee, Yonyou และซอฟท์แวร์อื่นๆ ของบุคคลที่สาม ใช้รูปแบบ Web Service มาตรฐานภายใต้รูปลักษณ์ SOA ที่ยืดหยุ่น ไม่มีผลเสียใดๆ และไม่มีการพึ่งพาเทคโนโลยีหรือการเจาะจงผู้ขาย`,
"label.SMS.new.det":`สร้างการแจ้งเตือนทางข้อความสั้นเพื่อเชื่อมโยงกับกฎเวิร์กโฟลว์ และกระบวนการอนุมัติหนึ่งอย่างหรือมากกว่า หากเปลี่ยนแปลงการแจ้งเตือนทางข้อความสั้นหรือการแก้ไขใดๆ นั้นจะถูกใช้กับกฎและการอนุมัติทั้งหมดที่เกี่ยวข้อง`,
"lable.product.page.previous":`กลับไปยังหน้าก่อนหน้า`,
"label.recordtype.labelname":`ป้ายกำกับชนิดบันทึก`,
"message.error.system.service.failure":`การดำเนินการบริการล้มเหลว โปรดติดต่อผู้ดูแลระบบ!`,
"label.visualpagefolder":`โฟลเดอร์เพจ`,
"label.username":`ชื่อผู้ใช้`,
"label.data.downpage.i.title.num5":`5. โปรดตรวจสอบความถูกต้องของข้อมูล`,
"label.permission.manage":`จัดการการมอบหมาย`,
"label_emailsync_status_user":`ผู้ใช้`,
"label.weixin.voting.least.two":`มีตัวเลือกการโหวตอย่างน้อย 2 ตัวเลือก`,
"label.tabpage.thisrecord":`บันทึกนี้`,
"label.icon.119":`กระดานดํา`,
"label.partner.common.webSit":`ชื่อโดเมน`,
"label.email.form.html2":`[เปลี่ยนเป็น "ข้อความเท่านั้น"]`,
"label.appupload.upload.noversion":`ไม่มีรุ่นที่อัปโหลด`,
"label.appointmentpage.wizard.subtitle1_2":`โซนเวลาของผู้เชิญคือ{0}`,
"MR":`ค้นหาหลายรายการ`,
"label.partnerCloud.orderingPlatform.availableBalance":`ยอดเงินคงเหลือในบัญชี`,
"label.schedulejob.setup.schedule.st3":`ที่สาม`,
"label.reportsSubscriptionPage.email.general":`ย่อ`,
"label.setsharerule.step4":`ขั้นตอนที่ 4: เลือกสิทธิ์`,
"front-epwechat-module-v1-info-desc":`คุณจะต้องรับและกรอกข้อมูลต่อไปนี้จากหลังบ้านวีแชทขององค์กร`,
"message.duplication.label.isactive":`เปิดการใช้งานใช่หรือไม่`,
"pagecreator_systemstyle_label_linkcolor":`สีลิงก์`,
"label.import.page1.alertfiledsize":`ขนาดไฟล์ที่อัปโหลดต้องไม่เกิน 100MB!`,
"tomorrow":`พรุ่งนี้`,
"label.publicdashboard":`แดชบอร์ดสาธารณะที่ไม่ได้จัดเก็บถาวร`,
"label.knowledgebase.same.taborworkspace":`แท็บหรือเวิร์คสเปซเดียวกัน`,
"homepage.layout":`เค้าโครงหน้าแรก`,
"label.emailobject.trackemailopening":`ติดตามอีเมล`,
"label.unlock.tip":`ปลดล็อกเพื่อแก้ไข`,
"lable.account.NextzDays":`90 วันถัดไป`,
"vue_label_report_throw":`ทิ้ง`,
"label.icon.102":`กําหนดการ`,
"label.payments.paytip2":`คุณได้อัปเกรดเป็นรุ่นชําระเงิน คลิกยืนยันเพื่อปิดหน้าต่างและรีเฟรชระบบ CRM ของคุณ`,
"label.customfields.email.tip":`อนุญาตให้ผู้ใช้ใส่ที่อยู่อีเมลและทวนสอบให้มั่นใจว่ารูปแบบถูกต้อง ถ้าฟิลด์นี้ได้กำหนดผู้ติดต่อและลีดแล้ว ผู้ใช้สามารถเลือกที่อยู่ได้เมื่อคลิก "ส่งอีเมล" โปรดทราบว่า ที่อยู่อีเมลที่กำหนดเองไม่สามารถใช้กับอีเมลแบบกลุ่มได้`,
"label.test_visitors":`ทดสอบรูปแบบการแสดงผลเมื่อมีผู้ดูฟอร์ม`,
"label.workflow.immediatelyoperate":`ดำเนินการเวิร์กโฟลว์ทันที`,
"label.approvalstep4.tip":`หน้าอนุมัติคือหน้าที่ผู้อนุมัติจะอนุมัติหรือปฏิเสธคำขอ เลือกฟิลด์ที่ต้องการแสดงบนหน้านี้จากตัวเลือกต่อไปนี้`,
"label.ccchat.person.invite.failsend":`การส่งคำเชิญต่อไปนี้ล้มเหลว กรุณาติดต่อผู้ดูแลระบบ`,
"label.import.index.obj":`ออบเจ็กต์`,
"label.multilang.leadscore.countnum":`{0} ครั้ง：`,
"label.report.error.typefind":`ไม่พบประเภทรายงานตามข้อมูลการจัดกลุ่ม`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(text, old_text, new_text)`,
"label_tabpage_unpacketz":`ไม่มีกลุ่มข้อมูลพร้อมใช้!`,
"lable.Create.new.template":`สร้างแม่แบบรายงานการบริการใหม่`,
"label.knowledgebase.display.error":`แสดง {a} ข้อผิดพลาด`,
"label.emailobject.template.message2":`ฟิลด์ที่แทรกในเนื้อหาของอีเมลปัจจุบันไม่ตรงกับบันทึกที่เกี่ยวข้องซึ่งอาจทำให้ค่าล้มเหลว`,
"label.productsales.today.taskcomplete":`ตั้งค่าให้สำเร็จ`,
"label.emailobject.selectone":`โปรดเลือกอย่างน้อยหนึ่งบันทึกเป็นผู้รับอีเมล`,
"button_partner_workspace_saveas_memo":`บันทึกพาร์ทเนอร์คลาวด์ปัจจุบันเป็น "แม่แบบ"`,
"vue_label_help_detail":`บันทึกรายละเอียด`,
"label.tabpage.minutesagoz":`นาทีที่แล้ว`,
"label_tabpage_characterz":`อักขระเริ่มต้น`,
"message.error.accesstoken.null":``,
"label.textMessageObject.send100":`ขออภัย คุณส่งข้อความสั้นได้เพียง 100 ข้อความต่อวัน โปรดเลือกอีกครั้ง!`,
"vue_label_commonobjects_detail_record_call":`บันทึกการโทรใหม่`,
"label.campaignmember.main.addlead":`เพิ่มสมาชิก-ลีด`,
"setup_mainpage_label_welcome30":`แพลตฟอร์ม CloudCC เป็นแพลตฟอร์มการประมวลผลใน clound ที่แท้จริง มีคุณลักษณะแพลตฟอร์มแบบเปิด โดยบูรณาการอย่างมีมาตรฐาน ปรับแต่งได้อย่างยืดหยุ่นสำหรับทุกแขนงอาชีพ สามารถร่วมมือกับซอฟต์แวร์ของบุคคลที่สาม เพื่อรวบรวมข้อมูลการบริหารจัดการองค์กรแบบเรียลไทม์และเป็นหนึ่งเดียว  ตอบสนองความต้องการการจัดการเชิงลึกของลูกค้าในระดับสูงสุด แพลตฟอร์ม CloudCC สามารถรวมเข้ากับแอปพลิเคชันหรือระบบขององค์กรใดก็ได้ รวมถึง SAP, Kingdee, Yonyou และซอฟท์แวร์อื่นๆ ของบุคคลที่สาม ใช้รูปแบบ Web Service มาตรฐานภายใต้รูปลักษณ์ SOA ที่ยืดหยุ่น ไม่มีผลเสียใดๆ และไม่มีการพึ่งพาเทคโนโลยีหรือการเจาะจงผู้ขาย`,
"label.file.library.deleteprompt":`ลบสมาชิกไลบรารีเอกสาร{0}?`,
"label.wtd.changefields.title":`การตั้งค่า Web to CloudCC`,
"label.sendmail.step1":`ขั้นตอนที่ 1: ระบุผู้รับ`,
"label.cpq.newquote.createorder.checkbox.selected":`ไม่สามารถเลือกใบสั่งซื้อเมื่อสร้างใบเสนอราคาใหม่`,
"label.emailtocloudcc.name":`ชื่อ`,
"message.error.object.nullbinding":`binding ว่างเปล่า`,
"B":`กล่องกาเครื่องหมาย`,
"label.pc.endtime":`เหลือเวลาไม่ถึง 30 วันใบอนุญาตของคุณจะหมดอายุ โปรดต่ออายุทันทีเพื่อไม่ให้กระทบต่อการทำงาน`,
"label.visualpage.section.start":`ป้ายกำกับตอนเริ่ม`,
"label.partnerCloud.basicSetting.available":`ชื่อโดเมนพร้อมใช้งาน`,
"label.data.exportall.all_desc":`ส่งออกข้อมูลของออบเจ็กต์ทั้งหมดที่ผู้ใช้ปัจจุบันมีสิทธิ์ดู`,
"label.editor.layout":`แก้ไขเค้าโครงการค้นหา`,
"label.send.chatter":`ส่งเวยเทีย`,
"label.h5.chatter.reply":`ตอบกลับอย่างรวดเร็ว`,
"component_chatter_post_button_file":`เพิ่มไฟล์แนบ`,
"label.emailobject.emaildetail.button.reply":`ตอบกลับ`,
"label.eidt.queue.title.desc":`ชื่อต้องไม่ซ้ำกัน และต้องขึ้นต้นด้วยตัวอักษร มีได้เฉพาะตัวอักษรตัวพิมพ์ใหญ่และตัวพิมพ์เล็ก ตัวเลข ขีดล่าง และความยาวต้องไม่เกิน 40`,
"label.campaign.channel.input.url":`5.กรุณากำหนดข้อมูลที่ผู้ใช้สามารถเห็นได้หลังการเข้าระบบ อาจจะเป็นหน้าขอบคุณ โฆษณากิจกรรม หรือบัตรเข้างาน:`,
"label.compact.layout.assign.tip":`ตารางนี้แสดงการกำหนดเค้าโครงข้อมูลคีย์สำหรับชนิดบันทึกต่างๆ`,
"vue_label_fall":`ลดลง`,
"label.trigger.save.failed":`การบันทึกล้มเหลว ข้อมูลไม่สามารถว่างเปล่า`,
"label.appupload.upload.tips.report":`หมายเหตุ: ไม่สามารถเพิ่มรายงานและรายงานเก่าลงใน "รายงานของฉัน" และ "รายงานสาธารณะที่ไม่ได้จัดเก็บถาวร" ลงในโปรแกรมสำเร็จรูปและไม่สามารถแสดงในรายการนี้ได้`,
"label.tianyancha.businessverify.rewriteall":`เขียนแก้ข้อมูลทั้งหมด`,
"label.campaign.channel.step6.remark4":`โปรดทราบว่า เจ้าของลีดคือเจ้าของแคมเปญปัจจุบันหรือผู้เชิญของช่องทางการขาย`,
"front-kefu-moudle-called-num":``,
"label.approvalstep4":`ขั้นตอนที่ 4: เลือกฟิลด์ที่จะแสดงในเค้าโครงหน้าการอนุมัติ`,
"label.login.verification.please.scan":`โปรดใช้แอป MFA บนโทรศัพท์มือถือเพื่อสแกนรหัส`,
"label.invoice.message.statusupdated":`อัปเดตสถานะ Invoice แล้ว`,
"label.pc.ui.2018.subject":`หัวข้อ`,
"label.area.notexist.userinfo":`ไม่พบกลุ่มผู้ใช้`,
"label.newuser":`ผู้ใช้ใหม่`,
"label.chat.micropost.share":`แบ่งปันโพสต์`,
"label.locatedupcurrentvalue":`ค่าที่อยู่ด้านบนของค่าปัจจุบัน`,
"vue_label_systemSettings_course":`การตั้งค่ากระบวนการ Lighting`,
"chatter.group.public":`สาธารณะ`,
"label.reportsSubscription.entrance":`สมัครสมาชิก`,
"front-kefu-moudle-v1-online-at":`แชทออนไลน์`,
"label.rejectbehaviourselect":`<strong> แค่ </strong> ปฏิเสธขั้นตอนนี้และส่งคำขออนุมัติกลับไปยังผู้อนุมัติล่าสุด (กลับไปที่ขั้นตอนที่ 1)`,
"vue_label_commonobjects_view_currentviewset":`หากต้องการยกเลิกตั้งค่าของมุมมองเริ่มต้นในปัจจุบัน สามารถตั้งค่ามุมมองอื่นเป็นมุมมองเริ่มต้นได้`,
"lable.currencyAdv.and":`และ`,
"label.appexchange.installedpage.publish":`ผู้เผยแพร่`,
"label.tab.profile.ismobile":`แอปพลิเคชันสำหรับอุปกรณ์มือถือ`,
"label.data.setok.t.desc2":`กลับไปที่หน้าแม่แบบข้อมูล`,
"label.email_required":`ต้องระบุอีเมล`,
"label.tabpage.fullscreenz":`เต็มจอ`,
"chatter.sticker.set":`ตั้งค่าการติดตามเวยเทีย`,
"label.mobile.phone.year":`ปี`,
"label.projectManagement.next.page.before":`หน้าที่แล้ว`,
"pagecreator_button_pcpage":`เว็บเพจสำหรับ PC`,
"label.dashboard.xsld.percent":`เปอร์เซ็นต์`,
"label.ccpeak.service.checkerror":`การตรวจสอบไวยากรณ์ล้มเหลว`,
"label.icon.26":`โฟลเดอร์`,
"label_partner_common_webSit_memo":`ชื่อโดเมนเริ่มต้นของพาร์ทเนอร์คลาวด์ในองค์กรของคุณคือ:`,
"label.unselectfile":`ไฟล์ที่ไม่ได้เลือก`,
"label.take.notice":`โปรดทราบ`,
"message.error.filename.null":`fileName ไม่สามารถว่างเปล่า!`,
"vue_label_SMS_nophone":`ไม่มีหมายเลขโทรศัพท์`,
"label.area.assignuser":`กำหนดผู้ใช้`,
"label.icon.176":`แจ้งเตือน`,
"label.icon.21":`สกุลเงิน`,
"message.error.system.service.deletedeny":`ข้อมูลถูกเชื่อมโยง ไม่สามารถลบได้!`,
"label.compact.layout.main.tip":`เลือกเค้าโครงข้อมูลสำคัญที่จะใช้เมื่อบันทึกของออบเจ็กต์นี้ปรากฏเป็นรายการใน CloudCC`,
"label.emailtocloudcc.delete":`ลบ`,
"label.dashboardSetup.showdw.d2":`สิบล้าน`,
"front-kefu-moudle-hqyyjlsb-admin":``,
"label.partnerCloud.basicSetting.userCounts":`จํานวนบทบาทพาร์ทเนอร์`,
"front-kefu-moudle-calling-num":``,
"label.alldocument":`เอกสารทั้งหมด`,
"coderules.nullvalue1":`การสร้างล้มเหลว ให้ป้อนค่า[{0}]ที่ใช้ในกฎการสร้าง`,
"lable.automatically.shared":`การแบ่งปันอัตโนมัติ`,
"label.batchadd.newbatchpage.save.emptyselect":`มีตัวเลือกบังคับที่ไม่ได้เลือก โปรดตรวจสอบ`,
"vue_label_homepage_card_30dayswithout":`โอกาสทางธุรกิจที่ไม่ได้ติดต่อเป็นเวลา 30 วัน`,
"label.multilang.dupicatecheck.onegroupnote":`โปรดเลือกข้อมูลอย่างน้อยสองรายการ แล้วคลิกปุ่ม [โหลดข้อมูลที่เลือก] เพื่อเข้าสู่หน้าการผสานข้อมูล ปัจจุบันเป็นข้อมูลธุรกิจกลุ่มที่ {0} มีทั้งหมด {1} รายการบันทึก`,
"UG.activity.03":`กำหนดการนัดหมาย`,
"label.pc.oldpage":`อินเทอร์เฟซรุ่นเก่า`,
"label.exchange.sync.state.task.m2":`บันทึกที่ซิงค์เมื่อ 60 นาทีที่ผ่านมา:`,
"label.setmovable":`การตั้งค่าแบบไดนามิก`,
"label.sendemail.send.loginfail":`การเข้าสู่ระบบอีเมลล้มเหลว โปรดรีเซ็ตการตั้งค่าข้อมูลอีเมล`,
"label.copy.quote.lines":`คัดลอกบรรทัดใบเสนอราคา`,
"label.copying.reward.to.groups":`คัดลอกไปยังกลุ่มบรรทัดใบเสนอราคา`,
"label.ems.connect.error":`การเชื่อมต่อเซิร์ฟเวอร์ล้มเหลว โปรดตรวจสอบ`,
"lable.account.Tomorrow":`พรุ่งนี้`,
"label.manageAll.sta2":`อนุมัติ`,
"label.create_form":``,
"label.ems.saveDetail.error.msg":`การบันทึกล้มเหลว กรุณาตรวจสอบข้อมูล เช่น บัญชีอีเมล รหัสผ่าน เป็นต้น`,
"label.service.gantt.distribution.recommendation":`งานที่แนะนำ`,
"label.email.track.attachment.size.control2":`ขนาดไฟล์ที่กำลังอัปโหลดในขณะนี้เกิน 10M ไม่สามารถอัปโหลดได้`,
"lable.product.pricebooks.add":`เพิ่มลงในสมุดราคา`,
"label.login.time":`เวลาเข้าสู่ระบบ`,
"label.tabpage.yes1z":`ใช่ 1`,
"label.SalesCommitmentKanBan":`คัมบังข้อผูกมัดการขาย`,
"label_partner_workspace_myspace":`เวิร์คสเปซของฉัน`,
"chatter.like":`ได้รับความชื่นชอบ`,
"lable.PowerProcess.number.input":`โปรดป้อนจำนวนเต็ม`,
"chatter.coll":`บุ๊กมาร์ก`,
"label.campaign.channel.img.remark":`หมายเหตุ: ขนาดรูปภาพต้องไม่เกิน 2M`,
"label.field.duplicate.error.msg7":`ข้อมูลซ้ํา`,
"vue_label_pool_discard":`ทิ้ง`,
"label.service.gantt.total.planned.duration":`แผนระยะเวลารวมของการนัดหมายการบริการ`,
"label.weixin.click.loadmore":`คลิกเพื่อโหลดเพิ่มเติม`,
"label.help.new.features.yd":`คู่มือการใช้งานอินเทอร์เฟซใหม่สำหรับอุปกรณ์มือถือ`,
"label":`ป้ายกำกับ`,
"label.quickbooks.viewlist.total1":`รวมทั้งหมด {0} invoice รวมเป็น {1}`,
"front-kefu-moudle-v1-input-publicKey":``,
"label.approval.allowed.reject":`อนุญาตให้ปฏิเสธ`,
"label.visualpage.folder.notdel":`โฟลเดอร์นี้มีไฟล์ไม่สามารถลบได้`,
"label.projectManagement.charging":`เรียกเก็บเงิน`,
"label.ccservice.validate":`ค่าที่สอดคล้องกันของฟิลด์{1} ภายใต้ออบเจ็กต์ API {0} คือ{2} รูปแบบไม่ถูกต้อง โปรดระบุหมายเลขที่ถูกต้อง!`,
"message.unbind.mfadevice.no.permission":`คุณไม่มีสิทธิเลิกผูกอุปกรณ์ MFA โปรดติดต่อผู้ดูแลระบบ`,
"label.partner.new.step3.meno":`ไม่แน่ใจว่าต้องป้อนอะไร? ไม่ต้องกังวล คุณสามารถเปลี่ยนแปลงได้ทุกเมื่อในภายหลัง`,
"label.import.page3.importsucceedtip":`เริ่มต้นการนำเข้าสำเร็จ อีเมลจะถูกส่งไปยังอีเมลที่ผูกไว้หลังจากการนำเข้าเสร็จสิ้น`,
"label.customsetting.visible.protect":`ป้องกันแล้ว`,
"label.publishreadandwrite":`เปิดแบบอ่าน/เขียน`,
"vue_label_file_add_most_once":`เพิ่มครั้งละมากสุด`,
"label.salescloud.teamrole.optionlist.group":`กำหนดบทบาทให้กับสมาชิกทีมโอกาสทางธุรกิจและสมาชิกกลุ่มลูกค้า`,
"label.appointment.wizard.subtitle7":`สถานที่`,
"label.task.dateminus":`ลบ`,
"label.data.exp.zippwd":`ใส่รหัสผ่านไฟล์บีบอัดด้วยตนเอง`,
"UG_Forcast_09":`ขั้นตอนถัดไป`,
"message.duplication.label.allselectlink":`[เลือกทั้งหมด]`,
"label.file.ccchat.selectfromcloudcc":`เลือกไฟล์จาก CloudCC`,
"label.ems.addaccount3":`เพิ่มบัญชี`,
"front-epwechat-module-v1-schedule-sync":`กำหนดการซิงค์`,
"label.h5.manage":`จัดการแอปพลิเคชัน`,
"setup.layout.label.nobutton":`ไม่มีตัวเลือกปุ่ม`,
"label_component_hotdeal":`ข้อเสนอยอดนิยม`,
"template.dashboard.contract.analysis":`การวิเคราะห์สัญญาและการจ่ายเงิน`,
"vue_label_dashboard_editcomponent":`แก้ไขส่วนเสริม`,
"label.quotationInformation":`ข้อมูลใบเสนอราคา`,
"label.data.file.validation_rules":`บังคับใช้เกณฑ์การทวนสอบ`,
"label.ccpeak.construction.shareobj":`ในการสร้างออบเจ็กต์ตารางแบ่งปันของออบเจ็กต์ ต้องส่งผ่านชื่อ API ของออบเจ็กต์และแฟล็กการแบ่งปัน:`,
"label.wei.pollinformation":`ข้อมูลพื้นฐานของเวยโพล`,
"label.quickbooks.viewlist.total3":`ชำระเงินทั้งหมด {0} รายการ รวมเป็น {1}`,
"label.paging.totalofpagesnoid":`ทั้งหมด {0} หน้า`,
"label.unlock":`ปลดล็อก`,
"front-invoice-online-payment-information":``,
"label.permission.systempermission":`กำหนดสิทธิ์ของระบบ`,
"message.error.object":`เมื่อเรียกใช้พบว่าออบเจ็กต์ไม่ได้กำหนดไว้;`,
"font-trade-module-v1-invoice-intro":``,
"label.userinfo.pwdexpired":`รหัสผ่านปัจุบันหมดอายุแล้ว เพื่อความปลอดภัย คุณจำเป็นต้องเปลี่ยนรหัสผ่านตอนนี้`,
"label.userphoto.photo":`รูปโปรไฟล์`,
"label.tabularreport.filterrecord":`เลือกเกณฑ์เพื่อยืนยันบันทึกที่จะแสดง`,
"label.partnerCloud.orderingPlatform.rechargeIt":`ยอดเงินในบัญชีของคุณไม่เพียงพอ กรุณาเติมเงิน`,
"label.icon.120":`คอมพิวเตอร์`,
"label.projectManagement.select.new.type":`เลือกประเภทใหม่`,
"vue_label_commonobjects_detail_customer_details":`กำลังโหลดรายละเอียดลูกค้า`,
"label.ems.status":`สถานะ`,
"label.validate.function.description":`ในเกณฑ์การทวนสอบสามารถใช้ฟังก์ชันใดๆ ที่สอดคล้องกับไวยากรณ์ java ได้ นิพจน์จำเป็นต้องส่งกลับค่าข้อมูลแบบบูลีน <br> คุณยังสามารถใช้ฟังก์ชันเฉพาะที่ CloudCC เสนอมาได้ ：isNew(),isChanged(ฟิลด์Apiชื่อ__c),priorValue(ฟิลด์Apiชื่อ__c),priorValue()การส่งกลับประเภทobject，จำเป็นต้องเปลี่ยนเป็นประเภทฟิลด์ที่ตรงกัน`,
"label.escalation.setup.newaction.step2":`ขั้นตอนที่ 2: เลือกผู้ใช้เพื่อกำหนดเคสอัตโนมัติ`,
"label.forecast.customforecast.searchforecast":`ค้นหาการพยากรณ์`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`ขอบเขตบนของทุกช่วงราคาต้องมากกว่าขอบเขตล่าง`,
"vue_label_commonobjects_view_notice_deletefailreason":`การลบข้อมูล id {0}ล้มเหลว เนื่องจาก{1};`,
"page.field.masterinput.remark":`การเปิดการใช้งานมาสเตอร์อินพุตจะปรับใช้กับการนำเข้าบันทึกรายการที่เกี่ยวข้องเมื่อสร้างบันทึกใหม่ที่แท็บเมนูหน้าเว็บ`,
"lable.SalesCommitmentKanBan.contractName":`ชื่อสัญญา`,
"front-gantt-module-add-milestone":``,
"label.callcenter.save.error":`กรุณาอย่าบันทึกซ้ำ`,
"label.workflow.selectobj":`ขั้นตอนที่ 1: เลือกออบเจ็กต์`,
"label.validate.function.category.all":`- ประเภทฟังก์ชันทั้งหมด -`,
"label.multilang.uploadifupage.select":`คุณได้เลือกทั้งหมด {0} ไฟล์`,
"label.weixin.dragsort":`ลากไอคอนในแอปของฉันเพื่อจัดลำดับใหม่`,
"N":`ตัวเลข`,
"label.knowledge.article.translation.completed":`การแปลบทความเสร็จสิ้น`,
"label.weixin.myapp":`แอปของฉัน`,
"label.icon.138":`สกุลเงิน`,
"vue_label_chat_create_discussion_now":`สร้างการสนทนาใหม่ทันที`,
"label.knowledge.recover.article":`กู้คืนบทความ`,
"label.ccpeak.use.class.time.map":`เข้าถึงได้ทาง Map`,
"front-email-payment-error-tips":``,
"label.service.gantt.ziyuan":`เฉพาะ`,
"label.upload.error":`ล้มเหลว`,
"label.staticresource.upload.error":`การอัปโหลดทรัพยากรแบบคงที่ผิดพลาด!`,
"com.cloudcc.login.error.message.loginfail":``,
"pagecreator_button_back":`ขั้นตอนก่อนหน้า`,
"label_tabpage_skip":`ข้าม`,
"label.pw.old":`กรุณาใส่รหัสผ่านเก่า`,
"pagecreator.layout.label.modifylayout":`ตัวแก้ไขเค้าโครง`,
"vue_label_chatter_share_group":`แบ่งปันกับกลุ่ม`,
"label.app.edit":`แก้ไขแอปพลิเคชัน`,
"label.user.Email.repeat":`ข้อผิดพลาด: อีเมลซ้ำกับอีเมล Seat ที่มีอยู่`,
"label.field.quilt":`ฟิลด์นี้ครอบคลุม`,
"label.projectManagement.Groupuser":`จัดกลุ่มตามผู้ใช้`,
"label.deleteall":`ลบทั้งหมด`,
"label.appexchange.download.tiaoguo.mes":`ข้ามการติดตั้งส่วนเสริมที่ขัดแย้งกันดังต่อไปนี้:`,
"label.sendemail.recycle.operatehello":`#username สวัสดี:\r\n`,
"label.emailmerge.mergeFolder.max20templates":`เลือกได้มากที่สุด 20 แม่แบบ!`,
"label.campaignmember.main.deleteleaddesc":`ลบลีดทั้งหมดออกจากแคมเปญในครั้งเดียว`,
"Opportunity_Detailed_Phase_Label_Popup_003":`ระยะเวลาที่คงสถานะ`,
"vue_label_file_no_title":`ไม่มีหัวข้อ`,
"label.data.dataexpalltype.all.desc":`ส่งออกข้อมูลของออบเจ็กต์ทั้งหมดที่ผู้ใช้ปัจจุบันมีสิทธิ์ดู`,
"label.dashboard.unit2":`หน่วย: ล้าน`,
"label.list.userinterface.isrelatedlist":`เปิดใช้งานโฮเวอร์รายการที่เกี่ยวข้อง`,
"label.role.tree":`โครงสร้างลำดับขั้นบทบาทในองค์กรของคุณมีดังนี้:`,
"label.campagin.roi.zcsl":`จำนวนการลงทะเบียน`,
"message.error.forecast.setupchange":`ไม่พบข้อมูลที่คุณพยายามเข้าถึงอาจเป็นเพราะผู้ใช้รายอื่นลบหรือเปลี่ยนแปลงข้อมูล`,
"label.sendemail.changeowner.dataname":`ชื่อเอกสารคือไฟล์ #dataname`,
"label.salescloud.opportunity.contactrole.optionlist":`ค่ารายการตัวเลือกบทบาทผู้ติดต่อในโอกาสทางธุรกิจ`,
"setup_mainpage_label_welcome1":`ต้องการสิทธิ์ที่เหมาะสม`,
"UG_activity_02":`มอบหมายภารกิจ`,
"label.tabpage.erraddressz":`รูปแบบที่อยู่อีเมลไม่ถูกต้อง โปรดป้อนที่อยู่อีเมลให้ถูกต้อง`,
"label.weixin.nicheng":`ชื่อเล่นวีแชท`,
"label.forecast.settings.mrsz":`ค่าพยากรณ์เริ่มต้น`,
"label.campaign.channel.download.size3":`ขนาดเล็ก: 300*300 พิกเซล`,
"label.icon.73":`เครื่องมือกล`,
"label.ServiceCloud.suoxuchanpin":`สินค้าจำเป็น`,
"label.escalation.setup.newrule.description":`ป้อนชื่อเกณฑ์จากนั้นเลือก"กล่องกาเครื่องหมายที่เปิดใช้งานเกณฑ์นี้สำหรับการเลื่อนขั้นอัตโนมัติ การเปิดใช้เกณฑ์นี้จะเป็นการปิดใช้งานเกณฑ์การเลื่อนขั้นในปัจจุบัน`,
"label.data.import.setup.whichfield.cloudccid":`CloudCCID`,
"label.validate.function.funcExplain.PRIORVALUE":`ส่งกลับประเภท object ซึ่งจำเป็นต้องแปลงเป็นประเภทฟิลด์ที่เกี่ยวข้อง`,
"Lead.Scoring.Warning.001":`สำหรับลีดหนึ่งราย ระบบสามารถให้คะแนนอัตโนมัติเมื่อสร้างและแก้ไข แต่หากเป็นการนำเข้าเป็นจำนวนมาก หรือการสร้างผ่านอินเทอร์เฟซต้องดำเนินการด้วยตนเองผ่านการให้คะแนนแบบกลุ่ม`,
"label.tianyancha.businessverify.msg9":`คำอธิบายสิทธิ์ของ "ข้อตกลง" ฉบับนี้เป็นของ Beijing CloudCC.com Technology Co.,ltd.`,
"label.compact.layout.tip":`เค้าโครงข้อมูลสำคัญใช้เพื่อแสดงฟิลด์สำคัญสำหรับบันทึกรายละเอียดในหน้ารายละเอียด`,
"label.visualpage.btype":`รายงาน`,
"label.textmessage.vonage.settings":`การตั้งค่า`,
"label.field.not.exites":`ไม่พบ!`,
"label.payment.switch.version":`กําลังเปลี่ยนรุ่น`,
"label.ems.hour":`ชั่วโมง`,
"label.weixin.cannot.edit":`ไฟล์ประเภทนี้ไม่สามารถแก้ไขได้!`,
"chatter.pt.limit":`ขนาดไฟล์สูงสุดคือ`,
"label.quote.detailinfo.add":`เพิ่มรายละเอียดใบเสนอราคา`,
"component.setup.label.displayfield":`แสดงฟิลด์`,
"vue_label_report_reportfolder":`โฟลเดอร์ที่รายงานตั้งอยู่`,
"label.gbkencoding":`อักษรจีนตัวย่อ (GBK)`,
"front-kefu-moudle-v1-Transfer-to":``,
"label.file.stop.sharing.desc2":`การแบ่งปัน`,
"label.textmessage.messageCannoutuse":`ไม่สามารถใช้งานได้ในขณะนี้ โปรดติดต่อผู้ดูแลระบบเพื่อเปิดใช้งานฟังก์ชันข้อความสั้น`,
"component_newrecords_label_type":`ประเภทการจัดเก็บ`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`สมุดราคาใหม่`,
"vue_label_newfile":`ไฟล์ใหม่`,
"label.reportTypcrtB":`ออบเจ็กต์ที่เกียวข้องกับ (B) กรุณาคลิกออบเจ็กต์ที่เกี่ยวข้อง`,
"label.knowledgebase.type":`ประเภท`,
"label.report.select.format":`เลือกรูปแบบรายงาน`,
"component.todaytask.label.title":`ภารกิจวันนี้`,
"message.undelete":`ยืนยันว่าจะยกเลิกการลบหรือไม่?`,
"label.ccdocument.trace.retention":`ฟังก์ชันติดตามการรักษาสายสัมพันธ์`,
"label.publicgroup.tip":`กลุ่มสาธารณะคือกลุ่มผู้ใช้ ซึ่งอาจรวมถึงผู้ใช้รายบุคคล กลุ่มอื่นๆ ผู้ใช้ในบทบาทหรือขอบเขตเฉพาะ`,
"label.forecast.settings.lable2":`มุมมองเริ่มต้นของบทคัดย่อการพยากรณ์`,
"label.projectManagement.positive.integer":`โปรดป้อนจำนวนเต็มบวกระหว่าง 0-24`,
"label.projectManagement.one.work.list":`กรอกรายการงานอย่างน้อยหนึ่งรายการ!`,
"label.or":`|| หรือ`,
"label.projectManagement.no.person.in.charge":`ไม่มีผู้รับผิดชอบ`,
"vue_label_commonobjects_detail_an_email":`ส่งอีเมล 1 ฉบับ`,
"front-electronic-signature-field-mapping":``,
"label.marketsea.name.error":`ชื่อฐานข้อมูลต้องไม่ว่างเปล่า`,
"component.setup.button.appurl":`URL ของระบบ`,
"label.mr.title.button.group1":`ที่`,
"chatter.contact":`รายละเอียดการติดต่อ`,
"vue_label_pool_hasfixed":`มีช่องทางการร่วมมือที่ตายตัว`,
"lable.list.queue.des":`คิวช่วยให้กลุ่มผู้ใช้จัดการปริมาณงานที่แบ่งปันได้อย่างมีประสิทธิภาพมากขึ้น คิวคือตำแหน่งที่สามารถกำหนดเส้นทางบันทึกเพื่อรอให้สมาชิกของกลุ่มผู้ใช้ดำเนินการ บันทึกจะยังคงอยู่ในคิวจนกว่าผู้ใช้ตกลงที่จะดำเนินการหรือโอนไปยังคิวอื่น คุณสามารถระบุชุดของออบเจ็กต์ที่แต่ละคิวรองรับ หรือระบุกลุ่มผู้ใช้ที่ได้รับอนุญาตให้ดึงบันทึกจากคิว`,
"label.reportsSubscriptionPage.condition":`กำหนดเงื่อนไข`,
"label.transwork":`เวิร์คแบนซ์งานแปล`,
"label.batch.batchopration.resel":`กรุณาเลือกข้อมูลที่จะถ่ายโอนอีกครั้งและคลิกปุ่ม "OK" เพื่อข้ามไปยังหน้ามุมมองรายการ`,
"label.cloudccsite.new":`เว็บไซต์ใหม่`,
"label.button.select.page.required.field":`เลือกฟิลด์บังคับในเพจนี้`,
"label.pagelayout":`เค้าโครงเพจ`,
"label.weixin.trace.record":`บันทึกการติดตาม`,
"label.emailtocloudcc.clear":`ล้าง`,
"label.checkfield.find":`ค้นหารายการซ้ำ`,
"message.view.count.title0":`รวมหน้าเพจปัจจุบัน`,
"label.reportsSubscriptionPage.schedulereport.frequency":`ความถี่`,
"setup.mainpage.label.welcome5":`ฟิลด์ที่กำหนดเอง`,
"label.implementation.details":`รายละเอียดการดำเนินการ`,
"label.attendance.history":`ประวัติบันทึกเวลาทำงาน`,
"label.is.pigeonhole":`จะจัดเก็บถาวรใช่หรือไม่`,
"lable.account.CurrentandPreviousFYt":`ปีงบประมาณนี้และสองปีแรก`,
"label.forecast.customforecast.tab.opportunity":`แท็บย่อยโอกาสทางการขาย`,
"label.version.business.track":`ติดตามโอกาสทางธุรกิจ`,
"label.profilelayoutedit.selectrecordtype.tip":`เลือกชนิดบันทึกสำหรับโปรไฟล์ผู้ใช้นี้ คุณต้องเพิ่มฟิลด์ชนิดบันทึกลงในเค้าโครงเพจที่เกี่ยวข้องกับโปรไฟล์นี้ เช่นนี้ถึงสามารถแสดงในหน้ารายละเอียดและหน้าแก้ไขได้`,
"label.campagin.roi.zclzb":`สัดส่วนการลงทะเบียน`,
"label.validate.function.funcFormat.WEEKDAY":`WEEKDAY(date)`,
"label.view.sort.message":`เรียงลําดับตาม {!sort}`,
"page.field.masterinput.sort":`มาสเตอร์อินพุตแสดงตามลำดับการบันทึก`,
"label.selected.field":`ฟิลด์การค้นหาที่เลือก`,
"label.product.proofTwo":`โปรดเลือกตัวเลือกผลิตภัณฑ์อย่างน้อย {1} รายการที่{0}`,
"vue_label_report_filtercondition":`เงื่อนไขตัวกรอง`,
"label.forecast.shrepage.desc1":`หน้านี้จะแสดงรายการ`,
"label.file.copy.link":`คัดลอกลิงก์`,
"vue_label_chat_movedto":`{name} เปลี่ยน {label} เป็น {newField}`,
"label.layout.new.built":`สร้างส่วนใหม่`,
"label_tabpage_crecordtypez":`เปลี่ยนชนิดบันทึก`,
"label.report.searchcustominfo":`ใส่คีย์เวิร์ดเพื่อค้นหารายงานกำหนดเองที่ตรงกัน`,
"chatter.feed.menutype.user":`ผู้ใช้`,
"label.recordtypeselect":`เลือกชนิดบันทึก`,
"label.partner.new.step3":`ขั้นตอนที่ 3: ใส่ชื่อและ URL`,
"label.newCustomReportType":`แหล่งข้อมูลรายงานที่กำหนดเองใหม่`,
"label.service.gantt.day.timescale":`ระยะห่างช่วงเวลาที่แสดงในมุมมองรายวัน：`,
"label.displaytype3":`ปุ่มรายการ`,
"label.weixin.discharge.rate":`การกระจัดของเครื่องยนต์`,
"label.weixin.menu.message":`ข้อความเมนู`,
"label.mask.show.all.characters":`ตัวพรางแสดงอักขระทั้งหมด`,
"label.quickbooks.fieldlabel.billingaddress":`ที่อยู่เปิดบิล`,
"Dashboard.View.All":`แดชบอร์ดทั้งหมด`,
"setup_mainpage_label_welcome22":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าการจัดการ → แม่แบบการสื่อสาร → แม่แบบอีเมล`,
"chatter.group.groupInformation":`ข้อมูลของกลุ่ม`,
"front-epwechat-module-v1-input-secret":`กรุณาใส่ Secret`,
"lable.Set.value.prompt":`หรือกรองบันทึกที่แสดงในรายการที่เกี่ยวข้อง เลือกกล่องกาเครื่องหมาย หรือฟิลด์รายการตัวเลือกและค่าที่คุณต้องการกรอง ถ้าคุณป้อนค่าด้วยตนเอง กรุณาใช้เครื่องหมายจุลภาคเพื่อแยกค่า`,
"label.appupload.upload.from":`จาก`,
"label.weixin.postunsolve":`เลยกำหนดเวลา`,
"label.cooperation.all":`ความร่วมมือทั้งหมด`,
"lable.PowerProcess.close.time":`เวลาปิดตาม {detailInterestType}`,
"lable.opppdt.selPdt.leastone.fields":`โปรดเลือกอย่างน้อยหนึ่งฟิลด์`,
"label.emailtocloudcc.help":`โปรดป้อนรหัสผ่านอีเมลหรือรหัสการให้สิทธิ์ที่ถูกต้อง หากเซิร์ฟเวอร์อีเมลของคุณต้องเปิดใช้งานบริการ IMAP / SMTP เพื่อเข้าสู่ระบบโดยลูกค้าของบุคคลที่สาม คุณต้องเข้าสู่ระบบที่อยู่อีเมลก่อนเพื่อเข้าสู่การตั้งค่าและยืนยันว่าบริการนั้นเปิดใช้งานอยู่ และทำการคัดลอกรหัสมากรอกในช่องรหัสผ่าน`,
"label.attendance.offwork.time":`เวลาออกงาน`,
"front-gantt-module-v1-project-gantt":``,
"label.chuangming.description":`กำหนดค่าข้อมูลอินเทอร์เฟซข้อความสั้นของช่วงหมิง เพื่อตอบสนองความต้องการทางธุรกิจในการส่งและรับข้อความสั้นขององค์กร`,
"label.custom.lead.notice.account.name":`สวัสดี!  มีลีดข้ามสเตจ คุณถูกกำหนดให้เป็นเจ้าของลูกค้า ผู้ติดต่อ และโอกาสทางธุรกิจ ลูกค้าชื่อ:`,
"label.emailobject.failedtosend1":`สาเหตุของการส่งล้มเหลว: การตรวจสอบอีเมลล้มเหลว โปรดเชื่อมโยงอีเมลส่วนตัวอีกครั้ง!`,
"vue_label_ccchat_notice_updaterecordsuccess":`อัปเดตบันทึกนี้แล้ว`,
"label.dayinmonth":`ของเดือน`,
"label.sendemail.chat.follow":`#nameที่เคารพ:  \n\n สวัสดี! #userNameติดตามคุณ`,
"label.emailsync.form.emialpassword":`รหัสผ่าน`,
"component_task_label_subject":`หัวข้อ`,
"label.projectManagement.please.enter.a.positive.integer":`โปรดป้อนจำนวนเต็มบวก`,
"lable.account.NexteDays":`7 วันถัดไป`,
"label.appupload.upload.managed":`สามารถสร้างแพ็กเกจที่มีการจัดการได้สูงสุดหนึ่งแพ็กเกจเท่านั้น!`,
"label.data.dataexpalltype.all.desc1":`1. รหัสผ่านสำหรับการส่งออกไฟล์บีบอัดทั้งหมดสามารถสร้างได้โดยอัตโนมัติหรือป้อนด้วยตนเอง รหัสผ่านที่สร้างขึ้นโดยอัตโนมัติจะถูกส่งไปยังอีเมลของผู้ใช้หลังจากที่ส่งออกข้อมูลสำเร็จแล้ว รหัสผ่านที่ป้อนด้วยตนเองจะไม่ถูกส่งไปยังอีเมลของผู้ใช้ ดังนั้น ผู้ใช้ต้องจำรหัสผ่านที่ป้อนด้วยตัวเอง หากไม่ป้อน จะไม่มีรหัสผ่านโดยค่าเริ่มต้น`,
"label.step1.total3":`ขั้นตอนที่ 1 จาก 3`,
"label.escalation.setup.detail.section":`รายละเอียดเกณฑ์`,
"front-gantt-module-drag-task-sorting":``,
"label.isEnableVisualpage.new.title":`เปิดใช้งานการเข้าถึงเพจที่กําหนดเอง`,
"label_tabpage_yesz":`ใช่`,
"label.emailobject.emaildetail.button.replyall":`ตอบกลับทั้งหมด`,
"label.knowledge.setting.data.one":`ไม่สามารถเพิ่มหมวดหมู่ย่อยได้อีกต่อไป`,
"label.manageAll.sel.one3":`รายการที่ฉันอนุมัติ`,
"UG_contact_01":`จะใช้ประโยชน์จากผู้ติดต่อของคุณอย่างไร?`,
"font-trade-module-v1-invoice-name":``,
"label.central.daylight.time":`เวลาออมแสงกลาง`,
"label.chatter.pastThirtyday":`30 วันที่ผ่านมา`,
"vue_label_commonobjects_detail_activity_ownevent":`อิเวนต์ที่มีอยู่`,
"label.user.modify":`แก้ไขผู้ใช้`,
"label.uploadTemplate":`อัปโหลดแม่แบบ`,
"setup_mainpage_label_welcome14":`การปรับแต่งเวิร์กโฟลว์ และการจัดการกระบวนการอนุมัติ`,
"label.workmate":`เพื่อนร่วมงาน`,
"label.displaycolumns":`คอลัมน์ที่แสดง`,
"label.emailnoticeintro":`การแจ้งเตือนทางอีเมล คืออีเมลที่ส่งเมื่อกฎเวิร์กโฟลว์เกิดทริกเกอร์`,
"label.knowledge.category.button.five":`ลบหมวดหมู่`,
"template.report.business.opportunities.type":`โอกาสทางธุรกิจตามประเภท`,
"vue_labenl_applauncher_moreapp":`แอปพลิเคชันอื่นๆ`,
"label.captcha.expired":`รหัสยืนยันหมดอายุแล้ว โปรดรับอีกครั้ง`,
"template.chart.bnqzkhslmb":`จำนวนลีดเป้าหมายในปีนี้`,
"chatter.up.user.pic":`อัปโหลดรูปโปรไฟล์`,
"label.timezone.importtimezone.gmt":`ใช้เวลามาตรฐานกรีนิช`,
"label.step.type":`เลือกประเภทสมาชิกที่จะค้นหา`,
"Dashboard.View.RecentlyView":`มุมมองล่าสุด`,
"label.reportinthisfolder":`รายงานในโฟลเดอร์นี้`,
"label.product.vies":`มุมมองผลิตภัณฑ์`,
"pagecreator_systemstyle_message_delete_fail":`การลบรูปแบบล้มเหลว`,
"label.multipleactivity.singleUser":`ผู้ใช้คนเดียว`,
"vue_label_email_enter_subject":`ใส่หัวข้อ`,
"label_tabpage_alltabs":`แท็บทั้งหมด`,
"label.publicgroup.groupname":`ชื่อกลุ่ม`,
"template.report.sales.performance":`ประสิทธิภาพพนักงานขาย`,
"label.newWindow":`หน้าต่างใหม่`,
"label.forecast.editopp.forecastedit":`การแก้ไขการพยากรณ์`,
"label.data.import.setup.whichfield":`คุณต้องการใช้ฟิลด์ใดในโซลูชันสำหรับการจับคู่？`,
"label.noadd_dashboard":`อย่าเพิ่มลงในแดชบอร์ด`,
"label.subtotal":`ผลรวมย่อย`,
"front-email-payment-weichat":``,
"label.attendance.position.alert":`โปรดเลือกป้ายกำกับก่อน`,
"chatter.follow.me":`ติดตามฉัน`,
"label.mobile.more.details":`แก้ไขรายละเอียดไฟล์`,
"Dashboard_SelectBoardToDisplay":`โปรดเลือกแดชบอร์ดที่แสดงในแท็บเพื่อเปิดแดชบอร์ด`,
"front-gantt-module-v1-search-project":``,
"label.paging.totalofpagereport":`ทั้งหมด {0} หน้า ({1} แถว)`,
"label.from.phone":`หมายเลขโทรศัพท์มือถือของผู้ส่ง`,
"lable.Signatory":`ผู้ลงนาม:`,
"label.campagin.roi.query.roi2":`ROI ช่องทางการขายของแคมเปญ`,
"label.tabpage.selectcontentz":`กรุณาเลือกเนื้อหา`,
"label.multilang.lookfiltercondition.valuetypenotmate":`เงื่อนไขของแถวที่ {0} ไม่ถูกต้อง  ประเภทค่าไม่ตรงกัน!`,
"label.interfaceconstraint.disabled":`อินเทอร์เฟซนี้ถูกปิดใช้งาน กรุณาติดต่อผู้ดูแลระบบ`,
"third":`ลำดับที่สาม`,
"label.quickbooks.viewlist.status":`สถานะ`,
"label.emailtocloudcc.select3":`กรุณาเลือกเจ้าของบันทึก`,
"label.projectManagement.week.work":`งานของฉันในสัปดาห์นี้`,
"vue_label_pool_nodemand":`ไม่มีความประสงค์`,
"label.version.two.developapi":`API โปรแกรมพัฒนาเฉพาะความต้องการ`,
"label.icon.82":`เครื่องพิมพ์`,
"label.batchadd.newbatchpage.suclist":`ข้อมูลเพิ่มเรียบร้อยแล้ว`,
"label.checkfield.chooseatlast":`กรุณาเลือกอย่างน้อย 2 ตัวเลือก`,
"label.quotation.deleteTip":`โปรดเลือกบรรทัดใบเสนอราคาที่ต้องการลบ`,
"label.generatepage.title.desc2":`หลังจากคลิกปุ่มบันทึก จะเกิดหน้าเพจ web และลิงก์ web URL ที่สามารถเข้าถึงได้`,
"label.licence.total":`จำนวนใบอนุญาตทั้งหมด`,
"Y":`ค้นหาความสัมพันธ์`,
"label.wuzibiekesitan.time":`เวลาอุซเบกิสถาน`,
"label.component.hotdeal.nodata":`ไม่มีข้อมูลที่เกี่ยวข้องกับโอกาสทางธุรกิจ`,
"label.data.exp.save":`บันทึกแม่แบบ`,
"label.appupload.upload.tips.dashboard":`หมายเหตุ: ไม่สามารถเพิ่มแดชบอร์ดที่อยู่ใน "แดชบอร์ดส่วนตัวของฉัน" และ "แดชบอร์ดสาธารณะที่ไม่ได้จัดเก็บถาวร" ลงในแพ็กเกจหรือแสดงในรายการนี้ได้ รายงานเก่าที่เกี่ยวข้องจะไม่ถูกอัปโหลด`,
"lable.PowerProcess.new.PowerProcess":`กระบวนการให้สิทธิ์ใหม่`,
"label.loginhis.search.download":`เนื่องด้วยประวัติการเข้าระบบมีมาก เมื่อค้นหาและดาวน์โหลดจึงอนุญาตให้ดาวน์โหลดเฉพาะบันทึกประวัติในช่วง 2 เดือน`,
"label.tabpage.deleteview":`ลบมุมมอง`,
"label.chatter.recently":`เมื่อเร็วๆ นี้`,
"label.industrialandcommercialverification.title":`การทวนสอบธุรกิจ`,
"message.nextapproverlost":`ผู้อนุมัติรายถัดไปที่กำหนดว่างเปล่า`,
"front-kefu-moudle-v1-mfsysy-time":`จำนวนวันทดลองใช้ฟรีที่เหลือ`,
"label.role.assign.tip":`เลือกผู้ใช้ที่จะแสดงในรายการ <b>ตัวเลือกผู้ใช้</b> เพื่อกำหนดบทบาทให้`,
"label.addattachment.step2.intruduce":`ทำซ้ำขั้นตอนที่ 1 และ 2 เพื่อเพิ่มหลายไฟล์`,
"vue_label_pool_returnreasondiscription":`ส่งคืนคำอธิบายเหตุผล`,
"label.weixin.report.range":`ระยะเวลา`,
"label.wei.weiresearchtab":`ตัวเลือกเวยโพล`,
"vue_label_report_setdrill":`ตั้งค่าการเจาะรายละเอียด`,
"page_404_button_back":`ย้อนกลับไปขั้นตอนก่อนหน้า`,
"label.customfields.autonumber.tip":`ระบบใช้หมายเลขซีเรียลที่สร้างโดยรูปแบบการแสดงผลที่คุณกำหนด หมายเลขจะเพิ่มขึ้นโดยอัตโนมัติในทุกบันทึกใหม่`,
"label.ccpeak.return.allrecords":`ส่งคืนบันทึกทั้งหมด`,
"label.ccchat.notmember.active.group2":`คุณไม่มีชื่อประกอบด้วย`,
"label.uniquename":`ชื่อเฉพาะ`,
"label.emailtocloudcc.filed.ssl":`การเชื่อมต่อที่ปลอดภัย`,
"chatter.emailFollowMe":`เมื่อติดตามฉัน`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`บริษัทเป็นเจ้าของลิขสิทธิ์ สงวนลิขสิทธิ์ สายด่วนบริการลูกค้า`,
"label.projectManagement.actualworkinghours":`ระยะเวลาการทํางานจริง`,
"label.quickbooks.fieldlabel.taxresale":`ภาษีซื้อมาขายไป`,
"label.icon.12":`ซ่อมบำรุง`,
"label.data.exp.dataexptemp":`แม่แบบการส่งออกข้อมูล`,
"component_setup_tabs_label_add":`เพิ่มใหม่`,
"label.appointmentdetail.wizard.title10":``,
"label.multilingual.close":`ไม่ได้เปิดใช้งานการจัดการหลายภาษา`,
"message.error.username.notexist":`ไม่พบชื่อผู้ใช้ กรุณาใส่ใหม่อีกครั้ง!`,
"label.batchadd.newbatchpage.des2":`หากฟิลด์ตัวเลขอัตโนมัติไม่จำเป็นต้องป้อนข้อมูล ระบบจะสร้างตัวเลขให้โดยอัตโนมัติเมื่อทำการบันทึก`,
"vue_label_SMS_search":`ค้นหาลีดหรือผู้ติดต่อ`,
"label.appupload.successWithUrl":`ตอนนี้คุณสามารถใช้ URL การติดตั้งต่อไปนี้เพื่อติดตั้งโปรแกรมสำเร็จรูป`,
"UG_Forcast_06":`โปรดเลือกผู้ใช้ที่มีสิทธิ์ในการพยากรณ์`,
"vue_label_dashboard_secondarygroup":`กรุณาเลือกกลุ่มลำดับสอง`,
"label.weixin..xsld.total":`มูลค่ารวมของกรวยการขาย`,
"label.setup.mobile.bottombutton.recovery.default.fail":`การคืนค่าเริ่มต้นล้มเหลว`,
"label.addrecurrencetimetrigger":`เพิ่มทริกเกอร์วงจร`,
"label.emailsync.connectaccount":`เชื่อมต่อบัญชีอีเมล`,
"label_fiscal_years":`ปีงบประมาณ`,
"label.icon.164":`รถบัส`,
"label.batchadd.mustinput":`ใส่`,
"message.newtabpage.nokeywords":`กรุณาใส่คีย์เวิร์ดที่มีความยาวอักขระอย่างน้อยหนึ่งตัวหรือใช้เงื่อนไขการค้นหาขั้นสูง!`,
"label.login.verification.mfa.desc3":`หากบัญชีของคุณถูกใช้โดยผู้ใช้หลายคน หลังจากที่คุณผูก MFA สำเร็จแล้ว ผู้ที่ไม่ได้ผูก MFA จะไม่สามารถเข้าสู่ระบบ วิธีแก้ไขคือขอให้ผู้อื่นติดตั้งแอปพลิเคชัน MFA และสแกนรหัสคิวอาร์ในหน้านี้ หรือบันทึกรูปภาพรหัสคิวอาร์เพื่อให้ผู้อื่นสแกนรหัสในภายหลัง อย่างไรก็ตาม ตามแนวทางปฏิบัติที่ดีที่สุดด้านความปลอดภัย เราขอแนะนำให้คุณเลิกใช้บัญชีร่วมกันหลายคน`,
"label.partnerCloud.basicSetting.initialize":`หลังจากเริ่มต้น คุณไม่สามารถแก้ไขชื่อโดเมนคลาวด์พาร์ทเนอร์ได้`,
"label.address.county":`เขต/อำเภอ`,
"label.validate.function.funcFormat.TODAY":`TODAY()`,
"label.sso.addAKey":`เพิ่มรหัสลับ`,
"label.myusergroup":`กลุ่มผู้ใช้ของฉัน`,
"label.import.index.time-consuming":`ใช้เวลานาน`,
"label_tabpage_systems":`มีทั้งหมด * ระบบ`,
"batch.sendemail.s":`การส่งอีเมลสำเร็จ`,
"label.appointment.wizard.subtitle4-1-1":`15 นาที`,
"label.projectManagement.delete.milestone":`การลบไมล์สโตนจะลบข้อมูลทั้งหมดที่เกี่ยวข้องกับไมล์สโตนและไมล์สโตน และข้อมูลจะไม่สามารถกู้คืนได้ คุณแน่ใจหรือไม่ว่าต้องการลบมัน`,
"label.umeng.chatter.praise":`ถูกใจยฺหวินเทียของคุณ`,
"font-evaluate-module-v1-evdetails":``,
"label.group.filter.resources.and":`เลือกวิธีการกรองทรัพยากรและความสัมพันธ์`,
"label_emailtocloudcc_description":`เพิ่มอีเมลธุรกิจของคุณ เช่น sales@company.com, info@company.com, และsupport@company.com ที่นี่ ระบบจะสร้างลีดหรือเคสตามอีเมลที่ได้รับโดยอัตโนมัติ เพื่อให้แน่ใจว่าจะติดตามอีเมลขาเข้าจากลูกค้าได้อย่างทันท่วงที`,
"label.chat.topic.delete.prompt2":`โปรดทราบว่าหัวข้อที่มีชื่อเดียวกันในที่อื่นจะไม่ถูกลบ`,
"message.error.group.authorization":`คุณไม่มีสิทธิ์ตั้งค่ากลุ่มนี้`,
"label.attendance.wz":`สถานที่`,
"vue_label_activity_notice_logacal_success":`คุณบันทึกการโทรแล้ว`,
"label.emailtocloudcc.step1.case1":`Email to Case`,
"label.h5.chatter.praisenum":`ได้รับการถูกใจ`,
"label_time_statistics_basis":`เกณฑ์สถิติเวลา`,
"label.onlyadmincanedit":`<strong>เฉพาะ</strong>ผู้ดูแลระบบเท่านั้นที่สามารถแก้ไขบันทึกระหว่างกระบวนการอนุมัติ`,
"label.fieldtoolongmassage":`ฟิลด์`,
"label.sales.team.shared":`แบ่งปันทีมโอกาสทางธุรกิจ`,
"label_emailsync_status_department":`หน่วยงาน`,
"label.mobile.quickcreate.default.sellingfunnel":`กรวยการขาย`,
"label.tabpage.closez":`ปิด`,
"homepage.components.two":`ขั้นตอนที่ 2: เลือกตําแหน่งที่แสดงส่วนเสริมที่กําหนดเอง`,
"label.everyday":`ทุกวัน`,
"lable.Product.to.asset.BOM":`ผลิตภัณฑ์ถูกโอนเป็น BOM สินทรัพย์`,
"label.appointment.wizard.subtitle4-3":`ผู้รับเชิญสามารถเลือกช่วงเวลาเริ่มต้นการประชุม`,
"label.customobjects.standardfieldslist":`รายการฟิลด์มาตรฐาน`,
"label.customfields.suretodelete":`ใช่ ฉันต้องการลบฟิลด์ที่กำหนดเองนี้`,
"component.chatter.label.to":`ถึง`,
"label.emailsync.form.seversetting":`ตั้งค่า`,
"label.service.gantt.enabled.resources":`ทรัพยากรที่เปิดใช้งาน`,
"label.tianyancha.h5.weibo":`เวยป๋อ`,
"template.chart.dddje":`จำนวนเงินที่ปิดการขายไม่สำเร็จ`,
"label.pc.trigger.apiname":`มี API Name นี้อยู่แล้ว กรุณาลองใหม่อีกครั้ง`,
"label.icon.34":`ติดตั้ง`,
"label.schedulejob.setup.schedule.prgname":`ชื่อโปรแกรม`,
"label.weixin.free.registration":`ลงทะเบียนฟรี`,
"label.placeholder":`กรุณาใส่คีย์เวิร์ดที่จะค้นหา`,
"label.emailobject.manage.template":`จัดการแม่แบบอีเมล`,
"label.knowledge.article.existsdata":`มีข้อมูลอื่นที่ไม่ตรงตามข้อกำหนด`,
"label.campaign.channel.lookup.ticket":`ค้นหาบัตรเข้างาน`,
"label.searchlayout.relation.searchfield":`ค้นหาฟิลด์ตัวกรองสำหรับการค้นหารายการที่สัมพันธ์กัน`,
"label.recordid.cannot.empty":`ID บันทึกไม่สามารถว่างเปล่า`,
"label_partner_workspace_member_choice":`เลือกโปรไฟล์`,
"vue_label_campaign_amount":`รายได้`,
"label.niue.time":`เวลาเกาะนีอูเอ`,
"front-homepageobject-module-v1-workload-ranking":``,
"message.error.datainvalid":`ข้อผิดพลาด: ข้อมูลไม่ถูกต้อง`,
"vue_label_helpcenter_salesfunnel":`ใช้กรวยการขายรุ่นใหม่วิเคราะห์และติดตามสถานการณ์ของโอกาสทางธุรกิจ  เพื่อการวิเคราะห์ข้อมูลกระบวนการขายของคุณ <br>ที่มุมบนซ้ายจะบันทึกเงื่อนไขตัวกรอง เช่น บทบาท หรือเจ้าของ เป็นต้น เพื่อค้นหาโอกาสทางธุรกิจทั้งหมดที่สอดคล้องกับเงื่อนไข และวิเคราะ์ข้อมูล คลิกที่สเตจของกรวยการขาย เพื่อดูบันทึกทั้งหมดในสเตจนั้น`,
"vue_label_transferownernotice":`เจ้าของบันทึกที่เกี่ยวข้องกับรายการนี้ก็จะถูกเปลี่ยนเช่นกัน`,
"label.monitorsys.operator":`ผู้ดำเนินการ`,
"label.please.codeNorm":`โปรดเลือกมาตรฐานรหัส`,
"label.campaign.channel.step6.remark2":`เปิดใช้งานฟังก์ชันเชิญพนักงาน`,
"market.potential.customers":`ลีดในตลาด`,
"label.customfields.phone.tip":`อนุญาตให้ผู้ใช้ใส่หมายเลขโทรศัพท์ใด ๆ โดยจะเปลี่ยนเป็นรูปแบบหมายเลขโทรศัพท์อัตโนมัติ`,
"label.currency.edit":`การแก้ไขสกุลเงิน: เปลี่ยนสกุลเงินของบริษัท`,
"label.emailobject.emaildetail.button.markasunread":`ติดป้ายว่ายังไม่ได้อ่าน`,
"label_partner_template_memo":`บันทึกข้อความ`,
"label.chat.message.search.all":`ค้นหาเนื้อหาทั้งหมด`,
"label_tabpage_hoursagoz":`ชั่วโมงก่อน`,
"label.customcomponent.developer.help":`ช่วยเหลือนักพัฒนาส่วนเสริมที่กำหนดเอง`,
"setup_mainpage_label_welcome":`ยินดีต้อนรับสู่แพลตฟอร์ม CloudCC PaaS ฟังก์ชันหลักของแพลตฟอร์มมีดังนี้`,
"label.h5.similar.opportunity.list":`ผลลัพธ์รวมถึงโอกาสทางธุรกิจที่ปิดการขายสำเร็จที่เหมือนกับโอกาสทางธุรกิจของคุณตั้งแต่หนึ่งฟิลด์ขึ้นไป การบุ๊กมาร์กโอกาสทางธุรกิจจะเป็นการเพิ่มโอกาสทางธุรกิจเหล่านี้ไปยังรายการโอกาสทางธุรกิจที่คล้ายกันในหน้ารายละเอียดโอกาสทางธุรกิจของคุณ`,
"vue_label_record_count":`จำนวนบันทึก`,
"label.icon.29":`การสาธิต`,
"pagecreator.page.label.pagelayout":`เค้าโครงเพจ`,
"label.ggReleaseRange.searchRole":`ค้นหาบทบาท`,
"label.campagin.member.field.setup":`การตั้งค่าฟิลด์สมาชิกแคมเปญ`,
"augest":`เดือนสิงหาคม`,
"label.salescloud.massloss.content":`ปิดการใช้งานการขายแบบทีมจะลบทีมโอกาสทางธุรกิจเริ่มต้นของผู้ใช้และทีมที่มีอยู่ทั้งหมดที่อยู่เหนือโอกาสทางธุรกิจ และไม่สามารถกู้คืนได้`,
"label.customfields.new.step2.opration.unique.info":`ไม่อนุญาตให้มีค่าซ้ำ`,
"vue_label_email_optional_members":`ตัวเลือกสมาชิก`,
"label.emailobject.attachment.download":`ดาวน์โหลด`,
"label.recordamount":`จำนวนบันทึก`,
"front-kefu-moudle-call-recorder":``,
"label.more.info":`รายละเอียด`,
"vue_label_commonobjects_view_secondsbefore":`{seconds} วินาทีก่อน`,
"label.emailsync.status.action":`ดำเนินการ`,
"label.customfields.totalsummary.collectedfields":`ออบเจ็กต์สรุป`,
"label.knowledge.setting.hint.two":`หมายเหตุ: คุณไม่สามารถปิดใช้งานได้หลังจากที่คุณเปิดใช้งาน Knowledge`,
"label.login.access.yujidao":`คาดการณ์`,
"label.assignment.setup.detail.description":`สร้างรายการเกณฑ์เพื่อมอบหมายบันทึกให้กับผู้ใช้โดยอัตโนมัติตามเงื่อนไขที่ระบุไว้`,
"message.error.marketsea.null":`ไม่มีฐานข้อมูลนี้`,
"lable.account.Current.CY":`ปีปฏิทินนี้`,
"vue_label_salesadvance_lost":`สูญเสีย`,
"label.file.ownedbyme":`ฉันเป็นเจ้าของ`,
"label.component.helper.nodata":`ไม่มีเรื่องที่ต้องระวังในขณะนี้ กรุณาตรวจสอบภายหลัง`,
"label.weixin.appr.pending.auditor":`รอผู้อนุมัติ`,
"UG_opportunity_004":`หลากหลายประเภทธุรกิจ`,
"label.leadscore.setup":`ตั้งค่าการให้คะแนนลีด`,
"label.addtimetrigger":`เพิ่มทริกเกอร์เวลา`,
"label.mr.title.match":`จับคู่เหมือนหรือไม่`,
"label.projectManagement.Newmilestone":`ไมล์สโตนใหม่`,
"label.preview":`แสดงตัวอย่าง`,
"label.tabpage.issuez":`ปัญหา`,
"label.img.max.size":`รูปภาพที่อัปโหลดมีขนาดใหญ่เกินไปและขนาดรูปภาพสูงสุดไม่ควรเกิน 500K โปรดอัปโหลดอีกครั้ง`,
"label.mainpageset":`การปรับแต่งส่วนเสริมหน้าแรก`,
"label.user.login.false.lock":``,
"UG_solution_02":`โซลูชันคือโซลูชันภายในสำหรับแก้ไขปัญหาที่ลูกค้าพบ`,
"vue_label_approve_put_away":``,
"label.profile.existing":`โปรไฟล์ที่มีอยู่`,
"label.ems.logininfo":`ข้อมูลการเข้าสู่ระบบ`,
"label.weixin.location.service":`ออบเจ็กต์ที่รองรับบริการหาตำแหน่งที่ตั้ง`,
"label.multilang.datamoveaction.totaldata":`มีทั้งหมด {0} รายการบันทึกที่สอดคล้องกับเงื่อนไข สามารถโอนย้ายได้สูงสุด 100 รายการต่อครั้ง!`,
"label.ccdocument.cannot.update.set":`เอกสารไม่ใช่ไฟล์ประเภท Word, Excel, PPT ไม่สามารถอัปโหลดไปยังโฟลเดอร์แม่แบบตัวหนังสือสีแดงได้!`,
"vue_label_fliter_addfliter":`เพิ่มตัวกรอง`,
"label.custom.page.or.trigger":`(เพจที่กำหนดเองหรือทริกเกอร์)`,
"label.tag.filter1":`ตรงกับป้ายกำกับที่เลือกในเวลาเดียวกัน`,
"UG.homepage.006":`ทำความเข้าใจกิจกรรมของลูกค้าแบบ 360 องศา ผ่านแบบสอบถาม แชทสด อีเมล ใบงาน ไปจนถึงโพสต์โซเชียลมีเดีย และแคมเปญ (เช่น ลีด การสนับสนุนบริการ และกิจกรรมต่างๆ)`,
"SCORE":`คะแนน`,
"label.file.library.managemembers2":`จัดการไลบรารีเอกสารสมาชิก`,
"label.email.template.public.SMS":`โฟลเดอร์แม่แบบข้อความสั้นสาธารณะ`,
"label.leadscore.donot":`ไม่สามารถให้คะแนนลีดได้`,
"label.gaode.map":``,
"pagecreator_button_preview":`แสดงตัวอย่าง`,
"UG_contact_04":`หรือ`,
"label.ccchat.person.invite.eminfo":`{0}เชิญคุณเข้าร่วมกลุ่ม{1}ใน CloudCC CCChat แล้ว - พื้นที่การทำงานร่วมกันเฉพาะของบริษัทของคุณ! ใช้ CCChat เพื่อสนทนากับเพื่อนร่วมงานของคุณ สร้างกลุ่มสำหรับโครงการของคุณ และแบ่งปันไฟล์`,
"setup_object_field_dependency_label_actionfieldvalue":`ค่าฟิลด์ควบคุม`,
"lable.Product.options":`ตัวเลือกผลิตภัณฑ์`,
"front-electronic-signature-add-autofill-field":``,
"label.customfields.totalsummary.selectcollectedfields":`เลือกออบเจ็กต์ที่ต้องการจะสรุป`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`ยอดเงินสัญญาป้อนได้สูงสุด 10 หลัก`,
"label.forecast.shrepage.pagetitle":`ผู้ใช้ บทบาท และภูมิภาคร่วม`,
"label.login.access.mark":`ต้องการความช่วยเหลือเพื่อแก้ไขปัญหาการรองรับ คุณสามารถให้ผู้ดูแลระบบของคุณเข้าสู่ระบบและเข้าถึงข้อมูลในสิทธิ์ของคุณได้`,
"lable.outlook.edit.zdyout":`แม็ปฟิลด์ Exchange ที่กำหนดเอง`,
"label.approveoperate":`อนุมัติดำเนินการ`,
"label.tabpage.linknamez":`ชื่อลิงก์`,
"label.report.error.deletehavedashboard":`รายงานนี้ได้สร้างแดชบอร์ดใหม่ ไม่สามารถลบได้`,
"label.summaryreport.2018.step1":`ขั้นตอนที่ 1: เลือกวิธีการจัดกลุ่มสำหรับข้อมูลสรุป`,
"label.campaignmember.main.leadtomember.title":`การปรับค่าการแม็ปฟิลด์`,
"label.select.dashboar.type":`โปรดเลือกประเภทแดชบอร์ด!`,
"message.setup.field.picklist.valueexists":`มีค่ารายการตัวเลือกนี้อยู่แล้ว`,
"label.loading":`กำลังโหลดข้อมูล...`,
"label.payments.paytip1":`ระบบของคุณไม่ใช่รุ่นทดลองใช้ โปรดคลิก "ยืนยัน" เพื่อรีเฟรชหรือลงชื่อเข้าใช้อีกครั้ง`,
"label.view.appliedMobile":`ปรับใช้สำหรับบนอุปกรณ์มือถือหรือไม่`,
"label.multilang.forcast.financialyear":`ปีงบประมาณที่ {0}`,
"front-web-module-v1-detail-comment-opinion":``,
"UG_Forcast_10":`เสร็จสิ้น`,
"label.optionlistset":`ชุดรายการตัวเลือก`,
"label.visualpage_list.vpname":`ชื่อเพจที่กำหนดเอง`,
"vue_label_calendar_failed_to_delete_calendar":`การลบปฏิทินล้มเหลว`,
"label.json.string.null":`ว่าง`,
"message.serviceappo.time.violation2":`การละเมิดเวลาที่อนุญาตสําหรับการนัดหมายบริการ: เวลาสิ้นสุดการนัดหมายการบริการที่วางแผนมากกว่าวันหมดอายุของการนัดหมายการบริการ`,
"label.productsales.today.noevttsk":`วันนี้ไม่มีอิเวนต์ที่ยังไม่ได้ดำเนินการ หรือภารกิจที่ครบกำหนด`,
"label_tabpage_emptyz":`ล้าง`,
"front-kefu-moudle-no-create":``,
"label.wedge.shaped.tail.arrow.cannot.empty":`ลูกศรหางลิ่มไม่สามารถว่างเปล่า!`,
"label.continue.shopping":`สั่งซื้อสินค้าต่อ`,
"label.turntomain":`ข้ามไปที่เนื้อหาหลัก`,
"component.assistant.label.nodata":`ไม่มีรายการสำหรับวันนี้ โปรดตรวจสอบในภายหลัง`,
"label.payments.paytip4":`กรุณาใส่จำนวนที่ถูกต้อง!`,
"label.appupload.upload.versionName":`ชื่อรุ่น`,
"label.chatter.endData":`วันที่สิ้นสุด`,
"front-kefu-moudle-buytr-tip":``,
"label.repw":`รหัสผ่านซ้ำ`,
"label.tabularreport.intro":`รายงานแบบตารางเป็นวิธีที่ง่ายและเร็วที่สุดในการแสดงข้อมูล`,
"label.selectoperatetype":`เลือกประเภทการดำเนินการ`,
"setup.layout.label.required":`จำเป็นต้องระบุ`,
"label.default.designee":`ผู้รับมอบหมายเริ่มต้น`,
"label.ccdocument.cannotdel.folder":`โฟลเดอร์นี้มีไฟล์อยู่ ไม่สามารถลบโฟลเดอร์นี้ได้`,
"label.escalation.setup.newentries.inputentries":`ใส่รายการเกณฑ์`,
"label.emailobject.addnewtemplate":`สร้างแม่แบบใหม่`,
"label_chatter_content":`เนื้อหา`,
"label.htyj.mubiao":`เป้าหมาย`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`วันศุกร์`,
"label_tabpage_fieldoptions":`ฟิลด์ชนิดบันทึก ฟิลด์รายการตัวเลือกและฟิลด์รายการตัวเลือก (หลายตัวเลือก) ขอแนะนำให้ป้อนคีย์เวิร์ดไม่เกิน 10 คำโดยคั่นด้วยเครื่องหมายจุลภาคหรือความสัมพันธ์ เช่น "ปักกิ่ง,เซี่ยงไฮ้,กว่างโจว"`,
"label.mobiletablayoutedit.remark2":`เลือกฟิลด์ที่ต้องการจะแสดงบนเมนูโทรศัพท์มือถือ`,
"label.sendemail.chat.addComentsat":`#nameที่เคารพ:\n\n สวัสดี!  คุณถูกกล่าวถึงในความคิดเห็นที่โพสต์โดย #userName`,
"Z":`สูตร`,
"label.multilang.batchdeleteaction.movesuccess":`มีทั้งหมด {0} รายการบันทึกที่ลบสำเร็จ!`,
"label.textmessage.vonage.message2":`การตั้งค่าบัญชี API  Nexmo ช่วยให้ผู้ใช้สามารถเข้าถึงบัญชี API Vonage บนแพลตฟอร์ม CloudCC เพื่อส่งและรับข้อความได้`,
"label.file.use.document":`การใช้พื้นที่จัดเก็บ`,
"UG.Lead.011":`สร้างลีด`,
"label.view.name":`ชื่อมุมมอง`,
"label.data.downtemplate":`ดาวน์โหลดแม่แบบ`,
"vue_label_appstore_get_now":`รับทันที`,
"label.controlfield":`ฟิลด์ควบคุม`,
"label.dataimport.type.insert":`แทรก`,
"label.customfields.multiselect.tip":`อนุญาตให้ผู้ใช้เลือกได้หลายค่าจากรายการที่กำหนด`,
"label.weixin.approval.qxzjl":`โปรดเลือกบันทึก`,
"component.salesperformance.label.70finish":`เสร็จสิ้น - ยังไม่ได้จัดการ (> 70%)`,
"Lead_Auto_Scoring_Setting":`การตั้งค่าการให้คะแนนลีดแบบอัตโนมัติ`,
"pagecreator_layout_message_canntdelete":`ไม่อนุญาตให้ลบเค้าโครงปัจจุบัน`,
"vue_label_report_exprotpage":`จำนวนหน้าที่ส่งออก：หน้าที่ {page}`,
"label.campaign.channel.step4":`ขั้นตอนที่ 4 : ตั้งค่าฟิลด์บังคับของหน้าลงทะเบียนช่องทางการขาย`,
"label.app.launcher":`ตัวเรียกใช้งานแอปพลิเคชัน`,
"vue_label_campaign_selectedmember":`เลือกสมาชิกแคมเปญแล้ว {member} ราย`,
"label.mobile.quickcreate.default.approvals":`รอการอนุมัติ`,
"label.view.step4":`ขั้นตอนที่ 4. จำกัดการมองเห็น`,
"label.exchange.sync.state.user":`สถานะการซิงค์ผู้ใช้`,
"label.forecast.customforecast.tab.forecast":`แท็บย่อยการพยากรณ์`,
"label.theUserLoginForTheFirstTime":`ผู้ใช้เข้าสู่ระบบครั้งแรก`,
"label.workflowoperate.tip":`กำหนดการทำงานเวิร์กโฟลว์ที่จะทริกเกอร์เมื่อสอดคล้องกับเงื่อนไขของกฎ`,
"font-evaluate-module-v1-ten-points":``,
"label.knowledge.delete":`เกิดข้อผิดพลาดในการลบความรู้`,
"front-console-see-contacts":``,
"label.h5.similar.opportunity.add.to.favorites":`เพิ่มในบุ๊กมาร์ก`,
"front-epwechat-module-v1-install-app":`ติดตั้งแอปในวีแชทขององค์กร`,
"setup_layout_message_relatedlistbutton":`เลือกปุ่มมาตรฐานที่แสดงในรายการที่เกี่ยวข้อง`,
"label.salescloud.massloss.title":`อาจจะทำให้ข้อมูลจำนวนมากสูญหาย`,
"front-console-conversation-btn1":``,
"label.custom.canvasScale":`อัตราส่วนแคนวาส`,
"label.lead.score.doing":`กำลังให้คะแนนลีด`,
"message.approval.step.validation.invalid.number":`ใส่ตัวเลขที่ถูกต้อง`,
"chatter.lk":`ชื่นชอบ`,
"label.dashboardSetup.showmaxval":`แสดงค่าสูงสุด`,
"label.keywords":`คีย์เวิร์ด`,
"vue_label_helpcenter_SMS":`เปิดใช้งานฟังก์ชันข้อความสั้น<br> หากcountrycodeของระบบ CRM ที่คุณซื้อคือUSA แสดงว่ามีฟังก์ชันข้อความสั้นอยู่ในระบบขององค์กรของคุณ ผู้ดูแลระบบขององค์กรสามารถป้อนหมายเลขโทรศัพท์ที่ซื้อโดยองค์กรของคุณในระบบ vonage เกตเวย์ vonage ในแอปพลิเคชันชุดหลังบ้าน จากนั้นใช้ฟังก์ชันข้อความสั้นในเมนูของแอปพลิเคชัน Sales Cloud <br>กล่องข้อความสั้น<br> กล่องข้อความสั้นแบ่งออกเป็น 2 ส่วน ด้านซ้ายคือบันทึกของลีดหรือผู้ติดต่อด้วยข้อความสั้น หลังจากคลิกบันทึก ด้านขวาจะแสดงรายละเอียดการส่งและรับ คุณสามารถดูบันทึกของตัวเองและผู้ใต้บังคับบัญชาของคุณ <br>ข้อความสั้นแบบกลุ่ม<br> คุณสามารถส่งข้อความกลุ่มในเมนูข้อความสั้นตรงรายชื่อลีดหรือผู้ติดต่อ และปุ่มส่งข้อความสั้นเกี่ยวกับสมาชิกแคมเปญ คุณสามารถส่งข้อความสั้นถึงลีดหรือผู้ติดต่อใน CRM เท่านั้น หลังจากแก้ไขข้อความสั้น ให้เลือก "ส่ง" และบันทึกการส่งแบบกลุ่มจะถูกสร้างขึ้นโดยไม่คำนึงถึงจำนวนผู้รับ หรือคุณสามารถเลือก "ส่งแยก" เพื่อส่งข้อความสั้นแยกสนับสนุนการแสดงฟิลด์ผสานที่แทรกในแม่แบบข้อความสั้น`,
"label.emailobject.createnewavailability":`สร้างลิงก์ตารางการนัดหมายใหม่`,
"front-kefu-moudle-buytr-send-email":``,
"front-kefu-moudle-v1-Put-away-the-chat":``,
"label.marketseamemset.lead.maxuser":`จํานวนลีดสูงสุดของสมาชิก`,
"label.forecast.forecastroleuserpage.shre.manager":`เฉพาะผู้ดูแลระบบเท่านั้นที่สามารถแบ่งปันการพยากรณ์ได้`,
"label.file.noselect":`ไม่เลือกไฟล์`,
"label.notification.task3":`สถานะของภารกิจที่คุณมอบหมายให้[ผู้ได้รับมอบหมาย]ถูกแก้ไขเป็น[สถานะใหม่]`,
"label.dependfield":`ฟิลด์พึ่งพา`,
"lable.SalesCommitmentKanBan.receipts":`รับเงิน`,
"label_partner_workspace_member_search":`ค้นหา`,
"label.share.originally.posted":`โพสต์เริ่มต้น`,
"label.autonumber":`หมายเลขอัตโนมัติ`,
"label.view.sortview.name":`ชื่อมุมมอง`,
"label.h5.add.activity":`เพิ่มกิจกรรม`,
"label.textmessage.vonage.phone.number":`หมายเลขโทรศัพท์`,
"label.partnerCloud.financeSetting.enterApiKey":`โปรดป้อนคีย์ API`,
"label.industrialandcommercialverification.enablestatus":`สถานะเปิดใช้งาน`,
"label.reportTypeFocusD1":`ระบุประเภทบันทึก (แถว) ที่จะเป็นจุดสำคัญของรายงานที่สร้างโดยแหล่งข้อมูลรายงานนี้`,
"vue_label_report_four-levelseriesobjecttree":`แผนภูมิออบเจ็กต์ชุดข้อมูลสี่ระดับ`,
"label.mobile.default.catalogue":`ค่าเริ่มต้นแค็ตตาล็อก`,
"label.partnerCloud.partnerAccount.again":`เติมเงินอีกครั้ง`,
"label.summaryreport.step2.new":`ขั้นตอนที่ 2: เลือกวิธีจัดกลุ่มข้อมูลสรุป`,
"label.tabpage.cancel":`ยกเลิก`,
"label.multilang.datamovelist.datamove":`โอนย้าย {0} หลายรายการจากผู้ใช้หนึ่งไปยังอีกผู้ใช้หนึ่ง`,
"label.conferloginandvisitlimit":`ให้สิทธิ์การเข้าสู่ระบบและการเข้าถึง`,
"vue_label_help_viewhelpcenter":`ดูศูนย์ช่วยเหลือ CloudCC`,
"label.leadscore.norule":`ไม่มีเกณฑ์การให้คะแนน โปรดสร้างเกณฑ์การให้คะแนนก่อน หรือเปิดใช้งานเกณฑ์การให้คะแนนที่สร้างไว้แล้ว`,
"label.tabpage.exitz":`ออก`,
"label.DeploymentStatus":`สถานะการพัฒนา`,
"label.layout.saving":`กำลังบันทึกเค้าโครง...`,
"label.emailobject.emaildetail.field.object":`ออบเจ็กต์`,
"label.customfields.searchrelation.fieldtag.tip":`ใส่ป้ายกำกับที่จะใช้ในมุมมองการแสดง มุมมองเค้าโครงเพจ มุมมองรายงาน และมุมมองรายการ`,
"message.huanxin.bindtenant.notfound":`ผู้ใช้ไม่ได้ผูก Seat`,
"label.referpersonalias":`นามแฝงของผู้เสนอ`,
"label.icon.31":`คอมพิวเตอร์`,
"label.appupload.upload.install.thispackage":`แพ็กเกจนี้`,
"label.appointment.wizard.subtitle1-1":`กำหนดเอง`,
"pagecreator_page_message_save_fail":`การบันทึกหน้าเพจล้มเหลว`,
"label.lastset":`สุดท้ายกด`,
"label.version.support.limited":`การสนับสนุนถูกจํากัด`,
"vue_label_homepage_kanban":`คัมบัง`,
"label.layout.editsearchdistribute":`แก้ไขเค้าโครงการค้นหาหน้าเพจ`,
"template.dashboard.customer.analysis":`การวิเคราะห์ลูกค้า`,
"label.continue_editing":``,
"label.version.sum.customtab":`แท็บเมนูแบบกำหนดเอง`,
"label.validate.function.funcExplain.TIMEVALUE":`ส่งกลับเวลาในฟิลด์วันที่/เวลา (ชั่วโมง นาที วินาที)`,
"label.import.page1.selectobjfromdata":`เลือกออบเจ็กต์ที่ต้องการจะนำเข้าข้อมูล`,
"label.partnerCloud.basicSetting.success":`การเริ่มต้นใช้งานสําเร็จ`,
"label.customfields.fielddependency.cannotcreat":`ไม่สามารถสร้างความสัมพันธ์แบบพึ่งพาได้ ฟิลด์ที่คุณเลือกพึ่งพาตัวเองโดยตรงหรือโดยอ้อม`,
"label.umeng.activity.youhaveatask":`คุณมี 1 ภารกิจใหม่`,
"label.file.folder.create":`สร้างโฟลเดอร์ใหม่`,
"vue_label_campaign_member_status":`สถานะสมาชิก`,
"lable.opppdt.addpdt.table.date":`วันที่`,
"label_partner_workspace_login_buttontext":`ปุ่มข้อความ`,
"label_other_mistakes":`ข้อผิดพลาดอื่น ๆ`,
"label.must.be.configured":`ต้องกําหนดค่า`,
"label.customize.memory.function.sorting.enable":`เปิดใช้งานหน่วยความจำการเรียงลำดับของส่วนหัวของมุมมอง`,
"setup.layout.label.areaname":`ชื่อภูมิภาค`,
"label_chatter_pastThirtyday":`30 วันที่ผ่านมา`,
"setup_mainpage_label_welcome25":`คําแนะนําการใช้งาน:  คลิกเมนูด้านซ้ายของหน้านี้→การตั้งค่าการจัดการ→การควบคุมความปลอดภัย→การตั้งค่าการแบ่งปัน`,
"label.ccchat.person.invite.succsend":`คำเชิญเข้าร่วม CCChat ถูกส่งไปที่`,
"label.select.time.range":`โปรดเลือกช่วงเวลา`,
"label.partnerCloud.orderingPlatform.djustQuantity":`เพิ่มสินค้าลงในตะกร้าสินค้า ปรับปริมาณในตะกร้าสินค้า และตรวจสอบราคา`,
"label.manageAll.sta1":`อยู่ระหว่างการอนุมัติ`,
"label.cy.select":`กรุณาเลือกสกุลเงิน`,
"chatter.lam":`ความคิดเห็น`,
"label.partner.setup.title":`ตั้งค่า`,
"component.setup.label.displaybutton":`แสดงปุ่มกด`,
"component.salesperformance.label.target":`เป้าหมาย`,
"label.campagin.channel":`กรุณาใส่ค่าของช่องทางลงทะเบียน`,
"label.validate.function.funcFormat.ISCHANGED":`ISCHANGED(field)`,
"UG.homepage.009":`เข้า CRM`,
"label.file.item":``,
"label.file.library.addmembprompt":`เป็นสมาชิกระดับบริหารแล้ว อย่าเพิ่มซ้ํา`,
"label.bmap.releasePosition":`โพสต์ตำแหน่งที่ตั้ง`,
"setup_object_layout_label_selectedprofile":`โปรไฟล์ที่เลือก`,
"label_emailsync_message":`แจ้งเตือน`,
"label.view_submissions":``,
"lable.tianyancha.repeated":`เลือกซ้ำ`,
"label.import.index.introduce":`นําเข้าข้อมูลของคุณสู่ระบบด้วยสามขั้นตอนง่ายๆ`,
"label.time.operation.new":`งานที่ต้องกำหนดเวลาใหม่`,
"label.projectManagement.Pleaseentersettlementtype":`กรุณากรอกประเภทการชำระเงิน`,
"label.icon.169":`รถเที่ยวชมสถานที่`,
"vue_label_commonobjects_detail_related_listview":`แสดงรายการ`,
"label.view.step1":`ขั้นตอนที่ 1. ใส่ชือมุมมอง`,
"label.summaryreport.intro":`รายงานสรุปแสดงข้อมูลผลรวมย่อยและข้อมูลสรุปอื่นๆ พร้อมกัน`,
"vue_label_file_input_correct_name":`กรุณากรอกชื่อที่ถูกต้อง`,
"System_Email_Template_Title":`ยินดีต้อนรับสู่แฟลตฟอร์ม CloudCC CRM`,
"label.tianyancha.province":`ตัวย่อจังหวัด`,
"label.deleteall.sure":`ยืนยันว่าจะลบทั้งหมดหรือไม่`,
"label.passwordPolicy.setup.uppercasealpandnum":`ต้องประกอบด้วยตัวอักษรตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และตัวเลข`,
"front-lightning-module-v1-details-page-chart-select":`เลือกออบเจ็กต์และวิธีการแสดง`,
"setup_mainpage_label_welcome8":`ลากและวางอินเทอร์เฟซที่กำหนดเอง`,
"lable.outlook.edit.lastupc":`ผู้ติดต่อที่อัปเดตล่าสุด`,
"label.weixin.registered":`ลงทะเบียน`,
"vue_label_file_history_version":`ประวัติรุ่น`,
"vue_label_campaign_earned":`ยอดเงินที่จะได้รับ`,
"label.staticresource.useful.realtion.tip":`ต่อไปนี้คือการอ้างอิงเพจทั้งหมดไปยังทรัพยากรแบบคงที่นี้`,
"vue_label_file_libraray":`ไลบรารีเอกสาร`,
"label.department.phone":`หมายเลขโทรศัพท์`,
"label.emailtemplate.edit":`แก้ไขแม่แบบอีเมล`,
"label.processsetting.key.information.tips":`ข้อมูลสำคัญและเคล็ดลับ`,
"label.summaryreport.step7":`ขั้นตอนที่ 7: เลือกประเภทแผนภูมิและการรายงาน`,
"label.chat.topic.remove.favorite":`ลบออกจากรายการโปรด`,
"label.campagin.roi.ksrq":`วันที่เริ่มต้น`,
"label.data.downpage.e_title.e_btn":`เข้าสู่หน้าการส่งออกเพื่อเริ่มต้นการส่งออก`,
"label.approvaldatamove.dname":`ผู้อนุมัติปัจจุบัน`,
"lable.Partial.attributes":`คุณลักษณะบางส่วน`,
"template.report.enabled.products":`ผลิตภัณฑ์ที่เปิดใช้งาน`,
"lable.outlook.detail.cto":`CloudCC.com ไปยัง Exchange`,
"label.sendemail.activity.newtasktitle":`แจ้งเตือนภารกิจใหม่`,
"label.validate.function.funcFormat.DAY":`DAY(date)`,
"label.log.datetime.value":`กรุณาใส่เวลาสอบถาม!`,
"label.import.index.updaterecord":`อัปเดตบันทึก`,
"label.registration.page.invitation":`คําเชิญหน้าลงทะเบียน`,
"pagecreator_systemstyle_label_detailcolor":`สีของรายละเอียด`,
"label.tabname.cannot.empty":`ชื่อแท็บไม่สามารถว่างเปล่า!`,
"label.data.newtemplate.savetemp":`คุณสามารถเลือกบันทึกเป็นแม่แบบเพื่อบันทึกฟิลด์และเงื่อนไขที่เลือกให้เป็นแม่แบบส่งออกข้อมูลของหน้าแม่แบบนี้และบันทึกลงในหน้าแม่แบบ กรุณาใส่ชื่อแม่แบบและคำอธิบายแม่แบบอย่างละเอียดเพื่อความสะดวกในการใช้งานภายหลัง`,
"label.ems.body":`ข้อความ`,
"enc":`ข้อความที่เข้ารหัส (การเข้ารหัสการจัดเก็บข้อมูล)`,
"label.profile.mobile.setup.commonSaler":`พนักงานขายทั่วไป`,
"label.continueselectproduct":`เลือกผลิตภัณฑ์ต่อ`,
"label.event.new":`อิเวนต์ใหม่`,
"label.renametabandtaglib":`เปลี่ยนชื่อแท็บและป้ายกำกับ`,
"label.qrcodelogin.message.exception":`เซิร์ฟเวอร์ผิดปกติ โปรดติดต่อผู้ดูแลระบบ`,
"label.service.gantt.locationToGantt":`แผนภูมิแกนต์`,
"label.mr.theLastGroup":`นี่เป็นกลุ่มสุดท้ายแล้ว กรุณาคลิก [ย้อนกลับไปดูรายการข้อมูลที่ซ้ำกัน] เพื่อค้นหาข้อมูลที่ซ้ำกัน`,
"label.report.export.format.content":`ส่งออกส่วนหัวของตาราง การจัดกลุ่ม และรายละเอียด ส่งออกข้อมูลรายละเอียดได้สูงสุด`,
"label.version.accountandcontact":`ลูกค้าและผู้ติดต่อ`,
"label.partnerCloud.financeSetting.enterMd5Key":`กรุณากรอกรหัส MD5`,
"label.login.access.quater":`สัปดาห์`,
"vue_label_commonobjects_view_searchthisview":`ค้นหารายการนี้`,
"label.import.step1.allobj":`ออบเจ็กต์ทั้งหมด`,
"front-efficient-project-management":`Project Cloud จะช่วยสนับสนุนคุณด้วยการจัดการวงจรโครงการแบบเต็มรูปแบบ ตั้งแต่การเริ่มต้นโครงการ การวางแผน การดำเนินการ การควบคุม และการปิด เพิ่มประสิทธิภาพการจัดการโครงการตามความต้องการทางธุรกิจ และช่วยให้คุณจัดการโครงการได้อย่างมีประสิทธิภาพ`,
"label.includedvalue":`ค่าที่รวม`,
"label.service.newBuildDialog.past.days":`จํานวนวันที่ผ่านมา`,
"vue_label_report_sortup":`เรียงจากน้อยไปมาก`,
"label.appointment.wizard.subtitle3-2":`วันอังคาร`,
"label.dashboard.trend":`แนวโน้ม`,
"label.schedulejob.setup.schedule.st2":`ที่สอง`,
"label.view.sortview.number":`จำนวนบันทึก`,
"lable.Please.enable.order":`ไม่ได้เปิดใช้งานใบสั่งซื้อ โปรดเปิดใช้งานใบสั่งซื้อก่อน`,
"label.datamanage.immediately.import":`นำเข้าทันที`,
"label.delete.condition":`ล้าง`,
"label.dashboard.chooseDispalyOnTheHomePage":`เลือกหน้าแรกที่แสดง`,
"asset.accountid.contactid.required":`สินทรัพย์แต่ละรายการต้องเชื่อมกับลูกค้าหรือผู้ติดต่อ`,
"label.mask.character":`อักขระตัวพราง`,
"lable.account.Previous.FY":`ปีงบประมาณก่อนหน้า`,
"chatter.attachment":`ไฟล์แนบ`,
"label.view_only":`ดูเท่านั้น`,
"label.tianyancha.name":`ชื่อธุรกิจ`,
"label.service.gantt.avg.traveltime":`เวลาเดินทางเฉลี่ยของการนัดหมายการบริการ`,
"vue_label_pool_move":`ถ่ายโอน`,
"label.import.index.beforeexport":`2. ก่อนนำเข้าโปรดตรวจสอบให้แน่ใจว่าได้นำเข้าบันทึกที่เกี่ยวข้องทั้งหมดแล้ว เช่น หากคุณกำลังนำเข้าบันทึกผู้ติดต่อ และคุณต้องการกรอกข้อมูลในฟิลด์ลูกค้า (เป็นฟิลด์ค้นหา) คุณต้องสร้างบันทึกลูกค้าที่คุณจะกรอกก่อนจึงนำเข้าบันทึกผู้ติดต่อ และกรอกข้อมูลที่เกี่ยวข้องกับลูกค้า เช่น ชื่อ หรือ id ในฟิลด์ลูกค้า`,
"label.view.delete":`ลบมุมมอง`,
"template.detail.info.link":`ลิงก์รายละเอียดข้อมูล`,
"label.sendemail.send.setfail":`ตั้งค่าข้อมูลอีเมลไม่สำเร็จ โปรดตั้งค่าข้อมูลอีเมลให้ถูกต้อง`,
"label_emailtocloudcc_redmessage11":`การรับรอง SMTP ล้มเหลว โปรดตรวจสอบว่าที่อยู่อีเมลและรหัสผ่านถูกต้องหรือไม่`,
"label.campaigns.memberalert":`โปรดเลือกสมาชิกอย่างน้อยหนึ่งคน`,
"label.schedulejob.setup.schedule.frequency":`ความถี่`,
"component.newrecords.label.all":`ดูทั้งหมด`,
"label.mr.caption.opportunity":`ตรวจสอบซ้ำและผสาน: เงื่อนไขการสืบค้นข้อมูลโอกาสทางธุรกิจที่ซ้ำกัน`,
"chatter.group.onlyMembers":`กลุ่มนี้มองเห็นได้เฉพาะสมาชิกเท่านั้น และมีเพียงเจ้าของกลุ่มที่มีสิทธิ์เพิ่มสมาชิก`,
"label.recordtype.edit.selectvalue.show":`ค่ารายการตัวเลือกจะแสดงตามลำดับที่บันทึก`,
"message.textmaxlength":`ต้องยาวไม่เกิน 255`,
"label.reportsSubscriptionPage.visibility":`เรียกใช้รายงานจากมุมมองของผู้ใช้ต่อไปนี้`,
"label.umeng.chatter.addcoments":`ยฺหวินเทียของคุณมีการตอบกลับใหม่ 1 รายการ`,
"chatter.up.f":`การอัปโหลดล้มเหลว ข้อผิดพลาดที่ไม่รู้จัก`,
"label.icon.146":`แป้นพิมพ์`,
"lable.custom.CY.Ago":`สองปีที่กําหนดเองก่อนหน้า`,
"label.tabpage.step3":`ขั้นตอนที่ 3 เลือกฟิลด์แสดงผล`,
"label.checkfield.introduce":`ตั้งค่าฟิลด์ในออบเจ็กต์ที่สามารถตรวจสอบการซ้ำได้ ในรายงานข้อมูลจะสามารถตรวจสอบการซ้ำของข้อมูลตามฟิลด์ที่ตั้งค่าได้`,
"label.tag.addtags":`เพิ่มป้ายกำกับ`,
"label.service.newBuildDialog.characterlimit":`ชื่อยาวเกินจำนวนอักขระสูงสุด 25 ตัว`,
"font-evaluate-module-v1-evquestions":``,
"label.knowledge.only.update.draft":`อัปเดตได้เฉพาะบทความฉบับร่าง`,
"label.partnerCloud.basicSetting.defaultCounts":`จํานวนบทบาทเริ่มต้นที่สร้างขึ้นเมื่อเพิ่มลูกค้าพาร์ทเนอร์`,
"label.chat.topic.delete":`ลบ`,
"label.workflow.contentcondition":`สอดคล้องกับเงื่อนไข`,
"vue_label_commonobjects_view_sortby":`เรียงลำดับตาม{field}`,
"label.passwordPolicy.setup.pwdremember24":`จํา {0} รหัสผ่าน`,
"front-kefu-moudle-free-account":``,
"label.marketsea.isautorecycle":`เปิดใช้งานการรีไซเคิลอัตโนมัติ`,
"label.addattachment.view":`ดูไฟล์`,
"vue_label_helpcenter_contact":`ในรายละเอียด ให้กดปุ่มมุมมองแบบแผนภูมิต้นไม้ถัดจากผู้ติดต่อ จะสามารถดูลําดับชั้นผู้ติดต่อ และทำความเข้าใจความสัมพันธ์ของผู้ติดต่อที่เกี่ยวข้องและดูข้อมูลในฟิลด์ผู้ติดต่อแต่ละคน`,
"label.taskevent":`ภารกิจและอิเวนต์`,
"label.industrialandcommercialverification.message":`จำนวนการสอบถามฟรีของวันนี้หมดแล้ว`,
"label.object.already.delete":`ลบออบเจ็กต์แล้ว`,
"label.project.hit.four":`แจ้งเตือนการอัปเดตงานย่อย`,
"label.taskpagelayout":`เค้าโครงหน้าภารกิจ`,
"label.version.sum.locationfield":`ฟิลด์ตำแหน่งทางภูมิศาสตร์`,
"front-sales-button-toQB":``,
"label.app.oceanblue":`สีน้ำเงินเข้ม`,
"label.operating":`กำลังดำเนินการ...`,
"label.customfields.formula.dateexample":`Reminder Date（วันที่แจ้งเตือน）= CloseDate - 7`,
"label.happen_delete":`การลบฟอร์มมีผลกระทบอะไรบ้าง?`,
"label.service.appointmentList.plansToStart":`เริ่มแผน`,
"label.persmets.operate.licence":`ใบอนุญาต`,
"label.mobile.quickcreate.default.activities":`ปฏิทิน`,
"label.australian.eastem.standard.time":`เวลาออมแสงตะวันออก (นิวเซาท์เวลส์)`,
"label.emailobject.remove":`ลบ`,
"label.weixin.vote":`ร่วมโหวต`,
"label.reportsSubscriptionPage.condition.aggregate":`ผลรวม`,
"front-kefu-moudle-has-unbind":``,
"chatter.group.newGroup":`กลุ่มใหม่`,
"label.tabpage.systems":`มีทั้งหมด * ระบบ`,
"label.textmessage.vonage.connect":`เชื่อมต่อกับ Vonage`,
"label.campaign.channel.input.ticket":`ส่งบัตรเข้างาน`,
"label.ccpeak.query.sharetab":`สืบค้นตารางแบ่งปัน`,
"label.reporttype":`แหล่งข้อมูลรายงาน`,
"message.duplication.label.isprofiletip":`หากเลือกจะตรวจสอบข้อมูลที่ผู้ใช้เห็นทั้งหมดในปัจจุบัน มิฉะนั้นจะตรวจสอบข้อมูลทั้งหมด`,
"label.tianyancha.businessverify.xieyi":`ข้อตกลงการอนุญาตใช้สิทธิ์`,
"font-evaluate-module-v1-select-person":``,
"vue_label_chatter_all_groups":`ทุกกลุ่ม`,
"label.recordtype.profile.setdefault":`ตั้งค่าเริ่มต้น`,
"label.mr.descreption.nocondition":`ไม่มีข้อมูลซ้ำที่สอดคล้องกับเงื่อนไข`,
"label.tabpage.askz":`คุณต้องการจะถามอะไร`,
"label.marketsea.selectMember":`เลือกสมาชิก`,
"template.report.stage.possibility.analysis":`การวิเคราะห์ความเป็นไปได้ในสเตจ`,
"label.data.selectderivedobject":`เลือกออบเจ็กต์ที่ต้องการส่งออก`,
"label.customfields.formula.explain":`คำอธิบาย: ปัจจุบันรองรับการดำเนินการเลขคณิตในฟิลด์ เช่น ตัวเลข เปอร์เซ็นต์ เป็นต้น ตลอดจนการค้นหาค่าของฟิลด์ เช่น สูตรตัวเลข jine*knxing&nbsp;&nbsp;&nbsp ค้นหาฟิลด์ที่มีค่า: khmc__r.dianhua`,
"vue_label_notice_change_fail":`การแก้ไขล้มเหลว`,
"label.customobjects.trackoldandnewvalues":`ติดตามค่าเก่าและค่าใหม่`,
"label.h5.leftprompt":`คุณยังไม่ได้ส่งเนื้อหาที่แก้ไข ยืนยันว่าจะออกหรือไม่?`,
"label.select.field":`ตัวเลือกฟิลด์`,
"label.customobjects.layoutedit":`กำหนดเค้าโครงเพจ`,
"label.false":`เท็จ`,
"UG_Forcast_07":`อนุญาตให้พยากรณ์`,
"vue_label_chatter_team_member":`สมาชิกกลุ่ม`,
"label.tabpage.retypez":`เมื่อเปลี่ยนชนิดบันทึก ค่ารายการตัวเลือกที่มีอยู่จะไม่เปลี่ยนแปลงโดยอัตโนมัติ เราขอแนะนำให้อัปเดตค่ารายการตัวเลือกที่มีอยู่ในบันทึกในที่เดียวกัน`,
"front-epwechat-module-v1-single-desc":`เข้าสู่ระบบแบบ SSO  ผ่านวีแชทขององค์กรไปยังเทอร์มินัลอื่นของ CloudCC เพื่อสลับไปมาระหว่างเทอร์มินัลอย่างรวดเร็ว`,
"label.closeandconverted":`ปิด-ข้ามสเตจแล้ว`,
"label.service.confirmed":`ยืนยัน`,
"label.partner.workspace.member.cloudcc":`โปรไฟล์ CloudCC`,
"label.star.click":`คลิกเพื่อล้าง`,
"label.icon.135":`สกุลเงิน`,
"button_partner_workspace_login_logo_upload":`อัปโหลดรูปภาพ`,
"message.error.sql.constraint.recordnotsingle":`การตั้งค่า ID ภายนอกไม่สําเร็จ! สาเหตุ: ฟิลด์มีข้อมูลที่ซ้ํากันในข้อมูลเดิม`,
"label.ccchat.person.invite.errorpwd":`ใช้อักขระอย่างน้อย 8 ตัวที่มีตัวเลขและอักขระผสมรวมกัน`,
"label_tabpage_isdeleterecord":`ลบบันทึกที่เลือกหรือไม่`,
"label.weixin.prompt.message":`ข้อความแจ้งเตือน`,
"vue_label_chatter_view_original_post":`ดูโพสต์ต้นฉบับ`,
"label.multilingual.tip3":`การเปิดใช้งานหลายภาษาทำให้ผู้ใช้ในองค์กรสามารถกำหนดค่าประเภทภาษาเป็นภาษาที่คุณเปิดใช้งานได้`,
"label.dataimport.error.datetime":`เกิดข้อผิดพลาด: วันที่และเวลา`,
"label_tabpage_addcondition":`เพิ่มเงื่อนไข`,
"label.query.detail.manageexcludeuser":`จัดการผู้ใช้ภายนอก`,
"label.tianyancha.creditcode":`รหัสเครดิตทางสังคม`,
"label.cy.enter":`ใส่อัตราการแปลงสกุลเงินบริษัทของคุณเป็นสกุลเงินใหม่`,
"label.textmessage.vonage.message1":`ด้วยการเชื่อมต่อ Vonage ผู้ใช้สามารถส่งและรับข้อความบนแพลตฟอร์ม CloudCC ได้ แต่ก่อนหน้านั้นผู้ใช้จะต้องลงทะเบียนบัญชี Vonage และซื้อหมายเลขโทรศัพท์`,
"front-marketing-module-v1-share-invitation":`แบ่งปีนคำเชิญพนักงาน`,
"label.file.items":`รายการ`,
"label.otherwise":`มิฉะนั้น`,
"label.permission.detail.system":`ระบบ`,
"message.success.task.emailsend":`การบันทึกข้อมูลการส่งอีเมลสำเร็จ`,
"label.the.reward.group":`กลุ่มบรรทัดใบเสนอราคา`,
"setup.layout.label.relatedlistsetup":`ตั้งค่ารายการที่เกี่ยวข้อง`,
"label.empty":`ล้าง`,
"label.weixin.cloudcc.user.binding":`ผูกผู้ใช้ CloudCC`,
"label.file.what.change":`ส่งการเปลี่ยนแปลงใดๆ (ตัวเลือก)`,
"label.search":`ค้นหา`,
"label.mobile":`โทรศัพท์มือถือ`,
"template.report.month.potential.customer":`ลีดในเดือนนี้`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`เปิดใช้งานเกณฑ์การทวนสอบสำหรับการสแกนนามบัตรหรือไม่`,
"lable.outlook.list.des":`การกำหนดองค์ประกอบ Exchange Sync ต้องตั้งค่า CloudCC for Exchange ที่จะนำไปใช้กับกลุ่มผู้ใช้เฉพาะ`,
"label.appupload.install.error.info":`{0} "{1}" ถูกใช้โดย{2}  กรุณาเปลี่ยนชื่อ{0}`,
"label.tabpage.addoptionsz":`เพิ่มตัวเลือก`,
"label.arabian.standard.time":`เวลามาตรฐานอาหรับ`,
"label.thefirst":`แถวแรก`,
"label_partner_workspace_login_footertext":`ข้อความส่วนท้าย`,
"lable.Disabled.successfully":`ปิดการใช้งานเรียบร้อยแล้ว`,
"label.confirm.del":`บันทึกอยู่ระหว่างการอนุมัติ โปรดยืนยันหากต้องการที่จะลบ`,
"vue_label_normal_reregister":`ลงทะเบียนใหม่`,
"label_file_img":`รูปภาพ`,
"label.salescloud.salesdashboard.sales.behavior":`พฤติกรรมของพนักงานขาย`,
"label.startdate":`วันที่เริ่มต้น`,
"label.field.duplicate.error.msg5":`โปรดตรวจสอบข้อความแสดงข้อผิดพลาดต่อไปนี้และแก้ไขแล้วลองอีกครั้ง`,
"setup.main2018.label.managesetup":`จัดการการตั้งค่า`,
"label.forecast.editshrepage.title":`การแบ่งปันใหม่`,
"UG.solution.01":`เสนอโซลูชัน`,
"label.knowledgebase.data.recovery.successfully":`กู้คืนข้อมูล {a} รายการสำเร็จ`,
"label.pc.ui.2018.myccchat":`CCChat ของฉัน`,
"label.attachement":`หมายเหตุและไฟล์แนบ`,
"message.mobilechooseatmostten":`เลือกได้มากที่สุด 10 ฟิลด์`,
"label.campagin.roi.bhzeywjh":`จำนวนโอกาสทางธุรกิจทั้งหมด`,
"label.autoresponserule":`กฎการตอบกลับอัตโนมัติ`,
"label.attendance.yuyue":`คุณไม่ได้จองไว้ ต้องการจะลงทะเบียนหน้างานใช่หรือไม่?`,
"label.insert":`แทรก`,
"label.service.ganttBaiduMap.shutDown":`ยืนยันว่าจะปิด?`,
"label.icon.194":`โทรทัศน์`,
"message.serviceterritory.violation":`การละเมิดพื้นที่: ภูมิภาคของทรัพยากรไม่ตรงกับภูมิภาคให้บริการในการนัดหมายการบริการ`,
"label.appointment.disable.function":`ปิดการใช้งานฟังก์ชั่น`,
"lable.currencyManage.manageexchangeRate.dis":`กรุณาคลิกจัดการอัตราแลกเปลี่ยนที่หมดอายุ" เพื่อจัดการอัตราแลกเปลี่ยนที่หมดอายุของบริษัทของคุณ อัตราแลกเปลี่ยนที่หมดอายุจะใช้กับโอกาสทางธุรกิจ ผลิตภัณฑ์ที่มีโอกาสทางธุรกิจ และรายงานที่เกี่ยวข้องกับออบเจ็กต์ทั้งสองนี้ "`,
"vue_label_file_upload_tip_newmsg":`ขอแนะนำว่าไฟล์ที่อัปโหลดควรมีขนาดเล็กกว่า {size}MB มิฉะนั้นอาจทำให้หน้าเพจโหลดช้า`,
"label.event.next.week":`อิเวนต์ของสัปดาห์หน้า`,
"label.datamanage.import.contactfield":`ให้เลือกฟิลด์ในแฟ้มนําเข้าที่ควรนําเข้าไปยังผู้ติดต่อแต่ละรายจากตารางต่อไปนี้  เมื่อคุณทําเสร็จแล้วให้คลิกขั้นตอนถัดไป:`,
"label.projectManagement.time.allocated":`กำหนดเวลา`,
"label_tabpage_isdeleteview":`คุณยืนยันจะลบมุมมองนี้หรือไม่?`,
"label.pc.ui.2018.search":`กรุณาใส่เนื้อหาที่ต้องการค้นหา`,
"label.role.createrolelevel":`สร้างลำดับขั้นของบทบาท`,
"label.tabpage.editview":`แก้ไขมุมมอง`,
"label_partner_common_manageSetup":`การตั้งค่าการจัดการพาร์ทเนอร์คลาวด์`,
"label.service.gantt.noservice.resource":`ไม่พบทรัพยากรบริการที่พร้อมใช้งานในภูมิภาคให้บริการที่เลือก`,
"message.numbertoolarge":`ตัวเลขใหญ่เกินไป`,
"label.sendsms.success":`การส่งข้อความสั้นสำเร็จ`,
"UG.opportunity.009":`หรือ`,
"label.ccpeak.construction.dataobj":`ในการสร้างออบเจ็กต์ข้อมูลรายการหนึ่ง ต้องผ่านชื่อออบเจ็กต์ API:`,
"front-lighting-module-v1-detail-file-uploadInfo":`บันทึกถูกล็อกและไม่สนับสนุนการอัปโหลดไฟล์ โปรดติดต่อผู้ดูแลระบบเพื่อปลดล็อก`,
"label.import.page2.newnotmatchfiled":`ฟิลด์ในไฟล์ทั้งหมด {{ csvfiledlength }} ฟิลด์ ยังไม่ได้แม็ป {{this.csvfiledlength - this.selectlength}} ฟิลด์`,
"label.ems.inputmailss":`เซิร์ฟเวอร์รับอีเมล`,
"label.knowledgebase.data.published.successfully":`เผยแพร่ข้อมูล {a} รายการสำเร็จ`,
"label_emailtocloudcc_position":`ตำแหน่ง`,
"label.data.exp.customexp":`การส่งออกแบบกำหนดเอง`,
"component_chatter_post_button_user":`เพิ่มผู้ใช้`,
"label.new.visualpagefolder":`เพจที่กำหนดเอง: สร้างโฟลเดอร์ใหม่`,
"label.forecast.shrepage.classdes":`คำอธิบายระดับสิทธิ์การเข้าถึง`,
"label.task.overdue.unfinished":`ภารกิจที่เลยกำหนดเวลา`,
"label.ccchat.micropost.isedit.setting.info":`ผู้โพสต์หรือเขียนความคิดเห็น เจ้าของบันทึก ผู้ดูแล ccchat และผู้ดูแลชุมชนนี้ ทั้งหมดมีสิทธิ์แก้ไขข้อความ`,
"label.recordname":`ชื่อบันทึก`,
"label.posted_your":`และเผยแพร่บน...ของคุณ`,
"label.globaloperation.operationtype.custom.page":`เพจที่กำหนดเอง`,
"label_tabpage_busoppnamez":`ชื่อโอกาสทางธุรกิจ`,
"front-epwechat-module-v1-schedule-desc":`ซิงค์กําหนดการในวีแชทขององค์กรกับอิเวนต์ใน CloudCC`,
"label.escalation.setup.newentries.lastmodifydate":`ตามเวลาที่เคสแก้ไขล่าสุด`,
"setup_layout_label_nofield":`ไม่มีตัวเลือกฟิลด์`,
"label.sendemail.registIMUser.logininfo":`พอร์ทัลพาร์ทเนอร์คลาวด์ที่คุณสามารถลงทะเบียนได้มีดังต่อไปนี้：<br>`,
"label.weixin..xsld.kehu":`ลูกค้า`,
"label.display_thank":``,
"label.group.no.my.group":`ไม่มีกลุ่มของฉันที่ตรงกัน`,
"label.partnerCloud.newBuildSite.enterDomain":`กรุณากรอกชื่อโดเมน`,
"label.step1.total2":`ขั้นตอนที่ 1 จาก 2`,
"label.ccpeak.delete.record":`ลบบันทึก:`,
"label.customer.tab.step1.introduce":`เลือกออบเจ็กต์ที่กำหนดเองสำหรับแท็บแบบกำหนดเองใหม่นี้และใส่รายละเอียดเพิ่มเติม`,
"label_tabpage_newInterfacez":`อินเทอร์เฟซรุ่นใหม่`,
"setup.mainpage.label.manageuser":`จัดการผู้ใช้`,
"label.partnerCloud.partnerAccount.completed":`ชำระเงินเรียบร้อยแล้ว?`,
"label.projectManagement.kanban":`คัมบังงาน`,
"label.operate":`ดำเนินการ`,
"label.service.dispatchingUnits.selected.time.range":`แสดงการนัดหมายการบริการในช่วงเวลาที่เลือก`,
"component_setup_label_pagesize":`จำนวนรายการที่แสดงต่อหน้า`,
"font-evaluate-module-v1-email-evaluation-settings":``,
"label.service.dispatchingUnits.skills":`ทักษะ`,
"label.editrecurrencetimetrigger":`แก้ไขทริกเกอร์วงจร`,
"vue_label_file_edit_lib":`แก้ไขไลบรารีเอกสาร`,
"label.campaignmember.selectmember.deleteconc":`แคมเปญ: ลบสมาชิกจากรายชื่อผู้ติดต่อ`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`วันจันทร์`,
"front-detail-module-v1-by":`จนถึง`,
"label.mobile.home.page.date.signed":`วันที่ทำสัญญาคาดการณ์`,
"label.apply.send.success":`การส่งสำเร็จ!`,
"label.app.choseimg":`เลือกรูปภาพ`,
"label.customsetting.visible":`การมองเห็น`,
"label.sendemail.activity.task.distributetaskcompleted":`ภารกิจที่คุณมอบหมายให้#belongtoidccnameติดป้ายว่าสำเร็จแล้ว`,
"label.dashboard.snapshot.refreshing":`กำลังรีเฟรส`,
"label.document.name.already.exists":`มีชื่อเฉพาะของโปรไฟล์แล้ว!`,
"label.ccchat.person.invite.needlastname":`ใส่นามสกุลของคุณ`,
"pagecreator_page_button_copy":`คัดลอก`,
"label.appointmentpage.wizard.subtitle1-2":`สัปดาห์ที่แล้ว`,
"label.validate.function.funcFormat.MILLISECOND":`MILLISECOND(date)`,
"label.profile.allowtocreateview":`สร้างมุมมอง`,
"message.error.recordid":`ID บันทึกไม่สามารถว่างเปล่า`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`กลับไปสู่บทบาทที่สูงกว่า`,
"label.translation.start3":`หากจำเป็นให้เลือกหนึ่งออบเจ็กต์ เช่น งานเวิร์กโฟลว์มีออบเจ็กต์ (บัญชี ผู้ติดต่อและอื่นๆ) เพื่อกรองการแปลศัพท์เฉพาะ`,
"label.ccpeak.send.email":`การแจ้งเตือนทางอีเมล:`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`ยังไม่ถึงวันหมดอายุ`,
"label.permission.objectpermission.objpermission":``,
"label.version.custom.report":`รายงานมาตราฐาน (เพจที่กำหนดเอง)`,
"label.title.qrcodeOrbarcode":`สร้างกฎรหัสคิวอาร์/บาร์โคด`,
"label.emailtocloudcc.step2.name":`กำหนดแหล่งที่มาของอีเมล`,
"label.reportsSubscription.edited.successfully":`การแก้ไขการสมัครใช้งานรายงานสําเร็จ!`,
"label_tabpage_kanbansetup":`การตั้งค่าคัมบัง`,
"label.tianyancha.regcapital":`ทุนจดทะเบียน`,
"front-epwechat-module-v1-web-single":`SSO ของ web:`,
"label.visualpage.display.top":`แสดงส่วนหัวของหน้า false-ไม่แสดงส่วนหัวของหน้า`,
"label.customfields.fielddependency.selectcell":`เลือกอย่างน้อยหนึ่งเซลล์จากตารางด้านล่าง`,
"label.paging.addmember.totalofpages":`รวม <span id='recordCount'></span>&nbsp;&nbsp;<span id='recordRange'></span> รายการ &nbsp;&nbsp;`,
"label.email.saveing":`บันทึกข้อมูล ··`,
"label.userinfo.doublepwd.notnull":`รหัสผ่านซ้ำไม่สามารถว่างเปล่า!`,
"label.appointment.wizard.subtitle4-4-2":`สองสัปดาห์`,
"label.chatter.BCC":`สำเนาลับ`,
"label.emailtocloudcc.description":`เพิ่มอีเมลธุรกิจของคุณ เช่น sales@company.com, info@company.com, และsupport@company.com ที่นี่ ระบบจะสร้างลีดหรือเคสตามอีเมลที่ได้รับโดยอัตโนมัติ เพื่อให้แน่ใจว่าจะติดตามอีเมลขาเข้าจากลูกค้าได้อย่างทันท่วงที`,
"label.sendemail.send.atlastone":`ผู้รับอย่างน้อยหนึ่งคน`,
"label.mobile.phone.subordinate":`รวมผู้ใต้บังคับบัญชาหรือไม่`,
"label.data.choses.e_desc":`สามารถเลือกส่งออกข้อมูลทั้งหมดหรือเลือกส่งออกข้อมูลออบเจ็กต์เดียวได้ตามความต้องการของคุณ`,
"chatter.new":`ข่าวสาร`,
"vue_label_help_back":`กลับไประดับก่อนหน้า`,
"label.skipwizardintro":`ตัวช่วยเริ่มต้นทันใจสามารถสร้างกระบวนการอนุมัติได้ในขั้นตอนเดียวภายในเวลาเพียงไปกี่นาที`,
"label.weixin.fmu.before.week":`ล่วงหน้า {0} สัปดาห์`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat ชอบเวยเทียของคุณ`,
"lable.currencyAdv.andafterdate":`และหลังจากวันที่`,
"label.sometoprocess":`หากมีเพียงบันทึกบางประเภทเท่านั้นที่สามารถเข้าสู่กระบวนการอนุมัตินี้ได้ กรุณาป้อนเงื่อนไขด้านล่าง เช่น เฉพาะรายงานค่าใช้จ่ายสำหรับพนักงานของสำนักงานใหญ่เท่านั้นที่ใช้กระบวนการอนุมัตินี้`,
"label.campaignmember.main.updateleaddesc":`อัปเดตสถานะของลีดทั้งหมดพร้อมกัน`,
"label_partner_common_roleSetup":`บทบาทพาร์ทเนอร์คลาวด์และการตั้งค่าผู้ใช้`,
"label.console.step5.no":`เลือกวิธีการแสดงบันทึก`,
"label.salescloud.teamrole.optionlist.account":`เพิ่มสมาชิกกลุ่มลูกค้าไปที่`,
"Report.Delete.Confirm.Title":`กรุณายืนยัน`,
"label.onclick":`คลิก`,
"label.weixin.input.identifying.code":`กรุณาป้อนรหัสยืนยัน`,
"label.knowledge.translate":`แปลได้เฉพาะบทความความรู้ฉบับร่างหรือฉบับหลักที่ตีพิมพ์แล้วเท่านั้น`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":``,
"label.escalation.setup.newaction.otheremail.otheremail":`อีเมลอื่นๆ`,
"label.icon.104":`กําหนดการ`,
"label.partnerCloud.exceedTwo":`ขนาดของรูปโปรไฟล์ที่อัปโหลดต้องไม่เกิน 2MB!`,
"label_tabpage_thevalurofz":`ค่า`,
"front-lightning-module-v1-details-page-chart-maximum":`ป้อนอักขระสูงสุด 50 ตัว`,
"label.data.downpage.i.title.num6":`แนะนำคุณว่าให้นำเข้าบันทึก 5 รายการเพื่อทดสอบก่อนจึงนำเข้าข้อมูล เพื่อให้แน่ใจว่าไฟล์ที่นำเข้านั้นถูกต้อง`,
"label.ccpeak.update.record":`อัปเดตบันทึก:`,
"label.dataimportandexport":`การนำเข้าและส่งออกข้อมูล`,
"label.tabpage.notexceed25":`บันทึกที่เลือกต้องไม่เกิน 25 รายการ`,
"label.starting":`กําลังดําเนินการ`,
"label.knowledge.language.spanish":`ภาษาสเปน`,
"label_emailtocloudcc_set":`ตั้งค่าข้อมูลอีเมล`,
"message.oneormoreneedsreport":`แดชบอร์ดใช้รายงานนี้ โปรดลบส่วนเสริมแดชบอร์ดที่อ้างอิงรายงานนี้และลองอีกครั้ง`,
"label.attendance.xccheckin":`ลงทะเบียนเข้าหน้างาน`,
"label.emailmerge.editfolder.title":`โฟลเดอร์แม่แบบจดหมายเวียน`,
"template.report.year.customer":`ลีดในปีนี้`,
"label.partner.common.webSit.memo":`ชื่อโดเมนเริ่มต้นของพาร์ทเนอร์คลาวด์ในองค์กรของคุณคือ:`,
"label.partnerCloud.financeSetting.onlinePayment":`ชําระเงินออนไลน์`,
"Pagelayout.Setup.001":`เลือกรายการที่เกี่ยวข้องเพื่อแสดงบนเค้าโครงหน้าโฮเวอร์`,
"front-kefu-moudle-time-length":``,
"label.deleteObject":`ลบออบเจ็กต์แล้ว`,
"label.setup.mobile.homepageshortcuts.select":`เลือกฟังก์ชันทางลัด 4 ฟังก์ชันที่ต้องแสดงที่ส่วนบนของหน้าแรก`,
"setup.mainpage.label.welcome26":`การจัดการข้อมูล-แบทช์`,
"label.ServiceCloud.yuyuebainhao":`หมายเลขการนัดหมายการบริการ`,
"label.emailobject.emaildetail.button.addtolead":`เพิ่มไปยังลีด`,
"label.event.single.view":`มุมมองเดี่ยว`,
"lable.product.pricebooks.ustand":``,
"label.emailtocloudcc.department":`แผนก`,
"component_assistant_label_30daysnoact":`ไม่มีกิจกรรมใดๆ ใน 30 วัน`,
"label.weixin.no.pending.qzkh.qin":`ขณะนี้ยังไม่มีข้อมูลลีด`,
"label.vlidaterule.formula":`สูตรเงื่อนไขข้อผิดพลาด`,
"label.tianyancha.h5.contact":`ข้อมูลการติดต่อ`,
"label.button":`ปุ่ม`,
"message.checkemail":`<strong>ข้อผิดพลาด：</strong> อีเมลที่กรอกไม่ถูกต้อง กรุณาตรวจสอบ`,
"lable.account.previous.CY":`ปีปฏิทินก่อนหน้า`,
"label.icon.13":`ซ่อมบำรุง`,
"chatter.coll.c":`ยกเลิกบุ๊กมาร์ก`,
"label.knowledge.category.hint.four":`การจัดหมวดหมู่ข้อมูล`,
"label.tianyancha.phonenumber":`รายละเอียดการติดต่อ`,
"label.tablayoutedit.remark":`เลือกฟิลด์และเพจที่กำหนดเองที่ต้องการให้แสดงในหน้าเพจเมนู`,
"label.shareusers":`ผู้ใช้ร่วม`,
"label.endtime":`เวลาสิ้นสุด`,
"label.length":`ความยาว`,
"label.umeng.activity.event.begin":`เริ่มหลังจาก`,
"label.tabpage.alltabs":`แท็บทั้งหมด`,
"label.exact.query":`สืบค้นข้อมูลที่เหมือนกัน`,
"label.weixin.skip":`ข้าม`,
"label.ems.cancel":`ยกเลิก`,
"label.trigger":`ทริกเกอร์`,
"label.exchange.sync.setting":`การตั้งค่า Exchange Sync`,
"label.product.pricebooks.name":`ชื่อสมุดราคา`,
"label.relation.list.total":`เลือกทั้งหมด`,
"label.step2.total7":`ขั้นตอนที่ 2 จาก 7`,
"label.martrixreport.2018.step6.new":`ขั้นตอนที่ 6: เลือกประเภทกราฟและสิ่งที่รายงานจะแสดง`,
"label.standard.buttonandlink.override":`เขียนทับ`,
"front-console-conversation-btn4":``,
"vue_label_dashboard_range":`ช่วง`,
"label.app.sort.show":`แอปพลิเคชันจะเรียงลำดับตามการบันทึก`,
"label.salescloud.teamrole.choose.correct":`เลือกผู้ใช้ซ้ำกัน โปรดแก้ไข`,
"label.schedule_post":`โพสต์`,
"front-kefu-moudle-server-request-num":``,
"label.h5.logout":`ออกจากระบบ`,
"label.weixin.horse.club.member.message":`ข้อมูลสมาชิก aid-max`,
"label.field.addoptionlist.introduce":`เพิ่มค่ารายการตัวเลือกหนึ่งค่าหรือมากกว่าที่ด้านล่าง แต่ละค่าควรอยู่ในแถวของตัวเอง`,
"setup_layout_label_setupfield":`ตั้งค่าคุณสมบัติฟิลด์`,
"label.chatter.nextStep":`ขั้นตอนถัดไป`,
"label.quickbooks.searchlist.total1":`มีบันทึกการออกใบแจ้งหนี้ {0} รายการที่ไม่เกี่ยวข้องกับการค้นหา และยอดรวมคือ {1}`,
"label.tianyancha.h5.regcapital":`ทุนจดทะเบียน`,
"label.icon.184":`ปรึกษา`,
"label.dashboard.message.refreshtoomush":`สแนปช็อตแดชบอร์ดถูกรีเฟรชบ่อยเกินไป โปรดรีเฟรชในภายหลัง`,
"label.umeng.approval.reject":`#approverได้ปฎิเสธคำร้อง#obj`,
"label.h5.chatter.newmessage":`กรุณาใส่ข้อความใหม่`,
"message.error.relationid":`relationid ไม่สามารถว่างเปล่า!`,
"label.setup.mobile.offlinecache.selectdefault":`เลือกเปิดการใช้งานเมนูออฟไลน์เริ่มต้น`,
"label.setup.mobile.homepageshortcuts.saveprompt":`กรุณาเลือกฟังก์ชันทางลัด 4 ฟังก์ชัน`,
"label.projectManagement.Selectmonth":`เลือกเดือน`,
"label.version.ultimate":`รุ่นอัลติเมต`,
"label.validate.remark5":`ฟิลด์วันที่บังคับต้องอยู่ในลำดับเวลาที่ถูกต้อง เช่น วันเริ่มต้นต้องน้อยกว่าวันสิ้นสุด`,
"label.version.nowis":`CloudCC รุ่นปัจจุบันของคุณคือ`,
"front-kefu-moudle-CRM-set":``,
"label.mr.title.customerAddress":`ที่อยู่ลูกค้า`,
"label_emailtocloudcc_step1_name":`เลือกฟังก์ชัน`,
"label.time.operation.edit":`แก้ไขงานที่ต้องกำหนดเวลา`,
"label_tabpage_operationz":`ฟิลด์ และการดำเนินการไม่สามารถว่างเปล่า`,
"label.translation.start4":`คลิกสองครั้งที่คอลัมน์การแปลเพื่อป้อนค่าใหม่`,
"vue_label_systemSettings_request":`คำขออนุมัติการโอนแบบกลุ่ม`,
"label.maintenance.notice":`ประกาศการบำรุงรักษาประจำวัน`,
"label.customfields.txet.textlength.tip":`การป้อนฟิลด์ข้อความด้านล่างความยาวของฟิลด์ข้อความต้องไม่เกิน 255`,
"label.ccdocument.select.template.open":`โปรดเลือกแม่แบบที่จะเปิด`,
"vue_label_display_date_field":`แสดงฟิลด์วันที่`,
"label_partner_workspace_tab":`แท็บ`,
"lable.account.LasthDays":`120 วันที่ผ่านมา`,
"chatter.using.sticker":`เปิดใช้งานการติดตามเวยเทีย`,
"message.save.dataerror":`ข้อผิดพลาด: เกิดข้อผิดพลาดในการบันทึกเนื่องจากข้อมูลยาวเกินไปหรือปัญหาอื่นๆ โปรดแก้ไขข้อมูลและบันทึกอีกครั้ง`,
"vue_label_commonobjects_view_chart_newchart":`แผนภูมิใหม่`,
"label.chat.micropost.a.group":`กลุ่ม`,
"lable.currencyManage.advcurrencyunEnabled":`ปิดใช้งานการจัดการสกุลเงินขั้นสูงแล้ว`,
"label.appexchange.workflow":`กฎเวิร์กโฟลว์`,
"vue_label_calendar_show_details_and_add_events":`แสดงรายละเอียดและเพิ่มอิเวนต์`,
"label.salescloud.optionlist.inputname":`ใส่ชื่อค่ารายการตัวเลือกด้านล่าง`,
"label.dashboard.folder":`โฟลเดอร์แดชบอร์ด`,
"label.knowledgebase.permanently.remove.articles":`การลบบทความที่เก็บถาวรจะลบบทความและฉบับที่เกี่ยวข้องทั้งหมดออกจากคลังความรู้อย่างถาวร`,
"label.emailtocloudcc.titel":`Email to CloudCC`,
"label.visualpage.sel":`เพจที่กำหนดเองในโฟลเดอร์นี้`,
"label.planned.all.work":`งานที่วางแผนทั้งหมด`,
"label.weixin.agree.agreement":`ยอมรับข้อตกลงที่เกี่ยวข้อง`,
"label.forecast.customforecast.qsn":`ปีเริ่มต้น`,
"label.appupload.managed":`มีการจัดการ`,
"template.report.folder.sale.index":`การวิเคราะห์ดัชนียอดขาย`,
"UG_opportunity_011":`นำเข้าการเสนอขาย`,
"label.validate.function.funcFormat.SECOND":`SECOND(date)`,
"UG_homepage_005":`ระบบการขายอัจฉริยะ`,
"label.clicktoreturn":`คลิกที่นี่เพื่อย้อนกลับ`,
"label.collectionofview":`ชุดมุมมอง`,
"com.cloudcc.login.error.message.nonuser":`ไม่พบผู้ใช้`,
"vue_label_systemSettings_emailsetting":`การตั้งค่าอีเมล`,
"vue_label_email_mark_as":`ติดป้ายว่า`,
"label.tabpage.customernamez":`ชื่อลูกค้า`,
"label.appupload.install.apicannotsame":`ชื่อ api ใหม่ต้องไม่เหมือนเดิม`,
"label.task.all.undealt":`ภารกิจที่ยังไม่ได้จัดการทั้งหมด`,
"front-lightning-module-v1-dashborad-statistical-indicators":`ตัวชี้วัดทางสถิติ`,
"UG.quota.02":`ใบเสนอราคาเป็นข้อกำหนดทางกฎหมายที่เกี่ยวกับการเสนอขายผลิตภัณฑ์ที่ระบุในเวลาที่กำหนดและในราคาที่กำหนดระหว่างลูกค้าและซัพพลายเออร์`,
"label.approve":`อนุมัติ`,
"vue_label_calendar_remove_calendar":`ลบปฏิทิน`,
"label.mr.title.contactName":`ชื่อผู้ติดต่อ`,
"label.projectManagement.resource":`การจัดการทรัพยากร`,
"label.rejectbehaviour1":`อนุญาตให้ผู้อนุมัติเลือกว่าจะกลับไปขั้นตอนใด (กลับไปยังขั้นตอนที่ N)`,
"label.publicgroup.relationship":`กลุ่มสมาชิกสัมพันธ์`,
"Lead.Scoring.DetailedPage.Popup.Title":`ข้อมูลเชิงลึกของลีด`,
"label.owner.edit":`แก้ไขเจ้าของ`,
"label.campaign.channel.ticket.mark":`หมายเหตุ: บันทึกรหัสคิวอาร์ลงในอัลบั้มรูปภาพ โดยการถ่ายภาพหน้าจอของโทรศัพท์มือถือ หรือบันทึกรหัสคิวอาร์ลงในโทรศัพท์มือถือและเข้างานกิจกรรมด้วยรหัสคิวอาร์นี้`,
"label.opportunity.setting.showstage.info":`ให้พื้นที่ทางลัดของสเตจของโอกาสทางธุรกิจแสดงบนหน้ารายละเอียดบนอุปกรณ์มือถือหรือไม่`,
"label.emailobject.wizard.desc3":`ใช้แม่แบบอีเมลประหยัดเวลาได้มาก`,
"label.cpq.quote.no.product.add":`ใบเสนอราคายังไม่มีผลิตภัณฑ์ กรุณาเพิ่มผลิตภัณฑ์ก่อนสร้างใบสั่งซื้อ`,
"label.customer.tab":`แท็บที่กำหนดเอง`,
"Opportunity_Detailed_Phase_Label_Popup_002":`วันที่ออก`,
"component_telerecord_label_name":`ชื่อ`,
"label_component_helper_nodata":`ไม่มีเรื่องที่ต้องระวังในขณะนี้ กรุณาตรวจสอบภายหลัง`,
"label.dashboardSetup.d2":`ค่าเบรกพอยต์ 2`,
"setup.mainpage.label.welcome4":`คําแนะนําการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าแอปพลิเคชัน → สร้าง→ออบเจ็กต์`,
"label.step4.total5":`ขั้นตอนที่ 4 จาก 5`,
"label.payment.the.remaining.days":`บัญชีของคุณเหลืออีก {0} วัน`,
"label.encoding":`การเข้ารหัส`,
"label.setting.intergrationlist.status2":`กำลังติดตั้งการเชื่อมต่อนี้`,
"label.new":`ใหม่`,
"label.search.searchsetup":`การตั้งค่าการค้นหา`,
"label_tabpage_printz":`พิมพ์`,
"report.type.label.customService":`การสนับสนุนลูกค้า`,
"label.notification.addEmailObject.message":`คุณมีอีเมลจาก{!fromaddress} โปรดคลิกเพื่อดู`,
"label.icon.68":`เครื่องจักร`,
"UG.Lead.003":`โซเชียล`,
"label_mobile_default_field_service_home":`หน้าแรก Service Cloud`,
"label.select.one.group":`โปรดเลือกกลุ่มบรรทัดใบเสนอราคาอย่างน้อยหนึ่งกลุ่ม!`,
"front-kefu-moudle-trkey-nopower":``,
"label.chatter.cancel":`ยกเลิก`,
"label.weixin.report.optiondisplay":`แสดงตัวเลือกรายงาน`,
"front-kefu-moudle-v1-System-version":``,
"lable.product.pricebooks.editall":`แก้ไขทั้งหมด`,
"label.group.no.recent3":`หรือ`,
"label.knowledge.article.delete":`เกิดข้อผิดพลาดในการลบบทความความรู้`,
"label.relateobj":`รายการที่เกี่ยวข้อง`,
"workflow.action.tasks.assignortype.type":`ประเภท`,
"label.layout.selectedfields":`เลือกฟิลด์`,
"label.role.assign.operate":`เมื่อต้องการกําหนดผู้ใช้อื่นให้กับบทบาทนี้: <br><ul><li>เลือกจากรายการแบบดึงลงเพื่อแสดงผู้ใช้ที่มีอยู่ </li><li>เลือกผู้ใช้จากด้านซ้ายและเพิ่มลงในรายการ <b>ผู้ใช้ที่เลือก</b> </li></ul>`,
"label.field.insert":`แทรกฟิลด์`,
"label.icon.11":`คน`,
"label.group.no.recent4":`สร้างกลุ่ม`,
"front-epwechat-module-v1-input-corpid":`กรุณาป้อน Corpld`,
"setup_object_field_dependency_label_actionfieldnotnull":`โปรดเลือกฟิลด์ควบคุมสำหรับการตั้งค่าก่อน`,
"setup.mainpage.label.welcome19":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าการจัดการ → จัดการผู้ใช้ → ผู้ใช้ บทบาท โปรไฟล์`,
"label.escalation.setup.list.rulename":`ชื่อเกณฑ์`,
"label.ems.addaccount":`เพิ่มบัญชีทันที`,
"label.reportsSubscription.details.only":`รายละเอียดเท่านั้น (รูปแบบ Excel .xlsx)`,
"vue_label_commonobjects_view_groupby":`จัดกลุ่มตาม`,
"label.email.form.text":`ข้อความเท่านั้น`,
"label.weixin.loginname":`ชื่อผู้ใช้`,
"label.forecast.settings.sr":`รายได้`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0}เผยแพร่โพสต์ทั้งหมดในกลุ่ม{1}`,
"label.ccchat.enter.subject":`กรุณากรอกหัวข้อแบบสำรวจ`,
"label.customer.tab.introduce":`เมนูออบเจ็กต์แบบกําหนดเองจะมีลักษณะและฟังก์ชันการทํางานคล้ายกับเมนูมาตรฐานที่ระบบมี`,
"message.login.mfaverification.wrong":`รหัสความปลอดภัยไม่ถูกต้อง!`,
"component.newrecords.label.name":`ชื่อ`,
"label.salescloud.opportunity.addandedit.contactrole":`เพิ่มและแก้ไขบทบาทผู้ติดต่อ`,
"label_emailtocloudcc_button_next":`ขั้นตอนถัดไป`,
"label.console.step5":`ขั้นตอนที่ 5. เลือกวิธีการแสดงบันทึก`,
"setup.main2018.label.norole":`คุณไม่มีสิทธิ์ที่เกี่ยวข้องกับการจัดการระบบ`,
"template.chart.ywjhqd":`สเตจของโอกาสทางธุรกิจ`,
"label.instrumentPanel.breakpointOneLabelname":`ค่าต้องมากกว่าค่าต่ําสุด`,
"label.qrcode":`รหัสคิวอาร์`,
"label_tabpage_no2z":`ไม่ 2`,
"label.log.search.date.range":`ช่วงการสืบค้นต้องไม่เกิน {c} เดือน!`,
"label.console.step7":`ขั้นตอนที่ 7. กำหนดโปรไฟล์`,
"label.australian.central.standard.time":`เวลามาตรฐานกลาง (นอร์เทิร์นเทร์ริทอรี)`,
"label_tabpage_deleteviewfailed":`การลบมุมมองล้มเหลว`,
"vue_label_commonobjects_view_searchview":`ค้นหามุมมอง`,
"message.error.object.notexists":`ไม่พบออบเจ็กต์`,
"label.tablecell":`เซลล์`,
"vue_label_notice_edit_success":`การแก้ไขสำเร็จ`,
"label.customer.language":`ค่าเริ่มต้นภาษา`,
"label.csrf":`เปิดใช้งานการรักษาความปลอดภัยด้วย csrf`,
"label.forecast.customforecast.submit.zhi":`ถึง`,
"label.sso.saml.idp.config.desc2":`คลิก เปิดใช้งานผู้ให้บริการข้อมูลประจําตัว เพื่อเปิดใช้งาน CloudCC.com องค์กรในฐานะผู้ให้บริการข้อมูลประจําตัว`,
"label.export_data":`ส่งออกข้อมูล`,
"component.todaytask.label.all":`ดูทั้งหมด`,
"label.h5.chatter.record":`บันทึกการติดตาม`,
"front-vew-email-verification":`ตรวจสอบอีเมลและยืนยันบัญชี ดังที่คุณทราบ คุณสามารถเข้าสู่ระบบได้อีกครั้งหลังจากยืนยันอีเมลแล้วเท่านั้น`,
"laber.marketsea.del.error":`ฐานข้อมูลถูกใช้ ไม่สามารถลบได้`,
"vue_label_notice_homepage_entername":`กรุณาป้อนชื่อที่แก้ไข`,
"UG.Forcast.01":`การพยากรณ์`,
"front-email-payment-tips":``,
"setup.mainpage.label.welcome2":`ฐานข้อมูลที่กำหนดเอง (ออบเจ็กต์)`,
"APPIntegration.Social.facebookerror":`ต้องเป็น URL ของ facebook.com ที่ถูกต้องตามกฎหมาย`,
"label.profile.mobile.setup.stand":`หน้าแรกมาตรฐาน`,
"label.custom.CY":`ปีที่กำหนดเอง`,
"label.knowledgebase.publishing.conditions":`การเผยแพร่ข้อมูล {a} รายการล้มเหลว และไม่สามารถเผยแพร่ได้หากไม่ตรงตามเกณฑ์การเผยแพร่!`,
"label.tianyancha.description":`การเปิดใช้งานการทวนสอบข้อมูลธุรกิจเทียนเหยี่ยนฉา เมื่อผู้ใช้ป้อนข้อมูลลูกค้าองค์กรจะช่วยผู้ใช้กรอกข้อมูลการจดทะเบียนธุรกิจของลูกค้าได้อย่างถูกต้อง การบริการของเทียนเหยี่ยนฉาจะรองรับแค่ข้อมูลผู้ประกอบธุรกิจที่จดทะเบียนในจีนแผ่นดินใหญ่เท่านั้น`,
"label.appexchange.uninstallpage.title":`ถอนการติดตั้งโปรแกรมสำเร็จรูปนี้จะส่งผลให้:`,
"label.currencyRate":`อัตราแลกเปลี่ยน`,
"setup_layout_label_areashow":`ชื่อภูมิภาคแสดงตำแหน่งที่ตั้ง`,
"label.setup.case.setting":`มินิโปรแกรมสร้างเคส`,
"vue_label_commonobjects_view_fixed_at_most":`ปักหมุดได้มากที่สุดแค่ 3 คอลัมน์`,
"template.report.month.income":`รายได้เดือนนี้`,
"label.sms.companyname":`ชื่อบริษัท`,
"label.sendemail.registIMUser.waitmessage":`คุณไม่มีพอร์ทัลพาร์ทเนอร์คลาวด์ที่สามารถเข้าสู่ระบบได้ โปรดรอให้ผู้ดูแลระบบแจ้งให้คุณทราบภายหลัง ไปยังที่อยู่ที่กำหนดเพื่อเข้าสู่หน้าเข้าสู่ระบบ กรุณาใช้ชื่อผู้ใช้และรหัสผ่านข้างต้นในการเข้าสู่ระบบ`,
"label.custom.field.task.object":`สวัสดี! ตอนนี้มีหนึ่งภารกิจมอบหมายให้คุณ หัวข้อภารกิจ:`,
"message.pleaseselectdayinweek":`โปรดเลือกหนึ่งวันในสัปดาห์`,
"label.chat.topic.favorites":`รายการโปรด`,
"UG.Campaign.004":`นำเข้าแคมเปญ`,
"label.approval.preview":`แสดงตัวอย่างขั้นตอนการอนุมัติ`,
"label.knowledgebase.assign.articles.to.people.or.queues":`เลือกภาษาเป้าหมาย แล้วกำหนดบทความให้กับบุคคลหรือคิว การส่งออกการแปลมักจะถูกกําหนดให้กับคิว บทความที่แปลภายในมักจะกําหนดให้กับบุคคล`,
"pagecreator_systemstyle_message_save_success":`บันทึกรูปแบบสำเร็จ`,
"label.outline":`สรุป`,
"label.read.only.field":`ฟิลด์อ่านอย่างเดียว`,
"front-gantt-module-v1-early-warning":``,
"label.file.ccchat.selectfrompc":`เลือกไฟล์จากคอมพิวเตอร์ของคุณ`,
"vue_label_systemSettings_social":`โซเชียลมีเดีย`,
"label_report_year_last_year":`เทียบปีต่อปี`,
"lable.PowerProcess.Meet.the.conditions":`ต้องเป็นไปตามเงื่อนไขต่อไปนี้:`,
"label.changemydisplay.list.title":`เปลี่ยนการแสดงผลของฉัน`,
"UG_Forcast_03":`เริ่มวางแผนและดำเนินกลยุทธ์ทางธุรกิจ <br>ขอให้คุณมีความสุขกับการพยากรณ์!`,
"label.sendemail.chat.sendmessage":`#nameที่เคารพ:\n\n สวัสดี! #userName ส่งข้อความถึงคุณ`,
"label.huanxinconfig.secretid.lost":`secretid ต้องไม่ว่างเปล่า`,
"label.icon.49":`ผลิตกระแสไฟฟ้า`,
"chatter.feed.button.publish":`เผยแพร่`,
"label.power":`^ ยกกำลัง`,
"label.partnerCloud.financeSetting.informationThree":`3. หลังจากเข้าสู่อินเทอร์เฟซการจัดการคีย์แล้ว ให้คลิก [คีย์ผลิตภัณฑ์ MAPI Gateway] เพื่อรับไอดีของพาร์ทเนอร์และคีย์ MD5`,
"label.emailtocloudcc.step1.lead2":`หลังจากกำหนดค่า อีเมลที่ได้รับจะสร้างบันทึกลีดโดยอัตโนมัติ เพื่อให้แน่ใจว่าจะไม่พลาดโอกาสทางธุรกิจ`,
"label.knowledgebase.delete.draft.succeeded":`ลบฉบับร่างสำเร็จ`,
"label.dashboardSetup.title":`ตัวแก้ไขส่วนเสริม`,
"label.trigger.operation.email.template.map":`ส่งคืนข้อมูลแม่แบบ หัวเรื่องอีเมล: m.get("หัวเรื่อง"); เนื้อหาอีเมล: m.get("เนื้อหา"); ประเภทของอีเมลเป็นข้อความหรือไม่: m.get("istext")`,
"label.dependencesearchfilter":`ตัวกรองการสืบค้นที่เกี่ยวข้อง`,
"label.selected.search.length":`ฟิลด์ค้นหาที่เลือกต้องไม่เกิน 10 ฟิลด์`,
"label.profile.commonusercontrol":`สิทธิ์ผู้ใช้ทั่วไป`,
"lable.Microsoft.YaHei":`Microsoft Yahei`,
"label.appupload.component.type.app":`แอปพลิเคชัน`,
"label.customsetting.manage.position":`ตำแหน่ง`,
"vue_label_systemSettings_bindweb":`ผูกเว็บไซต์`,
"label.loginservice.license.notexist":`ไม่พบใบอนุญาต`,
"label.icon.43":`กระดิ่ง`,
"UG_homepage_003":`มุมมอง 360 องศา`,
"label.file_format":`รูปแบบไฟล์`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`วันอาทิตย์`,
"vue_label_chatter_post_has_delete":`โพสต์ถูกลบแล้ว`,
"report_label_searchresult":`ผลการค้นหา`,
"label.tabpage.justsz":`เพิ่งจะ`,
"Lead_Scoring_Setting_LevelSetting":`การตั้งค่าความนิยมของลีด`,
"setup.object.field.dependency.label.selectedfieldvalue":`ค่าฟิลด์ที่เลือก`,
"label.search.morelistview":`มุมมองรายการเพิ่มเติม`,
"vue_label_homepage_won":`ปิดการขายสำเร็จ`,
"label.notification.last30days":`เกือบ 30 วัน`,
"vue_label_helpcenter_pool":`ใช้ฐานข้อมูลลูกค้าและลีดเพื่อจัดการข้อมูลการขายของคุณ <br>ตั้งค่าฐานข้อมูล<br> สร้างฐานข้อมูลที่หลังบ้าน ตั้งค่าผู้ดูแลระบบและสมาชิกของฐานข้อมูล และกำหนดกฎการรีไซเคิลอัตโนมัติสำหรับสิ่งที่เกินกำหนด ซึ่งสะดวกในการจัดการติดตามโอกาสภายในทีมของคุณ และสนับสนุนให้สมาชิกในทีมติดตามผลอย่างแข็งขัน <br>จัดการข้อมูลด้วยตนเอง<br> ผู้ดูแลฐานข้อมูลสามารถดำเนินการ เช่น การแจกจ่าย การรีไซเคิล การทิ้ง และการถ่ายโอนบันทึกในฐานข้อมูล และจัดการบันทึกของฐานข้อมูลอย่างสม่ำเสมอ <br > สมาชิกฐานข้อมูลรับบันทึกที่ยังไม่ได้แจกจ่าย หรือดูบันทึกที่รับผิดชอบได้`,
"label.emailsync.status.export":`ส่งออกเป็นเอกสารรูปแบบ Excel_csv`,
"label.service.miniProgram.slideshowTitle":`ภาพสไลด์`,
"label.service.miniProgram.slideshowName":`ชื่อภาพสไลด์`,
"label.fieldupdate.selectobj":`เลือกออบเจ็กต์สำหรับอัปเดตฟิลด์นี้ และคลิกถัดไป "การอัปเดตฟิลด์จะเชื่อมโยงกับกฎเวิร์กโฟลว์และกระบวนการอนุมัติประเภทเดียวกันเท่านั้น"`,
"label.ccpeak.take.notice.sharetab":`หมายเหตุ: ไม่จำเป็นต้องเพิ่ม __c "!" ลงในฟิลด์นิพจน์ของตารางแบ่งปัน`,
"label.log.startdate.after.endate":`เวลาเริ่มต้นต้องไม่มากกว่าเวลาสิ้นสุด!`,
"label.rememberme":`จำชื่อผู้ใช้`,
"label.partner.all.maxNum":`ข้อมูลที่ใหญ่ที่สุดของพาร์ทเนอร์คลาวด์:`,
"component.setup.iframe.label.inputurl":`ใส่ที่อยู่ URL`,
"label.h5.systemmessage":`ข้อมูลระบบ`,
"label.delete.date":`ลบวันที่`,
"front-email-payment-select-month-tips":``,
"front-kefu-moudle-bind-userinfo":``,
"label.appointment.wizard.notif2":`คุณต้องตั้งค่าระยะเวลาการนัดหมายก่อนที่จะสร้างตารางการนัดหมาย`,
"label.custom.field.maping.number":`จำนวนลีดต้องไม่มากกว่าจำนวนฟิลด์ที่แม็ป`,
"label.event.dayview":`มุมมองรายวัน`,
"label.replace":`แทนที่`,
"label.knowledgebase.search.knowledge.articles":`ค้นหาบทความความรู้`,
"component_event_label_soon":`ทันที`,
"label.imgfield.upload":`อัปโหลดรูปภาพ`,
"message.printable.view":`มุมมองที่พิมพ์ได้`,
"vue_label_notice_uploadavatar_notice1":`รูปโปรไฟล์ที่อัปโหลดขนาดต้องไม่เกิน 2 MB`,
"label.visualpage.developer.help":`ช่วยเหลือนักพัฒนาเพจที่กำหนดเอง`,
"label.validate.function.funcFormat.IF":`IF(logical_test, value_if_true, value_if_false)`,
"label.sso.saml.sp.description1":`การตั้งค่า SSO`,
"vue_label_calendar_step_1":`ขั้นตอนที่ 1: ตั้งชื่อปฏิทินออบเจ็กต์`,
"component.telerecord.button.save":`บันทึก`,
"setup_mainpage_button_manageobject":`การจัดการออบเจ็กต์`,
"label.marketingactivityinfluence":`อิทธิพลจากแคมเปญ`,
"label.quote.bjjsxx":`ข้อมูลใบเสนอราคาที่ได้รับ`,
"label.appupload.upload.install.retry":`ติดตั้งใหม่`,
"label.layout.assignrules":`เกณฑ์การจัดสรร`,
"UG.Lead.006":`ผู้เข้าชมเว็บไซต์`,
"label.workmate.searchs":`ค้นหาเพื่อนร่วมงาน`,
"label.visualpage_list.no":`ไม่มีสิทธิ์ในการเข้าถึงเพจที่กำหนดเอง`,
"label.service.miniProgram.slideshowintroduce":`ชื่อภาพสไลด์ใช้เพื่อระบุรายการโฆษณาเท่านั้น จะไม่แสดงในโฆษณา`,
"label.multilang.messagedetail.search.desc":`เราไม่พบข้อความที่มี{0}:`,
"label.mobile.phone.read.note":`กรุณาใส่หมายเหตุที่นี่`,
"label.passwordPolicy.setup.isUsingGotp":`เปิดใช้งานการเข้าสู่ระบบหลายบัญชี`,
"message.datetypeerror":`<strong>ข้อผิดพลาด：</strong>ใส่วันที่ไม่ถูกต้อง`,
"label.searchlayout.listview.button":`ปุ่มที่แสดงในมุมมองรายการ`,
"label.sectionpart":`ส่วน`,
"label.partnerCloud.basicSetting.userSetting":`การตั้งค่าบทบาทและผู้ใช้`,
"System_Data_Import_Warning_MaxCount":`องค์กรของคุณสามารถนำเข้าข้อมูลได้ครั้งละ {0} รายการเท่านั้น ตอนนี้ข้อมูลเกินแล้ว กรุณาปรับเปลี่ยนและนำเข้าอีกครั้ง`,
"label.datamove.qualified.record":`สามารถโอนบันทึกที่สอดคล้องกับเงื่อนไขได้สูงสุด 100 รายการต่อครั้ง!`,
"component_task_label_priority":`ลำดับความสำคัญ`,
"vue_label_report_me":`ฉัน`,
"label.college.duplicate.option":`ตัวเลือกซ้ำไม่ได้!`,
"label.pw.letter":`ตัวอักษร`,
"label.file.sharedwithme":`แบ่งปันกับฉัน`,
"label.translation":`แปล`,
"lable.currencyAdv.exchagecurrency.before":`ก่อน`,
"label.file.share":`แบ่งปัน`,
"label.page.next":`หน้าถัดไป`,
"label.autoRegister.changepwd.setpwd.notmatch":`รหัสผ่านสองครั้งไม่ตรงกัน`,
"label.tabpage.include":`รวม`,
"front-email-payment-thanks":``,
"vue_label_help_helponthispage":`ความช่วยเหลือในหน้านี้`,
"label.approvepagelayout":`อนุมัติเค้าโครงเพจ`,
"vue_lightning_help_zero_distance_communication":`ประหยัดเวลาด้วยการเปิดขอการสนับสนุนออนไลน์และสื่อสารทางไกลกับผู้เชี่ยวชาญด้านบริการ CloudCC`,
"vue_label_normal_case_sf":`เคส`,
"label.report.line.tuozhuai":`กรุณาลากวางหรือดับเบิลคลิกเมาส์เพื่อเลือกคอลัมน์รายงานและปรับลำดับคอลัมน์`,
"template.dashboard.management":`การบริหารการปฏิบัติการ`,
"label.customcomponent.params.info.n1":`ใช้ค่า args ในป้ายกำกับ component โดยให้ args อยู่ในรูปแบบ json เช่น : args="name:'zhang',age:26", ใน cc code block ใช้ String myName = name; int myAge = age;`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`อัตราข้อผูกมัดที่ทำสัญญา`,
"label.add.status":`เพิ่มสถานะ`,
"label.loss.customers":`สิ้นสุดแล้ว/เสียลูกค้า`,
"vue_label_chatter_involving_me":``,
"label.update.input":`กรุณาแก้ไขข้อมูลที่ป้อน`,
"label.import.step1.commonobj":`ออบเจ็กต์ที่ใช้บ่อย`,
"label.appupload.upload.tips.document":`หมายเหตุ: ไฟล์ที่อยู่ใน "โฟลเดอร์ส่วนตัวของฉัน" และ "โฟลเดอร์แม่แบบตัวหนังสือสีแดง" ไม่สามารถเพิ่มลงในโปรแกรมสำเร็จรูป และไม่สามารถแสดงในรายการนี้ได้`,
"label.appupload.install.complete":`สำเร็จ`,
"label.console.edit":`แก้ไขคอนโซล`,
"setup.object.field.dependency.label.removefromlist":`ลบค่าที่เลือก`,
"label.textmessage.groupsms.no.phone":`ไม่มีหมายเลขโทรศัพท์`,
"label.account.Current.and.NextFQ":`ไตรมาสงบประมาณนี้และถัดไป`,
"label.sso.saml.sp.idtype.userid":`คำสั่งประกอบด้วย ID ผู้ใช้จากออบเจ็กต์ผู้ใช้`,
"label.data.import.setup.operate.update":`อัปเดตบันทึกที่มีอยู่โดยไม่แทรกบันทึกใหม่ใดๆ เข้าไป`,
"front-kefu-moudle-v1-jcaws-call-serve":``,
"label.version.bacheditordel":`แก้ไข/ลบ/ย้าย แบบกลุ่ม`,
"lable.even.higher":`สูงกว่า`,
"label.datetime.error":`รูปแบบวันที่ไม่ถูกต้อง`,
"vue_label_commonobjects_detail_customer_hierarchy":`ลำดับชั้นของลูกค้า`,
"label.startuploadfile":`เริ่มอัปโหลด`,
"label.appointment.wizard.subtitle3-1":`วันจันทร์`,
"label.weixin.relevance":`โอกาสทางธุรกิจที่เกี่ยวข้อง`,
"label.datamanage.field.mapping.information":`การตั้งค่าการแม็ปฟิลด์`,
"label.brief.lastweek":`สัปดาห์ที่แล้ว`,
"label.nextstep":`ขั้นตอนถัดไป`,
"label.listtoshow":`รายการต่อไปนี้แสดงรายการ{0}`,
"label.partner.ishave":`ข้อผิดพลาด: มีชื่อโดเมนนี้แล้ว`,
"label.service.miniProgram.name":`กรุณากรอกชื่อ`,
"label.view.filterbyaddition":`กรองตามฟิลด์เพิ่มเติม (ตัวเลือก):`,
"label.projectManagement.nodata.task":`ยังไม่มีบันทึกของงาน มาเพิ่มข้อมูลงานกันเถอะ`,
"label.chooseemailtemplate":`เลือกแม่แบบอีเมล`,
"label.page.step4.add.profile":`ขั้นตอนที่ 4: เพิ่มลงโปรไฟล์`,
"label.ems.mailtype":`ประเภทอีเมล`,
"label.weixin.no.pending.projects.vg":`เยี่ยมมาก ไม่มีโครงการรออนุมัติ`,
"label.tabpage.saveviewfailed":`การบันทึกมุมมองล้มเหลว`,
"label.chat.file.upload.cancel":`ยกเลิกการอัปโหลด`,
"com.cloudcc.login.error.message.notenabled":`ผู้ใช้ปิดการใช้งาน`,
"label.data.import.setup.operate.insertandupdate":`อัปเดตบันทึกที่มีอยู่และแทรกบันทึกใหม่`,
"label_target_type":`ประเภทเป้าหมาย`,
"label.notification.event2":`[ผู้ได้รับมอบหมาย]ดูอิเวนต์ที่คุณมอบหมายให้แล้ว`,
"chatter.feed.menutype.feed.news":`เนื้อหาที่ฉันติดตาม`,
"label.import.page1.suitedwayofcustomer":`วิธีการจับคู่ลูกค้า`,
"label.import.page2.CloudCCfiled":`ฟิลด์ CloudCC`,
"label.custom.quarter.start":`วันเริ่มต้นไตรมาสที่กำหนดเอง`,
"label.page.including.tab":`รวมแท็บ`,
"label.mobile.phone.day.plan2":`แผนของวันนี้`,
"template.report.lead.conversion.statistics":`สถิติการข้ามสเตจของลีด`,
"label.show.type":`ประเภทการแสดงผล`,
"label.weixin.no.pending.wdgz.qin.week":`สัปดาห์นี้ไม่มีงานที่ได้รับมอบหมาย`,
"2018UI.Homepage.DataDeleted.Info":`ข้อมูลถูกลบแล้ว คลิกเพื่อกลับไปขั้นตอนก่อนหน้า`,
"label.vlidaterule.message":`ข้อมูลที่ผิดพลาด`,
"label.approval.remark":`ความเห็นการอนุมัติ`,
"label.field.duplicate1":`ไม่ซ้ำ`,
"label.batchtransfer":`โอนแบบกลุ่ม`,
"label.quickbooks.view.allinvoices":`Invoices ทั้งหมด`,
"vue_label_commonobjects_detail_lead_selectedstatus":`ทำเครื่องหมายว่าเลือกแล้ว`,
"label_home_page_source":`กรุณาเลือกแหล่งข้อมูล`,
"front-kefu-moudle-v1-opencall-please":``,
"setup_layout_label_asc":`เรียงจากน้อยไปมาก`,
"label.use_tikect":`ใช้บัตรเข้างาน?`,
"label.tag.setup":`การตั้งค่าป้ายกำกับ`,
"label.existinglayout":`เค้าโครงเพจที่มีอยู่`,
"label.productsales.today.noevt":`วันนี้ไม่มีอิเวนต์ที่ยังไม่ได้ดำเนินการ!`,
"message.error.view.date.validerr":`ใส่รูปแบบวันที่ที่ถูกต้อง (YYYY-MM-DD, MM / DD / YYYY) หรืออักขระวันที่พิเศษ`,
"label.mr.descreption.oneGroupReData3":`ได้จัดการข้อมูลซ้ำแล้ว`,
"label.tianyancha.businessverify.msg1":`ในการเปิดใช้งานฟังก์ชันการทวนสอบข้อมูลทางธุรกิจ ผู้ใช้ควรอ่านและทำความเข้าใจข้อกำหนดใน "ข้อตกลงการอนุญาตใช้สิทธิ์" นี้อย่างละเอียด (ต่อไปนี้จะเรียกว่าข้อตกลง) รวมถึงข้อยกเว้นสำหรับ Beijing CloudCC.com Technology Co.,ltd. จากความรับผิด (ต่อไปนี้จะเรียกว่า CloudCC) และข้อกำหนดเกี่ยวกับสิทธิของผู้ใช้ โปรดอ่านอย่างละเอียดและเลือกที่จะยอมรับหรือไม่ยอมรับ "ข้อตกลง" นี้`,
"label.custom.CQ":`ไตรมาสที่กำหนดเอง`,
"label.version.custom.dashboard":`แดชบอร์ดมาตรฐาน (เพจที่กำหนดเอง)`,
"vue_label_commonobjects_detail_dragtoupload":`ลากไฟล์มาที่นี่ หรือ<em>คลิกอัปโหลด</em>`,
"label.tabpage.addadvancedoptions":`เพิ่มตัวเลือกขั้นสูง`,
"front-kefu-moudle-v1-Launch-page":``,
"label.emailobject.tabname":`อีเมล`,
"label.weixin.addmore":`เพิ่มเติม`,
"message.error.view.operator.validerr":`ตัวดำเนินการที่ไม่รองรับ`,
"label.another_page":`เปลี่ยนเส้นทางไปยังหน้าอื่น`,
"label.reportTypeFocusD2":`ตัวอย่าง: หากรายงานเกี่ยวกับผู้ติดต่อของโอกาสทางธุรกิจของพาร์ทเนอร์"`,
"label.icon.47":`บารอมิเตอร์`,
"label.task.today":`ภารกิจวันนี้`,
"label.service.gantt.weekend.highlight":`ไฮไลต์สุดสัปดาห์`,
"label.customcomponent.referencetagname":`ชื่อป้ายกำกับ`,
"label.senderemail":`ที่อยู่อีเมลผู้ส่ง`,
"label.defaultvalue":`ค่าเริ่มต้น`,
"label_tabpage_Sdfez":`วันก่อน`,
"pagecreator.page.label.pagename":`ชื่อหน้าเพจ`,
"vue_label_report_pagenumber":`ค่าเลขหน้าในช่วง`,
"label.emailsync.connectaccount.description":`เพิ่มที่อยู่อีเมลส่วนตัวของคุณที่นี่ ระบบจะจับคู่ลีดและผู้ติดต่อในระบบโดยอัตโนมัติตามที่อยู่รับส่งอีเมล และทำการซิงค์เนื้อหาในอีเมลกับบันทึกนี้ เพื่อความสะดวกในการติดตามความคืบหน้าในการสื่อสารกับลูกค้า`,
"label.schedulableprg.chooseweek":`โปรดเลือกวันของสัปดาห์ถัดไป`,
"lable.edit.queue.membercanuse":`สมาชิกที่พร้อมใช้งาน`,
"lable.Quick.find":`ค้นหาอย่างรวดเร็ว`,
"label.daynuminmonth":`วันที่   ของเดือน`,
"message.error.state":`state ไม่สามารถว่างเปล่า!`,
"label.introduction.the.form":``,
"label.batchtransfer.pleaseselectcomefromuser":`กรุณาเลือกโอนจากผู้ใช้`,
"front-dashboard-module-implemented":`ดําเนินการ`,
"label.custombutton.newerror":`การสร้างล้มเหลว`,
"label.version.allow.size":`, เกินขีดจำกัดแล้ว! หากมีความจำเป็น กรุณาอัพเกรดรุ่น cloudcc!`,
"label.weixin.account.loginpage":`หน้าเข้าสู่ระบบอย่างปลอดภัยของลูกค้า`,
"message.pleaseselectfieldtype":`กรุณาเลือกประเภทฟิลด์`,
"component.setup.label.parentobject":`ออบเจ็กต์พาเรนต์`,
"System.TAB.SeeViewAmount":`ดูจำนวนรวม`,
"label.event.lastmonth":`เดือนที่แล้ว`,
"label.taskrecordtype":`ประเภทบันทึกภารกิจ`,
"label.layout.selectedpages":`เลือกหน้าเพจ`,
"label.appointmentdetail.wizard.title19":`แผนงานวันเสาร์`,
"label_chatter_endData":`วันที่สิ้นสุด`,
"label.appupload":`โปรแกรมสำเร็จรูป`,
"label.knowledgebase.article.link":`เชื่อมโยงบทความ`,
"label.licence.enddate":`วันหมดอายุใบอนุญาต`,
"chatter.fieldtrack.record":`บันทึก`,
"label.reportsSubscriptionPage.schedulereport.weekly":`ทุกสัปดาห์`,
"label.forecast.editshrepage.title2":`แก้ไขการแบ่งปัน`,
"label.attendance.onwork.time":`เวลาเข้างาน`,
"label.appointment.wizard.subtitle1-8":`3 ชั่วโมง`,
"pagecreator.layout.button.upload":`อัปโหลดเค้าโครง`,
"label.input.notless.than.number":`กรุณาใส่หนึ่งตัวเลขที่มากกว่าหรือเท่ากับ {0}`,
"setup.mainpage.label.welcome13":`คำแนะนำการใช้งาน: คลิกที่เมนูด้านบน → รายงาน → สร้างใหม่`,
"label.forecast.settings.data.opp":`วันที่ปิดโอกาสทางธุรกิจ`,
"vue_label_display_checkbox_field":`แสดงฟิลด์กล่องกาเครื่องหมาย`,
"label.summaryreport.2018.step5":`ขั้นตอนที่ 5: เลือกประเภทแผนภูมิและไฮไลต์รายงาน`,
"front-lightning-module-v1-dashborad-one-statistic":`กรุณาเลือกอย่างน้อยหนึ่งสถิติและประเภทสถิติ`,
"label.home.standard.dashboard.forcase":`คุณไม่ได้ตั้งค่าสิทธิ์การพยากรณ์ ดูคัมบังข้อผูกมัดการขายไม่ได้`,
"page.field.track":`การติดตามฟิลด์`,
"label.dataimport.format.datetime.error":`รูปแบบไม่ถูกต้อง โปรดใช้รูปแบบ yyyy / MM / dd HH: mm: ss หรือ yyyy-MM-dd HH: mm: ss`,
"lable.opppdt.selPbk.title":`เลือกสมุดราคา`,
"pagecreator_systemstyle_label_stylename":`ชื่อรูปแบบ`,
"label.projectManagement.nodata.project":`ไม่พบข้อมูลที่เกี่ยวข้อง รีบมาสร้างโครงการที่เกี่ยวข้องกับฉันกันเถอะ`,
"label.start_below":`เริ่มแบ่งปันฟอร์มกับผู้ติดต่อ ฟอร์มของคุณได้รับการเผยแพร่อย่างปลอดภัยและสามารถใช้ได้ที่ URL ต่อไปนี้`,
"label.campaignmember.main.delete":`ลบสมาชิกแคมเปญแบบกลุ่ม`,
"label.modifyall":`แก้ไขทั้งหมด`,
"label.homepage":`หน้าแรก`,
"vue_label_pool_adoptedbyme":`ที่ฉันรับไว้`,
"label.email.clearItem":`ล้างเฉพาะอีเมลที่มีไม่รายการที่เกี่ยวข้อง`,
"label.callcenter.login.Amazon.connect":``,
"label.import.page1.selectimportfiled":`เลือกไฟล์ที่ต้องการนำเข้า`,
"message.error.id":`id  ไม่สามารถว่างเปล่า!`,
"label.ggReleaseRange.searchUsers":`ค้นหาผู้ใช้พาร์ทเนอร์`,
"label.changemypwd":`เปลี่ยนรหัสผ่านของฉัน`,
"label.ccpeak.reference.parameters":`พารามิเตอร์ที่สามารถอ้างอิงได้โดยตรงคือ:`,
"chatter.share.success.tip":`สำเร็จ! คุณได้แบ่งปันโพสต์นี้ไปที่`,
"label.message.checkfailed":`การตรวจสอบไวยากรณ์ล้มเหลว ชื่อคลาสนี้ถูกใช้แล้ว!`,
"label.shangqing.introduction":`รวมการวิเคราะห์อิเวนต์ที่กำลังเป็นที่นิยมของลีดหรือลูกค้าเพื่อช่วยให้พนักงานขายเข้าใจลูกค้าได้รอบด้านมากขึ้น`,
"label.allemailnotice":`การแจ้งเตือนอีเมลทั้งหมด`,
"vue_label_report_copy":`คัดลอกรายงาน`,
"label.exchange.sync.state.setting":`ปรับแต่งการตั้งค่า`,
"label.merge.result.error1":`บันทึกต่อไปนี้ถูกล็อก ไม่อนุญาตให้ "ผสาน"`,
"label.process.des":`หากต้องการดูข้อมูลโดยละเอียดของบันทึกปัจจุบัน โปรดคลิกลิงก์ทางด้านซ้าย`,
"label.textmessage.vonage.create.lead.setting":`เมื่อได้รับข้อความสั้นที่ระบบไม่มีหมายเลขโทรศัพท์ให้สร้างลีดใหม่`,
"label.views":`ยอดวิว`,
"label.notification.tip1":`คุณไม่มีการแจ้งเตือนใดๆ ในขณะนี้`,
"label.forecast.detailforecast.returnforecast":`ส่งคืนการพยากรณ์`,
"label.knowledgebase.target.framework.name":`ชื่อเฟรมเวิร์กเป้าหมาย`,
"label.brief.close.opportunities":`จำนวนโอกาสที่ปิดการขายสำเร็จ`,
"label.appointment.wizard.subtitle4-2":`เวลาแจ้งเตือนกำหนดการล่าสุด`,
"vue_label_systemSettings_set_record":`กำหนดรูปแบบการแสดงรายการที่เกี่ยวข้องของรายละเอียดบันทึก คุณสามารถสลับระหว่างรูปแบบการ์ดและแบบรายการ`,
"pagecreator_page_message_publish_fail":`การเผยแพร่หน้าเพจล้มเหลว`,
"vue_label_homepage_name":`ชื่อหน้าแรก`,
"label.weixin.no.pending.wdgz.qin.month":`ไม่มีตารางการทำงานของสัปดาห์นี้`,
"label.campagin.register.page":`หน้าเพจลงทะเบียบสมาชิกแคมเปญ`,
"label.campaign.channel.edit":`แคมเปญ: แก้ไขช่องทางการขาย`,
"label.folder":`โฟลเดอร์`,
"label.umeng.chatter.follow":`ติดตามคุณ`,
"label.sso.theKeyToEdit":`การแก้ไขคีย์`,
"label.deletelayout":`ลบเค้าโครงเพจ`,
"label.same.analyze.miaoshu":`ความสัมพันธ์ตามเงื่อนไขข้างต้น คือ: "ชื่อโอกาสทางธุรกิจ" หรือ "ชื่อลูกค้า" หรือ ("เบอร์โทรศัพท์ผู้ติดต่อ" และ "อีเมลผู้ติดต่อ");`,
"label.ccpeak.sel":`คลาสในโฟลเดอร์นี้`,
"label.tabpage.addtoworkbench":`เพิ่มไปยังเวิร์คแบนซ์`,
"label.forecast.shrepage.classdes.r":`อ่านอย่างเดียว - ผู้ใช้จะสามารถดูข้อมูลที่พยากรณ์`,
"homepage.custompagename":`ชื่อหน้าแรกที่กำหนดเอง`,
"label.sendemail.batchapprovalinfo":`#name สวัสดี: \ r \ n การอนุมัติแบบชุดที่คุณดำเนินการเสร็จสิ้นแล้ว โดยอนุมัติสำเร็จ #successnum รายการ และอนุมัติล้มเหลว #errornum รายการ`,
"front-email-payment-Invoice-alipay-describe":``,
"setup.object.field.dependency.label.configured":`เนื้อหาที่ปรับแต่งแล้ว`,
"label.potentialcustomers":`ลีด`,
"label.timetrigger.button":`ปุ่มเพิ่มเวลาทริกเกอร์จะใช้ไม่ได้ในสถานการณ์ต่อไปนี้ :`,
"label.category.10":`ทนาย`,
"label.selectall":`เลือกทั้งหมด`,
"message.field.id.not.null":`ID ฟิลด์ไม่สามารถว่างเปล่า`,
"CloudCCCRM.ST.Info.TypeIn.001":`โปรดระบุ`,
"label.author":`ผู้เขียน`,
"label.import.step1.csvonly":`1. รองรับเฉพาะไฟล์รูปแบบ csv นำเข้าบันทึกได้มากที่สุด{{recordnumlimit}} รายการ（<span?style="color:?red">หากต้องการเรียกใช้ทริกเกอร์จะนำเข้าได้สูงสุด 2,000 รายการ</span>）บันทึกที่เกินขีดจำกัดระบบจะละเว้นการนำเข้าโดยอัตโนมัติ หากต้องการนําเข้าข้อมูลเพิ่มเติมให้แยกไฟล์ออกเป็นหลายไฟล์ก่อนแล้วจึงนําเข้าเป็นส่วนๆ`,
"label.assignment.setup.newrule.name":`ชื่อเกณฑ์`,
"label.campaignmember.selectmember.chosestatusdesc":`โปรดเลือกแคมเปญที่คุณต้องการเพิ่มสมาชิกและระบุสถานะของสมาชิก หากต้องการสร้างแคมเปญใหม่ คุณต้องออกจากกระบวนการนี้`,
"label_tabpage_operation":`การดำเนินการ`,
"label_tabpage_datatyoez":`ประเภทข้อมูล`,
"UG_product_04":`สร้างผลิตภัณฑ์`,
"label_emailtocloudcc_step1_case2":`หลังจากการกำหนดค่า อีเมลที่จะได้รับจะสามารถสร้างเคสได้โดยอัตโนมัติ และจะจับคู่ผู้ติดต่อและลูกค้าในกล่องขาออก ทั้งจะแขวนเคสไว้กับลูกค้าและผู้ติดต่อที่เกี่ยวข้องเพื่ออํานวยความสะดวกในการตอบรับและการติดตามบริการ Case`,
"workflow.action.tasks.assignortype.role":`บทบาท`,
"vue_label_notice_refreshi_success":`การรีเฟรชสำเร็จ`,
"label.notification.arketsea.abandon":`5}ทิ้ง{2}{0}：{1}`,
"label.icon.36":`คอมพิวเตอร์`,
"chatter.group.cancelToJoin":`ยกเลิกการเข้าร่วม`,
"label.publicgroups.edit":`แก้ไขกลุ่มสาธารณะ`,
"message.duplication.label.letternum":`จำนวนอักขระที่ตรงกัน`,
"label.brief.lost.opportunities":`จำนวนโอกาสที่ปิดการขายไม่สำเร็จ`,
"setup.layout.label.nofield":`ไม่มีตัวเลือกฟิลด์`,
"label.dataimport.isSharingRule":`ดำเนินการกฎการแบ่งปัน`,
"vue_label_opportunity_contactrole_synctocontacts":`ซิงค์ข้อมูลไปยังผู้ติดต่อ`,
"attachment_button_massdownload":`ดาวน์โหลดเป็นชุด`,
"label.weixin.agreement.remark":`บริการวีแชทนี้เป็นเครื่องมือเสริมที่ aid-maxให้บริการคำปรึกษาแก่ลูกค้า ไม่ใช่จุดสิ้นสุดที่บริษัทประกันภัยจะชำระค่าสินไหมทดแทน ค่าสินไหมทดแทนของลูกค้าควรเป็นไปตามข้อกำหนดที่แท้จริงของบริษัทประกันภัย`,
"label.partnerCloud.basicSetting.introTwo":``,
"pagecreator_layout_funcpath":`/ตัวสร้าง/ไลบรารีเค้าโครง`,
"label.ccdocument.online.edit":`แก้ไขเอกสารออนไลน์`,
"label.partner.setup.Enable":``,
"label.log.state":`สถานะการดำเนินการ`,
"label.lower.bound":`ขอบเขตล่าง`,
"label.timezone.isenable":`เปิดใช้งานผู้ใช้หลายโซนเวลา อนุญาตให้ผู้ใช้ตั้งค่าโซนเวลาของตนเองและแสดงวันที่และเวลาในโซนเวลาของผู้ใช้`,
"label.martrixreport.setrowtitle":`กำหนดหัวแถว`,
"label.bottom":`ส่วนล่าง`,
"label.multilang.ccchat.groupnotcontainsname":`คุณไม่ได้เป็นสมาชิกกลุ่มกิจกรรมใดๆ ที่ในชื่อประกอบด้วย{0}`,
"label.step1.of.step5":`ขั้นตอนที่ 1 จาก 5`,
"message.report.error.FieldListIsAmbiguous":`มีฟิลด์สูตรในฟิลด์รายงานอ้างอิงฟิลด์ต่อไปนี้ซึ่งทำให้ผิดปกติ โปรดลบฟิลด์สูตรนี้ ฟิลด์ที่อ้างอิงโดยสูตร:`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`เปลี่ยนจาก {0} เป็น {1}`,
"label.report.export.print.content":`ส่งออกส่วนหัวของรายงานปัจจุบัน การจัดกลุ่ม และข้อมูล 2,000 รายการแรก`,
"message.thanksusing":`ขอบคุณที่ใช้ CloudCC.com！`,
"label.reportexport.allobject":`ส่งออกออบเจ็กต์ทั้งหมด`,
"label.projectManagement.working.hours.per.day":`ชั่วโมงการทำงานต่อวัน`,
"label.partnerCloud.financeSetting.enterCollaborator":`กรุณาป้อนไอดีผู้ร่วมงาน`,
"label.defineReportRecords":`กำหนดชุดบันทึกของรายงาน`,
"greate":`มากกว่า`,
"label.sure_discard":`คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการแก้ไขของคุณ?`,
"label.escalation.setup.newaction.notifyowner":`แจ้งเตือนเจ้าของเคส`,
"label.icon.28":`หมวกปริญญา`,
"lable.PowerProcess.see.page":`ดูอิเวนต์สําคัญ`,
"message.error.object.relogin":`การเข้าสู่ระบบล้มเหลว โปรดลองเข้าสู่ระบบอีกครั้ง`,
"label.chatter.activity":`กิจกรรม`,
"label.query.clone.detail.choose.canChoose":`ตัวเลือกออบเจ็กต์รายละเอียด`,
"chatter.using.object":`เปิดการใช้งานการติดตามเวยเทียของออบเจ็กต์เพื่อให้ผู้ใช้สามารถติดตามบันทึกของออบเจ็กต์ได้ เลือกฟิลด์ที่ต้องการติดตามเพื่อให้ผู้ใช้สามารถเห็นการอัปเดตเวยเทียเมื่อบันทึกที่ติดตามเปลี่ยนแปลง`,
"UG.opportunity.001":`คุณจะตรวจสอบพนักงานขายของคุณอย่างไร?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`แผนภูมิทรัพยากรบริการ`,
"vue_label_email_current_email":`การแทรกแม่แบบนี้จะเขียนทับอีเมลปัจจุบัน`,
"label.h5.approval.page.layout":`คุณสามารถตั้งค่าเค้าโครงหน้าการอนุมัติได้ดังนี้: <br>การตั้งค่า->สร้าง->เวิร์กโฟลว์และการอนุมัติ->กระบวนการอนุมัติ<br>เลือกกระบวนการอนุมัติที่เกี่ยวข้อง คลิกชื่อของกระบวนการอนุมัติ <br>เลือกแก้ไข-> อนุมัติเค้าโครงหน้า <br>คุณสามารถกำหนดเค้าโครงหน้าอนุมัติได้`,
"component.hots.label.title":`ข้อเสนอยอดนิยม`,
"mail.foldername.notOnly":`ไฟล์นี้มีอยู่แล้ว`,
"label.customer.tab.step1":`ขั้นตอนที่ 1: ใส่รายละเอียด`,
"label.delete.persion":`ผู้ลบ`,
"chatter.changed0":`นำ {0} จาก {1} เปลี่ยนเป็น {2}`,
"homepage.components.type":`ประเภทส่วนเสริม`,
"label.norfolk.isiands.time":`เวลานอร์ฟอล์ก`,
"label.product.pricebooks.view":`มุมมองสมุดราคา`,
"label.forecast.customforecast.director":`ผู้ใต้บังคับบัญชาโดยตรง`,
"label.emailtocloudcc.step3total3":`ขั้นตอนที่ 3 จาก 3`,
"label.cloudccsite.end":`ปิดการใข้งานหน้าแรกของเว็บไซต์`,
"label.login.verification.mfa.device":`ทวนสอบอุปกรณ์ MFA เสมือน`,
"chatter.follow":`ฉันต้องการติดตาม`,
"label.month's":`ของเดือน`,
"label.sendmail.step1.introduce":`เลือกหนึ่งมุมมองด้านล่าง (ที่มีผู้รับอีเมลนี้)`,
"label.shangqing.title":`การตั้งค่าข้อมูลธุรกิจ`,
"label.rejectrecords":`ปฏิเสธการบันทึก`,
"label.selectupdatevalue":`เลือกค่าเป้าหมายที่คุณต้องการเปลี่ยน`,
"vue_label_pricebook_disabled":`สมุดราคาปิดอยู่`,
"component.chatter.label.title":`เวยเทียล่าสุด`,
"label.partner.all.workspace":`เวิร์คสเปซ`,
"label.querydetailservice.delete.message":`ข้อมูลถูกลบหรือไม่มีอยู่จริง`,
"label.objectRelationshipWithout":`มีบันทึกที่เกี่ยวข้องหรือไม่`,
"nocontain":`ไม่ประกอบด้วย`,
"label.partnerCloud.financeSetting.accountSettings":`การตั้งค่าบัญชีพาร์ทเนอร์`,
"label.file.sharetype.owner":`เจ้าของ`,
"label.open.multilingual":`เปิดการใช้งานหลายภาษา`,
"label.searchresult.field":`ฟิลด์ผลการค้นหา`,
"label.tabpage.selectdate":`เลือกวันที่`,
"label.h5.logouting":`ออกจากระบบ`,
"label.quickbooks.fieldlabel.payment":`วิธีการจ่ายเงิน`,
"label.chatter.leaveword":`ฝากข้อความ`,
"label.customfields.majoranddetailrelation.tip":`สร้างความสัมพันธ์หลัก-รองชนิดพิเศษระหว่างออบเจ็กต์นี้ (ระดับลูกหรือรายละเอียด") กับออบเจ็กต์อื่น (ระดับพาเรนต์หรือ"ส่วนหลัก")โดยที่:<br>●ฟิลด์ความสัมพันธ์ของบันทึกรายละเอียดทั้งหมดเป็นข้อมูลบังคับ <br>●เมื่อบันทึกค่าของฟิลด์ความสัมพันธ์แล้วจะไม่สามารถเปลี่ยนแปลงได้ </li><br>●สิทธิ์การเข้าถึงทั้งหมดของบันทึกรายละเอียดและการแบ่งปันจะถูกกำหนดโดยบันทึกหลัก </li><br>●เมื่อผู้ใช้ลบบันทึกหลัก บันทึกรายละเอียดจะถูกลบทั้งหมด </li><br>●คุณสามารถสร้างฟิลด์สรุปสะสมในบันทึกหลักเพื่อสรุปบันทึกรายละเอียดได้ </li><br>ฟิลด์ความสัมพันธ์อนุญาตให้ผู้ใช้คลิกไอคอนค้นหาเพื่อเลือกค่าจากรายการป๊อปอัป ออบเจ็กต์หลักคือแหล่งที่มาของค่าในรายการ"`,
"label.batchapproveorrefuse":`การอนุมัติแบบกลุ่ม/การปฏิเสธคำขออนุมัติ`,
"label.copy.success":`คัดลอกสำเร็จ`,
"vue_label_show_record_count":`แสดงจํานวนบันทึก`,
"label.ems.delete.false":`การลบล้มเหลว`,
"label.new.Product.Goals":`เป้าหมายผลิตภัณฑ์ใหม่`,
"label_chatter_BCC":`สำเนาลับ`,
"label.knowledgebase.data.archived.successfully":`ข้อมูล {a} รายการถูกเก็บถาวรเรียบร้อยแล้ว`,
"label.chuangming.title":`เกตเวย์ข้อความสั้นของเครือข่ายช่วงหมิง`,
"label.notification.arketsea.recovery":`{5}รีไซเคิล{0}:{1}ของคุณไปยัง{2}`,
"label.partnerCloud.orderingPlatform.paymentAmount":`จำนวนเงินที่ชำระ:`,
"label.martrixreport.2018.step5.new":`ขั้นตอนที่ 5: เลือกมาตรฐานรายงาน`,
"label.testing":`กำลังตรวจสอบ...`,
"chatter.poll.option4":`ตัวเลือกที่ 4`,
"lable.outlook.detail.otc":`Exchange ไปยัง CloudCC.com`,
"label.startuploadfile.batch.step2":`ขั้นตอนที่ 2. คลิกปุ่ม "เริ่มการอัปโหลด" เพื่ออัปโหลดไฟล์`,
"lable.outlook.edit.outdes":`กรุณาใส่ฟิลด์ที่กำหนดเองที่คุณได้สร้างไว้ใน Exchange ก่อนที่จะแม็ปฟิลด์ Exchange แบบกำหนดเองนี้กับฟิลด์ CloudCC.com , CloudCC.com จะตรวจสอบว่ามีฟิลด์ Exchange อยู่ในการซิงค์ครั้งแรก`,
"hour":`ชั่วโมง`,
"label.appointmentpage.wizard.notif4":`รูปแบบอีเมลไม่ถูกต้อง`,
"label.import.index.state":`สถานะ`,
"label.integrations.mailchimp.massage6":`ข้อมูลที่เลือกจะถูกส่งออกไปยังรายการ Mailchimp ที่คุณเลือก`,
"label.file.share.email.subject":`#sharedByได้แบ่งปันไฟล์ให้คุณใน#orgname`,
"label.assignment.setup.newentries.noassignment":`อย่ามอบหมายเจ้าของซ้ำ`,
"label.dashboard.unit1":`หน่วย: หมื่น`,
"label.forecast.customforecast.foretype.commit":`ข้อผูกมัด`,
"label.type":`ประเภท`,
"label.partner.workspace.login.logo":`โลโก้ส่วนหัว`,
"pagecreator_systemstyle_button_edit":`แก้ไขรูปแบบ`,
"label.displaytype2":`ปุ่มหน้ารายละเอียด`,
"email.one":``,
"label.partnerCloud.orderingPlatform.unavailable":`ไม่มีผลิตภัณฑ์พร้อมใช้งาน`,
"vue_label_email_save_the_signature_successfully":`การบันทึกลายเซ็นสำเร็จ`,
"label.reportsSubscriptionPage.email.detailed":`รายละเอียด`,
"chatter.group.query":`แบบสอบถาม`,
"label.translation.unsupported.format":`รูปแบบที่ไม่รองรับ การนำเข้าหลายภาษารองรับเฉพาะรูปแบบ property`,
"message.operateexception":`ข้อความแจ้งเตือน (หากพบปัญหากรุณาติดต่อผู้ดูแลระบบของคุณ)`,
"label.sendemail.chat.praiseFeedcomment":`#nameที่เคารพ: \ n \ n สวัสดี! #userNameชื่นชอบความคิดเห็น(#href)ของคุณ`,
"label.recycle.clearmy":`ล้างถังขยะรีไซเคิลของคุณ`,
"label_tabpage_choose":`เลือก`,
"#label.importstep2tip":`หากคุณต้องการจะอัปโหลดหลายไฟล์ คุณสามารถบีบอัดไฟล์ทั้งหมดแล้วนำเข้าพร้อมกัน#`,
"label.batchedit":`การแก้ไขเป็นชุด`,
"label.integrations.mailchimp.export":`ส่งไปยัง Mailchimp`,
"label.cloudccsite.name":`ชื่อเว็บไซต์`,
"serviceterritory.serviceappointment.iscontain.contain":`เนื่องจากภูมิภาคให้บริการเชื่อมโยงกับการนัดหมายการบริการ จึงไม่สามารถลบภูมิภาคให้บริการได้ คุณไม่จำเป็นต้องเปิดใช้งานภูมิภาคให้บริการนี้`,
"label.sum":`จํานวนรวม`,
"setup.mainpage.label.welcome29":`API มาตรฐานเชื่อมต่อกับผลิตภัณฑ์ของบุคคลที่สาม`,
"label.tabpage.nothingz":`ไม่มี`,
"label.weixin.actual.contract.jine":`จำนวนเงินแท้จริงของสัญญา`,
"label.tabpage.emailaddressz":`ที่อยู่ผู้ส่ง`,
"label.dashboard.unit4":`หน่วย: สิบล้าน`,
"label.dashboard.data.labels":`ป้ายกำกับข้อมูล`,
"label.import.page2.oneonone":`หนึ่งฟิลด์ CloudCC สามารถจับคู่กับหนึ่งฟิลด์ในไฟล์`,
"homepage.components.name":`ชื่อส่วนเสริม`,
"template.report.task.theme":`หัวข้อภารกิจ`,
"component.setup.label.setupsaveok":`บันทึกการตั้งค่าส่วนเสริมสำเร็จ`,
"front-epwechat-module-v1-add-selfapp":`เพิ่มแอปที่สร้างขึ้นเอง`,
"label.to.save.the.current.page.information.button.":`หากต้องการบันทึกข้อมูลหน้าปัจจุบัน ให้คลิกปุ่ม "บันทึกด่วน"`,
"vue_label_file_not_support_preview":`ไฟล์นี้ไม่รองรับการแสดงตัวอย่าง กรุณาดาวน์โหลดเพื่อดู`,
"label.object.reached.limit":`จำนวนของออบเจ็กต์ถึงขีดจำกัด`,
"label.partnerCloud.basicSetting.online":`เปิดใช้งานการชำระเงินออนไลน์`,
"label.app.step1.error.nameexist":`มีชื่อกลุ่มสาธารณะนี้แล้ว`,
"label.workflowandapprove":`เวิร์กโฟลว์และการอนุมัติ`,
"label.recordtypeselect.change.tip":`เมื่อเปลี่ยนชนิดบันทึก ค่ารายการตัวเลือกที่มีอยู่จะไม่เปลี่ยนแปลงโดยอัตโนมัติ เราขอแนะนำให้อัปเดตค่ารายการตัวเลือกที่มีอยู่ในบันทึกในที่เดียวกัน`,
"label.summaryreport.step6":`ขั้้นตอนที่ 6: เลือกมาตรฐานรายงาน`,
"Pagelayout.Setup.004":`ปรับแต่งได้มากที่สุด 4 ฟิลด์`,
"label.file.attached":`แนบไฟล์`,
"front-invoice-online-payment-setup-configure":``,
"label.approvaldatamove.submitdate":`วันที่เสนอ`,
"label.emailobject.time.from":`ผู้ส่ง:`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`ฟิลด์$Schemefield_name$ในบันทึกนี้มีอยู่ในฐานข้อมูลแล้ว และจะไม่มีการแทรกอีกต่อไป บันทึกจะถูกละเว้นการนำเข้า`,
"assetbom.copy.notpermission":`โปรดติดต่อผู้ดูแลระบบ คุณไม่มีสิทธิ์คัดลอก BOM สินทรัพย์`,
"lable.outlook.mcto.autoallocation":`นำบันทึก CloudCC.com ที่เกี่ยวข้องจัดสรรให้พวกเขาอัตโนมัติ`,
"label.dataimport.but.datalength":`แต่ความยาวของข้อมูลคือ`,
"label.setuserstocommit":`ใช้ตัวเลือกด้านล่างเพื่อระบุว่าผู้ใช้ใดสามารถส่งคำขออนุมัติเบื้องต้นได้`,
"component_telerecord_label_related":`รายการที่เกี่ยวข้อง`,
"front-lighting-module-v1-detail-file-lockInfo":`บันทึกถูกล็อกและไม่สนับสนุนการเพิ่มไฟล์ โปรดติดต่อผู้ดูแลระบบเพื่อปลดล็อก`,
"pagecreator_layout_button_edit":`แก้ไขเค้าโครง`,
"label.app.step3.tabcanuse":`แท็บที่ใช้ได้`,
"label.ems.delete.sure":`ยืนยันที่จะลบข้อมูลบัญชีอีเมลนี้หรือไม่?`,
"label.email.show":`แสดงผล`,
"label.checkbox.unchecked":`ที่ไม่ได้เลือก`,
"message.error.operation":`การดำเนินการล้มเหลว โปรดติดต่อผู้ดูแลระบบ!`,
"label.template.set.folder.only.upload.type.file":`โฟลเดอร์แม่แบบตัวหนังสือสีแดงสามารถอัปโหลดได้แค่ไฟล์ประเภท Word Excel และPPT เท่านั้น`,
"label.knowledgebase.select.publish.status":`กรุณาเลือกสถานะการเผยแพร่`,
"label.recordtype.tabname.edit":`ป้อนชื่อใหม่สำหรับชนิดบันทึกที่เลือก แล้วคลิก "บันทึก"`,
"label.tabpage.exportview":`ส่งออกมุมมอง`,
"label.dataimport.insert.sharetab":`การแทรกตารางแบ่งปันล้มเหลว`,
"vue_label_dashboard_penetrateto":`เจาะเข้าไปใน`,
"label.weixin.group.member":`สมาชิก`,
"vue_label_systemSettings_customadd":`ส่วนขยายที่กำหนดเอง`,
"UG_Account_03":`ตรวจสอบลูกค้าซ้ำแบบเชิงรุกและผสาน`,
"label.singapore.standard.time":`เวลาสิงคโปร์`,
"label.weixin.captcha":`รหัสยืนยัน`,
"Account_News_Setting_004":`เปิดใช้งานข่าวสาร`,
"label_emailtocloudcc_select1":`กรุณาเลือก`,
"label_ring_ratio":`อัตราส่วนลูกโซ่`,
"label.industrialandcommercialverification.button.save":`บันทึก`,
"label.approvalstep5.tip":`หน้าการอนุมัติเป็นหน้าที่ผู้อนุมัติจะอนุมัติหรือปฏิเสธคำขอจริง โดยใช้ตัวเลือกด้านล่างเพื่อเลือกคุณสมบัติการแก้ไขของฟิลด์ที่จะแสดงในหน้านี้`,
"label.import.page1.maxrecord{{30000}}":`1. คุณนำเข้าบันทึกได้มากที่สุด {{30000}} รายการต่อครั้ง`,
"setup_object_layout_label_profileoptions":`โปรไฟล์ที่กำหนดได้`,
"label.emailtemplate.type":`ประเภทแม่แบบ`,
"label.searchlayout.tab.field":`ฟิลด์ที่แสดงภายใต้แท็บ`,
"chatter.news":`ข่าวสาร`,
"label.pw.small.letter":`ตัวพิมพ์เล็ก`,
"label.notification.group3":`คุณถูกปฏิเสธให้เข้าร่วมกลุ่มสาธารณะ`,
"label.ccchat.day.before.yesterday":`เมื่อวันก่อน`,
"component.chatter.post.label.title":`เผยแพร่`,
"label.tianyancha.type":`ประเภทนิติบุคคล`,
"label.detail.searchlayout":`ดูเค้าโครงการค้นหา`,
"vue_label_pool_deleteconfirm":`ยืนยันการลบข้อมูล(TableCheckedObjectArrlength}ที่เลือกหรือไม่?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1. รองรับเฉพาะแฟ้มข้อมูลรูปแบบ csv ขนาดใหญ่ที่สุด {{100}}mb และนำเข้าบันทึกได้มากที่สุด {{30000}} รายการต่อครั้ง หากเกินขีดจํากัด โปรดแยกไฟล์ออกเป็นหลายไฟล์ก่อน และนําเข้าเป็นส่วนๆ`,
"label.h5.similar.opportunity.lookup":`ค้นหาโอกาสทางธุรกิจที่คล้ายกัน`,
"template.report.customer.list.opportunity":`มีรายชื่อลูกค้าที่มีโอกาสทางธุรกิจมากขึ้น`,
"component_setup_iframe_label_memo":`คลิกไอคอนการตั้งค่า และป้อน URL ที่จะฝัง`,
"label.version.allemail":`ส่งอีเมลแบบกลุ่ม`,
"lable.product.editp":`แก้ไขราคา`,
"label.weixin.plate.number":`หมายเลขทะเบียนรถ`,
"font-evaluate-module-v1-disabled-successfully":``,
"label.multilingual.tip1":`ใช้หน้าเพจนี้เพื่อกําหนดภาษาทั้งหมดที่องค์กรของคุณใช้`,
"label.japan.standard.time":`เวลามาตรฐานญี่ปุ่น`,
"lable.product.notdel.use":`ความพยายามในการลบ เนื่องจากยังคงเชื่อมโยงกับบันทึกต่อไปนี้ ในกรณีนี้เราขอแนะนําให้คุณปิดใช้งาน`,
"label.appointment.wizard.subtitle4-2-4":`4 ชั่วโมง`,
"label.queue.edit":`แก้ไข`,
"label.partnerCloud.financeSetting.informationTwo":`2. ที่หน้าแรกของศูนย์ธุรกิจคลิก [การจัดการบัญชี] - [การจัดการข้อมูลร้านค้า] - [ตรวจสอบ PIDIKEY] - [การจัดการคีย์]`,
"label.partnerCloud.partnerOrdering.permission":`สิทธิ์การสั่งซื้อของพาร์ทเนอร์`,
"vue_label_commonobjects_detail_company_hierarchy":`ลำดับชั้นของบริษัท`,
"label.forecast.settings.sl":`จำนวน`,
"label.partner.workspace.tab.memo":`เลือกแท็บที่สามารถใช้ได้ในพาร์ทเนอร์คลาวด์นี้ สามารถเลือกแท็บมาตรฐานของระบบและแท็บที่กำหนดเองได้`,
"label.mr.mainRecord":`บันทึกหลัก`,
"setup_mainpage_label_welcome20":`อีเมล แม่แบบข้อความสั้น`,
"front-email-payment-select-date-tips":``,
"label.dependencelisttag":`ป้ายกำกับรายการที่เกี่ยวข้อง`,
"label.umeng.activity.eventof":`อิเวนต์ของ`,
"label.sales.dashboard.collection":`เป้าหมายการเก็บเงิน`,
"report_label_folder":`โฟลเดอร์`,
"label.assignment.setup.newentries.step1":`ขั้นตอนที่ 1: ตั้งค่าการเรียงลำดับรายการเกณฑ์นี้`,
"label.quote.shrname":`ชื่อผู้รับ`,
"label.newreport.group.sum":`สถิติจำนวนกลุ่ม`,
"label.number.MinCheck":`จํานวนขั้นต่ำของ{0}คือ {1} โปรดแก้ไขจำนวนแล้วคลิกบันทึก`,
"label.chatter.save":`บันทึก`,
"vue_label_email_all_email_templates":`แม่แบบอีเมลทั้งหมด`,
"message.summaryconditionnototal":`เงื่อนไขสรุปต้องไม่เลือกฟิลด์สรุปสะสมได้!`,
"label.callboard":`ประกาศ`,
"label.step2.total5":`ขั้นตอนที่ 2 จาก 5`,
"vue_label_homepage_custom_homepage_page":`หน้าแรกที่กำหนดเอง`,
"label.data.newtemplate.e_seltype":`เลือกวิธีการส่งออกข้อมูล`,
"label.data.dataexpalltype.all.desc2":`2. การส่งออกข้อมูลทั้งหมดจำเป็นต้องใช้เวลาระยะหนึ่ง หลังจากการส่งออกเสร็จสมบูรณ์ ระบบจะส่งอีเมลแจ้ง`,
"lable.account.CalenderYear":`ปีปฏิทิน`,
"message.error.data":`ข้อมูลที่ส่งผ่านต้องไม่ว่างเปล่า โปรดตรวจสอบพารามิเตอร์ที่ส่งผ่าน`,
"label.from_user":`จากผู้ใช้`,
"label.parentdepartment":`แผนกหลัก`,
"template.dashboard.product.analysis":`การวิเคราะห์ผลิตภัณฑ์`,
"label.tabpage.unpacketz":`ไม่มีกลุ่มข้อมูลพร้อมใช้!`,
"label.icon.107":`การสื่อสาร`,
"label.monitorsys.operator.username":`ผู้ใช้`,
"label.serchreport":`ค้นหารายงาน`,
"label.payment.upgrade":`อัพเกรด`,
"setup_layout_button_ok":`ยืนยัน`,
"label.please.select.channel":`โปรดเลือกหัวหน้าช่องทาง`,
"template.chart.txdrw":`เตือนความจำ`,
"chatter.group.accept":`ยอมรับ`,
"pagecreator_systemstyle_message_canntdelete":`ไม่อนุญาตให้ลบรูปแบบปัจจุบัน`,
"label_tabpage_ctbtsftcz":`คลิกที่ด้านหลังเพื่อค้นหาเนื้อหาที่เลือก`,
"label.datamanage.select.accountfield":`(เลือกฟิลด์ที่ตรงกับลูกค้าที่นำเข้า)`,
"label.schedulejob.setup.list.title":`งานที่ต้องกำหนดเวลา`,
"label.visualpage_list.title":`เปิดใช้งานการเข้าถึงเพจที่กำหนดเอง`,
"label.mr.selectTwoData":`กรุณาเลือกข้อมูลอย่างน้อย 2 รายการเพื่อผสาน`,
"label.customer.tab.step2.different":`ใช้การแสดงแท็บที่ต่างกันในแต่ละโปรไฟล์`,
"label.mobile.side.tab.can":`ใช้ได้`,
"label.log.url":`URL`,
"label.weixin.cloudccnumber.isgoon":`ผูกบัญชี CloudCC ไว้แล้ว หากคุณดำเนินการต่อ บัญชีวีแชทที่เคยผูกไว้กับบัญชี CloudCC นี้จะไม่สามารถใช้ระบบวีแชท CloudCC ได้ ดำเนินการต่อหรือไม่?`,
"label.applet.to.case":`มินิโปรแกรมพอร์ทัลการบริการลูกค้า`,
"lable.outlook.detail.cmaping":`แม็ปฟิลด์ผู้ติดต่อ`,
"label.theUserActiveTime":`ช่วงเวลาที่ผู้ใช้เข้าใช้งาน`,
"label.event.moveup.9hour":`ล่วงหน้า 9 ชั่วโมง`,
"vue_label_pool_other":`อื่นๆ`,
"label.fieldname":`ชื่อฟิลด์`,
"vue_label_notice_add_success":`การเพิ่มสำเร็จ`,
"label.conditiontag.lookup.insertbutton":`แทรกที่เลือก`,
"label.identifying":`รหัสประจำตัว`,
"label.tabpage.uploadingz":`กำลังอัปโหลด`,
"label.view.introduce":`แก้ไขมุมมอง`,
"vue_label_dashboard_sortingmethod":`กรุณาเลือกวิธีการเรียงลำดับ`,
"label.quote.number.introduce":`กรอกจำนวนและส่วนลดของผลิตภัณฑ์จากนั้นคลิก "บันทึก"`,
"front-kefu-moudle-which-missphone-case":``,
"label.sendemail.chat.response":`ตอบกลับเวยเทีย:`,
"label.productsales.refreshTime":`เวลารีเฟรสครั้งล่าสุด`,
"lable.SalesCommitmentKanBan.phase":`สเตจ`,
"label.version.sum.object":`ออบเจ็กต์`,
"label.defineReportStep2":`ขั้นตอนที่ 2`,
"message.duplication.label.returnDuplications":`กลับไปที่รายการตัวกรองซ้ำ`,
"label.lookover":`ตรวจสอบ`,
"label.quickbooks.button.copy2":`ซิงค์จาก CloubCC ไป QuickBooks`,
"label.checkbox.true":`ใช่`,
"label.profilename":`ชื่อโปรไฟล์`,
"label.finalapproveoperate":`ดำเนินการอนุมัติขั้นสุดท้าย`,
"label.SMS.detailed":`การแจ้งเตือนทางข้อความสั้นคือข้อความสั้นที่ส่งโดยกฎเวิร์กโฟลว์เมื่อถูกทริกเกอร์`,
"label.lasttimemodifier":`ผู้ที่แก้ไขครั้งล่าสุด`,
"label.sso.summary":`สรุป`,
"label.customfields.encd.tip":`อนุญาตให้ผู้ใช้ใส่ตัวอักษรและตัวเลขใด ๆ ผสมกัน และจัดเก็บในรูปแบบของข้อความธรรมดา สามารถแสดงในรูปแบบการเข้ารหัส และสามารถค้นหาได้`,
"vue_label_report_formulacolumn":`คอลัมน์สูตรระดับแถว`,
"vue_label_systemSettings_transfer":`โอนบันทึกแบบกลุ่ม`,
"lable.product.ecm":`ระบุจำนวนเงินที่ถูกต้อง`,
"label.partner.setup":`การตั้งค่าพาร์ทเนอร์คลาวด์`,
"label.same.analyze.miaoshu2":`"ฟังก์ชั่น`,
"label.mobile.phone.day.summary":`สรุปของวันนี้`,
"label.ccchat.person.error.illdomain":`ข้อผิดพลาด: มีโดเมนที่กรอกรูปแบบไม่ถูกต้อง`,
"label.knowledgebase.edit.as.draft":`แก้ไขเป็นฉบับร่าง`,
"message.duplication.label.newfilterule":`กฎตัวกรองซ้ำใหม่`,
"vue_label_salesfunnel_notice1":`สรุปโอกาสทางธุรกิจ`,
"label.partnerCloud.partnerAccount.order":`หมายเลขใบสั่งซื้อ：`,
"label.account.Current.and.PreviousFQ":`ไตรมาสบัญชีนี้และก่อนหน้า`,
"label.customfields.formula.dateandtimeexample":`Next（ค่าถัดไป）= NOW()   1`,
"label.area.unassign":`ผู้ใช้ที่ไม่ได้รับมอบหมาย`,
"label.at.my":`เนื้อหาที่ฉัน @`,
"vue_label_calendar_notice_stopsharingfail":`การหยุดการแบ่งปันล้มเหลว`,
"label.data.file.validation.rules":`บังคับใช้เกณฑ์การทวนสอบ`,
"label.escalation.setup.entrydetail.escalation.hour":`ชั่วโมง`,
"vue_label_ccchat_notice_pleaseentercontent":`กรุณาป้อนเนื้อหาและตัวเลือกของโพสต์`,
"label.forecast.edit.error1":`ข้อผิดพลาด: สกุลเงินไม่ถูกต้อง`,
"label_emailtocloudcc_exists1":`อีเมลนี้ถูกตั้งค่าเป็น Email to Lead กรุณาอย่าตั้งค่าซ้ำ`,
"label.trigger.send.email":`ทริกเกอร์การแจ้งเตือนทางอีเมล:`,
"label.setmysafetysignagain":`ตั้งค่าเครื่องหมายความปลอดภัยของฉันใหม่`,
"label.callcenter.pleaseenter.access.keyID":``,
"chatter.poll.option10":`ตัวเลือกที่ 10`,
"vue_label_systemSettings_mobelbottonsetting2":`การตั้งค่าเมนูด้านล่างรวมขององค์กร`,
"label.quickbooks.searchs":`ค้นหา`,
"label.section":`เซคชัน`,
"label.customfields.fielddependency.new.tip":`สร้างความสัมพันธ์การพึ่งพาที่จะส่งผลให้เกิดการกรองแบบไดนามิกของค่าในรายการตัวเลือกหรือรายการเลือกหลายรายการตามค่าที่ผู้ใช้เลือกในฟิลด์อื่น <ul ><li>ฟิลด์ที่ขับเคลื่อนตัวกรองเรียกว่าฟิลด์ควบคุม กล่องกาเครื่องหมายมาตราฐานและแบบกำหนดเองและรายการตัวเลือกที่มีค่าอย่างน้อยหนึ่งค่าและน้อยกว่า 300 ค่าสามารถเป็นฟิลด์ควบคุมได้ </li> <li> ฟิลด์ที่ค่าถูกกรองเรียกว่า "ฟิลด์พึ่งพา" รายการตัวเลือกที่กำหนดเองและรายการเลือกหลายรายการสามารถเป็นฟิลด์พึ่งพาได้ </li></ul>`,
"label.customobjects.track.introduce3":`โปรดทราบ: ติดตามแค่ฟิลด์ส่วนที่เปลี่ยนแปลงเท่านั้น เมื่อติดตามค่าฟิลด์ จะขึ้นเฉพาะ "เปลี่ยนแปลงแล้ว" เท่านั้น`,
"front-kefu-moudle-all-hidden-phone":``,
"vue_label_calendar_share_calendar_with_others":`แบ่งปันปฏิทินกับผู้อื่น`,
"label.case.copre":`ดาวน์โหลดรหัสคิวอาร์ของเว็บไซต์พอร์ทัลการบริการลูกค้า`,
"label.conditiontag.lookup.pagetitle":`เลือกค่ารายการตัวเลือก`,
"UG.opportunity.004":`หลากหลายประเภทธุรกิจ`,
"label.event.moveup.1day":`ล่วงหน้า 1 วัน`,
"label.industrialandcommercialverification.enablestatus1":`เปิดใช้งานการทวนสอบข้อมูลธุรกิจ`,
"label.ccpeak.newrecord.getorpost":`เพิ่มบันทึกใหม่: ใช้ CCObject ออบเจ็กต์ CCObject มี 2 เมธอดผู้สร้าง`,
"frame.personinfo.label.resizeimage":`หากต้องการปรับภาพขนาดย่อของคุณ กรุณาลากและวางรูปโปรไฟล์บนเส้นประ`,
"label.optional.searchresultfield":`ตัวเลือกฟิลด์ผลการค้นหา`,
"UG.Contract.02":`สัญญาคือข้อตกลงเป็นลายลักษณ์อักษรของคู่สัญญา หลายบริษัทใช้สัญญาเพื่อกำหนดเงื่อนไขในการทำธุรกิจกับบริษัทอื่นๆ ใช้ CloudCC เพื่อสร้างและจัดทำเอกสารสัญญาที่มีอยู่กับลูกค้าและโอกาสทางธุรกิจ ติดตามสัญญาผ่านขั้นตอนการอนุมัติ ใช้การแจ้งเตือนเวิร์กโฟลว์เพื่อเตือนให้คุณทราบถึงการขยายเวลาของสัญญา`,
"label.group.activity":`กลุ่มกิจกรรม`,
"label.tabpage.characterz":`อักขระเริ่มต้น`,
"label.globalsearch.tip":`กรุณาใส่เนื้อหาที่ต้องการค้นหา`,
"label.campaign.channel.download.size2":`ขนาดกลาง: 500*500 พิกเซล`,
"label.step3.total4":`ขั้นตอนที่ 3 จาก 4`,
"label.partnerCloud.payForFailure":`การชําระเงินล้มเหลว`,
"label.ggReleaseRange.editSuccess":`แก้ไขสำเร็จ`,
"label.summaryinforelyon":`ข้อมูลสรุปตาม`,
"label.productsales.htyj":`ผลสำเร็จของสัญญา`,
"label.newpagelayout":`เค้าโครงรุ่นใหม่`,
"front-gantt-module-input-task-name":``,
"label.c_d_without":`บันทึก C" อาจจะมีหรือไม่มีความเกี่ยวข้องกับบันทึก  "D" "`,
"label.licence":`ใบอนุญาต`,
"setup.layout.button.selectall":`เลือกทั้งหมด`,
"label.app.step1.error.appnameexist":`ข้อผิดพลาด: ไม่มีชื่อแอปพลิเคชันนี้`,
"label.cpq.quote.item.no.record":`เฉพาะผลิตภัณฑ์ในใบสั่งซื้อเท่านั้นที่สามารถแปลงเป็นสัญญาได้`,
"label.knowledgebase.noaffect.existing.translations":`ไม่ การเปลี่ยนแปลงของฉันจะไม่ส่งผลต่อการแปลที่มีอยู่`,
"label.schedulejob.setup.schedule.editjob":`แก้ไขงานที่ต้องกำหนดเวลา`,
"lable.PowerProcess.Tips":`กระบวนการให้สิทธิ์เป็นไทม์ไลน์ที่ปรับแต่งได้รวมถึงขั้นตอนทั้งหมด (อิเวนต์สำคัญ) พนักงาน อาทิ เจ้าหน้าที่ฝ่ายสนับสนุนลูกค้า จะต้องทำตามขั้นตอนทั้งหมดจึงจะสามารถแก้ไขเคสการสนับสนุนหรือบันทึกใบสั่งงานได้ โดยหลังจากตั้งค่าเสร็จสิ้นจะสามารถนำไปใช้กับสิทธิ์ได้`,
"label.campaignmember.selectmember.step2":`ขั้นตอนที่ 2: เลือกสมาชิกที่ต้องการเพิ่ม`,
"vue_label_calendar_stopsharing":`ยืนยันว่าจะหยุดแบ่งปันปฏิทินหรือไม่`,
"vue_label_notice_savemenu_fail":`การบันทึกเมนูล้มเหลว`,
"message.error.getitems.id":`getItems:id ไม่สามารถว่างเปล่า`,
"label.return.currencylist":`กลับไปที่รายการ: การจัดการสกุลเงิน`,
"label.wtd.detail.p":`รุ่น PC`,
"label.knowledgebase.publish.now":`เผยแพร่ตอนนี้`,
"label.appupload.install.explain":`คําแนะนําในการติดตั้ง`,
"label.visualpage.folder.all":`โฟลเดอร์หน้าเพจทั้งหมด`,
"message.passwordPolicy.validate.complexReq2":`ข้อผิดพลาด: รหัสผ่านจะต้องประกอบด้วยตัวเลข ตัวอักษรพิมพ์ใหญ่พิมพ์เล็กและสัญลักษณ์`,
"label.umeng.chatter.at":`กล่าวถึงคุณ`,
"label.mobile.phone.month.report":`รายงานประจำเดือน`,
"label.describableEditeSelectedFields":`เลือกเป็นฟิลด์คอลัมน์รายงานเริ่มต้นที่จะแสดงเมื่อสร้างรายงานที่กำหนดเองใหม่`,
"component.event.label.subject":`หัวข้อ`,
"label.knowledgebase.edit.draft":`แก้ไขฉบับร่าง?`,
"label.customer.tab.step1.selectoneobject":`เลือกออบเจ็กต์ที่กำหนดเองที่มีอยู่`,
"label_partner_step2":`ขั้นตอนที่2: ยืนยันแม่แบบ`,
"label_starting_annual":`ปีเริ่มต้น`,
"X":`กล่องข้อความ`,
"label.customer.tab.style":`รูปแบบแท็บ`,
"vue_label_commonobjects_detail_book":``,
"chatter.email.referredToMe":`เมื่อในโพสต์กล่าวถึงฉัน (เช่น เมื่อ@)`,
"label.enable.both.barcode.qrcode":`เปิดใช้งานบาร์โคดและรหัสคิวอาร์พร้อมกัน`,
"front-market-form-quired-choose":``,
"noinclude":`ไม่รวม`,
"label.sms.template.select":`โปรดเลือกแม่แบบข้อความสั้น`,
"label.weixin.optionten":`ตัวเลือกที่สิบ`,
"message.duplication.label.matchlastletters":`จับคู่อักขระ n ตัวหลัง`,
"label.webtocloudcc.submit.success":`การส่งสำเร็จ`,
"label.sales.dashboard.number":`ลำดับที่`,
"label.custom.field":`ฟิลด์ที่กำหนดเองนี้`,
"label.dataimport.of.field":`ฟิลด์`,
"label.view.new":`สร้างมุมมองใหม่`,
"UG_activity_03":`กำหนดการนัดหมาย`,
"label.customfields.image.tip":`อนุญาตผู้ใช้อัปโหลดรูปภาพ`,
"label.startexport":`เริ่มต้นการส่งออก`,
"vue_label_commonobjects_view_chart_verticalbar":`แผนภูมิแท่งแนวตั้ง`,
"label.ccchat.person.invite.allexist":`ทุกคนที่คุณเชิญใช้ CCChat อยู่แล้ว`,
"label.fielddependence":`ฟิลด์แบบพึ่งพา`,
"label.scan.tip":`เมื่อใช้เบราว์เซอร์ IE7, IE8, Chrome หรือ Firefox ขอแนะนำให้ใช้ความละเอียดที่สูงกว่า 1024 × 768`,
"label.wei.weiactor":`ผู้เข้าร่วมการโหวตเวยโพล`,
"label.service.miniProgram.quantity":`สร้างบันทึกภาพสไลด์ได้สูงสุด 20 รายการ~`,
"vue_label_homepage_new_homepage_page":`หน้าแรกใหม่`,
"label.apply.telphone.validate.error":`รหัสยืนยันทางโทรศัพท์ไม่ถูกต้อง`,
"component.assistant.button.newevent":`อิเวนต์ใหม่`,
"System_TimeField_Format_Warning":`ไม่ใช่ช่วงเวลายังผล`,
"chatter.feed.publishfeed":`เผยแพร่`,
"label.setting.intergrationlist":`เชื่อมต่อแอป`,
"label.object.prefix":`หน่วยคำเติมหน้าออบเจ็กต์`,
"label.tippage.confirmed":`ใช่ ฉันต้องการลบแหล่งข้อมูลรายงานที่กำหนดเองและรายงานที่อ้างอิงทั้งหมด`,
"label_emailsync_form_signin":`เข้าสู่ระบบ`,
"label.delete.cancel":`ยกเลิกการลบ`,
"label.dashboard.myHomePage.des":`เลือกแดชบอร์ดที่ต้องการจะแสดงในแต่ละแอปพลิเคชันของคุณ`,
"lable.account.FY.Ago":`สองปีงบประมาณก่อนหน้า`,
"label.umeng.approval.reassign":`#approverได้มอบหมาย#obj申请ใหม่`,
"label.data.exp.zippwd2":`สร้างรหัสผ่านไฟล์บีบอัดอัตโนมัติ`,
"label.tabpage.contentz":`กรุณาใส่เนื้อหา`,
"label.callcenter.batch.add.number":``,
"label.tabpage.deleteviewsuccess":`การลบมุมมองสำเร็จ`,
"setup_layout_group_field":`ฟิลด์`,
"label.appupload.component.addobj.scheme.label.suoshu":`ออบเจ็กต์พาเรนต์`,
"front-project-module-v1-market-is-template":`ทำเครื่องหมายว่าแม่แบบ`,
"label.service.gantt.one.esource.types":`และทรัพยากรประเภทใดประเภทหนึ่งดังต่อไปนี้`,
"label.emailtocloudcc.search":`ค้นหา`,
"label.mobile.home.page.myyj":`ผลงานของฉัน`,
"vue_label_normal_invoice_sf":`ใบแจ้งหนี้`,
"label.permission.detail.app.fenpei.tip":`ระบุแอปพลิเคชันที่จะมองเห็นได้ในเมนูแอปพลิเคชัน`,
"label.login.access.month":`เดือน`,
"label_tabpage_retypez":`เมื่อเปลี่ยนชนิดบันทึก ค่ารายการตัวเลือกที่มีอยู่จะไม่เปลี่ยนแปลงโดยอัตโนมัติ เราขอแนะนำให้อัปเดตค่ารายการตัวเลือกที่มีอยู่ในบันทึกในที่เดียวกัน`,
"label.ems.private.company.message":`คลาวด์รุ่นส่วนบุคคลไม่รองรับการแก้ไขอีเมลบริษัทออนไลน์`,
"label.dataimport.length.check":`ความยาวเกิน 18 หลัก โปรดตรวจสอบบันทึกนี้อย่างละเอียดและแก้ไข`,
"label.batchtransfer.type1":`โอนย้ายโอกาสทางธุรกิจที่ยังไม่ได้จัดการที่ไม่ได้เป็นของลูกค้าปัจจุบัน`,
"vue_label_calendar_are_you_sure_to_remove":`ยืนยันว่าจะลบปฏิทินนี้หรือไม่`,
"label.icon.117":`กระเป๋านักเรียน`,
"vue_label_systemSettings_downloadapp":`ดาวน์โหลดโปรแกรมสำหรับอุปกรณ์มือถือ`,
"label.approval.project":`โครงการที่รออนุมัติ`,
"template.organization":`ระดับองค์กร`,
"label.weixin.return.research":`กลับไปหน้าข้อมูลไมโครรีเสิร์ช`,
"label.ccchat.person.invite.addsay":`เพิ่มหนึ่งข้อความทางเลือก...`,
"UG.Case.02":`เคสจะช่วยให้คุณสามารถตอบสนองและแก้ไขปัญหาของลูกค้าได้ เคสเป็นบันทึกที่มีฟังก์ชันทรงพลังของ Cloud CC ที่ไม่เพียงแต่สามารถติดตามปัญหาของลูกค้าได้ แต่ยังสามารถแสดงมุมมองของลูกค้าที่สมบูรณ์ได้ด้วย`,
"label_emailtocloudcc_step1":`ขั้นตอนที่ 1`,
"workflow.action.tasks.assignortype.owner":`เจ้าของ`,
"label.data.import.page":`เข้าสู่หน้าการนำเข้าข้อมูล`,
"label.cache":`แคช`,
"label.custom.page.cuspage.width":`ความกว้างของหน้า (พิกเซล)`,
"label.customcomponent.referencetag":`อ้างอิงป้ายกำกับ`,
"label.tabpage.search":`ค้นหา`,
"label.knowledge.searcharticle.casefields":`ฟิลด์เคสที่ใช้ค้นหาบทความแนะนำ`,
"setup_layout_message_relatedlistfield":`นอกจากเลือกฟิลด์ที่แสดงในรายการที่สัมพันธ์กันแล้ว คุณยังสามารถจัดลำดับฟิลด์ที่เลือกใหม่ได้`,
"label.relationobject.type":`ประเภทออบเจ็กต์ที่เกี่ยวข้อง`,
"UG_Account_02":`มีบางธุรกิจให้บริการกับธุรกิจอื่น มีบางธุรกิจร่วมมือกับผู้ใช้ปลายทางโดยตรง และมีบางที่ให้บริการกับองค์กร NGO`,
"UG_homepage_006":`ทำความเข้าใจกิจกรรมของลูกค้าแบบ 360 องศา ผ่านแบบสอบถาม แชทสด อีเมล ใบงาน ไปจนถึงการโพสต์โซเชียลมีเดีย และแคมเปญ (เช่น ลีด การสนับสนุนบริการ และกิจกรรมต่างๆ)`,
"chatter.poll.option1":`ตัวเลือกที่ 1`,
"label.ccdocument.fieldforld":`ชื่อโฟลเดอร์ของเอกสาร`,
"label.wei.result":`ผลโหวต`,
"label.recentview.new":`ล่าสุด`,
"label.martrixreport.setsumfield":`เลือกฟิลด์ที่ใช้เป็นแถวสรุปในรายงานเมทริกซ์ของคุณ`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`วันจันทร์`,
"label.marketsea.button.recycle":`รีไซเคิล`,
"label.standard.buttonandlink.info2":`โปรดเลือกเพจที่กำหนดเองเพื่อแทนที่ URL ของ CloudCC สำหรับปุ่มมาตรฐานหรือลิงก์`,
"label.reportsSubscription.select.two.months":`โปรดเลือกช่วงวันที่ของความถี่ภายในสองเดือน!`,
"label.standard.buttonandlink.page":`เพจ CloudCC มาตรฐาน`,
"vue_label_commonobjects_view_chart_horizontalbar":`แผนภูมิแท่งแนวนอน`,
"label.Remove":`ลบ`,
"label.mobile.phone.receivable":`ผลตอบแทน`,
"label.appupload.uploaddetail.goback":`กลับไปที่รายการโปรแกรมสำเร็จรูป`,
"label.select.role":`กรุณาเลือกบทบาท`,
"label.file.sharetype":`ประเภทการแบ่งปัน`,
"label.app.chosetab":`เลือกแท็บ`,
"label.case.other.phone":`หมายเลขโทรศัพท์มือถืออื่นๆ`,
"chatter.edit.cancel":`การเปลี่ยนแปลงของคุณถูกยกเลิก`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`การรับ auth2cn ล้มเหลว!`,
"message.error.system.service.permissiondeny":`ขออภัย คุณไม่มีสิทธิ์ใช้บริการนี้ โปรดติดต่อผู้ดูแลระบบ!`,
"label.chatter.mygroups":`กลุ่มของฉัน`,
"label.umeng.approval.approvalpass":`#obj คำขออนุมัติผ่านแล้ว #objname`,
"label.chatter.owner":`เจ้าของ`,
"vue_label_commonobjects_view_kanban_view":`มุมมองคัมบัง`,
"message.please.choose.group.role":`โปรดเลือกบทบาทของทีม`,
"label.icon.136":`สกุลเงิน`,
"label_tabpage_selectdate":`เลือกวันที่`,
"chatter.emailInformation":`ข้อมูลทั่วไป`,
"front-lightning-module-v1-dashborad-bubble-size":`ขนาดบับเบิ้ล`,
"label.stdashbord.xsld.business.wan":`หมื่น`,
"label.datamanage.field.notexist":`ไม่มีฟิลด์ที่ตรงกับออบเจ็กต์`,
"UG.Forcast.04":`เริ่มใช้`,
"UG.contact.02":`ดึงดูดผู้ติดต่อผ่านหลายช่องทาง เช่น โทรศัพท์ อีเมล โซเชียล`,
"vue_label_pool_selecttransferinto":`เลือกฐานข้อมูลที่จะโอนเข้า`,
"label.quote.xingming":`ชื่อ`,
"label.customerinfo.userlicencenum":`จำนวนใบอนุญาตใช้สิทธิ์`,
"label.group.no.my.archived":`ไม่พบกลุ่มที่เก็บถาวรที่ตรงกัน`,
"label.weixin.add.activity.tel":`เพิ่มโทรศัพท์ของกิจกรรม`,
"label.partner.setup.address":`ที่อยู่พาร์ทเนอร์คลาวด์`,
"label.data.file.i_title.num3":`3. ระบบจะอ่านไฟล์ข้อมูลก่อนที่จะนำเข้าสู่เซิร์ฟเวอร์ จากนั้นเริ่มโปรแกรมนำเข้าหลังบ้านแบบกลุ่ม ผลการนำเข้าจะแจ้งให้ผู้ใช้ทราบทางอีเมล คุณไม่จำเป็นต้องรอในหน้าการดำเนินการนี้`,
"label_sum_up":`รวม`,
"label.searchall.title":`การค้นหาระดับโกลบอล`,
"label.bind.chooseone":`เลือกเจ้าของ`,
"label.campaign.channel.input.owner.select1":`เจ้าของแคมเปญในปัจจุบัน`,
"front-kefu-moudle-v1-Expand-chat":``,
"label.component.hotdeal":`ข้อเสนอยอดนิยม`,
"component_event_label_title":`อิเวนต์ที่จะเกิดขึ้น`,
"No.planed.activity":`ไม่มีกิจกรรมที่วางแผนไว้`,
"label.searchlayout.result.field":`ฟิลด์ที่แสดงผลการค้นหา`,
"label.leadscore.value":`คะแนน`,
"vue.dashboard.linkage.is.set.successfully":`ตั้งค่าการเชื่อมโยงสำเร็จ!`,
"PersonalInfo.LoginHistory.001":`ลิงก์ของเบราว์เซอร์ยืนยันการลงทะเบียนอีเมล`,
"front-gantt-module-v1-problem-number":``,
"label.page.step5.of.step5":`ขั้นตอนที่ 5 จาก 5`,
"label.sendemail.chat.sendmessagesubject":`ข้อความแจ้งเตือนจาก CloudCC CCChat`,
"label.Linkedin_accounts":`บัญชี Linkedin`,
"label.qrcode.useful.life":`อายุของรหัสคิวอาร์`,
"deleterow":`ลบแถว`,
"label.forecast.settings.future1":`1 รอบถัดไป`,
"message.error.group.operation":`การจัดเก็บกลุ่มอย่างถาวรผิดพลาด`,
"label_tabpage_loadz":`กำลังโหลดหน้าเพจ กรุณารอสักครู่...`,
"label.brackets.left":`(วงเล็บด้านซ้าย`,
"label.source.code":`ดูรหัสต้นฉบับ`,
"setup_layout_label_areasetup":`ตั้งค่าคุณสมบัติภูมิภาค`,
"component.assistant.label.todaylead":`ลีดที่มอบหมายให้คุณในวันนี้`,
"label.qrcode_signin":`รหัสคิวอาร์จำกัดเฉพาะแอปพลิเคชันที่ต้องสแกนหน้าร้านและเข้าสู่ระบบ`,
"label.calendarshare":`แบ่งปันปฏิทิน`,
"IMG":`รูปภาพ`,
"label.use.rule.when.both":`ใช้กฎนี้เมื่อเปิดใช้งานบาร์โคดและรหัสคิวอาร์พร้อมกัน`,
"label.ccpeak.addshare.record":`บันทึกตารางแบ่งปันที่เพิ่มใหม่: ดูบันทึกที่เพิ่มใหม่`,
"label.enable.email.tracking":`เปิดใช้งานการติดตามอีเมล`,
"label.top.plsinput":`ค้นหารายการนี้...`,
"vue_label_helpcenter_case":`เคส คือความคิดเห็นหรือปัญหาของลูกค้า เจ้าหน้าที่ฝ่ายสนับสนุนสามารถตรวจสอบเคสเพื่อเรียนรู้วิธีให้บริการที่ดีขึ้น พนักงานขายสามารถใช้เคสเพื่อเรียนรู้ถึงผลกระทบต่อกระบวนการขาย การตอบสนองต่อเคสต่างๆ สามารถช่วยให้ลูกค้าของคุณพึงพอใจและยกระดับภาพลักษณ์ของแบรนด์`,
"label.useonly":`สำหรับใช้เท่านั้น`,
"label.displaytype":`ประเภทการแสดงผล`,
"label.most.user.group":`ผู้ใช้สามารถเข้าร่วมได้มากที่สุด 100 กลุ่มผู้ใช้ คุณเข้าร่วมแล้ว 100 กลุ่ม`,
"label.umeng.activity.yourevent":`อิเวนต์ของคุณ`,
"label.forecast.shrepage.classdes.w":`อ่าน/เขียน - ผู้ใช้จะสามารถดูและเขียนทับข้อมูลที่พยากรณ์`,
"label.defaultaccess":`ค่าเริ่มต้นสิทธิ์การเข้าถึง`,
"label.partner.new.step2":`ขั้นตอนที่2: ยืนยันแม่แบบ`,
"component_setup_iframe_label_title":`เพจที่กำหนดเอง`,
"label.sso.saml.sp.idenitytype":`ชนิดข้อมูลประจำตัว SAML`,
"label.dashboard.this.folder":`แดชบอร์ดในโฟลเดอร์นี้`,
"label.data.newtemplate.e.seltype.desc":`วิธีการส่งออกข้อมูลมีสองวิธี：</li><li class`,
"label.forecast.customforecast.submit.tip1":`ส่งมาจาก    ใช่หรือไม่`,
"label.version.workflow.and.approval":`เวิร์กโฟลว์และการอนุมัติอัตโนมัติ`,
"label.tianyancha.tip":`ข้อมูลไม่ถูกต้อง โปรดป้อนใหม่!`,
"label.report_details":`รายละเอียดรายงาน`,
"template.report.folder.contract.product":`การวิเคราะห์สัญญาและผลิตภัณฑ์`,
"label.all":`ทั้งหมด`,
"label.version.area.long.rich":`{0}ฟิลด์ Rich Text หรือกล่องข้อความยาว`,
"label.enc":`การเข้ารหัสการจัดเก็บข้อมูล`,
"vue_label_pricebook_enterproductname":`กรุณาใส่ชื่อผลิตภัณฑ์`,
"label.edit.quote.line":`แก้ไขบรรทัดใบเสนอราคา`,
"label.edit":`แก้ไข`,
"M":`ความสัมพันธ์ข้อมูลหลัก-ข้อมูลรอง`,
"front-kefu-phonenumber-exists":``,
"label.standardplatformuser":`ผู้ใช้แพลตฟอร์มมาตราฐาน`,
"label.custom.page.configuration":`การปรับแต่งเพจที่กำหนดเอง`,
"url.error.contact.null":`ที่อยู่ไมโครเซอร์วิสว่างเปล่า`,
"label.sethelp":`ตัวช่วยในการตั้งค่า`,
"setup.mainpage.label.welcome23":`การตั้งค่าความปลอดภัย`,
"label.sales.page.dashboard.fenxi":`แดชบอร์ดวิเคราะห์การขาย`,
"label.limit":`จำกัด`,
"maintenanceasset.asset.contractlineitem.illegal":`คุณต้องเลือกสินทรัพย์ในรายการบรรทัดสัญญาก่อนจึงจะสามารถเชื่อมโยงรายการบรรทัดสัญญากับสินทรัพย์การบํารุงรักษาได้`,
"UG.contact.04":`หรือ`,
"Opportunity.Detailed.Phase.Label.004":`วัน`,
"label.emailobject.receive":`ผู้รับ`,
"label.brief.new":`เพิ่มใหม่`,
"label.marketsea.button.adopt":`รับ`,
"label.select.up.to.three.fields":`เลือกได้สูงสุดสามฟิลด์`,
"vue_label_allsearch_noresults":`เราได้ค้นหาคําค้นหาที่คุณใช้บ่อยและไม่พบผลลัพธ์ที่ตรงกับ{userInput}`,
"Report_CantDelete_Info":`รายงาน{0}ถูกอ้างอิงโดยแดชบอร์ด{1} ไม่สามารถลบได้!`,
"label.chile.summer.time":`เวลาชิลี`,
"label.partnerCloud.menu.selectedMenu":`เมนูที่เลือก (เมนูที่เลือกจะแสดงบนอุปกรณ์มือถือด้วย)`,
"vue_label_report_onlysummary":`สรุปเท่านั้น`,
"front-template-V1-Applicable-object":`โปรดเลือกออบเจ็กต์ที่เกี่ยวข้อง`,
"label.invoice.message.sendfailed":`การส่ง Invoice ล้มเหลว กรุณาส่งใหม่ภายหลัง`,
"front-kefu-moudle-v1-use-free":`ทดลองใช้ฟรี`,
"label.rule.updated.successfully":`อัปเดตกฎสำเร็จ`,
"label.owner.lastone":`คงไว้อย่างน้อยหนึ่งเงื่อนไข`,
"label.appointment.wizard.subtitle1":``,
"template.report.opportunities.closed.month":`โอกาสทางธุรกิจที่ปิดในเดือนนี้`,
"label.tabpage.choosecontent":`โปรดเลือกเนื้อหา`,
"template.chart.jbnddxl":`ยอดสั่งซื้อในช่วงหกเดือนที่ผ่านมา`,
"label.fieldsecurity.detail":`รายละเอียดข้อมูลความปลอดภัยของฟิลด์`,
"label.knowledgebase.data.deleted.successfully":`ลบข้อมูล {a} รายการสําเร็จ`,
"label.sso.saml.idp.config.nameidfmt":`รูปแบบ ID ชื่อ`,
"label.emailobject.prompt":`แจ้งเตือน`,
"label.marketsea.isgetbyself":`อนุญาตให้สมาชิกรับด้วยตนเองได้`,
"label.winxin.cancelprompt":`ไม่ได้บันทึกการดำเนินการปัจจุบัน ยืนยันที่จะออกหรือไม่`,
"label.appexchange.installedpage.message2":`แอปพลิเคชันและส่วนเสริมถูกติดตั้งในรูปแบบของโปรแกรมสำเร็จรูป แอปพลิเคชันที่กำหนดเอง แท็บ ออบเจ็กต์ที่กำหนดเอง เพจที่กำหนดเอง และทริกเกอร์ตอนเริ่มต้นจะถูกระบุว่า "อยู่ระหว่างการพัฒนา" ทำให้ผู้ใช้ไม่สามารถใช้งานได้ สิ่งนี้ช่วยให้คุณสามารถทดสอบและปรับแต่งพวกมันก่อนการปรับใช้ คุณสามารถใช้ฟังก์ชันอื่น ๆ ในการตั้งค่าเพื่อเปิดใช้งานส่วนเสริมทีละรายการ หรือคลิกปรับใช้เพื่อปรับใช้ส่วนเสริมหนึ่งรายการ`,
"vue_label_import_importtype":`ประเภทการนำเข้า`,
"label.data.importef.des":`ไฟล์ที่นำเข้าไม่สำเร็จจะถูกเก็บไว้บนเซิร์ฟเวอร์เป็นเวลา 48 ชั่วโมง และจะถูกลบโดยอัตโนมัติหลังจาก 48 ชั่วโมง`,
"chatter.email.reply":`เมื่อตอบกลับโพสต์ของฉัน`,
"label.stdashbord.xsld.business.sdl":`อัตราการสูญเสียคำสั่งซื้อ`,
"labal.emailtemplate.namemessage":`มีชื่อเฉพาะของแม่แบบอีเมลนี้แล้ว โปรดแก้ไขอีกครั้ง`,
"vue_label_email_Please_select_file":`โปรดเลือกไฟล์`,
"label.event.modify":`แก้ไขอิเวนต์`,
"label.projectManagement.isnmber":`โปรดป้อนตัวเลขที่มีทศนิยมไม่เกินหนึ่งตำแหน่ง`,
"lable.outlook.detail.emailst":`ตั้งค่าอีเมล`,
"label.partnerCloud.priceOfManual.isUsed":`การตั้งค่านี้ส่งผลกระทบต่อผู้ใช้พาร์ทเนอร์ว่าเมื่อสั่งซื้อจะสามารถใช้สมุดราคาได้หรือไม่`,
"setup_mainpage_label_welcome26":`การจัดการข้อมูล-แบทช์`,
"label.file.version":`รุ่น`,
"pagecreator_systemstyle_label_bordercolor":`สีเส้นขอบ`,
"label.approval.isallowed.reject.prompt":`เมื่ออนุมัติข้อมูลเดียว อนุญาตให้ปฏิเสธหรือไม่ (การอนุมัติแบบชุดปฏิเสธได้เสมอ)`,
"label.myinfo":`ข้อมูลของฉัน`,
"front-template-V1-fontSize":`ขนาดตัวอักษร`,
"lable.outlook.edit.alpreo":`เลือก Exchange ก่อนเสมอ`,
"front-email-payment-card-number":``,
"label.cpq.quote.pricebook.no.change":`เมื่อกำหนดสมุดราคาสำหรับใบเสนอราคาแล้วจะไม่สามารถเปลี่ยนแปลงได้ หากคุณใช้สมุดราคาใหม่ โปรดสร้างบันทึกใบเสนอราคาใหม่`,
"vue_label_file_size_limit_tip":`ขนาดไฟล์เกินขีดจำกัด`,
"lable.PowerProcess.worktime":`เวลาทํางานของกระบวนการให้สิทธิ์`,
"label.monthly.month.report":`รายงานอัตราการเติบโต (MOM)`,
"front-kefu-moudle-v1-sydq-buyuser":`การทดลองใช้ของคุณหมดอายุแล้ว โปรดใช้หลังจากซื้อบัญชี Easemob`,
"label_tabpage_Rolesz":`บทบาทและผู้ใต้บังคับบัญชา`,
"chatter.f.n":`ติดตามบันทึก`,
"UG.Forcast.02":`การพยากรณ์เป็นการประมาณการยอดขายของสเตจที่กำหนด รูปแบบการพยากรณ์สามารถช่วยคุณกำหนดความต้องการผลิตภัณฑ์และรายได้จากการขายในช่วงระยะเวลาหนึ่ง ผู้ควบคุมสามารถใช้การพยากรณ์เพื่อกำหนดเป้าหมายและประเมินความก้าวหน้าของทีมได้ การพยากรณ์ทั้งหมดขององค์กรจะสามารถสะท้อนภาพรวมการขายของพนักงานขายได้ (โดยไม่คำนึงถึงความสมบูรณ์ระหว่างไปป์ไลน์และการปิดการขาย)`,
"label.productsales.contract.phb":`การจัดอันดับสัญญา`,
"label.umeng.insert.approval.submit":``,
"message.duplication.label.matchfirstletters":`จับคู่อักขระ n ตัวแรก`,
"label.partnerCloud.partnerAccount.toPay":`ไปชําระเงิน`,
"label.model.un":`รุ่น: UN6786`,
"label.save.c1":`ชื่อของ web to CloudCC ไม่สามารถซ้ำได้!`,
"week":`สัปดาห์`,
"Pagelayout.Setup.003":`ต้องเลือกฟิลด์ Name`,
"label.query.detail.openpartnermessage":`เมื่อเปิดใช้งานลูกค้าเป็นพาร์ทเนอร์แล้ว ลูกค้าจะปรากฏในรายงานที่กรองแล้วและมุมมองรายการในฟิลด์ isPartner นอกจากนี้ผู้ใช้พาร์ทเนอร์ก็สามารถสร้างจากผู้ติดต่อที่เชื่อมโยงกับลูกค้ารายนี้ คุณแน่ใจหรือไม่?`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(date)`,
"label.apply.send.false":`การส่งล้มเหลว`,
"label.recordtype.edit.selectvalue":`ค่ารายการตัวเลือก`,
"label.chosesubject":`เลือกหัวข้อ`,
"label.validate.function.funcExplain.YEAR":`ส่งกลับปีของวันที่ ตัวเลขระหว่าง 1900 ถึง 9999`,
"component.chatter.button.more":`ดูรายละเอียดเพิ่มเติม`,
"label.top.class.smallest":`ระดับขั้นต่ำสุดคือ 1`,
"label.startingvalue":`หมายเลขเริ่มต้น`,
"label.multi.layout.remark":`นำไปใช้กับเค้าโครงทั้งหมดที่แสดงเมื่อเพิ่มรายการมาสเตอร์อินพุตจำนวนมากที่หน้าเว็บ`,
"label.role.availableuser":`ตัวเลือกผู้ใช้`,
"label.weixin.iebrowser":`เบราว์เซอร์ที่คุณใช้อยู่ในปัจจุบันคือ IE6 ซึ่ง เผยแพร่โดยไมโครซอฟท์ในปี 2544 ระบบ CloudCC ใช้เทคโนโลยีใหม่ในการพัฒนา เนื่องด้วยเบราว์เซอร์รุ่นนี้ต่ำเกินไปจึงไม่รับประกันว่าจะใช้งานฟังก์ชันได้ปกติทั้งหมด กรุณาอัปเดตเบราว์เซอร์ของคุณ`,
"Homepage_News_004":`ไม่มีข่าวสาร`,
"vue_label_normal_task_sf":`ภารกิจ`,
"label.version.nonsupport.trigger":`ไม่รองรับทริกเกอร์!`,
"pagecreator_page_label_pagelayout":`เค้าโครงเพจ`,
"label_tabpage_step3":`ขั้นตอนที่ 3: เลือกฟิลด์ที่จะให้แสดง`,
"label.canOnlyUploadCSVFormatFile":`สามารถอัปโหลดได้เฉพาะไฟล์ในรูปแบบ csv เท่านั้น`,
"label.b.c.least":`บันทึก B" แต่ละบันทึก ต้องมีความสัมพันธ์กับบันทึก "C" อย่างน้อยหนึ่งรายการ`,
"label.list.userinterface.sales.enable":`สิทธิ์การเข้าดูข้อมูลการจัดลำดับในหน้าแรกการขาย`,
"label.umeng.approval.approvalreject":`คำขอ#objถูกปฏิเสธ#objname`,
"vue_labenl_normal_notice_share_fail":`การแบ่งปันล้มเหลว`,
"label_emailtocloudcc_tip":`แจ้งเตือน`,
"label.h5.touchselect":`คลิกเลือก`,
"label.tabularreport":`รายงานแบบตาราง`,
"label.app.defaulttab":`แท็บเริ่มต้น`,
"label.validate.function.category.Datetime":`วันที่และเวลา`,
"vue_label_pricebook_editdetail":`แก้ไขรายการสมุดราคา`,
"vue_label_commonobjects_view_no_selected_record":`บันทึกที่ไม่ได้เลือก`,
"chatter.changed":`จะ`,
"label.asset.bom.based":`สร้าง BOM สินทรัพย์ตามโครงสร้างผลิตภัณฑ์ที่สั่งซื้อ`,
"label.appointmentdetail.wizard.title8":`เริ่มบ่อยแค่ไหน`,
"label.area.query.user.error":`ไม่สามารถสืบค้นข้อมูลผู้ใช้ที่สอดคล้องกับภูมิภาค และ ID ภูมิภาค ว่างเปล่า`,
"page.field.masterinput":`ตั้งค่ามาสเตอร์อินพุต`,
"chatter.selads":`เลือกผู้รับ`,
"label.data.exp.please.savebutton":`โปรดเลือก "บันทึกเป็นแม่แบบ"`,
"label.members.activity":`สมาชิกที่ใช้งานอยู่`,
"label.weixin.click.searchs":`คลิกเพื่อค้นหาบันทึก`,
"label.input.least.two":`กรุณาใส่อักขระอย่างน้อยสองตัว`,
"label.marketing.seting":`การตั้งค่า Marketing Cloud`,
"label.approveprocess.tip":`การอนุมัติเป็นกระบวนการทางธุรกิจที่ซับซ้อน ซึ่งต้องรวบรวมและวางแผนข้อมูลก่อนดำเนินการ ขอแนะนำให้คุณปฏิบัติตามคำแนะนำด้านล่างก่อนเริ่ม`,
"front-email-payment-Invoice-login-account":``,
"label.selectmulti.mes":`ผู้รับที่เลือกมากเกินไป`,
"label.workflow.gotolist":`ย้อนกลับไปที่รายการเวิร์กโฟลว์`,
"label.profile.fieldsafety":`ความปลอดภัยระดับฟิลด์`,
"front-project-module-v1-no-selectemplat":`ในขณะนี้ไม่มีแม่แบบพร้อมใช้งาน`,
"label.sendemail.queue.assigntitle":`อีเมลแจ้งเตือนบันทึกออบเจ็กต์การจัดสรรคิว`,
"label.approval.mobile.comments.placeholder":`กรุณาใส่หมายเหตุตรงนี้ มากที่สุด 1,000 อักษร`,
"vue_label_report_given":`เฉพาะ`,
"vue_label_dashboard_groups":`กรุณาเลือกกลุ่ม`,
"label.service.gantt.popoverTip":`ระยะทางในการเดินทางคาดการณ์ / ระยะเวลาคาดการณ์`,
"label.mr.title.characters":`ตามอักขระกี่ตัวแรก`,
"label.passwordPolicy.setup.day":`วัน`,
"label_tabpage_personvisible":`พนักงานที่เกี่ยวข้องสามารถมองเห็น`,
"ct":`หลายสกุลเงิน`,
"label.chatter.newEvent":`อิเวนต์ใหม่`,
"vue_label_systemSettings_id":`ไอดีในการเข้าสู่ระบบ`,
"label.page.preview.web.tab":`ดูตัวอย่างแท็บ Web`,
"label_emailsync_button_sure":`ยืนยัน`,
"front-template-V1-Modification-time":`เวลาแก้ไข`,
"vue_label_homepage_edit_fixed_components":`แก้ไขส่วนเสริมมาตรฐาน`,
"label.apply":`ปรับใช้`,
"Main.Menu.Mobiledownload":`สามารถใช้สำหรับ`,
"vue_label_salesfunnel_notice6":`ความน่าจะเป็นของจำนวนเงินทั้งหมดของโอกาสทางธุรกิจ 100%`,
"label.chosesubject.sendemail":`ส่งอีเมล`,
"label.changemydisplay.chagetab.des":`เลือกแท็บที่คุณต้องการแสดงในแต่ละแอปพลิเคชัน`,
"label.attendance.setting.checkUser":`มีอยู่แล้วในบันทึกเวลาทำงานอื่น`,
"label.list.projectSetting.setup":`การตั้งค่าการจัดการโครงการ`,
"label.app.introduce2":`คุณสามารถปรับแต่งแอปพลิเคชันที่มีอยู่ให้เข้ากับวิธีการทํางานของคุณ หรือสร้างแอปพลิเคชันใหม่โดยการจัดกลุ่มเมนูมาตรฐานและเมนูแบบกําหนดเอง`,
"label_emailsync_form_emialpassword":`รหัสผ่าน`,
"label.Lightning.Setting":`การตั้งค่า Lightning`,
"label.print.preview":`ตัวอย่างการพิมพ์`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`คุณยังต้องการสร้างอิเวนต์นี้ในช่วงเวลานี้หรือไม่?`,
"label.mobile.phone.report.type":`ประเภทรายงาน`,
"lable.account.CalenderWeek":`สัปดาห์ปฏิทิน`,
"label_emailtocloudcc_step3total3":`ขั้นตอนที่ 3 จาก 3`,
"label_tabpage_emailaddressz":`ที่อยู่อีเมลผู้ส่ง`,
"label.data.is_woking":`กำลังดำเนินการ`,
"label.knowledge.cancelattach.case":``,
"label.sendemail.chat.chatcontent":`เนื้อหาโพสต์หลัก:`,
"label.timezone.set":`ตั้งค่าโซน`,
"label_tabpage_uploadingz":`กำลังอัปโหลด`,
"front-epwechat-module-v1-home-url":`URL หน้าแรก:`,
"label.reportsSubscription.select.subscription.frequency":`โปรดเลือกความถี่ในการสมัครสมาชิก!`,
"label.validate.function":`ฟังก์ชัน`,
"label.partnerCloud.orderingPlatform.quantity":`จำนวนการซื้อ`,
"label.compact.layout.chatter":`เวยเทีย`,
"label.sso.saml.sp.description2":`ปรับแต่ง SSO เพื่อความสะดวกในการล็อกเข้าสู่ระบบ CloudCC จากภายนอก`,
"label.ccchat.message.new.error1":`เราไม่พบผู้ใช้ Chat ใดที่ชื่อประกอบด้วย{0}`,
"label.file.share.email.content3":`โปรดเข้าสู่ระบบ CloudCC CRM เพื่อตรวจสอบข้อมูลเฉพาะ`,
"label.file.cancel.sharing":`ยกเลิกการแบ่งปัน`,
"label.changemydisplay.showalltabs.add":`เพิ่มแท็บลงในการแสดงผลเริ่มต้น`,
"label_chatter_incident":`เหตุการณ์`,
"label.file.folder.delete3":`ยืนยันว่าต้องการลบ {foldername} หรือไม่？`,
"label_tabpage_delsuccessz":`การลบสำเร็จ`,
"label.view_contact":`ดูผู้ติดต่อ`,
"label.deactivate":`ปิดการใช้งาน`,
"label.Horizontal.Date":`กรองการนัดหมายการบริการตามวันที่แนวนอน`,
"label.forecast.tree.title":`ลำดับชั้นการพยากรณ์`,
"vue_label_dashboard_dategruop":`โปรดเลือกเกณฑ์การจัดกลุ่มวันที่`,
"label.version.nonsupport.custompage":`ไม่รองรับหน้าเพจที่กำหนดเอง!`,
"label.tabpage.personvisible":`พนักงานที่เกี่ยวข้องสามารถมองเห็น`,
"message.error.unknown":`ข้อผิดพลาดที่ไม่รู้จัก;`,
"label.down":`ลง`,
"label.multilang.customforcast.financialyear":`ปีงบประมาณที่ {0}`,
"label.dataimport.type.error":`ประเภทผิด โปรดตรวจสอบบันทึกนี้อย่างละเอียดและแก้ไข`,
"label.batchadd.newbatchpage.save.num":`รูปแบบตัวเลขไม่ถูกต้อง`,
"front-Dev-V12.2.8-calendar-endField":`ฟิลด์สิ้นสุด`,
"label.tabpage.rtemptyz":`ชนิดบันทึกไม่สามารถว่างเปล่า`,
"vue_label_dashboard_maximum":`โปรดใส่ค่าสูงสุด`,
"label.expiredate":`วันหมดอายุ`,
"label_emailtocloudcc_button_view":`มุมมอง`,
"label.event.future":`อิเวนต์ในอนาคต`,
"label.mobile.app.layout":`เค้าโครงสำหรับอุปกรณ์มือถือ`,
"label.emailobject.contacts":`ผู้ติดต่อ`,
"label.approvalstep2.tip":`ก่อนเข้าสู่ขั้นตอนนี้ยืนยันว่าบันทึกนี้สอดคล้องกับเงื่อนไขหรือไม่`,
"label.usefollowtoset":`ใช้ตัวเลือกดังต่อไปนี้เพื่อระบุผู้ใช้ที่ควรมอบหมายคำอนุมัติ`,
"label.dashboard.summary.editPageHeader":`แก้ไขส่วนหัวของหน้า`,
"label_partner_workspace_tab_memo":`เลือกแท็บที่สามารถใช้ได้ในพาร์ทเนอร์คลาวด์นี้ สามารถเลือกแท็บมาตรฐานของระบบและแท็บที่กำหนดเองได้`,
"front-lightning-module-v1-details-page-chart-title-supports":`หัวข้อสามารถแทรกชื่อบันทึกในรูปแบบ{recordname} เช่น: ชื่อสำหรับยอดเงินรวมของโอกาสทางธุรกิจ{recordname} และชื่อบันทึกปัจจุบันคือ CloudCC จะแสดงชื่อว่า "ยอดเงินรวมของโอกาสทางธุรกิจของ CloudCC";`,
"label.enable.generate.location.service":`เปิดใช้งานบริการสร้างข้อมูลละติจูดและลองจิจูดของลูกค้าตามที่อยู่ของลูกค้า`,
"label.loginsystem":`ระบบการเข้าสู่ระบบ`,
"label.email.template.edit.template":`แก้ไขแม่แบบ`,
"vue_label_commonobjects_detail_share":`ส่วนแบ่งรายได้`,
"label.icon.142":`บ้าน`,
"label.maintype":`ประเภทหลัก`,
"label.step2.total4":`ขั้นตอนที่ 2 จาก 4`,
"label.select.intended.tablayout":`เลือกเค้าโครงเพจสําหรับแท็บ Web ที่คุณต้องการสร้าง`,
"label.custom.unit":`หน่วย`,
"label.mr.title.phone":`โทรศัพท์`,
"label.compact.layout.frame.showtype":`วิธีการแสดง：`,
"label.associations":`ออบเจ็กต์ที่เกี่ยวข้อง`,
"label.potentialcustomers.name":`ชื่อลีด`,
"label.edit.profile":`อัปเดตโปรไฟล์`,
"label.tabpage.allvisible":`ผู้ใช้ทั้งหมดมองเห็น`,
"label.login.verification.confirmation.enabled":`ยืนยันเปิดการใช้งาน`,
"vue_label_norm_recordselected":`เลือกข้อมูลแล้ว {selectNum} รายการ`,
"label.partner.workspace.member.selectedprofile":`โปรไฟล์ที่เลือก`,
"label.divide":`/ หาร`,
"label.version.case.control":`การจัดการ Case`,
"label.attendance.nocheckin":`ยังไม่บันทึกเวลาเข้างาน`,
"vue_label_helpcenter_report2.1":`2. ลบการจัดกลุ่มแถว: <br> A. หลังจากพบฟิลด์ "การจัดกลุ่มแถว" ที่คุณต้องการลบในรายการ "แถวกลุ่ม" ทางด้านซ้าย ให้คลิก "×" บนฟิลด์ <br> B. หรือค้นหาฟิลด์ "การจัดกลุ่มแถว" ที่คุณต้องการลบในส่วนหัวของรายงานตัวอย่างทางด้านขวา คลิก "ปุ่มแบบf7ลง" และคลิก "ลบแถวกลุ่ม" <br> ลบการจัดกลุ่มคอลัมน์: <br> A. หลังจากพบฟิลด์ "'การจัดกลุ่มคอลัมน์" ที่คุณต้องการลบในรายการ "คอลัมน์กลุ่ม" ทางด้านซ้าย ให้คลิก "×" บนฟิลด์ <br> B. หรือค้นหาฟิลด์ "กลุ่มคอลัมน์" ที่คุณต้องการลบในส่วนหัวของรายงานตัวอย่างทางด้านขวา คลิกปุ่มแบบดึงลง แล้วคลิก "ลบคอลัมน์กลุ่ม" <br>•กำหนดรายละเอียดวันที่เพื่อจัดกลุ่มบันทึก<br> ขั้นตอนที่ 1: หลังจากจัดกลุ่มบันทึกตามฟิลด์วันที่ คุณยังสามารถปรับแต่งรายละเอียดวันที่ ขั้นแรก เลือกฟิลด์วันที่ที่คุณต้องการจัดกลุ่มรายงานตาม จากนั้นคลิก "ปุ่มแบบดึงลง" ถัดจากฟิลด์นี้ในส่วนหัวของรายงานตัวอย่าง แล้วคลิก "จัดกลุ่มวันที่ตาม" <br>`,
"label.payment.renew":`ต่ออายุ`,
"vue_label_file_wrong_type":`ประเภทการอัปโหลดไฟล์ไม่ถูกต้อง รูปแบบของไฟล์ที่คุณกำลังอัปโหลดคือ {type}!`,
"UG_opportunity_005":`กระบวนการขายมากมาย`,
"label.knowledge.language.korean":`ภาษาเกาหลี`,
"label.customobjects.inputrecordtagandformat":`ใส่ป้ายกำกับและรูปแบบของบันทึก`,
"label.h5.chatter.commentednum":`ได้รับการตอบกลับแล้ว`,
"label.quickbooks.button.unlink":`ยกเลิกการเชื่อมต่อ`,
"label.step5.total5":`ขั้นตอนที่ 5 จาก 5`,
"label.projectManagement.Selweek":`เลือกสัปดาห์`,
"label.optional.searchfield":`ตัวเลือกฟิลด์ค้นหา`,
"label.mobile.quickcreate.default.signin":`ลงทะเบียนเข้า`,
"label.visualpage.unable.parse":`แท็กที่แก้ไขไม่ได้`,
"mesage.error.role.delete":`ไม่สามารถลบบทบาทได้ เนื่องจากขณะนี้ถูกกำหนดให้เป็นบทบาทย่อย`,
"label.role.user":`ผู้ใช้ในบทบาท`,
"button_partner_workspace_saveas":`บันทึกเป็น`,
"label.file.no.public.link.created":`ไม่ได้สร้างลิงก์สาธารณะ`,
"label.login.access.shenyu":`คงเหลือ`,
"label.ccchat.group.section":`กลุ่ม`,
"label.weixin.object.notnull":`หัวข้อไม่สามารถว่างเปล่า`,
"label.accmarketsea.add.title":`สร้างฐานข้อมูลลูกค้าใหม่`,
"label.sales.funnel.layout":`เค้าโครงกรวยการขาย`,
"pagecreator.page.button.edit":`แก้ไข`,
"label_tabpage_entercontent":`กรุณาใส่เนื้อหา`,
"component_event_label_begindate":`*เวลาเริ่มต้น`,
"label.file.versionhref":`ข้ามไปที่หน้าเพจรุ่นใหม่ &gt;&gt;`,
"label_chatter_send":`ส่ง`,
"setup_layout_label_buttonlist":`เลือกปุ่ม`,
"label.custom.Current.and.NexttCQ":`ไตรมาสที่กำหนดเองปัจจุบันและสามไตรมาสหน้า`,
"pagecreator_page_label_pagedesc":`คำอธิบายหน้าเพจ`,
"label.appupload.upload.uploader":`ผู้อัปโหลด`,
"label.console.step5.tab.primary":`เป็นแท็บหลัก`,
"vue_label_globalsearch_expandlist":`ขยายรายการ`,
"label.forecast.edit.userqu":`เป้าหมายของ`,
"label.step1.total5":`ขั้นตอนที่ 1 จาก 5`,
"label.multilang.dupicatecheck.onegroupredata":`ความคืบหน้าของการตรวจสอบซ้ำและผสาน: ทั้งหมด {0} กลุ่ม：`,
"vue_label_systemSettings_repeat":`จัดการการทําซ้ํา`,
"label.mobile.side.tab.error1":`โปรดเลือกฟังก์ชันที่ใช้บ่อยและแท็บแอปพลิเคชันที่ต้องการให้แสดง`,
"label.knowledgebase.reduction":`เรียกคืน`,
"label.standard.buttonandlink.override.usedefault":`ไม่ครอบคลุม (ปรับใช้ค่าเริ่มต้น)`,
"dateandtime":`วันที่/เวลา`,
"label.group.activate.info":`เปิดการใช้งานกลุ่ม`,
"label.triggertotask":`ทริกเกอร์ภารกิจ`,
"label.emailobject.save.template":`บันทึกเป็นเทมเพลต`,
"label.audit.objInfo":`รายละเอียดการตรวจสอบ`,
"label.callcenter.successfully.logged.account":``,
"label_new_customer_target":`เป้าหมายลูกค้าใหม่`,
"label.campaign.channel.step5":`ขั้นตอนที่ 5: ดูตัวอย่างหน้าการลงทะเบียนของช่องทางการขายและรหัสต้นฉบับ`,
"label.log.type":`ประเภทการดำเนินการ`,
"front-template-V1-noTemplate":`ไม่มีแม่แบบที่พร้อมใช้งานภายใต้ออบเจ็กต์การเปลี่ยนปัจจุบัน`,
"label_report_line_daixuan":`คอลัมน์รายงานที่รอเลือก`,
"label.tianyancha.businessverify.relation.tip":`เขียนฟิลด์ที่เทียนเหยี่ยนฉาส่งคืนไปยังฟิลด์ลูกค้า`,
"label.default.value":`ใช้ค่านี้เป็นค่าเริ่มต้นสำหรับรายการตัวเลือกหลัก`,
"label.weixin.campaign.attendance":`ลงทะเบียนเข้าแคมเปญ`,
"message.duplication.label.check":`ตรวจสอบ`,
"label.salescloud.salescloud.yes2forbidden":`ใช่ ปิดการขายแบบทีม`,
"lable.currencyAdv.exchagecurrency.rate":`ขอบเขตอัตราแลกเปลี่ยน`,
"lable.Hide.title":`ซ่อนหัวข้อ`,
"label.finishedreport":`รายงานที่สร้างแล้ว`,
"vue_label_account_business":`โอนย้ายโอกาสทางธุรกิจที่จบแล้วของเจ้าของลูกค้า`,
"vue_label_pool_assigned":`แจกจ่ายแล้ว`,
"label.report.export.error":`การส่งออกผิดปกติ โปรดลองอีกครั้ง`,
"label.layout.availablefield":`ฟิลด์พร้อมใช้งาน`,
"label.licence.remainder":`จำนวนใบอนุญาตที่เหลือ`,
"label.approval.idea.required":`ต้องมีความเห็นการอนุมัติ`,
"front-kefu-moudle-needhand-createcase":``,
"label.dashboard.snapshot.Data.change":`แหล่งข้อมูลมีการเปลี่ยนแปลง โปรดตั้งค่าใหม่`,
"label.partner.workspace.login.footertext":`ข้อความส่วนท้าย`,
"vue_label_chatter_upload_link_type":`เลือกอัปโหลดโพสต์ลิงก์แล้ว`,
"front-dialog-module-v1-error-detail":`รายละเอียดข้อผิดพลาด`,
"label.emailobject.sendgroupemail":`ส่งอีเมลแบบกลุ่ม`,
"lable.newtabpage.allviews":`มุมมองทั้งหมด`,
"label.khdd":`ที่อยู่ลูกค้า`,
"vue_label_dashboard_sortfield":`เรียงลําดับฟิลด์`,
"label.form.sample":`ตัวอย่างฟอร์ม`,
"component_setup_button_cancel":`ยกเลิก`,
"vue_label_salesfunnel_notice5":`ความน่าจะเป็นของยอดเงินโอกาสทางธุรกิจ 1%-99% * ความน่าจะเป็น`,
"pagecreator_systemstyle_label_modifystyle":`ตัวแก้ไขรูปแบบ`,
"UG_homepage_001":`ปิดการขายสำเร็จมากขึ้นในเวลาที่สั้นลง`,
"label.campaign.pc":`สำหรับคอมพิวเตอร์`,
"label.visualpage.lightning":`รุ่น Lightning`,
"label.knowledge.category.hint.two":`หลังจากสร้างกลุ่มหมวดหมู่แล้ว ให้ใช้เพจนี้เพื่อเลือกกลุ่มที่ Lightning ควรใช้`,
"label.south.africa.standard.time":`เวลามาตราฐานแอฟริกาใต้`,
"label.service.gantt.reservation.number":`หมายเลขการนัดหมาย`,
"label.weixin.report.period":`ระยะเวลา`,
"label.leadtomap.exp":`แม็ปฟิลด์แบบกําหนดเองของลีดแต่ละฟิลด์ขององค์กรกับฟิลด์ลูกค้า ผู้ติดต่อ หรือโอกาสทางธุรกิจแบบกําหนดเอง การแม็ปเหล่านี้จะถูกใช้เมื่อลีดข้ามสเตจ`,
"label.currency.d":`สามารถเปลี่ยนสกุลเงินของบริษัทเป็นสกุลเงินอื่นที่องค์กรของคุณรองรับ โดยอัตราแลกเปลี่ยนทั้งหมดที่กำหนดไว้ในระบบจะได้รับการแก้ไขเพื่อให้สอดคล้องกับการเปลี่ยนแปลงนี้`,
"label.forecast.detailforecast.oppyclb":`หมวดการพยากรณ์โอกาสทางธุรกิจ`,
"label.reportsSubscriptionPage.email.selected":`สมาชิกที่เลือก`,
"vue_label_homepage_componentname":`กรุณาใส่ชื่อส่วนเสริม`,
"lable.account.Previous.FYt":`สองปีงบประมาณแรก`,
"label.appupload.success":`อัปโหลดเสร็จแล้ว`,
"label.customer.newtab":`แท็บเพจที่กำหนดเองใหม่`,
"label.value.notnull":`ค่าไม่สามารถว่างเปล่า`,
"label.case.miniprogram.layout":`ลูกค้าสร้างเคส: ใช้เค้าโครงหน้าเพจนี้เมื่อลูกค้าส่งคำขอบริการผ่านเว็บเพจหรือมินิโปรแกรมของวีแชท ซึ่งเค้าโครงนี้สามารถแก้ไขได้แต่ไม่สามารถลบได้`,
"label.partnerCloud.partnerAccount.twoDecimal":`กรุณาใส่รูปแบบที่ถูกต้อง คุณสามารถเก็บทศนิยมสองตำแหน่งไว้`,
"UG.Lead.004":`Web ฟอร์ม`,
"label.umeng.activity.event.eventwillbeginnew":`แจ้งเตือนอิเวนต์: #event เวลาเริ่มต้น #begintime`,
"label.projectManagement.subtasks":`งานย่อย`,
"vue_label_checkduplicate_repeat_conditions":`กําหนดเงื่อนไขการทําซ้ํา`,
"label.subject":`หัวข้อ`,
"label_search_otherusers_forecast":`ค่นหาการพยากรณ์ของผู้ใช้อื่น`,
"label_tabpage_namemandatory":`ต้องระบุชื่อมุมมอง`,
"label.timezone.importtimezone":`ข้อมูลนําเข้าการตั้งค่าโซนเวลาของฟิลด์วันที่และเวลา`,
"label.mobile.buttom.team.init":`การเริ่มต้นผู้ใช้กลยุทธ์กลุ่ม`,
"label.checkfield.choosefield":`โปรดเลือกฟิลด์ที่คุณต้องการตรวจสอบ`,
"label.b_c_least":`บันทึก B" แต่ละบันทึก ต้องมีความสัมพันธ์กับบันทึก "C" อย่างน้อยหนึ่งรายการ`,
"label.knowledge.setting.hint.five":`เลือกผู้เขียน Knowledge`,
"label.h5.similar.opportunity.step2":`ขั้นตอนที่ 2. กำหนดเงื่อนไขการจับคู่`,
"label.page.style.imbedded.cloudcc":`ใช้รูปแบบเต็มหน้าจอเพื่อเพิ่มมุมมองของเนื้อหา หน้าจอที่ฝังอยู่ในหน้าต่าง CloudCC.com`,
"label.sendemail.marketactivity.invitecode":`รหัสเชิญเข้าร่วมแคมเปญ#campaignname`,
"label.block.pricing":`การตั้งราคาแบบแยกส่วน`,
"message.error.field.number.zero":`รูปแบบการป้อนความยาวผิดพลาด ไม่สามารถเป็น 0`,
"pagecreator.systemstyle.message.save.success":`การบันทึกรูปแบบสำเร็จ`,
"pagecreator_systemstyle_label_styledesc":`คำอธิบายรูปแบบ`,
"APPIntegration_Dropbox_setting_01":`เปิดการใช้งาน`,
"label_emailtocloudcc_redmessage2":`กรุณาป้อนรหัสผ่านอีเมลที่ถูกต้อง`,
"label.user.special.operations":`การดําเนินงานเฉพาะไม่สามารถใช้ชั่วคราว โปรดติดต่อผู้ดูแลระบบ!`,
"pagecreator_page_label_layoutpreview":`แสดงตัวอย่างเค้าโครง`,
"APPIntegration_Dropbox_setting_03":`การเปิดใช้งาน Dropbox ช่วยให้คุณสามารถเลือกไฟล์จาก Dropbox ได้โดยตรง`,
"label.sure_leave":`คุณแน่ใจนะว่าจะออกจากระบบ`,
"label.applt.copylink":`คัดลอกลิงก์มินิโปรแกรม`,
"label_tabpage_allpotentialcustomers":`ลีดทั้งหมด`,
"label.rulestrikedate":`วันที่เรียกกฎ`,
"label_tabpage_justsz":`เพิ่งจะ`,
"label.customize.memory.function.sorting.title":`ปรับแต่งฟังก์ชั่นหน่วยความจำรายการของฉัน`,
"message.duplication.label.mergebutton":`ผสาน`,
"chatter.group.cancelRequest":`ยกเลิกคำขอ`,
"label.campaign.channel.step6.remark":`หากยืนยันหน้าการลงทะเบียนแล้วให้คลิกปุ่มสร้าง จากนั้นระบบจะสร้างหน้าการลงทะเบียนให้คุณ`,
"label.appupload.upload.install.abort":`ยกเลิกการติดตั้ง`,
"label.emailobject.proposetimes":`ตารางการนัดหมาย`,
"label.probability.cannot.empty":`ความน่าจะเป็นไม่สามารถว่างเปล่า และต้องเป็นตัวเลข`,
"vue_label_homepage_editkanban":`แก้ไขคัมบัง`,
"lable.Related.template":`แม่แบบที่เกี่ยวข้อง`,
"label.cloudccclass.list.cls.time":`คลาสตัวจับเวลา`,
"component.task.label.enddate":`วันหมดอายุ`,
"label.sendmail.step3":`ขั้นตอนที่ 3: ตรวจสอบและยืนยัน`,
"label.projectManagement.Gridview":`มุมมองแบบกริด`,
"label.emailobject.time":`เวลาส่ง`,
"label.applt.address":`ที่อยู่มินิโปรแกรมพอร์ทัลการบริการลูกค้า`,
"label.searchfield":`ฟิลด์การค้นหา`,
"vue_label_calendar_please_enter_the_name":`กรุณากรอกชื่อ`,
"label.list.userinterface.default.page.setup":`อินเทอร์เฟซเริ่มต้นของระบบ`,
"label.detail.2018":`รายละเอียด`,
"label.webtocloudcc.success":`ส่งข้อมูลของคุณเรียบร้อยแล้ว ขอบคุณสำหรับการมีส่วนร่วม เราจะให้บริการคุณด้วยใจจริง!`,
"component_telerecord_label_title":`บันทึกการโทร`,
"label.setting.sureDelete.rules":`ยืนยันว่าจะลบกฎนี้หรือไม่?`,
"vue_label_email_current_theme":`การแทรกแม่แบบนี้จะเขียนทับหัวเรื่องอีเมลปัจจุบัน`,
"lable.Order.product":`ผลิตภัณฑ์ที่สั่งซื้อ`,
"UG_product_02":`ผลิตภัณฑ์หมายถึงผลิตภัณฑ์หรือบริการที่ขายหรือซื้อ`,
"label.appexchange.task":`งานเวิร์กโฟลว์`,
"label.selectprocesscondition":`ระบุเงื่อนไขขั้นตอน`,
"label.mobile.quickcreate.default.scan":`สแกน`,
"label.tabpage.prepagez":`แต่ละหน้าแสดง`,
"label.query.error":`การสืบค้นผิดพลาด`,
"label.tabularreport.2018.step1":`ขั้นตอนที่ 1: เลือกคอลัมน์รายงาน`,
"pagecreator.systemstyle.label.modifystyle":`ตัวแก้ไขรูปแบบ`,
"label.app.step3":`ขั้นตอนที่ 3. เลือกแหล่งที่มาของภาพสำหรับโลโก้ของแอปพลิเคชันที่กำหนดเอง`,
"label_tabpage_rowsz":`ลบแถว`,
"label.validate.function.funcExplain.SUBSTITUTE":`แทนที่ old_text ในสตริงข้อความด้วย new_text หากต้องการแทนที่ข้อความที่ระบุในสตริงข้อความให้ใช้ SUBSTITUTE`,
"vue_label_checkduplicate_select_data_to_merge":`เลือกข้อมูลที่จะผสาน`,
"vue_label_commonobjects_view_chart_displaymode":`วิธีการขยาย`,
"label.industrialandcommercialverification.servicesetiings":`ตั้งค่าการบริการ`,
"label.refresh":`รีเฟรช`,
"label.taskfield":`ฟิลด์ภารกิจ`,
"label.notification.approval4":`[ผู้เสนอ]กำลังขออนุมัติ[ออบเจ็กต์]`,
"label.group.isusing":`เปิดการใช้งาน`,
"label.language.settings":`การตั้งค่าภาษา`,
"front-kefu-moudle-please-login":``,
"label.page.double.line.cloudcc":`แถวคู่และรวมแถบด้านข้าง CloudCC`,
"folder.error.delete":`1. โฟลเดอร์ปัจจุบันมีรายงานไม่สามารถลบได้! 2. โฟลเดอร์ปัจจุบันมีรายงานที่ซ่อนอยู่ไม่สามารถลบได้! รายงานที่ซ่อนอยู่คือการลบออบเจ็กต์ตามตรรกะ (การตั้งค่า - สร้าง - ออบเจ็กต์ที่ลบแล้วภายใต้ออบเจ็กต์) รายงานที่สร้างขึ้นถูกซ่อนไว้เนื่องจากวัตถุไม่ได้ถูกลบจริงๆ`,
"eight":`แปด`,
"label.marketseamemset.user":`สมาชิก`,
"label.recordnum":`หมายเลขบันทึก`,
"page.404.button.back":`กลับไปขั้นตอนก่อนหน้า`,
"label.mobile.phone.month.plan":`แผนของเดือนหน้า`,
"label.marketseamemset.account.title2":`กรุณาตั้งค่าจำนวนสูงสุด และสิทธิ์ของลูกค้าของสมาชิกที่ไม่เกี่ยวข้องกับฐานข้อมูล`,
"vue_label_chatter_current_avatar":`รูปโปรไฟล์ปัจจุบัน`,
"label.mobile.side.tab.remark3":`กดปุ่ม Shift ค้างไว้แล้วคลิกหรือลากเพื่อเลือกชุดของรายการที่อยู่ติดกัน; กดปุ่ม Ctrl ค้างไว้แล้วคลิกเพื่อเลือกหลายรายการที่ไม่อยู่ติดกัน`,
"component.sendmail.label.touser":`ผู้รับ`,
"label.homeitems.noobject":`ไม่มีหัวข้อ`,
"template.report.overall.sales":`ระยะเวลาการขายโดยรวม (ตามที่มาของลีด)`,
"label.partner.donotdel":`ไม่สามารถดำเนินการ    ให้เสร็จสิ้นได้`,
"label.service.miniProgram.bindCopyDesc":`หลังจากผูกองค์กรกับบัญชีสาธารณะหรือมินิโปรแกรมของบริษัทคุณแล้ว คุณสามารถใช้ที่อยู่เป็นพอร์ทัลการบริการลูกค้าของบริษัทคุณโดยการคัดลอก Jump Link ในคลิกเดียว`,
"UG_Contract_01":`จัดการสัญญา`,
"UG_quota_06":`สร้างใบเสนอราคา`,
"vue_label_report_deletereport":`ลบรายงาน`,
"front-epwechat-module-v1-input-appname":`กรุณากรอกชื่อแอป`,
"label_tabpage_deleteviewsuccess":`การลบมุมมองสำเร็จ`,
"component_chatter_label_mygroup":`กลุ่มของฉัน`,
"label.campagin.roi.leixing":`ประเภทแคมเปญ`,
"label.dashboard.myHomepageDashboard":`แดชบอร์ดหน้าแรกของฉัน`,
"UG_solution_04":`นำเข้าโซลูชัน`,
"label.knowledge.setting.hint.four":`เปิดใช้งาน Knowledge`,
"label.campaign.channel.add.field":`คลิกปุ่มเพื่อเพิ่มฟิลด์`,
"label.eastem.european.time":`เวลายุโรปตะวันออก`,
"label.partner.workspace.member.partner":`โปรไฟล์ CloudCC Partner`,
"label.campaignmember.main.backtocampaign":`กลับไปยังแคมเปญ`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`แน่นอน`,
"label.task.unsolve":`ภารกิจที่ยังไม่ได้จัดการทั้งหมด`,
"label.multilang.chatterservice.vote":`{0} คะแนน`,
"label.console":`คอนโซล`,
"label.emailsync.message1":`จะไม่สามารถซิงค์เนื้อหาอีเมลกับผู้ติดต่อและลีดหลังจากยกเลิกการเชื่อมโยง ยืนยันการยกเลิกหรือไม่?`,
"pagecreator.systemstyle.label.stylename":`ชื่อรูปแบบ`,
"setup_mainpage_label_welcome16":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าแอปพลิเคชัน → สร้าง → เวิร์กโฟลว์ กระบวนการอนุมัติ ภารกิจ การแจ้งเตือนทางอีเมล การอัปเดตฟิลด์ และอื่นๆ`,
"message.duplication.label.editfilterule":`แก้ไขกฎตัวกรองซ้ำ`,
"Account.News.Setting.004":`เปิดใช้งานข่าวสาร`,
"label_tabpage_saveviewsuccess":`การบันทึกมุมมองสำเร็จ`,
"label.forecast.forehistory.replacecommit":`แทนที่ข้อผูกมัด`,
"pagecreator_button_cancel":`ยกเลิก`,
"label.knowledge.article.nomatch":`เราไม่สามารถเก็บบทความนี้ได้เนื่องจากมีฉบับร่างที่เกี่ยวข้อง ลบฉบับร่างแล้วลองอีกครั้ง`,
"vue_label_combined_field":`ไม่มีฟิลด์ที่สามารถใช้สำหรับการรวมได้`,
"label.batchadd.save.prompt":`รายการบันทึก`,
"label.tabpage.summaryway":`วิธีการสรุป`,
"label.check.input.condition.two":``,
"mail.apiCode.notOnly":`มีชื่อเฉพาะอยู่แล้ว`,
"UG.quota.01":`จัดการใบเสนอราคาลูกค้า`,
"label.approved.receiveApprovalEmail.option3":`เฉพาะเวลาที่ฉันจัดสรรผู้อนุมัติ`,
"label.stdashbord.xsld.business.img5":`ความน่าจะเป็นของยอดเงินรวมในสเตจ 0%`,
"vue_label_chat_movedfromto":`{name}เปลี่ยน{label}จาก{oldField}เป็น{newField}`,
"label.customfields.new.step2.opration":`ตัวเลือกทั่วไป`,
"label.dashboardSetup.isurl":`เพิ่มลิงก์ใช่หรือไม่`,
"label.forecast.settings.mrfwqj":`ค่าเริ่มต้นขอบเขตเวลา`,
"label.campaign.channel.field":`ฟิลด์`,
"label.weixin.optionthree":`ตัวเลือกที่สาม`,
"label.safetystatement":`ประกาศด้านความปลอดภัย`,
"label.useskipwizard":`ใช้ตัวช่วยเริ่มต้นทันใจ`,
"label.projectManagement.completion":`เสร็จสิ้น`,
"label.customfields.fielddependency.new.step2":`<b>ขั้นตอนที่ 2:</b>  ในหน้าต่อไปสามารถเลือกแก้ไขกฎได้ โดยกฎเหล่านี้จะควบคุมค่าในฟิลด์ควบคุมที่ปรากฏในฟิลด์พึ่งพา`,
"setup.mainpage.label.welcome8":`ลากและวางอินเทอร์เฟซที่กำหนดเอง`,
"label.emailobject.list.outbox":`กล่องขาออก`,
"label.app.default.login.tab":`ค่าเริ่มต้นแท็บการเข้าสู่ระบบ`,
"label.follow_emails":``,
"vue_label_homepage_application_page":`หน้าแรกแอปพลิเคชัน`,
"label.confirm.template":`ยืนยันแม่แบบ`,
"lable.product.not":`ไม่สามารถดำเนินการ     ของคุณได้`,
"label.multilang.feedtrack.dispalyinfo":`คุณเลือกได้มากที่สุด {0} ฟิลด์`,
"label.weixin.plz.inputsrhkey":`โปรดป้อนคีย์เวิร์ดการค้นหา`,
"label.projectManagement.service.appointment":`การนัดหมายการบริการ`,
"label.list.userinterface.watermark.enable":`เปิดลายน้ำหน้าแรก PC และ APP, มุมมอง, รายละเอียดบันทึก, รายงาน, และแดชบอร์ด`,
"label.confirmDelete":`ยืนยันว่าจะลบข้อมูลเหล่านี้หรือไม่?`,
"label.sso.description":`ผู้ใช้สามารถเข้าสู่ระบบ CloudCC โดยไม่ต้องเข้าสู่ระบบตามชื่อผู้ใช้และรหัสการให้สิทธิ์ <br>URL เข้าสู่ระบบ：http://localhost:8080/ssologin.action?userName=admin@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 。<br>เมื่อใช้ลิงก์ด้านบน โปรดแทนที่ด้วยลิงก์ขององค์กรของคุณ "http://localhost:8080" โปรดแทนที่ด้วยชื่อผู้ใช้ขององค์กรของคุณ "admin@dev.com" <br>โปรดแทนที่ด้วยรหัสการให้สิทธิ์ขององค์กรของคุณ "dcc5c192facd7c08e124fbe93d8950b9"`,
"errormessage_email_atleastonereceiver_z":`โปรดเลือกหรือกรอกที่อยู่ผู้รับอย่างน้อยหนึ่งรายการ`,
"C":`ยอดรวมสะสม`,
"label.service.major.event.edit":`แก้ไขอิเวนต์สําคัญ`,
"label.icon.9":`ซ่อมบำรุง`,
"label.visualpage.notvalidate.check":`ไม่ใช่เพจที่กำหนดเองที่ถูกต้อง โปรดดูเอกสารความช่วยเหลือเพื่อตรวจสอบตัวสะกดของเพจ`,
"label.audit.todo.from":`มาจาก:`,
"label.directboss":`ผู้บังคับบัญชาโดยตรง`,
"label.manageAll.selpage":`จำนวนหน้าปัจจุบัน`,
"label.console.step6.all":`เต็มหน้าจอ และเลิกตรึงหน้า รายการจะปรากฏเฉพาะเมื่อเลือกเมนูระบบนำทางเท่านั้น`,
"vue_label_pool_expiredate":`วันหมดอายุ`,
"lable.no.matching.record":`ไม่มีบันทึกที่ตรงกัน`,
"label.standard.redirecterror":`ปุ่มมาตรฐานไม่สามารถไปยังหน้าที่กำหนดเองได้`,
"label.Platform.Setting":`การตั้งค่าแพลตฟอร์ม`,
"lable.outlook.edit.havenewc":`ผู้ติดต่อที่มีกิจกรรมล่าสุด`,
"label.partnerCloud.partnerAccount.choosePayment":`โปรดเลือกวิธีการชําระเงิน`,
"label.weixin.optionsix":`ตัวเลือกที่หก`,
"lable.SalesCommitmentKanBan.allCommitments":`Pipeline`,
"page_404_button_toknowmore":`เรียนรู้เพิ่มเติม`,
"label.customfields.number.tip":`เมื่อผู้ใช้ป้อนหมายเลขใดๆ เลข 0 ที่นำหน้าจะถูกลบ`,
"label.import.index.processimport":`ทําการนําเข้า`,
"label.quote.phone":`โทรศัพท์`,
"label.insert.approval":``,
"label.tabpage.printview":`ตัวอย่างการพิมพ์`,
"lable.product.price":`ราคา`,
"front-kefu-moudle-call-detail":``,
"label.umeng.approval.apply":`ยื่นคำขอ`,
"label.background.the.form":`พื้นหลังของฟอร์ม`,
"chatter.f":`ผู้ติดตาม`,
"label.quickbooks.searchresault.company":`ลูกค้า`,
"vue_label_systemSettings_platformutils":`เครื่องมือแพลตฟอร์ม`,
"front-quotation-v1-nofilles-tocreate":`โปรดคลิกปุ่มสร้างใบเสนอราคาเพื่อสร้างใบเสนอราคาก่อนส่ง`,
"label.category.6":`การแพทย์`,
"label.attendance.choose.positon":`เลือกที่หมาย`,
"label.batchadd.newbatchpage.save.pho":`รูปแบบโทรศัพท์ไม่ถูกต้อง`,
"UG.Account.01":`ลูกค้าของคุณคือใคร?`,
"label.marketseamemset.addspecialuser":`เพิ่มสมาชิกพิเศษ`,
"label.query.detail.forbidpartneruser":`ปิดใช้งานผู้ใช้พาร์ทเนอร์`,
"label.stdashbord.xsld.business.ydzhl":`อัตราการปิดการขายสำเร็จ`,
"vue_label_SMS_mymessagebox":`กล่องข้อความสั้นของฉัน`,
"label.knowledgebase.data.publishing.failed":`การเผยแพร่ข้อมูล {a} รายการล้มเหลว โปรดเลือกบทความที่มีสถานะเป็นฉบับร่างเพื่อเผยแพร่`,
"label.wholestate":`สถานะทั้งหมด`,
"label.selectedline":`คอลัมน์ที่เลือก`,
"label.validate.function.funcExplain.LEFT":`ส่งกลับอักขระจำนวนหนึ่งที่เริ่มจากด้านซ้ายของสตริงข้อความ`,
"label.emailmerge.edittemplate.detail":`ข้อมูลของแม่แบบจดหมายเวียน`,
"vue_label_checkduplicate_checkduplicate":`ตรวจสอบซ้ำ`,
"label.knowledgebase.assign.articles":`มอบหมายบทความ`,
"label.tabpage.recordsz":`บันทึก`,
"label.field.img.validate.error":`ชื่อตัวแปรหลัง$Userสะกดผิดหรือการอ้างอิง$Userไม่ถูกต้อง โปรดตรวจสอบการสะกด!`,
"workorderlineitem.worktype.isnot.father.worktype":`รายการบรรทัดใบสั่งงานนี้ต้องเลือกชนิดงานที่เกี่ยวข้องกับบันทึกหลัก`,
"label.ccchat.group.name.noexist":`ไม่มีชื่อกลุ่มที่คุณป้อน กรุณาป้อนใหม่อีกครั้ง`,
"label.weixin.sign.type":`ประเภทการลงทะเบียนเข้า (ออก) ผิดพลาด`,
"label.nowvaluereplace":`แทนที่ด้วยที่มีอยู่`,
"report_label_report":`รายงาน`,
"label.knowledge.setting.plus":`การตั้งค่าคลังความรู้ Plus`,
"label.event.moveup.2day":`ล่วงหน้า 2 วัน`,
"label.translation.start":`เริ่มใช้งานเวิร์คแบนซ์งานแปล`,
"lable.PowerProcess.created.time":`สร้างวันที่ตาม{detailInterestType}`,
"label.ems.step2":`ขั้นตอนที่ 2`,
"label.tabpage.groupingemptyz":`กลุ่มรายการต้องไม่ว่างเปล่า`,
"pagecreator.layout.button.new":`เค้าโครงใหม่`,
"label.tabpage.listshow":`แสดงรายการ`,
"label.partnerCloud.productSet.optionName":`ชื่อตัวเลือก`,
"label.service.without.cycle":`ไม่มีวงจร`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0}โพสต์คะแนนโหวตของสมาชิกทุกคนในกลุ่ม{1}`,
"label_target_model_dimension":`ขนาดแบบจำลองเป้าหมาย`,
"component.task.label.subject":`หัวข้อ`,
"label.custom.field.login.query.information":`กรุณาเข้าสู่ระบบเพื่อเรียกดูรายละเอียด!`,
"label.validate.function.funcExplain.NOT":`เปลี่ยน FALSE เป็น TRUE หรือเปลี่ยน TRUE เป็น FALSE`,
"pagecreator_layout_button_horizontal":`แยกตามแนวนอน`,
"lable.Returned.to.successful":`ส่งคืนสําเร็จ`,
"label.campaign.channel.ticket.title":`บัตรเข้างาน`,
"label.ruleName.supportMaximum.50Characters":`ชื่อกฎรองรับอักขระได้สูงสุด 50 ตัว`,
"label.email.track.attachment.size.control1":`ขนาดสะสมของไฟล์แนบอีเมลปัจจุบันเกิน 20M และไม่สามารถอัปโหลดต่อไปได้`,
"template.report.folder.opportunities":`การวิเคราะห์โอกาสทางธุรกิจ`,
"label.knowledge.setting.data.eight":`คุณกำลังจะลบกลุ่มหมวดหมู่{flzmc} และหมวดหมู่ในกลุ่ม หมวดหมู่นี้จะไม่สามารถใช้กับบันทึกได้ คุณมีเวลา 15 วันในการยกเลิกและลบกลุ่มหมวดหมู่นี้ หลังจาก 15 วัน หมวดหมู่จะถูกลบออกอย่างถาวรและไม่สามารถกู้คืนได้ ยืนยันว่าจะลบกลุ่มหมวดหมู่นี้และหมวดหมู่หรือไม่?`,
"mail.id.notNull":`เมื่อแม่แบบถูกลบ id ต้องไม่ว่างเปล่า`,
"vue_label_normal_product_sf":`ผลิตภัณฑ์`,
"vue_label_report_superiortothisrelationship":`ความสัมพันธ์จากออบเจ็กต์พาเรนต์มายังออบเจ็กต์นี้`,
"label.leadscore.operation":`ตัวดำเนินการ`,
"label.customfields.formula.percentexample":`Discount（ส่วนลด）= (Amount - Discounted_Amount__c) / Amount`,
"component.setup.iframe.label.inputurlmemo":`กรุณาป้อน URL ของเพจที่จะนำเข้า`,
"label.icon.177":`โลโก้`,
"label.tabpage.myz":`ของฉัน`,
"label.leadmarketsea.add.title":`สร้างฐานข้อมูลลีดใหม่`,
"label.partnerCloud.partnerAccount.thePage":`หน้าที่ {skippageNum}`,
"label.visualpage.some.size":`ความจุรหัส : รองรับอักขระสูงสุด 300KB ประมาณ 300,000  ไบต์`,
"label.setwxpay.null":`ข้อมูลที่จำเป็นในการกำหนดค่าวีแชทเพย์ว่างเปล่า`,
"label.icon.74":`เครื่องมือกล`,
"font-evaluate-module-v1-evbad":``,
"System.TimeField.Format.Warning":`ไม่ใช่ช่วงเวลายังผล`,
"label.captcha":`รหัสยืนยัน`,
"label.payment.assessment":`การประเมินรุ่นอื่นๆ`,
"message.error.not.taskevent":`ออบเจ็กต์อิเวนต์ที่ไม่ใช่ภารกิจ`,
"font-evaluate-module-v1-evaluation":``,
"vue_label_commonobject_view_updatedago":`รีเฟรชเมื่อ {timeInterval}`,
"label.sendemail.birthday.newevent":`{!ownerNameที่เคารพ}：\r\n 3ใกล้ถึงวันเกิดของ{!objectLable}{!recordName} โปรดให้ความสนใจ！\r\n {!orgName}`,
"label.laststep":`ขั้นตอนก่อนหน้า`,
"message.duplication.label.matchoption":`ตัวเลือกการจับคู่`,
"label.setupmultplerecordtype":`หลายชนิดบันทึก`,
"vue_label_account_unprocessed_oppprtunities":`โอกาสทางธุรกิจที่ยังไม่ได้จัดการ`,
"KeyInformationLayout.DefaultLayout.Name":`ค่าเริ่มต้นระบบ`,
"label.partner.all":`พาร์ทเนอร์คลาวด์ทั้งหมด`,
"label.datamanage.export.error":`การส่งออกล้มเหลว!`,
"label.standard.buttonandlink":`ปุ่มมาตราฐานหรือลิงก์`,
"label.reportsSubscriptionPage.email":`รายงานอีเมล`,
"message.nogrammarfaultinformula":`ไม่มีข้อผิดพลาดทางไวยากรณ์ในสูตร`,
"front-kefu-moudle-nofind-instance":``,
"label.is.delete.data":`ข้อมูลที่คุณจะลบมีบันทึกที่อยู่ระหว่างการอนุมัติ คุณยืนยันที่จะลบหรือไม่?`,
"label.partner.error":`ข้อผิดพลาด: รูปแบบชื่อโดเมนไม่ถูกต้อง`,
"label.notification.time2":`{0} นาทีที่แล้ว`,
"label.ccchat.person.invite.needfirstname":`ใส่ชื่อของคุณ`,
"label.mr.title.URL":`URL`,
"chatter.norecord":`ไม่มีบันทึกที่จะแสดง`,
"label.readwrite":`อ่านและเขียน`,
"label.partnerCloud.orderingPlatform.orderPayment":`การชำระเงิน`,
"label.accesslimittype":`ระดับสิทธิ์การเข้าถึง`,
"label.preciew_tab":`ดูลิงก์ในแท็บใหม่`,
"label.attachment":`ไฟล์แนบ`,
"label_tabpage_helpNavigationz":`ช่วยเหลือและนำทาง`,
"label.dataimport.select":`เลือกข้อมูลนี้ และดำเนินการเมื่อนำเข้าข้อมูล`,
"chatter.en.info":`ป้อนข้อมูลเพื่อให้ทุกคนเข้าใจคุณมากขึ้น`,
"label.ccservice.validate.date":`ค่าที่สอดคล้องกันของฟิลด์{1} ภายใต้ออบเจ็กต์ API {0} คือ{2} รูปแบบไม่ถูกต้อง โปรดป้อนรูปแบบวันที่หรือเวลาที่ถูกต้อง!`,
"label.social.posts.send":`การส่งโพสต์ล้มเหลว`,
"label.emailobject.time.to":`ผู้รับ:`,
"label.defineReportStep1":`ขั้นตอนที่ 1`,
"savefail":`การบันทึกล้มเหลว`,
"label.mr.descreption.title":`ผสานข้อมูลซ้ำ`,
"label.share.info.by":`โดย`,
"label.list":`รายการ`,
"label.event.select":`เลือก`,
"message.accountmap.cannotfind":`ไม่พบที่อยู่ลูกค้า โปรดอัปเดตที่อยู่ลูกค้า`,
"label.choosefield":`ฟิลด์หน้าการอนุมัติ`,
"label.forecast.settings.title":`การตั้งค่าการพยากรณ์`,
"label.setup.log.datetime":`ดาวน์โหลดล็อกพฤติกรรม (ไฟล์ Excel.xls) ภายในช่วงเวลาที่ค้นหา`,
"button_partner_new":`พาร์ทเนอร์คลาวด์ใหม่`,
"label.umeng.approval.dlsp.reject":`#approvalnameปฏิเสธคำขออนุมัติ#objAPIName#recordnameของ#actorname`,
"label.tabpage.totalTeamz":`ทีมทั้งหมด`,
"label.lead.score.prompt3":`ขั้นตอนการให้คะแนนอาจใช้เวลานาน ทันทีที่การให้คะแนนเสร็จสิ้น คุณจะได้รับอีเมลยืนยันหนึ่งฉบับ`,
"label.schedulejob.setup.schedule.name":`ชื่อภารกิจ`,
"vue_label_report_advanced":``,
"label.emailsync.form.connecttime":`เวลาเชื่อมต่อ`,
"front-gantt-module-v1-project-status":``,
"label.field.for.example":`เช่น`,
"label.marketsea.manager.notnull":`ผู้จัดการไม่สามารถว่างเปล่า`,
"label.click.here":`&lt&lt คลิกที่นี่เพื่อย้อนกลับ`,
"UG.solution.04":`นำเข้าโซลูชัน`,
"label.validate.function.funcExplain.IF":`ตรวจสอบเงื่อนไขว่าเป็นจริงหรือไม่ หากเงื่อนไขเป็น TRUE จะส่งกลับค่าหนึ่ง；ถ้าเงื่อนไขเป็น FALSE จะส่งกลับอีกค่าหนึ่ง`,
"label.profile.settab":`การตั้งค่าแท็บ`,
"front-email-payment-weichat-tips":``,
"label.task.next.week":`ภารกิจของสัปดาห์หน้า`,
"label.operatedata.selectobjectfields.tip":`กรุณาเลือกฟิลด์ที่ต้องการส่งออกอย่างน้อยหนึ่งฟิลด์  <font color="red">โปรดทราบว่าไม่สามารถส่งออกฟิลด์ Rich Text ได้ </font>`,
"label.recalculate.alert":`โปรดเลือกกฎการแบ่งปันที่จะคำนวณใหม่`,
"label.marketsea.noopportunitydays":`วันที่ไม่ได้สร้างโอกาสทางธุรกิจ (ต้องมากกว่าจํานวนที่ไม่ได้ติดตามหลังได้มา)`,
"label.chat.likeperson":`ส่วนบุคคล`,
"label.selectedFields":`จำนวนตัวเลือกฟิลด์`,
"label.App":`แอปพลิเคชัน`,
"label.file.type":`ประเภทไฟล์`,
"permissionService.error1":`จํานวนสิทธิ์การใช้แอปไม่เพียงพอ`,
"front-detail-module-v1-chart-display":`แสดงแผนภูมิ`,
"label.audit.status":`สถานะการอนุมัติ`,
"UG.activity.05":`บันทึกการโทร`,
"label.connectOtherObject":`(คลิกเพื่อเชื่อมโยงออบเจ็กต์อื่น)`,
"lable.currencyManage.unEnabledadvcurrency":`ปิดใช้งานการจัดการสกุลเงินขั้นสูง`,
"label.ccpeak.getthree.function":`มี 3 วิธี ยังมี`,
"label.weixin.new.weitoupiao":`สร้างเวยโพลใหม่และคุณสามารถรับข้อมูลเพื่อเข้าร่วมโหวตในกิจกรรมของแพลตฟอร์มวีแชท`,
"label.tag.manage.prompt":`มีป้ายกำกับนี้แล้ว`,
"label.goon":`ดำเนินการต่อไป`,
"label.addworkflowoperate":`เพิ่มการดำเนินงานของเวิร์กโฟลว์`,
"label.weixin.click.search":`คลิกเพื่อค้นหาบันทึก`,
"vue_label_report_deletecolumn":`ลบคอลัมน์`,
"label.ordercondition":`เงื่อนไขการจัดเรียง`,
"message.error.group.notallow":`กลุ่มไม่อนุญาตให้จัดเก็บถาวร`,
"label.unread":``,
"vue_label_report_notice_namerequired":`ต้องระบุชื่อคอลัมน์`,
"label.tabpage.entercontent":`กรุณาใส่เนื้อหา`,
"label.schedulejob.setup.schedule.startdate":`วันที่เริ่มต้น`,
"component_assistant_button_newtask":`ภารกิจใหม่`,
"vue_label_report_notice_filter1":`เมื่อเปิดใช้งานตัวกรองขั้นสูงให้เขียนเงื่อนไขการกรองด้วยตนเองในช่องตัวกรองขั้นสูงด้านล่างตามรูปแบบที่แสดงในรูป`,
"value":`ค่า`,
"label.icon.70":`ซ่อมบำรุง`,
"label.knowledgebase.delete.draft.t":`ลบฉบับร่าง`,
"label.setup.mini.bind":`ผูกมินิโปรแกรม`,
"component_timeline_button_more":`ขั้นตอนเพิ่มเติม`,
"label_emailtocloudcc_redmessage4":`กรุณากรอกข้อมูลพอร์ต`,
"label.field.input.number":`กรุณาใส่ตัวเลขที่ถูกต้อง`,
"front-invoice-online-payment-setup-title":``,
"front-kefu-moudle-called-user":``,
"label.currency.disable":`สกุลเงินที่ปิดการใช้งาน`,
"label.user.alias":`นามแฝง`,
"UG_quota_04":`พิมพ์ใบเสนอราคา`,
"label.chatter.delete":`ลบ`,
"label.addtocurrentcustomer":`แนบกับลูกค้าปัจจุบัน`,
"message.error.recordid.null":`recordid ไม่สามารถว่างเปล่า!`,
"label.merge.records":`ผสานบันทึก`,
"report_label_norole":`คุณไม่มีสิทธิ์นี้ โปรดติดต่อผู้ดูแลระบบ!`,
"label.pqrs":`.`,
"label.email.attach.button":`คลิกปุ่ม "แนบไฟล์"`,
"label.tabpage.selrecordtypez":`เลือกชนิดบันทึก`,
"label.ServiceCloud.purchase.date":`วันที่ซื้อ`,
"label.customreporttype.delete.prompt":`โปรดลบรายงานต่อไปนี้ออกจากการลบ`,
"label.brief.total.page":`รวม {total} หน้า`,
"label.reportsSubscription.unsubscribe":`ยกเลิกการสมัครสมาชิก`,
"label.ccpeak.take.notice.exp.order":`หมายเหตุ: ฟิลด์ exp และเงื่อนไข ordering ต้องเพิ่ม __c "" หลังชื่อ API`,
"report_type_label_quote":`เสนอราคา`,
"label.file.norecord":`ไม่มีรายการที่จะแสดง`,
"vue_label_checkduplicate_all_processed":`ประมวลผลข้อมูลทั้งหมดแล้ว`,
"label.next":`ขั้นตอนถัดไป`,
"label.icon.10":`โฟลเดอร์`,
"label.lanxin.title.setting":`เชื่อมต่อข้อมูล`,
"label.h5.chatter.business":`โอกาสทางธุรกิจที่เกี่ยวข้อง`,
"lable.are.you.sure.to.delete.this.view":`ยืนยันว่าจะลบมุมมองหรือไม่`,
"vue_group_no_operation_permission":`ไม่มีสิทธิ์ดำเนินการ`,
"label.knowledge.archive.article":`เก็บบทความถาวร`,
"vue_label_lead_":`ไม่มีเกณฑ์การให้คะแนนพร้อมใช้ที่เปิดใช้งาน โปรดติดต่อผู้ดูแลระบบ`,
"label.fiscal.error.between":`กรุณาตรวจสอบและตั้งค่าวันเริ่มต้นปีงบประมาณหรือวันสิ้นสุดปีงบประมาณที่อยู่ในช่วงปีงบประมาณที่ผ่านมาใหม่อีกครั้ง!`,
"label.stdashbord.xsld.business.qdzje":`จำนวนเงินทั้งหมดที่ปิดการขายสำเร็จ`,
"label.calendar.day.view":`มุมมองรายวัน`,
"label.emailtocloudcc.tip":`แจ้งเตือน`,
"label.schedulejob.setup.schedule.st1":`ที่หนึ่ง`,
"label_tabpage_addtoworkbench":`เพิ่มไปยังเวิร์คแบนซ์`,
"label.umeng.approval.waitapproval":`รออนุมัติ`,
"label.justcheckingwebsite":`ยืนยันเว็บไซต์เท่านั้น`,
"homepage.components":`ส่วนเสริมหน้าแรก`,
"label.audit.remark":`หมายเหตุการอนุมัติ`,
"label.searchs.labelname":`ค้นหา{fieldlabelName}`,
"label.remarkofreport":`หมายเหตุรายงาน`,
"label.weixin.isno":`ใช่หรือไม่`,
"label.currencyCode":`รหัสสกุลเงิน`,
"label.service.resources":`ทรัพยากร`,
"label.clone_form":`คัดลอกฟอร์ม`,
"label.weixin.view.information":`แสดงข้อมูลมุมมอง`,
"UG_activity_05":`บันทึกการโทร`,
"chatter.feed.menutype.user.recentuser":`พนักงานที่ดูล่าสุด`,
"label.marketsea.notfollowdays2":`วันไม่ได้ติดตามผล`,
"label.tabpage.namemandatory":`ต้องระบุชื่อมุมมอง`,
"message.demo.nosupport":`ฟังก์ชันนี้จะเปิดตัวในรุ่นถัดไป`,
"label.mail.merge.template":`กำลังดำเนินการแม่แบบจดหมายเวียน...`,
"label.sendemail.marketactivity.sign":`แจ้งการลงทะเบียนเข้างานสำหรับแคมเปญ`,
"setup_layout_group_relatedlist":`รายการที่เกี่ยวข้อง`,
"label.pc.ui.2018.all.tabs":`แท็บทั้งหมด`,
"label.field.lost.right.bracket":`ไม่มีวงเล็บปิด`,
"label.datamanage.contact.novalue":`หมายเหตุ: การนำเข้านี้ไม่ได้กำหนดค่าให้กับฟิลด์ "ชื่อผู้ติดต่อ" และจะไม่มีการนำเข้าบันทึกผู้ติดต่อ!`,
"label.version.unlimited.edition":`รุ่นอันลิมิเต็ด`,
"vue_label_dashboard_selectsortfield":`โปรดเลือกฟิลด์การจัดเรียง`,
"label.partnerCloud.productSet.instructions":``,
"front-kefu-moudle-v1-canuse-obj":`ออบเจ็กต์ที่มองเห็นได้`,
"thursday":`วันพฤหัสบดี`,
"label.nextapprover":`ผู้อนุมัติรายถัดไป`,
"setup_mainpage_label_manageuser":`จัดการผู้ใช้`,
"label.saveandcontinue":`บันทึกและดำเนินการต่อ`,
"label.top.userCenter":`ศูนย์ส่วนบุคคล`,
"component.chatter.file.button.save":`เผยแพร่`,
"label_emailsync_setting":`การตั้งค่าอีเมลส่วนตัว`,
"label.usableshareuser":`ผู้แบ่งปันที่ใช้ได้`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`จัดเรียงค่าตามตัวอักษรแทนลำดับการป้อนค่า ค่าทั้งหมดจะแสดงผลตามลำดับตัวอักษร`,
"label.list.button":`กำหนดโปรไฟล์`,
"chatter.up.m":`ไฟล์ที่อัปโหลดมีขนาดใหญ่เกินไป ต้องไม่เกิน 20M`,
"label.knowledgebase.filters":`{a} ตัวกรอง`,
"label.sso.saml.sp.idtype.username":`คำสั่งประกอบด้วยชื่อผู้ใช้ cloudcc`,
"vue_label_file_size_limit":`ขนาดไฟล์ต้องไม่เกิน {size} Mb`,
"label.appupload.install.error.choice4":`ข้ามส่วนเสริมที่ขัดแย้ง ไม่ติดตั้งส่วนเสริมที่ขัดแย้ง`,
"label.currencyDecimalDigits":`ตำแหน่งทศนิยม`,
"label.weixin.customer.details":`รายละเอียดลูกค้า`,
"component.timeline.label.7daysahead":`7 วันก่อน`,
"label.sendsms.batch.step1":`ขั้นตอนที่ 1: ระบุผู้รับข้อมูลที่จะรวม`,
"label.brief.opportunity1":`โอกาสทางธุรกิจ`,
"label.datamanage.click.importbutton":`คลิก <b> นำเข้าทันที </b> ข้อมูลจะถูกนำเข้าสู่ระบบ CloudCC`,
"label_filter_benchmark_objects":`กรองออบเจ็กต์อ้างอิง`,
"label.area.record.notexist":`ไม่พบบันทึก`,
"label.event.overdue.unfinished":`อิเวนต์ที่เลยกำหนดเวลา`,
"label.file.publicview.errortype":`ไฟล์ประเภทนี้ไม่รองรับการแสดงตัวอย่าง`,
"label.setup.mobile.bottombutton.profile.setting":`ปรับแต่งเมนูด้านล่างของโปรไฟล์`,
"label.campaignmember.main.addleaddesc":`เพิ่มลีดทั้งหมดลงในแคมเปญนี้พร้อมกัน`,
"vue_label_approve_actual_operator":`ผู้ปฏิบัติงานจริง`,
"label.version.essential":`รุ่นเอสเซนเชียล`,
"lable.SalesCommitmentKanBan.commitments":`Pipeline`,
"label.chatter.pastEvents":`กิจกรรมที่ผ่านมา`,
"vue_label_calendar_choose_calendar_type":`เลือกประเภทปฏิทิน`,
"label.service.dispatchingUnits.batch.send":`จัดส่งแบบกลุ่ม`,
"chatter.poll.option8":`ตัวเลือกที่ 8`,
"label_tabpage_summaryway":`วิธีการสรุป`,
"front-kefu-moudle-trindex-copy-num":``,
"lable.quote.syncing.syncfinish":`การซิงค์เสร็จสิ้น`,
"label.home.task.finish":`เสร็จสิ้นภารกิจ`,
"label.toleadfield":`แม็ปฟิลด์ลีด`,
"label.everyone":`ทุกคน`,
"label.multilang.databatchadd.success":`เพิ่มข้อมูล {0}  รายการสำเร็จ`,
"label.quote.createdate":`สร้างวันที่`,
"email.template.nopermission":``,
"label.report.action.addtodashboard2":`เพิ่มแดชบอร์ด`,
"label.campaign.name":`ชื่อแคมเปญ`,
"label.check.input.condition":`ไวยากรณ์ผิดพลาด กรุณาตรวจสอบเงื่อนไขการกรองที่ระบุ`,
"front-epwechat-module-v1-upload-file":`อัพโหลดไฟล์เครดิต:`,
"label.batchadd.newbatchpage.button.add":`เพิ่มหนึ่งแถว`,
"label.partnerCloud.footer":`ส่วนท้าย`,
"lable.Enter.template.name":`กรุณาใส่ชื่อเท็มเพลต`,
"label_tabpage_last":`ขั้นตอนก่อนหน้า`,
"label.setup.mobile.bottombutton.setting":`การตั้งค่าหน้าเพจระดับหนึ่งบนอุปกรณ์มือถือ`,
"label_emailtocloudcc_filed_emailto":`Email to`,
"label.data.downpage.e_title.num3":`3. ผู้ใช้สามารถสร้างแม่แบบการส่งออกตามความต้องการของตนเอง เมื่อส่งออกข้อมูลก็อย่างง่ายดายโดยกดเลือกการส่งออกตามแม่แบบ`,
"startwith":`อักขระเริ่มต้น`,
"vue_label_normal_cancel":`ยกเลิก`,
"label.reportTypcrtD":`ออบเจ็กต์ที่เกี่ยวข้องกับ（D）กรุณาคลิกเลือกออบเจ็กต์ที่เกี่ยวข้อง`,
"label.globalselect.disabledvalue":`ค่าที่ปิดการใช้งาน`,
"vue_label_commonobjects_view_notice_deletecertification":`ยืนยันว่าต้องการลบข้อมูล{selectNum}ที่เลือกหรือไม่?`,
"front-epwechat-module-v1-bound-role":`ผูกบทบาท`,
"label.partnerCloud.financeSetting.gaofilter":`เงื่อนไขตัวกรองขั้นสูง (เช่น 1 And 2 Or 3)`,
"label.quote.sprname":`ชื่อผู้รับ`,
"lable.asset.successfully":`แปลงผลิตภัณฑ์เป็นสินทรัพย์สำเร็จ`,
"label.projectManagement.service.appointment.work.noedit":`แก้ไขเวลานัดหมายบริการไม่ได้`,
"lable.tianyancha.h5.inputandsearch":`ใส่คีย์เวิร์ดเพื่อค้นหาบริษัทที่เกี่ยวข้อง`,
"label.customcomponent.check.tag.firstrow":`แถวแรกต้องเป็น`,
"label.knowledgebase.published.translations":`การแปลที่เผยแพร่แล้วจะถูกเก็บถาวร และการแปลในสถานะฉบับร่างจะถูกลบออก`,
"vue_label_wang_yi":`หวังอี`,
"label.step3.total3":`ขั้นตอนที่ 3 จาก 3`,
"label.stdashbord.xsld.business.img6":`ความน่าจะเป็นของจำนวนในสเตจ 100% /(ความน่าจะเป็นของจำนวนในสเตจ 100%   ความน่าจะเป็นของจำนวนในสเตจ 0%)`,
"component_button_cancel":`ยกเลิก`,
"label.delete.false.not.exists":`การลบล้มเหลว ไม่พบข้อมูล`,
"label.appupload.install.error.choice1":`กรุณาอย่าติดตั้ง`,
"label.Days.After.Horizontal.Date":`จำนวนวันหลังวันที่แนวนอน`,
"setup_layout_button_additem":`เพิ่มรายการที่เลือก`,
"UG.contact.05":`สร้างผู้ติดต่อ`,
"label.form.title":`ชื่อฟอร์ม`,
"label.horizontalbar-group":`แผนภูมิแท่งแนวนอน-แบ่งกลุ่ม`,
"component_sendmail_label_title":`ส่งอีเมล`,
"label.passwordPolicy.setup.neverexpires":`ไม่มีวันหมดอายุ`,
"label.sso.saml.idp.config.desc1":`การเปิดใช้งาน CLoudCC.com เป็นผู้ให้บริการข้อมูลประจําตัวช่วยให้คุณสามารถใช้ SSO ในเว็บไซต์อื่น ๆ และกําหนดผู้ให้บริการที่เหมาะสมเพื่อสนับสนุนแอปพลิเคชัน SSO โดยคุณไม่ต้องลงชื่อเข้าใช้อีกครั้งเพื่อเปลี่ยนผู้ให้บริการ`,
"label.chat.topic.desc.null":`มีข้อมูลบางอย่างเกี่ยวกับหัวข้อนี้หรือไม่? เลือกแก้ไขรายละเอียดบนแถบเมนูเลือกแบบดึงลงที่มุมขวาบน`,
"label.movablecustomerfield":`ฟิลด์ที่กำหนดเองแบบไดนามิก`,
"label.trigger.folder":`โฟลเดอร์ทริกเกอร์ที่ไม่ได้จัดเก็บถาวร`,
"label.selectuploadfile":`กรุณาเลือกไฟล์อัปโหลด!`,
"front-email-payment-card-tips":``,
"label.tabpage.addcondition":`เพิ่มเงื่อนไข`,
"label.number.MinAndMaxCheck":`จํานวนขั้นต่ําของ{0}คือ {1} และจำนวนสูงสุดคือ {2} โปรดแก้ไขจำนวนแล้วคลิกบันทึก`,
"vue_label_dashboard_dashboard":`การเปลี่ยนชื่อแดชบอร์ดสำเร็จ`,
"label.objectDeleteList":`รายการลบออบเจ็กต์`,
"lable.service.gantt.and":`และ`,
"label.emailtocloudcc.step2":`ขั้นตอนที่ 2`,
"label.chatter.postup":`เผยแพร่`,
"label.personalsetting":`การตั้งค่าส่วนบุคคล`,
"message.please.choose.permission":`โปรดเลือกสิทธิ์การเข้าถึง`,
"label.mobile.move":`เว็บเพจสำหรับบนอุปกรณ์มือถือ`,
"label.Choose":`ตัวเลือก`,
"label_chatter_vote":`โหวต`,
"label.weixin.user.select.one":`เลือกหนึ่งผู้ใช้`,
"pagecreator.page.label.modifypage":`ตัวแก้ไขหน้าเพจ`,
"label.select.partOrField":`เลือกส่วนหรือฟิลด์ที่คุณต้องการควบคุม`,
"vue_label_helpcenter_chat":`1. สื่อสารแบบทันที<br>กลยุทธ์กลุ่มสามารถแทนที่วีแชทขององค์กรได้ ทำให้คุณสามารถส่งข้อความ ไฟล์ และอื่นๆ ไปยังเพื่อนร่วมงานในบริษัทในขณะที่ทำงานในระบบ CRM เมื่อแต่ละแผนกต้องการตั้งกลุ่มสนทนาของแผนก หัวหน้าแผนกสามารถตั้งสนทนากลุ่มในกลยุทธ์กลุ่มและเพิ่มสมาชิกแผนกเข้ากลุ่ม <br>2. สร้างกลุ่มสนทนาสำหรับบันทึกของลูกค้าและโอกาสทางธุรกิจ<br> เปิดหน้ารายละเอียดบันทึกลูกค้าหรือโอกาสทางธุรกิจ คลิกปุ่ม "กลยุทธ์กลุ่ม" ที่มุมบนขวาเพื่อสร้างกลุ่ม หากผู้สร้างกลุ่มไม่ใช่เจ้าของบันทึก เจ้าของบันทึกจะถูกดึงเข้ากลุ่มโดยอัตโนมัติ ผู้อื่นสามารถเข้ากลุ่มโดยคลิกปุ่ม "กลยุทธ์กลุ่ม" ที่มุมขวาบนของหน้ารายละเอียดบันทึกหรือหลังจากเจ้าของกลุ่มเพิ่มเข้ากลุ่ม <br>3. ติดตามบันทึกในสนทนากลุ่ม<br> สร้างกลุ่มสนทนาสำหรับบันทึกลูกค้าและโอกาสทางธุรกิจตามข้อ 4.2 จากนั้นคุณสามารถติดตามความเคลื่อนไหวได้ทางการ์ด หากผู้ใช้มีสิทธิ์ดูบันทึกบนการ์ด สามารถข้ามไปยังหน้ารายละเอียดออบเจ็กต์ที่เกี่ยวข้องได้โดยตรงเมื่อคลิกที่การ์ด <br>ติดตามการเปลี่ยนแปลงฟิลด์บันทึกในสนทนากลุ่ม<br> เมื่อตั้งค่าบันทึก"ติดตามฟิลด์" รายการที่เกี่ยวข้อง และตั้งค่าฟิลด์ที่ต้องการติดตาม เมื่อฟิลด์ที่ติดตามเปลี่ยนแปลง ผู้ช่วยกลุ่มกลยุทธ์ในกลุ่มสนทนาจะส่งการ์ดพร้อมข้อมูลการเปลี่ยนแปลงไปยังกลุ่ม<br>ติดตามการเปลี่ยนแปลงของเจ้าของบันทึกในกลุ่มสนทนา<br> เมื่อเปลี่ยนเจ้าของบันทึก ผู้ช่วยกลยุทธ์กลุ่มจะส่งการ์ดพร้อมข้อมูลการเปลี่ยนแปลงไปยังกลุ่ม <br>ติดตามกิจกรรมกลุ่มสนทนา<br> หากมีการสร้างภารกิจหรืออิเวนต์ใหม่ที่เกี่ยวกับบันทึกในกลุ่มสนทนา ผู้ช่วยกลยุทธ์กลุ่มจะส่งการ์ดพร้อมข้อมูลพื้นฐานของภารกิจหรืออิเวนต์ให้กับกลุ่ม <br>ติดตามบันทึกใหม่ของรายการที่เกี่ยวข้องในกลุ่มสนทนา<br> เมื่อมีการเพิ่มบันทึกรายการที่เกี่ยวข้องกับบันทึกของกลุ่มสนทนา ผู้ช่วยกลยุทธ์กลุ่มจะส่งการ์ดข้อมูลพื้ฐานของบันทึกใหม่เข้ากลุ่ม เช่น: เมื่อมีการเพิ่มผู้ติดต่อใหม่ลงในรายชื่อผู้ติดต่อของบันทึกลูกค้า  จะได้รับการ์ด "ผู้ติดต่อใหม่" ในกลุ่มสนทนา และสามารถดูข้อมูลพื้นฐานได้บนการ์ด`,
"label.tianyancha.business":`ข้อมูลธุรกิจ`,
"chatter.group.groupMembersToFind":`ค้นหาสมาชิกกลุ่ม`,
"label.pc.ui.2018.pin.top":`ปักหมุด`,
"label.forecast.forehistory.submitor":`ผู้เสนอ`,
"vue_label_email_send_emails_separately":`การส่งแยกอีเมลสำเร็จ`,
"vue_label_homepage_select_display_field":`เลือกฟิลด์แสดงผล`,
"label.partnerCloud.partnerAccount.accountBalance":``,
"label.sendemail.template":`เลือกแม่แบบอีเมล`,
"label.service.violated":`ละเมิด`,
"label.manageAll.title":`ศูนย์การอนุมัติ`,
"label.forecast.settings.qy":`เปิดใช้งานการแบ่งปันการพยากรณ์`,
"label.detailofshare":`รายละเอียดที่แบ่งปัน`,
"label.multilang.passwordpolicy.chechlength":`ข้อผิดพลาด: รหัสผ่านต้องยาวไม่น้อยกว่า {0} อักขระ`,
"label.visualpage.filesave.error":`การบันทึกไฟล์ล้มเหลว โปรดลองอีกครั้ง`,
"vue_label_campaign_please_select_member_status":`โปรดเลือกสถานะสมาชิก`,
"homepage.components.sort":`จัดเรียงส่วนเสริม`,
"label.brief.thismonth":`เดือนนี้`,
"label_emailsync_connectaccount_description":`เพิ่มที่อยู่อีเมลส่วนตัวของคุณที่นี่ ระบบจะจับคู่ลีดและผู้ติดต่อในระบบโดยอัตโนมัติตามที่อยู่รับส่งอีเมล และทำการซิงค์เนื้อหาในอีเมลกับบันทึกนี้ เพื่อความสะดวกในการติดตามความคืบหน้าในการสื่อสารกับลูกค้า`,
"label.sms.csid":`หมายเลขลายเซ็น`,
"label.ccdocument.remark":`คำอธิบายเอกสาร`,
"label.forecast.customforecast.disdw":`หน่วยแสดงผล`,
"label_tabpage_field":`ฟิลด์`,
"label.logintime.all":`ทั้งวัน`,
"UG_Account_06":`สร้างลูกค้า`,
"label.login":`เข้าสู่ระบบ`,
"label.dupicate.data.error":`การสืบค้นข้อมูลผสานผิดปกติ โปรดตรวจสอบ!`,
"label.monitorsys.recent.logs":`แสดงรายการล็อกล่าสุด 200 รายการตามค่าเริ่มต้น`,
"message.chooseatleastonefield":`เลือกอย่างน้อยหนึ่งฟิลด์`,
"lable.PowerProcess.name1":`ชื่อกระบวนการให้สิทธิ์`,
"label.processdetail":`ประมวลผลรายละเอียดคำนิยาม`,
"label.upload.file.size.limit":`ขนาดไฟล์อัปโหลดต้องไม่เกิน 2MB!`,
"label.forecast.userenablepage.desc":`ผู้ใช้ที่เปิดใช้งานการพยากรณ์จะปรากฎในรายการ "ผู้ใช้ที่เปิดใช้งาน" เมื่อต้องการเปิดใช้งานผู้ใช้ที่พร้อมใช้งานให้เพิ่มผู้ใช้เหล่านั้นลงในรายการ "ผู้ใช้ที่เปิดใช้งาน" เมื่อต้องการปิดใช้งานผู้ใช้ให้ลบผู้ใช้ออก`,
"label.visualpage.type.detailembed":`ให้เพจประเภท detailEmbed เป็นเพจที่กำหนดเองมาตรฐาน`,
"label.textmessage.vonage.configurations":`การปรับแต่ง`,
"label.report.select.chart.and.item":`เลือกแผนภูมิและรายการไฮไลต์`,
"label.data.downpage.i.title.num1":`1. ระบบรองรับเฉพาะรูปแบบ CSV ทั่วไป`,
"label.mobileapp.scansetting":`สแกนการตั้งค่าโมดูลบนอุปกรณ์มือถือ`,
"chatter.emailFollow":`ติดตาม`,
"label.weixin.businformation":`ข้อมูลยานพาหนะ`,
"label.import.index.recentrecord":`บันทึกที่นำเข้าล่าสุด`,
"label.case.update":`อัปเดต`,
"label.isEnableVisualpage.new.desc":`เลือกหน้าเพจที่กำหนดเองเพื่อเพิ่มลงในรายการหน้าเพจที่กำหนดเองที่เปิดใช้งาน หลังจากบันทึกแล้วโปรไฟล์จะสามารถเข้าถึงหน้าเพจที่กำหนดเองที่เปิดใช้งานได้`,
"label.emailobject.wizard.title":`เชื่อมต่ออีเมลส่วนตัวของคุณ`,
"vue_label_ccchat_notice_deletepostsuccess":`การลบโพสต์สำเร็จ`,
"label.deleteQuoteLine":`ลบใบเสนอราคา`,
"label.integrations.export.failed.Mailchimp":``,
"label.increase":`  บวก`,
"label.setup.mobile.homepageshortcuts.setunable":`หน้าแรกไม่แสดงโมดูล`,
"label.ccchat.person.invite.toolong":`คุณไม่สามารถป้อนข้อความที่ยาวเกิน 255 อักขระ`,
"label.knowledge.setting.help":`ช่วยเหลือลูกค้าด้วยตนเอง`,
"label.is_pigeonhole":`จะจัดเก็บถาวรใช่หรือไม่`,
"message.atleastonecommitter":`ต้องมีผู้เสนออย่างน้อยหนึ่งคน`,
"label.emailobject.wizard.desc4":`ใส่เวลานัดหมายเพื่อให้การเชิญแบบหลายคนง่ายขึ้น`,
"APPIntegration_Dropbox_setting_02":`ปิดการใช้งาน`,
"template.report.open.opportunities":`โอกาสทางธุรกิจที่ยังไม่ได้ปิด`,
"label.goonwork":`ทำงานต่อ`,
"label.isiands.time":`เวลาเกาะ`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`กฎที่เปิดใช้งาน (แต่ละออบเจ็กต์รองรับการเปิดใช้งานกฎรหัสคิวอาร์หรือกฎบาร์โคดหนึ่งข้อเท่านั้น)`,
"label.summaryreport.2018.step2":`ขั้นตอนที่ 2 : เลือกข้อมูลที่จะสรุป`,
"pagecreator.systemstyle.message.delete.success":`การลบรูปแบบสำเร็จ`,
"label.standarduser":`ผู้ใช้มาตรฐาน`,
"label.reportsSubscription.succeeded":`การสมัครใช้งานรายงานสําเร็จ!`,
"lable.Select.a.template":`เลือกแม่แบบรายงานการบริการที่มีอยู่เป็นพื้นฐานสำหรับแม่แบบใหม่ของคุณ`,
"label.file.library.addfile2libsuccess":`{0} ไฟล์ อัปโหลดเรียบร้อยแล้ว！`,
"label.searchfield.instruction":`ฟิลด์ค้นหาคือฟิลด์สำหรับการค้นหาทั้งหมดหรือการสืบค้นออบเจ็กต์หนึ่งใด หากไม่ได้เลือกค่าเริ่มต้นจะดำเนินการสืบค้นตามฟิลด์ผลการค้นหาที่เลือกไว้`,
"U":`URL`,
"label.Time.slot.overlap":`ช่วงเวลาหนึ่งหรือหลายช่วงเวลาทับซ้อนกัน โปรดอัปเดตเป็นช่วงเวลาที่ไม่ทับซ้อนกัน`,
"vue_label_chat_opportunity_details":`รายละเอียดโอกาส`,
"label.knowledge.category.hint.seven":`กลุ่มหมวดหมู่ที่เลือก`,
"label.chatter.list":`รายการ`,
"front-email-payment-Invoice-preview":``,
"label_emailsync_message1":`หลังจากยกเลิกการเชื่อมโยงเนื้อหาอีเมลจะไม่ซิงค์กับผู้ติดต่อและลีด  ยืนยันการยกเลิกหรือไม่?`,
"label.summaryreport.step5":`ขั้นตอนที่ 5: กำหนดลำดับของแถวในรายงาน`,
"component_newrecords_label_name":`ชื่อ`,
"label.appointment.wizard.subtitle4-4-5":`สองเดือน`,
"component_salesperformance_label_title":`ประสิทธิภาพการขาย`,
"label.ccchat.person.invite.says":`พูดว่า:`,
"label.fax":`แฟกซ์`,
"label.knowledge.modify.article":`แก้ไขบทความ`,
"label.componenteditor.Limit.number.components":`ในหนึ่งหน้าเพิ่มส่วนเสริมได้สูงสุด 15 รายการ`,
"label.multilang.forecast.shrepage.desc":`หน้าเพจนี้แสดงรายชื่อผู้ใช้ บทบาทและภูมิภาคที่มีการเข้าถึง{0}ร่วมกัน`,
"label.chat.micropost.write.comment":`เขียนความคิดเห็น`,
"Lead.Scoring.Setting.Rule.Setup.Active":`เปิดใช้งานหรือไม่`,
"label.ccpeakfolder.time":`โฟลเดอร์คลาสตัวจับเวลา`,
"label.partnerCloud.financeSetting.filter":`เงื่อนไขการกรอง:`,
"label.knowledge.delete.topicassignment":`เกิดข้อผิดพลาดในการลบการกําหนดหัวข้อ`,
"label.file.orderbyname":``,
"vue_label_chat_activelater":`เปิดใช้งานภายหลัง`,
"chatter.reply":`ตอบกลับ`,
"label.setup.profile.accordtext":`ตัวอักษรที่แสดงคือ`,
"label.encd.plaintext":`ดูข้อความ`,
"label.h5.approval.cannotreassignmark":`ไม่อนุญาตให้กำหนดรายการผู้อนุมัติแทนใหม่ โปรดเลือกรายการอนุมัติอีกครั้ง`,
"label.version.area.lookup":`{0}กล่องข้อความหรือฟิลด์ค้นหาแบบตัวเลือก`,
"approval.request.email.body":`รายการต่อไปนี้กำลังรอการอนุมัติ: \ n คลิกลิงก์ด้านล่างเพื่ออนุมัติ: \ n`,
"label.user.mass.emails.select":`ส่งอีเมลแบบกลุ่ม : เลือกแม่แบบ`,
"lable.quote.syncing.title":`ซิงโครไนซ์ ใบเสนอราคา และโอกาสทางธุรกิจ`,
"vue_label_dashboard_dashboardaccess":`สิทธิ์การเข้าถึงแดชบอร์ด`,
"label_emailtocloudcc_filed_owner":`เจ้าของบันทึก`,
"label.brief.page":`หน้า`,
"label.isEnableVisualpage_new.desc":`เลือกเพจแบบกำหนดเองที่พร้อมใช้งานเพื่อเพิ่มลงในรายการเพจแบบกําหนดเองที่เปิดใช้งาน   หลังจากบันทึกแล้วโปรไฟล์จะสามารถเข้าถึงเพจแบบกําหนดเองที่เปิดใช้งานได้`,
"label.service.shift.view":`มุมมองกะ`,
"label.emailsync.addnewaccount":`เพิ่มบัญชีใหม่`,
"label.forecast.settings.prompt":`ปิดใช้งานการแบ่งปันการพยากรณ์จะลบการเข้าถึงการแบ่งปันที่กำหนดเองทั้งหมด`,
"front-electronic-signature-explain-second":``,
"label.emailtocloudcc.redmessage3":`โปรดระบุที่อยู่เซิร์ฟเวอร์`,
"message.confirmgiveupedit":`หากคุณออกจากหน้านี้ การเปลี่ยนแปลงที่ไม่ได้บันทึกทั้งหมดจะหายไป ทำต่อหรือไม่?`,
"label.gantt.plan.success":`วางแผนสำเร็จ`,
"label.monitorsys.type.error":`โปรดเลือกประเภทแบบสอบถาม`,
"label.industrialandcommercialverification.button.setup":`ตั้งค่า`,
"today":`วันนี้`,
"label.attendance.setting.position":`ตั้งค่าที่หมาย`,
"chatter.mynews":`ข่าวสารของฉัน`,
"label.recycle.dis.tip1":`ระบบจะเก็บข้อมูลไว้ในถังขยะรีไซเคิล 15 วัน หลังจากบันทึกอยู่ในถังขยะรีไซเคิลเป็นเวลา 15 วัน จะถูกลบออกอย่างถาวร`,
"label.icon.81":`ทำความเย็น`,
"label.customer.tab.page.prompt":`กรุณากําหนดค่าอย่างน้อยหนึ่งหน้า!`,
"label.globalselect.use":`ใช้ชุดค่ารายการตัวเลือกระดับโกลบอล`,
"template.report.customer.sales.order":`ใบสั่งขายของลูกค้าในระดับต่างๆ`,
"vue_label_dashboard_lastruntime":`เวลาดำเนินการล่าสุด`,
"label.edit.ccpeakfolder":`คลาส: แก้ไขโฟลเดอร์`,
"vue_label_lead_be_converted":`อยู่ในสถานะข้ามสเตจแล้ว ไม่สามารถเปลี่ยนได้`,
"label.tabpage.filenamez":`ชื่อไฟล์`,
"label.please.click.add.products.":`โปรดคลิก ""เพิ่มผลิตภัณฑ์"" เพื่อเพิ่มผลิตภัณฑ์ลงในใบเสนอราคา`,
"label.followup_emails":`เมื่อผู้เข้าชมส่งแบบฟอร์ม อีเมลติดตามเป็นวิธีที่รวดเร็วและง่ายดายในการติดต่อกับพวกเขา`,
"label.indochina.time":`เวลาอินโดจีน`,
"message.error.task.email":`ข้อยกเว้นภารกิจอีเมล`,
"label.dynamic.copy":`คัดลอกกฎเค้าโครงแบบไดนามิกพร้อมกัน`,
"label.log.d":`ดาวน์โหลดล็อกการตรวจสอบภายในระยะเวลาการค้นหา (ไฟล์ Excel.csv) >>`,
"pagecreator_layout_label_layoutname":`ชื่อเค้าโครง`,
"template.chart.htsktj":`สถิติการชำระเงินตามสัญญา`,
"label.appointment.wizard.subtitle4-2-5":`1 วัน`,
"label.view_form":`ดูฟอร์ม`,
"label.tablet":`แท็บเล็ต`,
"label.campaignmember.main.addcontact":`เพิ่มสมาชิก-ผู้ติดต่อปัจจุบัน`,
"message.get.userinfo.error":`การรับข้อมูลผู้ใช้ล้มเหลว`,
"label.department.username":`ชื่อผู้ใช้`,
"label.ems.verifysuccess":`ยืนยันการเพิ่มบัญชีอีเมลสำเร็จ!`,
"label.batchedit.copyValue":`นำไปใช้กับคอลัมน์นี้`,
"label.trigger.triggerVersion":`รุ่น`,
"label.mr.descreption.oneGroupReData5":`ข้อมูลกลุ่มไม่ได้ประมวลผล`,
"label.appointmentconfirmpage.wizard.subtitle5":`คำอธิบาย`,
"label.weixin.inbetween":`เลือกได้หลายข้อ`,
"label.salescloud.contactrole.relatelist.customnize":`รายการนี้ไม่สามารถปรับแต่งได้`,
"label.data.exp.please.nameanddes":`กรุณากรอกชื่อและคำอธิบายแม่แบบ`,
"label_partner_workspace_login":`หน้าเข้าสู่ระบบ`,
"label.notification.approval7":`[ชื่อผู้แทน]ปฏิเสธการขออนุมัติ[ออบเจ็กต์][ชื่อออบเจ็กต์]ที่[ผู้เสนอ]ร้องขอแทนคุณ`,
"message.send.posts.image.error":``,
"message.fieldtrack.operateupdate":`เปลี่ยนแปลงแล้ว`,
"label.sharerule.grantuselevelconstructureaccess":`ให้สิทธิ์การเข้าถึงโครงสร้างลำดับชั้น`,
"label.translation.setup":`การตั้งค่าหลายภาษา`,
"PageLayout.Search.MultiSearch.003":`คุณต้องเลือกอย่างน้อยหนึ่งฟิลด์`,
"label.ccchat.person.emaildomain":`โดเมนอีเมลของบริษัท`,
"pagecreator.systemstyle.label.bordercolor":`สีเส้นขอบ`,
"label.submit":`เสนอ`,
"UG.Lead.001":`จะดึงลีดเข้ามาอย่างไร?`,
"label.icon.172":`แผนที่`,
"label_chatter_owner":`เจ้าของ`,
"vue_label_systemSettings_Currency":`การจัดการสกุลเงิน`,
"page.layout.binfo":`ข้อมูลพื้นฐาน`,
"label.version.date":`{0} ฟิลด์วันที่`,
"label.data.is.woking":`กำลังดำเนินการ`,
"label.customfields.searchrelation.dependobjectDefault.tip":`สามารถเลือกบันทึกในออบเจ็กต์ที่เกี่ยวข้องเป็นค่าเริ่มต้นของฟิลด์นี้`,
"label.partnerCloud.orderingPlatform.configuration":`กําหนดค่าผลิตภัณฑ์`,
"lable.currencyManage.Enabledadvcurrency":`เปิดใช้งานการจัดการสกุลเงินขั้นสูง`,
"label.event.moveup.3hour":`ล่วงหน้า 3 ชั่วโมง`,
"label.reportexport.object":`ออบเจ็กต์ส่งออก`,
"front-dialog-module-v1-requestid":`ID คำขอ`,
"label.pw.symol":`สัญลักษณ์`,
"label_group_field":`ระบุฟิลด์การจัดกลุ่ม`,
"label.recallapprove":`เรียกคืนคำขออนุมัติ`,
"vue_label_pool_deal_done":`ปิดแล้ว`,
"label.shangqing.description":`นี่คือคำอธิบายที่เกี่ยวกับข้อมูลธุรกิจ`,
"label.view.allcansee":`<b>ผู้ใช้ทุกคน</b>สามารถมองเห็น`,
"chatter.poll.addOption":`เพิ่มตัวเลือก`,
"label.icon.112":`อาหารและเครื่องดื่ม`,
"label.ignorecase":`ถือว่า ABC "และ" abc "เป็นค่าที่ซ้ำกัน (ไม่ไวต่ออักษรใหญ่เล็ก)"`,
"label.email.track.edit":``,
"label_tabpage_erraddressz":`รูปแบบที่อยู่อีเมลไม่ถูกต้อง โปรดป้อนที่อยู่อีเมลให้ถูกต้อง`,
"label_tabpage_viewz":`พิมพ์มุมมองปัจจุบัน`,
"component.timeline.label.future":`ขั้นตอนถัดไป`,
"label.b_c_without":`บันทึกB"อาจจะมีหรือไม่มีความเกี่ยวข้องกับบันทึก"C" "`,
"label.version.autonumberfield":`ฟิลด์ตัวเลขอัตโนมัติ`,
"label.appointmentdetail.wizard.title5":`ลิงก์คําเชิญ`,
"label.weixin.addoption":`เพิ่มตัวเลือก`,
"label.b.c":`ความสัมพันธ์จาก B ไป C`,
"chatter.group.complete":`สำเร็จ`,
"label.must.numeric.value":`ต้นทุนต้องเป็นค่าตัวเลข`,
"lable.edit.queue.memberdes":`หากต้องการเพิ่มสมาชิกในคิวนี้ ให้เลือกประเภทสมาชิก จากนั้นเลือกบทบาทหรือผู้ใช้จาก "สมาชิกที่พร้อมใช้งาน" และย้ายไปที่ "สมาชิกที่เลือก" "หากวิธีการแบ่งปันของออบเจ็กต์ทั้งหมดในคิวเป็น "การอ่าน/เขียน/โอนย้ายทั่วไป" คุณไม่จำเป็นต้องกำหนดผู้ใช้ให้กับคิวเนื่องจากผู้ใช้ทั้งหมดสามารถเข้าถึงบันทึกของออบเจ็กต์เหล่านี้`,
"label.staticresource.chose.limit":`อยู่ระหว่างการปรับปรุงฟังก์ชัน ไม่สามารถรองรับการใช้ไฟล์รูปแบบนี้ได้ชั่วคราว  โปรดรอติดตาม`,
"vue_label_commonobjects_view_kanban_unset":`โปรดเลือกเกณฑ์การจัดกลุ่มในการตั้งค่ามุมมองคัมบัง`,
"label.appexchange.download.merge.mes":`ส่วนเสริมที่ขัดแย้งต่อไปนี้ได้รับการติดตั้งโดยการผสาน:`,
"label.sharerule.baseofowner":`ขึ้นอยู่กับเจ้าของบันทึก`,
"label.email.template.manage.SMS":`จัดการแม่แบบข้อความสั้น`,
"label.imgfield.example.tip":`หากสถานะการอนุมัติเป็นอนุมัติ "จะเป็นรูปสีเขียว หากไม่จะเป็นรูปสีแดง"`,
"template.report.potential.customer.industry":`อุตสาหกรรมของลีด`,
"component_hots_label_title":`ข้อเสนอยอดนิยม`,
"label_file_use_document":`การใช้พื้นที่จัดเก็บ`,
"label.input.path":`ป้อนเส้นทางอ้างอิง`,
"label.partnerCloud.financialSetup":`การตั้งค่าทางการเงินของพาร์ทเนอร์`,
"label_tabpage_myz":`ของฉัน`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`หลังจากลบแล้ว Email to CloudCC จะไม่สามารถใช้ผ่านทางอีเมลนี้ได้ ยืนยันการลบ?`,
"label.customfields.fielddependency.sure":`ค่าฟิลด์ควบคุมไม่รวมค่าที่ต้องพึ่งพา ยังต้องการบันทึกใช่หรือไม่?`,
"label.project.task.date":`วันที่ของงานต้องอยู่ในช่วงวันที่ของไมล์สโตน`,
"Report.CantDelete.Info":`รายงาน{0}ถูกอ้างอิงโดยแดชบอร์ด{1} ไม่สามารถลบได้!`,
"label.assignment.setup.title":`เกณฑ์การมอบหมาย`,
"image.pt.most.maxsize":`ขนาดไฟล์สูงสุดคือ 2M`,
"label.appupload.introduce":`แพ็กเกจประกอบด้วยส่วนเสริมต่างๆ เช่น แอปพลิเคชัน ออบเจ็กต์ เมนู ทริกเกอร์ และเพจที่กำหนดเอง แพ็กเกจเหล่านี้สามารถอัปโหลดและโพสต์ไปที่ Cloudcc.com AppExchange เพื่อการแบ่งปันแบบสาธารณะ รายการต่อไปนี้แสดงแพ็กเกจทั้งหมดที่องค์กรคุณสร้าง หากต้องการสร้างแพ็กเกจใหม่ โปรดคลิก "ใหม่"`,
"label.import.page2.confirm":`ยืนยัน`,
"label.console.step2.introduce":`เติมฟิลด์ด้านล่างเพื่อนิยามคอนโซล`,
"label.extendsfather":`จากพาเรนต์`,
"front-homepageobject-module-v1-year":``,
"front-grasp-sales-opportunities":`CRM ช่วยให้คุณเข้าใจโอกาสในการขายได้อย่างถูกต้องแม่นยำ ได้ลีดมากขึ้น เสนอราคาได้อย่างรวดเร็ว ทำธุรกรรมได้มากขึ้น ทำให้ลูกค้าเข้าถึงได้จากหลากหลายช่องทาง และปรับปรุง ROI ขององค์กรอย่างต่อเนื่อง`,
"label.tab.oldpage":`หน้าเพจรุ่นเก่า`,
"label.service.miniProgram.intro":`บทนํา`,
"label.data.import.setup.operate.insert":`แทรกบันทึกใหม่เท่านั้นไม่อัปเดตบันทึกที่มีอยู่`,
"label.ccpeak.direction.for.use":`คู่มือการใช้คลาสของแพลตฟอร์ม CloudCC [รุ่น 2.0]`,
"label.sendemail.chat.addComentsmyFeedsubject":`CloudCC CCChat ตอบกลับเวยเทีย`,
"label.campaignmember.main.importmember.contacts":`นำเข้าสมาชิก-ผู้ติดต่อปัจจุบัน`,
"setup.mainpage.label.welcome20":`อีเมล แม่แบบข้อความสั้น`,
"label.newbatcheditor.remark":`ระบบจะใช้เค้าโครงรูปแบบชนิดบันทึกของข้อมูลในแถวแรกเป็นเค้าโครงเพจเริ่มต้นในการแก้ไขแบบจำนวนมากสำหรับต่างชนิดบันทึกของต่างบันทึก`,
"label.step4.total7":`ขั้นตอนที่ 4 จาก 7`,
"label.campagin.roi.tzhbl":`อัตราผลตอบแทนจากการลงทุน`,
"label.emailmerge.mergepage.step3":`บันทึกกิจกรรม`,
"label.marketsea.isrecyclecreatebyself":`จะรีไซเคิลลูกค้าที่สร้างเองหรือไม่`,
"message.mobilechooseatmost.five":`เมนูส่วนหน้าของโทรศัพท์มือถือสามารถเลือกได้สูงสุดห้าฟิลด์`,
"label.icon.171":`โรงแรม`,
"label.saveandnext":`บันทึกและขั้นตอนต่อไป`,
"label.import.page1.selectcodingtype":`เลือกประเภทการเข้ารหัส`,
"label.searchlayout.displaybutton":`ปุ่มที่แสดง`,
"label.approvalstep5":`ขั้นตอนที่ 5: เลือกคุณสมบัติการแก้ไขของฟิลด์ที่จะแสดงในเค้าโครงหน้าการอนุมัติ`,
"label.passwordPolicy.setup.enforcePswHis":`ประวัติของรหัสผ่านเอ็นฟอร์ส`,
"vue_label_commonobjects_detail_contact_hierarchy":`ลําดับชั้นผู้ติดต่อ`,
"front-kefu-moudle-v1-trythjzx-intelligent":``,
"label.select.statistical.indicators":`กรุณาเลือกตัวชี้วัดทางสถิติ`,
"label.callcenter.Tianrun.RONGTONG":``,
"label.file.library":`ไลบรารีเอกสาร`,
"lable.completion.rate.color.setting":`การตั้งค่าสีอัตราความสำเร็จ`,
"label.name.firstname":`ชื่อ`,
"setup_layout_label_readonly":`อ่านอย่างเดียว`,
"label.chatter.recordcall":`บันทึกการโทร`,
"label.service.appointmentList.service.empty":`การนัดหมายการบริการว่างเปล่า`,
"component_milestones_label_choicestate":`ยืนยันสถานะนี้`,
"label.approved.receiveApprovalEmail.option2":`เฉพาะเวลาที่ฉันเป็นผู้อนุมัติ`,
"label.marketseamemset.account.title":`การตั้งค่าสมาชิกฐานข้อมูลลูกค้า`,
"label.changemydisplay.list.custom":`ปรับแต่งเมนูของฉัน`,
"label.emailtemplate.selecttype":`เลือกประเภทแม่แบบอีเมล`,
"component_timeline_label_title":`ไทม์ไลน์`,
"chatter.group.addRemoveMembers":`เพิ่ม/ลบสมาชิก`,
"label.console.step6.width":`ความกว้าง`,
"pagecreator.systemstyle.message.delete.fail":`การลบรูปแบบล้มเหลว`,
"label.partnerCloud.orderingPlatform.productPrice":`ประเภทผลิตภัณฑ์{productQuantity} ทั้งหมด {totalCount} ชิ้น ราคาตั้งต้น: {currency} {originalPrice} ส่วนลด: {currency} {Reduction}`,
"label.h5.share":`แบ่งปัน`,
"label.schedulejob.setup.list.tip":`ตั้งค่าแผนการดำเนินงานเป็นรายสัปดาห์หรือรายเดือนแบบอัตโนมัติ`,
"message.intheapproving":`บันทึกนี้อยู่ในกระบวนการอนุมัติแล้ว ไม่สามารถเสนอได้อีก`,
"vue_label_commonobjects_detail_real_time":`เมื่อเข้าร่วมแล้วกลยุทธ์กลุ่มจะปรากฏในรายการกลยุทธ์กลุ่มของคุณซึ่งจะถูกส่งให้คุณแบบเรียลไทม์`,
"label.autoRegister.changepwd.setpwd.too.weak":`สั้นเกินไป`,
"label.salescloud.forbiddenteamsales":`ปิดการใช้การขายแบบทีม`,
"component.chatter.link.label.title":`ลิงก์`,
"label.layout.editsearchdistribute.page":`เลือกหน้าเพจที่กำหนดเองที่ต้องการจะรวมในหน้าแท็บเมนู`,
"label.dashboard.show.value.percent":`แสดงมูลค่าและแสดง % กรุณาเลือกอย่างน้อย 1 ตัวเลือก`,
"label.everymonth":`ทุกเดือน`,
"label.campaign.channel.download.size1":`ขนาดใหญ่: 1000*1000 พิกเซล`,
"permissionService.error2":`ไม่สามารถเพิ่มสิทธิ์ของแอปได้`,
"button.partner.workspace.manage.memo":`จัดการพาร์ทเนอร์คลาวด์ของคุณ และตั้งค่าคุณสมบัติของพาร์ทเนอร์คลาวด์`,
"label.forecast.forehistory.commit.remark":`ส่งหมายเหตุ`,
"six":`หก`,
"label.datamanage.donot.export.object":`ไม่อนุญาตให้ส่งออกออบเจ็กต์ข้อมูล`,
"label.schedulejob.setup.schedule.execute":`ดำเนินการ`,
"lable.account.CurrentandPreviousCY":`ปีปฏิทินนี้และปีปฏิทินก่อนหน้า`,
"label.temp.SMS":`แม่แบบข้อความสั้น`,
"label_partner_all_state":`สถานะ`,
"label.editdocument":`แก้ไขคุณสมบัติ`,
"front-epwechat-module-v1-ios-single":`SSO ของ iOS:`,
"lable.redo":`ทําซ้ํา`,
"vue_label_SMS_alltemplates":`แม่แบบทั้งหมด`,
"label.allfolderreport":`โฟลเดอร์รายงานทั้งหมด`,
"label.layout.alltab":`แท็บทั้งหมด`,
"lable.account.Yesterday":`เมื่อวาน`,
"label.formula.to.evaluate":`ประเมินสูตร`,
"component_setup_label_setupsaveok":`บันทึกการตั้งค่าส่วนเสริมสำเร็จ`,
"pagecreator_page_message_canntdelete":`ไม่อนุญาตให้ลบหน้าเพจปัจจุบัน`,
"label.tab.message.failtotp":`แท็บล้มเหลว`,
"label.h5.chatter.location":`แทรกตำแหน่งที่ตั้ง`,
"vue_label_commonobjects_view_chart_gotodashboard":`ไปที่แดชบอร์ด`,
"label.data.exp.conf":`ยืนยันว่าจะส่งออกข้อมูลหรือไม่?`,
"label.currency.e":`การแก้ไขประเภทสกุลเงิน`,
"message.matrixReportSetupStage.column":`โปรดเลือก [กำหนดหัวแถว] เกณฑ์ผลรวมย่อย และเลือกเกณฑ์ผลรวมย่อยอย่างน้อยหนึ่งจากสองเกณฑ์`,
"font-evaluate-module-v1-have-comment":``,
"chatter.feed.dao":`ถึง`,
"label.import.index.notice":`หมายเหตุ:`,
"label.weixin.information":`รายละเอียด`,
"label.multilingual.tip5":`สถานะหลายภาษาไม่ถูกต้อง โปรดรีเฟรชและลองอีกครั้ง!`,
"label.appointment.wizard.subtitle3-7":`วันอาทิตย์`,
"label.emailobject.groupemail.fail.content":`{0}ที่เคารพ: \r\nสวัสดี! ที่อยู่อีเมลที่ส่งอีเมลกลุ่มล้มเหลวคือ: {1} \r\nCloudCC`,
"vue_label_notice_uploadavatar_fail":`อัปโหลดรูปโปรไฟล์ล้มเหลว`,
"chatter.group.myGroup":`กลุ่มของฉัน`,
"label.ccpeak.object.fieldapi.name":`เป็นชื่อฟิลด์ API ของออบเจ็กต์`,
"lable.activeCurrency":`สกุลเงินที่ใช้`,
"label.file.save.to.send":`บันทึกและส่งอีเมล`,
"label.emailmerge.list.editfolder":`แก้ไขโฟลเดอร์`,
"label.Path.Setting":`การตั้งค่ากระบวนการ`,
"label.validate.function.funcFormat.DATE":`DATE(year,month,day)`,
"message.objapiexists":`มีออบเจ็กต์ api นี้อยู่แล้ว`,
"label.sendmail.batch.confirm":`ส่งอีเมลแบบกลุ่ม: ยืนยัน`,
"message.approval.cannotsubmit.detail":``,
"setup.layout.button.deleteitem":`ลบรายการที่เลือก`,
"label.end.loginipIP":`ที่อยู่ IP สิ้นสุด`,
"component_event_label_subject":`หัวข้อ`,
"message.500":`ข้อผิดพลาดภายในของเซิร์ฟเวอร์`,
"label.wei.polltype":`ประเภท`,
"vue_label_norm_duplicate":`สำเนา`,
"label.addcycletrigger":`เพิ่มทริกเกอร์วงจร`,
"DetailedInfo.Activity.EmailMessage.01":`{0} ส่งอีเมลให้{1}แล้ว`,
"No.Activity":`ไม่มีกิจกรรม`,
"label.chat.topic.add.topic":`คลิกเพิ่มหัวข้อ`,
"label.schedulejob.setup.schedule.morning":`ช่วงเช้า`,
"chatter.save.al":`บันทึกการเปลี่ยนแปลงของคุณแล้ว`,
"label.setsharerule.step3":`ขั้นตอนที่สาม: เลือกบทบาทที่ต้องการแบ่งปัน`,
"label.tabpage.Sdfez":`วันก่อน`,
"label_submit_forecast":`ส่งการพยากรณ์`,
"label.version.sum.formulafield":`ฟิลด์สูตร`,
"lable.weixin.you.invitation":`คำเชิญทั้งหมดของคุณ`,
"label.stacked.horizontalbar":`กราฟิกแบบซ้อน-แผนภูมิแท่งแนวนอน`,
"label.file.anyone.can.link":`ทุกคนที่มีลิงก์นี้จะสามารถดูและดาวน์โหลดไฟล์ได้`,
"label.campaignmember.main.importmember.lead.desc":`นำเข้าข้อมูลในไฟล์ไปยังลีดของแคมเปญนี้`,
"UG_activity_01":`คุณติดตามบันทึกการโต้ตอบระหว่างลูกค้า/ทีมของคุณได้อย่างไร?`,
"label.reason":`เหตุผล`,
"label.version.free.createmax":`อนุญาตให้สร้างบันทึกได้ 2,000 รายการ ซึ่งถึงขีดจำกัดแล้ว!`,
"label.brief.thisweek":`สัปดาห์นี้`,
"label.deleteobjinapprove":`กรุณาใส่คำอธิบายประกอบเพื่อลบออบเจ็กต์นี้ออกจากกระบวนการอนุมัติ`,
"calendar.tips.event":``,
"label.customerinfo.mailinfo":`ข้อมูลอีเมลบริษัท`,
"lable.electronic.signature":`ลายเซ็นอิเล็กทรอนิกส์`,
"label_emailsync_addnewaccount":`เพิ่มบัญชีใหม่`,
"label.layout.exampleoftesgobj":`ตัวอย่างออบเจ็กต์ทดสอบ`,
"label.happen_submit":`ขั้นตอนต่อไปหลังจากผู้เข้าชมส่งฟอร์มนี้คืออะไร`,
"label.forecast.customforecast.button.submit":`เสนอ`,
"label_right_click_notice":``,
"font-trade-module-v1-invoice-no-price":``,
"lable.opppdt.selPdt.morecondtions":`ตัวกรองเพิ่มเติม`,
"label_invalid_token":`token ไม่ถูกต้อง`,
"label_chatter_postup":`เผยแพร่`,
"label.escalation.setup.newaction.step1":`ขั้นตอนที่ 1: กำหนดเงื่อนไขเวลาของเกณฑ์การเลื่อนขั้นนี้`,
"label.sendmail.step3.dealoption2":`เก็บกิจกรรมของอีเมลทุกฉบับ`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`ยืนยันว่าจะลบแม่แบบแบบกลุ่มหรือไม่?`,
"vue_label_appstore_enter_website":`เข้าสู่เว็บไซต์ทางการ`,
"label.when":`เวลาเผยแพร่`,
"label.linellae":`ลายเส้น`,
"label_chatter_detailinfo":`รายละเอียด`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`อัตราการชำระเงิน`,
"vue_label_homepage_dashboard_deleted":`ลบแดชบอร์ดแล้ว`,
"pagecreator.layout.button.vertical":`แยกตามแนวตั้ง`,
"label.redistribution1":`เลือกได้มากที่สุด 5 คน`,
"pagecreator_page_label_modifypage":`ตัวแก้ไขหน้าเพจ`,
"label.Service.Cloud.Setting":`การตั้งค่า Service Cloud`,
"setup_layout_label_pagename":`ชื่อเค้าโครงเพจ`,
"label.ems.send":`ส่ง`,
"vue_label_commonobjects_view_kanban_notice1":`มุมมองคัมบังจะแสดงบันทึก 200 รายการแรกเท่านั้น`,
"lable.outlook.detail.maping":`การแม็ปฟิลด์`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`การตั้งค่าแถบเลื่อนด้านข้างอุปกรณ์มือถือ`,
"label.trigger.operation.email.template.param":`พารามิเตอร์การจัดส่ง: ภาษา,ID แม่แบบข้อความ, ID บันทึก`,
"front-objectTemplate-V1-Select-a-template":`เลือกแม่แบบที่มีอยู่เป็นพื้นฐานสําหรับการสร้างแม่แบบใหม่ของคุณ`,
"label.email.template.delete.template":`ยืนยันหรือไม่ว่าต้องการลบแม่แบบนี้?`,
"label.reportsSubscription.cancel":`ยกเลิก`,
"lable.quote.syncingfrom.firstsync.description":`ผลิตภัณฑ์ที่มีโอกาสทางธุรกิจจะแทนที่รายละเอียดใบเสนอราคา`,
"label.weixin.no.pending.xsld.qin":`ขณะนี้ไม่มีข้อมูลกรวยการขาย`,
"template.dashboard.sales.indicators":`ดัชนียอดขาย`,
"label.field.new":`ดำเนินการประเมินและให้คะแนนแก่ผู้ใช้`,
"label.generatepage.title.desc1":`สร้างรหัส HTML สำหรับอุปกรณ์มือถือหรือ PC ตามฟิลด์ที่เลือก ผู้ใช้สามารถแก้ไขรหัสได้ตามต้องการ`,
"template.report.source.potential.customers":`ที่มาของลีด`,
"label.mr.title.queryData":`สืบค้นข้อมูลซ้ำ`,
"button_partner_workspace_enable":`เปิดการใช้งานพาร์ทเนอร์คลาวด์`,
"V":`หมายเลขอัตโนมัติ`,
"label.icon.19":`โฟลเดอร์`,
"vue_label_report_summaryformula":`สูตรสรุป`,
"label.appointment.wizard.subtitle2":``,
"label.stdashbord.xsld.business.bjdzhl":`อัตราการข้ามสเตจของสเตจนี้`,
"label.forecast.forehistory.deopportunity":`โอกาสทางธุรกิจของ`,
"chatter.email.referredToMeLeaveMessage":`เมื่อกล่าวถึงฉันในข้อความ (เช่น เมื่อ @)`,
"label.dategrouprelyon":`จัดกลุ่มวันที่ตาม`,
"label.sendmail.batch.finish":`ส่งอีเมลแบบกลุ่ม: เสร็จสิ้น`,
"label.weixin.allexpired":`หมดอายุทั้งหมด`,
"label.dashboardSetup.showdw.d4":`หมื่น`,
"message.duplication.label.masterRecord":`บันทึกหลัก`,
"vue_label_calendar_availability":`ความพร้อมใช้งาน`,
"vue_label_chat_approval_message":`ข้อความอนุมัติ`,
"vue_label_zhang_er":`จางเอ้อร์`,
"label.select.options":`โปรดเลือกตัวเลือก`,
"label.israel.daylight.time":`เวลามาตรฐานอิสราเอล`,
"front-sales-search-QB":``,
"vue_label_account_change_customer":`เปลี่ยนเจ้าของลูกค้า`,
"label.integrations.mailchimp2":`อ่านข้อมูลเพิ่มเติมเกี่ยวกับ Mailchimp และ CloudCC CRM`,
"lable.product.pricebooks.onisu":`สมุดราคาที่ไม่ได้เปิดการใช้งาน`,
"front-electronic-signature-backfill-field":``,
"label.document.myself.folder":`โฟลเดอร์ส่วนตัวของฉัน`,
"label.event.moveup.10hour":`ล่วงหน้า 10 ชั่วโมง`,
"report.label.report":`รายงาน`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(text, compare_text)`,
"label.usermanage.query.false":`การสืบค้นล้มเหลว ไม่พบผู้ใช้`,
"front-epwechat-module-v1-input-EncodingAESKey":`โปรดป้อน EncodingAESKey`,
"label.event.multi.view":`หลายมุมมอง`,
"label.h5.similar.opportunity.setup":`การตั้งค่าโอกาสทางธุรกิจที่คล้ายกัน`,
"label.setting.intergrationlist.button.install":`ติดตั้ง`,
"label.event.monthview":`มุมมองรายเดือน`,
"label.version.weixin":`รุ่นวีแชท`,
"label_emailtocloudcc_redmessage6":`การยืนยัน IMAP / SMTP ล้มเหลว โปรดตรวจสอบว่าที่อยู่อีเมลและรหัสผ่านถูกต้องหรือไม่`,
"UG.homepage.003":`มุมมอง 360 องศา`,
"vue_label_calendar_shared_calendar":`ปฏิทินที่ใช้ร่วมกัน`,
"label.select.hope.merge.num1.record":`โปรดเลือกบันทึกที่คุณต้องการผสานเป็นหนึ่งบันทึก (ครั้งละไม่เกินสามรายการ)`,
"label.createnewprocess":`สร้างกระบวนการอนุมัติใหม่`,
"font-trade-module-v1-invoice-status":``,
"label.customerinfo.introduce":`ข้อมููลโปรไฟล์บริษัท`,
"label.objectname":`ชื่อออบเจ็กต์`,
"label.chosen.field":`ฟิลด์ที่เลือก`,
"label_target_name":`ชื่อแบบจำลองเป้าหมาย:`,
"label.appointment.wizard.subtitle4-4-4":`หนึ่งเดือน`,
"label.emailobject.groupemail.msg1":`ไม่มีที่อยู่อีเมล`,
"label_component_hotdeal_nopermission":`หากต้องการดูข้อมูลเกี่ยวกับโอกาสทางธุรกิจ โปรดติดต่อผู้ดูแลระบบ CloudCC ของคุณ`,
"label.appointmentdetail.wizard.title13":`คำอธิบาย`,
"front-web-module-v1-detail-comment-title":``,
"label.visualpage.component.n1":`1. วิธีการเรียกใช้ <component:Name /> Nameเป็นชื่อเฉพาะของส่วนเสริม`,
"lable.outlook.mcto.erecord":`บันทึกแรก`,
"label.weixin.del.log":`ล้างล็อก`,
"setup_mainpage_label_welcome23":`การตั้งค่าความปลอดภัย`,
"label.selectreportline":`กรุณาเลือกแถวรายงาน`,
"label.chatter.following":`กำลังติดตาม`,
"seven":`เจ็ด`,
"message.error":`ข้อผิดพลาด:`,
"label.mobile.phone.reporter":`ผู้รายงาน`,
"label.valadate.telphone.false":`หมายเลขโทรศัพท์มือถือไม่ถูกต้อง กรุณาตรวจสอบ`,
"label.linkedin.setting":`เชื่อมต่อมินิแอป H5 Linkedin`,
"label.mobile.side.tab.success":`บันทึกการตั้งค่าแถบด้านข้างสำหรับอุปกรณ์มือถือสำเร็จ`,
"label.notification.approval3":`การอนุมัติ[ออบเจ็กต์]ของคุณถูก[ผู้อนุมัติ]มอบหมายใหม่ให้[ผู้อนุมัติใหม่]`,
"label.channel.invites.employees":`ช่องทางนี้เชิญพนักงาน`,
"label.assignment.setup.detail.assigner":`มอบหมายให้`,
"label.campaignmember.main.updatecontactdesc":`อัปเดตสถานะของผู้ติดต่อปัจจุบันทั้งหมดพร้อมกัน`,
"label.permission.detail.app.fenpei":`กำหนดแอปพลิเคชัน`,
"label.copydown":`คัดลอกลง`,
"label_emailsync_status_action":`ดำเนินการ`,
"lable.Please.switch":`โปรดเปลี่ยนไปใช้ระบบแนวนอนหรือแนวตั้งเพื่อใช้ฟังก์ชันนี้`,
"label_adjust_remark":`ปรับหมายเหตุ`,
"label.weixin.newspaper.coverage.list":`กรมธรรม์`,
"label.datamanage.contact.field":`ฟิลด์ผู้ติดต่อ`,
"label.partner.workspace.login.headerfooter":`ส่วนหัวของหน้าและส่วนท้ายของหน้า`,
"lable.account.quarter.ovdate":`วันสิ้นสุดไตรมาสบัญชี`,
"pagecreator.systemstyle.label.textcolor":`สีตัวอักษร`,
"label.industrialandcommercialverification.fieldmappingsettings":`การตั้งค่าการแมปฟิลด์`,
"component_chatter_button_message":`ความคิดเห็น`,
"label.partnerCloud.enterAddress":`กรุณาใส่ที่อยู่`,
"label.email.template.recently.used":`ใช้ล่าสุด`,
"component.event.label.calendar":`ดูปฏิทิน`,
"label.setup.mobile.offlinecache.setting":`การตั้งค่าแคชออฟไลน์สำหรับอุปกรณ์มือถือ`,
"label.custom.PreviousCQ":`ไตรมาสที่กําหนดเองก่อนหน้า`,
"lable.total.of.payments":`ยอดชำระทั้งหมด 0 รายการ`,
"label.ccpeak.use.class.time.trigger":`หากทริกเกอร์ใช้คลาสนี้ คุณสามารถใช้เมธอดใน CCService ได้โดยตรง`,
"label_tabpage_addresswrongz":`รูปแบบที่อยู่อีเมลไม่ถูกต้อง โปรดป้อนที่อยู่อีเมลให้ถูกต้อง!`,
"vue_label_homepage_select_components":`เลือกส่วนเสริม`,
"front-kefu-moudle-v1-secretID-reinput":`กรุณาใส่ secretID`,
"label.ccdocument.select.template.red":`โปรดเลือกแม่แบบเพื่อกำหนดตัวหนังสือสีแดง`,
"vue_label_email_public_template":`แม่แบบสาธารณะ`,
"label.eowechat.openid":`บัญชีวีแชทขององค์กร`,
"label.user.ip.notlogin.range":`IP ไม่อยู่ในช่วงการเข้าสู่ระบบ!`,
"chatter.email.reply.collection":`เมื่อตอบกลับโพสต์ที่ฉันเคยบุ๊กมาร์กไว้`,
"label.integrations":`การเชื่อมต่อ`,
"label.permission.modifyAppPermission.selectedapp":`แอปพลิเคชันที่เลือก`,
"label.privacystatement":`คำชี้แจงสิทธิ์ส่วนบุคคล`,
"label.specificvalue":`ค่าเฉพาะ`,
"label.appointmentconfirmpage.wizard.subtitle2":`วันที่และเวลา`,
"label.message.ispartner.delete":`ไม่สามารถลบลูกค้าได้เนื่องจากผู้ติดต่อได้เชื่อมโยงกับผู้ใช้พาร์ทเนอร์แล้ว`,
"report_button_go":`ไปที่`,
"label.h5.similar.opportunity":`โอกาสทางธุรกิจที่คล้ายกัน`,
"UG_Lead_005":`อีเมล`,
"label.num.length.not.overstep":`ค่าตัวเลขต้องยาวไม่เกิน 18 หลัก`,
"label.profile.mobile.setup.CEOandDirector":`CEO และผู้อำนวยการฝ่ายขาย`,
"label.addfield":`เพิ่มฟิลด์`,
"template.dashboard.institutional.overview":`ภาพรวมองค์กร`,
"label_tabpage_datefield":`เมื่อฟิลด์วันที่เท่ากัน คุณสามารถใช้ "เมื่อวาน", "วันนี้", "พรุ่งนี้", "เดือนที่แล้ว", "เดือนนี้", "เดือนหน้า", "สัปดาห์ที่แล้ว", "สัปดาห์นี้", "สัปดาห์หน้า "หรือรูปแบบ " YYYY-MM-DD, MM / DD / YYYY "`,
"label.category.7":`การท่องเที่ยว`,
"UG_contact_02":`ดึงดูดผู้ติดต่อผ่านหลายช่องทาง เช่น โทรศัพท์ อีเมล โซเชียล`,
"chatter.feed.menutype.feed.mecom":`การอัปเดตที่เกี่ยวข้องกับฉัน`,
"vue_label_systemSettings_calltemplate":`แม่แบบการสื่อสาร`,
"approval_process_errore":`เกิดข้อผิดพลาดระหว่างการบันทึก กรุณาติดต่อผู้ดูแลระบบ`,
"label.tabpage.choosefilez":`เลือกไฟล์`,
"label.changemydisplay.chagetab.cusapp":`แอปพลิเคชันแบบกำหนดเอง`,
"clearadvancedoption":`ล้างตัวเลือกขั้นสูง`,
"front-epwechat-module-v1-binding-user":`รายชื่อผู้ใช้ที่ถูกผูกไว้`,
"label.customfields.fielddependency.null":`ไม่ได้กำหนดฟิลด์แบบพึ่งพา`,
"label.enterprise":`รุ่นเอนเทอร์ไพรซ์`,
"font-evaluate-module-v1-five-points":``,
"lable.Synchronize.from.QuickBook":`ซิงค์จาก QuickBook`,
"front-gantt-module-v1-task-number":``,
"label.currency.edit.newexchagecurrency":`อัตราแลกเปลี่ยนที่หมดอายุ`,
"label.partnerCloud.partnerSite":`ไซต์พาร์ทเนอร์`,
"label_tabpage_unequalz":`ไม่เท่ากับ`,
"label.version.solutions":`โซลูชัน`,
"label.setting.intergrationlist.button.installed":`ติดตั้งแล้ว`,
"label.h5.chatter.share":`แบ่งปันไฟล์`,
"front-epwechat-module-v1-unbound-item4":`- การผูกสัมพันธ์บัญชีภายนอก`,
"label.textmessage.vonage.accessibility.setting":`ใช้การตั้งค่าสิทธิ์`,
"font-evaluate-module-v1-evaluation-set":``,
"message.servicecrew.time.violation2":`นอกเวลาทำการ`,
"label.processinfo":`ข้อมูลกระบวนการอนุมัติ`,
"label.knowledgebase.last.modified":`แก้ไขล่าสุด`,
"label.to.phone":`หมายเลขโทรศัพท์มือถือของผู้รับ`,
"label.baseoffirsttimereply":`การตอบกลับอนุมัติหรือปฏิเสธขึ้นอยู่กับการตอบกลับ<strong>ครั้งแรก</strong>`,
"label.projectManagement.startingEndingTime":`เวลาเริ่มต้นและสิ้นสุด`,
"label.licence.enable":`เปิดการใช้งาน`,
"label.partnerCloud.basicSetting.cshua":``,
"APPIntegration.Dropbox.setting.03":`การเปิดใช้งาน Dropbox ช่วยให้คุณสามารถเลือกไฟล์จาก Dropbox ได้โดยตรง`,
"label.account.contact":`แผนผังผู้ติดต่อลูกค้า`,
"label.many.dayline.tab":`ป้ายกำกับ`,
"label.weixin.input.username":`กรุณาป้อนชื่อ`,
"label.logintime.pagecue.invalido":`เวลาสิ้นสุดจะต้องเป็นตลอดทั้งวัน`,
"label.icon.30":`หนังสือ`,
"label_tabpage_advancedscreening":`เงื่อนไขตัวกรองขั้นสูง`,
"lable.currencyManage.unEnabledadvcurrency.agree":`ใช่ ฉันต้องการปิดใช้งานการจัดการสกุลเงินขั้นสูง`,
"label.tab.web.new":`แท็บ Web ใหม่`,
"label.bmap.tiananmen":`จตุรัสเทียนอันเหมิน`,
"label.disabled":`ไม่พร้อมใช้งาน`,
"error.currencyAdv.deleteprecodedate":`ไม่สามารถลบอัตราแลกเปลี่ยนวันก่อนหน้านี้ของรหัสสกุลเงินได้`,
"message.error.view.checkbox.validerr":`ข้อผิดพลาด: ใช้จริงหรือเท็จ`,
"UG_ST_006":`การเข้าถึงโดยตรง`,
"label.dongshifang.title":`เกตเวย์ข้อความสั้นตงสือฟาง`,
"label.data.dataexpalltype.all.desc3":`3.ข้อมูลที่ส่งออกสําเร็จจะถูกสร้างเป็นไฟล์บีบอัด ผู้ใช้สามารถดาวน์โหลดไฟล์ที่คุณส่งออกในหน้ารายการไฟล์ที่ส่งออกสำเร็จในอีเมล`,
"vue_label_pool_returnreason":`เหตุผลในการส่งคืน`,
"label.list.userinterface.des":`ใช้การตั้งค่าต่อไปนี้เพื่อปรับเปลี่ยนส่วนต่อประสานกับผู้ใช้งานขององค์กร:`,
"label.notification.approval2":`[ผู้อนุมัติ]ปฏิเสธคำขออนุมัติ[ออบเจ็กต์]ของคุณ`,
"label.service.dispatchingUnits.the.level":`ระดับ`,
"front-email-payment-Invoice-preview-tips":``,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`ข้อผิดพลาด: ฟิลด์ที่เลือกหนึ่งฟิลด์ขึ้นไปในส่วนเสริมของรายงานไม่สามารถใช้ได้อีกต่อไป <br>ใช้ตัวแก้ไขส่วนเสริมแดชบอร์ดเพื่อเลือกฟิลด์ที่พร้อมใช้งาน`,
"label.import.step2.chooseidorother":`2. สามารถเลือกใช้ ID หรือชื่อเพื่อให้ตรงกับบันทึกและกรอกข้อมูลในฟิลด์การค้นหา ถ้าคุณต้องการรับข้อมูล อาทิ id บันทึกที่เกี่ยวข้อง ให้สร้างรายงาน และตั้งค่าชื่อบันทึกและ id บันทึกเป็นคอลัมน์กลุ่มแล้วส่งออกรายงาน`,
"label.customobjects.introduce":`ออบเจ็กต์แบบกำหนดเองเป็นตารางฐานข้อมูลที่ใช้ในการจัดเก็บข้อมูลองค์กรใน CloudCC 
คุณสามารถใช้ออบเจ็กต์แบบกำหนดเองเพื่อขยายฟังก์ชันของ CloudCC หรือสร้างฟังก์ชันของแอปพลิเคชันใหม่`,
"label.visualpage.oldsystem":`รุ่นเก่า`,
"label.icon.94":`หนังสือ`,
"label.setup.log.desctiption":`คุณสามารถดาวน์โหลดการติดตามพฤติกรรมองค์กรของคุณ (ไฟล์ Excel.xls)`,
"label.dynamicpage.layout":`เค้าโครงเพจแบบไดนามิก`,
"lable.list.queue.objct":`ออบเจ็กต์ที่รองรับ`,
"label.customfields.placeholder.tip":`ข้อความตัวอย่างจะปรากฏในกล่องข้อความและหายไปหลังจากโฟกัส`,
"label.ems.activationtime":`เวลาเปิดใช้งาน`,
"label.detailinfo":`รายละเอียด`,
"label.icon.17":`รายงาน`,
"label_emailtocloudcc_button_complete":`สำเร็จ`,
"label.visualpage.component.n2":`2. หมายเหตุ ป้ายกำกับของ component ไม่สามารถทับซ้อนกันภายใน <cc>`,
"label.object.name.one":`ชื่อออบเจ็กต์ 1`,
"label.summaryreport.step2":`ขั้นตอนที่ 2: เลือกข้อมูลที่จะสรุป`,
"thisisanew":`ใหม่!`,
"label.query.detail.editpartneruser":`แก้ไขผู้ใช้พาร์ทเนอร์`,
"label.tabpage.newview":`สร้างมุมมองใหม่`,
"label.partnerCloud.productSet.addNew":`ตัวเลือกใหม่`,
"label.appupload.upload.new.remark":`นี่คือส่วนเสริมใหม่ล่าสุด`,
"label.case.ptext":`เราได้ผูกบริษัทคุณกับพอร์ทัลเว็บไซต์ คัดลอกที่อยู่พอร์ทัลบริการลูกค้าเวอร์ชันเว็บไซต์ของบริษัทคุณ และเพิ่มลงในเว็บไซต์ทางการของบริษัทคุณเพื่อเข้าสู่เว็บไซต์นี้`,
"lable.PowerProcess.name":`กระบวนการให้สิทธิ์`,
"label_tabpage_choosefilez":`เลือกไฟล์`,
"homepage.components.place":`ตำแหน่งส่วนเสริม`,
"lable.Synchronization.failure":`การซิงค์ล้มเหลว`,
"label.dashboard.snapshot.get.data":`ได้รับข้อมูลของคุณ`,
"label.input.invalid.format":`กรุณาป้อนรูปแบบที่ถูกต้อง`,
"label.quickbooks.view.openinvoices":`Invoices ที่อยู่ระหว่างดำเนินการ`,
"label.weixin.seating":`จํานวนที่นั่ง`,
"label.searchlayout.remark":`อนุญาตให้เลือกฟิลด์มาตรฐานและแบบกำหนดเองที่แสดงในฟังก์ชันการค้นหาต่อไปนี้:`,
"label.escalation.setup.entrydetail.escalation.assiner":`มอบหมายให้`,
"vue_label_calendar_availability_view":`ปฏิทิน-มุมมองความพร้อมใช้งาน`,
"label.country":`ประเทศ`,
"label.campagin.roi.zl":`ภาพรวม`,
"lable.currencyManage.advcurrencyEnabled":`เปิดใช้งานการจัดการสกุลเงินขั้นสูงแล้ว`,
"label.projectManagement.project.task":`งานโครงการ`,
"label.appointmentpage.wizard.subtitle3-2":`อีเมล`,
"label.input.invalid.date":`กรุณาป้อนวันที่แบบมาตรฐาน (ISO)`,
"vue_label_chatter_my_followers":`ผู้ติดตามของฉัน`,
"label.setupdevelop":`การพัฒนาแอปพลิเคชันใหม่`,
"label.sendemail.send.checksend":`ตรวจสอบว่าการส่งอีเมลสำเร็จหรือไม่`,
"label.eventfield":`ฟิลด์อิเวนต์`,
"label.ccpeak.ccobject.put":`ใช้ put โดยตรงเพื่อกำหนดค่าให้ CCObject ตัวอย่างเช่น:`,
"label.campaignmember.main.addMemberDesc":`คุณสามารถค้นหาลีดและผู้ติดต่อ เพิ่มพวกเขาลงในแคมเปญนี้ และจัดการสมาชิก`,
"label.knowledge.setting.hint.eleven":`ป้อนกลุ่มหมวดหมู่ข้อมูล`,
"label.knowledge.category.button.four":`เพิ่มหมวดหมู่ระดับเดียวกัน`,
"label.icon.27":`เรียน`,
"vue_label_chatter_certification":`ยืนยันว่าต้องการ {isStatus}"{titleName}"หรือไม่`,
"label.data.downpage.i.title.btn":`เข้าสู่หน้าการนำเข้า และเริ่มการนำเข้า`,
"label.campaign.channel.step6.pc":`สร้างหน้าเพจสำหรับคอมพิวเตอร์`,
"label.mr.caption.rule":`กฎ: ต้องเลือกเกณฑ์การตรวจสอบซ้ำหนึ่งข้อหรือมากกว่า`,
"label.service.gantt.resourcestype":``,
"label.searchfitconditions":`ค้นหา  ที่สอดคล้องตามเงื่อนไขดังต่อไปนี้`,
"label.partner.template.name":`ชื่อแม่แบบ`,
"setup.mainpage.label.welcome15":`กฎเวิร์กโฟลว์แพลตฟอร์มคลาวด์ CloudCC ทําให้กระบวนการสนับสนุนการขาย การตลาด และอื่นๆ ของคุณเป็นไปโดยอัตโนมัติ คุณสามารถกําหนดบันทึกให้กับผู้ใช้โดยอัตโนมัติ หรือแปลงจากผู้ใช้หนึ่งไปยังอีกผู้ใช้หนึ่งได้ด้วยเกณฑ์ที่กำหนดไว้ล่วงหน้า ประโยชน์หลักของการจัดการเวิร์กโฟลว์คืกำจัดกระบวนการดำเนินการที่ไม่จำเป็นออกไป เพิ่มประสิทธิภาพการทำงานขณะทำการอัปเดตบันทึก ด้วยวิธีการทำงานที่ได้มาตรฐาน ลดภาระการดำเนินงานมาเพิ่มระดับการจัดการด้านธุรกิจ และปรับเปลี่ยนระบบควบคุมการทำงานให้เหมาะสม สนับสนุนการอนุมัติออบเจ็กต์แบบไม่จำกัด ในขณะเดียวกันก็สามารถเรียกข้อความแจ้งเตือนทางอีเมล ข้อความสั้น ภารกิจ อัปเดตฟิลด์ และอื่นๆ`,
"vue_label_commonobjects_view_chart":`แผนภูมิ`,
"label.salescloud.teamrole.choose":`โปรดเลือกบทบาทของทีม`,
"lable.outlook.mcto.emailrel":`เชื่อมต่ออีเมล`,
"front-invoice-online-payment-setup-describe":``,
"label.korean.standard.time":`เวลามาตรฐานของเกาหลีใต้`,
"label.lord.howe.standard.time":`เวลาออมแสงเกาะลอร์ด ฮาว`,
"setup_layout_group_button":`ปุ่ม`,
"label.editdefaultshare":`แก้ไขการแบ่งปันเริ่มต้น`,
"label_fiscal_year":`ปีงบประมาณ`,
"label.appointmentdetail.wizard.title2":`ทุกคน`,
"label.email":`อีเมล`,
"label.city":`เมือง`,
"label.knowledgebase.data.recovery.failed":`กู้คืนข้อมูล {a} รายการล้มเหลว`,
"setup_mainpage_label_welcome6":`ผู้ใช้สามารถสร้างฟิลด์ประเภทต่างๆ ในออบเจ็กต์ทั้งหมดของระบบ CloudCC โดยไม่ต้องมีความรู้ด้านการเขียนโปรแกรมหรือการพัฒนารหัสของฟิลด์ ประเภทของฟิลด์ ได้แก่ ค้นหาความสัมพันธ์ เลือกฟิลด์เดี่ยว เลือกฟิลด์คู่ สูตร หมายเลขอัตโนมัติ URL โทรศัพท์ โทรสาร อีเมล กล่องกาเครื่องหมาย วันที่ เวลา ตัวเลข ข้อความ กล่องข้อความ รายการตัวเลือก (ตัวเลือกเดียว/หลายตัวเลือก) สกุลเงิน ฯลฯ`,
"label_emailtocloudcc_button_enable":`เปิดการใช้งาน`,
"label.account.custom":`ไตรมาสบัญชีที่กำหนดเอง`,
"label.custompublish_time":`เวลาเผยแพร่ของลูกค้า`,
"label.dashboardSetup.selwz":`เลือกตำแหน่งแสดงผล`,
"component_todaytask_label_all":`ดูทั้งหมด`,
"label.service.resource.group.tip":`เลือกทีมบริการเพื่อสร้างทรัพยากรบริการ และประเภททรัพยากรสามารถเลือกได้เฉพาะทีมเท่านั้น`,
"label.tianyancha.legalpersonname":`นิติบุคคล`,
"component.setup.label.titlefield":`ฟิลด์หัวข้อ`,
"label.email.template.public.mail":`โฟลเดอร์แม่แบบอีเมลสาธารณะ`,
"front-template-V1-DeleteTempalte":`ยืนยันว่าจะลบแม่แบบ"{{currentTelmplateName}}}"หรือไม่?`,
"pagecreator.layout.label.layoutdesc":`คำอธิบายเค้าโครง`,
"vue_label_file_singel_upload":`อัปโหลดได้เพียงไฟล์เดียวเท่านั้น หากคุณต้องการเปลี่ยนไฟล์ โปรดลบไฟล์ที่อัปโหลดก่อน`,
"label.view.hierarchy":`ดูลำดับชั้น`,
"label.file.owner.settings":`การตั้งค่าเจ้าของ`,
"label.sales.dashboard.name":`ชื่อ`,
"label.offfer.filer.name":`ชื่อไฟล์ใบเสนอราคา`,
"label.quickbooks.view.recentlypaid":`การชําระเงินล่าสุด`,
"label.step1.select.merge.records":`ขั้นตอนที่ 1: เลือกบันทึกที่ต้องการจะผสาน`,
"message.recordtype.assignprofile.tip":`เลือก"กล่องกาเครื่องหมาย เปิดใช้งานสำหรับโปรไฟล์ เพื่อให้บันทึกชนิดใหม่พร้อมใช้งานสำหรับโปรไฟล์นี้ ผู้ใช้ที่กำหนดให้ใช้กับโปรไฟล์นี้จะสามารถสร้างบันทึกสำหรับบันทึกชนิดนี้ หรือกำหนดชนิดบันทึกนี้ให้กับบันทึกที่มีอยู่ หากต้องการให้ชนิดบันทึกใหม่เป็นค่าเริ่มต้นสำหรับโปรไฟล์ โปรดเลือก"กล่องกาเครื่องหมาย "ตั้งเป็นค่าเริ่มต้น"`,
"label.appointmentdetail.wizard.title9":`ระยะเวลาการเดินทาง`,
"label.group":`กลุ่ม`,
"label.deltorecycle":`ลบไปที่ถังขยะรีไซเคิล`,
"label.import.index.numlimit":`1. รองรับเฉพาะไฟล์รูปแบบ csv (สามารถนำเข้าบันทึกได้มากที่สุด 30,000 รายการต่อครั้ง และหากเรียกใช้ทริกเกอร์จะสามารถนำเข้าได้มากที่สุด 2,000 รายการ) บันทึกที่เกินขีดจำกัดจะถูกระบบละเว้นโดยอัตโนมัติ หากต้องการนำเข้าข้อมูลเพิ่มเติม โปรดแบ่งออกเป็นหลายไฟล์และนำเข้าเป็นส่วนๆ`,
"label.file.delete.desc":`การลบไฟล์จะเป็นการลบไฟล์แนบของบันทึกหรือโพสต์ต่างๆ ด้วย`,
"UG_activity_04":`อีเมล Outlook/Gmail บันทึกอีเมลขาออก`,
"label.event.all.undealt":`อิเวนต์ที่ยังไม่ได้ดำเนินการ`,
"label.appupload.upload.install.error":`ไม่สามารถติดตั้งแอปพลิเคชันนี้ โปรดยุติการติดตั้งหรือติดตั้งใหม่หลังจากปรับเปลี่ยน API ในระบบ!`,
"template.chart.yqydcpsl":`จำนวนผลิตภัณฑ์ที่เปิดใช้งาน`,
"label.import.index.advancepreparation":`เตรียมการล่วงหน้า`,
"label.eowechat.epdeptnamee":`ชื่อแผนกวีแชทขององค์กร`,
"front-kefu-moudle-please-input-servernum":``,
"label.lookup.autocmp.nodata":`ไม่มีข้อมูลที่ตรงกัน`,
"vue_label_pool_assign":`แจกจ่าย`,
"label.knowledge.timing.publish":`กำหนดเวลาการเผยแพร่ล้มเหลว`,
"label.selected.groups":`กลุ่มบรรทัดใบเสนอราคาที่เลือก`,
"front-epwechat-module-v1-removesele-desc":`หลังจากลบแล้ว ข้อมูลการตั้งค่าทั้งหมดของแอปพลิเคชันนี้จะถูกล้าง คุณแน่ใจหรือไม่?`,
"label.batchtransfer.type2":`โอนย้ายโอกาสทางธุรกิจที่สิ้นสุดลงแล้ว`,
"label.richtext":`กล่องข้อความ Rich Text`,
"label.icon.174":`เครื่องบิน`,
"vue.please.select.grouping.basis":`โปรดเลือกเกณฑ์การจัดกลุ่ม`,
"label.matrixreport":`รายงานแบบเมทริกซ์`,
"label.jiandangfenpei.leftlist":`โปรไฟล์ที่ไม่ได้กำหนด`,
"label_chatter_card":`การ์ด`,
"label.file.enter.title":`กรุณาใส่หัวข้อ`,
"label.the.record.is.locked.and.cannot.be.selected.":`บันทึกถูกล็อกและไม่สามารถเลือกได้`,
"label.partner.success":`สำเร็จ! ชื่อโดเมนนี้สามารถใช้ได้`,
"label.selectreporttype":``,
"report.type.label.productPricebooks":`ผลิตภัณฑ์และสมุดราคา`,
"label.texttemplate.mergefields.tip":`เมื่อออกแบบเนื้อหาของข้อความสั้น คุณสามารถใช้ฟิลด์ผสานเพื่อแทนที่ข้อความได้ เมื่อใช้ข้อความสั้น ระบบจะแทนที่เป็นข้อความ ตัวอย่างเช่น {!Contact.name} เมื่อใช้ข้อความสั้น เนื้อหาจะกลายเป็นชื่อผู้ติดต่อ`,
"label.publicgroup.detail.showallusers":`ดูลูกค้าทั้งหมด`,
"label.brief.follow":`ติดตาม`,
"label.forecast.settings.qijian.p":`การพยากรณ์รายไตรมาส`,
"label.sms.url":`เว็บไซต์`,
"setup_layout_group_custompage":`เพจที่กำหนดเอง`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(text, compare_text)`,
"label.umeng.chatter.sendmessage":`ส่งข้อความถึงคุณ`,
"label.pc.layout":`เค้าโครง PC`,
"label.currency.v":`ป้อนจำนวนตำแหน่งทศนิยม(จำนวนหลักทางด้านขวาของจุดทศนิยม) ที่สามารถแสดงได้เมื่อแสดงข้อมูลสกุลเงินใหม่  ซึ่งต้องเป็นจำนวนเต็มระหว่าง 0 ถึง 6`,
"label.projectManagement.kanbantask":`งานคัมบัง`,
"component_recdetail_label_title":`รายละเอียด`,
"label.isremider":`แจ้งเตือนใช่หรือไม่`,
"front-epwechat-module-v1-input-home-url":`กรุณากรอก URL หน้าแรก`,
"label.usefullife":`ช่วงเวลาที่มีผล`,
"label.visualpage.ptype":`ทั่วไป`,
"label.quote.name":`ชื่อใบเสนอราคา`,
"vue_label_report_addtocomponent":`ยืนยันว่าจะเพิ่ม{name}ในไลบรารีส่วนเสริมหรือไม่?`,
"label.dashboardSetup.showdw.d1":`ร้อยล้าน`,
"label.validate.function.funcFormat.OR":`OR(logical1,logical2,...)`,
"label.component.helper.potentialcustom":`ลีดที่มอบหมายในวันนี้`,
"label.autoRegister.changepwd.setpwd.tip.number":`มีตัวเลขอย่างน้อยหนึ่งตัว`,
"label.data.setok.e.desc3":`ดาวน์โหลดข้อมูลที่คุณส่งออก`,
"label.data.downpage.e.title.num4":`4. ไฟล์ส่งออกมีสองรูปแบบ: รูปแบบ CSV และรูปแบบบีบอัด โดยรูปแบบการบีบอัดสองรูปแบบ: รูปแบบหนึ่งคือการสร้างรหัสผ่านไฟล์บีบอัดโดยอัตโนมัติ อีกรูปแบบหนึ่งคือการป้อนรหัสผ่านไฟล์บีบอัดด้วยตนเอง`,
"lable.quote.editqtpdt.description":`เลือกสมุดราคาสำหรับใบเสนอราคานี้ คุณสามารถเพิ่มผลิตภัณฑ์จากสมุดราคาเดียวเท่านั้น การเปลี่ยนสมุดราคาที่เลือกจะลบผลิตภัณฑ์ที่มีอยู่ทั้งหมดออกจากใบเสนอราคา`,
"front-kefu-moudle-edit-userinfo":``,
"label.please.ChooseMinAndMax":`โปรดเลือกตัวเลือกผลิตภัณฑ์อย่างน้อย {0} ตัวเลือก และเลือกได้สูงสุด {1} ตัวเลือก`,
"label.knowledgebase.archive.an.article":`เก็บบทความถาวร?`,
"label.multilang.customforcast.submit":`ส่งการพยากรณ์จากปีงบประมาณที่ {0}  {1} ถึง ปีงบประมาณที่ {2}  {3} ใช่หรือไม่?`,
"label.import.index.filename":`ชื่อไฟล์`,
"front-console-no-reco-contact":``,
"label.quantity.greater.than0":`จำนวนต้องมากกว่า 0`,
"label.codeNorm":`มาตรฐานรหัส`,
"label.average":`ค่าเฉลี่ย`,
"label.multilang.page1":`ที่`,
"label.data.exp.save.ok":`การบันทึกแม่แบบเสร็จสิ้น`,
"message.error.delete.record":`ไม่พบบันทึกที่จะลบ!`,
"label.newvaluereplaceoldvalue":`ใช้หน้านี้เพื่อแทนที่ค่าที่มีอยู่ทั้งหมดในรายการเลือกด้วยค่าใหม่ ตรวจสอบให้แน่ใจว่าค่าใหม่ได้รับการสร้างขึ้นในหน้ารายละเอียดของรายการตัวเลือกแล้ว`,
"label.tabpage.saveviewsuccess":`การบันทึกมุมมองสำเร็จ`,
"label.partnerCloud.productSet.parentOptions":`ตัวเลือกหลัก`,
"label.emailtemplate.availablemergefields":`ฟิลด์ผสานที่ใช้ได้`,
"label.data.import.setup":`การตั้งค่าการนำเข้าข้อมูล`,
"label.escalation.setup.entrydetail.escalation.action":`เลื่อนขั้นการปฏิบัติการ`,
"System.TimeField.Description":`อนุญาตให้ผู้ใช้ป้อนเวลาท้องถิ่น เช่น "2:40 PM", "14:40" และ "14:40:00" ทั้งหมดเป็นเวลาที่ถูกต้องสำหรับฟิลด์นี้`,
"front-additional-products":`ซื้อผลิตภัณฑ์อื่นๆ เพิ่มเติม`,
"label.appointment.wizard.subtitle4-4-1":`หนึ่งสัปดาห์`,
"label.chatter.colleagues.list":`รายชื่อเพื่อนร่วมงาน`,
"label.log.invalid.data":`เวลาไม่ถูกต้อง!`,
"label.file.preview.unconvert":`ยังไม่ได้สร้างการแสดงตัวอย่างข้อมูล กรุณาคลิกเพื่อแสดงตัวอย่างรายละเอียด`,
"label.customer.detailed":`เลือกหน้าเพจสำหรับเมนูใหม่นี้และกรอกรายละเอียดอื่นๆ`,
"label.sendsms.content":`เนื้อหามีดังนี้:`,
"label.exported_to":`ไฟล์ส่งออกจะถูกส่งอีเมลไปที่`,
"label.attendance.checkin":`บันทึกเวลาเข้างาน`,
"Dashboard.NoAccessRightToSee.Warning":`ขณะนี้คุณไม่มีสิทธิ์ดูแดชบอร์ด{0}เปิดเริ่มต้นที่คุณตั้งค่าไว้ คุณต้องรีเซ็ตเป็นค่าอื่น`,
"message.choosedelete":`โปรดเลือกข้อมูลที่ต้องการจะลบ`,
"label_tabpage_choosecontent":`โปรดเลือกเนื้อหา`,
"label.no_responses":`ไม่มีการตอบสนอง`,
"report_type_label_customService":`การสนับสนุนลูกค้า`,
"label.report.select.condition":`เกณฑ์การเลือก`,
"label.umeng.activity.distributeevent":`มอบหมายอิเวนต์ให้คุณแล้ว`,
"label.knowledge.language.portuguese":`ภาษาโปรตุเกส`,
"label.knowledgebase.published":`เผยแพร่`,
"UG_opportunity_001":`คุณจะตรวจสอบพนักงานขายของคุณอย่างไร?`,
"label.mr.caption.scope":`ขอบเขต: หากไม่เลือกจะสืบค้นข้อมูลทั้งหมด`,
"message.login.mfaverification.to.pclogin":`องค์กรของคุณเปิดใช้งานการเข้าสู่ระบบหลายบัญชีแล้ว คุณต้องผูกบนอุปกรณ์มือถือเพื่อเข้าสู่ระบบเป็นครั้งแรก กรุณาเข้าสู่ระบบทาง PC เพื่อผูกบัญชี`,
"vue_label_dashboard_pleaseenterthecolorrange":`กรุณาป้อนช่วงสี`,
"label.emailsync.status.time":`เวลา`,
"chatter.putup":`โพสต์ไฟล์`,
"vue_label_report_drillcondition":`เงื่อนไขการเจาะ`,
"label.emailobject.list.myemail":`อีเมลของฉัน`,
"label_tabpage_andz":`และ`,
"label.share_link":`แบ่งปันลิงก์`,
"label.emailtocloudcc.exists2":`อีเมลนี้ถูกตั้งค่าเป็น Email to Case กรุณาอย่าตั้งค่าซ้ำ`,
"label.icon.89":`ปรึกษา`,
"front-kefu-moudle-v1-qdygbzx-chat":`ยืนยันว่าจะปิดการแชทออนไลน์หรือไม่?`,
"label.approval.selectone":`เลือกอย่างน้อยหนึ่งการกระทํา`,
"chatter.group.groupName":`ชื่อกลุ่ม`,
"label_chatter_relateitem":`รายการที่เกี่ยวข้อง`,
"label.file.folder.delete1":`ลบโฟลเดอร์?`,
"Pagelayout_Setup_003":`ต้องเลือกฟิลด์ Name`,
"setup_mainpage_label_welcome2":`ฐานข้อมูลที่กำหนดเอง (ออบเจ็กต์)`,
"pagecreator.systemstyle.label.linkcolor":`สีลิงก์`,
"label.task.this.week":`ภารกิจของสัปดาห์นี้`,
"message.custom.field.donotdelete.report":`ฟิลด์นี้ถูกอ้างอิงโดยรายงาน`,
"pagecreator.layout.button.delete":`ลบเค้าโครง`,
"label.reportsSubscriptionPage.condition.operator":`ตัวดำเนินการทางตรรกะ`,
"label.location.display.type.degrees":`องศา นาที วินาที`,
"label.appupload.upload.url":`ติดตั้ง URL`,
"label.logical.relation":`ความสัมพันธ์เชิงตรรกะ`,
"label.knowledge.publish.article":`เผยแพร่บทความ`,
"vue_label_commonobjects_detail_activity_commingtask":`มีภารกิจที่จะเกิดขึ้น`,
"vue_label_pool_reason":`{0}เหตุผล`,
"front-gantt-module-subtasks-cannot-subtasks":``,
"label_tabpage_filesizez":`ขนาดไฟล์`,
"label.customfields.formula.returntype.monry.tip":`คำนวณจำนวนเงินในสกุลเงินดอลลาร์สหรัฐหรือสกุลเงินอื่นๆ และแปลงฟิลด์เป็นรูปแบบจำนวนสกุลเงินโดยอัตโนมัติ`,
"label.tabpage.allapplications":`แอปพลิเคชันทั้งหมด`,
"message.duplication.label.matchcontainletters":`การจับคู่ประกอบด้วย`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`วิธีการสร้างใบสั่งงาน โปรดเลือก "สร้างรายการบรรทัดใบสั่งงานหนึ่งรายการต่อสินทรัพย์"`,
"label.preview_post":`แสดงตัวอย่างโพสต์`,
"chatter.p.data":`วันที่เผยแพร่`,
"label.isnot.right.number":`ไม่ใช่ตัวเลขที่ถูกต้อง`,
"label.contentsource":`แหล่งที่มาของเนื้อหา`,
"message.groupandsummaryconditionsame":`เงื่อนไขการจัดกลุ่มต้องไม่เหมือนกับเงื่อนไขของการสรุป`,
"label.weixin.wdyj.nodata.qin":`ไม่มีข้อมูล{0}`,
"chatter.vote":`คะแนน`,
"label_partner_workspace_tab_option":`ตัวเลือกแท็บ`,
"chatter.changeVote":`เปลี่ยนโหวต`,
"label.data.file.i_title.num2":`2. แนะนำให้ส่งออกก่อนนำเข้า และใช้เอกสารที่ส่งออกเป็นแม่แบบเพื่อจัดระเบียบข้อมูลที่นำเข้าจากนั้นจึงนำเข้า (หากข้อมูลที่นำเข้ามีเครื่องหมายจุลภาคโปรดใช้สัญลักษณ์ "@" แทน)`,
"label.relation.list.error":`เกิดข้อผิดพลาด`,
"label.validate.function.funcExplain.MILLISECOND":`ส่งกลับมิลลิวินาทีในฟิลด์วันที่/เวลา`,
"label.emailobject.emaildetail.button.relateto":`เชื่อมต่อไปยัง`,
"label.dashboard.dataSource":`แสดงแหล่งข้อมูล`,
"label.marketseamemset.lead.title":`การตั้งค่าสมาชิกฐานข้อมูลลีด`,
"label.appupload.addobj":`เพิ่มลงในโปรแกรมสำเร็จรูป`,
"lable.outlook.mcto.domain":`เพิ่มรูปแบบเช่น (gmail.com) ลงในรายการที่ตัดออก`,
"label.input.right.url":`กรุณาใส่ URL ที่ถูกต้อง`,
"label.newprocessstep5.tip":`หน้าการอนุมัติ คือหน้าที่ผู้อนุมัติอนุมัติหรือปฏิเสธคำขอ ให้เลือกฟิลด์ที่จะแสดงในหน้านี้จากตัวเลือกต่อไปนี้`,
"label.schedulejob.setup.schedule.st4":`ที่สี่`,
"label.emailsync.status.user":`ผู้ใช้`,
"front-kefu-moudle-v1-jymm-reinput":`โปรดป้อนรหัสผ่านที่มีความยาว 12 ตัวที่ประกอบด้วยอักษรตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข และอักขระพิเศษอย่างน้อย 2 ตัว`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`ชื่อเกณฑ์การให้คะแนน`,
"label.mr.title.fieldName":`ชื่อฟิลด์`,
"label.data.deriall":`ส่งออกทั้งหมด`,
"label.tianyancha.businessverify.step2":`เปิดใช้งานการทวนสอบข้อมูลธุรกิจขั้นตอนที่สอง`,
"label.submissions":``,
"vue_label_calendar_removed_successfully":`การลบปฏิทินสำเร็จ`,
"label.eventrecordtype":`ประเภทบันทึกอิเวนต์`,
"lable.outlook.detail.syndire":`ทิศทางการซิงค์`,
"label.mobile.bind.fail":``,
"label.notification.task2":`[ผู้ได้รับมอบหมาย]ดูภารกิจที่คุณมอบหมายให้แล้ว`,
"label.partnerCloud.orderingPlatform.paymentMethod":`วิธีการชำระเงิน:`,
"label.escalation.setup.newaction.step3":`ขั้นตอนที่ 3: เลือกผู้ใช้ที่จะแจ้งเตือน`,
"label.summaryreport.selectsum":`เลือกข้อมูลสรุปและประเภทสรุป`,
"label.components.setup":`ตั้งค่าส่วนเสริม`,
"label.taskevent.introduce":`ด้านล่างนี้คือรายการภารกิจและอิเวนต์ของคุณ`,
"label.assignment.setup.detail.conditon":`เงื่อนไข`,
"front-lightning-module-v1-details-page-chart-select-statements":`เลือกรายงาน`,
"lable.Song.typeface":`Song Ti`,
"label.formulassesstrue":`สูตรประเมินว่าเป็นจริง`,
"label_partner_common_setup":`ตั้งค่าทั่วไป`,
"label_chatter_dateRange":`ช่วงวันที่`,
"label.partner.workspace.tab.mobile.using":`แท็บที่เลือกจะแสดงบนอุปกรณ์มือถือพร้อมกัน`,
"message.servicecrew.time.violation1":`การละเมิดเวลาในการจัดส่ง: มีสมาชิกในทีม`,
"report_label_projectcount":`โครงการ เรียงลำดับตามชื่อรายงาน`,
"label.file.uploadfile":`อัปโหลดไฟล์`,
"vue_label_commonobjects_detail_correct_email_address":`กรุณาใส่ที่อยู่อีเมลที่ถูกต้อง`,
"lable.account.CurrentandNextCQr":`ไตรมาสปฏิทินนี้และสามไตรมาสถัดไป`,
"setup.layout.label.order":`เกณฑ์การเรียงลำดับ`,
"label.service.major.event.independent":`อิสระ`,
"label.icon.38":`ตำแหน่ง`,
"label.knowledge.draft.record":`ไม่พบบันทึกที่จะลบ`,
"label_quota_percentage":`แสดงเปอร์เซ็นต์ความสมบูรณ์ของโควตา`,
"label.escalation.setup.entrydetail.escalation.minute":`นาที`,
"label.knowledgebase.edit.article.category":`แก้ไขหมวดหมู่บทความ`,
"Homepage_News_003":`ไม่มีข้อมูลลูกค้าจึงไม่สามารถแสดงข่าวสารได้ คุณสามารถแสดงข่าวสารของลูกค้าได้ที่นี่หลังจากสร้างลูกค้าแล้ว`,
"label.mr.descreption.oneGroupNote3":`รายการบันทึก`,
"label.customsetting.touse.getListCustomSetting":`สืบค้นข้อมูลการตั้งค่าแบบกำหนดเองของประเภท "รายการ" และส่งคืนข้อมูลทั้งหมดที่เกี่ยวข้องกับ apiName และ Name Map map = cs.getListCustomSetting (String apiName);`,
"message.error.view.cannotbenull":`ข้อผิดพลาด: ต้องป้อนค่า`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`วันศุกร์`,
"message.error.view.badprevilege.qin":`คุณไม่ได้รับอนุญาตให้เข้าถึง{1} จึงไม่มีข้อมูล`,
"label.dashboard.distribution":`กระจาย`,
"label.field.value.save":`จำเป็นต้องมีค่าในฟิลด์นี้เสมอเพื่อบันทึกข้อมูล`,
"label_custom_year":`ปีที่กำหนดเอง`,
"label.code.error":`รหัสมีคําสั่งและฟังก์ชันที่ไม่ได้รับอนุญาต เช่น:`,
"label.appexchange.uninstallpage.message2":`ลบการปรับแต่งของส่วนเสริมทั้งหมดนี้อย่างถาวร`,
"label.global.search.obj":`การตั้งค่าออบเจ็กต์ค้นหาระดับโกลบอล`,
"label.emailobject.from":`ผู้ส่ง`,
"lable.opppdt.selPdt.byconditions":`กรองเงื่อนไขตามฟิลด์`,
"chatter.p.note":`คำอธิบายประกอบของโพสต์นี้`,
"label.hiddenformulaedit":`ซ่อนตัวแก้ไขสูตร`,
"label.editQuotation":`แก้ไขใบเสนอราคา`,
"label.notification.arketsea.collection":`{5}ได้รับ{2}{0}{0}:{1}`,
"label.timzone.tip.info1":`เมื่อพูดถึงการเก็บรักษาฐานข้อมูล(insert และ update)java.util.Date ประเภทของข้อมูล，เช่น TpSysTask task=new TpSysTask();task.setBeginTime(new Date());......dbman.insert(task);หรือ dbman.update(task);ควรจะเปลี่ยน new Date()เป็นTimeUtil.getNowDate(userInfo),ดังนั้นประโยคที่เกี่ยวข้องในตัวอย่างข้างต้นควรเป็นtask.setBeginTime(TimeUtil.getNowDate(userInfo));`,
"label_tabpage_transformationsz":`เปลี่ยนแปลง`,
"front-kefu-moudle-IP-phone":``,
"label.emailobject.list.draft":`แบบร่าง`,
"label.tianyancha.businessverify.readandconfirm":`ฉันได้อ่านข้อตกลงการอนุญาตใช้สิทธิ์แล้ว และยอมรับข้อตกลงนี้`,
"label.win.customers":`สิ้นสุดแล้ว/ลูกค้าที่ปิดการขายสำเร็จ`,
"vue_label_commonobjects_view_switch_display":`บันทึกของคุณถูกจัดกลุ่มตามชนิดบันทึก สามารถคลิกที่ชื่อชนิดเพื่อสลับการแสดงผล`,
"pagecreator_systemstyle_label_textcolor":`สีตัวอักษร`,
"label.autosearch.keywords":`ค้นหาคีย์เวิร์ดอัตโนมัติ`,
"label.knowledge.setting.data.six":`คุณกำลังจะลบหมวดหมู่{lbmc} คุณต้องการดำเนินการต่อหรือไม่?`,
"front-console-sort-field":``,
"label.bangladesh.time":`เวลาบังคลาเทศ`,
"label.dashboardSetup.number":`ค่าตัวเลข`,
"lable.account.LastbDays":`30 วันที่ผ่านมา`,
"label.layout.searchdialog":`กล่องโต้ตอบค้นหา`,
"label.newprocessstep4.tip":`เลือกแม่แบบอีเมลที่ใช้สำหรับแจ้งผู้อนุมัติให้ทราบว่ามีการมอบหมายคำขออนุมัติให้กับพวกเขาแล้ว โปรดทราบว่า แม่แบบนี้จะใช้กับทุกขั้นตอนของกระบวนการนี้`,
"label.nousing":`ปิดการใช้งาน`,
"vue_label_report_detailline":`บรรทัดรายละเอียด`,
"label.emailobject.template.message3":`แม่แบบของคุณถึงขีดจำกัดแล้ว!`,
"label.c.d":`ความสัมพันธ์จาก C ไป D`,
"message.report.error.fail":`การโหลดล้มเหลว กรุณาลองใหม่อีกครั้ง`,
"label.edit.ccdocument.content":`แก้ไขเนื้อหาไฟล์แนบแล้ว`,
"label.textmessage.exceeded":`จำนวนของแม่แบบข้อความสั้นของคุณเกินขีดจำกัดสูงสุดแล้ว`,
"label.saveas":`บันทึกเป็น`,
"label.visualpage.an.inline.style":`ฝังเพจแบบกำหนดเองให้หน้ารายละเอียดและหน้าแท็บ`,
"label.pagelayout.remark2":`ข้อมูล หลังจากสร้างเค้าโครงเพจแล้ว คลิกปุ่ม "การกำหนดเค้าโครงเพจ" เพื่อควบคุมเค้าโครงเพจเริ่มต้นที่ผู้ใช้เห็น`,
"label.notification.approval1":`คำขออนุมัติ[ออบเจ็กต์]ของคุณได้รับการอนุมัติโดย[ผู้อนุมัติ]`,
"label.h5.chatter.image":`รูปแบบรูปภาพที่อัปโหลดไม่ถูกต้อง`,
"vue_label_dashboard_displayunit":`กรุณาเลือกหน่วยแสดงผล`,
"label.knowledge.default.language":`ภาษาเริ่มต้นของคลังความรู้`,
"label.chatter.publish":`เผยแพร่`,
"label.companyprofile.serveraddress":`การซิงค์นี้จะซิงค์เซิร์ฟเวอร์ปัจจุบันเท่านั้น`,
"label.chatter.groups":`กลุ่ม`,
"label_set_successfully":`การตั้งค่าสำเร็จ`,
"label.quote.zongjia":`มูลค่ารวม`,
"label.project.notice.endingdatelater":`วันสิ้นสุดต้องช้ากว่าหรือวันเดียวกับวันเริ่มต้น`,
"label.customfields.fielddependency.info":`ใช้หน้านี้กำหนดความสัมพันธ์ระหว่างฟิลด์ (เช่น รายการตัวเลือกที่จะมีการพึ่งพากัน)`,
"vue_label_lead_successful_conversion":`การข้ามสเตจสำเร็จ`,
"label.icon.93":`หนังสือ`,
"shift.serviceresource.illegal":`ทรัพยากรบริการไม่ได้เป็นสมาชิกภูมิภาคให้บริการนี้ หรือช่วงวันที่ของกะไม่อยู่ในขอบเขตของสมาชิก`,
"label.integrations.action.addnewlead":`สร้างลีดใหม่`,
"label_display_all_zeros":`แสดงแถวทั้งหมดที่มีค่าศูนย์`,
"canlendaryear":`ปีปฏิทิน`,
"label_tabpage_selrecordtypez":`เลือกชนิดบันทึก`,
"vue_label_commonobjects_view_chart_funnel":`แผนภูมิกรวย`,
"label.layout3":`เค้าโครง 3`,
"label.logintime.cue":`ไม่ได้กำหนดเวลาการเข้าสู่ระบบ`,
"label.service.miniProgram.lastDate":`วันที่แก้ไขล่าสุด`,
"label.emailobject.view.fromcrm":``,
"pagecreator.button.mobilepage":`เว็บเพจสำหรับโทรศัพท์มือถือ`,
"lable.oppt.jieduan.signcur":`ทำเครื่องหมายว่าสเตจปัจจุบัน`,
"label.fullaccess":`สิทธิ์การเข้าถึงแบบเต็มรูปแบบ`,
"homepage.layout.pagename":`ชื่อเค้าโครงเพจ`,
"label.appointment.wizard.subtitle4-2-3":`3 ชั่วโมง`,
"label.knowledgebase.please.check.record":`กรุณาเลือกบันทึกอย่างน้อย 1 รายการ`,
"label.view.sortview.closepage":`ปิดหน้านี้`,
"label_forecast_type":`ประเภทการพยากรณ์`,
"all.day":`ทั้งวัน`,
"label.view.sortview.printpage":`พิมพ์หน้านี้`,
"message.integration.configure":`การตั้งค่าการเชื่อมต่อสำเร็จ`,
"label.forecast.customforecast.foretype.close":`เซ็นสัญญาแล้ว`,
"label_chatter_like":`ชื่นชอบ`,
"template.report.folder.customer.potential":`การวิเคราะห์ลีด`,
"label.umeng.approval.dlsp.approve":`#approvalnameอนุมัติ#objAPIName#recordnameที่#actornameร้องขอ`,
"vue_label_normal_movedown":`ย้ายลง`,
"chatter.group.groupAccessPermissions":`สิทธิ์การเข้าถึงกลุ่ม`,
"label.visualpage.tip":`คุณสามารถสร้างหน้าเพจใหม่ของตัวเองได้ที่นี่`,
"message.validation.isnotdate":`ป้อนรูปแบบวันที่ให้ถูกต้อง`,
"label.icon.173":`เรือใบ`,
"label.icon.124":`ฉีดยา`,
"label.import.page2.csvfiled":`ฟิลด์ CSV`,
"setup_layout_component_area":`พื้นที่`,
"label.visualpage.workability.standard":`Class มาตรฐานที่สามารถใช้ได้บนเพจ`,
"label_emailtocloudcc_redmessage9":`ฐานข้อมูลผิดพลาด กรุณาติดต่อผู้ดูแลระบบ`,
"label_tabpage_contactsz":`ผู้ติดต่อ`,
"label.multilang.workflow.everydayinmonth":`ทุก {1} วันของ {0} เดือน`,
"APPIntegration.Social.linkedinerror":`ต้องเป็น URL ของ linkedin.com ที่ถูกต้องตามกฎหมาย`,
"button_partner_workspace_manage_memo":`จัดการพาร์ทเนอร์คลาวด์ของคุณ และปรับแต่งคุณสมบัติของพาร์ทเนอร์คลาวด์`,
"template.chart.bnsrmb":`เป้าหมายรายได้ปีนี้`,
"chatter.follow.now":`กำลังติดตาม`,
"label.entitlement.process.condition.repeat":`ตั้งค่าอิเวนต์สำคัญซ้ำ`,
"label.relationobject.isdl":`ให้จัดการแทนหรือไม่`,
"label.lasttimemodifieralias":`นามแฝงของผู้ที่แก้ไขครั้งล่าสุด`,
"vue_label_commonobjects_detail_task_name":`แก้ไขชื่อภารกิจ`,
"vue_label_homepage_quarterlyperformance":`ผลการดำเนินงานรายไตรมาส`,
"pagecreator.layout.message.delete":`ต้องการลบเค้าโครงที่เลือกหรือไม่?`,
"component_sendmail_label_cc":`สำเนา`,
"vue_label_email_enable_signature":`เปิดใช้ลายเซ็น`,
"label.partnerCloud.financeSetting.create":`เมื่อเปิดใช้งานพาร์ทเนอร์ใหม่ บัญชีจะถูกสร้างขึ้นโดยอัตโนมัติสําหรับลูกค้าที่มีเงื่อนไขเหมาะสม`,
"label.data.file.i.title.num1":`1. ไฟล์ที่นำเข้าต้องเป็นรูปแบบ CSV และต้องมีหัวข้อ หากไม่มีหัวข้อจะไม่สามารถนำเข้าได้`,
"label_efine_assessment":`รอบการประเมิน`,
"message.duplication.label.sectionTitle":`เลือกค่าที่จะเก็บ`,
"front-electronic-export-buttonExport":``,
"message.submitpage.email":`ยินดีด้วย! การส่งอีเมลคำร้องสำเร็จ!`,
"after":`หลังจาก`,
"label.version.nonsupport":`ไม่รองรับ`,
"label.icon.105":`กําหนดการ`,
"label.quickcreate.titledesc":`หลังจากเปิดใช้งานการสร้างด่วน คุณสามารถสร้างบันทึกใหม่อย่างรวดเร็วในช่องค้นหาเมื่อเข้าสู่ฟิลด์ค้นหา`,
"label.quote.number":`กรอกจำนวน`,
"label.view.sortview.setdefault.prompt":`กำหนดรายการมุมมองนี้เป็นมุมมองเริ่มต้น`,
"label.refertime":`เวลาส่ง`,
"frame.personinfo.label.minipic":`ภาพขนาดย่อ`,
"label.mobile.home.page.newopp":`ลีดล่าสุด`,
"label.address":`ที่อยู่`,
"front-pay":`จ่าย`,
"label.chat.serviceAppointment":`การแจ้งเตือนการบริการ`,
"label.umeng.activity.eventviewed":`อิเวนต์ที่คุณมอบหมายให้ #name ถูกดูแล้ว`,
"label.validate.function.funcExplain.DATE":`สร้างวันที่โดยใช้ ปี เดือน และวัน`,
"label.commiterselectapprover":`อนุญาตให้ผู้เสนอเลือกผู้อนุมัติด้วยตนเอง`,
"label.appointmentconfirmpage.wizard.subtitle3":`สถานที่`,
"vue_label_display_text_field":`แสดงฟิลด์ข้อความ`,
"label.salescloud.teamrole":`บทบาทของทีม`,
"maintenanceplan.workorder.generate.limit":`ใบสั่งงานที่สร้างขึ้นควรอยู่ในแผนการบํารุงรักษา`,
"label.campaignmember.selectmember.description":`เลือกหนึ่งมุมมองจากนั้นเลือกสมาชิกที่จะเพิ่มในแคมเปญ สถานะของสมาชิกคือ`,
"label.ismodify":`อนุญาตให้แก้ไขหรือไม่`,
"label.height":`สูง`,
"label.tabpage.thevalurofz":`ค่า`,
"label.create_successful":`สร้างฟอร์มสำเร็จ`,
"front-invoice-online-payment-setup-configure-dialog":``,
"label.customerinfo.smsEid":`เกตเวย์ข้อความสั้น EID`,
"label.visualpage.list.no":`ไม่มีสิทธิ์ในการเข้าถึงเพจที่กำหนดเอง`,
"look.trigger.in":`ดูคู่มือการใช้งาน`,
"label.setting.disable":`ปิดการใช้งาน`,
"chatter.group.name":`กลุ่ม`,
"label.solutionadministrator":`ผู้ดูแลโซลูชัน`,
"label.vlidaterule.top":`ด้านบนของหน้า`,
"pagecreator.layout.message.save.fail":`การบันทึกเค้าโครงล้มเหลว`,
"label.partnerCloud.orderingPlatform.noZero":`จำนวนต้องไม่เป็น 0`,
"label.customfields.suretodeleteprompt":`ยืนยันพร้อมท์การลบฟิลด์ที่กำหนดเอง`,
"button_partner_viewdetail":`ดู`,
"label.icon.122":`บ้าน`,
"label.customer.tab.step2.introduce":`เลือกโปรไฟล์ผู้ใช้ที่ต้องการใช้เมนูแบบกำหนดเองใหม่ และยังสามารถตรวจสอบหรือปรับเปลี่ยนได้ว่าจะแสดงเมนูบนหน้ารายละเอียดและหน้าแก้ไขของแต่ละโปรไฟล์หรือไม่`,
"label.task.delegated":`มอบหมายแล้ว`,
"vue_label_salesadvance_averageamount":`ราคาเฉลี่ยต่อหน่วย`,
"vue_label_chat_invitedtojoin":`“{invite}” ได้เชิญคุณเข้าร่วมกลุ่มสนทนา`,
"label.data.downpage.e_title.num1":`1. เลือกออบเจ็กต์ที่จะส่งออกข้อมูลหรือเลือกส่งออกทั้งหมด`,
"label_display_options":`ตัวเลือกการแสดงผล`,
"vue_label_chatter_more_comments":`ความคิดเห็นเพิ่มเติม`,
"label.ggReleaseRange.publish":`เผยแพร่รายการ`,
"label.valuetype.notmate":`เงื่อนไขแถวไม่ถูกต้อง ประเภทค่าไม่ตรงกัน!`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`ซิงค์ครั้งล่าสุด:`,
"label.dataimport.duplication.filter":`แจ้งเตือนตัวกรองซ้ำ`,
"label.appdownload.uninstall":`ถอนการติดตั้งโปรแกรมสำเร็จรูป`,
"message.error.task.add":`ข้อยกเว้นภารกิจใหม่`,
"UG.Account.07":`ชักนำลูกค้าเข้ามา`,
"label_tabpage_lastone":`เลือกอย่างน้อยหนึ่งการปฏิบัติการ`,
"front-console-holdTime":``,
"label.emailobject.schedule":`นี่คือตารางเวลาของฉัน โปรดเลือกเวลาที่เหมาะสม`,
"label.lookup.locked.data":`บันทึกถูกล็อกและไม่สามารถเลือกได้`,
"label.assignment.setup.newentries.ifcondtions":`หากสอดคล้องกับเงื่อนไขต่อไปนี้ให้เรียกใช้เกณฑ์นี้`,
"label.magadan.time":`เวลาปิตราปัฟลัฟสค์-คัมชัตสกี`,
"message.error.serviceterritorymember":`โปรดกำหนดทรัพยากรบริการที่เลือกเป็นสมาชิกภูมิภาคให้บริการภายในช่วงเวลาเริ่มต้นและสิ้นสุดของแผนการนัดหมายการบริการ`,
"label_chatter_delete":`ลบ`,
"label.partner.workspace.member.permission":`ตัวเลือกชุดสิทธิ์`,
"label.notification.task5":`ภารกิจของคุณเกินกำหนดแล้ว`,
"mary":`เดือนพฤษภาคม`,
"label.homepagemodule":`ส่วนเสริมหน้าแรก`,
"label.compact.layout.frame.error1":`หน้าจอด้านขวาไม่มีเนื้อหาไม่ได้`,
"chatter.error.refresherror":`การรีเฟรสล้มเหลว กรุณาลองใหม่อีกครั้ง`,
"label.login.rememberPsd":`จำรหัสผ่าน`,
"Lead.Scoring.Setting.Rule.Setup.01":`รายการเกณฑ์การให้คะแนนลีด`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`วันอาทิตย์`,
"label.visible":`ที่สามารถมองเห็น`,
"label.console.new":`คอนโซลใหม่`,
"label.mr.descreption.reDataList4":`มิลลิวินาที แต่ละหน้าแสดง`,
"vue_label_notice_uploadavatar_notice2":`รูปโปรไฟล์ที่อัปโหลดต้องอยู่ในรูปแบบ JPG/PNG/GIF เท่านั้น`,
"label.operation.error":`การดำเนินการล้มเหลว โปรดลองอีกครั้ง`,
"label.sendsms.context":`เนื้อหาข้อความสั้น`,
"label.least.show.line":`(แสดงอย่างน้อย 4 บรรทัด)`,
"label.tabpage.newWizardz":`ตัวช่วยสร้างฟังก์ชันใหม่`,
"label.tippage.li2":`ลบรายงานทั้งหมดตามแหล่งข้อมูลรายงานที่กำหนดเอง`,
"label.customfields.new.step2.opration.unique":`ไม่ซ้ำ`,
"label.listofshare.remark":`ผู้ใช้ต่อไปนี้สามารถดูข้อมูลของบันทึกนี้ได้`,
"label.address_information":`ข้อมูลที่อยู่`,
"label.projectManagement.overdue.tasks":`งานที่เกินกำหนด`,
"lable.account.PreviousCQ":`ไตรมาสปฎิทินก่อนหน้า`,
"label.service.miniProgram.advertising":`ชื่อโฆษณาใช้เพื่อระบุรายการโฆษณาเท่านั้น จะไม่แสดงในโฆษณา`,
"label.integrations.mailchimp.exportlead":`ส่งออกลีดไปยัง Mailchimp`,
"label.payments.paytip3":`โปรดเลือกที่อยู่ใบวางบิล`,
"label.mobile.phone.screen":`ตัวกรอง`,
"label.h5.tome":`เกี่ยวกับฉัน`,
"label.mobile.side.tab.remark1":`เพิ่มแท็บ CloudCC และออบเจ็กต์ในเมนูระบบนำทางของแถบเลื่อนด้านข้างอุปกรณ์มือถือ`,
"vue_label_calendar_choose_a_custom_color":`เลือกสีที่กำหนดเองสำหรับปฏิทินนี้`,
"label.lastname":`นามสกุล`,
"vue_label_dashboard_selectreport":`โปรดเลือกรายงาน`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`ส่งออกรายงานที่แสดงใน cloudcc ที่มีส่วนหัวของรายงาน การจัดกลุ่ม และข้อมูลการกรอง`,
"label_chatter_default":`ค่าเริ่มต้น`,
"label.globalSearch.info":`ค้นหาออบเจ็กต์ที่เลือกทั้งหมด`,
"label.integrations.mailchimp.massage2":`กำลังส่งออกลีดไปยัง Mailchimp คุณสามารถตรวจสอบได้ในรายการ Mailchimp ภายหลัง`,
"label.tabpage.addresswrongz":`รูปแบบที่อยู่อีเมลไม่ถูกต้อง โปรดป้อนที่อยู่อีเมลให้ถูกต้อง!`,
"label.mobile.phone.customer.call":`เข้าพบลูกค้า`,
"vue_label_email_linkrecordfail":`ยกเลิกการเชื่อมบันทึกแล้ว`,
"lable.account.LastfDays":`90 วันที่ผ่านมา`,
"label.cpq.order.status.delete":`ใบสั่งซื้อถูกเปิดใช้งานและไม่สามารถลบได้`,
"label.ccchat.notmember.active.group":`คุณไม่ได้อยู่ในชื่อ`,
"label.savepayset.failure":`บันทึกการตั้งค่าการชําระเงินออนไลน์ล้มเหลว`,
"label.version.createlimitbyobject":`CloudCC รุ่นปัจจุบันของคุณ คือ{0} สามารถสร้าง{2)ได้ {1} ถึงขีดจำกัดแล้ว! หากมีความจำเป็น กรุณาอัปเกรดรุ่น CloudCC!`,
"approval.process.errore":`เกิดข้อผิดพลาดระหว่างการบันทึก กรุณาติดต่อผู้ดูแลระบบ`,
"label.stdashbord.xsld.business.reportanalysis":`การวิเคราะห์แผนภูมิ`,
"label.login.verification.please.enter":`กรุณาใส่รหัสความปลอดภัยที่คุณได้รับจากแอป MFA`,
"label.tabpage.cue":`ข้อความแจ้งเตือน`,
"vue_label_salesadvance_converserate":`อัตราการเปลี่ยนสเตจ`,
"label.marketsea.recyclereminddays1":`ก่อนรีไซเคิลอัตโนมัติ`,
"label.import.page1.update":`อัปเดต`,
"label.document.folder":`โฟลเดอร์เอกสาร`,
"label.h5.similar.opportunity.feature":`ฟังก์ชันนี้จะเปิดให้ผู้ใช้สามารถค้นหาโอกาสทางธุรกิจที่ใช้ฟิลด์ร่วมกับโอกาสทางธุรกิจของผู้ใช้ เมื่อเปิดใช้แล้ว รายการ "โอกาสทางธุรกิจที่คล้ายกัน" จะปรากฏในบันทึกโอกาสทางธุรกิจ`,
"label.myanmar.time":`เวลาเมียนมา`,
"monday":`วันจันทร์`,
"vue_label_account_shareholder":`ผู้ถือหุ้น`,
"button.partner.search":`สืบค้น`,
"label.partnerCloud.partnerAccount.topUpAmount":`ยอดเติมเงิน`,
"label.tabpage.refreshz":`รีเฟรช`,
"lable.PowerProcess.complete":`นาทีที่จะเสร็จสิ้นอิเวนต์สำคัญ`,
"front-kefu-moudle- normal-phone":``,
"label.user.unauthorized.organization":`องค์กรที่ไม่ได้รับอนุญาต โปรดติดต่อผู้ดูแลระบบ!`,
"label.area.canot.save.nulldata":`ไม่สามารถบันทึกข้อมูลว่างเปล่า`,
"label.version.role.management":`การจัดการบทบาท`,
"label.recordtype.batchaddattachments.batch.remark":`ขั้นตอนที่ 1. เลือกไฟล์; ขั้นตอนที่ 2. คลิกปุ่ม "เริ่มการอัปโหลด" เพื่ออัปโหลดไฟล์; ขั้นตอนที่ 3. คลิกปุ่ม "เสร็จสิ้น" เพื่อกลับไปยังหน้าก่อนหน้า`,
"label_tabpage_contentz":`กรุณาใส่เนื้อหา`,
"label.partner.workspace.member.all":`ทั้งหมด`,
"label.validate.function.funcFormat.LEFT":`LEFT(text, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`โปรดเลือกลีดหรือผู้ติดต่ออย่างน้อยหนึ่งราย`,
"label.appupload.install.error.choice5":`หยุดการติดตั้งทันที และส่งออกส่วนเสริมที่ขัดแย้งกัน`,
"label.version.lookupmdfield":`ฟิลด์รายละเอียดหลัก`,
"setup.layout.label.desc":`จากมากไปน้อย`,
"vue_label_report_addsummaryformula":`เพิ่มสูตรสรุป`,
"label.done":`จริง`,
"label.input.samevalue":`ป้อนค่าเดียวกัน`,
"label.SMS.next":`เลือกออบเจ็กต์สำหรับการแจ้งเตือนข้อความสั้นนี้ แล้วคลิกขั้นตอนถัดไป "การแจ้งเตือนทางข้อความสั้นสามารถเชื่อมโยงกับกฎเวิร์กโฟลว์และขั้นตอนอนุมัติประเภทเดียวกันเท่านั้น"`,
"label.role.allunselectuser":`ผู้ใช้ที่ไม่ได้รับมอบหมายทั้งหมด`,
"label.loginhistory":`ประวัติการเข้าสู่ระบบ`,
"vue_label_report_addpublicreportstofolder":`เพิ่มรายงานสาธารณะในโฟลเดอร์นี้`,
"label.email.track.no.attachment":`ไม่มีไฟล์แนบ`,
"label_network_connection_failure":`การเชื่อมต่อเครือข่ายล้มเหลว`,
"vue_label_file_delete_lib_member":`ลบไลบรารีเอกสารสมาชิก`,
"label_partner_step1":`ขั้นตอนที่ 1: เลือกแม่แบบ`,
"label.password":`รหัสผ่าน`,
"label.select.the.fields.around.code":`เลือกฟิลด์ที่แสดงรอบรหัสคิวอาร์/บาร์โคด`,
"label.file.share.limit":`เกินขีดจำกัดการแบ่งปัน ไม่สามารถเพิ่มการแบ่งปันใหม่ได้!`,
"label.desktop":`เดสก์ทอป`,
"label.sendmail":`ส่งอีเมล`,
"label.quote.detail":`รายละเอียดใบเสนอราคา`,
"label.approvalstep2":`ขั้นตอนที่ 2: ระบุเงื่อนไขขั้นตอน`,
"label_component_hotdeal_nodata":`ไม่มีข้อมูลที่เกี่ยวข้องกับโอกาสทางธุรกิจ`,
"lable.reset":`รีเซ็ต`,
"label.eventpagelayout":`เค้าโครงหน้าอิเวนต์`,
"label.icon.100":`เครื่องเขียน`,
"UG.quota.03":`แม่แบบใบเสนอราคา`,
"label.calendar.week.view":`มุมมองรายสัปดาห์`,
"component_chatter_file_button_save":`เผยแพร่`,
"label.as":`สำหรับ`,
"template.chart.yqxypjz":`ค่าเฉลี่ยการตอบสนองที่คาดไว้`,
"UG.Contract.03":`สร้างสัญญา`,
"label.projectManagement.gantt":`แผนภูมิแกนต์`,
"label.forecast.edit.error0":`ข้อผิดพลาด: กรุณาเปิดใช้สกุลเงินของบริษัทอย่างน้อยหนึ่งสกุลเงิน!`,
"label.ccpeak.delete.sharetab":`ลบตารางแบ่งปัน`,
"label.account.contact.goback":`ส่งลูกค้ากลับ`,
"vue_label_email_insert_field":`กรุณาเลือกฟิลด์แทรก`,
"setup_object_field_dependency_label_fieldvalueoptions":`ตัวเลือกค่าฟิลด์`,
"label.salescloud.opportunity.contactrole.optionlist.main":`ด้านล่างนี้คือรายการหลักของค่ารายการตัวเลือกสำหรับฟิลด์บทบาทผู้ติดต่อในโอกาสทางธุรกิจ`,
"label.huanxinconfig.tenantid.lost":`tenantid ต้องไม่ว่างเปล่า`,
"label.mask.show.last_4":`ตัวพรางแสดงตัวเลข 4 หลักสุดท้าย`,
"label.targer.name":`ชื่อเป้าหมาย`,
"vue_label_commonobjects_detail_unlocksuccess":`การปลดล็อกสำเร็จ`,
"front-kefu-moudle-length-min":``,
"label.chat.topic.my.favorite":`หัวข้อที่ฉันบุ๊กมาร์ก`,
"chatter.upload":`อัปโหลด`,
"message.cannotapproveit":`ไม่สามารถดำเนินการตามคำขออนุมัติ`,
"label.weixin..xsld.order.by.jine":`เรียงลำดับตามจำนวนเงินในสัญญา`,
"label.projectManagement.wait.test":`รอการทดสอบ`,
"template.report.customer.contact.list":`รายชื่อผู้ติดต่อของลูกค้า`,
"label.empty.recycle.bin":`ล้างถังขยะรีไซเคิล`,
"label.detail.approveprocess":`ดูกระบวนการอนุมัติ`,
"label.appexchange.uninstallpage.message4":`ลบรายงาน มุมมอง และแท็บที่กำหนดเองอย่างถาวรตามออบเจ็กต์ที่กำหนดเองในแพ็กเกจนี้`,
"label.weixin.linkreport":`เชื่อมต่อ→รายงาน`,
"label.tianyancha.orgnumber":`รหัสองค์กร`,
"Q":`รายการตัวเลือก (หลายตัวเลือก)`,
"pagecreator_systemstyle_message_save_fail":`การบันทึกรูปแบบล้มเหลว`,
"label.partner.new":`พาร์ทเนอร์คลาวด์: ใหม่`,
"label.ems.accounttype":`ประเภทบัญชี (A)`,
"label.weixin.next":`ขั้นตอนถัดไป`,
"label.weixin.coach.interpret":`aid-max ขอสงวนสิทธิ์ในการแก้ไขและการตีความขั้นสุดท้ายภายในขอบเขตทางกฎหมายของบริการวีแชทนี้`,
"label.some":`บาง`,
"label.currency.rate":`การแก้ไขสกุลเงิน: อัตราแลกเปลี่ยน`,
"label.emailobject.template.name":`ชื่อแม่แบบ`,
"UG.Campaign.001":`วางแผนแคมเปญ`,
"label.mr.descreption.reDataList3":`กลุ่ม, ระยะเวลาในการสืบค้น`,
"label.project.hit.nine":`แจ้งเตือนปัญหาทุกวัน`,
"lable.PowerProcess.golist":`<<กลับไปที่รายการ: กระบวนการให้สิทธิ์`,
"label.viewbuttonedit.remark":`เลือกปุ่มมาตรฐานและปุ่มแบบกำหนดเองที่จะแสดงบนมุมมองหน้าเว็บ`,
"label.component.helper":`ผู้ช่วย`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`ลงทะเบียนชำระเงิน`,
"chatter.group.userName":`ชื่อผู้ใช้`,
"label.mobile.phone.business":`โอกาสทางธุรกิจ`,
"label.quickbooks.payments":`การจ่ายเงิน`,
"label.step6.total7":`ขั้นตอนที่ 6 จาก 7`,
"label.forecast.detailforecast.revenue":`การพยากรณ์รายได้`,
"vue_label_commonobjects_view_chart_displayas":`แสดงผลเป็น`,
"label.recordeditoption":`บันทึกคุณลักษณะการแก้ไข`,
"label.sendemail.send.sendfailstandby":`การส่งอีเมลล้มเหลว โปรดติดต่อผู้ดูแลระบบ (กล่องขาออกสำรอง)`,
"label.knowledgebase.reset.filter":`รีเซ็ตตัวกรอง`,
"label.icon.111":`อาหารและเครื่องดื่ม`,
"label.standard.buttonandlink.firstsetting":`การตั้งค่าลําดับความสําคัญ`,
"front-filter-module-v1-filter-description":`ไม่สามารถบันทึกตัวกรองด่วนสําหรับการดําเนินการปัจจุบัน ไม่มีผลต่อมุมมองหรือผู้ใช้อื่น`,
"label.showmore":`แสดงเพิ่มเติม`,
"UG_Lead_001":`จะดึงลีดเข้ามาอย่างไร?`,
"label.exchange.sync.state.setting.m1":`บัญชีบริการ Miscrosoft Exchange ที่มอบให้:`,
"label.please.enter.channel.name":`กรุณาใส่ชื่อช่องทาง`,
"label.emailtocloudcc.edit":`แก้ไข`,
"label.layout.tabdialog":`แท็บ`,
"label.Emoji":`อิโมจิ`,
"template.report.completed.tasks":`งานที่เสร็จแล้ว`,
"label.tabpage.enterviewname":`ขั้นตอนที่ 1: กรุณาใส่ชื่อมุมมอง`,
"label.mobile.phone.not.to.choose":`ไม่เลือก`,
"label.datamanage.contact.namenull":`หมายเหตุ: หากฟิลด์ไม่กำหนดค่า"ชื่อผู้ติดต่อ" บันทึกผู้ติดต่อจะไม่ถูกนำเข้า!`,
"LT":`ตำแหน่งทางภูมิศาสตร์`,
"label.exchange.sync.state.task.m3":`บันทึกที่ซิงค์เมื่อ 24 ชั่วโมงที่ผ่านมา：`,
"lable.SalesCommitmentKanBan.contractOwner":`เจ้าของสัญญา`,
"vue_label_chatter_write_review":`เขียนรีวิว`,
"label.h5.approval.enter.content":`กรุณาใส่หมายเหตุการอนุมัติ`,
"label.location.display.type":`สัญกรณ์การแสดงละติจูดและลองจิจูด`,
"label.numberscannotnull":`จำนวนไม่สามารถว่างเปล่า`,
"label.icon.3":`สกุลเงิน`,
"setup_object_field_dependency_label_linkedfieldvalue":`ค่าฟิลด์พึ่งพา`,
"label.task.future":`ภารกิจที่กำลังจะเกิดขึ้น`,
"label.look.more.record":`ดูบันทึกเพิ่มเติม`,
"vue_label_account_cases":`โอนทุกเคสของเจ้าของลูกค้า`,
"label.emailobject.emaildetail.title.ccaddress":`สำเนาถึง:`,
"label.setHistoryTrack":`ตั้งค่าการติดตามประวัติ`,
"ObjectDetailed.ViewKeyInformation.Layout":`แก้ไขข้อมูลคีย์`,
"label.layout.editsearchdistribute.tip":`เลือกฟิลด์ที่ต้องการจะรวมกับเค้าโครงที่ค้นหานี้ โปรดทราบว่า ตัวเลือกที่ทำขึ้นทั้งหมดจะกำหนดแสดงแค่ผลการค้นหาเท่านั้น จะไม่ส่งผลกระทบต่อฟิลด์ที่ถูกค้นหาจริง`,
"label.emailtoall":`ส่งอีเมลให้ทุกคน`,
"label_partner_new":`พาร์ทเนอร์คลาวด์: สร้างใหม่`,
"label.direct.dashboard.me.not.approval":`รายการที่ยังไม่ได้รับการอนุมัติของฉัน`,
"label.platform.customize.customizeui":`UI แบบกำหนดเอง`,
"label.userinfo.pwderror.againinput":`รหัสผ่านที่ป้อนสองครั้งไม่ตรงกัน โปรดป้อนใหม่!`,
"label.customsetting.introduce":`ใช้การตั้งค่าแบบกำหนดเองเพื่อสร้างและจัดการองค์กร โปรไฟล์ และข้อมูลระดับผู้ใช้ที่กำหนดเอง ข้อมูลการตั้งค่าแบบกำหนดเองจะถูกเก็บไว้ในแคชของแอปพลิเคชัน ซึ่งหมายความว่าคุณสามารถเข้าถึงได้อย่างมีประสิทธิภาพโดยไม่ต้องสืบค้นซ้ำ`,
"label.file.owner":`เจ้าของ`,
"label.icon.7":`คน`,
"label.document.query.button":`คลิกปุ่มเรียกดูเพื่อค้นหาไฟล์`,
"label.tabpage.turnoffsz":``,
"message.error.appid.appsecret.failed":`รับรหัสความปลอดภัยล้มเหลว!`,
"vue_label_commonobjects_view_to_display_fields":`เลือกแสดงได้มากที่สุด 10 ฟิลด์`,
"label.martrixreport.setlinetitle":`กำหนดหัวตาราง`,
"vue_label_chatter_applycertification":`ยืนยันว่าต้องการยอมรับ"{name}"เข้าร่วมกลุ่มหรือไม่`,
"front-electronic-export-success":``,
"label.emailsync.status.enable":`เปิดการเชื่อมต่อ`,
"label.c_d":`ความสัมพันธ์จาก C ไป D`,
"PageLayout_Search_MultiSearch_003":`คุณต้องเลือกอย่างน้อยหนึ่งฟิลด์`,
"label.tabpage.newInterfacez":`อินเทอร์เฟซรุ่นใหม่`,
"label.cutomsummaryfieldedit":`แก้ไขฟิลด์สรุปที่กำหนดเอง`,
"label.usermanage.view.field.notexist":`ไม่มีฟิลด์ที่สอดคล้องกับมุมมอง`,
"label.list.userinterface.dashboard.setup":`ตั้งค่าแดชบอร์ด`,
"label.knowledgebase.delete.article":`ลบบทความ`,
"label.dataimport.type.update":`อัปเดต`,
"label.marketsea.new":`ฐานข้อมูลใหม่`,
"label_tabpage_newlybuildz":`ใหม่`,
"vue_label_helpcenter_report1":`1. สร้างรายงาน<br> รายงาน Lightning ในระบบการจัดการการขาย CloudCC เป็นเครื่องมือวิเคราะห์ข้อมูลที่มีประสิทธิภาพ ปัญหาการขายหลายอย่างสามารถแก้ไขได้ด้วยการจัดกลุ่ม การกรอง และการสรุปบันทึก เช่น: "โอกาสทางธุรกิจใหม่ของบริษัทสร้างรายได้เท่าใดในไตรมาสที่แล้ว" คุณสามารถเพิ่มแผนภูมิรายงานได้จากการกรอกข้อมูลภาพรวมให้ครบถ้วน หลังจากสร้างรายงานเสร็จสิ้น ให้คลิกเรียกใช้เพื่อดูผลลัพธ์ทั้งหมดของข้อมูล <br> ขั้นตอนที่ 1: จากแท็บรายงาน คลิก "รายงานใหม่" <br> ขั้นตอนที่ 2: เลือกแหล่งข้อมูลรายงาน และคลิก "ถัดไป" <br> คุณสามารถตัดสินใจได้ว่าบันทึกใดหรือฟิลด์ใดจะเป็นแหล่งข้อมูลของรายงาน เลือกหรือค้นหาออบเจ็กต์เพื่อเป็นออบเจ็กต์หลัก คุณสามารถเลือกวัตถุที่มีความสัมพันธ์กับออบเจ็กต์หลักได้สูงสุด 4 รายการ ทั้งยังสามารถเลือกความสัมพันธ์ระหว่างออบเจ็กต์ได้ <br> ขั้นตอนที่ 3: เข้าสู่หน้าแก้ไขรายงานและแสดงข้อมูลตัวอย่าง<br> ในโหมดแก้ไข คุณสามารถปรับแต่งรายงาน เพิ่มฟิลด์เป็นคอลัมน์ในรายงาน จัดกลุ่มแถวและคอลัมน์ และใช้ตัวกรองเพื่อกรองข้อมูลรายงานจนกว่าจะแสดงข้อมูลที่คุณต้องการ<br>•เพิ่ม ลบคอลัมน์ และปรับลำดับของคอลัมน์<br> เพิ่มคอลัมน์: ในโหมดแก้ไขรายงาน ให้คลิกกล่องข้อมูล "คอลัมน์" ใน "สรุป" บน ด้านซ้ายของหน้า และผ่านช่องค้นหา เลือกหรือเลื่อนรายการช่องแบบเลื่อนลงและเลือกช่องที่ต้องการเพื่อเพิ่มคอลัมน์รายงาน <br> ลบคอลัมน์: <br> A. หลังจากพบ "คอลัมน์" ที่คุณต้องการลบในรายการ "คอลัมน์" ทางด้านซ้าย ให้คลิก "×" ในช่องฟิลด์ <br> B. หรือค้นหา "คอลัมน์" ที่คุณต้องการลบในส่วนหัวของมุมมองแสดงตัวอย่างรายงานทางด้านขวา คลิก "ปุ่มแบบเลื่อนลง" แล้วคลิก "ลบคอลัมน์" <br> การลบคอลัมน์ออกจากรายงานจะไม่เป็นการลบฟิลด์ หากคุณลบคอลัมน์แต่ต้องการกู้คืน ให้เพิ่มคอลัมน์นั้นอีกครั้ง <br> ปรับลำดับคอลัมน์: ลากช่อง "คอลัมน์" ในรายการ "คอลัมน์" ทางด้านซ้ายขึ้นและลงเพื่อปรับลำดับของ "คอลัมน์" <br>•เพิ่มและลบการจัดกลุ่มแถวและการจัดกลุ่มคอลัมน์<br> เพิ่มการจัดกลุ่มแถว: คลิกกล่องข้อมูล "แถวกลุ่ม" ใน "สรุป" ทางด้านซ้ายของหน้า เลือกช่องค้นหาหรือเลื่อนรายการแบบดึงลงหลังรายการและเลือกฟิลด์ที่ต้องการเพิ่มฟิลด์การจัดกลุ่มแถวรายงานเพื่อกรองข้อมูล <br> คุณสามารถเพิ่มการจัดกลุ่มแถวได้สูงสุดสามกลุ่มโดยไม่ต้องเพิ่มการจัดกลุ่มคอลัมน์ <br> เพิ่มการจัดกลุ่มคอลัมน์: เมื่อมีการจัดกลุ่มแถว คุณสามารถเพิ่มการจัดกลุ่มคอลัมน์ได้ คลิกกล่องข้อมูล "คอลัมน์กลุ่ม" ใน "สรุป" ทางด้านซ้ายของหน้า เลือกช่องค้นหาหรือเลื่อนช่องรายการแบบดึงลง และเลือกฟิลด์เพิ่มคอลัมน์รายงานเพื่อกรองข้อมูล <br> คุณสามารถเพิ่มกลุ่มคอลัมน์ได้สูงสุด 2 กลุ่ม หากมีกลุ่มคอลัมน์คุณสามารถเพิ่มกลุ่มแถวได้สูงสุดสองกลุ่ม ฟิลด์ที่เป็นกลุ่มแถวไม่สามารถเป็นกลุ่มคอลัมน์ได้ <br>`,
"label.notification.event1":`[ผู้มอบหมาย]มอบหมายอิเวนต์ให้คุณแล้ว`,
"chatter.field":`ฟิลด์`,
"chatter.feed.menutype.feed.newscom":`เนื้อหาทั้งหมดที่ฉันกำลังติดตาม`,
"label.attendance.range":`ช่วงเวลาทำงาน`,
"vue_label_calendar_deleteconfirm":`ยืนยันว่าจะลบปฏิทิน{name}ไหม`,
"label.ems.createTask":`{taskName}ใหม่`,
"label.visualpage.wgd":`เพจที่กำหนดเองที่ไม่ได้จัดเก็บถาวร`,
"label.multilang.product.deleterederect1":`ความพยายามในการลบ <font style = "font-weight: bold;"> {0} </font> ของคุณไม่สำเร็จเนื่องจากยังคงมีความสัมพันธ์กับบันทึกต่อไปนี้ ในกรณีนี้แนะนำให้คุณปิดใช้งาน`,
"label_emailtocloudcc_filed_servertype":`ประเภทเซิร์ฟเวอร์`,
"label.umeng.insert.approval.dlsp.approvenew":``,
"label.tabpage.queue":`คิว`,
"label.approval.step":`ขั้นตอนการอนุมัติ`,
"label.approvaldatamove.approvalprocessname":`ชื่อกระบวนการ`,
"label.actualapprovedpeople":`ผู้อนุมัติจริง`,
"label.systemlog.f":`ล้มเหลว`,
"front-template-V1-addText":`เพิ่มข้อความ`,
"label.chat.like":`ถูกใจ`,
"label.userinfo.oldpwd.notnull":`รหัสผ่านเก่าไม่สามารถว่างเปล่า!`,
"label.service.all.done.major.event":`คุณได้เสร็จสิ้นอิเวนต์ที่สำคัญทั้งหมด`,
"label_chatter_to":`ถึง`,
"message.toomuchlinecannotoutput":`เลือกแถวรายงานมากเกินไป รายงานไม่สามารถส่งออกได้!`,
"maintenanceasset.assetid.maintenanceplanid.unique":`แผนการบํารุงรักษาได้จัดสรรให้กับสินทรัพย์แล้ว โปรดอย่าทําซ้ํา`,
"lable.quote.syncing.firstsync.description":`รายละเอียดใบเสนอราคาจะแทนที่ผลิตภัณฑ์ที่มีโอกาสทางธุรกิจ`,
"lable.outlook.mcto.saveemail":`ตรวจสอบให้แน่ใจว่าบันทึกไฟล์แนบแล้ว`,
"label.passwordPolicy.setup.pwdremember2":`จำ 2 รหัสผ่าน`,
"label.project.hit.five":`แจ้งเตือนการอัปเดตงานโครงการ`,
"label.linkedin.setting.appid":`คีย์`,
"label.dataimport.error.name.notnull":`เกิดข้อผิดพลาด : name ไม่สามารถว่างเปล่า`,
"label.knowledge.case.field.selected":`ฟิลด์เคสที่เลือก`,
"label.version.datetime":`{0} ฟิลด์วันที่และเวลา`,
"Dashboard_NoAccessRightToSee_Warning":`คุณได้เปิดแดชบอร์ด{0}ตามค่าเริ่มต้น ขณะนี้คุณไม่มีสิทธิ์ดู และคุณต้องตั้งค่าใหม่เป็นค่าอื่น`,
"label.login.access.permission":`รับสิทธิ์การเข้าถึง`,
"label.operatedata.import.tip":`1. ไฟล์ที่นำเข้าต้องเป็นรูปแบบ CSV และต้องมีหัวข้อ หากไม่มีหัวข้อจะไม่สามารถนำเข้าได้ <br/>2. แนะนำว่าให้ส่งออกก่อนนำเข้า และใช้เอกสารที่ส่งออกเป็นแม่แบบข้อมูลที่จะจัดระเบียบข้อมูลที่นำเข้า หลังจากนั้นค่อยนำเข้า (หากข้อมูลที่นำเข้ามีเครื่องหมายจุลภาค กรุณาใช้สัญลักษณ์ "@" แทน) <br/>3. ระบบจะอ่านไฟล์ที่ต้องการนำเข้าสู่เซิร์ฟเวอร์ก่อนเริ่มการใช้งานโปรแกรมนำเข้าการจัดการชุดหลังบ้าน ผลการนำเข้าจะแจ้งให้ผู้ใช้ทราบทางอีเมล คุณไม่จำเป็นต้องรอในหน้าการดำเนินการนี้`,
"workflow.action.tasks.assignortype.rolename":`ชื่อบทบาท`,
"vue_label_account_quotations":`โอนย้ายใบเสนอราคาของลูกค้าทั้งหมด`,
"lable.account.CurrentCQ":`ไตรมาสปฏิทินนี้`,
"label.user.database.error":`พบข้อผิดพลาดฐานข้อมูล!`,
"label_emailtocloudcc_titel":`Email to CloudCC`,
"label_file_content":`เนื้อหาข้อความ`,
"label.button.behavior":`รูปแบบ`,
"message.recordtype.new.tip":`ป้อนรายละเอียด`,
"label.ccchat.message.new.error3":`ข้อผิดพลาด: คุณไม่สามารถเลือกผู้รับได้เกิน 9 คน`,
"vue_label_commonobject_notice_lessthanwords":`ชื่อไฟล์ควรมีความยาวน้อยว่า {FILE_NAME_COUNT}ตัวอักษร！`,
"label.stacked.verticalline":`กราฟแท่งซ้อน`,
"vue_label_SMS_messagebox":`กล่องข้อความสั้น`,
"label.appexchange.installedpage.message3":`ตามลิงก์ข้างโปรแกรมสำเร็จรูปที่ติดตั้ง คุณสามารถดำเนินการต่างๆ ได้ในหน้านี้ หากต้องการลบโปรแกรมสำเร็จรูป คลิก <b> ถอนการติดตั้ง </b>  หากต้องการจัดการใบอนุญาต
โปรแกรมสำเร็จรูป คลิก <b> จัดการใบอนุญาต </b>`,
"label.unusedapproveprocess":`กระบวนการอนุมัติที่ไม่ได้เปิดการใช้งาน`,
"label.onlywithspecificconditions":`การคำนวณนี้ควรรวมเฉพาะบันทึกที่สอดคล้องกับเงื่อนไขเฉพาะ`,
"lable.outlook.mcto.formaterror":`รูปแบบไม่ถูกต้อง`,
"label.area.parent":`ภูมิภาคหลัก`,
"vue_label_chat_activesuccess":`การเปิดใช้งานสำเร็จ`,
"label.setting.intergrationlist.button.upgrade":`อัปเดต`,
"label.page_hidden":`ฟิลด์ซ่อนของหน้าการลงทะเบียน`,
"label.customsetting.manage.belong":`ตั้งค่าเจ้าของ`,
"label.appointment.wizard.subtitle4-2-8":`7 วัน`,
"template.chart.ydywjhxsje":`ยอดขายของโอกาสทางธุรกิจรายเดือน`,
"label.multilang.currencylist.after":`หลัง {0}`,
"vue_label_commonobjects_view_chart_countby":`รวมตาม`,
"label.week":`สัปดาห์`,
"label.emailtemplate.name":`ชื่อแม่แบบ`,
"label.umeng.sign":`ลงทะเบียนเข้าแล้ว`,
"label.appupload.upload.details":`รายละเอียด`,
"label.file.loading":`กำลังโหลด`,
"label.newdetail.orgTitle":`เครือข่ายผู้ติดต่อ`,
"label.salescloud.field.addoptionlist":`เพิ่มค่ารายการตัวเลือก`,
"pagecreator.page.funcpath":`/ต้วสร้าง/รายการหน้าเพจ`,
"Account.News.Setting.001":`การตั้งค่าลูกค้า`,
"label.marketsea.getnoconversiondays":`วันที่ไม่ได้แปลง (ต้องมากกว่าจํานวนวันที่ไม่ได้ติดตามหลังจากได้มา)`,
"message.error.event.add":`อิเวนต์ใหม่ผิดปกติ`,
"front-electronic-export-choseChimp":``,
"vue_label_report_personothers":`พนักงานคนอื่นๆ`,
"label.hierarchy.diagram":`แผนผังลําดับชั้น`,
"label.stdashbord.xsld.business.yqsr":`รายได้ที่คาดหวัง`,
"label.chat.topic.max.count":`คุณถึงจำนวนมากที่สุดของหัวข้อแล้ว`,
"label.sendemail.send.sendfail":`การส่งอีเมลล้มเหลว โปรดติดต่อผู้ดูแลระบบ`,
"registration.page.body.title":`หน้าการลงทะเบียน`,
"label.userphoto.back":`ยกเลิก`,
"label.service.without.timeslot":`ดูเหมือนจะไม่มีช่วงเวลาแล้ว มาเพิ่มกันตอนนี้เลย!`,
"label.processsetting.remaining.quantity":`ป้อนอักขระได้สูงสุด 255 ตัว จํานวนที่เหลือ:`,
"label.sure.delete":`ยืนยันการลบ`,
"front-epwechat-module-v1-callback":`การตั้งค่าการย้อนกลับ`,
"front-email-payment-failed":``,
"label.icon.67":`เครื่องจักร`,
"UG_Forcast_01":`การพยากรณ์`,
"label.escalation.setup.newentries.step3":`ขั้นตอนที่ 3: ระบุวิธีการตั้งค่าเวลาการเลื่อนขั้น`,
"lable.account.NextCY":`ปีปฏิทินถัดไป`,
"report.type.label.quote":`เสนอราคา`,
"label.area.name":`ชื่อภูมิภาค`,
"component.setup.label.object":`ออบเจ็กต์`,
"label.customsetting.type":`ประเภทการตั้งค่า`,
"label.showdetail":`แสดงรายละเอียด`,
"label.department.prev":`หน้าก่อน`,
"label.select.data.source.report":`โปรดเลือกแหล่งข้อมูล`,
"UG_homepage_002":`ใช้เครื่องมือทางธุรกิจที่เป็นแบบเดียวกันมาจัดการลีด กรวยการขาย และข้อมูลลูกค้าของคุณ`,
"vue_label_report_notice_exprot1":`ส่งออกเฉพาะบรรทัดรายละเอียด ใช้ข้อมูลนี้สำหรับการคำนวณเพิ่มเติม หรืออัปโหลดไปยังระบบอื่นๆ การส่งออกเพจย่อยสามารถส่งออกได้สูงสุด 5,000 บรรทัดต่อหน้า`,
"message.error.task.phonecreate":`ภารกิจการโทรเกิดความผิดปกติ`,
"label_chatter_day":`วัน`,
"label.setinitialcommiter":`ขั้นตอนที่ 6 ระบุผู้เสนอตั้งต้น`,
"message.huanxinconfig.notfound":`ไม่พบการกําหนดค่าที่เกี่ยวข้องกับ Easemob`,
"label.customfields.file.count.tip":`กรุณาใส่จำนวนไฟล์ที่ฟิลด์สามารถใส่ได้ ค่าเริ่มต้นคือ 1`,
"label.weixin.appmanage":`การจัดการแอปพลิเคชัน`,
"label.approverautoconfirm":`วิธีการกำหนดผู้อนุมัติอัตโนมัติ`,
"vue_label_CCChat_followers":`ผู้ติดตาม`,
"label.usermanage.notselect":`ผู้ใช้ที่ไม่ได้เลือก`,
"label.item":`รายการ`,
"label.sendemail.chat.linkurl":`ลิงก์ URL:`,
"label.sendmail.step3.deliveroptions":`ตัวเลือกการจัดส่ง`,
"homepage.components.creationtime":`สร้างเวลา`,
"label.pc.ui.2018.ccchat.setting":`การตั้งค่า CCChat`,
"label.knowledge.search.result.highlight":`ไฮไลต์ที่เกี่ยวข้องกับบทความในผลการค้นหา`,
"label.data.downpage.e.title.num2":`2. หากคุณเลือกที่จะส่งออกข้อมูลออบเจ็กต์เดียว คุณต้องเลือกวิธีการส่งออกข้อมูล ได้แก่ การส่งออกแบบกำหนดเอง การส่งออกตามแม่แบบ และแม่แบบการส่งออก`,
"label.field.duplicate.error.msg1":`มีข้อมูลที่ซ้ํากันอยู่ ให้ประมวลผลข้อมูลที่ซ้ํากันก่อนแล้วจึงตั้งค่าคุณสมบัติเฉพาะ`,
"label.campaign.channel.input.number.error":`รูปแบบตัวเลขไม่ถูกต้อง`,
"label.goto.dashboard":`ไปที่แดชบอร์ด`,
"com.cloudcc.login.error.message.invalid.ip":`IP ไม่อยู่ในช่วงการเข้าสู่ระบบ`,
"label.selectnewfieldvalue":`กำหนดค่าฟิลด์ใหม่`,
"label.appointmentdetail.wizard.title11":``,
"Opportunity_Detailed_Phase_Label_Popup_001":`วันที่เข้า`,
"front-dynamiclayout-module-v1-readonly":`ฟิลด์{readonly}ถูกตั้งค่าเป็นฟิลด์แบบอ่านอย่างเดียว`,
"vue_label_calendar_start_field":`ฟิลด์เริ่มต้น`,
"label.weixin.recalculate.shared.failed":`การคำนวณกฎการแบ่งปันออบเจ็กต์ใหม่ล้มเหลว`,
"label.sendmail.step3.dealoptions":`ตัวเลือกการดำเนินการ`,
"setup_layout_label_modifypage":`แก้ไขหน้าเพจ`,
"homepage.components.select.wide":`เลือกส่วนเสริมที่จะแสดงแบบกว้าง`,
"label.import.page1.laststep":`ขั้นตอนก่อนหน้า`,
"label.weixin.donot.permission":`คุณไม่มีสิทธิ์ดําเนินการ`,
"message.error.name.null":`name ไม่สามารถว่างเปล่า!`,
"label.salescloud.teamrole.optionlist":`ค่ารายการตัวเลือกบทบาทกลุ่ม`,
"component_setup_label_titlefield":`ฟิลด์หัวข้อ`,
"vue_label_commonobjects_detail_have_been":`คุณได้`,
"label.textmessage.vonage.setup":`การตั้งค่า Vonage`,
"label.recordtype.profile.enableit":`เปิดการใช้งานโปรไฟล์`,
"UG.product.04":`สร้างผลิตภัณฑ์`,
"label.knowledge.No.related.articles":``,
"label.chat.muted":`ปิดการแจ้งเตือน`,
"registration.page.field.selection":`เลือกฟิลด์หน้าลงทะเบียน`,
"label.project.hit.eleven":`การแจ้งเตือนการมอบหมายปัญหา`,
"lable.newtabpage.advsearch":`ค้นหาขั้นสูง`,
"label.report.share.roleandsub":`บทบาทและผู้ใต้บังคับบัญชาภายใน`,
"component.salesperformance.label.nodata":`เพิ่มโอกาสทางธุรกิจของคุณ จากนั้นกลับมาที่นี่เพื่อดูกราฟผลการดำเนินงาน`,
"label.submitted_on":`วันที่ส่ง`,
"label.file.create.link":`สร้างลิงก์`,
"label.contact":`ผู้ติดต่อ`,
"label.tab.message.failtoopenleft":`ไม่สามารถเปิดการผสานในแถบด้านซ้าย`,
"label.replaces":`แทนที่`,
"label.customcomponent.check.tag.startwith":`ส่วนเสริมต้องขึ้นต้นด้วยป้ายกำกับ< cc:component >`,
"label.tab.web":`แท็บ Web`,
"message.success.task.add":`การบันทึกข้อมูลภารกิจใหม่สำเร็จ`,
"label.chatter.addresser":`ผู้ส่ง`,
"label.mobile.homepage":`หน้าแรก`,
"label.data.imp.su.ok":`ระบบกำลังนำเข้า`,
"label.knowledge.category.hint.one":`กลุ่มหมวดหมู่เป็นโครงสร้างลำดับชั้นของการจัดหมวดหมู่ข้อมูล เช่น กลุ่มหมวดหมู่ที่ชื่อว่า "ตำแหน่งที่ตั้ง" อาจมีรวมถึงลำดับชั้นทางภูมิศาสตร์ของทวีป ประเทศ ภูมิภาค และรัฐ ใช้หน้านี้เพื่อจัดการกลุ่มหมวดหมู่และหมวดหมู่ที่มีอยู่`,
"label.schedulejob.setup.schedule.weekly":`ทุกสัปดาห์`,
"label.tag.manage.description":`ป้ายกำกับทั้งหมดที่เกี่ยวข้องกับ{0}แสดงอยู่ด้านล่าง คุณสามารถเปลี่ยนชื่อหรือลบป้ายกำกับที่มีอยู่`,
"label.tabcontrol":`แท็บ`,
"label.field.duplicate3":`ถือว่า "ABC" และ "abc" เป็นค่าที่ซ้ำกัน (ไม่ไวต่ออักษรใหญ่เล็ก)`,
"label.customsetting.type.list":`รายการ`,
"lable.account.ovdate":`วันที่สิ้นสุดไตรมาสบัญชี`,
"label_chatter_pastSevenday":`7 วันที่ผ่านมา`,
"front-kefu-moudle-v1-lxndxsdb-free":`ติดต่อพนักงานขายของคุณเพื่อเปิดฟังก์ชั่น Seat ฟรี`,
"label.termsforusage":`ข้อกำหนดการใช้งาน`,
"label.forecast.settings.qijian.m":`พยากรณ์รายเดือน`,
"label_tabpage_viewname":`ชื่อมุมมอง`,
"label.report.action.addtodashboard1":`เพิ่มไปยังแดชบอร์ด`,
"label_vue_create_edit_obj_create_event_dialog_desc":`ผู้ใช้ที่ได้รับมอบหมายของคุณมีสิ่งที่ต้องทำในช่วงเวลานี้:`,
"vue_label_report_standardfilter":`ตัวกรองมาตรฐาน`,
"label.umeng.approval.submit":`#applyerส่ง#objเพื่อขออนุมัติ`,
"label.tab.mobile.sign":`ไอคอนสำหรับอุปกรณ์มือถือ`,
"vue_label_commonobjects_detail_check_the_content":`มีข้อผิดพลาดในการทวนสอบ โปรดตรวจสอบเนื้อหาที่กรอก`,
"UG_Campaign_001":`วางแผนแคมเปญ`,
"chatter.group.baseInformation":`ข้อมูลพื้นฐาน`,
"label.sendemail.send.noreceiver":`ไม่มีผู้รับหรือที่อยู่อีเมลของผู้รับว่างเปล่า`,
"template.chart.yskje":`ยอดลูกหนี้`,
"label.textarea":`กล่องข้อความ`,
"vue_label_statistics_value":`ค่าสถิติ`,
"font-evaluate-module-v1-select-img":``,
"label.totalof":`คุณได้เลือกทั้งหมด`,
"label.hangye":`อุตสาหกรรม`,
"label.partner.common.setup":`ตั้งค่าทั่วไป`,
"label.icon.78":`เกษตรกรรม`,
"lable.outlook.detail.addemail":`เพิ่มอีเมล`,
"label.ServiceCloud.fuwuquyu":`ภูมิภาคให้บริการ`,
"label.gb2312encoding":`อักษรจีนตัวย่อ (GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10 นาที`,
"label_emailtocloudcc_reauthorization":`การตรวจสอบใหม่`,
"label.approval.message":`ใส่ความเห็นการอนุมัติได้สูงสุด 1,000 อักษร`,
"label_component_helper":`ผู้ช่วย`,
"label.editRate":`แก้ไขอัตราแลกเปลี่ยน`,
"label.setuptemplate":`แม่แบบกระบวนการอัตโนมัติ`,
"label_emailsync_button_cancel":`ยกเลิก`,
"label.marketseamemset.account.maxuser":`จำนวนลูกค้าสูงสุดของสมาชิก`,
"label.someerror":`ด้วยเหตุผลด้านความปลอดภัย ช่วงเวลาใน CloudCC ของคุณกำลังจะหมดลง <br> <br> คุณต้องการจะเลือกทางใด?`,
"label_person_in_charge":`ผู้รับผิดชอบ`,
"label.visualpage.reference.standard.style":`ใช้รูปแบบมาตรฐานของแพลตฟอร์ม customize-รูปแบบที่กำหนดเอง`,
"errormessage_email_relatedorreceivermusthaveone_z":`เลือกผู้รับและรายการที่เกี่ยวข้องอย่างน้อยหนึ่งรายการ`,
"label.insert.field.empty.continue":`บันทึกที่มีค่า{resDataField}]ว่างเปล่าไม่สามารถสร้างรหัสได้ คุณยังต้องการสร้างต่อไปหรือไม่?`,
"component.newrecords.label.title":`บันทึกล่าสุด`,
"template.detail_info_link":`ลิงก์รายละเอียดข้อมูล`,
"component_setup_tabs_label_default":`ค่าเริ่มต้นหน้า`,
"label.emailobject.template.name.null":`ชื่อแม่แบบอีเมลต้องไม่ว่างเปล่า`,
"label.knowledge.field.changed":`เปลี่ยน {1}`,
"homepage.components.select.narrow":`เลือกส่วนเสริมที่จะแสดงแบบแคบ`,
"label.mobile.phone.week":`สัปดาห์ที่เท่าไหร่`,
"component_chatter_button_like":`ชื่นชอบ`,
"label.brief.won":`ปิดการขายสำเร็จ`,
"label.setup.profile.replaceme":`แทนที่เกี่ยวกับฉัน`,
"label.knowledge.setting.enable.lightning":`เปิดใช้งานคลังความรู้ Lightning`,
"label.middle":`ตรงกลาง`,
"label.icon.109":`คน`,
"vue_label_normal_activity_sf":`กิจกรรม`,
"chatter.poll.option6":`ตัวเลือกที่ 6`,
"label.lanxin.setting":`เชื่อมต่อ มินิแอป H5 Lanxin`,
"label.stdashbord.xsld.business.totals":`สรุปสถานการณ์ทางธุรกิจ`,
"label.emailobject.emaildetail.promptbutton1":`ยืนยัน`,
"Opportunity.Detailed.Phase.Label.001":`สเตจ`,
"label.customcomponent.params.info":`ใช้พารามิเตอร์อย่างไร`,
"label.emailtocloudcc.button.next":`ขั้นตอนถัดไป`,
"front-email-payment-billing-date":``,
"label.ems.with3day":`ภายใน 3 วัน`,
"label.project.subtask.date":`วันที่ของงานย่อยต้องอยู่ในช่วงวันที่ของงาน`,
"label.role.allunselectanduseduser":`ผู้ใช้ที่ไม่ได้รับมอบหมายและเปิดใช้งานทั้งหมด`,
"front-kefu-moudle-yes-wantbuy":``,
"label.looking_for":`คุณพบผลลัพธ์ที่ต้องการหรือไม่?`,
"page.404.label.noresource":`ขออภัย ไม่มีทรัพยากรที่คุณเข้าถึง`,
"vue_label_ccchat_notice_deletecommentcertification":`ยืนยันว่าจะลบความคิดเห็นนี้หรือไม่?`,
"label.data.setok.e.desc1":`หลังจากการส่งออกสำเร็จคุณจะได้รับอีเมลแจ้งเตือนจากระบบ ข้อมูลที่ส่งออกจะถูกบันทึกไว้ชั่วคราวบนเซิร์ฟเวอร์ ระบบจะบันทึกไว้ให้คุณเพียง 48 ชั่วโมงเท่านั้น กรุณาดำเนินการโดยเร็วที่สุด`,
"label.weixin.confirm.delete":`ยืนยันว่าจะลบข้อมูลนี้หรือไม่`,
"A":`กล่องข้อความ (Rich Text)`,
"template.report.sales.cycle":`ระยะเวลาวงจรการขาย`,
"label.service.shift":`กะ`,
"label.visualpage.display.side.bar":`แสดงแถบด้านข้าง false-ไม่แสดงแถบด้านข้าง`,
"label.list.userinterface.chatter.showall":`หน้าแรก CCChat จะแสดงเวยเทียทั้งหมดตามค่าเริ่มต้น`,
"vue_label_systemSettings_set_course":``,
"label.icon.156":`คน`,
"label.marketsea.button.move":`ถ่ายโอน`,
"front-email-payment-select-email":``,
"front-electronic-signature-service-provider":``,
"label.h5.add.checkin":`ลงทะเบียนเข้า`,
"vue_label_amount_total":`ยอดเงินรวม`,
"label.campaign.channel.new":`แคมเปญ: สร้างช่องทางการขาย`,
"label.knowledgebase.restore.creates.draft":`การเรียกคืนจะสร้างฉบับร่างจากเวอร์ชันนี้ คุณต้องเผยแพร่ฉบับร่างเพื่อให้พร้อมใช้งาน`,
"UG_Case_01":`เคส`,
"label.validate.function.funcExplain.CONTAINS":`ตรวจสอบว่าข้อความมีอักขระเฉพาะหรือไม่ ถ้าใช่ส่งกลับค่า TRUE ถ้าไม่ส่งกลับค่า FALSE`,
"label.data.exp.savetemp":`บันทึกเป็นแม่แบบ`,
"front-project-module-v1-template-newcreate":`สร้างโครงการใหม่จากแม่แบบโครงการ`,
"label.field.default.count":`จำนวนแถวเริ่มต้น`,
"page.note.acc":`หมายเหตุและไฟล์แนบ`,
"label.close":`ปิด`,
"label.app.detailbeforeedit":`ด้านล่างนี้เป็นข้อมูลของแอปพลิเคชั่นที่กำหนดเอง คลิกแก้ไข "สามารถเปลี่ยนแปลงแอปพลิเคชันที่กำหนดเองได้"`,
"label.profile.standardfieldsafety":`ความปลอดภัยของฟิลด์ระดับมาตรฐาน`,
"vue_label_report_notice_deletefilter":`กรุณาลบเงื่อนไขตัวกรองขั้นสูงก่อน`,
"label.multilang.datamoveaction.movesuccess":`มีทั้งหมด {0} รายการบันทึกที่โอนย้ายสำเร็จ!`,
"label.emailmerge.edittemplate.descirption":`กรุณาใส่ข้อมูลเกี่ยวกับแม่แบบจดหมายเวียนของคุณ โปรดทราบว่า หมายเหตุที่แสดงใน CloudCC จะไม่ปรากฎใน Word`,
"label.visualpage.at.the.end":`ป้ายกำกับตอนจบ`,
"label.exchange.sync.state":`สถานะ Exchange Sync`,
"label.newdashboardpage.new":`เพิ่มแถวใหม่`,
"label.querydetailservice.profile.notsetup":`ไม่ได้ตั้งค่าโปรไฟล์ที่ตรงกับบัญชีของคุณ`,
"label.escalation.setup.detail.description":`สร้างรายการเกณฑ์เพื่อเลื่อนขั้นเคสโดยอัตโนมัติตามเงื่อนไขที่ระบุไว้ หลังจากนั้นคุณสามารถจัดลำดับใหม่ได้จากหน้านี้`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`ต้องการเปิดใช้งานการสร้างใหม่และการแก้ไข H5 บนอุปกรณ์มือถือหรือไม่`,
"vue_label_file_upload_tip_msg":`ขอแนะนำให้อัปโหลดไฟล์ที่มีขนาดไม่เกิน 30MB มิฉะนั้นอาจทําให้หน้าเว็บโหลดช้า`,
"label.eowechat.epdeptid":`id แผนกวีแชทขององค์กร`,
"label.adminorapprover":`ผู้ดูแลระบบ <strong>หรือ</strong> ผู้อนุมัติที่ได้รับมอบหมายในปัจจุบัน สามารถแก้ไขบันทึกได้ในระหว่างกระบวนการอนุมัติ`,
"label_emailtocloudcc_email":`อีเมล`,
"setup_main2018_label_norole":`คุณไม่มีสิทธิ์ที่เกี่ยวข้องกับการจัดการระบบ`,
"label.onlyone":`เพียงหนึ่งเดียว`,
"label.sso.saml.idp.config.nameidtype":`ประเภทออบเจ็กต์`,
"vue_label_normal_campaign_sf":``,
"label.icon.61":`เครน`,
"label.datatype":`ประเภทข้อมูล`,
"label.mobile.home.page.today.work":`งานของฉัน`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat ชื่นชอบความคิดเห็นของคุณ`,
"chatter.sel.p":`เลือกแล้ว 0 คน`,
"label.b_c":`ความสัมพันธ์จาก B ไป C`,
"label.tabcontrolnameandtaglib":`ชื่อแท็บและป้ายกำกับ`,
"label.globaloperation.tip":`สร้าง แก้ไข และค้นหาการดำเนินการระดับโกลบอลสามารถใช้ได้รับหน้าเพจรายละเอียดข้อมูล`,
"R":`ชนิดบันทึก`,
"label.initcommiteoperate":`เริ่มต้นการเสนอ`,
"front-kefu-moudle-v1-Operation-without0-permission":``,
"button_partner_create":`สร้าง`,
"label.document.name.length.cannot.than":`ความยาวของชื่อไฟล์ต้องไม่เกิน 255`,
"label.area.donot.delete":`ไม่สามารถลบภูมิภาคได้เนื่องจากมีภูมิภาคย่อย`,
"label.currency.activation":`เปิดใช้งาน`,
"label.connect":`&เชื่อมต่อ`,
"button.partner.viewdetail":`ดู`,
"setup_object_field_dependency_label_mustsetup":`กรุณาตั้งค่าการพึ่งพาของฟิลด์ก่อนแล้วค่อยบันทึก`,
"label.SalesCommitmentKanBan.task":`จำนวนภารกิจ`,
"lable.quote.syncing.finishbutton":`เสร็จสิ้น`,
"label.weixin.group.type":`ประเภทการเข้าถึง`,
"vue_label_commonobjects_detail_relationship":`ระดับความสัมพันธ์`,
"vue_label_email_cc":`สำเนาลับ`,
"setup.object.field.dependency.label.fieldvalueoptions":`ตัวเลือกค่าฟิลด์`,
"label.sso.lookAtTheKey":`ดูคีย์`,
"UG.opportunity.008":`ทีมโอกาสทางธุรกิจ`,
"label.customfields.new.step1":`ขั้นตอนที่ 1. เลือกประเภทฟิลด์`,
"lable.qrcodeOrbarcode.rule":`สร้างกฎรหัสคิวอาร์/บาร์โคด`,
"vue_label_notice_nopermission_delete":`ขออภัย คุณไม่มีสิทธิ์ลบข้อมูลนี้ โปรดติดต่อผู้ดูแลระบบ`,
"label.customerobj.tab":`แท็บออบเจ็กต์ที่กำหนดเอง`,
"com.cloudcc.login.error.message.nolicens":`ไม่มีสิทธิ์การใช้งาน`,
"label.sendsms.batch.confirm":`ส่งข้อความสั้นแบบกลุ่ม: ยืนยัน`,
"label.forecast.settings.sos":`รายได้และจำนวน`,
"label.calendar.addevent.notice.opencalendarfirst":`กรุณาเปิดปฏิทินของฉันหรือปฏิทินอื่นก่อนเพิ่มอิเวนต์`,
"message.success.task.phonerecord":`ภารกิจบันทึกการโทรสำเร็จ`,
"label.knowledgebase.create.new.subtab":`แท็บย่อยใหม่`,
"label.knowledge.article.recordid":`id บทความความรู้ต้องไม่ว่างเปล่า`,
"Opportunity.Detailed.Phase.Label.Popup.003":`จำนวนวันที่อยู่ในสเตจ`,
"homepage.layout.nowpage":`เค้าโครงเพจปัจจุบัน`,
"template.chart.khslph":`การจัดอันดับจํานวนลูกค้า`,
"front-epwechat-module-v1-android-single":`SSO ของ Android：`,
"serviceresource.assignedresource.islacksr.lack":`ไม่สามารถลบทรัพยากรบริการได้เนื่องจากมีการกำหนดทรัพยากรบริการให้กับการนัดหมายการบริการ คุณไม่จำเป็นต้องเปิดใช้งานทรัพยากรบริการนี้`,
"label.email.only.display.info":`ในกรอบด้านล่างจะแสดงเฉพาะผู้ติดต่อหรือเพื่อนร่วมงานที่บันทึกที่อยู่อีเมลไว้เท่านั้น`,
"label.weixin..xsld.yjhtje":`จำนวนเงินในสัญญาโดยประมาณ`,
"label.permission.delete.permsets.error.prompt":`ชุดสิทธิ์นี้มีผู้ใช้ ไม่สามารถลบได้!`,
"label.ccchat.enter.two.choices":`กรุณากรอกอย่างน้อย 2 ตัวเลือก`,
"label.edit.field.select.style2":`เลือกครั้งละ 1 บรรทัด`,
"vue_label_email_please_enter_email_subject":`กรุณาใส่หัวเรื่องอีเมล`,
"batch.sendemail.f":`การส่งอีเมลล้มเหลว`,
"label.sms.senderr":`การส่งข้อความสั้นล้มเหลว`,
"label.batchadd.newbatchpage.save.em":`รูปแบบอีเมลไม่ถูกต้อง`,
"label.icon.96":`วงเวียน`,
"message.recordtype.deleterecord.tip":`ใช้หน้านี้เพื่อแทนที่ชนิดบันทึกที่มีอยู่ทั้งหมดด้วยชนิดบันทึกใหม่ โดยเลือกชนิดบันทึกใหม่จากกล่องด้านล่าง  หากคุณต้องการลบชนิดบันทึกที่มีอยู่ทั้งหมดโดยไม่แทนที่ โปรดเลือกไม่มี"`,
"label.field.edit.max":`คะแนนสูงสุด`,
"label.partnerCloud.orderingPlatform.preferential":`ส่วนลด`,
"label.callcenter.login.later":``,
"batch.change.owner":`โปรดเลือกเจ้าของ`,
"label.version.allow.upload.size":`ขนาดไฟล์สูงสุดที่อนุญาตให้อัปโหลดคือ`,
"setup.mainpage.label.welcome17":`การตั้งค่าสิทธิ์`,
"label.tag.sectionname":`ข้อมูลป้ายกำกับ`,
"label_partner_workspace_setup":`ตั้งค่า`,
"label.managecontrol":`จัดการสิทธิ์`,
"label.timetrigger.condition":`เงื่อนไขการประเมินจะถูกตั้งค่าทุกครั้งที่สร้างหรือแก้ไขบันทึก`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`สัปดาห์`,
"front-verkoop-bywerking-error":``,
"label.allowcommittercallback":`อนุญาตให้ผู้เสนอปรับเปลี่ยนคำขออนุมัติ`,
"vue_label_commonobjects_detail_lead_finishistatus":`ทำเครื่องหมายสถานะว่าสำเร็จ`,
"message.error.object.lookupmd":`ออบเจ็กต์ได้สร้างความสัมพันธ์แบบข้อมูลหลัก-ข้อมูลรอง`,
"label.stdashbord.xsld.business.img7":`ความน่าจะเป็นของจำนวนในสเตจ 0% / (ความน่าจะเป็นของจำนวนในสเตจ 100%    ความน่าจะเป็นของจำนวนในสเตจ 0%)`,
"label.checkruleofevent":`เกณฑ์การทวนสอบอิเวนต์`,
"front-epwechat-module-v1-single":`SSO`,
"label.tabpage.save":`บันทึก`,
"label_emailtocloudcc_search":`ค้นหา`,
"label.tianyancha.h5.registeredPlace":`สถานที่ลงทะเบียน (อักษรย่อ)`,
"label.field.addoptionlist":`เพิ่มค่ารายการตัวเลือก：รายการตัวเลือก`,
"label.schedule_anotherpost":`วางแผนโพสต์อื่นๆ`,
"label.customfields.searchrelation.tip":`สร้างความสัมพันธ์ที่เชื่อมโยงออบเจ็กต์นี้กับออบเจ็กต์อื่น ฟิลด์ความสัมพันธ์อนุญาตให้ผู้ใช้คลิกไอคอนค้นหาเพื่อเลือกค่าจากรายการเลือกแบบผุดขึ้น ออบเจ็กต์อื่นคือแหล่งที่มาของค่าในรายการ`,
"label.partnerCloud.partnerAccount.prepaidPhone":`เติมเงินเข้าบัญชี`,
"label.projectManagement.view.details":`ดูรายละเอียด`,
"label.sendemail.chat.praiseFeed":`#nameที่เคารพ:\n\n    สวัสดี！#userNameกดชื่นชอบเวยเทียของคุณ`,
"label.validate.function.category.Text":`ข้อความ`,
"component.task.label.newevent":`ภารกิจใหม่`,
"label.data.import.setup.operate":`หากพบบันทึกที่มีอยู่ คุณอยากจะดำเนินการอย่างไร?`,
"label.salescloud.salesdashboard.clear.option":`ล้างตัวเลือก`,
"lable.account.PreviousCY":`สองปีปฏิทินแรก`,
"label.appointment.wizard.subtitle8":``,
"label_emailsync_status_viewlog":`ดูล็อก`,
"message.duplication.label.filtertitle":`ตัวกรองซ้ำ`,
"label.custom.quarter.description":`หน้านี้ช่วยให้คุณกำหนดบันทึกไตรมาสเองได้ วันที่ของไตรมาสที่กำหนดเองจะถูกสร้างตามที่คุณเลือกด้านล่าง`,
"label_tabpage_filenamez":`ชื่อไฟล์`,
"lable.currencyAdv.andbefordate":`และวันที่ก่อนหน้า`,
"label.version.nonsupport.sharerule":`ไม่รองรับกฎการแบ่งปัน!`,
"front-epwechat-module-v1-unbound":`ไม่ผูก`,
"label.division":`แผนก`,
"label.data.import.setup.repeat":`คุณต้องการป้องกันการสร้างบันทึกซ้ำหรือไม่?`,
"label.callcenter.makesure.Amazon.connect":``,
"label.version.lead.control":`การจัดการลีด`,
"label.copying.reward.groups":`คัดลอกกลุ่มบรรทัดใบเสนอราคา`,
"#label.severalorone":`ไฟล์บีบอัดหรือไฟล์เดี่ยว#`,
"label.mailinginfo":`ที่อยู่ทางไปรษณีย์`,
"component.telerecord.label.title":`บันทึกการโทร`,
"label.godocumentlist":`ย้อนกลับไปยังรายการเอกสาร`,
"APPIntegration.Dropbox.setting.01":`เปิดการใช้งาน`,
"label.tianyancha.website":`เว็บไซต์`,
"label_tabpage_greaterequalz":`มากกว่าหรือเท่ากับ`,
"vue_label_campaign_influencedopportunity":`กระทบต่อโอกาสทางธุรกิจ`,
"message.save.param.null":`พารามิเตอร์ว่างเปล่า การบันทึกล้มเหลว`,
"front-epwechat-module-v1-domain":`ชื่อโดเมนที่เชื่อถือได้ - JS-SDK:`,
"label.allowreport":`อนุญาตรายงาน`,
"label.service.major.event":`อิเวนต์สําคัญ`,
"label.import.index.selectobjectandfiles":`เลือกออบเจ็กต์และไฟล์`,
"label.chatter.task":`ภารกิจ`,
"label.knowledge.setting.hint.twelve":`ป้อนประเภทข้อมูล`,
"lable.account.CurrentandPreviousFY":`ปีงบประมาณนี้และปีงบประมาณก่อนหน้า`,
"label.martrixreport.step3":`ขั้นตอนที่ 3: เลือกข้อมูลที่ต้องการสรุป`,
"front-console-select-cases":``,
"label.partnerCloud.partnerAccount.backHome":`กลับไปที่หน้าแรก`,
"label.me.assign":`ที่ฉันมอบหมาย`,
"label.appointment.wizard.subtitle3":``,
"label.edit_columns":`แก้ไขคอลัมน์`,
"label.partnerCloud.orderingPlatform.useRebates:":`ใช้เงินคืน:`,
"label.projectManagement.enter.up.to.10.digits":`ป้อนได้สูงสุด 10 หลัก`,
"label.integrations.description.mailchimp":`CloudCC เชื่อมต่อกับ MailChimp หลังจากที่คุณนำเข้าลีดและผู้ติดต่อในระบบไปยัง MailChimp คุณจะสามารถส่งอีเมลทุกประเภทแบบกลุ่มไปยังผู้รับที่กำหนดได้ และคุณยังสามารถดูสถิติของอีเมลใน MailChimp ได้อีกด้วย`,
"label.ccchat.person.error.requiredomain":`ข้อผิดพลาด: ต้องมีอย่างน้อยหนึ่งโดเมน`,
"label.projectManagement.Pleaseselectitem":`โปรดเลือกโครงการ`,
"label.netaccess":`การเข้าถึงเครือข่าย`,
"vue_label_SMS_searchobject":`ค้นหาออบเจ็กต์`,
"label.role.viewintree":`แสดงในมุมมองแผนภูมิต้นไม้`,
"lable.SalesCommitmentKanBan.accountName":`ชื่อลูกค้า`,
"label.please.contact.your.administrator":`กรุณาติดต่อผู้ดูแลระบบเพื่อเปิดใช้งานการสร้างกฎรหัสคิวอาร์/บาร์โคด`,
"label.sso.saml.sp.idenitysource":`ตำแหน่งข้อมูลประจำตัว SAML`,
"label.queue.delete":`ลบ`,
"label.service.miniProgram.jumpLink":`Jump link`,
"label_set_ forecast_scope":`ตั้งค่าช่วงการพยากรณ์`,
"label.weixin.success.sign":`โปรดทราบ ลงทะเบียนเข้างานสำเร็จ`,
"front-dialog-module-v1-error-code":`รหัสข้อผิดพลาด`,
"label.projectManagement.nodata.problem":`เยี่ยม ไม่มีปัญหายุ่งยากที่ต้องแก้ไข`,
"label.myhomepage":`หน้าแรกของฉัน`,
"label.exchange.sync.state.task.m1":`ซิงค์ครั้งล่าสุด:`,
"label.pw.config":`กรุณากรอกยืนยันรหัสผ่าน`,
"front-console-new-contact":``,
"label.customfields.fielddependency.editexplain":`<li>ดับเบิลคลิกที่เซลล์เพื่อเปลี่ยนการมองเห็นของค่าฟิลด์ควบคุมที่หัวแถว</li><li>หากต้องการเปลี่ยนหลายเซลล์พร้อมกัน กรุณาเลือกเซลล์เพิ่ม จากนั้นคลิกปุ่มรวมค่า "หรือปุ่ม "ลบค่า" จะสามารถเปลี่ยนการมองเห็นเซลล์ที่เลือกทั้งหมดพร้อมกัน</li><li>กด Shift ค้างไว้เพื่อเลือกชุดเซลล์ที่อยู่ติดกัน และกด Ctrl ค้างไว้เพื่อเลือกเซลล์ที่ไม่ได้อยู่ติดกัน</li><li>ใช้ปุ่ม"แสดงตัวอย่าง"เพื่อทดลองดูผลลัพธ์ </li>"`,
"setup_mainpage_label_welcome7":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้→การตั้งค่าแอปพลิเคชัน→สร้าง→ออบเจ็กต์→ชื่อออบเจ็กต์→ฟิลด์ที่กำหนดเอง`,
"message.validation.sum":`เค้าโครงหน้าอนุมัติแสดงฟิลด์มากเกินไป สามารถแสดงได้มากที่สุด 190 ฟิลด์`,
"label.knowledge.attach.case":``,
"front-electronic-signature-custom-field-type":``,
"vue_label_pricebook_activated":`เปิดใช้งานสมุดราคาแล้ว`,
"vue.schedule.pre":`นี่คือตารางเวลาของฉัน โปรด`,
"Lead_Tools_BatchScoring":`การให้คะแนนลีดแบบกลุ่ม`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`กรองโดย`,
"label.report.no.recently":`ไม่มีบันทึกล่าสุด`,
"label.service.gantt.dangerous.sum":`จำนวนการนัดหมายการบริการที่อยู่ในอันตราย`,
"label.main.field":`ฟิลด์หลัก`,
"label.weixin.optionfive":`ตัวเลือกที่ห้า`,
"homepage.wide":`คอลัมน์กว้าง (คอลัมน์ด้านขวา)`,
"vue_label_notice_confirmdelatehomepage":`ยืนยันว่าจะลบหน้าแรกหรือไม่?`,
"vue_label_report_exportpages":`จำนวนหน้าที่ส่งออก：ที่`,
"label.select_compaign":`เลือกแคมเปญ`,
"attachment.button.massdownload":`ดาวน์โหลดเป็นชุด`,
"label.chatter.incident":`อิเวนต์`,
"label_partner_new_step1":`ขั้นตอนที่ 1: เลือกแม่แบบที่คุณชอบ`,
"button.partner.workspace.saveas.memo":`บันทึกพาร์ทเนอร์คลาวด์ปัจจุบันเป็น "แม่แบบ"`,
"vue_label_pricebook_edit":`แก้ไขสมุดราคา`,
"label.weixin.privacy.rights":`สิทธิ์ที่เกี่ยวข้องกับความเป็นส่วนตัว: ตำแหน่งโดยประมาณ (ตามเครือข่าย); ตำแหน่งที่แม่นยำ (GPS)`,
"label.please.codeType":`กรุณาเลือกประเภทรหัส`,
"label.approveorrefuserequest":`อนุมัติ/ปฏิเสธคำขอ`,
"message.error.sharemember":`sharemember ที่ส่งผ่านไม่สามารถว่างเปล่า โปรดตรวจสอบพารามิเตอร์ที่ส่งผ่าน!`,
"label.file.folder.edit":`แก้ไขโฟลเดอร์`,
"label.data.import.setup.repeat.yes":`ใช่ - ห้ามสร้างบันทึกซ้ำ หมายเหตุ: หากคุณต้องการอัปเดตบันทึกที่มีอยู่ ต้องเลือกตัวเลือกนี้`,
"label.approveBeforeTheOperation":`การดำเนินงานก่อนการอนุมัติ`,
"vue_label_file_already_checked_file":`เลือกแล้ว {checkedWork} ไฟล์ และเพิ่มครั้งละไม่เกิน 10 ไฟล์`,
"vue_label_hidden_record_count":`ซ่อนจํานวนบันทึก`,
"UG_product_01":`แสดงรายการผลิตภัณฑ์/บริการ`,
"label.tabpage.clearoptionsz":`ล้างตัวเลือกขั้นสูง`,
"label.partnercloud.num.overstep":`เกินจำนวนสูงสุดของคลาวด์พาร์ทเนอร์`,
"label.tianyancha.businessverify.msg8":`ปัจจุบันฟังก์ชันนี้รองรับการสืบค้นเฉพาะธุรกิจที่มีที่อยู่จดทะเบียนในจีนแผ่นดินใหญ่เท่านั้น และมีความล่าช้าที่เหมาะสม`,
"Lead_Scoring_DetailedPage_Popup_Title":`ข้อมูลเชิงลึกของลีด`,
"label.emailtocloudcc.email":`อีเมล`,
"vue_label_pool_highcost":`ต้นทุนผลิตภัณฑ์สูง`,
"label.callcenter.enterprise.configuration":`โปรดคัดลอกคู่กุญแจในการตั้งค่าองค์กร - การเชื่อมต่อระบบในระบบเทียนรุ่น`,
"label.view.edit.search.prompt":`กรุณาใส่คีย์เวิร์ด`,
"label.ems.sms":`ส่งข้อความสั้น`,
"label.emailobject.list.new":`เขียนอีเมล`,
"label.salescloud.forenableteamsales":`เปิดใช้งานการขายแบบทีม`,
"pagecreator.systemstyle.funcpath":`/ตัวสร้าง/ไลบรารีรูปแบบแบรนด์`,
"label.partnerCloud.basicSetting.domain":`ชื่อโดเมนระดับบนสุดต้องไม่ว่างเปล่า`,
"label.projectManagement.Posttask":`งานถัดไป`,
"label.tianyancha.businessverify":`เปิดใช้งานการทวนสอบข้อมูลธุรกิจ`,
"label.tianyancha.h5.info":`ข้อมูลพื้นฐาน`,
"september":`เดือนกันยายน`,
"chatter.poll.option9":`ตัวเลือกที่ 9`,
"label.department.firstpage":`หน้าแรกแล้ว`,
"label.reportsSubscriptionPage.condition.button":`เพิ่มเงื่อนไข`,
"label.exchange.sync.state.task":`ภารกิจ`,
"pagecreator.layout.button.splitall":`แยกทั้งหมด`,
"vue_label_calendar_please_select_the_start":`กรุณาเลือกฟิลด์เริ่มต้น`,
"label.tab.message.failtogettop":`การรับแท็บด้านบนล้มเหลว`,
"label.sharerule.organizationscopesetshare":`การตั้งค่าการแบ่งปันเริ่มต้นในองค์กร`,
"label.delete.rules":`ลบกฎ`,
"label.recordtype.tabname.detail":`ใช้ปุ่ม "แก้ไข"เพื่อเปลี่ยนคุณสมบัติของชนิดบันทึกนี้ ใช้ลิงก์ "แก้ไข" ในรายการที่เกี่ยวข้องกับ "ค่ารายการตัวเลือก" เพื่อเลือกค่ารายการตัวเลือกที่มีอยู่สำหรับบันทึกชนิดนี้`,
"label.knowledge.setting.hint.ten":`ไม่แน่ใจว่าว่าจะจัดระเบียบอย่างไร? ไม่มีปัญหา คุณสามารถทําในภายหลังได้`,
"vue_label_norm_undone":`การดำเนินการนี้ไม่สามารถยกเลิกได้`,
"label.trigger.line":`บรรทัด:`,
"lable.info.queue.reason":`เหตุผลของการเป็นสมาชิก`,
"label.validate.function.funcExplain.HOUR":`ส่งกลับชั่วโมงในฟิลด์วันที่/เวลา ซึ่งเป็นตัวเลขระหว่าง 0 ถึง 11`,
"label.update.document.content":`แก้ไขเนื้อหาเอกสารแล้ว`,
"lable.Existing.template":`แม่แบบที่มีอยู่`,
"label.summaryreport.step3":`ขั้นตอนที่ 3: เลือกวิธีจัดกลุ่มข้อมูลสรุป`,
"label.emailmerge.list.filetype":`ประเภทไฟล์`,
"label.customfields.helptext.tip":`เมื่อผู้ใช้วางเมาส์เหนือไอคอนข้อมูลถัดจากฟิลด์นี้ ข้อความนี้จะแสดงในหน้ารายละเอียดและหน้าแก้ไข`,
"label.setting.intergrationlist.description":`ด้วยการเชื่อมต่อที่แม่นยำ คุณสามารถดูและแบ่งปันข้อมูลระหว่างแอปพลิเคชันทางธุรกิจได้โดยไม่ต้องออกจาก CRM การเชื่อมต่อบางแอปพลิเคชัน เช่น QuickBooks และ Zapier จำเป็นต้องได้รับการอนุญาตที่เกี่ยวข้องก่อนที่ผู้ใช้จะสามารถใช้งานได้ การเชื่อมต่อบางแอปพลิเคชัน เช่น Gmail, Outlook เป็นต้น ผู้ใช้แต่ละคนสามารถกำหนดค่าได้ในบัญชีของตนเอง`,
"component_milestones_label_title":`ไมล์สโตน`,
"label.custom.AntiRevocation":`คืนค่าล่าสุด`,
"label.mobile.app.new.task":`ต้องการเปิดใช้งาน App อิเวนต์และภารกิจรุ่นใหม่บนอุปกรณ์มือถือหรือไม่`,
"vue_label_opportunity_related_chooseproduct":`เลือกอย่างน้อยหนึ่งผลิตภัณฑ์`,
"label.standardguest":`ผู้มาเยือนมาตรฐาน`,
"label.icon.125":`เครื่องมือ`,
"label.skipsomeset":`CloudCC จะเลือกการตั้งค่าให้คุณโดยอัตโนมัติเพราะนี่คือตัวช่วยเริ่มต้นทันใจ`,
"label.forecast.shrepage.fmanager":`ผู้จัดการการพยากรณ์`,
"label.mobile.quickcreate.default.work":`ทำงาน`,
"label.projectManagement.nodata.team.members":`ไม่พบสมาชิกโครงการของฉัน`,
"label_social_media_account_settings":`การตั้งค่าบัญชีโซเชียลมีเดีย`,
"UG.quota.05":`การซิงค์โอกาสทางธุรกิจแบบสองทาง`,
"label.partner.workspace.tab.selectedoption":`แท็บที่เลือก`,
"front-kefu-moudle-v1-clientID-reinput":`กรุณาใส่ clientID`,
"label.mobile.home.page.contract.value":`มูลค่าสัญญาโดยประมาณ`,
"december":`เดือนธันวาคม`,
"label.campagin.roi.dcrs":`จำนวนผู้เข้าร่วม`,
"label.currency.edits":`การแก้ไขสกุลเงิน`,
"label.currency.company":`สกุลเงินของบริษัท`,
"label.customfields.newformula.nogrammererror":`นิพจน์ไม่มีข้อผิดพลาดทางไวยากรณ์`,
"label.version.nonsupport.api":`ไม่มี API อินเทอร์เฟซที่รองรับ`,
"label.data.file.i.title.num2":`2. แนะนำให้ส่งออกก่อนนำเข้า และใช้เอกสารที่ส่งออกเป็นแม่แบบเพื่อจัดระเบียบข้อมูลที่นำเข้าจากนั้นจึงนำเข้า (หากข้อมูลที่นำเข้ามีเครื่องหมายจุลภาคโปรดใช้สัญลักษณ์ "@" แทน)`,
"front-console-conversation-title":``,
"front-kefu-moudle-call":``,
"vue_label_systemSettings_pagefooter":`การตั้งค่าส่วนท้าย`,
"label.newRule.successfully.added":`เพิ่มกฎเรียบร้อยแล้ว`,
"label.trigger.direction.for.use":`คำแนะนำการใช้ทริกเกอร์แพลตฟอร์ม [รุ่น 2.0]`,
"label.instrumentPanel.maxLabelname":`ค่าควรมากกว่าค่าต่ำสุด ค่าเบรกพอยต์ 1 และค่าเบรกพอยต์ 2`,
"label.same.month.report":`รายงานอัตราการเติบโต`,
"label.knowledge.language.american":`ภาษาอังกฤษแบบอเมริกัน`,
"label.paging.totalof":`ทั้งหมด {0} รายการ`,
"label.tianyancha.businessverify.enable.error":`การเปิดใช้งานการทวนสอบข้อมูลธุรกิจล้มเหลวใช่หรือไม่ กรุณาติดต่อผู้ดูแลระบบ !`,
"vue_label_commonobjects_detail_email_template":`ใช้แม่แบบอีเมล`,
"message.error.save.failed":`บันทึกล้มเหลว!`,
"advancedoptions":`ตัวเลือกขั้นสูง`,
"setup_object_layout_message_selectedlayoutandrecordtype":`กรุณาเลือกเค้าโครงและชนิดบันทึก`,
"label.sendemail.recycle.operatesuccess":`การล้างถังขยะรีไซเคิลสำเร็จแล้ว ข้อมูลทั้งหมด #size รายการถูกลบ!`,
"J":`กล่องข้อความ (ยาว)`,
"message.validation.isnotmail":`กรอกที่อยู่อีเมลที่ถูกต้อง`,
"label.timetrigger.before.lasttime":`ก่อนเวลาแก้ไขล่าสุด 1 ชั่วโมง`,
"label.tabpage.arecordtypez":`ชนิดบันทึกพร้อมใช้`,
"label.reportoption":`ตัวเลือกรายงาน`,
"pagecreator.button.next":`ขั้นตอนถัดไป`,
"assetbom.transferowner.notpermission":`โปรดติดต่อผู้ดูแลระบบ คุณไม่มีสิทธิ์โอน BOM สินทรัพย์`,
"label.toptitle.lightning":`เมนู Lightning`,
"label.copy.target":`คัดลอกค่าเป้าหมาย`,
"label.productsales.oppor.approach":`โอกาสทางธุรกิจที่กำลังจะมาถึง`,
"label.email.template.select":`โปรดเลือกแม่แบบอีเมล`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`ต้องกรอกขอบเขตล่างของส่วนลดที่แก้ไขทุกขั้น`,
"label.tabularreport.step3":`ขั้นตอนที่ 3: กําหนดลําดับของคอลัมน์ในรายงาน`,
"label.multilang.cchttpservice.signin":`{0}ที่เคารพ โปรดทราบ แขกทั้งหมด{2}ที่คุณเชิญเข้าร่วมกิจกรรม{1}ได้ลงทะเบียนเข้างานเรียบร้อยแล้ว`,
"label.appexchange.uninstallpage.message3":`ลบข้อมูลทั้งหมดที่สร้างขึ้นสำหรับออบเจ็กต์แบบกำหนดเองทั้งหมดในโปรแกรมสำเร็จรูปนี้แบบถาวร`,
"label_tabpage_ownedz":`แบ่งปัน`,
"label.tabularreport.2018.step2":`ขั้นตอนที่ 2: เลือกมาตรฐานการรายงาน`,
"label.object":`ออบเจ็กต์`,
"template.report.contracted.customers":`การวิเคราะห์อุตสาหกรรมของลูกค้าตามสัญญา`,
"label.field.remark3":`โปรดทราบว่า หากลบฟิลด์ที่กำหนดเองบางฟิลด์จะลบตัวกรองที่ใช้กับฟิลด์ที่กำหนดเองนั้นทั้งหมด และยังอาจเปลี่ยนแปลงผลของเกณฑ์การมอบหมายหรือเกณฑ์การเลื่อนขั้นที่อาศัยข้อมูลของฟิลด์ที่กำหนดเองนั้นด้วย`,
"label.eventview.issms":`แจ้งเตือนข้อความสั้นหรือไม่`,
"label.knowledge.language.brazilian":`ภาษาโปรตุเกส (บราซิล)`,
"vue_label_norm_viewfilter":`การกรองมุมมอง`,
"label.forecast.settings.qijian":`ช่วงเวลาการพยากรณ์`,
"label.startuploadfile.step.intruduce":`คลิกปุ่ม "เลือกไฟล์" เพื่อค้นหาไฟล์และไฟล์ที่เลือกจะแสดงด้านล่าง`,
"label.smstemplate":`แม่แบบข้อความสั้น`,
"vue_label_chatter_no_permission":`คุณไม่มีสิทธิ์ดูไฟล์นี้`,
"label.callcenter.Incorrect.data.filling":``,
"label.tag.search.button":`กรองตามป้ายกำกับ`,
"label.multiplyselectoptions":`กล่องกาเครื่องหมาย`,
"lable.outlook.detail.mutual":`ซิงค์ทั้งสองทาง`,
"label.workflow.estimatecondition1":`เมื่อสร้างหรือแก้ไขบันทึกและไม่สอดคล้องกับเงื่อนไขกฎก่อนหน้านี้`,
"label.validate.globalvariable.user.profileId":`ID โปรไฟล์`,
"UG.Campaign.003":`สร้างแคมเปญ`,
"label.validate.function.funcExplain.ISNULL":`ตรวจสอบนิพจน์ว่าว่างเปล่าหรือไม่ (ว่างเปล่า) ถ้าใช่จะส่งกลับค่า TRUE (จริง) ถ้าหากมีฟังก์ชันจะส่งกลับค่า FALSE (เท็จ)`,
"label.setting.intergrationlist.status0":`สถานะการเชื่อมต่อ`,
"label.copy_error":`คัดลอกล้มเหลว`,
"label.connectOtherNone":`ออบเจ็กต์ที่เลือกไม่มีออบเจ็กต์ที่สามารถเชื่อมโยงเพิ่มเติมได้`,
"label.bmap.beijing":`ปักกิ่ง`,
"front-kefu-moudle-v1-hxzxybsc-again":`Easemob  Seat ถูกลบ โปรดเชื่อมต่ออีกครั้ง!`,
"label.wei.pollsubject":`หัวข้อแบบสำรวจ`,
"APPIntegration_Social_twittererror":`ต้องเป็น URL ของ twitter.com ที่ถูกต้องตามกฎหมาย`,
"label.appupload.install.apicannotuse":`ชื่อ api ยังไม่สามารถใช้งานได้`,
"label.returntolist":`กลับไปที่รายการ`,
"label.translation.start2":`เลือกส่วนเสริมการตั้งค่า`,
"lable.edit.queue.alter":`โปรดเลือกออบเจ็กต์ที่รองรับคิว`,
"label.campaign.channel.step3":`ขั้นตอนที่ 3: การเลือกฟิลด์หน้าการลงทะเบียนของช่องทางการขาย`,
"label.data.newtemplate.e.seltype":`เลือกวิธีการส่งออกข้อมูล`,
"front-kefu-moudle-hangup":``,
"label.forecast.forecastroleuserpage.shre.managerandother":`ผู้ดูแลระบบและผู้จัดการการพยากรณ์สามารถแบ่งปันการพยากรณ์ได้`,
"label.knowledgebase.mark.as.new.version":`ติดป้ายว่าเวอร์ชันใหม่`,
"label.conditiontag.lookup":`ค้นหา`,
"label.import.page3.importsucceed":`การนำเข้าสำเร็จ`,
"label.stdashbord.xsld.condtion":`ตั้งค่าเงื่อนไข`,
"label_emailtocloudcc_redmessage10":`ข้อมูลหมดอายุแล้ว โปรดลงชื่อเข้าใช้อีกครั้ง`,
"label.event.moveup.1hour":`ล่วงหน้า 1 ชั่วโมง`,
"label.chat.topic.page.add.favorite":`บันทึกเป็นรายการโปรดในหน้าแรก CCChat`,
"label.icon.88":`ปรึกษา`,
"page_404_label_noresource":`ขออภัย ไม่มีทรัพยากรที่คุณเข้าถึง`,
"label.quickbooks.refresh":`รีเฟรช`,
"front-kefu-moudle-which-getphone-case":``,
"label.objecttab.edit":`แก้ไขแท็บออบเจ็กต์`,
"label.data.file.the.trigger":`ดำเนินการทริกเกอร์`,
"frame.personinfo.label.personimage":`รูปโปรไฟล์`,
"label_tabpage_turnoffsz":`ปิด-ข้ามสเตจแล้ว`,
"label.sendmail.batch.chose":`ส่งอีเมลแบบกลุ่ม: เลือกผู้รับ`,
"label.data.downpage.i_title":`ขั้นตอนการนำเข้าข้อมูล:`,
"label.recycle.clearconfirm":`ยืนยันว่าต้องการล้างหรือไม่?`,
"chatter.using":`ใช้ที่นี่`,
"label.batchadd.newbatchpage.list":`รายการข้อมูลใหม่จำนวนมาก`,
"pagecreator.systemstyle.button.new":`รูปแบบใหม่`,
"label.notification.serviceappointment.changestate":`{1}{0}สถานะเปลี่ยนเป็น{2}{3}`,
"label.weixin.weipollname":`ชื่อเวยโพล`,
"label.tabpage.skip":`ข้าม`,
"label.edit.field":`แก้ไขฟิลด์`,
"label.edit.new.rule":`แก้ไขกฎการสร้าง`,
"label.approved.receiveApprovalEmail":`ยอมรับคำขออนุมัติอีเมล`,
"label.dashboard.refreshNow":`รีเฟรสทันที`,
"label.lookup.introduce":`ค้นหาแบบฟัซซี่ด้วยอักขระ`,
"homepage.components.newdes":`โปรดตรวจสอบให้แน่ใจว่ารูปแบบรหัส HTML ที่ป้อนด้านล่างถูกต้อง รหัส HTML ไม่เหมาะสมที่เขียนในส่วนเสริมอาจทำให้แท็บทั้งหมดของหน้าแรกไม่สามารถแสดงข้อมูลที่ถูกต้องได้`,
"label.role.giveuserrole":`กำหนดบทบาทให้ผู้ใช้`,
"lable.opppdt.selPbk.subtitle":`สมุดราคาของ`,
"setup_mainpage_label_welcome19":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าการจัดการ → จัดการผู้ใช้ → ผู้ใช้ บทบาท โปรไฟล์`,
"setup.mainpage.label.welcome22":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าการจัดการ → แม่แบบการสื่อสาร → แม่แบบอีเมล`,
"label.tianyancha.h5.zipcode":`รหัสไปรษณีย์`,
"label_tabpage_allapplications":`แอปพลิเคชันทั้งหมด`,
"label.chatter.like":`ชื่นชอบ`,
"label.licence.noremainder":`จำนวนใบอนุญาตที่เหลืออยู่ไม่เพียงพอ`,
"lable.outlook.edit.dataset":`การตั้งค่าข้อมูล`,
"D":`วันที่`,
"label.detail":`ดู`,
"label.globaloperation.operationtype.custom_page":`เพจที่กำหนดเอง`,
"label.addattachment.down":`ดาวน์โหลดไฟล์`,
"label.data.exportall.all_btn":`ส่งออกข้อมูลทั้งหมด`,
"label.recordtypeselect.current":`ชนิดบันทึกปัจจุบัน`,
"label.tabpage.entercusnamez":`กรุณาใส่ชื่อลูกค้า`,
"label.location.valunit.km":`กิโลเมตร`,
"label.mobile.phone.week.plan":`แผนของสัปดาห์หน้า`,
"vue_label_report_everyday":`ทุกวัน`,
"label.weixin.broadcasting":`กำลังส่ง...`,
"label.input.search.string":`กรุณาใส่สตริงของการค้นหา`,
"label.picandreporttype":`ประเภทแผนภูมิ`,
"label.setmulti":`หลายรายการ`,
"label.visualpage.component.t":`ใช้ส่วนเสริม component`,
"label.knowledge.designate":`สามารถกำหนดได้เฉพาะบทความความรู้ที่มีสถานะเป็นฉบับร่างเท่านั้น`,
"label.enable.barcode.only":`เปิดใช้งานบาร์โคดเท่านั้น`,
"vue_label_commonobjects_detail_a_group_strategy":`ข้อมูลนี้ขาดผู้ครอบครอง ไม่สามารถสร้างกลยุทธ์กลุ่มได้`,
"setup.layout.group.button":`ปุ่ม`,
"label.mini.layout.remark":`นำไปใช้กับเค้าโครงที่แสดงในหน้าต่างโฮเวอร์ด้านหน้า`,
"setup.mainpage.label.welcome3":`การสร้างฟอร์มใน CloudCC Cloud บนแพลตฟอร์ม CloudCC จะอาศัยฐานข้อมูลที่กําหนดเอง (ออบเจ็กต์) ซึ่งผู้ใช้กําหนดเป็นตารางฐานข้อมูลที่จัดเก็บข้อมูลเฉพาะองค์กรของคุณ ความสัมพันธ์ระหว่างตารางและตารางยังสามารถสร้างขึ้นได้อย่างง่ายดายโดยไม่ต้องพัฒนาโปรแกรมใดๆ`,
"label.knowledge.draft.status":`สถานะการเผยแพร่บทความความรู้ต้องเป็นฉบับร่าง`,
"label.manageAll.sel.one1":`รายการที่รออนุมัติ`,
"label.campagin.roi.bhydkhywjh":`จำนวนที่ปิดการขายกับลูกค้าในโอกาสทางธุรกิจสำเร็จ`,
"label_partner_template_thumbnail":`ภาพขนาดย่อ`,
"label.loginip.setup":`ช่วง Ip การเข้าสู่ระบบ`,
"label.data.downpage.e.title.e.btn":`เข้าสู่หน้าการส่งออกเพื่อเริ่มต้นการส่งออก`,
"vue_label_appstore_project_management":``,
"assetbom.delete.notpermission":`โปรดติดต่อผู้ดูแลระบบ คุณไม่มีสิทธิ์ลบ BOM สินทรัพย์`,
"vue.dashboard.setdrill.inThe":`ใน`,
"label.mobile.more.savephoto":`บันทึกรูปภาพ`,
"label.customerinfo.PageTriggerFag":`คลาสที่กำหนดเอง ทริกเกอร์ การซิงค์เพจที่กำหนดเอง`,
"label.commonobjects.Nopermission":`ขออภัย คุณไม่มีสิทธิ์ในการแก้ไขข้อมูลนี้ โปรดติดต่อผู้ดูแลระบบ`,
"label.searchlayout.opperationtab.xsldfield":`คลิกฟิลด์มุมมองที่แสดงโดยลิงก์กรวยการขายในแท็บโอกาสทางธุรกิจ`,
"label.emailsync.form.disconnect":`ยกเลิกการเชื่อมต่อ`,
"label.document.nofile.upload":`ไม่มีไฟล์อัปโหลด`,
"label.appointmentpage.wizard.subtitle3-3":`หมายเลขโทรศัพท์`,
"message.custom.field.donotdelete":`ฟิลด์ถูกใช้ไม่สามารถลบได้`,
"chatter.using0":`จนถึงตอนนี้ใช้เวลา {0} มิลลิวินาที`,
"label.tabpage.multiple":`แบบเลือกตอบ`,
"label.attendance.setting.sy.alert":`บันทึกเวลาทำงานต้องเลือกพนักงานที่เหมาะสม!`,
"label.refuse":`ปฏิเสธ`,
"label.log.button":`ค้นหาตามชื่อผู้ใช้`,
"component_chatter_link_label_title":`ลิงก์`,
"template.report.contract.collection":`การชำระเงินตามสัญญา`,
"label.campaignmember.selectmember.step1":`ขั้นตอนที่ 1: เลือกแคมเปญและสถานะสมาชิกแคมเปญ`,
"label.datamanage.warn.owner":`คำเตือน: หากยังดำเนินการนำเข้าครั้งนี้ต่อไปจะถือว่าคุณเป็นเจ้าของบันทึกที่นำเข้าทั้งหมด`,
"label.a.b":`ความสัมพันธ์จาก A ไป B`,
"label.app.step3.homeisfrist":`หน้าแรกต้องเป็นหน้าที่หนึ่ง`,
"UG_Lead_003":`โซเชียล`,
"label.partner.workspace.member.choice":`เลือกโปรไฟล์`,
"lable.outlook.detail.emaping":`การแม็ปฟิลด์อิเวนต์`,
"label.service.appointmentList.gantt.chart.shows":`แผนภูมิแกนต์แสดงวันที่`,
"label.mr.caption.account.result":`ตรวจสอบซ้ำและผสาน: ผลลัพธ์ของการสืบค้นข้อมูลซ้ำของลูกค้า`,
"vue_label_chatter_approve_members_join":`อนุมัติสมาชิกเข้ากลุ่ม`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`วัน`,
"pagecreator.systemstyle.label.modifycolor":`แก้ไขสี`,
"label.tabpage.yesz":`ใช่`,
"label.fieldtoolongmessage":`ฟิลด์เกินขีดจำกัด`,
"lable.account.year.name":`ชื่อปีงบประมาณ`,
"label.mini.layout":`เค้าโครงหน้าโฮเวอร์`,
"label.icon.97":`การสอน`,
"vue_label_chat_smart_assistant":`ผู้ช่วยอัจฉริยะ`,
"label.marketingmanagementuser":`ผู้ใช้การบริหารจัดการด้านการตลาด`,
"label_emailtocloudcc_description2":`เชื่อมต่ออีเมลธุรกิจของคุณ`,
"label.campaign.channel.input.name":`1. กรุณาใส่ชื่อช่องทางการขาย`,
"UG.homepage.007":`ตั้งแต่การส่งอีเมลติดตามผลไปจนถึงกิจกรรมการขายแบบอัตโนมัติ ตั้งแต่การสร้างเวิร์กโฟลว์โดยใช้เทคโนโลยีพิมพ์เขียวของเราไปจนถึงทริกเกอร์มาโครที่กำหนดเอง ภารกิจประจำวันแบบอัตโนมัติ และการมุ่งเน้นการสร้างความสัมพันธ์มากขึ้น`,
"label.share":`แบ่งปัน`,
"label.step2.total6":`ขั้นตอนที่ 2 จาก 6`,
"label.sendemail.chat.addComentspraise":`#nameที่เคารพ:\n\n    สวัสดี！#userNameตอบกลับเวยเทียที่คุณชอบ`,
"label.icon.20":`แฟ้ม`,
"label.service.gantt.absenteeism":`ขาดงาน`,
"message.error.color.nagatice":`จํานวนหน้าปัจจุบันต้องไม่เป็นค่าลบ`,
"chatter.group.applyToJoin":`สมัครเข้าร่วม`,
"pagecreator_layout_message_delete":`ต้องการลบเค้าโครงที่เลือกหรือไม่?`,
"label.multilang.viewlist.count":`รวมทั้งหมด {0} รายการบันทึก`,
"message.notdesable.type":`ไม่สามารถปิดใช้งานชนิดบันทึกนี้เนื่องจากโปรไฟล์ต่อไปนี้ใช้เป็นค่าเริ่มต้น`,
"label.standard.time":`เวลามาตราฐาน`,
"label_chatter_newpost":`โพสต์ล่าสุด`,
"front-epwechat-module-v1-binding":`ผูกวีแชทขององค์กร`,
"label.recent":`ล่าสุด`,
"label.globaloperation.createfeeditem":`สร้างรายการฟีด`,
"label_partner_common_roleNum":`จำนวนบทบาท`,
"front-template-V1-quikSearch":`ป้อนชื่อฟิลด์และค้นหาอย่างรวดเร็ว`,
"label_tabpage_haschangedz":`ลีดรายนี้ข้ามสเตจแล้ว`,
"label.service.work.order.line":`รายการบรรทัดใบสั่งงาน`,
"label.lead.score.ok":`โอเค`,
"Account_News_Setting_003":`การตั้งค่าทั่วไป`,
"label.event.moveup.15minutes":`ล่วงหน้า 15 นาที`,
"vue_label_all_selected_objects":`ออบเจ็กต์ที่เลือกทั้งหมด`,
"label.visualpage.an.inline.style.relatedlist":`ฝังเพจที่กำหนดเองให้รายการที่เกี่ยวข้อง`,
"label.umeng.approval.approvaling":`#applyer อยู่ระหว่างการขออนุมัติ #obj#objname#owner`,
"lable.SalesCommitmentKanBan.digital":`ตัวเลข`,
"label.appupload.img.max.size":`รูปภาพที่อัปโหลดมีขนาดใหญ่เกินไป ขนาดรูปภาพไม่ควรเกิน 20K โปรดอัปโหลดอีกครั้ง`,
"vue_label_normal_top":`ปักหมุด`,
"label.knowledge.language.traditional":`ภาษาจีนตัวเต็ม`,
"homepage.layout.edit":`แก้ไขเค้าโครงหน้าแรก`,
"label.campagin.qrcode":`รหัสคิวอาร์ของแคมเปญ`,
"label.emailmerge.merge.emailmerge":`จดหมายเวียน`,
"label.icon.18":`นาฬิกา`,
"vue_label_homepage_taskview":`มุมมองภารกิจ`,
"label.search.related.record":`ไม่พบบันทึกที่เกี่ยวข้อง`,
"label.report.reports":`รายงาน`,
"label.appointment.wizard.subtitle4-3-2":`15 นาที`,
"label.forecast.condition":`เงื่อนไขการพยากรณ์`,
"label.westem.indonesia.time":`เวลาอินโดนีเซีย`,
"front-epwechat-module-v1-callback-desc":`คุณจะต้องคัดลอกข้อมูลต่อไปนี้ไปยังหลังบ้านวีแชทขององค์กร`,
"label.version.group":`รุ่นสำหรับกลุ่ม`,
"label.allReportType":`แหล่งข้อมูลรายงานที่กำหนดเองทั้งหมด`,
"label.trigger.lastmodifydate":`เวลาแก้ไขครั้งล่าสุด`,
"message.layout.unique.sectionfield":`ละเมิดข้อจำกัดเฉพาะของฟิลด์ในเค้าโครงเพจ โปรดยืนยันและบันทึกอีกครั้ง!`,
"vue_label_systemSettings_mobelbottonsetting":`การตั้งค่าเมนูด้านล่างของอุปกรณ์มือถือ`,
"label.recordtype.selectonefield":`เลือกฟิลด์ที่ต้องการจะเพิ่มใหม่อย่างน้อยหนึ่งฟิลด์`,
"label.notification.group1":`[ผู้สมัคร]กำลังสมัครเข้าร่วมกลุ่มสาธารณะของคุณ`,
"component_todaytask_label_title":`ภารกิจวันนี้`,
"label.assignment.setup.list.description":`การกำหนดเกณฑ์การมอบหมายจะสามารถส่งบันทึกไปยังผู้ใช้ที่เกี่ยวข้องโดยอัตโนมัติ การกำหนดเกณฑ์การมอบหมายประกอบด้วยเงื่อนไขที่กำหนดไว้ในบันทึก และรายการเกณฑ์จำนวนมาก`,
"label.project.resource.data":`ทรัพยากรบริการนี้ได้จัดสรรให้กับการนัดหมายการบริการแล้ว โปรดอย่าเพิ่มซ้ำ`,
"label.emailmerge.newtemplate.file":`ไฟล์`,
"label.notification.task1":`[ผู้มอบหมาย]มอบหมายภารกิจให้คุณแล้ว`,
"label.ServiceCloud.Overlapping":`ตัวจัดส่งการแสดงผลที่ทับซ้อนกัน`,
"label.globalselect.used":`ตำแหน่งที่ใช้งานฟิลด์`,
"setup_layout_button_layoutprop":`คุณสมบัติเค้าโครง`,
"label.quickbooks.retrivingdata":`กำลังดึงข้อมูล ...`,
"component.button.ok":`ยืนยัน`,
"message.pleaseinputformula":`กรุณาป้อนสูตร`,
"label.h5.whatifollow":`ที่ฉันติดตาม`,
"label.new.crew.target":`เป้าหมายพนักงานใหม่`,
"label_chatter_task":`ภารกิจ`,
"label.knowledge.setting.data.four":`เลือกกลุ่มหมวดหมู่ได้มากที่สุด {count} รายการ`,
"label.rule.not.enabled":``,
"label_in_scope":`อยู่ในช่วง`,
"label.partnerCloud.orderingPlatform.bundle":`ชุดผลิตภัณฑ์`,
"label.emailtocloudcc.redmessage10":`ข้อมูลหมดอายุแล้ว โปรดลงชื่อเข้าใช้อีกครั้ง`,
"label.knowledgebase.data.assignment.succeeded":`มอบหมายข้อมูล {a} รายการสำเร็จ`,
"vue_label_commonobjects_view_nokanban":`ยังไม่มีมุมมองคัมบังที่สร้างขึ้น`,
"label.knowledgebase.article.cancelled.attaching.case":`บทความ{name}ยกเลิกการแนบกับเคสแล้ว!`,
"label.brief":`สรุป`,
"label.version.sum.app":`แอปพลิเคชัน`,
"label.commoninfo":`ข้อมูลทั่วไป`,
"vue_label_SMS_nodata":`ไม่มีข้อมูล`,
"label.icon.153":`ข้อมูล`,
"label.conditiontag.lookup.false":`เท็จ`,
"label.emailobject.view.unread":`ยังไม่ได้อ่านทั้งหมด`,
"label.staticresource.useful":`ใช้ที่ไหน?`,
"label.ems.connect.test":`ตรวจสอบ`,
"vue_label_chat_group_assistant_notification":`การแจ้งเตือนผู้ช่วยกลุ่ม`,
"label.multipleactivity.total":`ทั้งหมด`,
"vue_label_report_addtocomponentlibrary":`เพิ่มในไลบรารีส่วนเสริม`,
"font-evaluate-module-v1-following-personnel":``,
"label.setup.mobile.bottombutton.change.fail":`การแก้ไขล้มเหลว`,
"front-epwechat-module-v1-unbound-item5":`และข้อมูลจะกู้คืนไม่ได้ กรุณายืนยันว่าคุณต้องการที่จะไม่ผูกมัน`,
"label.customerinfo.smsUid":`เกตเวย์ข้อความสั้น UID`,
"label.list.isOpenApprovalQueue":`เปิดคิวการอนุมัติหรือไม่ (หากเลือกผู้อนุมัติด้วยตนเองจะไม่สามารถใช้งานได้)`,
"label.leadscore.setup.scorenumber":`ครั้ง`,
"label.workflow.selectobj.introduce":`เลือกออบเจ็กต์ที่จะใช้ในกฎเวิร์กโฟลว์`,
"label.visualpage.label.for.example":`ป้ายกำกับหน้าเพจ เช่น:`,
"label.appointmentdetail.wizard.title17":`แผนงานวันพฤหัสบดี`,
"label.projectManagement.timeFrame":`เวลาเริ่มต้นและเวลาสิ้นสุดของงานต้องอยู่ในช่วงเวลาของไมล์สโตน`,
"lable.product.pricebooks.list":`สมุดราคา คือ รายการสินค้าที่มีราคาต่อหน่วยและสกุลเงินที่กำหนดไว้เป็นพิเศษ สมุดราคาสามารถกำหนดได้หลายสกุลเงิน โปรดจำไว้ว่าเมื่อวางโครงสร้างสินค้าในสมุดราคา โอกาสทางธุรกิจหรือใบเสนอราคาจะรวมสินค้าจากสมุดราคาเดียวกันเท่านั้น หากคุณต้องการแก้ไขสินค้าในสมุดราคาโปรดคลิกชื่อสมุดราคา`,
"font-trade-module-v1-delete-invoice":``,
"vue_label_salesadvance_winamount":`จำนวนเงินทั้งหมดที่ปิดการขายสำเร็จ`,
"component.salesperformance.label.nopermission":`กรุณาติดต่อผู้ดูแลระบบของคุณเพื่อดูข้อมูลที่เกี่ยวข้องกับโอกาสทางธุรกิจ`,
"vue_label_report_formatreport_desc":`ส่งออกรายงานที่มีส่วนหัวของรายงาน กลุ่ม และการตั้งค่าตัวกรอง`,
"label.enable.qrcode.only":`เปิดใช้งานเฉพาะรหัสคิวอาร์เท่านั้น`,
"label.smstemplate.edit":`แก้ไขแม่แบบข้อความสั้น`,
"label.qrcodeSetting.detailed.information":`รหัสคิวอาร์สามารถเก็บข้อมูลได้มากกว่าบาร์โคดทั่วไป และไม่จำเป็นต้อง<br/>ใช้เครื่องอ่านบาร์โคดเหมือนบาร์โคดทั่วไป  จึงทำให้<br/> ขอบเขตของแอปพลิเคชันขยายครอบคลุมไปถึงการติดตามผลิตภัณฑ์ การระบุสินค้า< br?/>  การจัดการไฟล์ การตลาด เป็นต้น`,
"label.event.moveup.1week":`ล่วงหน้า 1 สัปดาห์`,
"label.customize.memory.function.sorting.disable":`ปิดใช้งานหน่วยความจำการเรียงลำดับของส่วนหัวของมุมมอง`,
"label.icon.195":`อ่างอาบน้ำ`,
"label.compact.layout.assign":`กำหนดเค้าโครงข้อมูลสำคัญ`,
"label.icon.183":`บ้าน`,
"front-kefu-moudle-v1-jchxzxzi-chat":`เชื่อมต่อฟังก์ชั่นการแชท Seat ออนไลน์ของ Easemob เพื่อการให้บริการ SaaS ที่ครอบคลุมมากขึ้น`,
"label.mycontact":`ผู้ติดต่อของฉัน`,
"label.tabularreport.2018.step3":`ขั้นตอนที่ 3: เลือกมาตรฐานรายงาน`,
"chatter.group.uploadGroupPicture":`อัปโหลดรูปโปรไฟล์กลุ่ม`,
"label.total.forecast.setup":`จัดลำดับความสำคัญของการพยากรณ์และตั้งค่าเป็น`,
"label.weixin.group.description":`หมายเหตุ`,
"label.edit_emailfooter":`แก้ไขส่วนท้ายอีเมล`,
"label.ems.create":`สร้างใหม่`,
"label.weixin.optionseven":`ตัวเลือกที่เจ็ด`,
"font-evaluate-module-v1-continue-work":``,
"label.close.multilingual":`ปิดการใช้งานหลายภาษา`,
"component.chatter.post.button.user":`เพิ่มผู้ใช้`,
"label.use_QRcode":`ใช้รหัสคิวอาร์`,
"label.operatedata.exportsuc":`การส่งออกสำเร็จ โปรดเข้าสู่ระบบอีเมลของคุณเพื่อตรวจสอบที่อยู่ไฟล์ส่งออกของคุณ โปรดรีบดาวน์โหลด ไฟล์ที่ส่งออกจะถูกบันทึกไว้ให้คุณ 48 ชั่วโมง เพื่อป้องกันที่อยู่ลิงก์ของคุณแนะนำให้ลบอีเมลที่ระบบส่งให้คุณหลังจากที่ดาวน์โหลด`,
"label.page.step2.define.content":`ขั้นตอนที่ 2: กำหนดเนื้อหาและแสดงคุณสมบัติ`,
"label_tabpage_groupingitem":`การจัดกลุ่มรายการ`,
"label.customfields.placeholder":`กรอกตัวอย่าง`,
"vue_label_commonobjects_detail_enter_subject":`กรุณาใส่หัวข้อ`,
"label.multilang.workflow.everyotherdayinmonth":`ทุก {1} วัน ของ {0} เดือน`,
"label.knowledgebase.data.archiving.failed":`เก็บข้อมูลถาวร {a} รายการล้มเหลว`,
"vue_label_notice_nopermission_view":`ขออภัย คุณไม่มีสิทธิ์ดูข้อมูลนี้ กรุณาติดต่อผู้ดูแลระบบ`,
"vue_label_calendar_calendar_view":`มุมมองปฏิทิน`,
"lable.outlook.edit.des":`หากผู้ติดต่อ Exchange ตรงกับผู้ติดต่อ CloudCC.com หลายราย ให้ซิงค์กับผู้ติดต่อ CloudCC.com ที่ตรงตามเกณฑ์ต่อไปนี้`,
"label.custom.NextCQ":`ไตรมาสที่กําหนดเองถัดไป`,
"label.emailsync.form.stutas":`สถานะเปิดใช้งาน`,
"label.nameandintro":`ชื่อและคำอธิบาย`,
"label.dashboardSetup.showdw":`หน่วยแสดงผล`,
"label.tianyancha.actualcapital":`ทุนจดทะเบียนที่ชำระแล้ว`,
"front-kefu-moudle-info-delete-calluser":``,
"label.emailobject.list.all":`เลือกทั้งหมด`,
"label.campaign.channel.step7.send":`เลือกพนักงานที่ต้องการจะส่งอีเมลให้`,
"label.formulafield.type":`สูตรจะส่งกลับ`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`วันพฤหัสบดี`,
"label.chosesubject.eat":`นัดทานข้าว`,
"label.back":`ย้อนกลับ`,
"label.h5.allcompany":`ยฺหวินเทียทั้งหมด`,
"label.location.display.type.digital":`ตัวเลข`,
"label.datamanage.error.csv":`รูปแบบไฟล์ไม่ถูกต้อง ระบบรองรับเฉพาะรูปแบบ CSV ทั่วไป กรุณาดำเนินการใหม่อีกครั้ง`,
"label.emailobject.mark":`สัญลักษณ์`,
"setup_mainpage_label_welcome9":`ผู้ใช้ไม่จําเป็นต้องเขียนรหัส เพียงลากและวางเม้าส์ก็จะปรากฎประเภทการแสดงผล และการปรับเค้าโครงขององค์ประกอบเพจทั้งหมด รวมถึงการตั้งค่าคุณสมบัติของฟิลด์ เช่น ฟิลด์อ่านอย่างเดียว และฟิลด์บังคับ เป็นต้น`,
"label.icon.56":`เครื่องมือวัด`,
"label.forecast.edit.fwcd":`ความยาวของช่วง`,
"vue_label_email_Please_select_related_items_first":`โปรดเลือกรายการที่เกี่ยวข้องก่อน`,
"label.icon.87":`หนังสือ`,
"label.knowledgebase.recovery.was.successful":`กู้คืนสำเร็จ`,
"label.emailobject.emaildetail.promptcontent":`ยืนยันหรือไม่ว่าต้องการลบข้อความนี้? โปรดทราบว่าการลบนี้ไม่สามารถยกเลิกได้`,
"label.delete.role":`ลบบทบาท`,
"label.multiselect":`รายการตัวเลือกที่เลือกได้หลายรายการ`,
"label.customerinfo.mailisnull":`ไม่ได้ตั้งค่าอีเมลที่บริษัทส่ง`,
"label.waitforamoment":`กำลังโหลดหน้าเพจ โปรดรอสักครู่ ...`,
"lable.edit.queue.tip":`ป้อนเมื่อส่งแจ้งเตือน (เช่น เมื่อใส่เคสลงในคิว) ชื่อคิวและที่อยู่อีเมลที่จะใช้  สามารถละเว้นที่อยู่อีเมลและจะไม่มีการแจ้งเตือน หากเลือก "ส่งอีเมลถึงสมาชิก" เมื่อกำหนดออบเจ็กต์ให้กับคิว สมาชิกคิวจะได้รับการแจ้งเตือน หากไม่เลือกก็จะไม่แจ้งเตือน`,
"lable.custom.y.d":`หน้านี้ช่วยให้คุณกำหนดบันทึกรายปีเองได้ วันที่ของปีที่กำหนดเองจะถูกสร้างตามที่คุณเลือกด้านล่าง`,
"chatter.feed.content.user.searchbutton":`ค้นหา`,
"label.data.downpage.i.list.desc3":`หลังจากผู้ใช้ดาวน์โหลดสามารถดูสาเหตุของการนำเข้าล้มเหลวที่คอลัมน์สุดท้ายของไฟล์`,
"label.tag.manage.createdby":`ผู้สร้าง`,
"label.h5.similar.opportunity.last.months3":`3 เดือนล่าสุด`,
"chatter.group.members":`สมาชิก`,
"label.knowledgebase.data.translation.failed":`การแปลข้อมูล {a} รายการล้มเหลว`,
"label.log.look":`ดูการตั้งค่าเส้นทางการตรวจสอบ`,
"label.service.gantt.week.timescale":`ระยะห่างช่วงเวลาที่แสดงในมุมมองรายสัปดาห์：`,
"label.userLicence":`ใบอนุญาตใช้สิทธิ์`,
"label.file.library.managemembers.permission":`สิทธิ์การเข้าถึง`,
"label_emailtocloudcc_name":`ชื่อ`,
"label.mr.mrSuccess":`ผสานสำเร็จ`,
"vue_label_commonobject_view_notice_selectadd":`โปรดเลือกข้อมูลที่ต้องการเพิ่ม`,
"vue_label_commonobjects_detail_level":`ระดับ`,
"CloudCCCRM_ST_Info_TypeIn_001":`โปรดระบุ`,
"label_chatter_list":`รายการ`,
"label_tabpage_optionsz":`ตัวเลือก`,
"UG_homepage_008":`ทำความเข้าใจสถานะของธุรกิจในปัจจุบัน (รายงานสรุปการขาย การจัดอันดับ กรวยการขาย เป็นต้น)  ตรวจสอบโอกาสทางธุรกิจที่อาจมีปัญหาอยู่ พยากรณ์ผลสำเร็จ รับพิจารณาและมอบหมายเรื่องสำคัญทันที ทำการตัดสินใจได้อย่างชาญฉลาด`,
"label.myselfdashboard":`แดชบอร์ดส่วนตัวของฉัน`,
"label.globaloperation.operationtype.record_phone":`บันทึกการโทร`,
"label.field.standard":`ฟิลด์มาตรฐาน`,
"label.changemydisplay.appedit.check":`แทนที่การตั้งค่าการปรับแต่งแอปพลิเคชันที่กำหนดเองส่วนบุคคลของผู้ใช้`,
"label.tianyancha.h5.legalpersonnames":`ผู้แทนโดยชอบธรรม`,
"label.tabpage.sorttypez":`ประเภทการจัดเรียง`,
"label.newdashboard.folder":`โฟลเดอร์แดชบอร์ดใหม่`,
"label.campaign.channel.step6":`ขั้นตอนที่ 6: สร้างหน้าลงทะเบียนช่องทางการขาย`,
"label.ems.composeemail":`ส่งอีเมล`,
"label.app.step4.tabcanuse":`แท็บที่ใช้ได้`,
"label.sendmail.batch":`ส่งอีเมลแบบกลุ่ม`,
"label.process.execute.title":`อยู่ระหว่างการอนุมัติ`,
"lable.outlook.detail.lastup":`ปรับปรุงล่าสุด`,
"label_emailtocloudcc_delete":`ลบ`,
"lable.opppdt.selPdt.leastone":`โปรดเลือกอย่างน้อยหนึ่งรายการ`,
"label.customfields.new.step2.opration.exid":`ID นอกระบบ`,
"label.assignment.setup.newrule.description":`ป้อนชื่อเกณฑ์จากนั้นเลือก"กล่องกาเครื่องหมายที่เปิดใช้งานเกณฑ์นี้สำหรับการมอบหมายอัตโนมัติ การเปิดใช้เกณฑ์นี้จะเป็นการปิดการใช้งานเกณฑ์การมอบหมายในปัจจุบัน"`,
"label.campaign.channel.input.to.isactivity":`7. เปิดใช้งานช่องทางการขายหรือไม่`,
"label.document.return":`กลับไปหน้าเอกสาร`,
"label.data.downpage.i_title.num5":`5. โปรดตรวจสอบความถูกต้องของข้อมูล`,
"label.taskinto":`เมื่องานมอบหมายให้ผู้ใช้โดยอัตโนมัติ งานคือแม่แบบที่กฎเวิร์กโฟลว์ใช้`,
"label.customfields.formula.textexample":`Full Name（ชื่อเต็ม）= LastName & ", " & FirstName`,
"label.appointmentpage.wizard.subtitle1-1":`สัปดาห์หน้า`,
"label.weixin.radio":`วิทยุ`,
"vue_label_file_replace_reason_check":`เหตุผลในการแทนที่ (ทางเลือก)`,
"label.sendemail.recycle.operateexception":`มีข้อยกเว้นในการดำเนินการล้างถังขยะรีไซเคิล โปรดลองอีกครั้ง!`,
"label.vlidaterule.formulaerror":`หาก "ส่วนลด" มากกว่า 30% ข้อผิดพลาดจะแสดงขึ้น`,
"vue_label_campaign_existing_member_status":`รักษาสถานะสมาชิกที่มีอยู่`,
"label.service.miniProgram.fillSlideshowName":`กรุณากรอกชื่อภาพสไลด์`,
"label_partner_workspace_login_headerfooter":`ส่วนหัวของหน้าและส่วนท้ายของหน้า`,
"label.quickbooks.viewlist.total2":`ประมาณการทั้งหมด {0} รายการ  รวมเป็น {1}`,
"chatter.viewingResults":`ดูผลลัพธ์`,
"label_tabpage_allvisible":`ผู้ใช้ทั้งหมดมองเห็น`,
"label.quote":`ใบเสนอราคา`,
"label.changemydisplay.list.des":`กําหนดค่าเมนูตามต้องการ`,
"label.leadscore.notimes":`จำนวนครั้งการให้คะแนนครบแล้ว`,
"label.icon.51":`ผลิตกระแสไฟฟ้า`,
"component.assistant.label.title":`ผู้ช่วย`,
"label.emailobject.emailsent":`การส่งอีเมลสำเร็จ!`,
"label.group.nofile":`ไม่มีไฟล์ส่งไปถึงกลุ่มนี้`,
"label.foldervisitlimit2":`ผู้ใช้ทุกคนจะไม่สามารถมองเห็นโฟลเดอร์นี้ได้`,
"label.dataoperate":`ดำเนินการข้อมูล`,
"label.addattachment.size":`ขนาด`,
"label.not.double":`ไม่อนุญาตให้มีค่าซ้ำ`,
"label.customfields.formula.number.tip":`คำนวณค่าตัวเลข`,
"lable.opppdt.addpdt.table.description":`แถวคำอธิบาย`,
"label.sms.isactivity":`เปิดการใช้งานใช่หรือไม่`,
"label.campaign.channel.input.owner":`4. เจ้าของลีดที่ลงทะเบียนจากช่องทางการขายนี้คือ:`,
"label.visualpage.notfound.error":`เกิดข้อผิดพลาดที่ไม่รู้จัก โปรดติดต่อผู้ดูแลระบบ`,
"label.mr.title.button.group3":`รายการบันทึก`,
"label_tabpage_beginz":`เริ่มต้น`,
"label_tabpage_queue":`คิว`,
"label.tabpage.advancedscreening":`เงื่อนไขตัวกรองขั้นสูง`,
"nogreate":`น้อยกว่าหรือเท่ากับ`,
"chatter.fields":`ฟิลด์`,
"button_partner_workspace_manage":`การจัดการ`,
"label.partnerCloud.orderingPlatform.search":`ค้นหาผลิตภัณฑ์`,
"message.password.isnull":`รหัสผ่านไม่สามารถว่างเปล่า!`,
"label.fenbeitong.title":`การตั้งค่าเฟินเป้ยทง`,
"label.salescloud.contactrole.message.chooseatleastone":`โปรดเลือกผู้ติดต่ออย่างน้อยหนึ่งราย`,
"label.knowledge.delete.election":`เกิดข้อผิดพลาดในการเลือกประเภทข้อมูล`,
"front-console-status-hoided":``,
"label.lastmodifydate":`เวลาแก้ไขล่าสุด`,
"vue_label_chat_deleting_chat":`หลังจากลบแล้ว ประวัติการสนทนาจะถูกล้างและลบออกจากรายการกลยุทธ์กลุ่ม เมื่อได้รับข้อความใหม่ จะปรากฏในรายการกลยุทธ์กลุ่มอีกครั้ง`,
"label.timeframe":`กรอบเวลา`,
"UG.opportunity.002":`กำหนดวงจรการขายและปรับแต่งสเตจของคุณ`,
"label.templates.merge":`โปรดเลือกแม่แบบที่ต้องการผสานสูงสุด 20 แม่แบบ`,
"label.generatepage.c2":`ความยาวมากที่สุด 30`,
"label.appointment.wizard.subtitle4-1-6":`2 ชั่วโมง`,
"label.passwordPolicy.setup.pwdremember3":`จำ 3 รหัสผ่าน`,
"button.partner.workspace.enable":`เปิดการใช้งานพาร์ทเนอร์คลาวด์`,
"vue_label_pool_nopool_notice":`คุณยังไม่ได้เข้าร่วมฐานข้อมูลใดๆ โปรดติดต่อผู้ดูแลระบบเพื่อสร้างหรือเข้าร่วมฐานข้อมูลที่อยู่`,
"label.layout.required.field.select":`ฟิลด์บังคับที่เลือก`,
"label.loginhis.date":`กรุณาใส่เวลาเริ่มต้นและเวลาสิ้นสุด`,
"vue_label_commonobjects_detail_and_overdue":`กำลังจะถึงและเกินกำหนด`,
"label_tabpage_advancedsearch":`ค้นหาขั้นสูง`,
"label.custom.field.login.home.query":`กรุณาเข้าสู่หน้าแรกของระบบเพื่อเรียกดูรายละเอียดงาน!`,
"page":`เพจ`,
"label_tabpage_onlymevisible":`มีแค่ฉันที่มองเห็น`,
"label.weixin.optionfour":`ตัวเลือกที่สี่`,
"label.confirm.to.remove":`ยืนยันการลบ`,
"label.event.moveup.30minutes":`ล่วงหน้า 30 นาที`,
"label.mail.merge.template.finish":`แม่แบบจดหมายเวียนเสร็จสมบูรณ์`,
"label.multilang.currencylist.before":`ก่อน {0}`,
"label.goback":`กลับไปขั้นตอนก่อนหน้า`,
"label.unknown.prefix":`คำนำหน้าที่ไม่รู้จัก โปรดป้อนคำนำหน้าที่ถูกต้อง`,
"lable.account.CurrentandPreviousCYt":`ปีปฏิทินนี้และสองปีแรก`,
"label.product.dent":`ระบุคีย์เวิร์ดและเงื่อนไขการคัดเลือก หลังจากนั้นคลิกค้นหา"และเริ่มค้นหา คลิก "ตัวกรองเพิ่มเติม" เพื่อใช้ตัวกรองหนึ่งตัวขึ้นไป ผลการค้นหาจะรวมไปถึงบันทึกทั้งหมดที่ตรงกับคีย์เวิร์ดและเงื่อนไขการกรอง"`,
"label.ems.bcc":`เพิ่มสำเนาลับ`,
"label.import.index.operation":`ดำเนินการ`,
"label.knowledge.setting.hint.eight":`เป็นระเบียบเรียบร้อย!`,
"label.sso.saml.sp.idtype.fid":`คำสั่งประกอบด้วย ID พันธมิตรจากออบเจ็กต์ผู้ใช้`,
"vue_label_chat_voice":``,
"label.config.pw":`ยืนยันรหัสผ่านใหม่`,
"lable.newtabpage.closesearchresult":``,
"lable.account.NextWeek":`สัปดาห์หน้า`,
"label.ems.username":`ชื่อผู้ใช้ (U)`,
"vue_label_email_emails_from_potential":`อีเมลจากลีดและผู้ติดต่อใน CRM ของคุณรวมถึงอีเมลที่มีพวกเขาอยู่ในผู้รับจะถูกจัดประเภทที่นี่`,
"lable.approval.shared":`อนุมัติการแบ่งปัน`,
"label.tabpage.allz":`ทั้งหมด`,
"label.file.uploadfiles":`อัปโหลดไฟล์`,
"label.emailobject.text":`ชื่อ`,
"label.version.allow.create":`อนุญาตให้สร้าง`,
"label.empty.field":`ฟิลด์ต้องไม่ว่างเปล่า`,
"label.emailsync.status.department":`หน่วยงาน`,
"label.pw.str":`อักขระ 5 ตัว`,
"label.attendance":`บันทึกเวลาทำงาน`,
"label_mobile_buttom_team":`กลยุทธ์กลุ่ม`,
"label.campaignmember.main.addcontactdesc":`เพิ่มผู้ติดต่อที่มีอยู่ทั้งหมดในแคมเปญนี้พร้อมกัน`,
"label.search.result":`ผลการค้นหา`,
"label.weixin.activity.account":`แขกที่เข้าร่วมกิจกรรม`,
"label_tabpage_clearoptionsz":`ล้างตัวเลือกขั้นสูง`,
"UG.activity.01":`คุณติดตามบันทึกการโต้ตอบระหว่างลูกค้า/ทีมของคุณได้อย่างไร?`,
"serviceappointment.new.status.limit":`ไม่สามารถสร้างการนัดหมายการบริการใหม่ที่มีสถานะวางแผนหรือจัดส่ง`,
"label.notice.higher":`แจ้งผู้บังคับบัญชาหรือไม่`,
"label.passwordPolicy.setup.gletters":`อักขระ`,
"label.data.exportsf.des":`ไฟล์ที่ส่งออกสำเร็จจะถูกเก็บไว้บนเซิร์ฟเวอร์เป็นเวลา 48 ชั่วโมง และจะถูกลบโดยอัตโนมัติหลังจาก 48 ชั่วโมง`,
"label.view.onlymecansee":`มีเแค่<b>ฉัน</b>ที่มองเห็น`,
"UG.Lead.005":`อีเมล`,
"label.umeng.approval.approvalfail":`การส่งล้มเหลว`,
"label.huanxinconfig.clientid.lost":`clientid ต้องไม่ว่างเปล่า`,
"label.campaignmember.main.updatecontactstatus":`อัปเดตสถานะ-ผู้ติดต่อปัจจุบัน`,
"component_chatter_button_delete":`ลบ`,
"label.weixin.no.pending.projects.qin":`ขณะนี้ยังไม่มีโครงการที่รออนุมัติ`,
"front-electronic-signature-auto-fill-field":``,
"message.resetpw":`ยืนยันว่าจะรีเซตรหัสผ่านหรือไม่?`,
"label.service.ganttBaiduMap.service.resourname":`ชื่อทรัพยากรบริการ`,
"vue_label_pricebook_deleted":`ลบสมุดราคาแล้ว`,
"label.icon.193":`อ่างอาบน้ำ`,
"label.validate.function.funcFormat.NOT":`NOT(logical)`,
"label.address.city":`เมือง`,
"label.pc.ui.2018.searchs":`กรุณาใส่เนื้อหาที่ต้องการค้นหา`,
"label.yard":`รหัสเชิญ`,
"label.data.downpage.i_title.btn":`เข้าสู่หน้าการนำเข้า และเริ่มการนำเข้า`,
"label.useablereceivers":`ผู้รับที่พร้อมใช้งาน`,
"label.cloudccsite.name.length":`ชื่อเว็บไซต์ต้องยาวไม่เกิน 255 อักขระ`,
"label.secrecy":`ความลับ`,
"label.campagin.roi.ydkhywjhzz":`จำนวนเงินรวมของลูกค้าในโอกาสทางธุรกิจที่ปิดการขายสำเร็จ`,
"vue_label_report_conditiondesc_one":`นอกจากการบอกรับเป็นสมาชิกแล้ว คุณสามารถกำหนดเงื่อนไขรายงานนี้ และคุณจะได้รับการแจ้งเตือนเมื่อตรงตามเงื่อนไข นี่คือตัวเลือก`,
"label.datamanage.select.contactfield":`(เลือกฟิลด์ที่ตรงกับผู้ติดต่อที่นำเข้า)`,
"label.emailtocloudcc.filed.action":`ปฏิบัติการ`,
"label.smstemplate.new":`แม่แบบข้อความสั้นใหม่`,
"label.mobile.side.tab.app":`แอปพลิเคชัน`,
"label.icon.118":`นาฬิกา`,
"label.customfields.selectcontainfieldlayout.tip":`ฟิลด์นี้จะถูกเพิ่มเป็นฟิลด์สุดท้ายใน 2 คอลัมน์แรกของเค้าโครงเพจเหล่านี้ หากคุณไม่ได้เลือกเค้าโครง ฟิลด์นี้จะไม่ปรากฏบนหน้าเพจ`,
"Lead_Homepage_Tools_BatchScoring":`การให้คะแนนแบบกลุ่ม`,
"lable.quote.syncing.quote":`ใบเสนอราคา`,
"pagecreator.button.preview":`แสดงตัวอย่าง`,
"label.ccchat.am":`โมงเช้า`,
"chatter.feed.menutype.user.nullrecent":`ไม่มีบันทึกล่าสุด`,
"lable.info.queue.showallmember":`ดูสมาชิกคิว`,
"label.multilang.campaign.selelctmember.desc":`เลือกหนึ่งมุมมองจากนั้นเลือกสมาชิกที่จะเพิ่มในแคมเปญ สถานะของสมาชิกคือ{0}`,
"label.notification.ccchat3":`เวยเทียของคุณมีการตอบกลับใหม่ 1 รายการ`,
"UG.product.03":`สมุดราคาที่รอบรับหลายสกุลเงิน`,
"label.sso.saml.idp.config.pksize":`ขนาดคีย์`,
"label.defineCustomReportType":`กำหนดแหล่งข้อมูลรายงานที่กำหนดเอง`,
"component.timeline.button.filter":`ตัวกรอง`,
"label.mr.nextGroup":`ข้ามกลุ่มนี้ไปยังกลุ่มถัดไป`,
"label.quote.sprdz":`ที่อยู่ผู้รับ`,
"label.total.refuse.forecast.have.priority":`ปฏิเสธการพยากรณ์ทั้งหมดก่อน`,
"lable.product.peep":`ล้างราคาที่เหมาะสม`,
"label.file.who.can.access":`ผู้ที่สามารถเข้าชม`,
"label.page.last":`หน้าสุดท้าย`,
"label.icon.180":`คน`,
"font-evaluate-module-v1-enabled-successfully":``,
"label.appointment.wizard.subtitle4-2-2":`2 ชั่วโมง`,
"label.passwordPolicy.setup.oneyear":`หนึ่งปี`,
"label.login.bound.mfadevice.title":`เปิดการใช้งานอุปกรณ์ MFA เสมือน`,
"vue_label_dashboard_statisticalvalue":`กรุณาเลือกค่าสถิติ`,
"label.ishistory":`ประวัติของ`,
"component.timeline.label.title":`ไทม์ไลน์`,
"label.page.step3.of.step5":`ขั้นตอนที่ 3 จาก 5`,
"label.assignment.setup.detail.section":`รายละเอียดเกณฑ์`,
"label.salescloud.opportunity.nothave.main.contactrole":`ไม่มีผู้ติดต่อหลัก`,
"label.import.page1.limitedcsv":`อัปโหลดได้เฉพาะรูปแบบ CSV เท่านั้น!`,
"label.icon.187":`ค้อน`,
"label.emailobject.wizard.desc5":`ปรับแต่งลายเซ็นของคุณเพื่อให้อีเมลสวยขึ้น`,
"vue_label_report_notice_copy_success":`การคัดลอกรายงานสำเร็จ!`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`คุณยังไม่ได้เลือกกฎการตรวจสอบซ้ำ`,
"label.componentEditor.upper.limit":`สูงสุด 100`,
"label.validate.function.funcExplain.ISNEW":`ตรวจสอบว่าเป็นบันทึกใหม่หรือไม่ และหากใช่ส่งกลับค่า TRUE มิฉะนั้นส่งกลับค่า FALSE`,
"label.postalCode":`รหัสไปรษณีย์`,
"label.dashboard.snapshot.enable.flag":`เปิดการใช้งานสแนปชอตแดชบอร์ด`,
"vue_label_file_upload_type_size":`อัปโหลดได้แค่ไฟล์ {fileType} และขนาดไม่เกิน {size} Mb`,
"label.appointment.wizard.subtitle3-6":`วันเสาร์`,
"homepage.narrow":`คอลัมน์แคบ (คอลัมน์ซ้าย)`,
"chatter.addmute.confirm":`ยืนยันว่าจะปิดการแจ้งเตือนโพสต์หรือไม่?`,
"label.lookup.account":`ค้นหาลูกค้า`,
"message.lostthemanager":`การส่งนี้ต้องได้รับอนุมัติจากผู้จัดการของผู้ใช้และค่านี้ว่างเปล่า สำหรับรายละเอียด โปรดติดต่อผู้ดูแลระบบของคุณ`,
"label.exchange.sync.state.contact.m3":`บันทึกที่ซิงค์เมื่อ 24 ชั่วโมงที่ผ่านมา：`,
"label.version.phone.app":`APP สำหรับโทรศัพท์มือถือ`,
"label_tabpage_search":`ค้นหา`,
"vue_label_helpcenter_campaign":`ในรายละเอียด ให้คลิกปุ่มแผนผังต้นไม้ถัดจากแคมเปญเพื่อดูแผนผังลําดับชั้นของแคมเปญ และทำความเข้าใจความสัมพันธ์หลัก-รองของแคมเปญ <br>จัดการผู้ติดต่อหรือลีดที่เกี่ยวข้องกับแคมเปญผ่านรายชื่อสมาชิกแคมเปญที่เกี่ยวข้อง`,
"front-lightning-module-v1-dashborad-last-year":`ปีที่แล้ว`,
"label.campaign.channel.value":`ค่า`,
"vue_label_opportunity_contactrole_primarycontact_notice":`หากคุณต้องการเลือกผู้ติดต่อหลัก โปรดบันทึกขั้นตอนนี้และเลือกใน "การจัดการ"`,
"label.biaoqingfaxian.title":`ค้นพบการยื่นประมูล`,
"label.approved":`อนุมัติ`,
"label.hong.kong.time":`เวลาฮ่องกง`,
"label.customfields.file.cannotopen":`ไม่สามารถเปิดไฟล์นี้ได้`,
"lable.New.tips":`คลิก "ใหม่" เพื่อสร้างแม่แบบรายงานการบริการตามแม่แบบมาตรฐานหรือแม่แบบใดแม่แบบหนึ่ง สามารถใช้แม่แบบได้หลังจากเปิดใช้งาน`,
"component.setup.tabs.label.add":`เพิ่มใหม่`,
"label.forecast.forehistory.replacebest":`ประสิทธิภาพยอดเยี่ยมถูกแทนที่`,
"front-kefu-moudle-v1-jctrrt-call-serve":``,
"label.workflow.configrule":`ขั้้นตอนที่2: ปรับแต่งกฎเวิร์กโฟลว์`,
"label.dashboard.snapshot.refresh.frequently":`รีเฟรชสแนปชอตแดชบอร์ดถี่เกินไป โปรดลองอีกครั้งในภายหลัง`,
"label.ems.editsetting":`แก้ไขการตั้งค่าอีเมล`,
"message.confirmdeleteAPP":`คุณกำลังจะลบแอปพลิเคชันนี้`,
"label_chatter_activity":`กิจกรรม`,
"label.editsharerules":`แก้ไขสิทธิ์การแบ่งปัน`,
"label.loginservice.license.notuse.must":`ใบอนุญาตไม่สามารถใช้งานได้ในขณะนี้ คุณจะต้อง`,
"label.import.step2.beforeexport":`1. ก่อนนำเข้าโปรดตรวจสอบให้แน่ใจว่าได้นำเข้าบันทึกที่เกี่ยวข้องทั้งหมดแล้ว เช่น หากมีความสัมพันธ์การค้นหาระหว่างออบเจ็กต์ที่คุณกําลังนําเข้าและผู้ติดต่อ โปรดนำเข้าผู้ติดต่อเหล่านี้ก่อนแล้วจึงนำเข้าข้อมูลของคุณ`,
"label.chat.mute":`ปิดการแจ้งเตือน`,
"label.icon.128":`บ้าน`,
"label.give":`&&และ`,
"label.hide":`ไม่แสดง`,
"label.relationobject.wpr":`ผู้แทน`,
"label.summation":`ผลรวม`,
"label.layout.availabletab.details":`รายละเอียดข้อมูล`,
"label.circle":`แผนภูมิโดนัท`,
"vue_label_opportunity_contactrole_add":`เพิ่มบทบาทผู้ติดต่อ`,
"label.file.library.file2libsuccess":`การเพิ่มไฟล์ในไลบรารีสำเร็จ!`,
"label.weixin.report.reportgenerated":`สร้างรายงานแล้ว`,
"label.icon.91":`คน`,
"report.label.pleaseinput":`กรุณาใส่เนื้อหาที่ต้องการค้นหา`,
"label.escalation.setup.newaction.otheremail.tip":`คุณสามารถป้อนอีเมลที่จะส่งได้สูงสุด 5 ฉบับ ใช้ลูกน้ำเพื่อแยกที่อยู่แต่ละรายการ`,
"label.area.donot.have.data":`ไม่มีข้อมูล`,
"label.customcomponent.btn.reference":`การอ้างอิงส่วนเสริม`,
"label.appointmentdetail.wizard.title7":``,
"label.ccchat.with":`มี`,
"label.file.size":`ขนาด`,
"label.product.sort.beyond":`รองรับการตั้งค่าสูงสุด 10 ระดับ!`,
"label.ccchat.2018":`ความเคลื่อนไหว`,
"label.report.select.column":`เลือกคอลัมน์`,
"label.appointmentpage.wizard.subtitle1_1":`กรุณาเลือกวันที่และเวลาที่เจาะจง`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`ต้องมีตัวอักษรและตัวเลขคละกัน มีทั้งตัวพิมพ์ใหญ่และตัวพิมพ์เล็กและสัญลักษณ์`,
"label_chatter_addressee":`ผู้รับ`,
"label.profile.remark2":`หากองค์กรของคุณใช้ชนิดบันทึก โปรดใช้ลิงก์ "แก้ไข" ในส่วน "ตั้งค่าชนิดบันทึก" ด้านล่าง เพื่อให้ผู้ใช้โปรไฟล์นี้สามารถใช้ชนิดบันทึกได้ตั้งแต่หนึ่งชนิดขึ้นไป`,
"UG_Account_01":`ลูกค้าของคุณคือใคร?`,
"label.dataimport.error.contact.notnull":`เกิดข้อผิดพลาด: ชื่อผู้ติดต่อไม่สามารถว่างเปล่า`,
"lable.account.CalenderQuarter":`ไตรมาสปฏิทิน`,
"vue_label_commonobjects_detail_empty":`ราคาขายไม่สามารถว่างเปล่า`,
"label.approveassigntemplate":`อนุมัติการกำหนดแม่แบบอีเมล`,
"label.objectRelationshipDescription1":`แหล่งข้อมูลรายงานนี้จะสร้างข้อมูลเกี่ยวกับ`,
"vue_label_email_insertmergefield":`แทรกฟิลด์ผสาน`,
"label.mobile.home.page.check.team":`ตรวจสอบทีม`,
"lable.edit.queue.edit":`แก้ไขคิว`,
"label.campagin.roi.query":`สืบค้น ROI ของแคมเปญ`,
"label.dataimport.field.allow.access.to":`ไม่อนุญาตให้เข้าถึงฟิลด์ข้อมูล โปรดลบบันทึกที่เกี่ยวข้องด้วยตนเองแล้วลองอีกครั้ง`,
"pagecreator.systemstyle.message.canntdelete":`ไม่อนุญาตให้ลบรูปแบบปัจจุบัน`,
"label.searchkey":`กรุณาใส่คีย์เวิร์ด`,
"chatter.showall":`แสดงทั้งหมด`,
"show":`แสดง`,
"label.quote.choseproduct":`เลือกผลิตภัณฑ์`,
"label.report.selected.field":`ฟิลด์ที่ถูกเลือก`,
"label.globaloperation.operationtype.create_data":`สร้างบันทึก`,
"label.knowledge.setting.data.seven":`ลบกลุ่มหมวดหมู่: {flzmc}`,
"chatter.email.mentionOrMessage":`กล่าวถึงหรือข้อความ`,
"label_tabpage_exclusivez":`ไม่รวม`,
"chatter.en.userinfo":`ใส่ข้อมูลที่เกี่ยวกับคุณ`,
"label.log.orgid":`องค์กร`,
"label.dataimport.insertdata.error.fieldrepeat.update":`ฟิลด์ $schemefield_name $ ในบันทึกนี้ไม่พบในฐานข้อมูล และไม่สามารถอัปเดตได้ บันทึกนี้จะถูกละเว้นการนําเข้า`,
"vue_label_chatter_add_link_success":`เพิ่มลิงก์สำเร็จ`,
"label.sender_details":`เพิ่มข้อมูลผู้ส่งใหม่เพื่อสร้างผู้ใช้สำหรับ...ของคุณ`,
"label.ccpeak.addwhere.condition":`สามารถเพิ่มเงื่อนไข where`,
"label.datamove.total":`มีทั้งหมด`,
"label.tianyancha.businessverify.warning":`โปรดทราบว่า การทวนสอบครั้งนี้รองรับแค่ข้อมูลผู้ประกอบธุรกิจที่ลงทะเบียนในจีนแผ่นดินใหญ่เท่านั้น`,
"label.emailmainbody":`ข้อความอีเมล`,
"label.justadmin":`เฉพาะผู้ดูแลระบบ`,
"label.data.downpage.e.list.desc1":`ข้อมูลที่แสดงในหน้านี้เป็นไฟล์ที่ส่งออกสำเร็จแล้ว โปรดดาวน์โหลดไฟล์ที่ส่งออกให้ทันเวลาตามข้อมูลที่แจ้งในอีเมล`,
"label.reportsSubscriptionPage.email.value":`ค่าที่พร้อมใช้งาน`,
"message.error.serviceappointment":`โปรดกรอกแผนเวลาเริ่มต้นและแผนเวลาสิ้นสุดในการนัดหมายบริการก่อน`,
"label.textMessageObject.selectone":`โปรดเลือกอย่างน้อยหนึ่งบันทึกเป็นผู้รับข้อความสั้น`,
"label.schedulejob.setup.schedule.plan":`แผน`,
"label.assignment.layout.field.isassigned":`ใช้เกณฑ์การมอบหมายที่ถูกต้องเพื่อมอบหมาย`,
"label.captcha.error":`รหัสยืนยันไม่ถูกต้อง!`,
"mobel_web_not_more_data":`ไม่มีข้อมูลเพิ่มเติม`,
"label.emailsync.form.emailaddress":`ที่อยู่อีเมล`,
"label.loginservice.error":`การเข้าสู่ระบบเกิดข้อผิดพลาด โปรดติดต่อผู้ดูแลระบบ`,
"label.integrations.description":`เชื่อมต่อบัญชี CloudCC ของคุณกับแอปพลิเคชันอื่นๆ ในระบบนิเวศของแอปธุรกิจ`,
"vue_label_homepage_notice_selectone":`โปรดเลือกลีดหรือผู้ติดต่ออย่างน้อย 1 ราย`,
"label.chatter.default":`ค่าเริ่มต้น`,
"label.tabpage.datefield":`เมื่อฟิลด์วันที่เท่ากัน คุณสามารถใช้ "เมื่อวาน", "วันนี้", "พรุ่งนี้", "เดือนที่แล้ว", "เดือนนี้", "เดือนหน้า", "สัปดาห์ที่แล้ว", "สัปดาห์นี้", "สัปดาห์หน้า "หรือรูปแบบ " YYYY-MM-DD, MM / DD / YYYY "`,
"front-kefu-moudle-myzdhsc-file":``,
"label.createname":`ผู้สร้าง`,
"label.mobile.phone.enter.plan":`ใส่แผนที่นี่`,
"report.label.highlevelreport":`รายงานขั้นสูงสามารถช่วยคุณสร้างรายงานที่เกี่ยวข้องกับออบเจ็กต์ได้มากที่สุด 4 รายการ`,
"label.edit.select.label":`วิธีแก้ไข`,
"label.partnerCloud.financeSetting.deduction":`หลังจากเปิดใช้งานออบเจ็กต์บัญชีเงินคืน รายได้เงินคืน และค่าใช้จ่ายเงินคืนจะถูกเพิ่มเข้ามา และผู้ใช้พาร์ทเนอร์จะสามารถใช้ยอดคงเหลือในบัญชีเงินคืนเพื่อหักยอดเงินเมื่อชำระเงินได้`,
"message.duplication.label.updateoption":`ดำเนินการเมื่ออัปเดต`,
"label.custom.CurrentCQ":`ไตรมาสที่กำหนดเองปัจจุบัน`,
"front-kefu-moudle-wait":``,
"sunday":`วันอาทิตย์`,
"label.service.timezone":`โซนเวลา`,
"setup.layout.label.selectfield":`เลือกฟิลด์`,
"label_emailtocloudcc_filed_action":`ดำเนินการ`,
"label.forecast.customforecast.mycommit":`ข้อผูกมัดของฉัน`,
"label.uploadsuc":`การอัปโหลดสําเร็จ`,
"vue_label_commonobjects_view_notice_atleast1field":`เลือกฟิลด์แสดงผลอย่างน้อย 1 ฟิลด์`,
"label.dataimport.khmc.length":`เกิดข้อผิดพลาด: ชื่อลูกค้ายาวเกินไป`,
"label.isemailnotification":`แจ้งเตือนทางอีเมลใช่หรือไม่`,
"label.addAPPexchange":`เพิ่มแอปพลิเคชัน AppExchange ...`,
"label.partnerCloud.orderingPlatform.currency":`สกุลเงิน:`,
"UG_quota_02":`ใบเสนอราคาเป็นข้อกำหนดทางกฎหมายที่เกี่ยวกับการเสนอขายผลิตภัณฑ์ที่ระบุในเวลาที่กำหนดและในราคาที่กำหนดระหว่างลูกค้าและซัพพลายเออร์`,
"label.customer.tab.step2.same.option3":`ซ่อนแท็บ`,
"H":`โทรศัพท์`,
"label_tabpage_searchz":`ค้นหา`,
"vue_label_homepage_deleted":`ถูกลบแล้ว`,
"label.weixin.recent.view":`มุมมองที่ดูล่าสุด`,
"template.report.opportunity.sales":`ยอดขายของโอกาสทางธุรกิจ`,
"label.customfields.new.step2.opration.unique.info.v1":`ถือว่า ABC "และ" abc "เป็นค่าที่ซ้ำกัน (ไม่ไวต่ออักษรใหญ่เล็ก)"`,
"savesuccess":`การบันทึกสำเร็จ`,
"label.partner.workspace.member.memo":`ผู้ใช้ทั้งหมดของโปรไฟล์และชุดสิทธิ์ที่เลือกสามารถเข้าถึงพาร์ทเนอร์คลาวด์นี้ได้`,
"label.icon.23":`ยา`,
"lable.batchadd.service.cfq.before":`ทริกเกอร์ (Before Insert)`,
"label.instrumentPanel.breakpointTwoLabelname":`ค่าต้องมากกว่าค่าต่ำสุดและค่าเบรกพอยต์ 1`,
"message.selectgsummaryinformation":`กรุณาเลือกข้อมูลสรุป`,
"label.tianyancha.businessverify.msg6":`ฟังก์ชันนี้ใช้บริการของบุคคลที่สาม อาจมีความไม่แน่นอนของประสิทธิภาพเนื่องจากการใช้งานพร้อมกันสูง สถานการณ์ที่ไม่สามารถให้บริการได้ CloudCC จะไม่ร่วมรับผิดชอบใดๆ`,
"vue_label_helpcenter_report3":`3. A. คลิกช่องค้นหาฟิลด์ หลังจากเลือกฟิลด์หรือเลือกรายการแบบดึงลงของฟิลด์ที่ต้องการค้นหา เลือกตัวดำเนินการของฟิลด์ ป้อนหรือเลือกค่าแล้วกดนำไปใช้หลังจากที่ตัวกรองฟิลด์แสดงผล <br>    B. คลิก“＋”ตรงช่องค้นหาด้านบน，ไปที่“กล่องเงื่อนไขตัวกรอง” แล้วป้อนเงื่อนไขตัวกรองขั้นสูงซึ่งประกอบด้วยตัวเลขและตัวอักษร เช่น（1 and 2）or3 <br>แก้ไขตัวกรอง<br>    หากต้องการแก้ไขตัวกรอรวมถึงตัวกรองมาตรฐาน ให้กดไปที่ตัวกรอง<br>ลบตัวกรอง<br>    กด“×”บนตัวกรองเพื่อลบตัวกรอง  <br>เรียกใช้รายงาน<br>    คลิกปุ่ม “เรียกใช้” ที่มุมบนขวาของหน้าเพื่อดูรายงานที่สมบูรณ์ <br>บันทึกรายงาน<br>    กดปุ่ม “บันทึก” ที่มุมขวาบนของหน้าแก้ไข กรอกชื่อรายงาน เลือกโฟลเดอร์แล้วบันทึก <br>2. สร้างโฟลเดอร์รายงาน<br>    หากยังไม่เคยสร้างโฟลเดอร์รายงานมาก่อน ระบบจะสร้าง “โฟลเดอร์รายงานที่กำหนดเองของฉัน” และ “โฟลเดอร์รายงานที่ยังไม่ได้จัดเก็บถาวร”ตามค่าเริ่มต้น <br>    ขั้นตอนที่ 1：กดที่สร้างโฟลเดอร์รายงานบนแท็บรายงาน<br>    ขั้นตอนที่ 2：ในหน้าต่างที่ปรากฏขึ้นมาของโฟลเดอร์รายงานใหม่ สามารถเลือกที่จะถ่ายโอนรายงานในโฟลเดอร์รายงานสาธารณะและเลือกผู้ใช้ที่มีสิทธิ์เข้าถึงโฟลเดอร์นี้ <br>3. ดูรายงาน<br>    ขั้นตอนที่ 1: เข้าสู่หน้ารายการรายงานจากแท็บรายงาน ไปที่“ดูล่าสุด”“สร้างโดยฉัน”“รายงานทั้งหมด”หรือโฟลเดอร์รายงาน เพื่อเข้าถึงรายงานที่ต้องการดู <br>    ขั้นตอนที่ 2: กดไปที่ชื่อรายงาน หรือกด “ปุ่มแบบดึงลง” ที่ด้านขวาของรายงาน แล้วเลือก “เรียกใช้” เพื่อดูรายงาน<br>    หากเป็นผู้ดูแลระบบ ให้ไปที่หน้ารายงาน แล้วคลิกไอคอน “ฟันเฟือง”ที่อยู่ถัดจากปุ่ม“สร้างโฟลเดอร์รายงานใหม่” จะสามารถเลือกฟิลด์ที่แสดงรายการของรายงานในแต่ละโฟลเดอร์<br>4. ส่งออกรายงาน<br>    ขั้นตอนที่ 1: จากหน้ารายการรายงาน เข้าสู่หน้ารายการรายงาน ค้นหารายงานที่คุณต้องการส่งออกแล้วกด "ปุ่มแบบดึงลง" ที่ด้านขวาสุดของรายงาน <br>    ขั้นตอนที่ 2: เลือกประเภท<br>    รูปแบบรายงาน: ประกอบด้วยส่วนหัวของรายงาน,  การจัดกลุ่ม และรายละเอียดการกรอง <br>    รายละเอียดของรายงานเท่านั้น:  รายละเอียดบรรทัดที่ไม่ได้จัดรูปแบบ <br>    ขั้นตอนที่ 3: กด“ส่งออก” ในส่วนของรายงานรูปแบบข้อมูลโดยละเอียดที่ต้องการส่งออกนั้น สามารถส่งออกข้อมูลได้สูงสุด 2,000 รายการ`,
"label.batchdelete.success":`การลบแบบกลุ่มสำเร็จ`,
"label.newprocess5.seq":`ลำดับ`,
"label.knowledgebase.data.translated.successfully":`การแปลข้อมูล {a} รายการสำเร็จ`,
"label_enable_range":`เปิดใช้งานช่วง`,
"label.ccchat.and":`และ`,
"label.assignment.setup.list.norule":`ไม่มีเกณฑ์การมอบหมาย`,
"vue_label_report_summaryformulacolumn":`คอลัมน์สูตรสรุป`,
"label.field.edit.change1":`คะแนนสูงสุดต้องไม่มากกว่า 100`,
"syntaxerror":`ไวยากรณ์ผิดพลาด โปรดตรวจสอบเงื่อนไขที่คุณป้อนอีกครั้ง`,
"label.icon.116":`บ้าน`,
"lable.asset.BOM.according.to.product":`สร้าง BOM สินทรัพย์ตามโครงสร้างผลิตภัณฑ์`,
"chatter.like.post":`ผู้ที่ชื่นชอบโพสต์นี้`,
"label.trigger.page":`หน้าทริกเกอร์`,
"vue_label_email_contact_adminstrator":``,
"label.workreport":`รายงานการทํางาน`,
"vue_label_homepage_edit_card_view":`แก้ไขมุมมองการ์ด`,
"label_emailsync_status_disabel":`ปิดการใช้งาน`,
"label.icon.54":`รถขุด`,
"message.error.view.validerr.common":`การยืนยันล้มเหลว`,
"label.exchange.sync.account.username":`ชื่อผู้ใช้บัญชีบริการ (ชื่อผู้ใช้โดเมนหรือ UPN):`,
"label.dataimport.error.date":`เกิดข้อผิดพลาด: วันที่`,
"label.orgname":`องค์กร`,
"label.weixin.group.owner":`เจ้าของ`,
"vue_label_dashboard_colorrange":`ช่วงสี`,
"label.forecast.shrepage.tableth":`พยากรณ์การเข้าชม`,
"label.related.disabled":`ไม่ได้เปิดใช้งานรายการที่เกี่ยวข้อง โปรดติดต่อผู้ดูแลระบบ เพื่อเปิดใช้งานรายการที่เกี่ยวข้องในเค้าโครงเพจ`,
"label.version.product.management":`การจัดการผลิตภัณฑ์`,
"label.knowledge.new.article.published":`บทความที่เผยแพร่เป็นบทความใหม่`,
"label.sendsms.batch.step4":`ขั้นตอนที่ 4: คุณได้ส่งข้อความสั้นสําหรับการประมวลผล`,
"vue_label_commonobjects_detail_and_tasks":`ยินดีด้วย, ไม่มีที่ภารกิจและอิเวนต์ที่ยังไม่ได้จัดการ`,
"label.salescloud.ci":`ครั้ง`,
"label.ccpeak.getapi.name.time":`หากคุณต้องการใช้เมธอดใน CCService คุณต้องสร้างอินสแตนซ์`,
"label.escalation.setup.detail.conditon":`เงื่อนไข`,
"label.lbs.isUseLbs":`เปิดใช้งานบริการระบุตำแหน่ง`,
"front-lightning-module-v1-dashborad-color-depth":`ความเข้มของสี`,
"date":`วันที่`,
"label.select.personnel":`เลือกพนักงาน`,
"label.appointmentpage.wizard.notif3":`กรุณากรอกอีเมล`,
"label.import.page1.pleaseselectwayofdealdata":`โปรดเลือกวิธีการประมวลผลก่อน`,
"label.partner.all.memo":`รายการแสดงทุกพาร์ทเนอร์คลาวด์ในองค์กร คลิก URL เพื่อตรงไปที่หน้าเข้าสู่ระบบ`,
"label.appointment.wizard.subtitle4-3-3":`30 นาที`,
"component_telerecord_label_subject":`หัวข้อ`,
"label.sendsms.batch.finish":`ส่งข้อความสั้นแบบกลุ่ม: สำเร็จ`,
"label.login.access.myusername":`ชื่อผู้ใช้ของฉัน`,
"label.weixin.wechatnumber":`รหัสวีแชท`,
"label.eowechat.status":`สถานะผู้ใช้`,
"Lead_Scoring_Setting_Rule_Setup_Value":`คะแนน`,
"label.appexchange.oldreport.noupload":`รายงานเก่า-อัปโหลดไม่ได้`,
"label.approverfieldediting":`การแก้ไขฟิลด์ผู้อนุมัติและบันทึก`,
"label_tabpage_customernamez":`ชื่อลูกค้า`,
"vue_label_dashboard_linkagesettings":`การตั้งค่าการเชื่อมโยง`,
"vue_label_ccchart_notice_deletecomment":`ยืนยันว่าจะลบความคิดเห็นนี้หรือไม่?`,
"label.allprofile":`โปรไฟล์ทั้งหมด`,
"label.campaignmember.main.addMember":`เพิ่มสมาชิก-ค้นหา`,
"label.projectManagement.subtask.list":`รายการงานย่อย`,
"label.code.some.size":`ความจุรหัส : รองรับอักขระสูงสุด 200KB ประมาณ 200,000 ไบต์`,
"front-custom-service":`Service Cloud ช่วยให้ลูกค้าได้รับบริการที่ปรับตามความต้องการของลูกค้าได้อย่างมีประสิทธิภาพและคล่องตัว การใช้ระบบใบสั่งงานอัจฉริยะจะช่วยลดเวลาในการแก้ไขปัญหาการบริการ เพิ่มอัตราการแก้ปัญหา เพิ่มความจงรักภักดีของลูกค้า และเพิ่มอัตราการซื้อซ้ำ`,
"label.SMS.det":`รายละเอียดข้อมูลการแจ้งเตือนทางข้อความสั้น`,
"setup_layout_label_nobutton":`ไม่มีตัวเลือกปุ่ม`,
"vue_label_email_Could_not_save_template":`ไม่สามารถบันทึกแม่แบบ`,
"label.imgfield.height":`ความสูง`,
"label.leadscore":`การให้คะแนนลีด`,
"setup_object_field_dependency_label_removefromlist":`ลบค่าที่เลือก`,
"message.error.code.null":`รหัสการให้สิทธิ์ต้องไม่ว่างเปล่า!`,
"label.tianyancha.businessscope":`ขอบเขตธุรกิจ`,
"vue_label_chat_empty_message":`ล้างข้อความ`,
"label.total":`รวม`,
"label.delerror.list":`รายการไฟล์ที่ไม่ได้ลบ`,
"label.selectedreceivers":`ผู้รับที่เลือก`,
"label.layout.availablepages":`หน้าเพจพร้อมใช้งาน`,
"label.pc.ui.2018.personalinfo":`ข้อมูลส่วนตัว`,
"label.chat.topic.edit.detial":`แก้ไขรายละเอียดข้อมูล`,
"label.mr.descreption.reDataList1":`ที่`,
"label.document.value.too.long":`ไฟล์นี้มีขนาดเกิน 5M!`,
"lable.opppdt.addpdt.table.listprice":`ราคาคงที่`,
"label.selectoperate":`เลือกการดำเนินการ`,
"label.icon.5":`สกุลเงิน`,
"label.icon.126":`เตียงคนไข้`,
"label.hiddensearch":`ซ่อนการค้นหา`,
"label.view.sortview.exportble":`สามารถส่งออกได้`,
"vue_label_homepage_noassignee":`ไม่มีผู้มอบหมาย`,
"label.knowledgebase.close.and.resolve":`ปิดและแก้ไข`,
"label.licence.used":`จำนวนใบอนุญาตที่ใช้`,
"label.newprocessstep5":`ขั้นตอนที่ 5 เลือกฟิลด์ที่จะแสดงในเค้าโครงเพจการอนุมัติ`,
"vue_label_appstore_all_applications":`แอปพลิเคชันทั้งหมด`,
"label.no.edit.permission":`ไม่มีสิทธิ์แก้ไขบันทึกที่เลือก และไม่สามารถเลือกได้`,
"vue_label_calendar_calendar_added_successfully":`การเพิ่มปฏิทินสำเร็จ`,
"report_line":`ฟิลด์ข้อมูล`,
"component.chatter.link.label.name":`ชื่อลิงก์`,
"label.data.expnode.e_desc1":`1. การส่งออกแบบกำหนดเอง: ผู้ใช้สามารถเลือกฟิลด์ที่จะส่งออกและเงื่อนไขในการกรองตามความต้องการของตนเอง`,
"label.tabularreport.step4":`ขั้นตอนที่ 4: เลือกมาตรฐานของรายงาน`,
"Opportunity.Detailed.Phase.Change.Text.001":`เปลี่ยนสเตจของโอกาสทางธุรกิจ`,
"label.quickbooks.searchresault.action":`ปฏิบัติการ`,
"component_timeline_label_today":`วันนี้`,
"label.callboard.remark":`ป้อนประกาศบริษัทขององค์กรคุณด้านล่าง`,
"label.campagin.field.choose":`เลือกฟิลด์ที่จะอยู่ในหน้าการลงทะเบียนแคมเปญ`,
"front-gantt-module-rolling-temporary-tasks":``,
"label.file.des":`คำอธิบาย`,
"Dashboard_View_RecentlyView":`ดูล่าสุด`,
"UG_Account_04":`คิวรีการกรองลูกค้าแบบพาสซีฟ`,
"chatter.refresh":`รีเฟรช`,
"label.tianyancha.companyorgtype":`ประเภทบริษัท`,
"label.chatter.dateRange":`ช่วงวันที่`,
"label.campagin.step3":`ขั้นตอนที่ 3: สร้างหน้าเพจ`,
"label.appointmentdetail.wizard.title14":`แผนงานวันจันทร์`,
"setup.object.field.dependency.button.setdependency":`ตั้งค่าการพึ่งพาของฟิลด์`,
"serviceterritorymember.serviceterritory.isactive.notactive":`ไม่ได้เปิดใช้งานภูมิภาคให้บริการนี้ คุณสามารถเพิ่มได้เฉพาะสมาชิกพื้นที่ให้บริการในภูมิภาคให้บริการที่เปิดใช้งาน`,
"template.chart.ygydyj":`การปิดการขายสำเร็จของพนักงาน`,
"label.tag.edittags":`แก้ไขป้ายกำกับ`,
"label.clone":`คัดลอก`,
"front-electronic-signature-setting-intro1":``,
"label_reach":`บรรลุ`,
"label.tabpage.havez":`มี`,
"label.email.clearCase":`ล้างเฉพาะอีเมลที่ไม่เกี่ยวกับเคส`,
"label.customer.tab.all":`แท็บทั้งหมด`,
"label.direct.dashboard.day.report":`รายงานประจำวันใหม่`,
"label_tabpage_exportview":`ส่งออกมุมมอง`,
"label.passwordPolicy.setup.maxFailTimes":`จำนวนครั้งสูงสุดที่ป้อนรหัสผ่านผิดได้`,
"label.processsetting.complete.enable":`เสร็จสิ้นและเปิดใช้งาน`,
"label.marketsea.memberfield":`สมาชิกดูฟิลด์ได้`,
"label.report.export.format.title":`รูปแบบรายงาน`,
"label.recycle.execute.title":`กำลังล้างถังขยะรีไซเคิล`,
"label.file.use.most.user":`ผู้ใช้ที่ใช้พื้นที่เก็บข้อมูลมากที่สุด`,
"report_type_label_systemReport":`รายงานระบบ`,
"label.customobjects.majorobject":`ออบเจ็กต์หลัก`,
"label.file.delete.public.link":`ลบลิงก์สาธารณะ`,
"front-epwechat-module-v1-id":`ID วีแชทขององค์กร`,
"label.partner.common.roleNum":`จำนวนบทบาท`,
"label.sendtonextapprover":`ส่งไปยังผู้อนุมัติรายถัดไป`,
"label.notification.tip3":`โหลดเพิ่มเติม 10 รายการ`,
"label.tabpage.placeenterz":`โปรดระบุ`,
"label.mobile.phone.cc.people":`สำเนาถึง`,
"component_setup_iframe_label_inputurlmemo":`กรุณาป้อน URL ของเพจที่จะนำเข้า`,
"label.umeng.activity.statuschange":`สถานะของภารกิจที่คุณมอบหมายให้กับ#nameเปลี่ยนเป็น#newstatus`,
"label.step3.restricted.visibility":`ขั้นตอนที่ 3. จำกัดการมองเห็น`,
"label.multilang.datadelete.approvedata":`บันทึกที่อยู่ระหว่างการอนุมัติ（{0} รายการ）：`,
"label.reportsSubscription.save":`บันทึก`,
"label.emailobject.template.visibility":`การมองเห็น`,
"label_partner_step3":`ขั้นตอนที่ 3: ข้อมูลพื้นฐาน`,
"label.product.across":`ข้ามสมุดราคา`,
"label.same.analyze.opportunity.name":`ชื่อโอกาสทางธุรกิจ`,
"label.chatter.memotel":`บันทึกการโทร`,
"label.recentview.seloption2":`ฉันสร้างล่าสุด`,
"label.ccchat.message.search.desc1":`เราไม่พบสิ่งที่มี`,
"label.reportexport":`ส่งออก`,
"label.service.gantt.drop.tip":`สิทธิ์ไม่เพียงพอ: คุณมีสิทธิ์ไม่เพียงพอที่จะทําเช่นนี้ โปรดติดต่อผู้ดูแลระบบ`,
"label.australian.westem.standard.time":`เวลามาตรฐานตะวันตก (ออสเตรเลีย)`,
"label.emailobject.email":`อีเมล`,
"Homepage_Contract_FieldMissed_DoesntSupport":`ฟิลด์ "qdrq" และ "htje" หายไปจากออบเจ็กต์สัญญาแสดงข้อมูลไม่ได้`,
"label.email.cancel.upload.info":`จะยกเลิกการอัปโหลดที่กำลังดำเนินการทั้งหมด`,
"label.page.copy.merged.field.value":`คัดลอกค่าฟิลด์ผสาน`,
"UG.ST.006":`การเข้าถึงโดยตรง`,
"label.trigger.service.connot.access":`ชุดคำสั่งที่เข้าถึงไม่ได้`,
"label.projectManagement.new.tasks":`งานใหม่`,
"lable.SalesCommitmentKanBan.receiptsRate":`อัตราการเก็บเงินสำเร็จ`,
"label.productsales.oppor.overdue":`โอกาสทางธุรกิจที่ค้างชำระ`,
"vue_label_pool_convertedbyme":`ที่แปลงโดยฉัน`,
"label.loginip.pagecue.invalidt":`ที่อยู่ Internet เริ่มต้นมีมากกว่าที่อยู่ Internet ปลายทาง หรือที่อยู่ Internet ไม่ถูกต้อง`,
"label.campagin.roi.xyzj":`การตอบสนองทั้งหมด`,
"label.visualpage.list.title":`เปิดใช้งานการเข้าถึงเพจที่กำหนดเอง`,
"chatter.feed.searchinitvalue":`พิมพ์ชื่อ ...`,
"label.export_submission":`ส่งออกข้อมูลการส่ง`,
"this.season":`ฤดูกาลนี้`,
"label.forecast.settings.gx":`การแบ่งปันข้อมูลพยากรณ์`,
"label.tag.addtags.tagcolour":`สีป้ายกำกับ`,
"label.api":`ชื่อ API`,
"label.bulk.delete":`ลบแบบกลุ่ม (ถาวร)`,
"label.reportsSubscriptionPage.condition.emailoption":`ตัวเลือกอีเมล`,
"vue_label_dashboard_newdashboardsuccessfully":`แดชบอร์ดใหม่สำเร็จ`,
"three":`สาม`,
"label.prompt":`แจ้งเตือน`,
"label.same.analyze.contact.phone":`โทรศัพท์มือถือผู้ติดต่อ`,
"label.icon.62":`ไปป์ไลน์`,
"label.forecast.shrepage.tableth.isnable":`อนุญาตให้ส่ง`,
"label.multilang.polloption.vote":`{0} คะแนน`,
"label.customfields.totalsummary.selecttotaltype":`เลือกประเภทการรวม`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`อัตราข้อผูกมัดที่เก็บเงินได้`,
"label.areaAndSub":`ภูมิภาคและภูมิภาคย่อย`,
"vue_label_pool_recycle":`รีไซเคิล`,
"lable.outlook.detail.synset":`การตั้งค่าการซิงค์`,
"label.quote.detail.introduce":`ใส่คีย์เวิร์ดและคลิก "ค้นหา" เพื่อเริ่มการค้นหา หลังจากค้นหาแล้วคลิก "เลือก" เพื่อเข้าสู่ขั้นตอนถัดไป`,
"label.profile.customappset":`ตั้งค่าแอปพลิเคชันที่กำหนดเอง`,
"label.changemylanguage":`เปลี่ยนภาษา`,
"message.approval.plzcapppor":`กรุณาเลือกผู้อนุมัติ`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`ปฏิทินสาธารณะและทรัพยากร`,
"label.wtd.changefields.title.desc1":`เลือกฟิลด์ที่จะใช้ในเพจ ป้อน URL ที่ส่งคืนแล้วคลิกปุ่มสร้างเพื่อสร้างเพจ`,
"label.weixin.voting.not.empty":`ตัวเลือกการโหวตไม่สามารถว่างเปล่า`,
"label.campaign.channel.equal":`เท่ากับ`,
"label.emailobject.emaildetail.button.back":`ย้อนกลับ`,
"label.ccchat.person.invite.allowemails":`เพื่อความปลอดภัย กรุณาใส่ที่อยู่อีเมลต่อท้ายด้านล่างเท่านั้น`,
"label.notEdit.message":`ขออภัย คุณไม่มีสิทธิ์แก้ไขข้อมูลนี้ โปรดติดต่อผู้ดูแลระบบ`,
"label.layout.selectedfields.relatedlist":`เลือกฟิลด์/รายการที่เกี่ยวข้อง`,
"label.weixin.voting.deadline":`หมดเวลาการโหวต`,
"label.document.upload":`เอกสารที่ต้องการจะอัปโหลด`,
"label.import.page2.notmatchfiled":`ในไฟล์มีทั้งหมด {{?csvfiledlength?}} ฟิลด์ เหลืออีก {{difflength}} ฟิลด์ที่ยังไม่ได้แม็ป`,
"label.data.exp.selzippwd":`ไม่กรอกค่าเริ่มต้นของรหัสผ่านแตกไฟล์`,
"label.user.step2.select.email.template":`ขั้นตอนที่ 2. เลือกแม่แบบอีเมล`,
"label.currency.effective":`สกุลเงินที่มีผล`,
"label.version.control.type":`ประเภทของรุ่น`,
"label.projectManagement.Taskorproblem":`งาน/ปัญหา`,
"label.everyweek":`ทุกสัปดาห์`,
"label.passwordPolicy.setup.pwdremember4":`จำ 4 รหัสผ่าน`,
"label.emailobject.groupemail":`อีเมลกลุ่ม`,
"label.approvepagelayout1":`หลายคนใช้เค้าโครงหน้าเดียวกัน`,
"label.integrations.mailchimp.massage5":`หลังจากที่คุณนำเข้าลีดและผู้ติดต่อในระบบไปยัง MailChimp คุณจะสามารถส่งอีเมลทุกประเภทแบบกลุ่มไปยังผู้รับที่กำหนดได้`,
"label.icon.22":`เพิ่ม`,
"Dashboard_View_All":`แดชบอร์ดทั้งหมด`,
"label.import.page2.example":`ตัวอย่าง`,
"label.send.letter":`ส่งจดหมายเชิญ`,
"label.mobilesectionpart":`ส่วนของเว็บเพจอุปกรณ์มือถือ`,
"component_setup_tabs_label_title":`Tab เพจ`,
"label.knowledgebase.results":`{a} ผลลัพธ์`,
"label.field.remark":`ปรับใช้กับ`,
"vue_label_systemSettings_url":`การตั้งค่าชื่อโดเมน`,
"vue_label_SMS_failed_find_view_list":`ไม่พบรายการมุมมอง`,
"setup_layout_label_order":`เกณฑ์การเรียงลำดับ`,
"label.customsetting.touse":`ใช้การตั้งค่าแบบกำหนดเอง customSetting`,
"label.product.enter":`ป้อนคีย์เวิร์ดเพื่อค้นหาสินค้าที่ตรงกัน`,
"label.email.template.private.SMS":`โฟลเดอร์แม่แบบข้อความสั้นส่วนตัว`,
"vue_label_homepage_chart_deleted":`ลบแผนภูมิและแดชบอร์ดแล้ว`,
"label.conversion_pages":`แปลงหน้าเพจ`,
"label.compact.layout.select":`เลือกฟิลด์เค้าโครงข้อมูลสำคัญ`,
"report_label_folderandreport":`รายงานและโฟลเดอร์`,
"label.product.entry":``,
"label.campaignmember.main.manageMember":`จัดการสมาชิก`,
"front-QBtoCC-changing":``,
"vue_label_pool_abandonreason":`เหตุผลในการทิ้ง`,
"template.report.customer.contract.statistics":`สถิติสัญญาของลูกค้า`,
"label.invoice.message.sendsuccessully":`การส่ง Invoice สำเร็จ`,
"label.addcurrentoperate":`เพิ่มการทำงานปัจจุบัน`,
"label.customerinfo.mailpwd":`ส่งรหัสผ่านอีเมล`,
"batch.nochange.owner":`ไม่อนุญาตให้เปลี่ยนเจ้าของข้อมูล!`,
"label_tabpage_uploadfailez":`การอัปโหลดล้มเหลว โปรดอัปโหลดใหม่อีกครั้ง`,
"vue_label_systemSettings_mobelqrsetting":`การตั้งค่าการสแกนบนอุปกรณ์มือถือ`,
"label.regular_field":`ฟิลด์แบบฟอร์ม`,
"label.tabpage.delsuccessz":`การลบสำเร็จ`,
"label.Days.Before.Horizontal.Date":`จำนวนวันก่อนวันที่แนวนอน`,
"label.evaluation.general":``,
"chatter.notlike.p":`เลิกชอบโพสต์นี้`,
"label.chatter.send":`ส่ง`,
"label.emailsync.button.cancel":`ยกเลิก`,
"label.notification.task4":`ภารกิจของคุณครบกำหนดวันนี้`,
"vue_label_helpcenter_detail1.2":`เปลี่ยนสถานะภารกิจอย่างรวดเร็ว: ทำเครื่องหมายที่กล่องด้านหน้าภารกิจในโมดูล “เกินกำหนดและกำลังจะถึง” แล้วคลิกปุ่มรีเฟรชเพื่อเปลี่ยนสถานะเป็น “เสร็จสิ้น” อย่างรวดเร็ว <br>ก่อนรีเฟรช ให้ยกเลิกการเลือกสถานะภารกิจโดยไม่เปลี่ยนแปลง <br>ภารกิจที่มีความสำคัญระดับสูง จะติดไอคอน “ธงแดง” ในไทม์ไลน์ของภารกิจ <br> ลำดับการแสดงไทม์ไลน์ภารกิจ <br>เรียงย้อนกลับตามวันครบกำหนดภารกิจ วันครบกำหนดบันทึกการโทร วันเริ่มต้นอิเวนต์ วันที่ส่งและรับอีเมล และ วันที่ส่งและรับข้อความสั้น หากเป็นวันที่เดียวกันจะเรียงย้อนกลับตามเวลาสร้างบันทึก <br> ตัวกรองไทม์ไลน์อิเวนต์ <br>ใช้ตัวกรองไทม์ไลน์อิเวนต์เพื่อจำกัดรายการที่มองเห็น เน้นที่รายการที่สำคัญ และค้นหารายการเป้าหมาย ตัวกรองนี้มีสามประเภท ได้แก่ ช่วงวันที่ อิเวนต์ที่แสดง และประเภทอิเวนต์<br> อิเวนต์ที่จะแสดง: อิเวนต์ทั้งหมด อิเวนต์ของฉัน<br> ในตัวกรองไทม์ไลน์อิเวนต์ ตัวเลือกนี้สามารถจำกัดช่วงการแสดงผลอิเวนต์ได้ <br> อิเวนต์ของฉัน: แสดงอิเวนต์ที่คุณเข้าร่วม ไม่ว่าจะเป็นเจ้าของหรือผู้เข้าร่วม เช่น คุณเป็นผู้ส่งอีเมลหรือจัดอิเวนต์ หรือเมื่อคุณเป็นผู้รับสำเนาหรือสำเนาลับของอีเมล แสดงว่าคุณเข้าร่วมในกิจกรรม <br>`,
"component_chatter_post_label_title":`เผยแพร่`,
"label.data.dataexptemplate.desc":`แม่แบบส่งออกข้อมูลคือแม่แบบที่ผู้ใช้สร้างขึ้นเพื่อส่งออกข้อมูล ใช้เพื่อความสะดวกรวดเร็วในการดำเนินการส่งออกของผู้ใช้`,
"label.helptext":`ข้อความช่วยเหลือ`,
"vue_label_norm_removecomponent_certify":`ยืนยันการลบส่วนเสริม`,
"front-template-V1-Click-new-template":`คลิก "ใหม่" เพื่อสร้างแม่แบบใหม่ คุณสามารถใช้แม่แบบเมื่อเปิดใช้งาน`,
"label.optional_fields":`ฟิลด์ตัวเลือก`,
"label.delete_about":`คุณต้องการลบ`,
"chatter.feed.initvalue":`คุณกําลังทําอะไรอยู่?`,
"label.mail.configure":`กำหนดค่าอีเมลส่วนตัวของคุณกับลูกค้า คุณสามารถใช้หน้าแรกของอีเมล CloudCC เพื่อส่งและรับอีเมล และซิงค์อีเมลในอดีตกับลีดและผู้ติดต่อ`,
"label.project.hit.seven":`แจ้งเตือนงานโครงการถึงกำหนด`,
"label.button.upgrade":`ซื้อและแก้ไขรุ่น`,
"lable.PowerProcess.event.name":`ชื่ออิเวนต์สําคัญ`,
"label.weixin.confirm":`ยืนยัน`,
"label.customfields.new.inputformula":`ใส่สูตร`,
"label.standard.buttonandlink.edit":`เขียนแก้ไขปุ่มมาตราฐานหรือลิงก์`,
"workflow.action.tasks.assignortype.createdtype":`ประเภทผู้สร้าง`,
"front-email-payment-paypal-describe":``,
"label.selectexistingoperate":`เลือกการดำเนินการปัจจุบัน`,
"label.workflow":`เวิร์กโฟลว์`,
"label.assignment.setup.detail.ruleentries":`รายการเกณฑ์`,
"label.data.file.i.title.num3":`3. ระบบจะอ่านไฟล์ข้อมูลก่อนที่จะนำเข้าสู่เซิร์ฟเวอร์ จากนั้นเริ่มโปรแกรมนำเข้าหลังบ้านแบบกลุ่ม ผลการนำเข้าจะแจ้งให้ผู้ใช้ทราบทางอีเมล คุณไม่จำเป็นต้องรอในหน้าการดำเนินการนี้`,
"label.use.view":`ใช้มุมมองที่มีอยู่`,
"label.forecast.settings.moren":`ค่าเริ่มต้นสายผลิตภัณฑ์`,
"vue_label_calendar_add_share":`เพิ่มการแบ่งปัน`,
"label_tabpage_newview":`สร้างมุมมองใหม่`,
"label.recycle":`ถังขยะรีไซเคิล`,
"UG_solution_03":`สร้างโซลูชันใหม่`,
"label.customfields.formula.text.tip":`สร้างสตริงข้อความ เช่น โดยการเชื่อมฟิลด์ข้อความอื่นๆ เข้าด้วยกัน`,
"vue_label_file_single_file_size":`ขนาดไฟล์เดี่ยวที่รองรับสูงสุด`,
"label.a.b.least":`บันทึก A" แต่ละบันทึก ต้องมีความสัมพันธ์กับบันทึก "B" อย่างน้อยหนึ่งรายการ`,
"label.validate.function.addtoformula":`แทรกฟังก์ชันที่เลือก`,
"label_tabpage_pleaseSelectz":`กรุณาเลือก`,
"label.account.NextFQ":`ไตรมาสบัญชีถัดไป`,
"label.project.project.name":`ชื่อโครงการซ้ำไม่ได้!`,
"label.emailtocloudcc.filed.owner":`เจ้าของบันทึก`,
"label.textmessage.template.message2":`ฟิลด์ที่แทรกในข้อความสั้นปัจจุบันไม่ตรงกับบันทึกที่เกี่ยวข้องอาจะทำให้ค่าล้มเหลว`,
"label.icon.92":`หนังสือ`,
"label.trailerpage":`หน้าสุดท้าย`,
"component_event_label_noevent":`ดูเหมือนว่าคุณทำงานของวันนี้เสร็จแล้ว`,
"label.trigger.tip":`เกี่ยวกับทริกเกอร์`,
"label.knowledge.case.field.usable":`ฟิลด์เคสพร้อมใช้งาน`,
"label.group.isusing.success":`การเปิดใช้งานสำเร็จ`,
"label.marketsea.nextnotfollowdays":`หลังจากติดตามครั้งที่แล้ว`,
"component.todaytask.label.choicestate":`เลือกสถานะ`,
"label.recordtype.main":`--หลัก--`,
"label.sendletter.step1":`ขั้นตอนที่ 1: ระบุผู้รับจดหมายเชิญ`,
"label_tabpage_saveviewfailed":`การบันทึกมุมมองล้มเหลว`,
"vue_label_report_notiec_selectone":`บันทึกออบเจ็กต์พาเรนต์แต่ละบันทึกต้องเกี่ยวข้องกับบันทึกออบเจ็กต์นี้อย่างน้อยหนึ่งรายการ`,
"UG_opportunity_003":`ติดตามช่องทางการขายของคุณ สร้างแดชบอร์ด`,
"#label.importsourcestep4":`ขั้นตอนที่ 4: นำเข้าไฟล์ของคุณ#`,
"front-kefu-moudle-v1-trrt-tip":``,
"UG.Forcast.09":`ขั้นตอนถัดไป`,
"label.ggReleaseRange.subordinates":`ค้นหาบทบาทและผู้ใต้บังคับบัญชา`,
"label.log.desctiption":`คุณสามารถดาวน์โหลดไฟล์ติดตามการตรวจสอบองค์กรที่มีเนื้อหามากขึ้นได้（ไฟล์ Excel.csv）`,
"label.submitted":`ส่งแล้ว`,
"label.validate.function.funcExplain.BEGINS":`ตรวจสอบว่าข้อความขึ้นต้นด้วยอักขระเฉพาะหรือไม่ หากใช่จะคืนค่า TRUE ไม่ใช่คืนค่า FALSE`,
"label.campaign.channel.code":`รหัสคิวอาร์ช่องทางการขายของแคมเปญ`,
"chatter.group.theLastActivityDate":`วันที่ทำกิจกรรมล่าสุด`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`กรุณาป้อนค่าเบรกพอยต์ 2`,
"label.labeltranslation":`การแปลป้ายกำกับ`,
"label.multilang.product.deleterederect":`การลบ{0}ของคุณไม่สามารถดำเนินการให้เสร็จสิ้นได้ เนื่องจากยังคงมีความสัมพันธ์กับบันทึกในสมุดราคาอื่นๆ บันทึกที่เกี่ยวข้องมีดังนี้`,
"lable.currencyManage.manageRate.dis":`หากต้องการจัดการอัตราแลกเปลี่ยนของออบเจ็กต์อื่นๆ เพิ่มสกุลเงินใหม่ เปิดหรือปิดการใช้สกุลเงิน หรือเปลี่ยนสกุลเงินของบริษัท กรุณาคลิกที่จัดการสกุลเงิน`,
"setup.layout.label.modifypage":`แก้ไขหน้าเพจ`,
"label.import.page2.editforname":`โปรดแก้ไขการแม็ปสำหรับฟิลด์{necessaryName}`,
"label.searchlayout":`เค้าโครงการค้นหา`,
"label.chatter.loadmore":`โหลดเพิ่มเติม`,
"label.trigger.folder.all":`โฟลเดอร์ทริกเกอร์ทั้งหมด`,
"label.export_submissions":`ส่งออกจํานวนการส่งฟอร์ม`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`อัตราภารกิจที่ทำสัญญาทั้งหมด`,
"KeyInformationLayout_DefaultLayout_Name":`ค่าเริ่มต้นระบบ`,
"label.h5.chatter.great":`ถูกใจ`,
"label.call.center.configuration.enable":`ใช้การตั้งค่าต่อไปนี้เพื่อปรับเปลี่ยนว่าจะเปิดใช้งานฟังก์ชัน Call Center ขององค์กรหรือไม่`,
"label.overdate":`วันที่สิ้นสุด`,
"chatter.poll":`โพล`,
"label.login.input.verification.code":`กรุณากรอกรหัสความปลอดภัย:`,
"label.file.sharetype.cooperation":`ผู้ร่วมทีม`,
"label.app.step5":`ขั้นตอนที่ 5. กำหนดโปรไฟล์`,
"front-gantt-module-save-order":``,
"label.globalselect.toallrecord":`เพิ่มค่ารายการตัวเลือกใหม่ให้กับชนิดบันทึกทั้งหมดที่ใช้ชุดค่าโกลบอลนี้`,
"setup.mainpage.label.welcome24":`แพลตฟอร์มคลาวด์ CloudCC ให้การตั้งค่าการเข้าถึงอย่างปลอดภัยสำหรับข้อมูลออบเจ็กต์ทั้งหมดในระบบซึ่งสามารถควบคุมการแบ่งปันข้อมูลและสิทธิ์การเข้าถึงโดยการตั้งค่ากฎเกณฑ์และเงื่อนไขต่างๆ`,
"homepage.layout.desctiption":`คุณสามารถสร้างเค้าโครงแท็บต่างๆ สำหรับหน้าแรกได้ในหน้านี้`,
"vue_label_SMS_notice_send_sussess":`ข้อความสั้นส่งเรียบร้อยแล้ว`,
"label.projectManagement.overdue":`เกินกําหนด`,
"label.assignment.setup.list.lead.description":`ใช้เกณฑ์การมอบหมายลีดเพื่อส่งลีดไปยังผู้ใช้ที่เกี่ยวข้องโดยอัตโนมัติ เกณฑ์การมอบหมายลีดประกอบด้วยเงื่อนไขที่กำหนดไว้สำหรับลีดและรายการกฎเกณฑ์หลายรายการ`,
"label.list.projectSetting.des":`ใช้การตั้งค่าต่อไปนี้เพื่อปรับเปลี่ยนว่าจะส่งอีเมลภายใต้โครงการหรือไม่`,
"setup.mainpage.label.welcome18":`การตั้งค่าสิทธิ์ระดับองค์กรของ CloudCC ช่วยให้คุณสามารถควบคุมการเข้าถึงของผู้ใช้แต่ละรายเมื่อทํางานกับข้อมูลและโมดูล การตั้งค่าสิทธิ์ตามบทบาทยังรวมถึงตำแหน่ง กลุ่ม บทบาท กฎการแบ่งปันข้อมูล การควบคุมความปลอดภัยระดับเฟิลด์ของผู้ใช้ ตระหนักถึงการแบ่งปันข้อมูลระหว่างบุคคลและแผนกต่างๆ ขององค์กร`,
"label.ratio":`อัตราการเติบโต`,
"label.Xaxis":`แกน X`,
"label.google.map":``,
"Dashboard.SelectBoardToDisplay":`โปรดเลือกแดชบอร์ดที่แสดงในแท็บเพื่อเปิดแดชบอร์ด`,
"label.data.newtemplate.e_conditions":`เงื่อนไขการส่งออก`,
"label.emailtocloudcc.description3":`เพิ่มอีเมลธุรกิจของคุณ เช่น sales@company.com, info@company.com, และsupport@company.com ที่นี่ ระบบจะสร้างลีดหรือเคสตามอีเมลที่ได้รับโดยอัตโนมัติ เพื่อให้แน่ใจว่าจะติดตามอีเมลขาเข้าจากลูกค้าได้อย่างทันท่วงที`,
"label.page.select.profile":`เลือกโปรไฟล์ผู้ใช้ที่ต้องการใช้แท็บแบบกำหนดเองใหม่ และสามารถตรวจสอบหรือแก้ไขว่าจะแสดงหรือไม่แสดงแท็บใดบนหน้ารายละเอียดและหน้าแก้ไขของทุกโปรไฟล์`,
"label.chosen.button":`ปุ่มที่เลือก`,
"front-epwechat-module-v1-info":`ข้อมูลหลังบ้านวีแชทขององค์กร`,
"label.translation.select":`เลือกเงื่อนไขตัวกรอง`,
"ten":`สิบ`,
"label.barcode":`บาร์โคด`,
"lable.product.nextdel":`ดำเนินการต่อและลบบันทึกที่แสดงหรือคลิก`,
"label.default":`ค่าเริ่มต้น`,
"label.chatter.theme":`หัวข้อ`,
"vue_label_commonobjects_view_split_screen_view":`มุมมองแยกหน้าจอ`,
"label.ems.myemails":`อีเมลของฉัน`,
"label.email.clearPersonalEmail":`ล้างอีเมลที่ซิงค์กับอีเมลส่วนบุคคลทั้งหมดหรือไม่`,
"label.login.access.admin":`ผู้ดูแลระบบของบริษัทของคุณ`,
"label.emailobject.wizard.desc":``,
"label.passwordPolicy.setup.minpwdlength":`รหัสผ่านที่สั้นที่สุด`,
"choserow":`กรุณาเลือกแถวที่จะแสดง`,
"front-epwechat-module-v1-role-binding":`การผูกบทบาท`,
"lable.outlook.edit.newdata":`วันที่สร้าง`,
"label.schedulejob.setup.schedule.enddate":`วันที่สิ้นสุด`,
"label.quickbooks.view":`มุมมอง`,
"font-evaluate-module-v1-not-inform":``,
"chatter.poll.option3":`ตัวเลือกที่ 3`,
"setup_layout_label_selectfield":`เลือกฟิลด์`,
"label.partner.common.roleSetup":`บทบาทพาร์ทเนอร์คลาวด์และการตั้งค่าผู้ใช้`,
"label_partner_new_step3":`ขั้นตอนที่ 3: ใส่ชื่อและ URL`,
"label.transfer":`ถ่ายโอน`,
"label.bmap.myaddress":`ตำแหน่งที่ตั้งของฉัน`,
"label_tabpage_individual":`เลือกได้ข้อเดียว`,
"label.autoRegister.changepwd.setpwd.repassword":`กรุณาป้อนรหัสผ่านอีกครั้ง`,
"vue_label_commonobjects_detail_and_before":`ก่อนหน้านี้`,
"front-kefu-moudle-v1-single-Login-area":``,
"label.replacedocument":`แทนที่เอกสาร`,
"label.validate.function.category.Logical":`ตรรกะ`,
"label.companyprofile.syncsuccess":`การซิงค์สำเร็จ`,
"template.chart.rwzthyxj":`หัวข้อภารกิจและลำดับความสำคัญ`,
"label.product.clearcondition":`ล้างเงื่อนไข`,
"component_task_label_person":`*ผู้ได้รับมอบหมาย`,
"label.tabpage.as":`เช่น`,
"message.error.calendar.add":`เพิ่มปฏิทินแล้ว`,
"label.marketsea.isrecycleleadcreatebyself":`จะรีไซเคิลลีดที่สร้างขึ้นเองหรือไม่`,
"label.icon.57":`บารอมิเตอร์`,
"UG.Lead.010":`หรือ`,
"setup_object_field_dependency_label_configured":`เนื้อหาที่ปรับแต่งแล้ว`,
"label.tianyancha.regnumber":`หมายเลขลงทะเบียน`,
"front-kefu-moudle-v1-Opened-chats":`เปิดแชท`,
"label_tabpage_converstatez":`สถานะข้ามสเตจแล้ว`,
"label.bmap.beijing.haidianqu":`ถนนซั่งตี้ 10 เขตไห่เตี้ยน กรุงปักกิ่ง`,
"label.startimport":`เริ่มนำเข้า`,
"label.knowledgebase.application.default.settings":`การตั้งค่าเริ่มต้นของแอปพลิเคชัน Lightning`,
"lable.account.year.custom":`ปีงบประมาณที่กำหนดเอง`,
"label.event.nextmonth":`เดือนหน้า`,
"label.email.body":`ข้อความ`,
"setup.object.field.dependency.label.mustsetup":`กรุณาตั้งค่าการพึ่งพาของฟิลด์ก่อนแล้วค่อยบันทึก`,
"label_tabpage_multiple":`แบบเลือกตอบ`,
"label.task.this.month":`ภารกิจของสัปดาห์นี้`,
"label.customfields.formula.moneyexample":`Gross Margin（กำไรขั้นต้น）= Amount - Cost__c`,
"label.tonewemailnotice":`เลือกออบเจ็กต์สำหรับภารกิจนี้และคลิกขั้นตอนถัดไป "ภารกิจสามารถเชื่อมโยงกับกฎเวิร์กโฟลว์และกระบวนการอนุมัติประเภทเดียวกันเท่านั้น"`,
"setup.mainpage.label.welcome11":`รายงานที่กำหนดเอง`,
"label.layout.availabletab":`แท็บที่ใช้ได้`,
"label.data.importef":`นำเข้าไฟล์ที่ล้มเหลว`,
"label.appupload.upload.alert":`ก่อนอัปโหลดโปรดระบุรายละเอียดเกี่ยวกับโปรแกรมสำเร็จรูปนี้ การตั้งค่าเหล่านี้เป็นข้อกำหนดที่ต้องปฏิบัติตามเพื่อติดตั้งโปรแกรมสำเร็จรูปนี้`,
"label.sales.accountteam.shared":`การแบ่งปันกลุ่มลูกค้า`,
"lable.currency.addexchageRate":`เพิ่มอัตราแลกเปลี่ยน`,
"label.page.simplified.chinese":`อักษรจีนตัวย่อ`,
"label.service.dispatchingUnits.search.service.area":`ค้นหาภูมิภาคให้บริการ`,
"lable.list.queue.name":`ชื่อคิว`,
"pagecreator.button.save":`บันทึก`,
"label.ccpeak.support.function":`รองรับหลากหลายฟังก์ชันในตารางเดียว`,
"label.tianyancha.legalpersonid":`ID นิติบุคคล`,
"label.sendemail.chat.addPostmainPage":`#nameที่เคารพ:\n\n   สวัสดี！#userNameโพสต์บนหน้าแรก CCChat ของคุณ`,
"batch.no.change":`โอนข้อมูลโดยไม่ได้รับอนุญาต`,
"label.the.referenced":`อ้างอิง`,
"label.input.webtab.information":`กรอกข้อมูลเกี่ยวกับแท็บ Web`,
"vue_label_systemSettings_subscription":`ประเภทการสมัครสมาชิก`,
"label.login.access.title":`สิทธิ์การให้ลูกค้าเข้าถึง`,
"label.schedulejob.setup.schedule.lastday":`วันสุดท้าย`,
"label.synchronize.department":`ซิงค์ผู้ใช้`,
"label_tabpage_lessequalz":`น้อยกว่าหรือเท่ากับ`,
"label.file.library.successmanagemember":`บันทึกการจัดการสมาชิกสำเร็จ`,
"label.service.major.event.oreder":`ลําดับ`,
"label.desktopintegration":`การเชื่อมต่อเดสก์ท็อป`,
"label.a_b":`ความสัมพันธ์จาก A ไป B`,
"every":`ทุกๆ`,
"label.tabpage.bar":`กราฟแท่ง`,
"label.filecontentsnotnull":`เนื้อหาเอกสารไม่สามารถว่างเปล่า`,
"label.layout.detailoftestobj":`รายละเอียดของออบเจ็กต์ทดสอบ`,
"label.summaryreport.2018.step3":`ขั้นตอนที่ 3: เลือกคอลัมน์รายงาน`,
"UG.Lead.002":`มีหลายวิธีในการระบุ "ลีด" สําหรับผลิตภัณฑ์หรือบริการของคุณ`,
"label_partner_workspace_member_selectedprofile":`โปรไฟล์ที่เลือก`,
"label.newdescription":`หมายเหตุใหม่`,
"vue_label_normal_moveup":`ขยับขึ้น`,
"label.mobile.quickcreate.default.logacall":`บันทึกการโทร`,
"userterritory.serviceterritory.user.unique":`ผู้ใช้รายนี้ถูกกำหนดให้กับภูมิภาคให้บริการนี้แล้ว โปรดอย่ามอบหมายซ้ำ`,
"label.weixin.record":`บันทึก`,
"front-kefu-moudle-connecting":``,
"label.monitorsys.recent.operation.log":`ล็อกล่าสุด`,
"lable.outlook.detail.lmaping":`การแม็ปฟิลด์ลีด`,
"lable.account.year.ovdate":`วันสิ้นสุดปีงบประมาณ`,
"vue.homepage.auditcard.record":`บันทึก {recordTotal} รายการ`,
"label.processsetting.delete.process.succeeded":`ลบกระบวนการสำเร็จ!`,
"label.customerinfo.smsPwd":`รหัสผ่านเกตเวย์ข้อความสั้น`,
"label.tolead.object":`นำเข้าออบเจ็กต์`,
"label.data.downpage.i.list.desc2":`หลังจากนำเข้าข้อมูลแล้ว คุณจะได้รับอีเมลเพื่อแจ้งคุณว่าการนำเข้าสำเร็จหรือไม่`,
"label.sharerule.ruletype":`ประเภทของกฎ`,
"label.reportsSubscriptionPage.email.toothers":`ส่งให้ฉันและผู้ใช้คนอื่น`,
"label.emailobject.templates":`เลือกแม่แบบ`,
"vue_label_checkduplicate_":`การวิเคราะห์การเสนอลูกค้าทับซ้อน`,
"label.campaign.channel.lookup.example":`ตัวอย่าง`,
"label.login.verification.please.note":`โปรดทราบ:`,
"label.version.charge":`ค่าใช้จ่าย`,
"label.ccdocument.show.trace":`แสดงการติดตาม`,
"label.sendemail.approval.submit":`สวัสดี #name:\n     #actorname ได้เสนอ #objLabel- เมื่อ#actordate #recordnameกำลังรอการอนุมัติจากคุณ โปรดคลิกลิงก์ด้านล่างหรือเข้าสู่ระบบ CRM และเข้าสู่ศูนย์การอนุมัติเพื่อการอนุมัติ: \ n #path #appPath / query.action?id = #recordid & m = query \ n #orgName`,
"setup.mainpage.label.welcome12":`ผู้ใช้สามารถกรอกข้อกำหนดของรายงานได้เพียงคลิกเมาส์และทำตามขั้นตอนคำแนะนำของระบบโดยไม่จำเป็นต้องแก้ไขโปรแกรม ระบบมีรายงานแบบตาราง รายงานสรุป และรายงานแบบเมทริกซ์ให้เลือกพร้อมใช้งาน นอกจากนี้ยังสามารถเลือกการแสดงผลสําหรับฟิลด์ทั้งหมดและลบฟิลด์ที่ไม่จําเป็นออก รวมทั้งมีแผนภูมิแท่ง แผนภูมิเส้น แผนภูมิโดนัท แผนภูมิรูปกรวย แผนภูมิวงกลม และแผนภูมิอีกหลายชนิดให้ผู้ใช้ใช้งานได้อย่างง่าย`,
"UG_contact_06":`นำเข้าผู้ติดต่อ`,
"message.success.event.add":`การบันทึกข้อมูลอิเวนต์ใหม่สำเร็จ`,
"report.line":`ฟิลด์ข้อมูล`,
"label.approvepagelayout2":`แต่ละคนใช้เค้าโครงเพจที่แตกต่างกัน`,
"vue_label_normal_contract_sf":`สัญญา`,
"label.tabpage.tpcustomersz":`ลีดข้ามสเตจ`,
"label.ccchat.message.new.error5":`ข้อผิดพลาด ข้อมูลของคุณต้องมีอักขระไม่เกิน 10,000 ตัว`,
"label.severalorone":`ไฟล์เดี่ยว`,
"pagecreator_systemstyle_label_buttonfontcolor":`ข้อความของปุ่ม`,
"label.customer.tab.step3.introduce":`เลือกแอปพลิเคชันแบบกำหนดเองที่คุณต้องการใช้แท็บแบบกำหนดเองใหม่ คุณยังสามารถตรวจสอบหรือปรับเปลี่ยนได้ว่าจะแสดงแท็บในหน้ารายละเอียดและหน้าแก้ไขของแต่ละแอปพลิเคชันแบบกำหนดเองหรือไม่`,
"chatter.group.groupEdit":`แก้ไขกลุ่ม`,
"label.partnerCloud.partnerAccount.spending":`ค่าใช้จ่ายเงินคืน`,
"label.slip":`รายการ)`,
"label.field.master.class":`ระดับความสัมพันธ์หลัก-รองเกินระดับ 3`,
"label.sendemail.chat.addComentsmyFeed":`#nameที่เคารพ:\n\n สวัสดี! #userNameกำลังตอบกลับเวยเทียของคุณ`,
"label.service.ganttBaiduMap.selectingDispatchTime":`เลือกเวลาจัดส่ง`,
"label.knowledgebase.remove.article":`ลบบทความออกจากที่เก็บถาวรไหม？`,
"label.appupload.notmanaged":`ไม่มีการจัดการ`,
"label.report.goto.step":`ไปที่ขั้นตอน`,
"label.publicgroup.save.mustbeselect":`ต้องเลือกสมาชิก`,
"label.data.expnode.e.desc2":`2. ส่งออกตามแม่แบบ: ผู้ใช้สามารถเลือกแม่แบบที่ใช้ในการส่งออกข้อมูล`,
"UG.product.02":`ผลิตภัณฑ์หมายถึงผลิตภัณฑ์หรือบริการที่ขายหรือซื้อ`,
"label.sendemailtouser":`ยืนยันว่าจะส่งอีเมลไปยังผู้ใช้ที่เลือกหรือไม่?`,
"label.knowledge.setting.hint.nine":`หากไม่พบ Knowledge จะมีประโยชน์อย่างไร?  บทความที่คล้ายคลึงจะถูกจัดเรียงเป็นหมวดหมู่ข้อมูลที่ไม่ซ้ำกัน และรวบรวมไว้ในกลุ่มหมวดหมู่ข้อมูลที่กว้างขึ้น เพิ่มกลุ่มหมวดหมู่ข้อมูลตอนนี้  คุณสามารถเพิ่มอีกได้ในภายหลัง`,
"front-asset-module-v1-view-asset-bom":`ดู BOM สินทรัพย์`,
"label_partner_all_enable":`เปิดการใช้งาน`,
"label.processsetting.disable.process.successfully":`ปิดการใช้งานกระบวนการเรียบร้อยแล้ว`,
"label.call.center.enable":`เปิดการใช้งาน Call Center`,
"message.recordtype.applyitseparatly":`ใช้เค้าโครงเพจที่แตกต่างกันสำหรับแต่ละโปรไฟล์`,
"label.weixin.report.customize":`ปรับแต่ง`,
"label.file.mongdb.file.is.not.exist":`ไม่มีไฟล์นี้แล้ว`,
"label.chat.edit.topics":`แก้ไขหัวข้อ`,
"label.knowledge.delete.searchterm":`เกิดข้อผิดพลาดในการลบคำค้นหา`,
"label_emailtocloudcc_redmessage3":`โปรดระบุที่อยู่เซิร์ฟเวอร์`,
"use":`ใช้`,
"label.batchtransfer.transferfrom":`โอนมาจาก`,
"label.recycle.my":`ถังขยะรีไซเคิลของฉัน`,
"label_json_string_null":`ว่าง`,
"label.version.lookupfield":`ฟิลด์ค้นหา`,
"lable.tianyancha.h5.searchf":`ไม่พบ`,
"label.validate.globalvariable.description":`$User.[ฟิลด์API] เช่น：$User.id <br>ค่าฟิลด์ที่ใช้ได้มี: id, name, roleId, roleName, profileId, profileName, department, title, email`,
"UG.opportunity.006":`อัจฉริยะแห่งโอกาสทางธุรกิจ`,
"label.applt.copy":`คัดลอกในคลิกเดียว`,
"chatter.emailMessageOrReply":`โพสต์หรือตอบกลับ`,
"label.newreport.self":`ฟิลด์ที่ถูกเลือก`,
"label.visualpage.checkpinxie":`กรุณาตรวจสอบตัวสะกดของหน้าเพจ`,
"label.knowledgebase.article.attaching.case":`บทความ{name}แนบกับเคสแล้ว!`,
"label.dialogbox":`กล่องโต้ตอบ`,
"label.summaryreport.step3.new":`ขั้นตอนที่ 3: เลือกข้อมูลที่ต้องการสรุป`,
"label.confirm":`ยืนยัน`,
"label.mobile.buttom.team":`กลยุทธ์กลุ่ม`,
"label.quickbooks.action.link":`เชื่อมต่อ`,
"vue_label_commonobjects_view_support_to_datas":`การดำเนินการรอบรับข้อมูลได้มากที่สุด 10 รายการ`,
"vue_label_helpcenter_homepage":`ผู้ใช้แต่ละคนจะมีโฮมเพจสองหน้า คือ หน้าแรกมาตรฐาน และหน้าแรกส่วนตัว ผู้ดูแลสามารถกำหนดหน้าแรกโปรไฟล์ที่สอดคล้องกับผู้ใช้ตามโปรไฟล์ของผู้ใช้ โปรดทราบว่าโฮมเพจรุ่น Lightning และโฮมเพจรุ่นเก่าทำงานร่วมกันไม่ได้ <br>1. หน้าแรกมาตรฐาน<br> เนื้อหาของหน้ามาตรฐานเป็นหนึ่งเดียวกันและแก้ไขไม่ได้ รวมถึงส่วนเสริม เช่น ผลการดำเนินงานรายไตรมาส ดูล่าสุด ศูนย์การอนุมัติ อิเวนต์วันนี้ ภารกิจ โอกาสทางธุรกิจที่ค้างชำระ โอกาสทางธุรกิจที่ไม่ได้ติดต่อเป็นเวลา 30 วัน และโอกาสทางธุรกิจที่กำลังจะมาถึง<br> ผลการดำเนินงานรายไตรมาส: ทุกคนสามารถกำหนดเป้าหมายรายไตรมาสของตนเองได้<br> ดูล่าสุด: แสดงบันทึกออบเจ็กต์ 10 รายการที่ดูล่าสุด<br> โอกาสทางธุรกิจที่ไม่ได้ติดต่อเป็นเวลา 30 วัน: แสดงโอกาสทางธุรกิจ 5 รายที่มีจำนวนวันที่ไม่ได้ติดต่อเกินกว่า 30 วัน และความน่าจะเป็นไม่ใช่ 0 และ 100 <br>2 หน้าแรกส่วนตัว<br> ทุกคนมีหน้าแรกส่วนตัวและเนื้อหาบนหน้าแรกส่วนบุคคลสามารถปรับแต่งเพื่อเพิ่มหรือลบส่วนเสริมได้ และคุณยังสามารถลากและวางเพื่อปรับตำแหน่งและขนาดของส่วนเสริมได้<br> เมื่อเปิดใช้หน้าส่วนตัวจะมีส่วนเสริมเริ่มต้น เช่น สรุป ศูนย์การอนุมัติ โอกาสทางธุรกิจที่ค้างชำระ และโอกาสทางธุรกิจที่กำลังจะมาถึง<br> หน้าส่วนบุคคลมีมีส่วนเสริมได้มากถึง 15 รายการ<br>3. หน้าแรกโปรไฟล์<br> ผู้ดูแลสามารถใช้เพจที่กำหนดเองในการสร้าง/แก้ไข/ลบหน้าแรกโปรไฟล์ และกำหนดหน้าแรกที่แตกต่างกันให้กับโปรไฟล์ต่างๆ เพื่อให้ผู้ใช้ที่โปรไฟล์ต่างกันได้เห็นผลลัพธ์ของหน้าที่ไม่เหมือนกัน<br> แต่ละหน้าแรกโปรไฟล์มีส่วนเสริมได้มากถึง 15 รายการ<br> 4. เพิ่มส่วนเสริม <br> หน้าแรกส่วนตัวและหน้าแรกโปรไฟล์สามารถปรับเพิ่มส่วนเสริม เช่น แดชบอร์ด แผนภูมิในแดชบอร์ด และมุมมองการ์ด<br> ส่วนเสริมแดชบอร์ด: แดชบอร์ดที่เพิ่มในหน้าแรกของระบบประกอบด้วยส่วนเสริมย่อยมากน้อยเท่าใดนั้นแสดงถึงจำนวนทรัพยากรที่แดชบอร์ดใช้ (รองรับส่วนเสริมได้มากที่สุด 15 รายการ) โดยหลังจากเพิ่มข้อมูลแดชบอร์ดจะไม่เชื่อมโยงกับแดชบอร์ดต้นทาง (นั่นคือหากแดชบอร์ดต้นทางถูกลบ แดชบอร์ดนี้จะยังคงทำงาน)<br> ส่วนเสริมแผนภูมิในแดชบอร์ด: สามารถเพิ่มรายละเอียดส่วนเสริมของบางแผนภูมิในแดชบอร์ดทางระบบในหน้าได้ ณ เวลานี้ฟังก์ชันการเชื่อมโยงส่วนเสริมจะใช้งานไม่ได้<br> ส่วนเสริมมุมมองการ์ด: สามารถเลือกปรับเพิ่มมุมมองเฉพาะของออบเจ็กต์เป็นแหล่งข้อมูลของโฮมเพจ ฟิลด์ และรายการดำเนินการ แต่ควรระมัดระวังว่าหากมุมมองแหล่งข้อมูลของมุมมองการ์ดถูกลบ มุมมองการ์ดจะไม่มีข้อมูล`,
"label.usersandlimit":`ผู้ใช้และสิทธิ์`,
"label.sendmail.step3.introduce2":`ผู้ที่ได้รับอีเมลนี้`,
"label.setupcustomfield":`ฟิลด์ที่กำหนดเอง`,
"label.layout.last.notdel":`ไม่อนุญาตให้ลบเค้าโครงล่าสุด`,
"label.emailtocloudcc.redmessage7":`การตั้งค่าหลังบ้านผิดพลาด โปรดติดต่อผู้ดูแลระบบ`,
"label.includedIn":`มีอยู่ใน {parentproductname}`,
"label.permission.detail.app.pagesetting":`การตั้งค่าเพจที่กำหนดเอง`,
"label.addfile.tips":`เลือกไฟล์แล้ว {SelectedNum} ไฟล์ สามารถเพิ่มไฟล์ได้สูงสุดครั้งละ {originNum} ไฟล์`,
"label.fieldinformation":`ข้อมูลฟิลด์`,
"label.campagin.roi.sjcb":`ต้นทุนที่แท้จริง`,
"label.email.all.works.company":`เพื่อนร่วมงานทั้งหมดในบริษัท`,
"label.currencyDesc":`ใช้หน้านี้เพื่อกำหนดสกุลเงินทั้งหมดที่องค์กรของคุณใช้ ควรนำสกุลเงินของบริษัทตั้งค่าเป็นสกุลเงินที่ใช้ทั้งหมดเมื่อรายงานรายได้ของสำนักงานใหญ่ หากกำหนดสกุลเงินอื่นๆ เป็นสกุลเงินบริษัท จะเปลี่ยนแปลงอัตราแลกเปลี่ยนทั้งหมดให้สอดคล้องกับการเปลี่ยนแปลงนี้`,
"label.file.details":`รายละเอียด`,
"label.foldervisitlimit3":`โฟลเดอร์นี้เข้าได้เฉพาะผู้ใช้ดังต่อไปนี้：`,
"label.account.next.M":`เดือนหน้า`,
"label.oweralias":`นามแฝงของเจ้าของ`,
"label.projectManagement.entryname":`ชื่อโครงการ`,
"label.customcomponent.page.add.title1":`ข้อมูลส่วนเสริม`,
"label.projectManagement.PleaseenterCreator":`โปรดป้อนผู้สร้าง`,
"label.multipleactivity.memberselected":`สมาชิกที่เลือก`,
"label_chatter_memotel":`บันทึกการโทร`,
"lable.Confirm.customers":`ยืนยันกู้คืนลีด {num} ราย`,
"front-email-payment-Invoice-number":``,
"label.not.appoint.validation":`ไม่ได้ระบุออบเจ็กต์ที่สอดคล้องกับเกณฑ์การทวนสอบ โปรดระบุ`,
"label.peru.time":`เวลาเปรู`,
"label.setting.intergrationlist.status3":`ต้องเข้าสู่ระบบบัญชี QuickBooks`,
"vue_label_display_number_field":`แสดงฟิลด์ตัวเลข`,
"label_productline_count":`จำนวนสายผลิตภัณฑ์`,
"label.data.downpage.i_title.num2":`2. ก่อนเริ่มการนำเข้า โปรดแน่ใจว่าชื่อฟิลด์ที่คุณต้องการนำเข้าตรงกับชื่อฟิลด์ออบเจ็กต์ในระบบ CloudCC`,
"label.field.duplicate4":`ถือว่า "ABC" และ "abc" เป็นค่าที่ต่างกัน (ไวต่ออักษรใหญ่เล็ก)`,
"message.approval.step.validation.invalid.levels":`ระดับอย่างน้อย 1`,
"label.tianyancha.businessverify.step1":`เปิดใช้งานการทวนสอบข้อมูลธุรกิจขั้นตอนที่หนึ่ง`,
"label.hidedetail":`ซ่อนรายละเอียด`,
"UG_Lead_009":`APP บันทึกการโทร`,
"label.partnerCloud.newProductSeries":`สายผลิตภัณฑ์ใหม่`,
"label.brief.opportunities":`โอกาสทั้งหมด`,
"label.user.mfa.unbind.remind":`คุณกำลังจะยกเลิกการผูก MFA จากผู้ใช้ที่เลือก ผู้ใช้จำเป็นต้องผูกอุปกรณ์ MFA ใหม่หลังจากเข้าสู่ระบบในครั้งต่อไป กรุณายืนยัน`,
"vue_label_report_grouprow":`แถวกลุ่ม`,
"setup.layout.label.newarea":`ภูมิภาคใหม่`,
"label.nostart":`ยังไม่เริ่ม`,
"UG_Lead_010":`หรือ`,
"label.emailmerge.mergepage.record.requeired":`โปรดเลือกบันทึกที่จะผสาน!`,
"label.appointmentpage.wizard.notif1btn1":`ยืนยัน`,
"UG.Account.02":`มีบางธุรกิจให้บริการกับธุรกิจอื่น มีบางธุรกิจร่วมมือกับผู้ใช้ปลายทางโดยตรง และมีบางที่ให้บริการกับองค์กร NGO`,
"label.address.country":`ประเทศหรือภูมิภาค`,
"label.userinfo.updatepwd":`อัปเดตรหัสผ่าน`,
"label.salescloud.teamrole.optionlist.opportunity":`เพิ่มสมาชิกทีมโอกาสทางธุรกิจไปยัง`,
"lable.account.Current.FY":`ปีงบประมาณปัจจุบัน`,
"chatter.coll.p":`บุ๊กมาร์กโพสต์นี้`,
"label.setupsms":`ข้อความสั้น`,
"label.atlantic.daylight.time":`เวลาออมแสงมหาสมุทรแอตแลนติก`,
"label.recordslock":`ล็อกบันทึก`,
"button_partner_search":`สืบค้น`,
"vue_label_salesfunnel_notice4":`ความน่าจะเป็นของจำนวนเงินทั้งหมดของโอกาสทางธุรกิจ 1%-99%`,
"vue_label_report_statistics":`สถิติ`,
"label.ccchat.notmember.active.group0":`คุณไม่ได้เป็นสมาชิกกลุ่มกิจกรรมใดๆ ที่ในชื่อประกอบด้วย{0}`,
"label.tag.manage.newtag":`ป้ายกำกับใหม่`,
"label.customfileds.formula.dateandtime.tip":`คำนวณวันที่/เวลา เช่น เพิ่มชั่วโมงหรือจำนวนวันที่แน่ชัดในวันที่/เวลาอื่นๆ`,
"label.weixin.mobile.fly.ios":`การแบ่งปันสำหรับอุปกรณ์มือถือ ios`,
"vue_label_file_over_file_size":`ไฟล์ file.name   เกินค่าเริ่มต้นระบบ!`,
"label.schedulejob.setup.schedule.last":`สุดท้าย`,
"label.ccchat.whose.name.contains":`ของสมาชิกกลุ่มกิจกรรมใดๆ`,
"label.project.milestone.name":`ชื่อไมล์สโตนในโครงการเดียวกันไม่สามารถซ้ำกันได้!`,
"message.passwordPolicy.validate.reuse":`ข้อผิดพลาด: ไม่สามารถใช้รหัสผ่านนี้ซ้ำได้`,
"label.stdashbord.xsld.business.img3":`ความน่าจะเป็นของจำนวนเงินในสเตจ 1%-99% * ความน่าจะเป็น`,
"label.event.view.list":`รายการมุมมอง`,
"label.workflow.ruletriggertime":`เวลาทริกเกอร์กฎ`,
"label.campaign.channel":`ช่องทางการขายของแคมเปญ`,
"label.appexchange.emailnotice":`การแจ้งเตือนอีเมลของเวิร์กโฟลว์`,
"label.icon.77":`เกษตรกรรม`,
"label.visualpage.display.value":`เขียนค่าที่จะแสดงที่นี่ ระวังว่าต้องไม่เว้นวรรคก่อนและหลัง`,
"label.forecast.customforecast.type.user":`ตามผู้ใช้`,
"label_tabpage_lessz":`น้อยกว่า`,
"label.same.analyze.contact.email":`อีเมลผู้ติดต่อ`,
"vue_label_report_range":`ช่วง`,
"lable.product.pricebooks.nr":`คุณสามารถคัดลอกเนื้อหาจากสมุดราคาที่มีอยู่โดยเลือกจากรายการตัวเลือกต่อไปนี้`,
"label_mobile_buttom_team_setUp":`การกำหนดกลยุทธ์กลุ่ม`,
"label.email.bcc.recipients":`ผู้รับสำเนาลับ`,
"vue_label_ccchat_notice_deletepostfail":`การลบโพสต์ล้มเหลว`,
"label_file_type":`ประเภทไฟล์`,
"label.multilang.feedtrack.operateupdate":`เปลี่ยนแปลงบันทึก{0}แล้ว 1 รายการ`,
"label.contractmanager":`ผู้จัดการสัญญา`,
"front-gantt-module-drag-one-task-sorting":``,
"label.partner.step2":`ขั้นตอนที่2: ยืนยันแม่แบบ`,
"front-epwechat-module-v1-again-binding":`ผูกใหม่`,
"label.service.miniProgram.imageSize":`ขนาดภาพอัปโหลดไม่เกิน 2MB!`,
"setup_main2018_label_managesetup":`จัดการการตั้งค่า`,
"component_salesperformance_label_nopermission":`หากต้องการดูข้อมูลที่เกี่ยวข้องกับโอกาสทางธุรกิจ โปรดติดต่อผู้ดูแลระบบของคุณ`,
"lable.account.stadate":`วันที่เริ่มต้นไตรมาสบัญชี`,
"label.service.gantt.and.resourcestype":`และประเภททรัพยากรคือ`,
"label.ems.attachfiles":`เพิ่มไฟล์แนบ`,
"label.data.expnode.e.desc1":`1. การส่งออกแบบกำหนดเอง: ผู้ใช้สามารถเลือกฟิลด์ที่จะส่งออกและเงื่อนไขในการกรองตามความต้องการของตนเอง`,
"vue_label_systemSettings_analyse":``,
"label.project.all.date":`วันที่สิ้นสุดต้องมากกว่าหรือเท่ากับวันที่เริ่มต้น!`,
"vue_label_commonobjects_view_summary_basis":`เกณฑ์การสรุป`,
"template.chart.yywjhdschd":`แคมเปญที่มีโอกาสทางธุรกิจ`,
"vue_label_pool_notmeet":`ไม่ตรงตามความต้องการของลูกค้า`,
"label.attendance.manager":`ผู้จัดการบันทึกเวลาทำงาน`,
"vue_labenl_normal_current":`ปัจจุบัน`,
"label.projectManagement.completed.quantity":`จำนวนที่เสร็จสิ้น`,
"label.layout.testfield":`ทดสอบฟิลด์`,
"label.customfields.selectcontainrelatelistlayout":`เลือกเค้าโครงเพจที่ควรมีรายการที่เกี่ยวข้องนี้`,
"label.fiji.time":`เวลาฟิจิ`,
"message.error.domain.already.exists":`มีชื่อโดเมนนี้แล้ว`,
"label.accountandcontact":`ลูกค้า/ผู้ติดต่อ`,
"label.dashboardSetup.right":`ขวา`,
"label.view.appliedMobile.xgry":`เลือกรายการนี้ เพื่อดูมุมมองนี้ในหน้าแรกของเวิร์คแบนซ์ของผู้ที่เกี่ยวข้องได้`,
"label.file.share.all":`ทุกผู้ใช้ในบริษัทของคุณ`,
"vue_label_pool_summary":`ข้อมูลทั้งหมด {0} รายการ รีเฟรซแล้ว {1}`,
"label.emailtemplate.new":`แม่แบบอีเมลใหม่`,
"label.tag.manage.button1":`ป้ายกำกับใหม่`,
"label.data.exp.tempexppage":`หน้าแม่แบบส่งออกข้อมูล`,
"font-trade-module-v1-invoice-total":``,
"label.folder.sort":`เรียงลำดับโฟลเดอร์`,
"label.multilang.campaign.countnum":`{0} ครั้ง`,
"label.homepagelayout":`เค้าโครงหน้าแรก`,
"setup_layout_button_cancel":`ยกเลิก`,
"lable.Search.in.QuickBook":`ค้นหาใน Quickbook`,
"setup_fielddependency_label_pleaseclick":`โปรดคลิกค่า "ฟิลด์ควบคุม" เพื่อแก้ไข`,
"setup.fielddependency.label.pleaseclick":`โปรดคลิกค่า "ฟิลด์ควบคุม" เพื่อแก้ไข`,
"label.version.sum.field":`ฟิลด์ที่กำหนดเอง`,
"label.form.is.submitted.successful":`แจ้งเตือนการส่งฟอร์มสำเร็จ`,
"label.campaignmember.main.batchaddmember":`เพิ่มสมาชิกแคมเปญแบบกลุ่ม`,
"label.sendemail.activity.newevent":`#belongtoidccnameที่เคารพ สวัสดี: \ r \ n เพื่อนร่วมงานของคุณ #createbyidccname เมื่อ #createdate มอบหมายอิเวนต์ใหม่ให้คุณ โดยเนื้อหามีดังต่อไปนี้: \ r \ n หัวข้อ: #subject \ r \ n 
เวลาเริ่มต้น: #begintime \ r \ n 
เวลาสิ้นสุด : #endtime \ r \ n 
รายการที่เกี่ยวข้อง: #relatedstr \ r \ n 
เนื้อหา: #remark \ r \ n 
สำหรับรายละเอียด โปรดไปที่ลิงก์นี้: \ r \ n #path \ r \ n 
#orgNameระบบ CRM`,
"label.knowledgebase.select.target":`กรุณาเลือกเป้าหมาย`,
"setup.layout.label.buttonlist":`เลือกปุ่ม`,
"pagecreator.page.label.pagedesc":`คำอธิบายหน้าเพจ`,
"label.version.professional":`รุ่นโปรเฟชชันนอล`,
"UG.Forcast.10":`เสร็จสิ้น`,
"template.chart.schdyqsr":`รายได้ที่คาดหวังจากแคมเปญ`,
"front-filter-module-v1-quick-filter":`ตัวกรองด่วน`,
"label.notification.group2":`คุณได้เข้าร่วมทีมสาธารณะเรียบร้อยแล้ว`,
"label.ServiceCloud.statistics.by.serviceArea":`สถิติตามภูมิภาคให้บริการ`,
"label.validate.function.funcExplain.TIMENOW":`ส่งกลับเวลาปัจจุบัน (ชั่วโมง นาที วินาที)`,
"label.brief.lastmonth":`เดือนก่อน`,
"label.weixin.member.states":`สถานะสมาชิก`,
"template.chart.ljxsje":`ยอดขายสะสม`,
"label.eidt.queue.label.hasused2":`มีการใช้ชื่อคิวนี้แล้ว`,
"label.textmessage.nophonenumber":`ผู้ติดต่อนี้ไม่ได้บันทึกข้อมูลโทรศัพท์มือถือ`,
"label.task.new":`ภารกิจใหม่`,
"label.tabpage.grid":`แสดงผลแบบกริด`,
"label.workbanch.setup.viewname":`ชื่อมุมมอง`,
"front-gantt-module-temporary-tasks":``,
"label.reportTypeDescripe":`ผู้ใช้สามารถสร้างรายงานตามออบเจ็กต์ที่กำหนดไว้ล่วงหน้า ความสัมพันธ์ของออบเจ็กต์ และฟิลด์ที่ระบุตามแหล่งข้อมูลรายงานที่กำหนดเอง`,
"setup_layout_label_fieldlist":`ฟิลด์พร้อมใช้งาน`,
"label.ggReleaseRange.searchforRole":`ค้นหาบทบาทของพาร์ทเนอร์`,
"label.datamanage.account.field":`ฟิลด์ลูกค้า`,
"label_tabpage_groupingemptyz":`กลุ่มรายการต้องไม่ว่างเปล่า`,
"label.permission.edit.insertinfo":`ป้อนข้อมูลชุดสิทธิ์`,
"label.back_forms":``,
"vue_label_calendar_step_2":`ขั้นตอนที่ 2: เลือกออบเจ็กต์มาตรฐานหรือแบบกำหนดเองเพื่อสร้างปฏิทิน`,
"lable.outlook.mcto.out":`โดเมนที่ลบ`,
"label.workflow.accessnext":`หากสอดคล้องตามเงื่อนไขด้านล่างจะเข้าสู่ขั้นตอนนี้`,
"label.data.exp.temppage":`การส่งออกข้อมูลและหน้าการสร้างแม่แบบ`,
"label_tabpage_printview":`ตัวอย่างการพิมพ์`,
"vue_label_report_preview":`หากต้องการดูการแก้ไขล่าสุดให้รีเฟรซตัวอย่าง`,
"frame_personinfo_label_personimage":`รูปโปรไฟล์`,
"component.chatter.button.like":`ชื่นชอบ`,
"label.ems.drafts":`แบบร่าง`,
"front-lightning-module-v1-details-page-chart-report-name":`ชื่อรายงาน`,
"label.partner.workspace.login":`หน้าเข้าสู่ระบบ`,
"include":`รวมถึง`,
"label_length_20":`ความยาวน้อยกว่า 20 อักขระ`,
"component_event_button_save":`บันทึก`,
"label.weixin.recalculate.shared.success":`คำนวณกฎการแบ่งปันออบเจ็กต์ใหม่สำเร็จ`,
"message.duplication.errorinscript.lessthan2":`ต้องเลือกบันทึกที่จะผสานอย่างน้อยสองรายการ!`,
"label_my_forecast":`การพยากรณ์ของฉัน`,
"label.ems.to":`ผู้รับ`,
"label_mobile_buttom_team_init":`การเริ่มต้นผู้ใช้กลยุทธ์กลุ่ม`,
"label.sendemail.send.codeerror":`การแปลงรหัสล้มเหลว โปรดใช้รหัสที่ถูกต้อง`,
"lable.quote.syncing.and":`และ`,
"label.campaignmember.selectmember.step1oftotal":`ขั้นตอนที่ 1 จาก 2`,
"label.ems.step3":`ขั้นตอนที่ 3`,
"lable.PowerProcess.detail.message":`รายละเอียดกระบวนการให้สิทธิ์`,
"chatter.poll.option2":`ตัวเลือกที่ 2`,
"front-view-module-v12-verify-number":`รูปแบบตัวเลขไม่ถูกต้อง โปรดตรวจสอบข้อมูลที่ป้อน`,
"label.setup.mobile.homepageshortcuts.savesuccess":`บันทึกการตั้งค่าฟังก์ชันทางลัดขอหน้าแรกบนอุปกรณ์มือถือเรียบร้อยแล้ว`,
"lable.outlook.edit.zdyoutfi":`ปรับแต่งชื่อช่อง Exchange`,
"label.assignment.setup.newentries.inputentries":`ใส่รายการเกณฑ์`,
"label.customfields.money.tip":`อนุญาตให้ผู้ใช้ป้อนสกุลเงินดอลลาร์สหรัฐฯ หรือสกุลเงินอื่น และฟิลด์จะแปลงรูปแบบสกุลเงินโดยอัตโนมัติ ฟังก์ชันนี้มีประโยชน์มากเมื่อส่งออกข้อมูลไปยัง Excel หรือสเปรดชีตอื่นๆ`,
"label.service.appointmentList.cancelThePlan":`ยกเลิกแผน`,
"label.chat.topic.suggest.add.topic":`ไม่มีข้อเสนอแนะ เพิ่มหัวข้อของคุณเอง`,
"vue_label_commonobjects_detail_tips":`เคล็ดลับ`,
"message.error.view.nameexists":`ข้อผิดพลาด: มีชื่อเฉพาะมุมมองนี้แล้ว`,
"label_emailtocloudcc_step2_name":`กำหนดแหล่งที่มาของอีเมล`,
"label.field.validation.apiname":`จำเป็นต้องเริ่มต้นด้วยตัวอักษร มีได้เฉพาะตัวอักษรตัวพิมพ์ใหญ่ตัวพิมพ์เล็ก ตัวเลข ขีดล่าง ความยาวมากที่สุด 50  น้อยที่สุด 2 หลัก และไม่สามารถเป็นคีย์เวิร์ดของฐานข้อมูลได้`,
"page.field.masterinput.remark2":`ตัวอย่างเช่น เมื่อสร้างใบสั่งขายใหม่ หากคุณต้องการป้อนรายละเอียดใบสั่งขายในหน้าเดียวกันพร้อมกัน คุณต้องเปิดใช้งานฟังก์ชันนี้ (ฟังก์ชันนี้เหมาะมากสำหรับออบเจ็กต์ที่มีความสัมพันธ์แบบข้อมูลหลัก-ข้อมูลรอง)`,
"label.rule.enabled.successfully":`เปิดใช้งานกฎเรียบร้อยแล้ว`,
"label.role.createrolelist.tip":`ต่อไปนี้เป็นรายการบทบาทในองค์กร  คลิกลิงก์บทบาทเพื่อดูข้อมูลโดยละเอียดเพิ่มเติม`,
"label.multilang.datamanage.dataimport.redundantmsg":`ความยาวของหัวข้อคือ&nbsp;{0}&nbsp แต่ความยาวของข้อมูลคือ&nbsp;{1}&nbsp ระบบไม่สามารถระบุได้ว่าฟิลด์&nbsp;{2}&nbspใดที่เกินมา`,
"label.visualpage.staticresource":`นำเข้าทรัพยากรแบบคงที่`,
"chatter.group.members01":`สมาชิก`,
"label.planned.workname":`ชื่องาน`,
"label.service.dispatchingUnits.gantt.data":`ตรงกับวันที่ในแผนภูมิแกนต์`,
"label.data.newtemplate.t.conditions":`เงื่อนไขแม่แบบ`,
"label.accmarketsea.edit.title":`การแก้ไขฐานข้อมูลลูกค้า`,
"label_chatter_priority":`ลำดับความสำคัญ`,
"label_mobile_buttom_team_open":`เปิดการใช้งานกลยุทธ์กลุ่ม PC และ APP`,
"front-gantt-module-no-tasks-available":``,
"component.newrecords.label.type":`ประเภทการจัดเก็บ`,
"label.version.ccdocument.and.remark":`ไฟล์แนบและหมายเหตุ`,
"label.martrixreport.step2":`ขั้นตอนที่ 2: เลือกวิธีการจัดกลุ่มที่ใช้ในการคำนวณข้อมูลสรุป`,
"label.projectManagement.Scheduleinformation":`ข้อมูลตารางเวลา`,
"label.emailmerge.mergeFolder.description":`คุณสามารถสร้างเอกสาร Microsoft Word ที่มีข้อมูลผู้ติดต่อของคุณในหน้านี้ได้ โปรดเลือกแม่แบบจดหมายเวียน โดยเลือกได้มากที่สุด 20 รายการ`,
"label.autoRegister.changepwd.setpwd.tip":`รหัสผ่านที่ติดตั้งจำเป็นต้องสอดคล้องกับเงื่อนไขดังต่อไปนี้`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`ตะกร้าสินค้าว่างเปล่า กรุณาคลิกปุ่มเพิ่มผลิตภัณฑ์เพื่อเพิ่มผลิตภัณฑ์`,
"label.marketcloud_seminar":`สัมมนา Marketing Cloud`,
"label.knowledgebase.no.results.knowledge.search":`ไม่มีผลลัพธ์"{a}"ใน Knowledge`,
"label.createdate":`สร้างเวลา`,
"vue_label_systemSettings_bazaar":`ตลาด`,
"report_type_label_contractPayment":`สัญญาและการจ่ายเงิน`,
"label.myemailset":`ตั้งค่าอีเมลของฉัน`,
"label.emailtype":`ประเภทอีเมล`,
"label.appexchange.uninstallpage.message5":`ลบความสัมพันธ์และรายการที่เกี่ยวข้องกับออบเจ็กต์แบบกำหนดเองในโปรแกรมสำเร็จรูปนี้อย่างถาวร`,
"label.customerinfo.applicationlicencenum":``,
"label.product":`ผลิตภัณฑ์`,
"lable.opppdt.selPdt.subtitle":`การเลือกผลิตภัณฑ์สำหรับ`,
"label_emailtocloudcc_step1_lead1":`Email to Lead`,
"label.multilang.recentview.query":`ดู {0} ล่าสุดของคุณ`,
"label.cumstom":`กำหนดเอง`,
"lable.product.pep":`กรุณาใส่ราคา`,
"label.suggestion":`ข้อเสนอแนะ`,
"vue_label_email_sentto":`ส่งให้`,
"label.email.cancel":`หลังจากยกเลิกการเชื่อมโยง อีเมลนี้จะไม่สามารถรับส่งข้อความได้ ยืนยันว่าจะยกเลิกหรือไม่?`,
"component_timeline_label_1monthahead":`1 เดือนก่อน`,
"setup_mainpage_label_welcome31":`คำแนะนำการใช้งาน: คลิกที่เมนูด้านซ้ายของหน้า→ การตั้งค่าการจัดการ → สร้าง →แอปพลิเคชัน`,
"label.weixin.settlement.rate":`อัตราการรับชำระหนี้`,
"front-lightning-module-v1-details-page-chart-add-report":`เพิ่มแผนภูมิรายงานมากที่สุด 10 แผนภูมิ`,
"label_related_list_types":`ประเภทรายการที่เกี่ยวข้องกับรุ่น Lightning`,
"label.tabpage.converstatez":`สถานะข้ามสเตจแล้ว`,
"label.chatter.ok":`ยืนยัน`,
"lable.SalesCommitmentKanBan.contractRate":`อัตราสัญญาลงนาม`,
"component.setup.label.setupsavefail":`บันทึกการตั้งค่าส่วนเสริมล้มเหลว`,
"label.email.form.text2":`[เปลี่ยนเป็น "HTML" ]`,
"UG.Lead.009":`APP บันทึกการโทร`,
"label.escalation.setup.newrule.title":`เกณฑ์การเลื่อนขั้นเคส`,
"label.field.available.value":`ค่าฟิลด์ที่ใช้การได้มี`,
"label.cannotuseaddtimetrigger":`<b>  เพิ่มปุ่มทริกเกอร์เวลา</b>ไม่สามารถใช้ได้ในสถานการณ์ต่อไปนี้:<br/><ol><li>  เงื่อนไขของกฎถูกตั้งค่าเป็นทุกครั้งที่สร้างหรือแก้ไขบันทึก</li><li>  
เปิดการใช้งานกฎแล้ว</li></ol>`,
"vue_label_chat_activefail":`การเปิดใช้งานล้มเหลว`,
"label.dashboard.show.total.percent":`แสดงผลรวมและแสดง % กรุณาเลือกอย่างน้อย 1 ตัวเลือก`,
"label.schedulejob.setup.schedule.jobprg":`จัดตารางเวลางาน`,
"label.select.email.type":`โปรดเลือกประเภทข้อความ!`,
"chatter.group.allTheMembers":`สมาชิกทั้งหมด`,
"label.webtab.validation.apiname":`ต้องขึ้นต้นด้วยตัวอักษร มีได้เฉพาะตัวอักษรตัวพิมพ์ใหญ่ตัวพิมพ์เล็ก ตัวเลข ขีดล่าง ความยาวมากที่สุด 20 หลัก และน้อยที่สุด 2 หลัก`,
"label_partner_new_step3_name":`ชื่อ`,
"vue_label_chatter_remove_member":`ลบสมาชิก`,
"label.customobjects.majorobject.tip":`หากคุณเลือกออบเจ็กต์ที่ไม่ได้มีความสัมพันธ์แบบข้อมูลหลัก-ข้อมูลรอง ข้อมูลสรุปจะไม่ทำตามสิทธิ์`,
"label.forecast.edit.kjjd":`ไตรมาสบัญชี`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`สัปดาห์ที่สาม`,
"label.weixin.senderror":`การส่งล้มเหลว`,
"label.visiturl":`เยี่ยมชม URL`,
"label.apply.img.error":`อักขระในรูปภาพป้อนไม่ถูกต้อง`,
"label.been.detained":`รีเซ็ตส่วนลด`,
"vue_label_helpcenter_dashboard2":`ในแดชบอร์ดที่สร้างขึ้นใหม่ คุณต้องเพิ่มส่วนเสริมก่อนแล้วจึงเลือกแหล่งข้อมูลรายงานหรือแหล่งข้อมูลมุมมองรายการ จากนั้นกำหนดประเภทของแผนภูมิที่ใช้และเลือกการจัดกลุ่มและข้อมูลสถิติที่เกี่ยวข้องเพื่อสร้างแผนภูมิ<br>&nbsp;&nbsp;&nbsp;&nbsp;หลังจากเพิ่มส่วนเสริมแล้ว คุณสามารถคลิกปุ่ม "เรียงลำดับใหม่" บนแดชบอร์ดเพื่อปรับตำแหน่งและขนาดของส่วนเสริม <br>&nbsp;&nbsp;&nbsp;&nbsp;หากคุณต้องการตั้งค่าเงื่อนไขตัวกรองเวลาสำหรับบางส่วนเสริม คุณสามารถคลิก "การตั้งค่าเงื่อนไขตัวกรอง" เพื่อเลือกส่วนเสริมและตั้งค่าฟิลด์เวลาที่ส่วนเสริมต้องใช้กรอง หลังจากนั้นคุณสามารถใช้ตัวกรองเวลาแดชบอร์ด เลือกช่วงเวลาที่เกี่ยวข้องเพื่ออัปเดตข้อมูลที่เลือก <br>&nbsp;&nbsp;&nbsp;หมายเหตุ: แดชบอร์ดรองรับส่วนเสริมได้มากที่สุด 10 รายการ <br>2. การเจาะและการเชื่อมของส่วนเสริม<br>&nbsp;&nbsp;&nbsp;&nbsp;ในแดชบอร์ดเดียวกัน ส่วนเสริม A สามารถตั้งค่าส่วนเสริม B และ C จากแหล่งข้อมูลเดียวกันกับออบเจ็กต์การเชื่อมโยง หลังจากนั้นให้คลิกที่พื้นที่ข้อมูลของส่วนเสริม A, B, และ C เพื่อทำสถิติข้อมูลใหม่ตามเงื่อนไขของส่วนเสริม A พร้อมกัน <br>&nbsp;&nbsp;&nbsp;&nbsp;โปรดทราบว่าการคลิกบนพื้นที่ข้อมูลของส่วนเสริม B หรือ C ส่วนเสริม A จะไม่สร้างสถิติใหม่ หากต้องการ คุณต้องตั้งค่าส่วนเสริม A เป็นออบเจ็กต์การเชื่อมโยงบนส่วนเสริม B/C <br>&nbsp;&nbsp;&nbsp;&nbsp;ข้อมูลส่วนเสริมแผนภูมิแต่ละรายการในแดชบอร์ดมาจากมุมมองหรือรายงาน ดังนั้นจึงมีฟังก์ชันการเจาะ กล่าวคือ การคลิกที่พื้นที่ข้อมูลของส่วนเสริมสามารถข้ามไปยังรายงานที่เกี่ยวข้องและมุมมองรายการได้ โปรดทราบว่าหากแหล่งข้อมูลดั้งเดิมล้มเหลว ส่วนเสริมจะไม่มีข้อมูลและฟังก์ชันการเจาะก็จะล้มเหลวด้วย <br>&nbsp;&nbsp;&nbsp;&nbsp;เนื่องด้วยการเจาะและการเชื่อมโยงเป็นพื้นที่ข้อมูลของส่วนเสริมที่ถูกคลิก ทั้งสองฟังก์ชันจึงไม่สามารถมีผลพร้อมกันได้ หากส่วนเสริมมีสองฟังก์ชันพร้อมกันจะมีผลเพียงฟังก์ชันเดียวโดยการเปลี่ยนสถานะของฟังก์ชัน`,
"vue_label_commonobject_view_notice_delete_false":`การลบบันทึก{0}ล้มเหลวเนื่องจาก{1};`,
"label.weixin.newspaper.coverage.information":`ข้อมูลกรมธรรม์`,
"label.you.do.not.have.permission.to.operate.":`คุณไม่มีสิทธิ์รดําเนินการ`,
"label.checkfield.match":`ตรงกัน`,
"message.custom.field.donotdelete.ref":`ฟิลด์ถูกอ้างถึงโดยฟิลด์อื่น`,
"label.version.maxsum":`ถึงขีดจำกัดแล้ว!`,
"System.ChangeUser.Info.001":`การเปลี่ยนเจ้าของสำเร็จ คุณไม่มีสิทธิ์ดูบันทึกนี้ คลิกเพื่อกลับไปยังหน้าก่อนหน้า`,
"label.target":`เป้าหมาย`,
"template.dashboard.behavior.analysis":`การวิเคราะห์พฤติกรรม`,
"label.login.verification.enter.prompt":`กรุณาใส่รหัสความปลอดภัยเป็นตัวเลข 6 หลัก`,
"label.am":`โมงเช้า`,
"chatter.emailSetUp.remark":`ใช้เพื่อติดตามผู้คน และดำเนินการเกี่ยวโพสต์ใน CCChat เลือกว่าจะส่งอีเมลหรือไม่`,
"label.accmarketsea.grouplist.title":`การตั้งค่าการจัดกลุ่มฐานข้อมูลลูกค้า`,
"label.stdashbord.xsld.business.danwei":`หน่วย: หมื่นหยวน`,
"label.app.step1.error.namenull":`ชื่อกลุ่มสาธารณะไม่สามารถว่างเปล่า`,
"label.login.button.verification":`ส่งการตรวจสอบยืนยัน`,
"label_tabpage_newWizardz":`ตัวช่วยสร้างฟังก์ชันใหม่`,
"label.addattachment.step1.intruduce":`ป้อนเส้นทางของไฟล์หรือคลิกปุ่มเพื่อค้นหาไฟล์`,
"pagecreator.layout.funcpath":`/ตัวสร้าง/ไลบรารีเค้าโครง`,
"fourth":`ลำดับที่สี่`,
"label.timetrigger.after.lasttime":`1 วันหลังจากเวลาแก้ไขล่าสุด`,
"vue_label_report_showme":`แสดงให้ฉันเห็น`,
"label.h5.similar.opportunity.end.date.in":`วันที่สิ้นสุดอยู่ในช่วงเวลาต่อไปนี้`,
"label.turntonextstep":`ไปที่ขั้นตอนถัดไป`,
"label.icon.106":`กำหนดการ`,
"label.user.receivenewsbulletin":`รับจดหมายข่าว`,
"label.mask.card.number":`หมายเลขบัตรเครดิต`,
"setup.object.layout.label.profileoptions":`โปรไฟล์ที่กำหนดได้`,
"vue_label_systemSettings_obj":`ออบเจ็กต์และฟิลด์`,
"label.call.center.history.open":`เปิดหน้าบันทึกการโทรโดยอัตโนมัติ`,
"label.attendance.cityname":`กรุณาใส่ชื่อเมือง`,
"label.newemailnotice.tip":`สร้างการแจ้งเตือนทางอีเมลเพื่อเชื่อมโยงกฎเวิร์กโฟลว์และกระบวนการอนุมัติหนึ่งกฎขึ้นไป หากการเปลี่ยนแปลงแจ้งเตือนทางอีเมลหรือมีการแก้ไขใดๆ จะถูกนำไปใช้กับกฎและการอนุมัติทั้งหมดที่เกี่ยวข้อง`,
"label.app.step1.error.labelnull":`ข้อผิดพลาด: ป้ายกำกับไม่สามารถว่างเปล่า`,
"front-kefu-moudle-connect-free-account":``,
"label.biaoqingfaxian.description":`เลือกเปิดใช้งานการค้นพบการเสนอราคา คุณสามารถเพิ่มเมนูค้นหาการเสนอราคาที่หน้าเว็บ ผู้ใช้สามารถดูข้อมูลการเสนอราคาของอุตสาหกรรมที่เกี่ยวข้อง และแปลงข้อมูลการเสนอราคาเป็นลีดในระบบ`,
"label.filter":``,
"label.data.downpage.e.title.num1":`1. เลือกออบเจ็กต์ที่จะส่งออกข้อมูลหรือเลือกส่งออกทั้งหมด`,
"label.h5.similar.opportunity.last.months12":`9-12 เดือนล่าสุด`,
"label.chatter.name":`ชื่อ`,
"vue_label_helpcenter_email":`1. การส่งอีเมล <br> การออกจากระบบและไปยังอีเมลของคุณและรับส่งอีเมลกับผู้ติดต่อของคุณได้กลายเป็นเรื่องอดีตไปแล้ว บน CloudCC คุณสามารถเชื่อมอีเมลส่วนตัวและรับส่งอีเมลจาก CloudCC ได้โดยตรง เมื่อคุณป้อนที่อยู่อีเมลหรือชื่อผู้รับจะจับคู่กับผู้ติดต่อหรือบันทึกลีดสำหรับคุณ คุณยังสามารถเชื่อมอีเมลกับบันทึกที่เกี่ยวข้องที่กำหนด และอีเมลที่คุณส่งจะถูกซิงค์กับหน้ารายละเอียดบันทึก <br>2. 4 ฟังก์ชันที่ใช้บ่อยเมื่อส่งอีเมล<br> เมื่อส่งอีเมล คุณสามารถใช้ 4 ฟังก์ชันด้านล่างเพื่อช่วยคุณ <br>การติดตามอีเมล<br> เมื่อคุณเปิดการติดตามอีเมล เราจะช่วยคุณตรวจสอบจำนวนครั้งที่อีเมลนี้ถูกเปิดและเวลาที่เปิดล่าสุด คุณสามารถวางเมาส์เหนือไอคอน "ตา" ในกล่องขาออกเพื่อดู <br>อัปโหลดไฟล์แนบ<br> คลิก อัปโหลดไฟล์แนบ คุณสามารถเลือกไฟล์ที่อัปโหลดไปยังระบบ และเลือกอัปโหลดไฟล์ก็ได้ คุณสามารถเลือกไฟล์แนบได้หลายไฟล์ตราบที่ขนาดไฟล์แนบน้อยกว่า 20M <br>แทรกฟิลด์ผสาน<br> เมื่ออีเมลเชื่อมโยงกับบันทึกออบเจ็กต์ คุณสามารถคลิกแทรกฟิลด์ผสาน เลือกวัตถุที่เกี่ยวข้อง เลือกฟิลด์ที่คุณต้องการแทรก และป้อนข้อความแทนที่หลังเครื่องหมายจุลภาคในฟิลด์ผสาน เช่น {!Contact.FirstName,Sir or Madam} เมื่อบันทึกแม่แบบ ฟิลด์ผสานจะแสดงในเนื้อหาอีเมลของแม่แบบ ใช้ฟิลด์ผสานเพื่อปรับแต่งเนื้อหาในอีเมลของคุณ คุณสามารถเพิ่มข้อความแทนที่ลงในฟิลด์ผสานใดๆ โดยข้อความแทนที่จะแสดงเมื่อบันทึกที่ผสานไม่มีข้อมูลในฟิลด์เท่านั้น <br>แก้ไขและเปิดใช้งานลายเซ็น<br> เมื่อคุณส่งอีเมลงาน ลายเซ็นที่แสดงถึงตัวตนจะช่วยยกระดับความเป็นมืออาชีพของคุณ คลิกปุ่ม "แก้ไขลายเซ็น" ้เพื่อแก้ไขข้อมูลพื้นฐานของคุณ และพร้อมรองรับการแทรกรูปภาพ หากคุณเลือก "เปิดใช้ลายเซ็น" ลายเซ็นของคุณจะถูกแนบไปกับเนื้อหาทุกครั้งที่คุณเขียนอีเมล และคุณสามารถปิดลายเซ็นได้ทุกเมื่อ <br>3. กรองกล่องขาเข้า<br> คุณสามารถกรองอีเมลที่ยังไม่ได้อ่านทั้งหมดในกล่องขาเข้าเพื่อความสะดวกในการทำงาน เมื่อคุณต้องการดาวน์โหลดไฟล์ทางอีเมล คุณสามารถกรองอีเมลทั้งหมดที่มีไฟล์แนบในกล่องขาเข้าของคุณเพื่อค้นหาอีเมลที่ต้องการได้อย่างรวดเร็ว นอกจากนี้คุณสามารถเข้าใจบันทึกของลูกค้าในระบบผ่านอีเมลได้อย่างรวดเร็วด้วยการกรองอีเมลลีดหรือกรองอีเมลที่ส่งโดยลีดหรือผู้ติดต่อ <br>4. การส่งอีเมลแบบกลุ่ม<br> มีปุ่มการส่งอีเมลแบบกลุ่มที่มุมขวาบนของลีดและรายชื่อผู้ติดต่อ คุณสามารถส่งอีเมลแบบกลุ่มไปยังลีดหรือผู้ติดต่อที่มีที่อยู่อีเมล เมื่อคุณมีบันทึกแคมเปญ คุณสามารถส่งอีเมลไปยังสมาชิกแคมเปญเป็นกลุ่มได้ ซึ่งสะดวกต่อการส่งคำเชิญเข้าร่วมกิจกรรมของคุณ`,
"front-kefu-moudle-auto-callphone":``,
"label.fiscal.FQ":`ไตรมาสบัญชี`,
"label_tabpage_groupsVisiblez":`ผู้ใช้บางกลุ่มมองเห็น`,
"UG.product.01":`แสดงรายการผลิตภัณฑ์/บริการ`,
"vue_label_commonobjects_view_members":`ตัวเลือกสมาชิก`,
"label.organization.id":`ID องค์กร`,
"label.tyle_preview":`แสดงตัวอย่างรูปแบบ`,
"label.campaign.channel.input.to.owner":`6. โปรดตั้งค่าว่าจะแจ้งให้เจ้าของทราบเมื่อสมาชิกลงทะเบียนเข้าหรือไม่:`,
"label.appointmentconfirmpage.wizard.notif1":`การนัดหมายถูกยกเลิก`,
"lable.tianyancha.maping":`การแม็ปฟิลด์`,
"front-kefu-moudle-v1-noadd-online-chats":`ไม่เพิ่ม seat ออนไลน์`,
"vue_label_commonobjects_detail_group_strategy":`ยืนยันที่จะเข้าร่วมกลยุทธ์กลุ่มลูกค้านี้หรือไม่？`,
"vue_label_report_deletegrouprow":`ลบแถวกลุ่ม`,
"lable.account.y.d":`หน้านี้ช่วยให้คุณกำหนดบันทึกปีงบประมาณเองได้ วันที่ของปีงบประมาณที่กำหนดเองจะถูกสร้างตามที่คุณเลือกด้านล่าง`,
"label.visualpage.lllegal.definitions":`นิยามของการกระทำผิดกฎหมาย`,
"label.tabpage.enterrecordnamez":`กรุณาใส่ผู้บันทึก`,
"vue_label_report_howmuchlines":`{length} แถว`,
"homepage.components.custom":`ส่วนเสริมที่กำหนดเอง`,
"label.campaign.channel.upload.img":`อัปโหลดรูปภาพ`,
"UG_Case_03":`การเลื่อนขั้นเคสแบบอัตโนมัติ`,
"label.approved.receiveApprovalEmail.option4":`ไม่เคย`,
"System.Data.Import.Warning.MaxCount":`องค์กรของคุณสามารถนำเข้าข้อมูลได้ครั้งละ {0} รายการเท่านั้น ตอนนี้ข้อมูลเกินแล้ว กรุณาปรับเปลี่ยนและนำเข้าอีกครั้ง`,
"label.sent.sms":`ส่งข้อความสั้น`,
"vue_label_dashboard_statistictype":`ประเภทสถิติ`,
"label_report_last_year_same":`ในช่วงเวลาเดียวกันของปีที่แล้ว`,
"lable.Examle":`ตัวอย่าง`,
"label.customerinfo.PageTriggerFagTitle":`ซิงค์ทุก 2 ชั่วโมง`,
"label.mobile.phone.read":`อ่าน`,
"label.product.gopage":`ไปที่`,
"label.a_b_without":`บันทึกA"อาจจะมีหรือไม่มีความเกี่ยวข้องกับบันทึก"B" "`,
"front-kefu-moudle-callin-missphone":``,
"label.sso.saml.sp.idsource.attrname":`ชื่อแอตทริบิวต์`,
"label.h5.chatter.colleagues2":`เพื่อนร่วมงาน`,
"label.approveprocess":`กระบวนการอนุมัติ`,
"label.dataimport.error.name.null":`เกิดข้อผิดพลาด: name ว่างเปล่า`,
"label.paging.countitems":`{0} รายการ`,
"vue_label_report_notice_filter":`เมื่อไม่ได้เปิดใช้งานตัวกรองขั้นสูงให้ใช้  "และ" คั่นระหว่างเงื่อนไขตัวกรอง  นั่นคือบันทึกที่มีลักษณะสอดคล้องกับ 1 และ 2 จะแสดงลงในรายงาน เช่น  1. เป็นโอกาสทางธุรกิจที่มีจํานวนเงินมากกว่า 1 ล้าน และ 2. เป็นวันที่ทําสัญญาคาดการณ์เท่ากับเดือนนี้ ผลลัพธ์ของรายงานคือโอกาสทางธุรกิจมากกว่า 1 ล้านในเดือนนี้`,
"front-lightning-module-v1-dashborad-export-picture":`ส่งออกรูปภาพ`,
"label.activity.disabled":`ไม่ได้เปิดใช้งานกิจกรรม โปรดติดต่อผู้ดูแลระบบของคุณเพื่อเปิดใช้งานประวัติกิจกรรมและกิจกรรมที่ยังไม่ได้จัดการบนเค้าโครงเพจ`,
"message_chooseatleastonefield":`โปรดเลือกฟิลด์ที่จะแสดงอย่างน้อยหนึ่งฟิลด์`,
"label.case.text":`ใบคำขอบริการที่ส่งผ่านเว็บไซต์สามารถสร้างบันทึกของเคสในระบบได้ โปรดเลือกผู้ใช้เพื่อเป็นผู้สร้างบันทึก โดยผู้ใช้ที่เลือกต้องมีสิทธิ์ในการสร้างเคส หน้าเว็บนี้เหมาะสำหรับคอมพิวเตอร์และโทรศัพท์มือถือ`,
"label.sendmail.step3.dealoption1":`สำเนาลับอีเมลทุกฉบับให้ฉัน`,
"label.forecast.settings.title.remark":`การคาดการณ์รายได้ที่ดีที่สุดสำหรับผู้ใช้ จะให้ผู้ใช้เห็นภาพรวมของธุรกิจที่สมบูรณ์`,
"label.apply.youxiaotime.finish.opperation":`มีช่วงเวลายังผล 5 นาที โปรดดำเนินการให้เสร็จสิ้นโดยเร็ว หากคุณไม่ได้ดำเนินการด้วยตัวเอง โปรดเพิกเฉยต่อข้อความนี้`,
"label.user":`ผู้ใช้`,
"pagecreator.page.button.copy":`คัดลอก`,
"label.userinfo.pwdupdate.or.reset":`รหัสผ่านของคุณถูกเปลี่ยนครั้งล่าสุดหรือรีเซตเมื่อ`,
"label.fieldupdata":`อัปเดตฟิลด์`,
"label.sendemail.chat.followsubject":`มีคนติดตาม CloudCC CCChat`,
"component_task_label_enddate":`วันหมดอายุ`,
"label.campaign.channel.step6.remark5":`คุณสามารถกำหนดเกณฑ์การมอบหมายใหม่ทางเกณฑ์การมอบหมายลีด`,
"label.mr.title.mobilePhone":`โทรศัพท์มือถือ`,
"label.notice":`แจ้งเตือน`,
"message.serviceappo.time.violation":`การละเมิดเวลาที่อนุญาตสําหรับการนัดหมายบริการ: เวลาสิ้นสุดการนัดหมายการบริการที่วางแผนน้อยกว่าเวลาเริ่มต้นที่เร็วที่สุดที่อนุญาต`,
"label.account":`ลูกค้า`,
"front-kefu-moudle-callcenter-user":``,
"label.usermanage.query.notexist":`ไม่พบผู้ใช้ที่สอบถาม`,
"label.forecast.userinfo.isnable":`อนุญาตให้พยากรณ์`,
"label_partner_workspace_member":`สมาชิก`,
"vue_label_dashboard_penetrationsetting":`การตั้งค่าการเจาะ`,
"chatter.fieldtrack.operatecreate":`สร้างแล้วหนึ่งรายการ`,
"label_tabpage_tpcustomersz":`ลีดข้ามสเตจ`,
"label.emailtocloudcc.redmessage6":`การยืนยัน IMAP / SMTP ล้มเหลว โปรดตรวจสอบว่าที่อยู่อีเมลและรหัสผ่านถูกต้องหรือไม่`,
"label.customfields.file.upload":`อัปโหลด`,
"label.forecast.isforecast":`ไม่ได้เปิดใช้งานการพยากรณ์รายได้`,
"label_benchmark":`เกณฑ์มาตรฐาน`,
"label.exchange.sync.state.system":`สถานะการซิงค์ระบบ`,
"UG.opportunity.003":`ติดตามช่องทางการขายของคุณ สร้างแดชบอร์ด`,
"label.campaign.matchway.select.error":`หากต้องการอัปเดตข้อมูล โปรดเลือกวิธีจับคู่`,
"vue_label_dashboard_located":`โฟลเดอร์ที่แดชบอร์ดตั้งอยู่`,
"front-electronic-signature-enter-object":``,
"vue_label_systemSettings_mobelquick":`การตั้งค่าด่วนสำหรับแอปมือถือ`,
"lable.outlook.list":`การปรับแต่ง Exchange Sync`,
"label.sendemail.approval.dlsp":`สวัสดี ,#dlspr：\n #actornameเสนอ#objAPIName-#recordname เมื่อ #actordate เนื่องจากผู้อนุมัติ#spr กำหนดให้คุณเป็นผู้อนุมัติแทน และกำลังรอการอนุมัติจากคุณ \n โปรดคลิกลิงก์ด้านล่างหรือเข้าสู่ระบบ CRM เพื่อเข้าสู่การอนุมัติโดยศูนย์การอนุมัติ: \n#url\n ขอบคุณ! \n#orgName`,
"label.service.deleteCustomView.wanttoremove.filter":`ยืนยันหรือไม่ว่าต้องการลบตัวกรอง "{name}"?`,
"component_task_label_newevent":`ภารกิจใหม่`,
"vue_label_commonobjects_view_chart_groupby":`แบ่งกลุ่มตาม`,
"front-kefu-moudle-v1-edit-chats":`แก้ไข Seat`,
"pagecreator_page_message_delete_fail":`การลบหน้าเพจล้มเหลว`,
"label.file.search":`ค้นหาไฟล์`,
"label.projectManagement.Addpredecessors":`เพิ่มงานก่อนหน้า`,
"label_tabpage_norecordtypez":`ชนิดบันทึกไม่พร้อมใช้งาน`,
"label.come.recycle.bin":`เข้าสู่ถังขยะรีไซเคิล`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`เกี่ยวข้องกัน`,
"label.customfields.address.tip":`อนุญาตให้ผู้ใช้เลือกฟิลด์ข้อมูลจังหวัด เมือง อำเภอ และใส่รายละเอียดข้อมูลที่อยู่ที่สามารถใช้ในการคำนวณละติจูดและลองจิจูด`,
"label.weixin.optioneight":`ตัวเลือกที่แปด`,
"label.recordtypeselect.modify":`แก้ไขชนิดบันทึก`,
"label.forecast.settings.future3":`3 รอบถัดไป`,
"label.rename":`เปลี่ยนชื่อ`,
"label.emailtocloudcc.button.complete":`สำเร็จ`,
"chatter.new.at":`กิจกรรมล่าสุด`,
"component.setup.label.milestonesfield":`ฟิลด์ไมล์สโตน`,
"vue_label_commonobjects_detail_email_newaddress":`ที่อยู่อีเมลผู้รับ`,
"lable.PowerProcess.big.event":`อิเวนต์สําคัญ：`,
"label.appexchange.uninstallpage.confirm":`ใช่ ฉันต้องการถอนการติดตั้งโปรแกรมสำเร็จรูปนี้ และลบส่วนเสริมที่เกี่ยวข้องทั้งหมดอย่างถาวร`,
"label_mobile_buttom_homepage":`หน้าแรก`,
"label.sso.saml.idp.config.logouturl":`URL Single Logout`,
"lable.quote.pdf.button.savetoquote":`บันทึกลงในใบเสนอราคา`,
"label.page.select.application":`เลือกแอปพลิเคชันกำหนดเองที่ต้องการใช้ในแท็บเมนูที่กำหนดเองใหม่ และยังสามารถตรวจสอบหรือปรับเปลี่ยนว่าแท็บเมนูจะแสดงในหน้ารายละเอียดและหน้าแก้ไขของแต่ละแอปพลิเคชันที่กำหนดเองได้หรือไม่`,
"chatter.down":`ดาวน์โหลด`,
"label.tabpage.searchz":`ค้นหา`,
"label.emailsync.form.action":`ปฏิบัติการ`,
"label.campaignmember.setup.campaignmember.field":`ฟิลด์สมาชิกแคมเปญ`,
"label.version.remark":`หมายเหตุ : รุ่นสำหรับใช้ฟรีจำกัดผู้ใช้ 5 คน สร้างบันทึกได้ 2,000 รายการ และไม่รองรับการนำเข้าและส่งออกข้อมูล`,
"label.selectoperateobject":`เลือกออบเจ็กต์ที่จะดำเนินการ`,
"label.appointmentdetail.wizard.title12":``,
"label.submitforapproval":`ส่งเพื่อขออนุมัติ`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`ขอบเขตล่างของส่วนลดที่แก้ไขแต่ละขั้นต้องเท่ากับขอบเขตบนของขั้นก่อนหน้า`,
"label.appupload.install.component.view":`ดูส่วนเสริม`,
"label.profile.customobjcontrol":`สิทธิ์ออบเจ็กต์ที่กำหนดเอง`,
"label.customfields.configprofilefieldsafety.tip":`เลือกโปรไฟล์ที่คุณต้องการให้สิทธิ์แก้ไขฟิลด์นี้ผ่านการรักษาความปลอดภัยระดับฟิลด์ หากคุณไม่เพิ่มฟิลด์ในการรักษาความปลอดภัยระดับฟิลด์ ฟิลด์จะไม่แสดงในโปรไฟล์ใดๆ`,
"label.service.gantt.service.resources":`ทรัพยากรบริการ`,
"label.input.right.emailaddress":`กรุณากรอกที่อยู่ Email ที่ถูกต้อง`,
"label.ccdocument.folder.notedit":`โฟลเดอร์นี้ไม่สามารถแก้ไขได้!`,
"label.data.choses.i.desc":`เลือกนำเข้าข้อมูลของออบเจ็กต์เดียวตามความต้องการของคุณ`,
"label.icon.75":`รถยนต์`,
"label.summaryreport.step4":`ขั้นตอนที่ 4: เลือกคอลัมน์รายงาน`,
"label.appupload.upload.install":`ติดตั้ง`,
"label.reportlist.newfolder":`โฟลเดอร์รายงานใหม่`,
"label.projectManagement.myproject":`โครงการของฉัน`,
"label.true":`จริง`,
"label.tabpage.reallproplez":`เจ้าของบันทึก`,
"label.change.lead.share.error":`ไม่มีสิทธิ์แก้ไขลูกค้า`,
"F":`วันที่/เวลา`,
"lable.account.CurrentandNextCQ":`ไตรมาสปฏิทินนี้และถัดไป`,
"UG.activity.06":`ต้องการติดตามลูกค้า`,
"UG.contact.03":`ติดตามผู้ติดต่อและสัญญาณการขายในที่เดียว`,
"label.field.duplicate.error.msg2":`การตั้งค่าคุณสมบัติเฉพาะล้มเหลว`,
"label.sales.dashboard.reality":`ได้รับชำระหนี้จริง`,
"lable.PowerProcess.type":`ประเภทกระบวนการให้สิทธิ์`,
"batch.selected.data":`จำนวนข้อมูลที่เลือก`,
"#label.importsourcefilestep2":`ขั้นตอนที่ 2: บีบอัดไฟล์ของคุณ(ตัวเลือก) #`,
"label.emailtemplate.select":`โปรดเลือกแม่แบบอีเมลที่คุณต้องการจะใช้`,
"chatter.most.w":`ป้อนอักขระได้สูงสุด 500 ตัว!`,
"vue_label_calendar_new_object_calendar":`ปฏิทินออบเจ็กต์ใหม่`,
"label.aggregated_formsdata":`สรุปข้อมูลฟอร์ม`,
"label.knowledge.language.french":`ภาษาฝรั่งเศส`,
"label.customfields.enc.tip":`อนุญาตให้ผู้ใช้ป้อนตัวอักษรและตัวเลขผสมกันและจัดเก็บในรูปแบบการเข้ารหัสที่ไม่สามารถค้นหาได้`,
"label.icon.158":`เมฆ`,
"font-evaluate-module-v1-bad-review ":``,
"UG_quota_03":`แม่แบบใบเสนอราคา`,
"label.eidt.queue.label.hasused":`ป้ายกำกับนี้ถูกใช้แล้ว`,
"label.lookupfilter":`ค้นหาตัวกรอง`,
"label.callcenter.Instance.name":``,
"label.commitertype":`ประเภทผู้เสนอ`,
"vue_label_checkduplicate_any_one":`สอดคล้องกับหนึ่งรายการ`,
"label.campaign.channel.input.img":`โปรดเลือกรูปภาพจากคอมพิวเตอร์เพื่อทำเป็นหน้าเพจขอบคุณ`,
"vue_label_dashboard_pleaseenterafoldername":`กรุณาใส่ชื่อโฟลเดอร์`,
"label.tianyancha.look":`ดู`,
"label.tabpage.lastone":`เลือกอย่างน้อยหนึ่งการปฏิบัติการ`,
"label.sendemail.approval.submit.title":`{!objLabel}-{!recordName} กำลังรอคุณอนุมัติ`,
"label.chat.topic.delete.prompt1":`กว่าจะลบหัวข้อเสร็จสมบูรณ์ต้องใช้เวลา หัวข้อจะยังคงถูกเก็บไว้ในโพสต์และบันทึก`,
"component_setup_label_displaybutton":`แสดงปุ่มกด`,
"label.partnerCloud.backgroundImage":`ภาพพื้นหลัง`,
"label.mobile.phone.time.range":`ช่วงเวลา`,
"label.page.url.address.remark":`ป้อนที่อยู่ของเว็บเพจในฟิลด์ "ลิงก์ URL" คุณสามารถป้อนที่อยู่ URL อย่างง่ายได้เหมือนกับแบบที่แสดงในเบราว์เซอร์ คุณยังสามารถใช้ฟิลด์ผสานตั้งแต่หนึ่งฟิลด์ขึ้นไปเพื่อแทรกข้อมูลเฉพาะขององค์กรจาก CloudCC ลงในพารามิเตอร์ URL เนื่องด้วยการตั้งค่าความปลอดภัยของเบราว์เซอร์ หรือเพราะไซต์ถูกบล็อกไม่ให้แสดงในเฟรม บางไซต์อาจไม่พร้อมใช้งานในแท็บ Web`,
"label.h5.copyemail":`คัดลอกอีเมลแล้ว`,
"label.view.step3":`ขั้้นตอนที่ 3: เลือกฟิลด์ที่ต้องการให้แสดง`,
"label.quickbooks.view.moneyreceived":`รับเงิน`,
"label.emailobject.attachment.preview":`แสดงตัวอย่าง`,
"label.selectapprover":`เลือกผู้อนุมัติ`,
"vue_label_normal_opportunity_sf":`โอกาสทางธุรกิจ`,
"label_emailtocloudcc_filed_port":`พอร์ต`,
"mesage.errorinsaving":`เกิดข้อผิดพลาดระหว่างการบันทึก กรุณาติดต่อผู้ดูแลระบบ`,
"label.partnerCloud.partnerCloudName":`โปรดป้อนชื่อพาร์ทเนอร์คลาวด์`,
"lable.edit.queue.checkemail":`ข้อผิดพลาด: ที่อยู่อีเมลไม่ถูกต้อง`,
"label_builder":`ตัวสร้างเพจ`,
"component_setup_label_setupsavefail":`บันทึกการตั้งค่าส่วนเสริมล้มเหลว`,
"label.icon.76":`รถยนต์`,
"label.reportsSubscriptionPage.schedulereport.monthly":`รายเดือน`,
"message.nopermession":`ไม่ได้รับอนุญาต`,
"label.view.groupscansee":`บาง<b>กลุ่มผู้ใช้</b>ที่มองเห็นได้`,
"label.leadscore.rule.new":`การให้คะแนนลีด: สร้างเกณฑ์ใหม่`,
"label.new.ccpeakfolder.time":`คลาสตัวจับเวลา: สร้างโฟลเดอร์ใหม่`,
"label.record":`บันทึก`,
"message.error.flabel":`ป้ายกำกับฟิลด์ไม่อนุญาตให้มีเครื่องหมายอัญประกาศเดี่ยวและอัญประกาศคู่เป็นภาษาอังกฤษ`,
"label.emailobject.emaildetail.promptbutton2":`ยกเลิก`,
"label.h5.phone":`โทรศัพท์`,
"label.visualpage.error.deal.with":`เกิดข้อผิดพลาด โปรดติดต่อผู้ดูแลระบบ`,
"label.button.step1.select.field":`ขั้นตอนที่ 1: เลือกฟิลด์`,
"label.setsharerule.step1":`ขั้นตอนที่ 1: เลือกประเภทของกฎที่่ต้องการตั้งค่า`,
"component.chatter.file.label.title":`อัปโหลดไฟล์`,
"front-epwechat-module-v1-appname":`ชื่อแอป:`,
"chatter.error.notsel":`ข้อผิดพลาด: โปรดเลือกภาพที่จะอัปโหลดก่อน!`,
"label.updatevalue":`ค่าที่แน่นอนที่จะเปลี่ยนแปลง`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0}โพสต์ไฟล์พนักงานทั้งหมดในกลุ่ม{1}`,
"label_tabpage_grid":`แสดงผลแบบกริด`,
"homepage.components.standard":`ส่วนเสริมมาตรฐาน`,
"label.movable":`ไดนามิก`,
"label.report.selected.field.cannot":`ต้องเลือกไม่เกิน 50 ฟิลด์`,
"label.projectManagement.distribution.by.excess":`จัดสรรตามส่วนเกิน`,
"addrow":`เพิ่มแถว`,
"label.approvaldatamove.p":`ใช้ตัวเลือกด้านล่างเพื่อจัดการคำขอจำนวนมากที่รอการอนุมัติ หากต้องการเริ่มต้นให้กรองบันทึกคำขออนุมัติและคลิก "ค้นหา" เมื่อรายการผลลัพธ์ปรากฏให้ระบุการดำเนินการที่จะดำเนินการ`,
"label.passwordPolicy.setup.title":`นโยบายรหัสผ่าน`,
"label.appointmentpage.wizard.title1":`0}（{1}）เชิญคุณ`,
"label.tippage.li1":`ลบแหล่งข้อมูลรายงานที่กำหนดเองอย่างถาวร`,
"label.campagin.roi.dcl":`อัตราการเข้าร่วม`,
"label.h5.new.errorbody":`โปรดกรอกข้อมูลทั้งหมดในฟิลด์บังคับที่มีเครื่องหมาย *`,
"label.cy.enable":`การเปิดใช้สกุลเงิน`,
"label.currency.rate.e":`แก้ไขอัตราแลกเปลี่ยนระหว่างสกุลเงินที่องค์กรใช้`,
"or":`หรือ`,
"lable.custom.Previous.CYt":`ปีที่กําหนดเองสองปีแรก`,
"front-epwechat-module-v1-unbound-desc":`หลังจากยกเลิกการผูกแล้ว บัญชีที่ผูกไว้จะถูกล้าง ยืนยันว่าจะเลิกการผูกหรือไม่?`,
"pagecreator_button_publish":`ประกาศ`,
"font-evaluate-module-v1-case-owners":``,
"label.pw.new":`กรุณาใส่รหัสผ่านใหม่`,
"message.tabsearch.nokeywords":`กรุณาใส่คีย์เวิร์ดที่มีความยาวอักขระอย่างน้อยหนึ่งตัว`,
"label.sendemail.send.erroruser":`ผู้ใช้ไม่ถูกต้อง`,
"label.personalinfo":`ข้อมูลส่วนตัวของฉัน`,
"label.case":`เคส`,
"lable.product.pricebooks.now":`สมุดราคาที่มีอยู่`,
"label.ccpeak.take.notice":`โปรดทราบว่า : ฟิลด์ที่ระบบสร้างอัตโนมัติ เช่น ID ตัวเลขอัตโนมัติ ผู้สร้าง เวลาที่สร้าง เป็นต้น ไม่จำเป็นต้องกำหนดค่า!`,
"label.page.first":`หน้าที่ 1`,
"label.icon.168":`ทิวทัศน์`,
"label.choices":`เลือก`,
"label.is.delete.document":`คุณต้องการลบเอกสารนี้หรือไม่?`,
"homepage.layout.custom":`เค้าโครงที่กำหนดเอง`,
"label.emailobject.template.insert.field":`แทรกฟิลด์`,
"label.ccpeak.folder.all":`คลาสโฟลเดอร์ทั้งหมด`,
"front-console-conversation-btn3":``,
"label.ems.port":`หมายเลขพอร์ต`,
"label.app.introduce":`แอปพลิเคชัน "คือชุดเมนูที่จัดเตรียมฟังก์ชันเป็นหน่วย ผู้ใช้สามารถเลือกแอปพลิเคชันจากเมนูแบบเลื่อนลงที่มุมขวาบนของแต่ละหน้า และเมนูจะสลับทันทีระหว่างแอปพลิเคชันต่างๆ"`,
"label.file.library.managemembers.admin":`ผู้จัดการไลบรารีเอกสาร`,
"vue_label_salesadvance_win":`ปิดการขายสำเร็จ`,
"label.email.click.complete.info":`คลิกปุ่ม "สำเร็จ" เพื่อกลับไปหน้าก่อนหน้า`,
"label.umeng.activity.event.willbegin":`อิเวนต์#eventของคุณกำลังจะเริ่มหลัง#time`,
"label.mobile.phone.week.summary":`สรุปของสัปดาห์นี้`,
"label.quickbooks.fieldlabel.terms":`ข้อกำหนด`,
"lable.currencyManage.advcurrencyEnabled.dis":`คุณสามารถแม็ปอัตราแลกเปลี่ยนสกุลเงินกับอัตราแลกเปลี่ยนที่หมดอายุในช่วงวันที่ที่ระบุ อัตราแลกเปลี่ยนที่หมดอายุจะใช้สําหรับรายงานที่เกี่ยวข้องกับโอกาสทางธุรกิจ ผลิตภัณฑ์ที่มีโอกาสทางธุรกิจ และออบเจ็กต์ทั้งสอง`,
"label.weixin.data.save.failed":`การบันทึกข้อมูลล้มเหลว`,
"label.service.gantt.filter.logic":`ตรรกะตัวกรอง：`,
"vue_label_pool_adopt":`รับ`,
"label.emailobject.markasunread":`ยังไม่ได้อ่าน`,
"label_please_select_a_member":`กรุณาเลือกสมาชิก`,
"label.salescloud.unit.ci":`หน่วย (อัน)`,
"vue_label_pool_obsolete":`ทิ้งแล้ว`,
"label.cancelall":`ยกเลิกการเลือกทั้งหมด`,
"label.exchange.sync.state.setting.m2":`เปิดใช้งานผู้ใช้ในการตั้งค่า CloudCC Exchange:`,
"vue_label_pool_claimtime":`เวลาในการรับประกัน`,
"label.forecast.forehistory.history":`ประวัติการพยากรณ์ของ`,
"label.knowledge.article.record":`บทความความรู้ไม่สอดคล้องกับข้อกําหนด`,
"label.setting.intergrationlist.button.uninstall":`ถอนการติดตั้งการเชื่อมต่อ`,
"label_tabpage_gotit":`ทราบแล้ว`,
"label.data.exp.csvform":`ใช้ได้กับการส่งออกข้อมูลเท่านั้น`,
"UG.Forcast.06":`โปรดเลือกผู้ใช้ที่มีสิทธิ์ในการพยากรณ์`,
"vue_label_report_savereport":`บันทึกรายงาน`,
"setup.object.field.dependency.label.mustone":`กรุณาตั้งค่าฟิลด์พึ่งพาอย่างน้อยหนึ่งค่า`,
"label.batchadd.newbatchpage.des1":`จำเป็นต้องระบุฟิลด์ name ของบันทึก หากไม่ระบุ ข้อมูลนี้จะไม่ถูกบันทึกตามค่าเริ่มต้น`,
"lable.custom.CurrentandPreviousCYt":`ปีที่กําหนดเองนี้และสองปีแรก`,
"label.versiontype.Professional":`รุ่นโปรเฟชชันนอล`,
"label.customfields.configprofilefieldsafety":`ปรับแต่งความปลอดภัยของฟิลด์โปรไฟล์`,
"label.ccpeak.wgd.time":`คลาสตัวจับเวลาที่ไม่ได้จัดเก็บถาวร`,
"component.telerecord.label.subject":`หัวข้อ`,
"label_year":`ปี`,
"pagecreator_layout_label_modifylayout":`ตัวแก้ไขเค้าโครง`,
"label.compact.layout.frame.splitline":`----เส้นแบ่งหน้าจอซ้ายและขวา----`,
"lable.PowerProcess.enter.the.process":`{describeName}เข้าสู่กระบวนการ`,
"label.emailobject.cc":`สำเนาถึง:`,
"front-electronic-export-choseCount":``,
"label.setup.mobile.bottombutton.recovery.default.success":`การคืนค่าเริ่มต้นสำเร็จ`,
"label.datamanage.import.accountfield":`จากตารางด้านล่าง เลือกฟิลด์จากไฟล์นำเข้าที่จะนำเข้าไปยังลูกค้าแต่ละราย หลังจากดำเนินการเสร็จสิ้น คลิกขั้นตอนถัดไป:`,
"vue_label_opportunity_related_list":`เพิ่มไปยังรายการที่เกี่ยวข้อง`,
"label.group.recent":`กลุ่มที่ดูล่าสุด`,
"vue_label_pool_finalclaimtime":`การเรียกร้องครั้งสุดท้าย`,
"vue_label_homepage_30daysnocontact":`โอกาสทางธุรกิจที่ไม่ได้ติดต่อเป็นเวลา 30 วัน`,
"label.tianyancha.field.error":`ไม่พบฟิลด์เทียนเหยี่ยนฉา กรุณาติดต่อผู้ดูแลระบบเพื่อเริ่มต้น`,
"label.product.go":`ไปที่รายงาน`,
"label.customsetting.manage.introduce":`หากการตั้งค่าแบบกำหนดเองเป็นรายการ คลิกสร้างใหม่เพื่อเพิ่มข้อมูลชุดใหม่ ตัวอย่างเช่น หากแอปพลิเคชันมีการตั้งค่ารหัสประเทศ แต่ละกลุ่มอาจมีชื่อและรหัสโทรศัพท์ระหว่างประเทศ`,
"label.task.dateadd":`บวก`,
"label.email.recipients.select":`กรุณาเลือกผู้รับ`,
"chatter.emailListMyChat":`เมื่อกดชอบหรือตอบกลับเวยเทียของฉัน`,
"label.batchadd.newbatchpage.save.name":`หากชื่อว่างเปล่า ระบบจะไม่เพิ่มบันทึกนี้ตามค่าเริ่มต้น โปรดตรวจสอบให้แน่ใจว่าชื่อของคุณไม่ได้เว้นว่างก่อนที่จะบันทึก`,
"UG_Lead_011":`สร้างลีด`,
"vue_label_salesfunnel_notice2":`จำนวนโอกาสระหว่างดำเนินการทั้งหมด`,
"APPIntegration_Social_linkedinerror":`ต้องเป็น URL ของ linkedin.com ที่ถูกต้องตามกฎหมาย`,
"label.industrialandcommercialverification.enablestatus2":`สืบค้นชื่อลูกค้าแบบเรียลไทม์`,
"label.stdashbord.xsld.business.ajssx":`กรองบทบาท`,
"lable.info.queue.showalluser":`ดูลูกค้าทั้งหมด`,
"label.generatepage.c1":`ต้องขึ้นต้นด้วยตัวอักษร มีได้เฉพาะตัวอักษรตัวพิมพ์ใหญ่ตัวพิมพ์เล็ก ตัวเลข และขีดล่าง`,
"label.thenset":`จากนั้นกด`,
"label.salescloud.salescloud.defaultteam":`ค่าเริ่มต้นทีมโอกาสทางธุรกิจของผู้ใช้`,
"label_partner_workspace_tab_selectedoption":`แท็บที่เลือก`,
"label.tippage.li":`การลบแหล่งข้อมูลรายงานที่กำหนดเองจะทำให้:`,
"lable.quote.syncingfrom.syncingto":`ผลิตภัณฑ์ที่มีโอกาสทางธุรกิจได้ซิงค์กับรายละเอียดใบเสนอราคาแล้ว`,
"label.emailobject.delete":`ลบ`,
"label.data.selectimportobject":`เลือกออบเจ็กต์ที่ต้องการนําเข้า`,
"label.knowledge.language.dutch":`ภาษาดัตช์`,
"message.campaign.page.overtime":`หน้านี้หมดอายุแล้ว`,
"label.ccchat.message.search.desc4":`ตรวจสอบการสะกดของคำค้นหา`,
"label.login.forgetPsd":`ลืมรหัสผ่าน`,
"vue_label_title_order":`สั่งซื้อ`,
"template.report.contract.follow.status":`สถานะการติดตามสัญญา`,
"label.forecast.edit.kjnd":`ปีงบประมาณ`,
"front-electronic-export-listTitle":``,
"label.dataimport.error.khmc.notnull":`เกิดข้อผิดพลาด: ชื่อลูกค้าไม่สามารถว่างเปล่า`,
"label.testobject":`ออบเจ็กต์ทดสอบ`,
"label_chatter_nextStep":`ขั้นตอนถัดไป`,
"label.file.public.link.share":`แบ่งปันลิงก์สาธารณะ`,
"label.weixin.organization.name":`ชื่อองค์กร`,
"label.quote.email":`อีเมล`,
"label.reg_field":`ฟิลด์ทั่วไป`,
"font-evaluate-module-v1-response":``,
"label.chatter.sendmail":`ส่งอีเมล`,
"label.weixin.start.incorrect":`รูปแบบวันเริ่มต้นไม่ถูกต้อง`,
"component_chatter_link_label_url":`ลิงก์ URL`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`ใช่ ฉันต้องการเปิดใช้งานการจัดการสกุลเงินขั้นสูง`,
"label.east.africa.time":`เวลาแอฟริกาตะวันออก`,
"label.product.proof.Three":`โปรดเลือกตัวเลือกผลิตภัณฑ์อย่างน้อย {1} รายการที่{0} และเลือกได้สูงสุด {2} รายการ`,
"label_emailtocloudcc_filed_password":`รหัสผ่านอีเมล`,
"component.task.label.person":`*ผู้ได้รับมอบหมาย`,
"pagecreator_systemstyle_label_buttonareacolor":`สีพื้นที่ปฏิบัติการ`,
"label.clearrule":`ล้างกฎเกณฑ์`,
"lable.customer.access":`สิทธิ์การเข้าถึงลูกค้า`,
"label.finish.wait":`ได้ดำเนินการคำร้องของคุณแล้ว รอระบบดำเนินการสำเร็จ โปรดตรวจสอบอีเมลของคุณ`,
"label.weixin.appr.auditor":`ผู้อนุมัติ`,
"label.tabpage.systemz":`ระบบ`,
"label.file.nocan.process.desc":`ไม่สามารถดำเนินการตามคำขอ เราไม่สามารถจัดส่งเนื้อหา`,
"label.relationobject.name":`ชื่อออบเจ็กต์ที่เกี่ยวข้อง`,
"setup.layout.group.relatedlist":`รายการที่เกี่ยวข้อง`,
"label.generatepage.title":`หน้าเพจ Web To CloudCC`,
"label.page.step3.input.url.information":`ขั้นตอนที่3: ป้อนรายละเอียด URL`,
"label.change.to":`เปลี่ยนสถานะสมาชิกแคมเปญเป็น`,
"label.validate.function.funcFormat.TIMEVALUE":`TIMEVALUE(date)`,
"label.partnerCloud.seriesSettings":`การตั้งค่าสายผลิตภัณฑ์`,
"component.timeline.label.1monthahead":`1 เดือนก่อน`,
"label.batchadd.senumberpage.selnum":`เลือกจำนวนบันทึกที่จะเพิ่ม`,
"label.downloadapp":`ดาวน์โหลด App`,
"label.dashboardSetup.showmainpage":`แสดงหน้าแรก`,
"label.h5.nophoneprompt":`เพื่อนร่วมงานไม่ได้ระบุหมายเลขติดต่อ`,
"label.service.deleteCustomView.wanttoremove.theFilter":`ยืนยันหรือไม่ว่าจะลบตัวกรอง "{name}"?`,
"label.appupload.state1":`อัปโหลดแล้ว`,
"component_timeline_button_filter":`ตัวกรอง`,
"label.passwordPolicy.setup.subtitle":`ตั้งข้อจำกัดรหัสผ่านและนโยบายการล็อกการเข้าสู่ระบบสำหรับผู้ใช้ทั้งหมด`,
"vue_label_normal_quote_sf":`ใบเสนอราคา`,
"label.productsales.today.noevttskaddall":`วันนี้ไม่มีอิเวนต์ที่ยังไม่ได้ดำเนินการหรือภารกิจที่ครบกำหนด คุณสามารถคลิก" "บนขวามือเพื่อเพิ่มภารกิจหรืออิเวนต์!`,
"label.projectManagement.no.end.date":`ไม่มีวันที่สิ้นสุด`,
"label.sendmail.batch.chosetemplate":`ส่งอีเมลแบบกลุ่ม: เลือกแม่แบบ`,
"serviceterritorymember.serviceresource.isactive.notactive":`ไม่ได้เปิดใช้งานทรัพยากรบริการนี้ คุณสามารถกำหนดภูมิภาคให้บริการให้กับทรัพยากรบริการที่เปิดใช้งาน`,
"label.notification.event.overlapEvent.continue":`สร้างต่อไป`,
"label.appupload.component.type.obj":`ออบเจ็กต์ที่กำหนดเอง`,
"label.partnerCloud.financeSetting.basicConfiguration":`พาธการรับ: แพลตฟอร์มสาธารณะ - การพัฒนา - การกําหนดค่าพื้นฐาน`,
"lable.outlook.detail.info":`รายละเอียดการตั้งค่า Exchange Sync`,
"vue_label_commonobjects_detail_activity_commingevents":`อิเวนต์ที่จะมาถึง`,
"coderules.nullvalue2":`การสร้างล้มเหลว โปรดป้อนค่า [{0} , {1}] ที่ใช้ในกฎการสร้าง`,
"label.version.sum.workflowrule":`กฎเวิร์กโฟลว์`,
"label.sso.saml.idp.config.enable":`เปิดใช้งานผู้ให้บริการข้อมูลประจำตัว`,
"label.temp.exp.conf":`ยืนยันว่าต้องการส่งออกแม่แบบหรือไม่?`,
"label.department":`หน่วยงาน`,
"label.trigger.operation.email.template":`รับข้อมูลแม่แบบข้อความ`,
"label.page.content.frame.height":`ความสูงของกรอบเนื้อหา (พิกเซล)`,
"label.ServiceCloud.jinengyaoqiu":`ความต้องการด้านทักษะ`,
"PageLayout.Search.MultiSearch.001":`คุณเลือกได้มากที่สุด 3 ฟิลด์เท่านั้น`,
"label.error500":`อ๊ะ! เกิดข้อผิดพลาดแล้ว ... <br />  รีบไปหาผู้ดูแลระบบเถอะ...`,
"label.appexchange.download.stop":`พบข้อขัดแย้ง หยุดการติดตั้ง`,
"label.service.dispatchingUnits.left.right.totalAll":`ข้อมูลปัจจุบัน {left}-{right} รายการ ข้อมูลทั้งหมด {totalCount} รายการ`,
"label.tabpage.haschangedz":`ลีดรายนี้เปลี่ยนแล้ว`,
"label.industrialandcommercialverification.button.cancel":`ยกเลิก`,
"label.edit.role":`แก้ไขบทบาท`,
"label.mr.descreption.condition2":`กฎ-ยึดตามอักขระกี่ตัวแรก: กรุณาใส่ตัวเลข เพื่อสืบค้นข้อมูลซ้ำของอักขระกี่ตัวแรกตามตัวเลขที่ระบุ`,
"label.testgrammer":`ตรวจสอบไวยากรณ์`,
"label.age":`อายุ`,
"lable.real.time.chat":`การแชทสดสนับสนุนโดย Easemob คุณสามารถกําหนดค่าการตั้งค่าขั้นสูงได้โดยตรงใน Easemob`,
"vue_label_opportunity_selected":`เลือกแล้ว {sum} ราย`,
"label.weixin.optionone":`ตัวเลือกที่หนึ่ง`,
"label.file.delete.public.link.desc":`เมื่อลบลิงก์สาธารณะจะไม่มีใครสามารถเข้าถึงไฟล์ที่มี URL นี้ได้ หากคุณสร้างลิงก์สาธารณะใหม่ ลิงก์จะกลายเป็น URL อื่น`,
"label_tabpage_cancel":`ยกเลิก`,
"template.report.opportunity.analysis":`การวิเคราะห์สเตจของโอกาสทางธุรกิจ`,
"label.escalation.setup.newrule.inputrule":`กรุณาใส่ชื่อเกณฑ์`,
"label.ccpeak.getapi.name":`เมื่อรับค่าบันทึกให้ get ชื่อ API ของฟิลด์โดยตรง:`,
"second":`ลำดับที่สอง`,
"label_tabpage_uploadsz":`อัปโหลด`,
"label.description":`หมายเหตุ`,
"label.ccchat.person.invite.notsamepwd":`รหัสผ่านไม่ตรงกัน`,
"label.mobile.app.isEnableAblumWatermark":`เพิ่มลายน้ําให้กับรูปภาพที่เลือกจากอัลบั้มโทรศัพท์เมื่อลงชื่อเข้าใช้`,
"vue_label_allsearch_searchable_items":`รายการที่ค้นหาได้`,
"lable.outlook.detail.react":`กิจกรรมล่าสุด`,
"label.sales.team":`ทีมโอกาสทางธุรกิจ`,
"label.guif.standard.time":`เวลามาตรฐานอ่าวเปอร์เซีย`,
"label.emailobject.emaildetail.button.forward":`ส่งต่อ`,
"label.refused":`ปฎิเสธแล้ว`,
"homepage.components.one":`ขั้นตอนที่ 1: กรอกชื่อส่วนเสริมที่กําหนดเอง`,
"day":`วัน`,
"label.dataimport.error.number":`เกิดข้อผิดพลาด: ตัวเลข`,
"label.customer.tab.step2.same.option2":`ปิดค่าเริ่มต้น`,
"component_button_ok":`ยืนยัน`,
"label.allrecordmeetprocess":`บันทึกทั้งหมดจะเข้าสู่ขั้นตอนนี้`,
"label.version.onefile.size":`ขนาดอัปโหลดของหนึ่งไฟล์`,
"label.partnerCloud.orderingPlatform.allProducts":`ผลิตภัณฑ์ทั้งหมด`,
"pagecreator.page.message.publish.success":`การเผยแพร่หน้าเพจสำเร็จ`,
"lable.currencyAdv.exchagecurrency.rate.pro":`ขอบเขตก่อนหน้า`,
"label.attendance.persons":`พนักงานที่เหมาะสม`,
"label.send.an.email":`ส่งอีเมล`,
"registration.page.browser.title":`การลงทะเบียนช่องทางการตลาดแคมเปญ`,
"label.importfilestep3":`ขั้นตอนที่ 2: เลือกและอัปโหลดไฟล์ของคุณ`,
"lable.currencyAdv.exchagecurrency.rate.next":`ขอบเขตถัดไป`,
"label.ems.no.sync.msg":`คุณยังไม่ได้กำหนดค่าข้อมูลการซิงค์อีเมล`,
"label.total_views":`ภาพรวมของการส่งฟอร์ม`,
"label.knowledge.article.notnull":`เลือกอย่างน้อยหนึ่งบทความ`,
"message.error.view.lastview.delete":`ไม่สามารถลบมุมมองรายการสาธารณะสุดท้ายได้</br>คุณไม่สามารถลบมุมมองรายการสุดท้ายที่ผู้ใช้ทุกคนมองเห็นได้<br><br>`,
"label.integrations.second.half":``,
"vue_label_systemSettings_mobelparams":`การตั้งค่าพารามิเตอร์อุปกรณ์มือถือ`,
"message.choose.maximum":`เลือกแบ่งข้อมูลได้มากที่สุด 150 รายการ ตอนนี้เลือกแล้ว`,
"vue_label_homepage_won&unprocessed":`ปิดการขายสำเร็จ ยังไม่ได้ประมวลผล`,
"UG.contact.01":`จะใช้ประโยชน์จากผู้ติดต่อของคุณอย่างไร?`,
"label.data.import.setup.remark":`ผู้ดูแลระบบสามารถตั้งค่ากฎที่จะดำเนินการเมื่อนำเข้าข้อมูล รวมถึงว่าจะดำเนินการตามเกณฑ์การตรวจสอบ ทริกเกอร์ และตัวกรองซ้ำหรือไม่`,
"pagecreator_layout_message_delete_success":`การลบเค้าโครงสำเร็จ`,
"lable.account.name":`ชื่อไตรมาสบัญชี`,
"label.userinfo.must.updatepwd":`ด้วยเหตุผลด้านความปลอดภัย คุณต้องเปลี่ยนรหัสผ่านเดี๋ยวนี้`,
"label.mobile.phone.subordinate.setup":`ไม่สามารถตั้งค่าว่าจะรวมผู้ใต้บังคับบัญชาหรือไม่ โปรดเลือกเจ้าของและตั้งค่าอนุญาตพยากรณ์ให้เขา`,
"label.monitorsys.delete.date":`วันที่`,
"label_emailsync_form_emailaddress":`ที่อยู่อีเมล`,
"label.projectManagement.cancelled":`ยกเลิก`,
"label.partnerCloud.partnerAccount.rechargeAmount":`ยอดเติมเงินต้องอยู่ระหว่าง 0.1 และ 100000000`,
"label.select.relatedlist.approval.layout":`เลือกรายการที่เกี่ยวข้องที่ต้องการจะแสดงบนเค้าโครงหน้าหน้าอนุมัติ`,
"label.userphoto.thumbnail":`ภาพขนาดย่อ`,
"label.assignment.setup.list.rulename":`ชื่อเกณฑ์`,
"label.emailtemplate.usemergefields":`ใช้ฟิลด์ผสานในแม่แบบอีเมล`,
"label.tabpage.enabletomobile":`เปิดการใช้งานไปยังอุปกรณ์มือถือหรือไม่`,
"setup_layout_label_desc":`จากมากไปน้อย`,
"vue_label_pool_abandonreasondiscription":`คําอธิบายเหตุผลในการทิ้ง`,
"label.ems.outputmails":`เซิร์ฟเวอร์ส่งออกอีเมล (SMTP)`,
"font-evaluate-module-v1-evall":``,
"front-epwechat-module-v1-unbound-tips":`ข้อมูลต่อไปนี้จะถูกลบออกหลังจากยกเลิกการผูก`,
"label.weixin.number.data":`รายการข้อมูล`,
"front-objectTemplate-V1-UseObject":`ออบเจ็กต์ที่เหมาะสม`,
"label.call.center.configuration":`การตั้งค่า Call Center`,
"vue_label_systemSettings_website":`พอร์ทัลเว็บไซต์การบริการลูกค้า`,
"lable.currencyAdv.foreverdate":`วันที่ถาวร`,
"label.globalselect.view":`ดูชุดค่ารายการตัวเลือก`,
"component_newrecords_label_title":`บันทึกล่าสุด`,
"component_assistant_label_title":`ผู้ช่วย`,
"label.equals.deletebut.bulk.delete":`ประกอบด้วยปุ่มลบแบบกลุ่ม (ถังขยะรีไซเคิล)`,
"label.field.duplicate.error.msg4":`ข้อผิดพลาด: ข้อมูลไม่ถูกต้อง`,
"label.input.right.date":`โปรดป้อนรูปแบบวันที่ที่ถูกต้อง`,
"file.error.notsel":`ข้อผิดพลาด: โปรดเลือกไฟล์ที่ต้องการอัปโหลด`,
"label.customcomponent.page.add.title":`ส่วนเสริมที่กำหนดเองใหม่`,
"message.chooseatleastthreefield":`เลือกฟิลด์อย่างน้อยสามฟิลด์`,
"label.dataimport.system.unnecessary":`, ระบบไม่สามารถยืนยันส่วนเกินได้`,
"message.login.wrong":`ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง !`,
"label.appupload.install.recheck":`ตรวจสอบอีกครั้ง`,
"label.ems.option":`ตัวเลือก`,
"label.wei.subject.img":`ไอคอนหัวข้อ`,
"chatter.emailReceiveOrNotAccept":`เลือกรับการแจ้งเตือน CCChat หากต้องการยกเลิกให้เลือกไม่รับ`,
"label.icon.46":`เตาถ่าน`,
"label.newpw":`รหัสผ่านใหม่`,
"font-evaluate-module-v1-praise":``,
"label.help.user":`คู่มือผู้ใช้`,
"label.callcenter.no.searchs":`ไม่พบข้อมูลที่เกี่ยวข้อง`,
"UG_homepage_007":`ตั้งแต่การส่งอีเมลติดตามผลไปจนถึงกิจกรรมการขายแบบอัตโนมัติ ตั้งแต่การสร้างเวิร์กโฟลว์โดยใช้เทคโนโลยีพิมพ์เขียวของเราไปจนถึงทริกเกอร์มาโครที่กำหนดเอง ภารกิจประจำวันแบบอัตโนมัติ และการมุ่งเน้นการสร้างความสัมพันธ์มากขึ้น`,
"label.saveandnew":`บันทึกและสร้างใหม่`,
"component_salesperformance_label_70finish":`เสร็จสิ้น - ยังไม่ได้จัดการ (> 70%)`,
"lable.account.dp":`หน้านี้ช่วยให้คุณกำหนดปีงบประมาณเองได้`,
"label.notification.serviceappointment.injeopardy":`}อยู่ในอันตราย โปรดจัดการโดยเร็วที่สุด`,
"label.workflow.edit.esimaterule":`ข้อผิดพลาด: เมื่อกฎมีทริกเกอร์เวลาที่เกี่ยวข้องด้วยคุณจะไม่สามารถเปลี่ยนเงื่อนไขการประเมินเป็น "ทุกครั้งที่สร้างหรือแก้ไขบันทึก"`,
"label.partnerCloud.basicSetting.feature":`การตั้งค่าฟังก์ชัน`,
"label.sms.companyname.gm.infor":`ข้อมูลอินเทอร์เฟซข้อความสั้นของเครือข่ายช่วงหมิง`,
"vue_label_homepage_components":`กรุณาเลือกส่วนเสริม`,
"label_chatter_allactivity":`กิจกรรมทั้งหมด`,
"label.quickcreate.title":`สร้างเค้าโครงใหม่อย่างรวดเร็ว`,
"label.tabpage.exclusivez":`ไม่รวม`,
"front-service-cloud-transfer-desc":``,
"label.data.downpage.i.list.desc1":`เนื่องด้วยในระหว่างการนําเข้ารูปแบบข้อมูลไม่ถูกต้อง หรือการตรวจสอบทริกเกอร์หรือเกณฑ์การทวนสอบล้มเหลว ข้อมูลที่นำเข้าล้มเหลวจะถูกสร้างเป็นไฟล์ csv และแสดงบนหน้าปัจจุบัน แต่ข้อมูลที่นําเข้าสำเร็จแล้วจะไม่แสดงบนเพจปัจจุบัน`,
"template.report.individual.case.status":`สถานะเคส`,
"label.report.export.file.format":`รูปแบบ：Excel รูปแบบ .csv`,
"vue_label_filternotice1":`นั่นคือสอดคล้องกับทุกเงื่อนไขพร้อมกันเช่น: 1. โอกาสทางธุรกิจที่มีมูลค่ามากกว่า 1 ล้าน 2. โอกาสทางธุรกิจที่คาดว่าจะทำสัญญาในช่วงเดือนนี้ ผลกากรองจะแสดงโอกาสทางธุรกิจที่มีมูลค่ามากกว่า 1 ล้านในเดือนนี้; เมื่อ<span?style="color:?red">เปิดใช้งานตัวกรองขั้นสูง</span>，จำเป็นต้องใส่เงื่อนไขตัวกรองด้วยตนเองลงในกล่องตัวกรองขั้นสูง`,
"label.lead.score.confirm1":`ขั้นตอนการให้คะแนนอาจใช้เวลานาน ทันทีที่การให้คะแนนเสร็จสิ้น คุณจะได้รับอีเมลยืนยันหนึ่งฉบับ`,
"label.scores":`คะแนน`,
"label.dashboard.message.mainnoset":`ไม่ได้กำหนดตั้งค่าแดชบอร์ดหน้าแรก`,
"label.customfields.optionlist.fieldvaluelist":`ป้อนคอลัมน์สำหรับฟิลด์รายการตัวเลือกด้านล่าง โดยแต่ละค่าควรอยู่เป็นแถวเดียว`,
"label.autosearch.title":`ค้นหาหัวข้ออัตโนมัติ`,
"label.knowledge.setting.hint.seventeen":`สร้างบทความ`,
"label_tabpage_closez":`ปิด`,
"label.partnerCloud.orderingPlatform.shoppingCart":`ตะกร้าสินค้า`,
"label.recalculate":`คำนวณใหม่`,
"label.umeng.approval.approvalmes4obj":`ในออบเจ็กต์#obj มีการอนุมัติสำเร็จ #numsucc รายการ และอนุมัติล้มเหลว #numfailed รายการ`,
"label.appointment.wizard.subtitle2-2":`ถึง`,
"label.validate.function.funcExplain.AND":`ตรวจสอบว่าพารามิเตอร์ทั้งหมดเป็นจริงหรือไม่ หากพารามิเตอร์ทั้งหมดเป็นจริงจะคืนค่า TRUE`,
"label.recordtype.batchaddattachments.remark":`ขั้นตอนที่ 1. เลือกไฟล์ ขั้นตอนที่ 2. จะจัดเก็บไฟล์ถาวรหรือไม่ ขั้นตอนที่ 3. คลิกปุ่ม "เริ่มการอัปโหลด" เพื่ออัปโหลดไฟล์ ขั้นตอนที่ 4. คลิกปุ่ม "เสร็จสิ้น" เพื่อกลับไปยังหน้าก่อนหน้า`,
"label.reportlist.findreport":`ค้นหารายงาน`,
"label.partnerCloud.financeSetting.enterAppsecret":`กรุณาป้อน  Appsecret`,
"label.campagin.roi.query2":`สืบค้น ROI ช่องทางการขายของแคมเปญ`,
"label.sendmail.notice.immediately":`ส่งแจ้งเตือนอีเมลทันที`,
"label.file.library.managemembers1":`จัดการสมาชิก`,
"label.forecast.customforecast.foredis.yclb":`หมวดการพยากรณ์`,
"label.no.target.model.available.":`ไม่มีแบบจำลองเป้าหมาย โปรดสร้างแบบจําลองเป้าหมายก่อน หรือติดต่อผู้ดูแลระบบ`,
"label.quote.contactname":`ชื่อผู้ติดต่อ`,
"label.customer.tab.step2.same":`ใช้การมองเห็นแท็บกับโปรไฟล์ทั้งหมด`,
"UG_product_03":`สมุดราคาที่รอบรับหลายสกุลเงิน`,
"label.pc.system.prompt":`ตัวพร้อมรับคำสั่ง`,
"homepage.components.description":`รายละเอียดส่วนเสริม`,
"front-email-payment-safety-code":``,
"label.the.extra.reward.group.describes":`เพิ่มคำอธิบายกลุ่มบรรทัดใบเสนอราคา`,
"label.isEnableVisualpage.new.rightlist":`เพจที่กำหนดเองที่เปิดใช้งานแล้ว`,
"label.icon.84":`หม้อแปลงไฟฟ้า`,
"label.chat.message.to":`ผู้รับ`,
"lable.product.pricebooks.edit":`การแก้ไขสมุดราคา`,
"label.partner.workspace.member.belong":`เป็นของ`,
"pagecreator_systemstyle_message_delete_success":`การลบรูปแบบสำเร็จ`,
"label.salescloud.teamrole.message.chooseatleastone":`โปรดเลือกอย่างน้อยหนึ่งผู้ใช้`,
"label.knowledgebase.self.window":`หน้าต่างเดียวกัน`,
"label.product.cost":`ขายราคาจอง`,
"label.imgfield.remove":`ล้างรูปภาพ`,
"label.event.lastweek":`สัปดาห์ที่แล้ว`,
"template.report.today.statistics":`สถิติการขายวันนี้`,
"label.emailobject.recipients":`ผู้รับ（{0}）：`,
"vue_label_commonobjects_view_successfully":`การตั้งค่ามุมมองเริ่มต้นสำเร็จ`,
"label.uploadfail.typeerror":`การอัปโหลดล้มเหลว ประเภทรูปภาพไม่ถูกต้อง!`,
"vue_label_lead_required_fields":`กรุณากรอกข้อมูลที่จําเป็น`,
"front-console-reopen":``,
"message.layout.unique.relatedlist":`ละเมิดข้อจำกัดเฉพาะของฟิลด์ในเค้าโครงเพจ โปรดยืนยันและบันทึกอีกครั้ง!`,
"label.emailobject.emaildetail.nextactivity":`กิจกรรมถัดไป`,
"label.publicgroup.save.error":`ข้อผิดพลาด: กลุ่มใดกลุ่มหนึ่งต่อไปนี้เป็นพาเรนต์ของกลุ่มนี้แล้ว`,
"label.editdefaultshare.tip":`แก้ไขการตั้งค่าการแบ่งปันเริ่มต้นทั้งองค์กรของคุณด้านล่าง การเปลี่ยนค่าเริ่มต้นเหล่านี้จะทำให้กฎการแบ่งปันทั้งหมดถูกคำนวณใหม่ อาจต้องใช้ทรัพยากรระบบและเวลามากขึ้น ซึ่งขึ้นอยู่กับปริมาณข้อมูลในองค์กรของคุณ`,
"label.icon.53":`รถ`,
"label.exchange.sync.state.setting.m3":`ผู้ใช้ที่มีที่อยู่อีเมลที่เชื่อม Microsoft Exchange และ CloudCC:`,
"label.currency.enable":`สกุลเงิน: เปิดการใช้งานสกุลเงิน`,
"component.timeline.label.past":`กิจกรรมที่ผ่านมา`,
"workflow.action.tasks.assignortype.user":`ผู้ใช้`,
"setup_layout_label_relatedlistsetup":`ตั้งค่ารายการที่เกี่ยวข้อง`,
"label.systemadmin":`ผู้ดูแลระบบ`,
"label_tabpage_allz":`ทั้งหมด`,
"label.ems.subject":`หัวข้อ`,
"message.recordtype.selectlayout.tip":`เลือกเค้าโครงเพจสำหรับบันทึกชนิดบันทึกนี้ที่ผู้ใช้ที่มีโปรไฟล์นี้จะเห็น หลังจากบันทึกให้เลือกค่ารายการตัวเลือกที่มีสำหรับชนิดบันทึกนี้`,
"label.current.version":`โปรแกรมรุ่นปัจจุบัน`,
"label.sourceoffile":`ไฟล์ภาษาที่ไม่ได้แปล: ไฟล์ภาษาที่ไม่ได้แปล`,
"label.file.versionerror":`กรุณาใช้แท็บไฟล์ในอินเทอร์เฟซรุ่นใหม่`,
"label.validate.function.funcExplain.MINUTE":`ส่งกลับนาทีในฟิลด์วันที่/เวลา`,
"abel.setup.mobile.bottombutton.profile.setting":`ปรับแต่งเมนูด้านล่างของโปรไฟล์`,
"label.recycle.dis.tip3":`เลือกถังขยะรีไซเคิลของฉันจากรายการแบบดึงลงเพื่อดูข้อมูลที่ถูกลบของคุณ ผู้ใช้ที่เป็นผู้ดูแลระบบสามารถเลือกดูถังขยะรีไซเคิลทั้งหมดได้`,
"message.selectnothing":`ไม่ได้เลือกเนื้อหา`,
"label.develop":`พัฒนา`,
"label.tab.lightningpage":`หน้าเพจรุ่น Lightning`,
"label.chat.micropost.share.info":`แบ่งปัน`,
"label.block.pricing.editor":`ตัวแก้ไขการตั้งราคาแบบแยกส่วน`,
"label.ccchat.file.unavailable":`ไฟล์นี้ไม่พร้อมใช้งาน`,
"label_component_helper_businesschange_0UntreatActivity":`โอกาสทางธุรกิจที่ไม่มีการจัดกิจกรรม`,
"label.search.setup.obj":`สามารถตั้งค่าออบเจ็กต์ได้สูงสุด 100 รายการ`,
"component.setup.button.cancel":`ยกเลิก`,
"message.longtextareamaxlength":`ต้องยาวไม่เกิน 32,000`,
"vue_label_chat_removedby":`คุณถูก "ผู้ดูแลระบบ" ลบออกจากกลุ่มสนทนา`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`ต้องไม่น้อยกว่า 8 อักขระ`,
"label.informassigner":`แจ้งผู้ได้รับมอบหมาย`,
"font-evaluate-module-v1-not-received":``,
"label.trigger.triggertime":`เวลาทริกเกอร์`,
"label.attendance.cannot.make":`ติดป้ายกำกับไม่ได้`,
"label.shouldallrecords":`การคำนวณนี้ควรรวมถึงบันทึกทั้งหมด`,
"label.eidt.queue.alter1":`กรุณาเลือกสมาชิกคิว`,
"L":`รายการตัวเลือก`,
"label_emailtocloudcc_filed_email":`อีเมล`,
"label.productsales.contract.badversion":`รุ่นปัจจุบันของคุณไม่รองรับออบเจ็กต์สัญญา ไม่สามารถตรวจสอบผลสำเร็จของสัญญาได้`,
"label.tabpage.operation":`ดำเนินการ`,
"label.file.copy.public.link":`คัดลอกลิงก์สาธารณะแล้ว`,
"label.all.SMS":`การแจ้งเตือนข้อความสั้นทั้งหมด`,
"UG_opportunity_008":`ทีมโอกาสทางธุรกิจ`,
"UG.Campaign.002":`วางแผน ดำเนินการและติดตามผลของแคมเปญ`,
"label.jiandangfenpei.title":`กำหนดโปรไฟล์`,
"pagecreator.systemstyle.message.delete":`ต้องการลบรูปแบบที่เลือกหรือไม่?`,
"lable.outlook.mcto.repeat":`หากพบบันทึกซ้ำให้ส่งลิงก์อีเมลไปยัง`,
"label.user.field":`ฟิลด์ผู้ใช้`,
"vue_label_commonobjects_detail_market_hierarchy":`ลำดับชั้นตลาด`,
"label.ems.emails":`อีเมล`,
"label.tabpage.deleteviewfailed":`การลบมุมมองล้มเหลว`,
"label.data.exp.new.expobjtemp":`สร้างแม่แบบออบเจ็กต์ส่งออก`,
"label.useformulassetval":`ใช้สูตรเพื่อตั้งค่าใหม่`,
"label.service.newBuildDialog.six.fields":`เลือกได้สูงสุดหกฟิลด์`,
"error":`ข้อผิดพลาด`,
"template.chart.sdyyfx":`การวิเคราะห์สาเหตุของการปิดการขายไม่สำเร็จ`,
"label.icon.191":`เครา`,
"label.app.step3.tabused":`แท็บที่เลือก`,
"label.user.level":`ระดับผู้ใช้`,
"label.custombutton.querydata.notexist":`ไม่พบข้อมูลที่สอบถาม`,
"label.executestate.calculating":`กำลังคำนวณ...`,
"label.visualpage.folder.notdel2":`1.ในโฟลเดอร์นี้มีเอกสารอยู่ ลบไม่ได้! 2.ในโฟลเดอร์นี้มีเอกสารซ่อนอยู่ ลบไม่ได้! ไฟล์ที่ซ่อนคือไฟล์ที่สร้างขึ้นตามออบเจ็กต์ที่ถูกลบตามตรรกะ (การตั้งค่า-สร้าง-ออบเจ็กต์ที่ถูกลบภายใต้ออบเจ็กต์) เนื่องด้วยออบเจ็กต์ไม่ได้ถูกลบจริง ไฟล์จึงถูกซ่อนไว้`,
"vue_label_report_conditiondesc_three":`คุณจะได้รับแจ้งเมื่อสอดคล้องกับเงื่อนไขทั้งหมด`,
"approval.request.email.subect":`คำขออนุมัติ`,
"label.log.user.value":`กรุณาใส่ชื่อผู้ใช้แบบสอบถาม!`,
"label.isCompanyCurrency":`บริษัท`,
"label.related.2018":`รายการที่เกี่ยวข้อง`,
"label.tonga.time":`เวลาตองกา`,
"message.actionfailed":`การปฏิบัติการล้มเหลว`,
"label.’s":`ของ`,
"label.custombutton.queryobj.notnull":`ID ออบเจ็กต์ที่สอบถามไม่สามารถว่างเปล่า`,
"label.list.userinterface.setup":`ตั้งค่าส่วนต่อประสานผู้ใช้`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`รูปแบบอีเมลไม่ถูกต้อง โปรดป้อนอีกครั้ง`,
"label.chatter.content":`เนื้อหา`,
"label.projectManagement.Addnotes":`เพิ่มหมายเหตุ`,
"label.service.newBuildDialog.reservation":`แสดงการนัดหมาย`,
"label.ccchat.pm":`บ่าย`,
"vue_label_chat_cannot_invite_users":`ไม่ใช่เจ้าของกลุ่มเชิญผู้ใช้เข้าร่วมกลุ่มไม่ได้`,
"label_partner_workspace_member_belong":`เป็นของ`,
"label.task.modify":`แก้ไขภารกิจ`,
"label.tabpage.transformationsz":`เปลี่ยนแปลง`,
"label.new.password.no.indexof":`รหัสผ่านใหม่ต้องไม่มีภาษาจีนและช่องว่าง`,
"label.ji.quarter":`ไตรมาสที่ {a}`,
"label.sso.isActiveNo":`ไม่`,
"label.mobile.phone.week.report":`รายงานประจำสัปดาห์`,
"label.email.template.please.select.folder":`กรุณาเลือกโฟลเดอร์`,
"label.pc.ui.2018.tab.groups":`กลุ่มแท็บ`,
"label.h5.approval.status":`สถานะการอนุมัติ`,
"setup.mainpage.label.welcome27":`ในแพลตฟอร์มคลาวด์ CloudCC มีฟังก์ชันเกี่ยวกับข้อมูลทั้งหมด เช่น นําเข้า ส่งออก ลบข้อมูลแบบกลุ่ม โอนย้ายแบบกลุ่ม เป็นต้น`,
"vue_label_systemSettings_setHomePage":``,
"label.select.button":`ตัวเลือกปุ่ม`,
"label_emailsync_status_enable":`เปิดการเชื่อมต่อ`,
"label.trigger.triggerVersion.detail":`ฟิลด์นี้ไม่สามารถแก้ไขได้ ทริกเกอร์ปัจจุบันมีสองรุ่นคือรุ่น 1.0 และรุ่น 2.0 ทริกเกอร์ใหม่ทั้งหมดเป็นรุ่น 2.0 ที่เป็นรุ่นสูงสุด รุ่น 1.0 ถูกปิดการใช้งานในการสร้างแล้ว`,
"pagecreator_layout_message_save_fail":`การบันทึกเค้าโครงล้มเหลว`,
"label.salescloud.salesdashboard.10big":`10 อันดับแรกโอกาสทางธุรกิจใหญ่ใน 3 เดือนข้างหน้า`,
"label.file.share.size":`จำนวนการแบ่งปันและลิงก์สาธารณะที่มากที่สุดต่อไฟล์คือ`,
"label.page.simple":`อย่างง่าย`,
"pagecreator.page.message.delete":`ต้องการลบเพจที่เลือกหรือไม่?`,
"label.weixin.newspaper.coverage.detailinfo":`รายละเอียดกรมธรรม์`,
"label.list.userinterface.chattersetup":`การตั้งค่า CCChat`,
"lable.opppdt.addpdt.table.quantity":`จำนวน`,
"label.product.description":`คําอธิบายผลิตภัณฑ์`,
"button_partner_back":`ย้อนกลับ`,
"label.user.current.loginuser.sessionid":`SessionID ของผู้ใช้ที่เข้าสู่ระบบอยู่ในขณะนี้คือ:`,
"label.otherreport":`รายงานอื่นๆ`,
"pagecreator_button_mobilepage":`เว็บเพจสำหรับโทรศัพท์มือถือ`,
"label.mobile.phone.state":`ตรวจสอบสถานะ`,
"lable.currencyManage.unenableCurrencyAdv":`ปิดใช้งานการจัดการสกุลเงินขั้นสูง`,
"lable.product.addp":`เพิ่มราคา`,
"label.field.validate.notpass":`ผ่านการตรวจสอบ ไม่พบข้อผิดพลาดทางไวยากรณ์`,
"label.app.global.search.obj":`นำไปใช้กับออบเจ็กต์การค้นหาระดับโกลบอล สามารถตั้งค่าออบเจ็กต์ได้สูงสุด 10 รายการ`,
"label.group.archived":`จัดเก็บถาวร`,
"vue_label_approve_to_submit":`รอส่ง`,
"showfrom":`แสดงจาก`,
"chatter.emailNotification":`การแจ้งเตือนอีเมล`,
"label.callcenter.pleaseenter.enterprise.number":``,
"label.forecast.customforecast.forecastnumber":`พยากรณ์ตัวเลข`,
"label.vlidaterule.messagelocation":`ตำแหน่งไม่ถูกต้อง`,
"label.h5.similar.opportunity.step3.conment":`จะแสดงคอลัมน์ความสัมพันธ์ที่ระบุจำนวนฟิลด์ที่ตรงกันเสมอ`,
"label.ccchat.group.gd.setting.info":`แก้ไขการตั้งค่ากลุ่ม CCChat`,
"label.knowledgebase.delete.article.succeeded":`ลบบทความสําเร็จ`,
"message.layout.edit":`การจัดการเค้าโครงเพจเป็นฟังก์ชันที่มีมูลค่าเพิ่มแยกต่างหาก หากองค์กรของคุณยืนยันว่าได้ซื้อโมดูลฟังก์ชันนี้แล้วสามารถสอบถามรหัสผ่านได้ที่ผู้ดูแลระบบ หากมีคำถามเพิ่มเติมโปรดติดต่อ CloudCC.com เพื่อรับการสนับสนุน`,
"label.case.create":`สร้างเคสแล้ว ({0}) รายการ`,
"label.icon.170":`ช็อปปิง`,
"message.error.contact.null":`ผู้ติดต่อไม่สามารถว่างเปล่า`,
"label.appupload.install.error.hasinstalled":`โปรแกรมสำเร็จรูปนี้ได้ติดตั้งในองค์กรของคุณแล้ว ก่อนติดตั้งรุ่นใหม่คุณต้องถอนการติดตั้งรุ่นเดิมก่อน`,
"label.service.miniProgram.imageType":`รองรับรูปภาพประเภท PNG, JPG, JPEG และขนาดที่แนะนำคือ 750*349 พิกเซล วางเมาส์เหนือรูปภาพเพื่ออัปโหลดหรือลบรูปภาพอีกครั้ง`,
"label.leadscore.rule.edit":`การให้คะแนนลีด: แก้ไขเกณฑ์`,
"vue_label_commonobject_anytime":`ช่วงเวลาใดก็ได้`,
"label.clearing.conditions":`ล้างเงื่อนไข`,
"label.campagin.roi.ydkhjhze":`จำนวนที่ปิดการขายกับลีดสำเร็จ`,
"Lead_Auto_Scoring_Setting_001":`ให้คะแนนลีดโดยอัตโนมัติเมื่อบันทึกหรือแก้ไข (ไม่รวมการนำเข้าแบบกลุ่มและการสร้างอินเทอร์เฟซ)`,
"pagecreator.systemstyle.label.buttonareacolor":`สีพื้นที่ปฏิบัติการ`,
"label.batchregist.huanxinuser.finish":`การลงทะเบียนผู้ใช้แบบกลุ่มเสร็จสิ้น`,
"UG_opportunity_006":`อัจฉริยะแห่งโอกาสทางธุรกิจ`,
"message.serviceappo.violation":`การละเมิดเวลาในการจัดส่ง: ช่วงเวลานี้ขัดแย้งกับการนัดหมายบริการอื่นๆ`,
"label.recordtypeselect.selectnew":`เลือกชนิดบันทึกใหม่`,
"Lead.Tools.BatchScoring":`การให้คะแนนลีดแบบกลุ่ม`,
"label.partnerCloud.financeSetting.enterWechat":`กรุณากรอกบัญชีร้านค้าวีแชทเพย์`,
"label.philippine.time":`เวลาฟิลิปปินส์`,
"five":`ห้า`,
"label_average_value":`ค่าเฉลี่ย`,
"message.realdelete":`ยืนยันว่าต้องการลบถาวรหรือไม่?`,
"label.currency.note":`ใส่ข้อมูลสกุลเงินใหม่ โปรดทราบว่า หลังจากเปิดการใช้งานสกุลเงินจะไม่สามารถลบได้อีก`,
"label.projectManagement.delete.prompt":`ลบแจ้งเตือน`,
"label.approval.present":`(ปัจจุบัน)`,
"label.escalation.setup.newrule.name":`ชื่อเกณฑ์`,
"label.edit.list":`รายการข้อมูลที่แก้ไขได้`,
"label.partnerCloud.financeSetting.informationOne":`1. ไปที่ศูนย์ธุรกิจอาลีเพย์ (b.alipay.com) และเข้าสู่ระบบด้วยบัญชี อาลีเพย์ที่สมัคร`,
"label.customfields.numberText":`2. ตัวเลขและทศนิยมที่ใส่รวมกันความยาวต้องไม่เกิน 18 หลัก`,
"label.biaoqing.businessverify.relation.tip":``,
"label.icon.149":`หุ่นยนต์`,
"System.btn.SaveAndCommit":`บันทึกและส่ง`,
"label.calendar.many":`หลายคน`,
"label.ccchat.create.email":`สร้างอีเมลแล้ว`,
"template.report.income.marketing.activities":`รายงานรายได้ของแคมเปญ`,
"label.ccchat.person.invite.needemail":`ป้อนที่อยู่อีเมล`,
"template.report.open.amount":`ยอดเงินที่ยังไม่ปิด`,
"label.currentoperate":`การดําเนินงานปัจจุบัน`,
"label.finalapprove":`การอนุมัติขั้นสุดท้าย`,
"label.emailmerge.mergepage.step2":`2. เลือกแม่แบบที่ต้องการผสานได้สูงสุด 20 แบบ:`,
"label_tabpage_sorttypez":`ประเภทการจัดเรียง`,
"label.workbanch":`เวิร์คแบนซ์ของฉัน`,
"font-evaluate-module-v1-disable":``,
"label.ServiceCloud.distributionMap":`แผนภูมิ`,
"lable.Confirm.potential.customers":`ยืนยันรับลีด {num} ราย`,
"label.mobile.quickcreate.default.nearby":`ใกล้เคียง`,
"label.isremider.noremider":`ไม่ต้องแจ้งเตือน`,
"label.approval.select.step":`เลือกขั้นตอนการอนุมัติเพื่อส่งกลับ`,
"chatter.error.pm":`ข้อผิดพลาด: ไฟล์ภาพที่อัปโหลดมีขนาดใหญ่เกินไป!`,
"UG_activity_08":`การนัดหมาย`,
"label.marketsea.notwinopportunitydays":`จำนวนวันที่ยังไม่ปิด (ต้องมากกว่าจำนวนวันที่ยังไม่ได้สร้างโอกาสทางธุรกิจ)`,
"label.selectpage":`เลือกหน้าเพจที่มีอยู่`,
"label.dashboard.dispalyOnTheHomePage":`หน้าแรกที่แสดง`,
"front-lightning-module-v1-details-page-chart-set-report":`ตั้งค่ารายงาน`,
"vue_label_pool_mydeal":`การเจรจาของฉัน`,
"vue_label_report_lastone":`รายงานสุดท้าย`,
"label.tabpage.potentialcustomersz":`ลีด`,
"font-evaluate-module-v1-more-satisfied":``,
"label.trigger.instructions":`<font color = "red"> หมายเหตุ: รหัสทริกเกอร์สามารถรองรับอักขระได้สูงสุด 200KB หรือประมาณ 200,000 ไบต์ </font> <font size = 3 color = "red"> </font>`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`อัตราข้อผูกมัดสำเร็จ`,
"label.umeng.approval.dlsp.approvenew":`การอนุมัติแทน: #actorname กำลังขอการอนุมัติ#objAPIName #recordname`,
"label.edit.visualpagefolder":`เพจที่กำหนดเอง: แก้ไขโฟลเดอร์`,
"label.pc.flash.teach":`วีดีโอสอนการใช้งาน`,
"label.showsearch":`แสดงการค้นหา`,
"label.reportsSubscriptionPage.condition.title1":`คุณจะได้รับแจ้งเมื่อตรงตามเงื่อนไขทั้งหมด`,
"label.h5.search.result":`ผลลัพธ์`,
"vue_label_commonobjects_view_chart_pie":`แผนภูมิวงกลม`,
"label_please_enter_currency":`กรุณาใส่สกุลเงิน`,
"chatter.share.to.profile":`โปรไฟล์ของคุณ`,
"label.mykeeptouchset":`การตั้งค่าการรักษาการติดต่อของฉัน`,
"label.profile.mustcopyaprofile":`คุณต้องเลือกหนึ่งโปรไฟล์ที่มีอยู่เพื่อคัดลอก`,
"label.managereport":`จัดการรายงาน`,
"label.total.choice":`ไฟล์ เลือกแล้วทั้งหมด`,
"label_emailtocloudcc_help":`โปรดป้อนรหัสผ่านอีเมลหรือรหัสการให้สิทธิ์ที่ถูกต้อง หากเซิร์ฟเวอร์อีเมลของคุณต้องเปิดใช้งานบริการ IMAP / SMTP เพื่อเข้าสู่ระบบโดยลูกค้าของบุคคลที่สาม คุณต้องเข้าสู่ระบบที่อยู่อีเมลก่อนเพื่อเข้าสู่การตั้งค่าและยืนยันว่าบริการนั้นเปิดใช้งานอยู่ และทำการคัดลอกรหัสมากรอกในช่องรหัสผ่าน`,
"label.trigger.sel":`ทริกเกอร์ในโฟลเดอร์นี้`,
"label.dashboardLookUp":`ค้นหาแดชบอร์ด`,
"label.batchadd.newbatchpage.save.emptytext":`มีฟิลด์บังคับที่ยังไม่ได้กรอก โปรดตรวจสอบอีกครั้ง`,
"setup.mainpage.label.welcome16":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าแอปพลิเคชัน → สร้าง → เวิร์กโฟลว์ กระบวนการอนุมัติ ภารกิจ การแจ้งเตือนทางอีเมล การอัปเดตฟิลด์ และอื่นๆ`,
"vue_label_email_mark as":`ติดป้ายเป็น`,
"label.customobjdel.cannot.delete.try":`ไม่สามารถลบออบเจ็กต์ได้ เนื่องจากมีความเกี่ยวข้องกับความสัมพันธ์ต่อไปนี้กับออบเจ็กต์อื่นๆ`,
"label.customsetting.visible.public":`สาธารณะ`,
"label.log.bit":`บิต`,
"label.data.exportall.all.desc":`ส่งออกข้อมูลของออบเจ็กต์ทั้งหมดที่ผู้ใช้ปัจจุบันมีสิทธิ์ดู`,
"message.login.mfadevice.already.bound":`ผู้ใช้ผูกอุปกรณ์ MFA แล้ว`,
"label.campaign.channel.please.img":`กรุณาอัปโหลดรูปภาพ`,
"assetbom.manage.notpermission":`โปรดติดต่อผู้ดูแลระบบเพื่อเปิดใช้สิทธิ์การจัดการ BOM สินทรัพย์`,
"schedstarttime.schedendtime.time.illegal":`แผนเวลาเริ่มต้นของการนัดหมายการบริการควรน้อยกว่าหรือเท่ากับแผนเวลาสิ้นสุด`,
"label.referperson":`ทุกคน`,
"front-email-payment-area":``,
"label.c.d.least":`บันทึก C" แต่ละบันทึก ต้องมีความสัมพันธ์กับบันทึก "D" อย่างน้อยหนึ่งรายการ`,
"label.weixin.longitude.isnull":`ละติจูดและลองจิจูดว่างเปล่าหรือไม่ถูกต้อง`,
"setup.layout.button.ok":`ยืนยัน`,
"vue_label_fiter_component_date_customdate":`วันที่ที่กําหนดเอง`,
"label.enable.case.createarticle":`อนุญาตให้ผู้ใช้สร้างบทความจากเคส`,
"label.event.moveup.8hour":`ล่วงหน้า 8 ชั่วโมง`,
"label.input.most.string":`กรุณาใส่อักขระไม่เกิน {0} ตัว`,
"lable.SalesCommitmentKanBan.contractEndDate":`วันสิ้นสุดสัญญา`,
"label.visualpage.function.name":`ชื่อเมธอด:`,
"label_emailtocloudcc_redmessage1":`กรุณากรอกที่อยู่อีเมลที่ถูกต้อง`,
"message.aliasnameinput":`ข้อผิดพลาด: ชื่อเฉพาะสามารถมีได้แค่อักขระที่เป็นตัวอักษรและตัวเลขคละกัน ต้องขึ้นต้นด้วยตัวอักษร และต้องไม่ซ้ำ`,
"label.data.exp.selectedtemp":`เลือกแม่แบบที่ต้องการสำหรับการส่งออกข้อมูล`,
"label.import.page1.suitedwayoflinkman":`วิธีจับคู่ผู้ติดต่อ`,
"label.customsetting":`การตั้งค่าที่กำหนดเอง`,
"label.versiontype.Free":`รุ่นสำหรับใช้ฟรี`,
"setup.layout.label.norelatedlist":`ไม่มีรายการที่เกี่ยวข้อง`,
"label.forecast.edittotal.de.leiji":`ยอดสะสมของ`,
"label.customfields.file.max":`ไฟล์ที่อัปโหลดมีขนาดใหญ่เกินไป โปรดอัปโหลดไฟล์ที่มีขนาดไม่เกิน 5M`,
"label_partner_all_workspace":`เวิร์คสเปซ`,
"label.searchrelation":`ค้นหาความสัมพันธ์`,
"label.icon.185":`ปรึกษา`,
"label.service.gantt.effective":`มีประสิทธิภาพ`,
"label.newreportstp1":`ขั้นตอนที่ 1: เลือกรูปแบบรายงาน`,
"label.category.9":`การผลิต`,
"label.zuowei":`เป็น`,
"front-quotation-v1-select-quota":`เลือกใบเสนอราคา`,
"label.dashboard.refresh":`รีเฟรช`,
"label.weixin.saveandnew.log":`บันทึกและสร้างล็อกใหม่`,
"label.report.list":`รายการของรายงาน`,
"FL":`ไฟล์`,
"label.h5.followingcolleagues":`เพื่อนร่วมงานที่ติดตาม`,
"template.report.conversions.number":`จำนวนการข้ามสเตจของลีด (ตามเจ้าของ)`,
"label.validate.function.funcFormat.MONTH":`MONTH(date)`,
"front-kefu-moudle-v1-tenant-ID":`ID ผู้เช่า`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`เวลา`,
"label.multilang.workflow.everyotherday":`ทุก {0} วัน`,
"label.chat.message.send.message":`ส่งข้อความ`,
"label.knowledgebase.fast.operation.error":`เกิดข้อผิดพลาดในการดําเนินงานด่วน`,
"label.multilang.dupicatecheck.dumplicatedata":`ในบันทึก{0}พบข้อมูลซ้ำที่สอดคล้องกับเงื่อนไขทั้งหมด {1} กลุ่ม ใช้เวลาสืบค้น {2} มิลลิวินาที แต่ละหน้าแสดง {2} กลุ่มข้อมูล`,
"vue_label_report_addFile_detail_Information":`ส่งออกเฉพาะบรรทัดรายละเอียด 2,000 บรรทัด และใช้ข้อมูลนี้ในการคํานวณเพิ่มเติมหรืออัปโหลดไปยังระบบอื่น`,
"label.ccchat.message.search.desc3":`เคล็ดลับการค้นหา`,
"message.deletereport.prompt":`ไม่สามารถลบรายงานนี้ได้`,
"pagecreator.page.message.save.success":`การบันทึกหน้าเพจสำเร็จ`,
"vue_label_rise":`เพิ่มขึ้น`,
"label.appupload.install.error.choicehead":`หากส่วนเสริมที่มีอยู่ในระบบขัดแย้งกับส่วนเสริมที่จะติดตั้งควรทำอย่างไร?`,
"message.dispatch.violation":`การละเมิดเวลาในการจัดส่ง: ช่วงเวลาการจัดส่งไม่ได้อยู่ในชั่วโมงการทํางานของแหล่งทรัพยากร`,
"label.tool":`เครื่องมือ`,
"label.sso.saml.idp.downloadcert":`ดาวน์โหลดใบรับรอง`,
"label.chatter.detailinfo":`รายละเอียด`,
"label.area.tree":`แผนผังภูมิภาค`,
"label.partnerCloud.priceOfManual.notEnabled":`ไม่เปิดใช้งาน`,
"label.chosesubject.call":`โทรออก`,
"label.leadscore.rule.detail":`การให้คะแนนลีด: รายละเอียดของเกณฑ์`,
"front-welcome-to-try":`ยินดีต้อนรับสู่การทดลองใช้`,
"label.umeng.activity.event.willbegin1":`อิเวนต์#eventกำลังจะเริ่มหลัง#time`,
"component.event.label.noevent":`ดูเหมือนว่าคุณทำงานของวันนี้เสร็จแล้ว`,
"label.document.templatesetof.folder":`โฟลเดอร์แม่แบบตัวหนังสือสีแดง`,
"label.quickbooks.none":`ไม่มีข้อมูลที่ตรงกัน โปรดค้นหาด้วยตนเองหรือสร้างใหม่`,
"label.assignment.setup.newrule.inputrule":`กรุณาใส่ชื่อเกณฑ์การมอบหมาย`,
"label.appointmentdetail.wizard.title4":`ชื่อบริษัท`,
"label.malaysia.time":`เวลามาเลเซีย`,
"label.partnerCloud.partnerAccount.way":`วิธีการเติมเงิน`,
"label.roleoflinkman":`บทบาทผู้ติดต่อ`,
"mesage.error.role.delate.user":`ไม่สามารถลบบทบาทได้เนื่องจากขณะนี้บทบาทถูกกำหนดให้กับผู้ใช้`,
"chatter.warning":`คำเตือน: หากคุณเลือกออบเจ็กต์อื่น การเปลี่ยนแปลงที่คุณเพิ่งทำจะไม่ถูกบันทึก คุณยืนยันจะดำเนินการต่อหรือไม่?`,
"label.service.gantt.violations.sum":`จำนวนการนัดหมายการบริการที่ละเมิด`,
"label.permission.objectpermission.recordfenpei1":`ชนิดบันทึกที่กำหนด`,
"label.mobile.phone.required.plan":`ต้องมีแผน`,
"label.after_leaving":`หลังจากออกจากระบบ ข้อมูลปัจจุบันจะไม่ถูกบันทึก`,
"label.cpq.opportunity.mainquote.trasnfer.order":`โอกาสทางธุรกิจมีใบเสนอราคาหลักและถูกแปลงเป็นใบสั่งซื้อแล้ว`,
"component.setup.iframe.label.title":`เพจที่กำหนดเอง`,
"visit.dispatchplatform.nopermission":`สิทธิ์ไม่เพียงพอ: คุณมีสิทธิ์ไม่เพียงพอที่จะเข้าถึงแพลตฟอร์มการจัดส่ง โปรดติดต่อผู้ดูแลระบบ`,
"label.validate.function.funcExplain.RIGHT":`ส่งกลับอักขระจำนวนหนึ่งที่เริ่มจากด้านขวาของสตริงข้อความ`,
"component.chatter.link.button.save":`เผยแพร่`,
"label.knowledge.selection":`สามารถเลือกได้สูงสุด 8 กลุ่มข้อมูลในแต่ละความรู้`,
"chatter.email.homePage":`เมื่อโพสต์ลงหน้าแรก CCChat ของฉัน`,
"vue_label_commonobjects_view_copy_view":`คัดลอกมุมมอง`,
"label.documentmessage":`รายละเอียดเอกสาร`,
"label.emailtocloudcc.step1":`ขั้นตอนที่ 1`,
"label.user.mfa.unbind":`ยกเลิกการผูก MFA ให้กับผู้ใช้ที่เลือก`,
"label.stdashbord.xsld.business.sdzje":`จำนวนเงินทั้งหมดที่สูญเสียคำสั่งซื้อ`,
"vue.please.select.the.total.method":`กรุณาเลือกวิธีการรวบรวม`,
"label.stdashbord.xsld.business.img1":`ความน่าจะเป็นของจำนวนในสเตจ 1% - 99%`,
"label.reportsSubscriptionPage.condition.title":`นอกจากฟังก์ชันการสมัครรับข้อมูลแล้ว คุณยังสามารถกำหนดเงื่อนไขในผลลัพธ์ของรายงานได้อีกด้วย คุณจะได้รับแจ้งเมื่อตรงตามเงื่อนไข ไม่บังคับ`,
"chatter.sel.field":`เลือกเกิน 20 ฟิลด์แล้ว`,
"label.login.access.year":`ปี`,
"label.dashboard.all":`แดชบอร์ดทั้งหมด`,
"label.approver":`ผู้อนุมัติ`,
"Lead.Homepage.Tools.BatchScoring":`การให้คะแนนแบบกลุ่ม`,
"lable.opppdt.selPdt.lesscondtions":`ตัวกรองน้อย`,
"label.integrations.action.export":`ส่งออกทันที`,
"label.datamanage.lookupandsure":`(ค้นหาและยืนยัน)`,
"label.email.attach.to.mail":`แนบไปกับอีเมล`,
"message.nodataordeleted":`ไม่มีข้อมูลหรือถูกลบไป`,
"component_newrecords_label_all":`ดูทั้งหมด`,
"lable.currencyAdv.startdate.rate":`แสดงอัตราแลกเปลี่ยนทั้งหมดในช่วงเวลาที่มีวันที่เริ่มต้นดังต่อไปนี้`,
"label.callbackoperate":`เรียกคืนการดำเนินงาน`,
"label.knowledge.setting.hint.eighteen":`เริ่มสร้างบทความสําหรับคลังความรู้`,
"label.user.step4.submit.email":`ขั้นตอนที่ 4. ส่งคำขอส่งอีเมลของคุณแล้ว`,
"label.appointment.wizard.subtitle4-1":``,
"component.assistant.button.newtask":`ภารกิจใหม่`,
"label.icon.129":`การ์ด`,
"label.relatedlist":`รายการที่เกี่ยวข้อง`,
"label.report.recently":`ดูล่าสุด`,
"label.batchadd":`เพิ่มแบบกลุ่ม`,
"front-template-V1-Delete-succeeded":`ลบแม่แบบ"{currentTelmplateName}}"สําเร็จ`,
"label.appupload.upload.otherdetail":`รายละเอียดอื่นๆ`,
"label.emailobject.link":`ลิงก์`,
"label.quickbooks.createcustomer":`สร้างลูกค้าใหม่บน QuickBooks`,
"report.label.projectcount":`โครงการ เรียงลำดับตามชื่อรายงาน`,
"vue_label_normal_contact_sf":`ผู้ติดต่อ`,
"chatter.group.groupActivities":`กลุ่มทั้งหมด`,
"label_tabpage_addoptionsz":`เพิ่มตัวเลือก`,
"label.knowledgebase.submit.for.translation":`ส่งงานแปล`,
"vue_label_pool_notallowed":`ลักษณะของธุรกิจไม่ได้รับอนุญาต`,
"label.icon.80":`ทํากระดาษ`,
"label.readonlys":`อ่านอย่างเดียว`,
"label.recordsediting":`บันทึกที่แก้ไขได้`,
"label.mr.title.email":`อีเมล`,
"label.partner.all.enable":`เปิดการใช้งาน`,
"label.customsetting.manage.errmessage":`กรุณาคงฟิลด์ที่กำหนดเองก่อน หลังจากนั้นค่อยจัดการข้อมูลอีกครั้ง`,
"label.cloudccclass.list.cls":`คลาส`,
"label.weixin.click.loadall":`คลิกเพื่อโหลดทั้งหมด`,
"label.weixin.appr.initialtime":`เวลาก่อตั้ง`,
"UG_ST_002":`ยืนยัน`,
"setup_mainpage_label_welcome17":`การตั้งค่าสิทธิ์`,
"label.appupload.state0":`ยังไม่ได้อัปโหลด`,
"label.icon.115":`บ้าน`,
"setup_mainpage_label_welcome5":`ฟิลด์ที่กำหนดเอง`,
"lable.custom.year.ovdate":`วันสิ้นสุดปีที่กำหนดเอง`,
"label_tabpage_findz":`ค้นหา`,
"label.appupload.uploading":`กำลังอัปโหลดโปรแกรมสำเร็จรูป`,
"setup.mainpage.label.welcome1":`ต้องการสิทธิ์ที่เหมาะสม`,
"label.file.folder.delete2":`ลบไลบรารีเอกสาร?`,
"2018UI_Homepage_DataNoAccess_Info":`คุณไม่ได้รับอนุญาตให้เข้าถึงบันทึกนี้ คลิกเพื่อกลับไปที่ขั้นตอนก่อนหน้า`,
"label.ems.google":`กูเกิ้ล`,
"label.hawaii.aleutian.standard.time":`เวลามาตรฐานฮาวาย`,
"template.report.unfinished.tasks":`งานที่ยังไม่เสร็จ`,
"vue_label_calendar_add_calendar":`เพิ่มปฏิทิน`,
"label.button.sel.useremail":`ส่งอีเมลให้ผู้ใช้ที่ถูกเลือก`,
"user.email.template":`เรียน{username}:<br>รหัสเชิญแคมเปญ[{Campaign.name}]ของคุณมีดังนี้: <br>{Campaign.ColleagueInvitationLetter}<br> URL คือ: <br>{Campaign.ColleagueInvitationLetterLink}<br> แคมเปญนี้รอบรับการลงทะเบียนด้วยรหัสคิวอาร์ และ URL! ขอบคุณสําหรับการสนับสนุนของคุณ<br>เจ้าของแคมเปญ: {Campaign.Owner}`,
"label.forecast.settings.shouru":`พยากรณ์รายได้`,
"label.casesensitive":`ถือว่า ABC" และ "abc" เป็นค่าที่ต่างกัน (ไวต่ออักษรใหญ่เล็ก)"`,
"message.pleaseinputrightdistanceweek":`กรุณากรอกช่วงสัปดาห์ให้ถูกต้อง`,
"label.linellae-group":`ลายเส้น-จัดกลุ่ม`,
"label.showdefault_times":`แสดงเวลาเผยแพร่เริ่มต้น`,
"label.smstemplate.finishmessagedetailinfo":`ใส่รายละเอียดแม่แบบข้อความสั้นสำเร็จ`,
"label.service.miniProgram.backgroundImage":`ภาพพื้นหลัง`,
"label.recentview.news":`บันทึกล่าสุด`,
"label.reportType.chose.and.form":`เลือกแหล่งข้อมูลรายงานและรูปแบบรายงาน`,
"setup.layout.button.additem":`เพิ่มรายการที่เลือก`,
"front-epwechat-module-v1-auto-mate":`จับคู่อัตโนมัติ`,
"vue_label_helpcenter_contract&plan":`สัญญาคือข้อตกลงเป็นลายลักษณ์อักษรของคู่สัญญา หลายฝ่ายใช้สัญญาเพื่อกำหนดเงื่อนไขในการทำธุรกิจกับบริษัทอื่นๆ ใช้ CloudCC เพื่อสร้างสัญญาที่มีอยู่กับลูกค้าและโอกาสทางธุรกิจ และจัดเตรียมเอกสารให้ ติดตามสัญญาผ่านขั้นตอนอนุมัติ. <br> จัดการธุรกรรมของคุณผ่านฟังก์ชันช่วยเหลือสัญญาและแผนการเก็บเงิน`,
"label_mobile_version_nonsupport_feature":`รุ่นนี้ไม่รองรับฟังก์ชันนี้ โปรดอัปเดตเป็นรุ่นล่าสุด`,
"label.icon.44":`ไฟ`,
"label.data.downpage.i.title.num3":`3. ก่อนนำเข้าโปรดตรวจสอบให้แน่ใจว่าได้นำเข้าบันทึกที่เกี่ยวข้องทั้งหมดแล้ว เช่น หากมีความสัมพันธ์การค้นหาระหว่างออบเจ็กต์ที่คุณกําลังนําเข้าและผู้ติดต่อ โปรดนำเข้าผู้ติดต่อเหล่านี้ก่อนแล้วจึงนำเข้าข้อมูลของคุณ`,
"label.mr.object.customer":`ลูกค้า`,
"label.social.user.null":`ข้อมูลผู้ใช้โซเชียล Social ต้องไม่ว่างเปล่า`,
"front-epwechat-module-v1-unbound-item2":`- การตั้งค่าข้อมูลทั้งหมด`,
"label.partnerCloud.partnerAccount.noempty":`ยอดเติมเงินต้องไม่ว่างเปล่า`,
"label.weixin.myapproval":`การอนุมัติของฉัน`,
"label.data.setok.e_desc1":`หลังจากการส่งออกสำเร็จคุณจะได้รับอีเมลแจ้งเตือนของระบบ ข้อมูลที่ส่งออกจะถูกบันทึกชั่วคราวไว้ในเซิร์ฟเวอร์เป็นเวลา 48 ชั่วโมง โปรดรีบทำโดยเร็ว`,
"lable.batchadd.service.cfq.after":`ทริกเกอร์ (After Insert)`,
"label.umeng.activity.youhaveanevent":`คุณมี 1 อิเวนต์ใหม่`,
"label_emailsync_status_connectaccounts":`เชื่อมต่อบัญชีอีเมล`,
"label.multilang.shenpi.count":`รวมทั้งหมด {0} รายการบันทึก:`,
"pagecreator.page.message.delete.fail":`การลบหน้าเพจล้มเหลว`,
"label.version.sum.lookupmdfield":`ฟิลด์ความสัมพันหลัก-รอง`,
"vue_label_pool_clueduplication":`ร่องรอยการทำซ้ำ`,
"label.system.setup.log":`ล็อกพฤติกรรมของระบบ`,
"label.globaloperation.operationtype.send.e-mail":`ส่งอีเมล`,
"vue_label_pricebook_entry":`รายการสมุดราคาใหม่`,
"label.forecast.forehistory.submit.date":`วันเวลาที่เสนอ`,
"chatter.handle":`คุณกําลังทําอะไรอยู่?`,
"lable.SalesCommitmentKanBan.complete":`เสร็จสิ้น`,
"label.weixin.upload.pictures":`อัปโหลดรูปภาพ`,
"label.create.document":`เพิ่มเอกสารใหม่`,
"vue_label_commonobjects_detail_unlockconfirm":`ยืนยันว่าจะปลดล็อกหรือไม่?`,
"label.customer.page":`แท็บเพจที่กำหนดเอง`,
"button.partner.workspace.saveas":`บันทึกเป็น`,
"setup.layout.label.asc":`เรียงจากน้อยไปมาก`,
"label.ccpeak.folder.time":`โฟลเดอร์คลาสตัวจับเวลาที่ไม่ได้จัดเก็บถาวร`,
"label_tabpage_includez":`รวม`,
"label.custom.button":`ปุ่มแบบกำหนดเอง`,
"label.weixin.binding":`ผูก`,
"P":`เปอร์เซ็นต์`,
"chatter.stop.n":`หยุดติดตามบันทึกนี้`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`วันพุธ`,
"template.report.revenue.marketing.activities":`รายได้จากแคมเปญ`,
"lable.SalesCommitmentKanBan.theActualReceipts":`ยอดเก็บเงินจริง`,
"vue_label_popularresults":`ผลลัพธ์ยอดนิยม`,
"label.log.belongs":`เป็นส่วนหนึ่งของ`,
"label.profile.remark":`ผู้ใช้โปรไฟล์นี้มีสิทธิ์และมีเค้าโครงเพจดังต่อไปนี้ ผู้ดูแลระบบสามารถเปลี่ยนโปรไฟล์ของผู้ใช้ได้โดยการแก้ไขข้อมูลส่วนตัวของผู้ใช้`,
"label.appupload.component.type.button":`ปุ่ม`,
"label.partner.all.operate":`ดำเนินการ`,
"vue_label_notice_modify_fail":`การแก้ไขล้มเหลว`,
"label.icon.137":`โลก`,
"front-dialog-module-v1-nosupport-copy":`ไม่รองรับการคัดลอก`,
"label.integrations.mailchimp.massage3":`ยกเลิกการอนุญาต`,
"UG.opportunity.010":`เปิดการเสนอขายใหม่`,
"front-lightning-module-v1-details-page-chart-selecting-reports":`เมื่อคุณเลือกรายงาน คุณสามารถเลือกเฉพาะรายงานสาธารณะ ซึ่งเป็นรายงานในโฟลเดอร์รายงานที่ผู้ใช้ทั้งหมดสามารถเข้าถึงได้ พร้อมกับรายงานในรายงานสาธารณะที่ไม่ได้เก็บถาวร`,
"System_btn_SaveAndCommit":`บันทึกและส่ง`,
"vue_label_dashboard_statisticaltype":`กรุณาเลือกประเภทสถิติ`,
"label.mr.object.opportunity":`โอกาสทางธุรกิจ`,
"label.area.detail.remark":`ผู้ใช้ในพื้นที่แสดงตัวอย่าง`,
"label.view.sortview.index":`หมายเลขลำดับ`,
"label.mobile.quickcreate.default.events":`อิเวนต์`,
"label.product.price":`ราคาขาย`,
"label.leadmarketsea.edit.title":`การแก้ไขฐานข้อมูลลีด`,
"pagecreator.layout.button.edit":`แก้ไขเค้าโครง`,
"label.addressee":`ผู้รับ`,
"label.movablesearchlayout":`เค้าโครงการค้นหาแบบไดนามิก`,
"label.ems.confirm":`ยืนยัน`,
"vue_label_file_save_to_file":`บันทึกไปยังไฟล์`,
"component_chatter_button_more":`ดูรายละเอียดเพิ่มเติม`,
"label.ccdocument.hidden.trace":`ซ่อนการติดตาม`,
"label.partnerCloud.maximumTwo":`ขนาดไฟล์สูงสุดคือ 2M`,
"label.event.moveup.4hour":`ล่วงหน้า 4 ชั่วโมง`,
"label.batchadd.save":`เพิ่มการแบ่งปันล้มเหลว`,
"label.passwordPolicy.setup.expireDate":`รหัสผ่านของผู้ใช้มีเวลาจำกัด`,
"label.workflowrule":`กฎเวิร์กโฟลว์`,
"vue_label_notice_pleaseselecview":`กรุณาเลือกมุมมอง`,
"label.h5.chatter.colleagues":`เกี่ยวกับเพื่อนร่วมงาน`,
"lable.opppdt.addpdt.subtitle":`เพิ่มผลิตภัณฑ์ลงใน`,
"label.data.import.setup.repeat.no":`ไม่ใช่-แทรกบันทึกทั้งหมดลงในไฟล์นำเข้าของฉัน`,
"label.changeCorporate":`เปลี่ยนสกุลเงินของบริษัท`,
"label.customfields.dateandtime.tip":`อนุญาตให้ผู้ใช้ใส่วันและเวลา หรือเลือกวันที่จากปฏิทิน หลังจากที่ผู้ใช้เลือกวันที่จากปฏิทินเรียบร้อยแล้ว วันที่นั้นจะถูกป้อนลง "ฟิลด์" วันที่/เวลา`,
"label.integrations.mailchimp.massage1":`โปรดเลือกบันทึกที่ต้องการส่งออกอย่างน้อย 1 รายการ`,
"lable.PowerProcess.custom":`ตามเงื่อนไขที่กำหนดเอง`,
"label.service.editDialog.displays.service.appointmentsFordays":`แสดงวันที่แนวนอนของการนัดหมายการบริการระหว่าง {before} และ {after} วัน`,
"label.Receivables.ActualMoneyTime":`เวลาเก็บเงินจริง`,
"label.matrixreport.intro":`รายงานเมทริกซ์จะแสดงข้อมูลสรุปที่คำนวณตามเงื่อนไขแนวนอนและแนวตั้งในรูปแบบกริด`,
"message.validation.isnotnumber":`ใส่ตัวเลขที่ถูกต้อง`,
"label.partner.workspace.member.search":`ค้นหา`,
"label.customfields.deletewill":`ถ้าลบฟิลด์ที่กำหนดเองจะ`,
"label.content":`เนื้อหา`,
"component.setup.button.weburl":`URL ภายนอก`,
"setup.mainpage.label.welcome28":`คำแนะนำการใช้งาน: คลิกเมนูด้านซ้ายของหน้านี้ → การตั้งค่าการจัดการ →การจัดการข้อมูล →การนำเข้าและส่งออกข้อมูล การโอนย้ายแบบกลุ่ม การลบแบบกลุ่ม`,
"label.related.setup":`การปรับแต่งความสัมพันธ์ของภารกิจและอิเวนต์`,
"label.weixin.sign":`คุณลงทะเบียนไปแล้วไม่จำเป็นต้องลงทะเบียนอีก`,
"label.norecord":`ไม่มีบันทึก`,
"label.emailmerge.detail.emailtempldatemerge":`แม่แบบจดหมายเวียน`,
"label_emailsync_status_role":`บทบาท`,
"label.mobileapp.modelsetting2":`เลือกโมดูลที่ตรงกับความต้องการทางธุรกิจตามการใช้งานจริง<br>เมื่อเลือก เปิดใช้งาน: โมดูลจะแสดง "เพิ่มเติม" - "ฟังก์ชันมาตรฐาน"บนอุปกรณ์มือถือ<br>เมื่อเลือก ปิดใช้งาน:  โมดูลจะไม่แสดง "เพิ่มเติม" - "ฟังก์ชันมาตรฐาน" บนอุปกรณ์มือถืออีกต่อไป`,
"component.sendmail.label.title":`ส่งอีเมล`,
"component_assistant_button_newevent":`อิเวนต์ใหม่`,
"label.chatter.input":`กรุณาป้อนเนื้อหาที่เกี่ยวข้อง`,
"message.error.view.operate.rtnlink":`คลิก<a href='javascript:history.back();'>ที่นี่</a>เพื่อกลับไปยังหน้าก่อนหน้า`,
"lable.new.profile":`โปรไฟล์ใหม่`,
"label.custom.field.null":`ไม่สามารถใช้งานได้`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`วันเสาร์`,
"label.stdashbord.xsld.business.img4":`ความน่าจะเป็นของจำนวนเงินรวมในสเตจ 100%`,
"pagecreator_layout_button_splitall":`แยกทั้งหมด`,
"label.mobile.phone.total.amount":`จำนวนเงินทั้งหมด (หมื่นหยวน)`,
"label.ratifyhistory":`ประวัติการอนุมัติ`,
"label.projectManagement.Antecedents":`งานก่อนหน้า`,
"label.projectManagement.Newserviceappointment":`การนัดหมายการบริการใหม่`,
"label.delete.record.is.approval":`บันทึกที่คุณจะลบอยู่ระหว่างการอนุมัติ คุณยืนยันที่จะลบหรือไม่?`,
"front-gantt-module-no-tasks-describe":``,
"vue_label_visualize_data":`เขียนแก้ข้อมูลเทียนเหยี่ยนฉาแล้ว โปรดบันทึก`,
"UG.activity.02":`มอบหมายภารกิจ`,
"label.field.duplicate2":`ไม่อนุญาตให้มีค่าซ้ำ`,
"label.cloudccclass.list.tip":`นักพัฒนาสามารถพัฒนาคลาสบนแพลตฟอร์ม CloudCC.com คลาสเหล่านี้สามารถใช้เพื่อปรับแต่งเพจและทริกเกอร์ได้`,
"before":`ก่อน`,
"UG.ST.001":`แจ้งเตือน`,
"label_tabpage_userGuidez":`คู่มือผู้ใช้`,
"vue_label_account_looking_for":`โปรดใส่รายละเอียดที่คุณต้องการสอบถาม`,
"vue_label_calendar_notice_timecantmove":`ไม่สามารถเปลี่ยนเวลาของปฏิทินออบเจ็กต์นี้โดยการลากและวาง`,
"label.mobile.phone.enter.summary":`ใส่ผลสรุปที่นี่`,
"label.object.api.existed":`มีชื่อ api ออบเจ็กต์นี้แล้ว กรุณาเปลี่ยนชื่อ api`,
"label.weixin..xsld.order.by.time":`เรียงลำดับตามวันที่ทำสัญญาคาดการณ์`,
"label.h5.chatter.whether":`ใช่หรือไม่`,
"label.file.delete.success":`การลบไฟล์สำเร็จ`,
"label.imgfield.type.url.tip1":`ผู้ใช้สามารถใส่ลิงก์เพื่ออ้างถึงรูปภาพ โดยเพิ่ม& cimgSize = ความกว้างและความสูง หลังลิงก์รูปภาพ เพื่อตั้งค่าขนาดภาพที่แสดง`,
"label.tomanyrecords":`ในตารางมีมากกว่า 5,000 รายการ`,
"label.save.partnercloud":`บันทึกข้อผิดพลาดของระบบคลาวด์พาร์ทเนอร์`,
"vue_label_homepage_fliteritems":`กรองรายการการตั้งค่า`,
"pagecreator_page_button_new":`หน้าเพจใหม่`,
"label.sharerule.baseofcondition":`ตามเงื่อนไข`,
"label.dashboard.snapshot":`สแนปชอตแดชบอร์ด`,
"label.appointmentpage.wizard.subtitle1.1":`กรุณาเลือกวันที่และเวลาที่เจาะจง`,
"label.reportsSubscriptionPage.condition.emailsummary":`ส่งรายงานเท่านั้น`,
"chatter.group.showAll":`แสดงทั้งหมด`,
"label.tabpage.helpNavigationz":`ช่วยเหลือและนำทาง`,
"label.emailtocloudcc.button.back":`ยกเลิก`,
"approval_request_email_subect":`คำขออนุมัติ`,
"label.lookup.error":`เกิดข้อผิดพลาดขณะค้นหา`,
"label.publicgroup.save.groupisnull":`ในระหว่างการบันทึกพบว่าข้อมูลกลุ่มย่อยว่าง โปรดลองบันทึกอีกครั้ง หากยังมีปัญหาโปรดติดต่อผู้ดูแลระบบ`,
"label.pie":`แผนภูมิวงกลม`,
"chatter.feed.is":``,
"label.customfields.file.max5m":`ขนาดไฟล์สูงสุดคือ 5M`,
"com.cloudcc.login.error.message.vaildauthfail":`การตรวจสอบการเข้าสู่ระบบไม่ถูกต้อง`,
"label.profile.appsetuppermission":`สิทธิ์การจัดการการตั้งค่าแอปพลิเคชัน`,
"label.customfields.file.totalmax":`ไฟล์ที่อัปโหลดมีขนาดใหญ่เกินไป โปรดอัปโหลดไฟล์ที่มีขนาดไม่เกิน 500M`,
"label.sms.list":`รายการข้อมูลอินเทอร์เฟซข้อความสั้น`,
"message.error.referencedcolumnIdnotexist":`ฟิลด์อ้างอิงรายงานถูกลบและไม่สามารถแสดงได้ตามปกติ กรุณาติดต่อผู้ดูแลระบบเพื่อขอความช่วยเหลือ`,
"front-lightning-module-v1-details-page-chart-setting-chart":`ตั้งค่าแผนภูมิรายงาน`,
"label.recordtype.profile.enables":`ชนิดบันทึกพร้อมใช้งาน`,
"chatter.this.n":`บันทึกนี้`,
"label.only.upload.file":`อัปโหลดได้เฉพาะไฟล์ jpg/png และขนาดไม่เกิน 500kb`,
"vue_label_lead_conversion_failed":`การข้ามสเตจล้มเหลว`,
"label.file.share.file.success":`แบ่งปันไฟล์สำเร็จ!`,
"label.processsetting.delete.process":`ยืนยันว่าจะลบกระบวนการนี้หรือไม่?`,
"message.uniquenamevalidate":`ต้องขึ้นต้นด้วยตัวอักษร ใช้เฉพาะอักขระที่เป็นตัวอักษรและตัวเลขและขีดล่าง เท่านั้น`,
"label.group.archived.desc.info":`กลุ่มนี้ถูกเก็บถาวร คุณจึงไม่สามารถสร้างโพสต์ใหม่หรือแบ่งปันไฟล์กับกลุ่มนี้ได้ เปิดใช้งานกลุ่มเพื่อเปิดใช้งานฟังก์ชันทั้งหมด`,
"label.customer.maincontact":`ผู้ติดต่อหลัก`,
"label.appointment.wizard.subtitle1-9":`4 ชั่วโมง`,
"label_productline_income":`รายได้ของสายผลิตภัณฑ์`,
"label.dashboardSetup.tz.ybb":`ข้ามไปที่แดชบอร์ด`,
"label.recordowner":`เจ้าของบันทึก`,
"message.approval.othersdoing":`มีบุคคลอื่นกำลังดำเนินการกับกระบวนการนี้ โปรดรีเฟรชเพื่อรับข้อมูลล่าสุด!`,
"Opportunity_Detailed_Phase_Label_002":`ปัจจุบันคงสถานะมาแล้ว {0} วัน`,
"label.field.validating.rule.isnot.passed":`เกณฑ์การทวนสอบไม่คอมไพล์ กรุณาตรวจสอบไวยากรณ์`,
"label.textmessage.fieldskong":`บางฟิลด์แทรกมีค่าเป็นศูนย์ โปรดแก้ไขและส่งอีกครั้ง`,
"com.cloudcc.login.error.message.islocked":`ผู้ใช้ถูกล็อก`,
"label.forecast.customforecast.foredis.debfb":`เปอร์เซ็นต์ของโควตา`,
"lable.opppdt.selPbk.changepbk.worning":`หากแก้ไขสมุดราคาของโอกาสทางธุรกิจนี้ ผลิตภัณฑ์ที่เกี่ยวข้องกับโอกาสทางธุรกิจนี้จะถูกลบออก ต้องการจะทำต่อหรือไม่?`,
"label.mr.backLookReData":`ย้อนกลับไปดูรายการข้อมูลซ้ำ`,
"label.quickbooks.searchqb":`ค้นหา QuickBooks`,
"label.service.gantt.searchSkills":`ค้นหาทักษะ`,
"label.account.Current.and.NexttFQ":`ไตรมาสบัญชีนี้และสามไตรมาสถัดไป`,
"customer.notopen.chat":``,
"vue_label_commonobjects_view_sum":`รวมทั้งหมด {total} รายการข้อมูล`,
"label.partnerCloud.orderingPlatform.adjust":`ปรับปรุงผลิตภัณฑ์ที่สั่งซื้อ`,
"label.emailmerge.mergeFolder.tips":`ในหน้านี้ คุณสามารถสร้างเอกสาร Microsoft Word ที่มีข้อมูลผู้ติดต่อของคุณได้ โปรดเลือกแม่แบบจดหมายเวียน โดยเลือกได้ไม่เกิน 20 รายการ`,
"vue_label_ccchat_notice_deletecommentfail":`การลบความคิดเห็นล้มเหลว`,
"label.emailsync.status":`สถิติการใช้อีเมลของผู้ใช้งาน`,
"label.forecast.forecastroleuserpage.desc":`การพยากรณ์ของผู้ใต้บังคับบัญชาจะถูกรวมเข้าในการพยากรณ์ของผู้จัดการเพื่อกำหนดผู้จัดการการพยากรณ์ให้บทบาทนี้`,
"label.step1.total4":`ขั้นตอนที่ 1 จาก 4`,
"front-kefu-moudle-confirm-fjcase":``,
"label.icon.60":`รถเครน`,
"label.appointmentpage.wizard.subtitle3":`โปรดป้อนข้อมูลของคุณ`,
"label.loginservice.license.exceed.time":`ใบอนุญาติหมดอายุแล้ว`,
"label.customcomponent.check.tag.lastrow":`แถวสุดท้ายต้องเป็น`,
"label.product.code":`รหัสผลิตภัณฑ์`,
"label.salescloud.salesdashboard.phone":`โทรศัพท์`,
"label_please_input_price_list_price":`กรุณาระบุราคาปลีก`,
"label.multilang.page3":`หน้า`,
"label.file.lastmodifydate":``,
"label.icon.121":`คอมพิวเตอร์`,
"message.error.system.service.unknow":`บริการที่ไม่รู้จัก ติดต่อผู้ดูแลระบบ!`,
"label.thesecond":`คอลัมน์ที่สอง`,
"vue_label_report_conditiondesc_two":`เพิ่มเงื่อนไขในรายงานนี้`,
"label.exchange.serverUrl":`ที่อยู่เซิร์ฟเวอร์`,
"RL":`อ้างอิง`,
"label.emailobject.emailsend.sendindividuallyprompt":`"ส่งแยก" จะส่งแบบหนึ่งต่อหนึ่ง แต่ละคนจะได้รับอีเมลแยกต่างหากจากเขา/เธอ คุณยืนยันจะ "ส่งแยก" หรือไม่?`,
"label.appointmentconfirmpage.wizard.subtitle4":`ผู้เข้าร่วม`,
"message.save.opportunity.team.save.failed":`ทีมโอกาสทางธุรกิจล้มเหลว`,
"vue_labenl_normal_notice_share_success":`การแบ่งปันสำเร็จ`,
"label.triggerfolder":`โฟลเดอร์ทริกเกอร์`,
"label.more":`เพิ่มเติม`,
"label.file.num":`จำนวน`,
"label.dashboard.list.sortBy":`รายการ เรียงลำดับตามเวลาที่เข้าใช้`,
"c":`สกุลเงิน`,
"label.weixin.detail.edit":`แก้ไข`,
"label.escalation.setup.newentries.step2":`ขั้นตอนที่ 2: เลือกเงื่อนไขของรายการเกณฑ์นี้`,
"label.report.error.prompt":`การกําหนดค่าล้มเหลว รองรับเฉพาะกลุ่มบรรทัดในชุดรายงาน และตรวจสอบให้แน่ใจว่าเป็นรายงานสาธารณะและยังไม่ถูกลบ!`,
"label.notification.new":`การแจ้งเตือนใหม่`,
"label_tabpage_releaseTourz":`เผยแพร่ทัวร์`,
"label.icon.41":`ตำแหน่ง`,
"label.sendsms.hello.new":`สวัสดี: คุณมี   ใหม่`,
"label.custom.combination":`รวม`,
"label.project.hit.fifteen":`แจ้งเตือนการกำหนดไมล์สโตน`,
"label.campaign.channel.step6.mobile":`สร้างหน้าเพจสำหรับอุปกรณ์มือถือ`,
"label.goback.N.step":`ย้อนกลับไปขั้นตอนที่ N`,
"label_partner_all_name":`ชื่อพาร์ทเนอร์คลาวด์`,
"label.usermanage.loginusername.exist":`มีชื่อผู้ใช้นี้แล้ว!`,
"template.chart.cpxse":`ยอดขายผลิตภัณฑ์`,
"chatter.feed.deletecomments":`ยืนยันจะลบหมายเหตุนี้หรือไม่?`,
"label.list.userinterface.show.newrcords.enable":`ปิดการใช้งานบันทึกล่าสุด`,
"label.sso.saml.idp.config.enablelogout":`เปิดใช้งาน Single Logout`,
"label.file.library.create":`สร้างไลบรารีเอกสารใหม่`,
"label.event.moveup.half.day":`ล่วงหน้า 0.5 วัน`,
"label.stdashbord.xsld.business.jhzje":`จำนวนเงินทั้งหมดของโอกาส`,
"label.partnerCloud.orderingPlatform.unitPrice":`ราคาต่อหน่วย`,
"label.recordtype.edit.attribute":`คุณสมบัติทั่วไป`,
"front-template-V1-TemplatePreview":`แสดงตัวอย่างแม่แบบ`,
"label.tabpage.personalCenterz":`ศูนย์ส่วนบุคคล`,
"label.setuplookuplayout":`ค้นหาเค้าโครง`,
"label.no.merge.records":`ไม่มีบันทึกที่ผสานได้`,
"label.attachementNew.set2":`ขั้นตอนที่ 2: จะจัดเก็บถาวรใช่หรือไม่`,
"label.publicgroup.detail.showmembers":`ดูสมาชิกกลุ่ม`,
"UG.Forcast.03":`เริ่มวางแผนและดำเนินกลยุทธ์ทางธุรกิจ <br>ขอให้คุณมีความสุขกับการพยากรณ์!`,
"label.h5.manageprompt":`เลือกเมนูเพื่อเพิ่มไปยังหน้าเพจ หรือคลิกไอคอนเมนูโดยตรงเพื่อเปิดเมนู`,
"label.icon.145":`เชื่อมต่อ`,
"label.select":`เลือก`,
"label.publicgroup":`กลุ่มสาธารณะ`,
"label.customcomponent.usewhere.title":`ตำแหน่งที่จะใช้ส่วนเสริมนี้:`,
"label.custom.page.button.name":`ปุ่มชื่อ`,
"pagecreator_layout_button_vertical":`แยกตามแนวตั้ง`,
"label.marketsea.autorecyclerule":`กฎการรีไซเคิลอัตโนมัติ`,
"label.reportsSubscription.entrance.attachment":`รูปแบบ Excel.xlsx`,
"component_chatter_button_collect":`บุ๊กมาร์ก`,
"label.page.step2.of.step5":`ขั้นตอนที่ 2 จาก 5`,
"label.reportsSubscription.addfile.helptext":`ที่นี่คุณสามารถตั้งค่าว่าจะเพิ่มเอกสารแนบรายงานและรูปแบบเอกสารแนบรายงานในอีเมลการสมัครสมาชิกหรือไม่`,
"label.oldpw":`รหัสผ่านเก่า`,
"lable.SalesCommitmentKanBan.contractAmount":`จำนวนสัญญา`,
"lable.Bundle":`เป็นของชุดผลิตภัณฑ์`,
"label.weixin.unit.million":`หน่วย (หมื่นหยวน)`,
"label.app.choseprofile":`กำหนดโปรไฟล์`,
"label_tabpage_editz":`แก้ไข`,
"label.email.attachement.size.info":`ขนาดไฟล์ต้องไม่เกิน`,
"label.chatter.pastSevenday":`7 วันที่ผ่านมา`,
"label.weixin.end.later.start":`วันที่สิ้นสุดต้องมากกว่าหรือเท่ากับวันที่เริ่มต้น`,
"label.passwordPolicy.setup.lockoutPeriod":`เวลาล็อก`,
"pagecreator_page_funcpath":`/ต้วสร้าง/รายการหน้าเพจ`,
"label.emailobject.apperror":`ไม่มีบริการอีเมล โปรดติดต่อผู้ดูแลระบบ`,
"label.custom.page.button.broadband":`ความกว้างของปุ่ม (พิกเซล)`,
"label.weixin.contract.rate":`อัตราสัญญาที่สำเร็จ`,
"label.brief.payments":`จำนวนเงินที่ได้รับชำระหนี้`,
"lable.approvaldatamove.transfermsg":`ส่งคําขออนุมัติที่ยังไม่เสร็จเป็นกลุ่มไปยังผู้ใช้ใหม่`,
"label.datamanage.account.namenull":`หมายเหตุ: หากไม่กำหนดค่าฟิลด์ให้ "ชื่อลูกค้า" บันทึกลูกค้าจะไม่ถูกนำเข้า`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`ยอดชำระเงินสะสมทั้งหมด`,
"Opportunity_Detailed_Phase_Label_001":`สเตจ`,
"vue_label_helpcenter_calendar2":`<br>ปฏิทินออบเจ็กต์: ปฏิทินที่คุณสร้างด้วยออบเจ็กต์จะแสดงข้อมูลที่บันทึกไว้เป็นรายการปฏิทินในมุมมองปฏิทินในฟิลด์วันที่ คุณสามารถแก้ไข ลบ และปรับแต่งสีปฏิทินออบเจ็กต์แต่ละรายการได้ <br>สร้างอิเวนต์ใหม่<br>คุณสามารถสร้างอิเวนต์ใหม่ในมุมมองปฏิทินได้โดยสองวิธีดังต่อไปนี้. <br>（1）คลิกปุ่ม "อิเวนต์ใหม่" ที่มุมขวาบนของมุมมองปฏิทินเพื่อสร้างอิเวนต์ใหม่ คุณสามารเลือกออบเจ็กต์อื่นๆ ในฟิลด์ "รายการที่เกี่ยวข้อง" และ"ชื่อ" เพื่อเชื่อมอิเวนต์กับออบเจ็กต์อื่นๆ เช่น โอกาสทางธุรกิจ  บันทึกอิเวนต์ที่เกี่ยวข้องกับออบเจ็กต์อื่นจะถูกซิงค์ในโมดูล "อิเวนต์" ของหน้ารายละเอียดออบเจ็กต์อื่น <br>（2）คุณสามารถสร้างอิเวนต์ใหม่โดยคลิกที่ตารางปฏิทินเช่นกัน<br>สร้างปฏิทินออบเจ็กต์ใหม่<br>ขั้นตอนที่1: คลิกแท็บปฏิทินของเมนูการนำทางเพื่อเข้าสู่หน้ามุมมองปฏิทิน <br>ขั้นตอนที่ 2: ค้นหาปฏิทินของฉันที่ด้านขวาของมุมมอง คลิกไอคอนถัดจากปฏิทินของฉัน และดำเนินการในหน้าต่างป๊อปอัปของ "ปฏิทินออบเจ็กต์ใหม่" ที่ปรากฏขึ้น. <br>ขั้นตอนที่ 3: ตั้งชื่อปฏิทินออบเจ็กต์ที่สร้างขึ้นก่อน เลือกออบเจ็กต์พื้นฐานของปฏิทิน เลือกฟิลด์ที่กำหนดว่าปฏิทินจะแสดงอะไร "ฟิลด์เริ่มต้น" "ตัวกรองมุมมอง"  และ"ฟิลด์ที่แสดง" ใช้ฟิลด์เริ่มต้นกำหนดช่วงเวลาของข้อมูลที่แสดง กรองข้อมูลผ่านตัวกรองมุมมอง ใช้ฟิลด์ที่แสดงกำหนดเนื้อหาที่แสดงในรายการปฏิทิน <br>ปฏิทินอื่นๆ<br>ปฏิทินอื่นๆ จะรวมปฏิทินของผู้ใช้รายอื่นที่เพิ่มเข้ามาอยู่ด้วย สามารถเพิ่มผู้ใต้บังคับบัญชาและปฏิทินพนักงานที่แบ่งปันปฏิทินกับคุณ<br>แบ่งปันปฏิทินอิเวนต์ของฉัน<br>ขั้นตอนที่ 1: คลิกแท็บปฏิทินของเมนูการนำทางเพื่อเข้าสู่หน้ามุมมองปฏิทิน <br>ขั้นตอนที่ 2: หา "อิเวนต์ของฉัน" ใต้ปฏิทินของฉันทางด้านขวาของมุมมองปฏิทิน คลิก "ปุ่มดึงลง" ทางด้านขวาของ "อิเวนต์ของฉัน"เลือกแบ่งปันปฏิทิน <br>ขั้นตอนที่ 3: เลือกผู้ใช้ที่ต้องการแบ่งปันและสิทธิ์การเข้าถึง ในหน้าต่างป๊อปอัป "แบ่งปันปฏิทิน" ที่ปรากฏขึ้น นอกจากนี้คุณยังสามารถดูบันทึกแบ่งปันปฏิทินของคุณได้โดยคลิก "ผู้ที่มีสิทธ์เข้าถึงได้ในขณะนี้" คลิกไอคอน "×" ทางด้านขวาของแบ่งปันบันทึก เพื่อลบแบ่งปันบันทึก <br>หลังจากแบ่งปันบันทึก ผู้ใต้บังคับบัญชาของคุณสามารถเพิ่มปฏิทินเหตุการณ์ของคุณลงในปฏิทินอื่นจากนั้นก็จะสามารถดูปฏิทินอิเวนต์ของคุณได้ <br>เพิ่มปฏิทิน<br>ขั้นตอนที่ 1: คลิกแท็บปฏิทินของเมนูการนำทางเพื่อเข้าสู่หน้ามุมมองปฏิทิน <br>ขั้นตอนที่ 2: คลิก "ปุ่มดึงลง" ของปฏิทินอื่นทางด้านขวาของมุมมองปฏิทินแล้วเลือกเพิ่มปฏิทิน <br>ขั้นตอนที่ 3: เลือกปฏิทินอิเวนต์ของพนักงานที่คุณต้องการเพิ่มในหน้าต่างป๊อปอัป "แบ่งปันปฏิทิน" คุณสามารถเลือกปฏิทินอิเวนต์ของผู้ใต้บังคับบัญชาและปฏิทินอิเวนต์ที่แบ่งปันกับคุณ คลิกเพิ่มเพื่อสำเร็จการเพิ่ม. <br>ลบปฏิทินที่เพิ่ม<br>คลิก "ปุ่มดึงลง" ทางด้านขวาของปฏิทินที่คุณต้องการลบใต้ปฏิทินอื่น ๆ เลือก "ลบ"`,
"label.callcenter.Seat.number":``,
"vue_label_commonobjects_view_change_all_selected_records":`เปลี่ยนบันทึกที่เลือกทั้งหมด`,
"label.user.notinuse":`ผู้ใช้ไม่ได้เปิดใช้งาน โปรดติดต่อผู้ดูแลระบบ`,
"label.usermanage.hasbeen.reached":`ถึงจำนวนสูงสุดของใบอนุญาตใช้สิทธิ์แล้ว โปรดติดต่อผู้ให้บริการเพื่อขอรับการอนุญาตเพิ่มเติม!`,
"vue_label_help_list":`มุมมองรายการ`,
"label.infomation.edit":`แก้ไขข้อมูลพื้นฐาน`,
"label.ccchat.person.setting.info":``,
"label.sso.isDelete":`ต้องการลบหรือไม่`,
"label.unique.identification.number":`หมายเลขประจำตัว`,
"label.weixin.no.pending.projects":`ไม่มีรายการที่รออนุมัติ`,
"label.projectManagement.Pleaseenteramember":`กรุณาระบุสมาชิก`,
"label.salescloud.salesdashboard.visit":`เข้าพบลูกค้า`,
"label.weixin.user.registered":`ลงทะเบียนผู้ใช้`,
"message.loginhistory.downloadcsv":`ดาวน์โหลดประวัติการล็อกอืน 6 เดือนล่าสุด (ไฟล์ Excel.csv)`,
"label.icon.37":`ตำแหน่ง`,
"template.chart.schdyqyx":`การตอบสนองที่คาดหวังของแคมเปญ`,
"label.tel.ten":`คุณสามารถใส่หมายเลขโทรศัพท์มือถือที่ต้องการส่งแจ้งเตือนได้มากสุด 10 หมายเลข ให้ใช้ ; "แยก" ระหว่างหมายเลขโทรศัพท์มือถือแต่ละหมายเลข`,
"label.data.exp.objdata":`คุณจะส่งออกข้อมูลของออบเจ็กต์นี้ตามเงื่อนไขต่อไปนี้`,
"label.loginservice.after.use":`หลังจากนี้ ถึงจะสามารถใช้ได้`,
"pagecreator_systemstyle_message_delete":`ต้องการลบรูปแบบที่เลือกหรือไม่?`,
"label.globalselect.deleteerror":`เนื่องจากชุดค่ารายการตัวเลือกนี้ถูกใช้โดยฟิลด์ต่อไปนี้ จึงไม่สามารถลบได้ชั่วคราว`,
"label.department.add":`เพิ่มหน่วยงาน`,
"label.attendance.dingwei":`ตำแหน่งที่ตั้ง`,
"label.workflow.editrule":`แก้ไขกฎ`,
"lable.product.pecm":`กรุณากรอกจำนวนเงินให้ถูกต้อง!`,
"label.icon.182":`กระเป๋าเอกสาร`,
"label.help.release.notes":`เผยแพร่ทัวร์`,
"UG.product.05":`นำเข้าผลิตภัณฑ์`,
"label.email2":`อีเมล`,
"label.weekrepeat":`ทำซ้ำทุกสัปดาห์`,
"label.mr.descreption.oneGroupReData2":`กลุ่ม`,
"chatter.at.d":`ระดับการใช้งาน`,
"label.mr.descreption.oneGroupReData1":`ความคืบหน้าของการตรวจสอบซ้ำและผสาน: ทั้งหมด`,
"label.weixin.mobile.fly.android":`การแบ่งปันบนอุปกรณ์มือถือ Android`,
"label.brackets.right":`) วงเล็บด้านขวา`,
"message.recordtype.applytoAllProfiles":`ปรับใช้เค้าโครงเพจเดียวกันทุกโปรไฟล์`,
"label.customcomponent.page.index.tip":`คล้ายกับการทำงานของฟังก์ชันในภาษาโปรแกรม ส่วนเสริมที่กำหนดเองอนุญาตให้คุณสามารถปกปิดรูปแบบการออกแบบทั่วไปได้ จากนั้นนำรูปแบบเหล่านั้นกลับมาใช้ใหม่ในเพจแบบกำหนดเองตั้งแต่หนึ่งเพจขึ้นไป`,
"lable.List.properties":`รายการคุณสมบัติ`,
"label.fieldinfo":`ข้อมูลฟิลด์`,
"label.ems.error.fail":`การโหลดล้มเหลว โปรดลองอีกครั้งหรือติดต่อผู้ดูแลระบบเพื่อดำเนินการ`,
"label_emailsync_form_email":`อีเมล`,
"lable.currencyManage.button.manageRate":`จัดการสกุลเงิน`,
"component_salesperformance_label_100finish":`สิ้นสุดแล้ว`,
"label.knowledgebase.data.assignment.failed":`การมอบหมายข้อมูล {a} รายการล้มเหลว`,
"label.custom.buttonandlink.remark":`เลือกรูปแบบ: หน้าต่างที่มีอยู่ / หน้าต่างใหม่ (หน้าต่างที่มีอยู่: เปิดที่หน้าต่างปัจจุบัน; หน้าต่างใหม่: เปิดที่หน้าต่างใหม่)`,
"label.list.userinterface.watermark.setup":`การตั้งค่าลายน้ํา`,
"component_timeline_label_7daysahead":`7 วันก่อน`,
"label.sendemail.chat.replyinchat":`ตอบกลับเวยเทีย:`,
"component.salesperformance.label.title":`ประสิทธิภาพการขาย`,
"label.data.downpage.e.list.desc2":`คุณจะได้รับอีเมลหลังจากการส่งออกข้อมูลสำเร็จเพื่อแจ้งการส่งออกข้อมูลสำเร็จ`,
"vue_label_campaign_fromclosedopprotunities":`โอกาสทางธุรกิจที่ปิดการขายสำเร็จจาก{sjcb}`,
"label.umeng.activity.taskviewed":`ภารกิจที่คุณจะมอบหมายให้กับ#nameถูกดูแล้ว`,
"vue_label_salesadvance_retentions":`จำนวนที่รักษาสายสัมพันธ์`,
"label.fieldtag":`ป้ายกำกับฟิลด์`,
"label.quickbooks.button.searchinquickbooks":`ค้นหาใน QuickBooks`,
"label.quickbooks.viewlist.action":`ปฏิบัติการ`,
"label.weixin.sysapp":`แอประบบ`,
"label.approval.examine.level":`อนุมัติระดับตามระดับขั้นผู้ใช้ ระดับขั้นผู้ใช้ที่สูงสุดถึง`,
"label.appupload.upload.error":`ไม่สามารถติดตั้งแอปพลิเคชันนี้ โปรดยุติการติดตั้งหรือติดตั้งใหม่หลังจากปรับเปลี่ยน API ในระบบ!`,
"label.emailtemplate":`แม่แบบอีเมล`,
"front-email-payment-Invoice-amount":``,
"label.viewselectedproducts":`ดูผลิตภัณฑ์ที่เลือก`,
"label.tianyancha.businessverify.openfirst":`กรุณาเปิดใช้งานการทวนสอบข้อมูลธุรกิจก่อน`,
"lable.SalesCommitmentKanBan.returnAList":`กลับไปที่รายชื่อพนักงาน`,
"label.knowledgebase.nopublished.draft.translations":`ไม่มีการแปลที่เผยแพร่หรือฉบับร่าง`,
"vue_label_calendar_day_view":`ปฏิทิน-มุมมองรายวัน`,
"label.globalselect.remark":`ชุดค่ารายการตัวเลือกระดับโกลบอลทำให้คุณสามารถแบ่งปันค่าระหว่างออบเจ็กต์ได้`,
"label.orderby":`วิธีการจัดลำดับ`,
"lable.weixin.LastaDaysFinished":`เสร็จสิ้นเมื่อ 7 วันที่ผ่านมา`,
"lable.currencyManage.Enabledadvcurrency.discripation":`คุณสามารถแม็ปอัตราแลกเปลี่ยนสกุลเงินเข้ากับอัตราแลกเปลี่ยนที่หมดอายุในช่วงวันที่ที่ระบุได้ 
อัตราแลกเปลี่ยนที่หมดอายุจะใช้สำหรับโอกาสทางธุรกิจ ผลิตภัณฑ์ที่มีโอกาสทางธุรกิจ และรายงานที่เกี่ยวข้องกับสองออบเจ็กต์นี้ โดยอัตราแลกเปลี่ยนที่หมดอายุนี้จะไม่สามารถใช้กับฟิลด์ของออบเจ็กต์อื่นหรือรายงานประเภทอื่นได้ ตัวอย่างเช่น อัตราแลกเปลี่ยนของวันที่ 1 มกราคมคือ 1 USD เท่ากับ 6.68 CNY แต่อัตราแลกเปลี่ยนของวันที่ 6 กุมภาพันธ์เปลี่ยนเป็น 1 USD เท่ากับ 6.70 CNY วันที่สิ้นสุด คือ วันที่ 1 มกราคม ถึง 6 กุมภาพันธ์ โอกาสทางธุรกิจที่อยู่ในช่วงวันนี้จะใช้อัตราแลกเปลี่ยนแรก (1 = 6.68) แต่โอกาสทางธุรกิจที่อยู่ตั้งแต่วันที่ 6 กุมภาพันธ์เป็นต้นไปจะใช้อัตราแลกเปลี่ยนที่สอง (1 = 6.70)`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`สัปดาห์ที่หนึ่ง`,
"label.leadtoobjectfield":`แม็ปฟิลด์ที่กำหนดเองของลีด`,
"label.dashboardSetup.shujuyuan":`แหล่งข้อมูล`,
"label.tabpage.userz":`ผู้ใช้`,
"label.sms.companyname.dsf":`อินเทอร์เฟซข้อความสั้นของตงสือฟาง`,
"label.step2.total3":`ขั้นตอนที่ 2 จาก 3`,
"front-gantt-module-Drag-dropt- reorder-tasks":``,
"label.dashboard.snapshot.no.enabled":`ไม่ได้เปิดใช้งานฟังก์ชันสแนปชอดแดชบอร์ด`,
"label.dashboard.unit3":`หน่วย: จำนวนเต็ม`,
"label.forecast.shrepage.desc2":`ผู้ใช้ บทบาทและภูมิภาคที่มีการเข้าถึงร่วมกัน`,
"label.commonobjects.new":`{eventName}ใหม่`,
"label.view.nameonlyone":`ชื่อเฉพาะมุมมอง`,
"label.assignment.setup.newentries.user":`ผู้ใช้`,
"label.otheremails":`อีเมลอื่นๆ`,
"component_sendmail_button_send":`ส่ง`,
"vue_label_accountpool":`ฐานข้อมูลลูกค้า`,
"label.h5.approval.actortime":`เวลาเริ่มต้น`,
"message.approval.cannotsubmit":`ไม่สามารถส่งเพื่อขออนุมัติได้`,
"vue_label_pool_createdbyme":`ฉันสร้างด้วยตัวเอง`,
"label.change.event":`เปลี่ยนเป็นมุมมองอิเวนต์`,
"vue_label_homepage_personalpage":`หน้าแรกส่วนตัว`,
"label.new.collect.target":`เป้าหมายสรุปใหม่`,
"label.ServiceCloud.zichanxuhao":`หมายเลขสินทรัพย์`,
"label.product.userl":`คอลัมน์สำหรับผู้ใช้ทั้งหมด`,
"label.syslog":`ล็อกระบบ`,
"label.reportcreatestatus":`รายงานสถานะการสร้าง`,
"label.datamanage.account.novalue":`หมายเหตุ: การนำเข้านี้ไม่ได้กำหนดค่าให้กับฟิลด์ "ชื่อลูกค้า" และบันทึกลูกค้าจะไม่ถูกนำเข้า!`,
"label.letter.body":`ข้อความจดหมายเชิญ`,
"label.select.please":`โปรดเลือก`,
"label.escalation.setup.entrydetail.description":`1. คลิกแก้ไข "เพื่อเปลี่ยนคุณสมบัติรายการเกณฑ์ <br/> 2. คลิก " ใหม่ "เพื่อเพิ่มการดำเนินการเลื่อนขั้น"`,
"label.component.salesDashboard.nodata":`เพิ่มโอกาสทางธุรกิจที่คุณกำลังใช้แล้วกลับมาที่นี่เพื่อดูผลการดำเนินงาน`,
"vue_label_helpcenter_account":`ในรายละเอียด ให้คลิกปุ่มแผนผังต้นไม้ที่อยู่ถัดจากลูกค้าเพื่อดูโครงสร้างลำดับชั้นของลูกค้า ทำความเข้าใจความสัมพันธ์หลัก-รองของลูกค้าที่เกี่ยวข้อง และดูฟิลด์บางส่วนของลูกค้าแต่ละราย <br> เมื่อเปลี่ยนเจ้าของลูกค้า สามารถเลือกที่จะเปลี่ยนเจ้าของข้อมูล เช่น โอกาสทางธุรกิจ เคสและข้อมูลอื่นๆ ที่เกี่ยวข้องกับลูกค้าได้พร้อมกัน`,
"front-kefu-moudle-v1-awshjzx-intelligent":``,
"label.productby":`ผู้สร้าง`,
"label.operation.date":`เวลาดำเนินการ`,
"label.name.donot.delete":`ไม่สามารถลบชื่อ`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(date)`,
"label.escalation.setup.entrydetail.howescalationtime":`วิธีการตั้งค่าเวลาการเลื่อนขั้น`,
"label.view.step2":`ขั้นตอนที่ 2. ระบุเงื่อนไขตัวกรอง`,
"lable.outlook.edit.notnull":`ชื่อฟิลด์ไม่สามารถว่างเปล่า`,
"label.knowledgebase.createnewbrowser":`สร้างแท็บเบราว์เซอร์ใหม่`,
"label.partner.all.name":`ชื่อพาร์ทเนอร์คลาวด์`,
"chatter.group.groupSetUp":`การตั้งค่ากลุ่ม`,
"label.reportlist.findfolder":`ค้นหาโฟลเดอร์`,
"component.setup.tabs.label.title":`Tab เพจ`,
"label.passwordPolicy.setup.pswComplexReq":`ต้องการรหัสผ่านที่ซับซ้อน`,
"label.emaildocument":`ส่งเอกสารทางอีเมล`,
"message.selectgsummaryconditon":`โปรดเลือกเงื่อนไขของการสรุป`,
"component_todaytask_label_notask":`ไม่มีงานที่มีกำหนดเสร็จวันนี้ - ถือโอกาสเอาเวลานี้ ไปดื่มกาแฟสักแก้วเถอะ`,
"label.user.organization.notexists":`ไม่พบองค์กร!`,
"label.isEnableVisualpage.new.leftlist":`เพจที่กำหนดเองพร้อมใช้งาน`,
"label.mobile.phone.write.week.report":`เขียนรายงานประจำสัปดาห์`,
"label.emailmerge.edittemplate.edit":`แก้ไขแม่แบบจดหมายเวียน`,
"template.dashboard.folder.sales.manage":`การจัดการการขาย`,
"label.confirm.order.productsToassets":`ยืนยันการโอนผลิตภัณฑ์ที่สั่งซื้อไปยังสินทรัพย์หรือไม่?`,
"label.service.dispatchingUnits.leftRight.total":`ข้อมูลปัจจุบัน {left}-{right} รายการ ข้อมูลทั้งหมด {totalCount} รายการ`,
"label.import.step1.chooseidorother":`2. คุณสามารถเลือกใช้ ID หรือชื่อที่ตรงกับบันทึกและกรอกข้อมูลลงในฟิลด์การค้นหา หากต้องการรับ id บันทึกที่เกี่ยวข้องและข้อมูลอื่นๆ สามารถสร้างรายงาน และตั้งค่าชื่อบันทึกและ id บันทึกเป็นคอลัมน์กลุ่มและส่งออกรายงาน`,
"label_tabpage_completez":`ทำเครื่องหมายสถานะที่เลือกว่าสำเร็จ`,
"chatter.c.adr":`ที่อยู่ในการติดต่อ`,
"label.account.d":`หน้านี้ช่วยให้คุณกำหนดบันทึกไตรมาสบัญชีเองได้ วันที่ของไตรมาสบัญชีที่กำหนดเองจะถูกสร้างตามที่คุณเลือกด้านล่าง`,
"label.tag.more50":`สร้างป้ายกำกับได้มากสุด 50 ป้าย`,
"setup.layout.label.areashow":`ชื่อภูมิภาคแสดงตำแหน่งที่ตั้ง`,
"label.partnerCloud.basicSetting.rebate":`เปิดใช้งานเงินคืน`,
"label.tabpage.greaterequalz":`มากกว่าหรือเท่ากับ`,
"vue.please.select.the.aggregate.basis":`โปรดเลือกเกณฑ์ผลรวม`,
"label.form":`ฟอร์ม`,
"label.chatter.colleagues.list.beizhu":`เปิดการใช้งาน`,
"label.priority":`ลำดับความสำคัญ`,
"vue_label_checkduplicate_set_repeat_rules":`ตั้งค่าเกณฑ์ในการทำซ้ำ`,
"label.share_form":`แบ่งปันฟอร์ม`,
"label_relation_shareholder":`ผู้ถือหุ้นเหมือนกับบริษัทย่อยไม่ได้`,
"label.project.hit.sixteen":`แจ้งเตือนปัญหาถึงกำหนด`,
"label.service.miniProgram.imageFormat":`อัปโหลดรูปภาพได้เฉพาะในรูปแบบ PNG, JPG, JPEG!`,
"label.summary.mode":`วิธีการสรุป`,
"vue_label_beforeverification":`ก่อนการทวนสอบ`,
"label.data.newtemplate.desc":`นำฟิลด์และเงื่อนไขที่ลูกค้าเลือกมาบันทึกเป็นแม่แบบ หากผู้ใช้ดำเนินการซ้ำสามารถส่งออกผ่านแม่แบบได้โดยตรง`,
"lable.evaluation.badreview":``,
"label.total.tabs":`มี{1}ทั้งหมด {0}`,
"label.emailmerge.mergeFolder.foldertemplate":`แม่แบบในโฟลเดอร์นี้`,
"vue_label_normal_notice_repeated":`กรุณาอย่าทำซ้ำ`,
"label.icon.140":`ข้อมูล`,
"label.fromonetoanother":`โอนย้ายจากผู้ใช้หนึ่งไปยังอีกผู้ใช้หนึ่ง`,
"label.user.list":`รายชื่อผู้ใช้`,
"label.file.prevent.share.operate":`ป้องกันไม่ให้ผู้อื่นแบ่งปันและยกเลิกการแบ่งปัน`,
"label.app.detail":`ดูแอปพลิเคชัน`,
"label.h5.similar.opportunity.correlation":`ความสัมพันธ์`,
"label_emailtocloudcc_filed_username":`ชื่อผู้ใช้อีเมล`,
"vue_labe_account_shareholdingratio":`สัดส่วนการถือหุ้น`,
"label.data.dataexpalltype.all_desc3":`3. ข้อมูลที่ส่งออกสำเร็จจะสร้างไฟล์บีบอัด ผู้ใช้สามารถดาวน์โหลดไฟล์ที่ส่งออกในหน้ารายการไฟล์ที่ส่งออกสำเร็จตามข้อมูลไฟล์ในอีเมล`,
"label.callcenter.please.select .seatID":``,
"label.remark.length.cannot.than":`คำอธิบายต้องยาวไม่เกิน 255`,
"label.batchtransfer.dateandtimetype.tip":`สำหรับฟิลด์วันที่/เวลาให้ป้อนค่าในรูปแบบต่อไปนี้:`,
"label.component.helper.businesschange.0UntreatActivity":`โอกาสทางธุรกิจที่ไม่มีการจัดกิจกรรม`,
"front-project-module-v1-plase-input-start-time":`กรุณาใส่วันที่เริ่มต้น`,
"label.event.moveup.6hour":`ล่วงหน้า 6 ชั่วโมง`,
"label.data.exp.tempexp":`ส่งออกตามแม่แบบ`,
"label.schedulejob.setup.schedule.afternoon":`ช่วงบ่าย`,
"label.ems.format":`รูปแบบ`,
"label.objectHasBeenDeleted":`ออบเจ็กต์ที่ลบแล้ว`,
"label.ServiceCloud.chaxunchenggong":`ค้นหาสำเร็จ`,
"label.campaign.channel.input.notice.owner":`แจ้งเตือนเจ้าของ`,
"label.bajisitan.time":`เวลาปากีสถาน`,
"label.warnMes":`ออบเจ็กต์ถูกใช้ การลบล้มเหลว!`,
"lable.Up.to.ten.fields":`เลือกออบเจ็กต์และเพิ่มฟิลด์ลงในตารางได้สูงสุด 10 ฟิลด์  ลูกศรขึ้นหรือลงเป็นฟิลด์ที่ปรากฏในส่วนหัวของคอลัมน์`,
"label.approverule":`เกณฑ์การอนุมัติ`,
"message.error.specific":`ส่งคืนการแจ้งเตือนข้อผิดพลาดเฉพาะ`,
"front-template-V1-saveUse":`บันทึกและแสดงตัวอย่าง`,
"label.uploadfile.success":`อัปโหลดสำเร็จแล้ว`,
"label.tabname.donot.database.key":`ชื่อแท็บไม่สามารถเป็นคีย์เวิร์ดของฐานข้อมูลได้!`,
"message.recordtype.selectlayout.select":`-- เลือกเค้าโครงเพจ --`,
"front-detail-module-v1-list-cardview":`มุมมองรายการ/การ์ด`,
"label.product.maintenance":`การบํารุงรักษา`,
"vue_label_helpcenter_approve":`1. รายการรออนุมัติ<br> รายการทั้งหมดที่คุณต้องอนุมัติ คุณสามารถค้นหาบันทึกที่จะอนุมัติตามวันเริ่มต้น วันสิ้นสุด ผู้เสนอ ชนิดบันทึก และรายการที่เกี่ยวข้องของบันทึกรออนุมัติ <br>อนุมัติบันทึกเดียว: คลิกปุ่มด้านซ้ายของแต่ละบันทึก <br> A. ดำเนินการอนุมัติ <br> ขั้นตอนที่ 1: คลิก "ดำเนินการอนุมัติ" เพื่อเปิดหน้าคำขออนุมัติ<br> ขั้นตอนที่ 2: คลิก "อนุมัติ" หรือ "ปฏิเสธ" เพื่อเสร็จสิ้นการอนุมัติ <br> หากต้องกำหนดผู้อนุมัติสำหรับขั้นตอนการอนุมัติถัดไปด้วยตนเอง ให้ดำเนินตามขั้นตอนที่ 3 หลังจาก "อนุมัติ" <br> ขั้นตอนที่ 3: เลือกผู้อนุมัติรายถัดไป เพื่อเสร็จสิ้นการอนุมัติ<br> หากคุณต้องการส่งคืนขั้นตอนหลังจากปฏิเสธให้ไปที่ขั้นตอนที่ 4 หลังจาก "ปฏิเสธ" <br> ขั้นตอนที่ 4: เลือกขั้นตอนการอนุมัติที่จะส่งคืนเพื่อเสร็จสิ้นการอนุมัติ <br> B. การมอบหมายใหม่<br> ขั้นตอนที่ 1: คลิก "มอบหมายใหม่"<br> ขั้นตอนที่ 2: ค้นหาผู้อนุมัติใหม่<br> ขั้นตอนที่ 3: คลิก "มอบหมายคำขออนุมัติใหม่" เพื่อเสร็จสิ้นการมอบหมายใหม่ <br>หมายเหตุ: หากคุณเป็นผู้อนุมัติแทน คุณจะมอบหมายใหม่ไม่ได้ <br> อนุมัติแบบกลุ่ม: หลังจากรายการที่จะอนุมัติแล้ว ให้คลิกปุ่มดำเนินการเหนือรายการ <br> C. ดำเนินการอนุมัติ<br> ขั้นตอนที่ 1: เลือกรายการบันทึกที่จะอนุมัติ<br> ขั้นตอนที่ 2: คลิก "ดำเนินการอนุมัติ"<br> ขั้นตอนที่ 3: คลิก "อนุมัติ" หรือ "ปฏิเสธ" เพื่อเสร็จสิ้นการดำเนินการ <br> หากคุณต้องการส่งคืนขั้นตอนหลังจากปฏิเสธให้ไปที่ขั้นตอนที่ 4 หลังจาก "ปฏิเสธ"<br> ขั้นตอนที่ 4: เลือกขั้นตอนการอนุมัติที่จะส่งคืนเพื่อเสร็จสิ้นการอนุมัติ <br> D.การมอบหมายใหม่<br> ขั้นตอนที่ 1: ลือกรายการบันทึกรออนุมัติ<br> ขั้นตอนที่ 2: คลิก "มอบหมายใหม่"<br> ขั้นตอนที่ 3: ค้นหาผู้อนุมัติใหม่<br> ขั้นตอนที่ 4: คลิก "มอบหมายคำขออนุมัติใหม่" เพื่อเสร็จสิ้นการมอบหมายใหม่<br>2. รายการที่ฉันเสนอ<br> แสดงรายการที่คุณเสนอขออนุมัติทั้งหมด คุณสามารถค้นหาบันทึกที่ขออนุมัติตามวันเริ่มต้น วันสิ้นสุด ผู้เสนอ ชนิดบันทึก รายการที่เกี่ยวข้องและสถานะการอนุมัติได้อย่างรวดเร็ว <br>3. รายการที่ฉันอนุมัติ<br> แสดงรายการที่คุณอนุมัติทั้งหมด คุณสามารถค้นหาบันทึกที่อนุมัติตามวันเริ่มต้น วันสิ้นสุด ผู้เสนอ ชนิดบันทึก รายการที่เกี่ยวข้องและสถานะการอนุมัติได้อย่างรวดเร็ว <br>4. รายการที่ฉันปฏิเสธ<br> แสดงรายการที่คุณปฏิเสธทั้งหมด คุณสามารถค้นหาบันทึกตามวันเริ่มต้น วันสิ้นสุด ผู้เสนอ ชนิดบันทึก รายการที่เกี่ยวข้องและสถานะการอนุมัติได้อย่างรวดเร็ว`,
"label.knowledgebase.knowledge.article":`บทความความรู้`,
"march":`เดือนมีนาคม`,
"label.accraditation":`อนุมัติ`,
"vue_label_pool_cantreach":`ไม่สามารถติดต่อลูกค้าได้`,
"label.service.appointmentList.startOf.maturityPeriod":`ระยะเวลาครบกำหนดเริ่มต้นขึ้น`,
"message.huanxin.closed":`ไม่ได้เปิดใช้งานฟังก์ชั่นแชท`,
"label.implementation.time.operation":`ดำเนินการงานที่ต้องกำหนดเวลา`,
"label.setting.intergrationlist.permissions":`สิทธิ์การเชื่อมต่อ`,
"label.translation.norecord":`ไม่มีบันทึก`,
"label.lack.expression":`นิพจน์บกพร่อง`,
"setup.layout.message.relatedlistfield":`นอกจากเลือกฟิลด์ที่แสดงในรายการที่สัมพันธ์กันแล้ว คุณยังสามารถจัดเรียงฟิลด์ที่เลือกใหม่ได้`,
"label.group.file":`ไฟล์กลุ่ม`,
"message.error.id.null":`ไม่พบข้อมูล ID นี้`,
"label.a_b_least":`บันทึก A" แต่ละบันทึก ต้องมีความสัมพันธ์กับบันทึก "B" อย่างน้อยหนึ่งรายการ`,
"label.addattachment.step3":`ขั้นตอนที่ 4. คลิกปุ่ม "เสร็จสิ้น" เพื่อกลับไปยังหน้าก่อนหน้า`,
"label.data.exportsf":`ส่งออกไฟล์สำเร็จ`,
"label.callcenter.call.out":``,
"front-electronic-export-exportIntro":``,
"label.custombutton.deletedata.notnull":`ข้อมูลที่ลบต้องไม่ว่างเปล่า`,
"UG.homepage.002":`ใช้เครื่องมือทางธุรกิจที่เป็นแบบเดียวกันมาจัดการลีด กรวยการขาย และข้อมูลลูกค้าของคุณ`,
"label.globaloperation":`การดำเนินการระดับโกลบอล`,
"label.icon.58":`คนงาน`,
"vue_label_salesadvance_lostrate":`อัตราการสูญเสีย`,
"chatter.from":`จาก`,
"front-epwechat-module-v1-account-binding":`การผูกบัญชี`,
"label.list.userinterface.old.page.setup":`อินเทอร์เฟซรุ่นเก่า`,
"label.forecast.settings.periods":`รอบ`,
"label.file.share.email.content":`#sharedByได้แชร์ไฟล์กับคุณใน#orgname`,
"label.knowledge.category.hint.five":`การตั้งค่าหมวดหมู่ข้อมูล`,
"setup.layout.label.selectedfield":`เลือกฟิลด์`,
"label_business_income":`รายได้ของโอกาสทางธุรกิจ`,
"vue_label_display_options_field":`แสดงฟิลด์รายการตัวเลือก`,
"label.emailtocloudcc.set":`ตั้งค่าข้อมูลอีเมล`,
"label.knowledge.setting.data.five":`ลบหมวดหมู่: {lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`ผูกองค์กรแล้ว`,
"label.ccpeak.delete.recycle":`บันทึกจะถูกลบไปยังถังขยะรีไซเคิล`,
"label.leadconvers.tip":`ลีดไม่สามารถแปลงเป็นลูกค้า ผู้ติดต่อ โอกาสทางธุรกิจ และภารกิจติดตามได้ หากยังไม่ยืนยันว่าลีดรายนั้นมีมูลค่า`,
"label.rsa.key.invalid":`คีย์สาธารณะไม่ถูกต้อง โปรดเข้าสู่ระบบอีกครั้ง`,
"label.mobile.bind.success":``,
"label.emailtocloudcc.filed.servertype":`ประเภทเซิร์ฟเวอร์`,
"label.user.new":`ผู้ใช้ใหม่`,
"label.setup.mobile.homepageshortcuts.remark":`องค์กรสามารถตั้งค่าการกำหนดค่าฟังก์ชันทางลัดที่ส่วนบนของเพจหน้าแรกขององค์กรตามสถานการณ์ทางธุรกิจ`,
"label_emailtocloudcc_select2":`เลือกประเภทการแสดงผล`,
"page.send.email":`ส่งอีเมล`,
"label.service.newBuildDialog.field.display":`ฟิลด์ที่จะแสดง`,
"vue_label_homepage_card_impending":`ใกล้กับโอกาสทางธุรกิจ`,
"label.message.contactispartner.delete":`มีผู้ใช้พาร์ทเนอร์เชื่อมโยงกับผู้ติดต่อนี้ ไม่สามารถลบออกได้`,
"label.attendance.checkout":`บันทึกเวลาออกงาน`,
"label.emailmerge.newtemplate.description":`กรุณาใส่ข้อมูลเกี่ยวกับแม่แบบจดหมายเวียนของคุณ โปรดทราบว่า หมายเหตุที่แสดงใน CloudCC จะไม่ปรากฎใน Word`,
"laebe.data.exp.success":`หลังจากการส่งออกสำเร็จคุณจะได้รับอีเมลแจ้งเตือนจากระบบ ข้อมูลที่ส่งออกจะถูกบันทึกไว้ชั่วคราวบนเซิร์ฟเวอร์ ระบบจะบันทึกไว้ให้คุณเพียง 48 ชั่วโมงเท่านั้น กรุณารีบไปที่หน้ารายการข้อมูลส่งออกเพื่อดาวน์โหลดข้อมูลของคุณโดยเร็วที่สุด`,
"lable.Maximum.number":`ชื่อแม่แบบอนุญาตให้ใช้อักขระได้สูงสุด 50 ตัว`,
"label.projectManagement.drag.and.drop.existing.tasks":`ลากและวางงานที่มีอยู่ในหมวดนี้`,
"label.forecast.tree.desc":`ลำดับชั้นการพยากรณ์จะกำหนดวิธีการสะสมค่าพยากรณ์ในองค์กรของคุณ รวมถึงผู้ที่สามารถดูและปรับเปลี่ยน ระบบจะสร้างขึ้นโดยอัตโนมัติตามโครงสร้างลำดับขั้นบทบาทของคุณ แต่คุณอาจจะต้องเพิ่มหรือแก้ไขผู้จัดการ พนักงานขายหรือผู้ใช้อื่นๆ คุณยังสามารถเปิดใช้งานการแบ่งปันการพยากรณ์ สำหรับผู้ใช้การพยากรณ์รายบุคคลอีกด้วย`,
"vue_label_chatter_upload_file_type":`เลือกประเภทไฟล์ที่จะอัปโหลดขึ้นโพสต์แล้ว`,
"front-lightning-module-v1-dashborad-analysis-dimension":`มิติการวิเคราะห์`,
"vue_label_homepage_custom_homepage":`หน้าแรกที่กำหนดเอง`,
"label.icon.39":`ตำแหน่ง`,
"label.appointmentpage.wizard.notif1":`โปรดเลือกเวลาก่อน`,
"vue_label_report_filterby":`กรองตาม{screenCondition}`,
"label.argentina.time":`เวลาอาร์เจนตินา`,
"label.role.assign.notremove":`ไม่อนุญาตให้ลบผู้ใช้ออกจากรายการ <b> ผู้ใช้ที่เลือก </b> ไปยัง <b> ผู้ใช้ที่ไม่ได้รับมอบหมายและเปิดใช้งานทั้งหมด </b> และ <b> ผู้ใช้ที่ไม่ได้รับมอบหมายทั้งหมด </b>`,
"label.sharerule.detailsetshare":`กฎการแบ่งปันโดยละเอียด`,
"label.file.publicview.error1":`ไฟล์ถูกลบหรือลิงก์สาธารณะไม่ถูกต้อง`,
"label.data.downpage.e_title.num4":`4. ไฟล์ส่งออกมีสองรูปแบบ: รูปแบบ CSV และรูปแบบบีบอัด โดยรูปแบบการบีบอัดสองรูปแบบ: รูปแบบหนึ่งคือการสร้างรหัสผ่านไฟล์บีบอัดโดยอัตโนมัติ อีกรูปแบบหนึ่งคือการป้อนรหัสผ่านไฟล์บีบอัดด้วยตนเอง`,
"label.knowledge.case.article":``,
"label.data.newtemplate.e.conditions":`เงื่อนไขการส่งออก`,
"front-object-change-owner":``,
"label.newdashboardpage.edittitle":``,
"label.datamove.end.query.no.record":`การสืบค้นสิ้นสุด ไม่พบบันทึกที่สอดคล้องกับเงื่อนไข!`,
"lable.SalesCommitmentKanBan.receiptsTarget":`เป้าหมายการเก็บเงิน`,
"label.orderagain":`เรียงลำดับใหม่`,
"vue_report_dashboard_transfer":`ย้ายโฟลเดอร์`,
"label.view.sortview.default":`ค่าเริ่มต้นมุมมอง`,
"label.brasilia.time":`เวลาบราซิเลีย`,
"label.industrialandcommercialverification.instructions":`การเปิดใช้งานการทวนสอบข้อมูลธุรกิจทำให้เมื่อผู้ใช้ใส่ข้อมูลบริษัทของลูกค้าจะช่วยให้ผู้ใช้ใส่ข้อมูลลงทะเบียนธุรกิจลูกค้าที่ถูกต้อง โปรดทราบว่า ปัจจุบันฟังก์ชันนี้รองรับแค่การสอบถามข้อมูลผู้ประกอบการธุรกิจที่ลงทะเบียนในจีนแผ่นดินใหญ่เท่านั้น`,
"label.chatter":`ยฺหวินเทีย`,
"label.sso.goBackToList":`กลับไปยังรายการ: ตัวจัดการคีย์`,
"label.mobile.side.tab.state":`เริ่มแถบด้านข้างที่กำหนดเอง`,
"label.weixin.addbus":`เพิ่มยานพาหนะ`,
"label.dropbox.description":`เชื่อมต่อบัญชี DropBox ของคุณเพื่อใช้ใน CloudCC`,
"label.service.newBuildDialog.available.tousers":`ทำให้ตัวกรองนี้สามารถใช้ได้กับผู้ใช้ทั้งหมด`,
"label.knowledge.language.thai":`ภาษาไทย`,
"label.passwordPolicy.setup.foreverlock":`ถาวร (ต้องให้ผู้ดูแลระบบปลดล็อก)`,
"label.bmap.unreported.location":`คุณไม่ได้รายงานข้อมูลตำแหน่งที่ตั้ง กรุณาตั้งค่าในบัญชีวีแชทสาธารณะ`,
"label.tag.field":`ป้ายกำกับ`,
"label.addyourlanguage":`คลิก "เพิ่ม" เพื่อเพิ่มภาษาที่องค์กรของคุณรองรับ`,
"label.chat.topic.my.use":`หัวข้อที่ฉันใช้`,
"UG.contact.06":`นำเข้าผู้ติดต่อ`,
"label.embed_code":`Embed code`,
"label.campaign.channel.input.chenben":`3. ต้นทุนที่แท้จริง:`,
"label.quickbooks.estimates":`ประมาณการ`,
"label.report.items.i.created":`รายงานที่สร้างโดยฉัน`,
"label.forecast.edit.fwqd":`ขอบเขตเริ่มต้น`,
"label.validate.function.funcExplain.DATEVALUE":`ส่งกลับฟิลด์วันที่ (รวมถึงปี เดือน วัน)ตามฟิลด์วันที่/เวลาที่ป้อน (รวมถึงปี เดือน วัน และเวลา GMT)`,
"vue_label_helpcenter_calendar1.1":`อิเวนต์เป็นเครื่องมือที่มีประสิทธิภาพเพื่อให้คุณเข้าใจความสัมพันธ์กับลูกค้าและปิดการขายได้เสมอ คุณสามารถเชื่อมอิเวนต์กับโอกาสทางธุรกิจ ลีด ลูกค้าและผู้ติดต่อ มุมมองปฏิทินจะแสดงบันทึกอิเวนต์เป็นหลัก <br>1.มุมมองปฏิทินและมุมมองรายการ<br>ดูปฏิทิน<br>คลิกแท็บปฏิทินของเมนูนำทางเพื่อไปที่หน้าปฏิทิน<br>มุมมองปฏิทิน<br>การจำแนกมุมมองปฏิทิน: มุมมองปฏิทินแบ่งออกเป็นรายเดือน รายสัปดาห์ รายวันและความพร้อมใช้งาน ข้อมูลที่บันทึกไว้ในช่วงเวลาต่างๆ สามารถแยกแสดงผ่านรูปแบบกริดที่แตกต่างกัน มุมมองความพร้อมใช้งานจะแสดงข้อมูลบันทึกรายวันของแต่ละปฏิทินเป็นมิติข้อมูลรวมถึงปฏิทินของฉันและปฏิทินอื่นๆ คลิกไอคอน "ปุ่มปฏิทิน" ที่ด้านบนขวาของหน้าปฏิทินเพื่อเปลี่ยนมุมมอง <br>สิ่งที่สามารถดูได้ในมุมมองปฏิทิน: ปฏิทินรวมถึงปฏิทินของฉันและปฏิทินอื่นๆ ในมุมมองปฏิทิน คุณสามารถดูข้อมูลที่บันทึกไว้ทั้งหมดของปฏิทินของฉัน ปฏิทินอิเวนต์และปฏิทินออบเจ็กต์ เราเรียกบันทึกเหล่านี้ว่า "รายการปฏิทิน". <br>คุณสามารถดูอิเวนต์ของคุณทั้งหมดผ่านมุมมองปฏิทิน ปฏิทินที่คุณสร้างด้วยออบเจ็กต์จะแสดงข้อมูลในฟิลด์วันที่เป็นรายการปฏิทินบนมุมมองปฏิทิน คุณยังสามารถดูปฏิทินอื่นๆ ในมุมมองปฏิทิน กล่าวคือคุณสามารถดูรายการปฏิทินใดๆ ที่เพื่อนร่วมงานของคุณแบ่งปันมุมมองให้ได้ <br>`,
"label.tabpage.rowsz":`ลบแถว`,
"label.file.library.managemembers.memberlist":`สมาชิกปัจจุบัน`,
"label.report.action.addtodashboard4":`เพิ่มลงในแดชบอร์ดที่มีอยู่`,
"label.chat.send.voice":`ส่งเสียง`,
"label.home.dashboard.add":`เพิ่มแดชบอร์ดหน้าแรก`,
"front-dialog-module-v1-copied-requestid":`คัดลอก ID คำขอแล้ว`,
"label.customfields.exportdata":`ส่งออกข้อมูล""`,
"label.emailobject.signature":`แก้ไขลายเซ็น`,
"label.hide.source":`ซ่อนรหัสต้นฉบับ`,
"label.icon.71":`ซ่อมบำรุง`,
"vue_label_help_whatslightning":`Lightning คืออะไร`,
"report.type.label.systemReport":`รายงานระบบ`,
"front-kefu-moudle-v1-input-email":`กรุณากรอกอีเมล์`,
"label.event.moveup.5minutes":`ล่วงหน้า 5 นาที`,
"message.error.postsid.null":``,
"UG.Account.05":`แผนผังผู้ติดต่อ`,
"label_emailtocloudcc_description3":`เพิ่มอีเมลธุรกิจของคุณ เช่น sales@company.com, info@company.com, และsupport@company.com ที่นี่ ระบบจะสร้างลีดหรือเคสตามอีเมลที่ได้รับโดยอัตโนมัติ เพื่อให้แน่ใจว่าจะติดตามอีเมลขาเข้าจากลูกค้าได้อย่างทันท่วงที`,
"report.label.searchresult":`ผลการค้นหา`,
"vue_label_report_detailsonly_desc":`ส่งออกเฉพาะบรรทัดรายละเอียดเท่านั้น และใช้ข้อมูลนี้เพื่อคำนวณเพิ่มเติมหรืออัปโหลดไปยังระบบอื่นๆ`,
"label.partnerCloud.partnerAccount.payment":`จํานวนเงินที่ชําระ:`,
"vue_label_commonobjects_view_select_member":`เลือกสมาชิก`,
"label.emailtocloudcc.step1.lead1":`Email to Lead`,
"label.forecast.settings.current":`รอบปัจจุบัน`,
"label.canceluploadfile":`ยกเลิกการอัปโหลด`,
"label.manual.shared":`การแบ่งปันที่กำหนดเอง`,
"label.document.uniquename.length.cannot.than":`ชื่อเฉพาะเอกสารต้องยาวไม่เกิน 255`,
"vue_label_lead_notcreateopportunity":`ไม่สร้างโอกาสทางธุรกิจ`,
"APPIntegration.Social.twittererror":`ต้องเป็น URL ของ twitter.com ที่ถูกต้องตามกฎหมาย`,
"message.duplication.label.errormessage":`ข้อความแสดงข้อผิดพลาด`,
"label.file.img":`รูปภาพ`,
"label.tabpage.sum":`รวม`,
"label.permission.systempermission.fenpei":`การกำหนดสิทธิ์ระบบ`,
"template.dashboard.folder.data":`การวิเคราะห์ข้อมูล`,
"label.sms.account":`บัญชีผู้ใช้`,
"label.product.filter":`ตัวกรองผลิตภัณฑ์`,
"label.file.content":`เนื้อหาข้อความ`,
"label.percent":`เปอร์เซ็นต์`,
"label.single.attachment":`ไฟล์เดียว`,
"label.processsetting.failed.enable.process":`การเปิดใช้งานกระบวนการล้มเหลว!`,
"label.view.modify":`แก้ไขมุมมอง`,
"label.knowledgebase.enter.keywords.filter":`ป้อนคีย์เวิร์ดเพื่อกรอง`,
"label.tabpage.uploadfailez":`การอัปโหลดล้มเหลว โปรดอัปโหลดใหม่อีกครั้ง`,
"label.please.enter.the.target.model.name":`โปรดป้อนชื่อแบบจำลองเป้าหมาย`,
"label.layout.availabletab.related":`ที่เกี่ยวข้อง`,
"label.label":`ป้ายกำกับ`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`วันเสาร์`,
"label.addattachment.unit":`ไบต์`,
"vue_label_commonobjects_view_selected":``,
"label.view.sortview.printble":`พิมพ์ได้`,
"label.umeng.insert.approval.approvaling":``,
"label.forecast.customforecast.tztotal":`จำนวนรวมหลังการปรับปรุง`,
"label.ccchat.failtoset":`การตั้งค่า ccchat ผิดพลาด`,
"label.ccchat.message.new.error2":`ผู้ใช้ Chat ของ`,
"label.validate.function.category.Advanced":`ขั้นสูง`,
"label.projectManagement.team.members":`สมาชิกในทีม`,
"vue_label_report_clickcrosstofliter":`คลิกที่จุดตัดในตารางข้างต้นเพื่อกรองรายละเอียด`,
"lable.opppdt.selPdt.leasttwenty":`โปรดเลือกมากสุดยี่สิบห้ารายการ`,
"label.campaign.channel.download":`ดาวน์โหลดรหัสคิวอาร์แบบความละเอียดสูง`,
"component_event_label_person":`ผู้ได้รับมอบหมาย`,
"vue_label_homepage_new_homepage":`หน้าแรกใหม่`,
"label.version.sum.vlidaterule":`เกณฑ์การทวนสอบ`,
"vue_label_chat_click_for_details":`คลิกเพื่อดูรายละเอียด`,
"label.fold":`ยุบ`,
"label.readonly":`อ่านอย่างเดียว`,
"label.h5.similar.opportunity.result":`ผลลัพธ์ของโอกาสทางธุรกิจที่คล้ายกัน`,
"label.yourimportsuc":`นำเข้าตามคำขอของคุณแล้ว โปรดตรวจสอบอีเมลของคุณ`,
"label.report.line.yixuan":`คอลัมน์รายงานที่เลือก`,
"setup_layout_label_areaname":`ชื่อภูมิภาค`,
"label.forecast.edit.title":`เป้าหมาย`,
"label.chatter.allweather":`ทุกโอกาส`,
"label.service.ganttBaiduMap.scheduled.endtime":`กำหนดเวลาสิ้นสุด`,
"lable.create.new.list":`สร้างรายการใหม่`,
"label.emailobject.groupemail.msg3":`{0} ผู้รับ`,
"lable.opppdt.selPdt.description":`ระบุคีย์เวิร์ดและเงื่อนไขการคัดเลือก หลังจากนั้นคลิกค้นหา"และเริ่มค้นหา คลิก "ตัวกรองเพิ่มเติม" เพื่อใช้ตัวกรองหนึ่งตัวขึ้นไป ผลการค้นหาจะรวมไปถึงบันทึกทั้งหมดที่ตรงกับคีย์เวิร์ดและเงื่อนไขตัวกรอง"`,
"label.file.versionerror1":`คุณสามารถคลิกลิงก์ด้านล่างเพื่อไปยังแท็บไฟล์ของอินเทอร์เฟซรุ่นใหม่ได้โดยตรง หรือคุณจะเปลี่ยนไปยังหน้าอินเทอร์เฟซรุ่นใหม่ด้วยตนเองแล้วใช้เมนูไฟล์ก็ได้`,
"label.under.approve.record":`บันทึกที่อยู่ระหว่างการอนุมัติ`,
"front-epwechat-module-v1-open":`เปิด`,
"label.projectManagement.delete.task":``,
"label.reportforms":`รายงาน`,
"label.tabpage.onlymevisible":`มีแค่ฉันที่มองเห็น`,
"label.customer.tab.please.name":`กรุณาใส่ชื่อแท็บ`,
"label_emailsync_form_stutas":`สถานะเปิดใช้งาน`,
"message.recordtype.nolist":`ชนิดบันทึกที่ไม่ได้กำหนด`,
"label.version.forecasting.sales":`การพยากรณ์การขาย`,
"chatter.sel.mostfield":`คุณเลือกได้มากที่สุด`,
"label.data.derived":`การส่งออกข้อมูล`,
"label.component.helper.businesschange.expiredtask":`โอกาสทางธุรกิจที่ภารกิจเกินกำหนด`,
"label.cycle":`วงจร`,
"lable.product.standp":`ราคามาตรฐาน`,
"label.sendemail.batchapproval":`การอนุมัติแบบชุด`,
"message.organization.not.open.mffverification":`องค์กรของคุณไม่ได้เปิดใช้งานการยืนยันแบบ 2 ขั้นตอน`,
"label.icon.131":`ร่ม`,
"UG.activity.08":`การนัดหมาย`,
"label_partner_workspace_member_choicepermission":`เลือกชุดสิทธิ์`,
"label.reportTypeCategory":`แหล่งข้อมูลรายงาน`,
"label.exporttwotype":`คุณสามารถส่งออกข้อความได้ 2 ประเภท`,
"message.oppdt.selectpricebook":`กรุณาเลือกสมุดราคาก่อน`,
"vue_label_dashboard_generatefromlistview":`สร้างจากมุมมองรายการ`,
"label.quote.title":`หัวข้อ`,
"label.tianyancha.businessverify.cancel.sure":`หลังจากปิดการใช้งานการทวนสอบข้อมูลธุรกิจจะไม่สามารถเขียนแก้ข้อมูลการจดทะเบียนธุรกิจได้เมื่อสร้าง/แก้ไขลูกค้า คุณยืนยันหรือไม่?`,
"label.save":`บันทึก`,
"label.mobile.quickcreate.default.appstore":`แอปสโตร์`,
"label.partnerCloud.orderingPlatform.configure":`ขณะนี้ยังมีผลิตภัณฑ์{a}ที่ยังไม่ได้กําหนดค่า โปรดกําหนดค่าแล้วบันทึก`,
"front-epwechat-module-v1-unbound-role":`บทบาทที่ไม่ได้ผูก`,
"label.partnerCloud.financeSetting.enterAlipay":`กรุณาป้อนบัญชีธุรกิจอาลีเพย์`,
"label.validate.function.funcExplain.TODAY":`ส่งกลับวันที่ปัจจุบัน`,
"label.visualpage.parameter.values":`แสดงค่าพารามิเตอร์บนเพจโดยตรง:`,
"label.version.task.and.activity":`การติดตามภารกิจและกิจกรรม`,
"label.audit.history":`รอการตรวจสอบ`,
"setup.object.field.dependency.label.addtolist":`เพิ่มค่าที่เลือก`,
"vue_label_report_exportquantity":`ปริมาณการส่งออก:`,
"label_tabpage_havez":`มี`,
"label.partnerCloud.partnerAccount.amountOfRebate":`จำนวนเงินคืนที่มีอยู่`,
"label.createralias":`นามแฝงผู้สร้าง`,
"label.created_followup":`สร้างอีเมลติดตาม`,
"label_chatter_mygroups":`กลุ่มของฉัน`,
"label.chat.topic.no.display":`ไม่มีหัวข้อที่จะแสดง`,
"vue_label_calendar_month_view":`ปฏิทิน-มุมมองรายเดือน`,
"label.service.gantt.resources.assigned.work":`ทรัพยากรที่ได้รับมอบหมายงาน`,
"UG_activity_07":`สร้างภารกิจ`,
"label.quote.xsjg":`ราคาขาย`,
"message.toomanyrows":`สืบค้นบันทึกมากเกินไป!`,
"label.importsourcestep1":`ขั้นตอนที่ 1: ไฟล์ที่พร้อมสำหรับการแปล`,
"vue_label_normal_appointment_sf":`ตารางการนัดหมาย`,
"lable.list.queue.message":`ไม่สามารถลบคิวได้เนื่องจากมีบันทึกออบเจ็กต์ที่เป็นของคิวอยู่`,
"label.service.major.event.desc":`อิเวนต์สําคัญหมายถึงขั้นตอนที่ขึ้นอยู่กับเวลาในกระบวนการ คุณสามารถเพิ่มอิเวนต์สำคัญได้ในช่วงเริ่มต้นของกระบวนการให้สิทธิ์ จากนั้นคุณสามารถใช้กระบวนการกับสิทธิ์ของลูกค้า และสร้างเคสหรือใบสั่งงานได้`,
"label.ems.hostorport.null":`เซิร์ฟเวอร์และหมายเลขพอร์ตไม่สามารถว่างเปล่า`,
"chatter.group.private":`ส่วนบุคคล`,
"label.icon.192":`สบู่`,
"vue_label_systemSettings_list":`การตั้งค่าการแสดงรายการที่เกี่ยวข้อง`,
"label.activity.saveobj.notnull":`ออบเจ็กต์ที่บันทึกไม่สามารถว่างเปล่า`,
"vue_label_chatter_current_no_people_approval":`ขณะนี้ยังไม่มีผู้ต้องการอนุมัติ`,
"label.tianyancha.reglocation":`ที่อยู่ที่ลงทะเบียน`,
"UG_ST_005":`ฉันเข้าใจแล้ว ไม่ต้องแสดงหน้านี้อีกครั้งหน้าให้เข้าไปโดยตรง`,
"label.vlidaterule.example.truetodisplay":`ข้อความนี้จะแสดงเมื่อสูตร "เงื่อนไขข้อผิดพลาด" เป็น <b>จริง</b>`,
"label.icon.99":`บันทึกย่อ`,
"label.whenselectmoreapprover":`เมื่อมีการเลือกผู้อนุมัติหลายคน`,
"label.forecast.customforecast.directorbest":`ผู้ใต้บังคับบัญชาโดยตรงที่มีประสิทธิภาพยอดเยี่ยม`,
"label.customsetting.view.introduce":`สร้างฟิลด์สำหรับการตั้งค่าแบบกำหนดเองของคุณ ข้อมูลฟิลด์เหล่านี้จะใส่ลงในแคชโดยแอปพลิเคชัน`,
"label.there.are.no.unenabled.rules":`ยังไม่ได้เปิดใช้กฎ`,
"front-project-module-v1-plase-selectemplat":`กรุณาเลือกแม่แบบโครงการ`,
"label.campaignmember.selectmember.from":`จาก`,
"setup_layout_button_quicksave":`บันทึกด่วน`,
"label.setup.service.report":`การตั้งค่าแม่แบบรายงานการบริการ`,
"label.visualpage.direction.for.use":`คู่มือการใช้เพจที่กำหนดเองของแพลตฟอร์ม [รุ่น 2.0]`,
"message.modify":`ยืนยันว่าจะแก้ไขหรือไม่?`,
"label.sms.inside":`ภายใน`,
"label.category.3":`การศึกษา`,
"label.login.mfadevice.verification.title":`ทวนสอบอุปกรณ์ MFA`,
"UG_Forcast_08":`ขั้นตอนก่อนหน้า`,
"label.projectManagement.unable.to.complete":`ไม่สามารถดําเนินการให้เสร็จสมบูรณ์ได้`,
"front-kefu-moudle-all-missphone":``,
"font-evaluate-module-v1-emergency":``,
"label.sso.saml.sp.idsource.attr":`ไอดีในแอตทริบิวต์`,
"chatter.not.meg":`ส่งข้อความเปล่าไม่ได้`,
"label.chatter.startDate":`วันที่เริ่มต้น`,
"label.emailobject.track.times":`เปิด {0} ครั้ง`,
"label.customsetting.fieldhasbeendeleted":`ลบฟิลด์แล้ว`,
"label.knowledge.setting.hint.thirteen":`เพิ่มหมวดหมู่ข้อมูลอื่น`,
"message.duplication.label.newfiltertitle":`ตัวกรองซ้ำใหม่`,
"setup_object_field_dependency_label_selectedfieldvalue":`ค่าฟิลด์ที่เลือก`,
"vue_label_calendar_who_currently_has_access":`ตอนนี้ใครมีสิทธิเข้าถึง`,
"message.passwordPolicy.validate.minlengthe":`อักขระ`,
"label.emailsync.status.disconnect":`ยกเลิกการเชื่อมต่อ`,
"label.applt.down.one":`ดาวน์โหลดในคลิกเดียว`,
"label.manageAll.sel.one2":`รายการที่ฉันเสนอ`,
"message.error.SQLTimeout":`ระบบไม่ว่าง โปรดลองอีกครั้งในภายหลัง!`,
"label.global.search.obj.setup":`การตั้งค่าออบเจ็กต์ค้นหาระดับโกลบอล`,
"vue_label_commonobjects_view_chat":`กลยุทธ์กลุ่ม`,
"vue_label_systemSettings_startSet":`เริ่มการตั้งค่า`,
"label.quickbooks.viewlist.balance":`ยอดคงเหลือ`,
"message.error.fieldid.null":`id เนื้อหาไฟล์ fieldid ต้องไม่ว่างเปล่า!`,
"label.replaceallnullvalue":`แทนที่ค่าว่างทั้งหมด`,
"label.georgia.time":`เวลาจอร์เจีย`,
"label.hastransfer":`รวมที่ข้ามสเตจแล้ว`,
"label.partner.all.description":`คำอธิบาย`,
"font-evaluate-module-v1-following-peopple":``,
"label_business_count":`จำนวนโอกาสทางธุรกิจ`,
"vue_label_ccchat_closedetail":`เก็บโพสต์เดิม`,
"label.partner.all.disable":`ปิดการใช้งาน`,
"label.view.relationship":`ความสัมพันธ์ของออบเจ็กต์`,
"label.noless":`>= มากกว่าหรือเท่ากับ`,
"label.sendsms.batch.step2":`ขั้นตอนที่ 2: เลือกแม่แบบข้อความสั้นหรือเนื้อหาข้อความสั้นที่กำหนดเอง`,
"label.stdashbord.xsld.business.jieduan":`ชื่อสเตจ`,
"label.appupload.component.type.trigger":`ทริกเกอร์`,
"label.knowledge.setting.data.two":`ต้องระบุชื่อหมวดหมู่`,
"label.color.display.of.completion.rate":`การแสดงสีอัตราความสำเร็จ`,
"label.loginhis.default":`แสดงประวัติ 200 รายการล่าสุดโดยค่าเริ่มต้น`,
"vue_label_pricebook_book":`สมุดราคาปัจจุบัน`,
"label.knowledgebase.data.deletion.failed":`การลบข้อมูล {a} รายการล้มเหลว`,
"label_partner_workspace_member_permission":`ตัวเลือกชุดสิทธิ์`,
"label.list.userinterface.approval.setup":`ตั้งค่าการอนุมัติ`,
"label.weixin.binding.effect":`binding ล้มเหลว โปรดเข้าสู่ระบบอีกครั้งเพื่อรับ`,
"label.appupload.install.newapicannotnull":`ชื่อ api ใหม่ไม่สามารถว่างเปล่า`,
"chatter.feed.menutype.feed.company":`เวยเทียทั้งหมด`,
"label.assignment.setup.detail.email":`อีเมล`,
"label_tabpage_selectcontentz":`โปรดเลือกเนื้อหา`,
"template.report.converted.leads.campaign":`ลีดที่ข้ามสเตจแล้วในแคมเปญ`,
"label.forecast.season":`ฤดูกาลนี้`,
"label.post":`โพสต์`,
"label.knowledge.setting.hint.fifteen":`วางรากฐานเรียบร้อยแล้ว ตอนนี้คุณและทีมของคุณสามารถเขียนและจัดระเบียบบทความ Knowledge ได้`,
"front-kefu-moudle-v1-Seats-name":`ชื่อเล่น Seat`,
"label.weixin.leadname":`ชื่อลีด`,
"label.account.quarter":`ไตรมาส`,
"label.detail.field":`ดูฟิลด์`,
"label.icon.189":`เครื่องสำอาง`,
"label.appointment.disable.reappointment":``,
"label.appointmentconfirmpage.wizard.subtitle1":`ชื่ออิเวนต์`,
"label.campaign.channel.step6.remark3":`ระบบจะสร้างรหัสเชิญเฉพาะสำหรับพนักงาน พนักงานสามารถใช้รหัสนี้ในการเชิญ และสามารถนับเป็นผลงานส่วนบุคคลได้`,
"System.AddressFieldType.Post":`รหัสไปรษณีย์`,
"label_partner_new_step2":`ขั้นตอนที่2: ยืนยันแม่แบบ`,
"vue_label_helpcenter_file":`ดูและจัดการไฟล์ของคุณ<br>ใช้ออบเจกต์ไฟล์แบบใหม่เพื่อดูและจัดการไฟล์ทั้งหมดของคุณ หรือไฟล์ที่ผู้อื่นแบ่งปัน คุณสามารถดูตัวอย่างไฟล์แบบออนไลน์ได้ <br>ไลบรารีเอกสาร<br>ใช้ฟังก์ชันไลบรารีเอกสารเพื่อสร้างคลังความรู้ของทีม ตั้งค่าผู้ดูแลระบบและสมาชิกที่แตกต่างกันเพื่อการจัดการที่สะดวก ใช้ฟังก์ชันโฟลเดอร์เพื่อจัดประเภทเอกสาร`,
"label.locateddowncurrentvalue":`ค่าที่อยู่ด้านล่างของค่าปัจจุบัน`,
"label.tianyancha.businessverify.msg5":`2: ความน่าเชื่อถือของการบริการ:`,
"label.setup.mobile.bottombutton.change.success":`การแก้ไขสำเร็จ`,
"label.appointmentconfirmail.wizard.subtitle2":`เวลา`,
"label.email.address.lookup":`ค้นหาที่อยู่อีเมล`,
"setup.mainpage.label.welcome":`ยินดีต้อนรับสู่แพลตฟอร์ม CloudCC PaaS ฟังก์ชันหลักของแพลตฟอร์มมีดังนี้`,
"label.icon.55":`รถปราบดิน`,
"label_tabpage_enterrecordnamez":`กรุณาใส่ผู้บันทึก`,
"label.tabpage.andz":`และ`,
"label.selectfiletoimport":`เลือกไฟล์ที่จะนำเข้า`,
"label.version.sum.trigger":`ทริกเกอร์`,
"label.multi.layout":`เค้าโครงแถว`,
"pagecreator.button.back":`ขั้นตอนก่อนหน้า`,
"label.imgfield.truetype":`โปรดอัปโหลดประเภทรูปภาพที่ถูกต้อง`,
"front-kefu-moudle-v1-publicKey":``,
"label.data.exp.newtemp":`การสร้างแม่แบบ`,
"label.martrixreport.2018.step4.new":`ขั้นตอนที่ 4: เลือกคอลัมน์รายงาน`,
"label.sendemail.chat.addComentsatsubject":`CloudCC CCChat แสดงความคิดเห็นเกี่ยวกับฉัน`,
"vue_label_applauncher_description_leadpool":`ใช้ฐานข้อมูลลีดในการจัดการสถานะการติดตามลีดภายในองค์กรได้อย่างสะดวกสบาย ทั้งยังกระตุ้นให้พนักงานปิดการขายให้เสร็จสมบูรณ์`,
"label.knowledgebase.archive.published.articles.without.drafts":`คุณเก็บถาวรได้เฉพาะบทความเผยแพร่ที่ไม่มีฉบับร่าง`,
"label.projectManagement.bar.chart":`กราฟแท่ง`,
"label.ccpeak.condition.return.sort":`ส่งกลับและจัดเรียงตามเงื่อนไข`,
"label.salescloud.opportunity.contactrole":`บทบาทผู้ติดต่อโอกาสทางธุรกิจ`,
"label.language":`ภาษา`,
"message.error.view.badprevilege":`ขออภัย คุณไม่มีสิทธิ์ใช้บริการนี้ โปรดติดต่อผู้ดูแลระบบ!`,
"label.textmessage.managetemplates":`จัดการแม่แบบ`,
"message.error.type.null":`ประเภทไม่สามารถว่างเปล่า!`,
"setup.mainpage.label.welcome9":`ผู้ใช้ไม่จําเป็นต้องเขียนรหัส เพียงลากและวางเม้าส์ก็จะปรากฎประเภทการแสดงผล และการปรับเค้าโครงขององค์ประกอบเพจทั้งหมด รวมถึงการตั้งค่าคุณสมบัติของฟิลด์ เช่น ฟิลด์อ่านอย่างเดียว และฟิลด์บังคับ เป็นต้น`,
"label.appupload.component.type.page":`เพจที่กำหนดเอง`,
"label.textmessage.bookschedule":`กรุณาคลิกที่ลิงก์ด้านล่างเพื่อดูและจองแผนการเดินทางของฉัน:`,
"component_chatter_post_button_save":`เผยแพร่`,
"lable.oppt.jieduan.signcomplete":`ทำเครื่องหมาย{labelname}ว่าเสร็จสมบูรณ์`,
"label.help.notes":`ช่วยเหลือและนำทาง`,
"label_tabpage_reallproplez":`เจ้าของบันทึก`,
"label.obtain.authorization.failure":`ไม่สามารถรับรหัสการให้สิทธิ์ โปรดให้สิทธิ์อีกครั้ง`,
"label.account.FiscalQuarter":`ไตรมาสบัญชี`,
"label.customsetting.savecustomvalue":`มีข้อมูลเกี่ยวกับตำแหน่งที่อยู่นี้อยู่แล้ว กรุณาแก้ไขแล้วบันทึกอีกครั้ง`,
"label.maximum":`ค่าสูงสุด`,
"component_chatter_file_label_maxsize":`ขนาดไฟล์สูงสุดคือ 20M`,
"c218":``,
"c875":``,
"c183":``,
"c366":``,
"c91":``,
"c184":``,
"c750":``,
"c619":``,
"c69":``,
"c675":``,
"c533":``,
"c167":``,
"c682":``,
"c960":``,
"c850":``,
"c343":``,
"c8":``,
"c157":``,
"c397":``,
"c556":``,
"c563":``,
"c179":``,
"c147":``,
"c303":``,
"c885":``,
"c808":``,
"c718":``,
"c414":``,
"c9":``,
"c15":``,
"c59":``,
"c504":``,
"c836":``,
"c187":``,
"c208":``,
"c952":``,
"c104":``,
"c346":``,
"c913":``,
"c571":``,
"c44":``,
"label.social.posts.content.null":``,
"c852":``,
"c561":``,
"obtain.contract.envelopeid.fail":``,
"c465":``,
"c982":``,
"c350":``,
"c352":``,
"c670":``,
"front-electronic-signature-given":``,
"c542":``,
"c314":``,
"c148":``,
"c47":``,
"c754":``,
"c326":``,
"c289":``,
"c196":``,
"c63":``,
"c769":``,
"c216":``,
"c842":``,
"c389":``,
"c7":``,
"c981":``,
"c143":``,
"c930":``,
"c515":``,
"c393":``,
"c357":``,
"c597":``,
"front-electronic-signature-cancelIntro1":``,
"c271":``,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":``,
"c424":``,
"c711":``,
"c197":``,
"front-electronic-signature-save-success":``,
"c765":``,
"c286":``,
"c145":``,
"c264":``,
"label.china":``,
"label.no.bind.mobile":``,
"c95":``,
"front-electronic-signature-open-signInfo1":``,
"c391":``,
"c106":``,
"c519":``,
"c528":``,
"c78":``,
"c41":``,
"c517":``,
"c774":``,
"c296":``,
"c757":``,
"front-electronic-signature-confirmintro":``,
"c446":``,
"c238":``,
"c980":``,
"c802":``,
"c387":``,
"c965":``,
"c480":``,
"c937":``,
"c632":``,
"c131":``,
"c680":``,
"c806":``,
"c649":``,
"c797":``,
"c616":``,
"c169":``,
"c21":``,
"c231":``,
"c555":``,
"c583":``,
"front-electronic-signature-open-signInfo2":``,
"c822":``,
"c600":``,
"c442":``,
"c762":``,
"label.user.not.permission":``,
"c35":``,
"c921":``,
"c305":``,
"c730":``,
"c525":``,
"c942":``,
"c780":``,
"c447":``,
"c369":``,
"c702":``,
"c22":``,
"c79":``,
"c785":``,
"label.insert.approval.reassign.error":``,
"c273":``,
"c3":``,
"c448":``,
"c495":``,
"c429":``,
"c16":``,
"c128":``,
"c955":``,
"c716":``,
"c638":``,
"c746":``,
"c534":``,
"c948":``,
"c317":``,
"c426":``,
"c457":``,
"c263":``,
"c372":``,
"c907":``,
"c771":``,
"c408":``,
"c12":``,
"c379":``,
"c410":``,
"c510":``,
"c701":``,
"c617":``,
"c213":``,
"c473":``,
"c975":``,
"c168":``,
"c121":``,
"label.send.invoice":``,
"c792":``,
"c686":``,
"c652":``,
"c136":``,
"c662":``,
"label.invoice.customer.is.error":``,
"c580":``,
"c894":``,
"c570":``,
"c133":``,
"c564":``,
"c854":``,
"c775":``,
"c105":``,
"c729":``,
"c491":``,
"c609":``,
"c611":``,
"c843":``,
"c933":``,
"c383":``,
"c186":``,
"c608":``,
"c149":``,
"c486":``,
"c598":``,
"c726":``,
"c645":``,
"label.verificationCode.is.invalid":``,
"c904":``,
"c594":``,
"c103":``,
"c188":``,
"c891":``,
"c902":``,
"c484":``,
"c421":``,
"c406":``,
"c739":``,
"c329":``,
"c351":``,
"c622":``,
"2":``,
"c463":``,
"c268":``,
"label.mobile.no.letter.blankcharacter":``,
"c438":``,
"c581":``,
"c953":``,
"c90":``,
"c2":``,
"c897":``,
"c444":``,
"c242":``,
"c135":``,
"c659":``,
"c773":``,
"c11":``,
"c799":``,
"c880":``,
"c890":``,
"c846":``,
"front-electronic-signature-sucessSign":``,
"c472":``,
"c963":``,
"c390":``,
"c248":``,
"c646":``,
"c308":``,
"c858":``,
"c152":``,
"c316":``,
"c435":``,
"c362":``,
"c800":``,
"c415":``,
"c735":``,
"c903":``,
"label.insert.approval.massreassign.error":``,
"c354":``,
"c409":``,
"c651":``,
"c582":``,
"c826":``,
"c781":``,
"c873":``,
"c837":``,
"label.diedirect.sale":``,
"c798":``,
"c368":``,
"c770":``,
"c882":``,
"front-setting-dialog-title-two":``,
"c535":``,
"front-electronic-signature-look-account":``,
"c19":``,
"c52":``,
"c388":``,
"c18":``,
"c820":``,
"c285":``,
"c478":``,
"c164":``,
"label.tip.excess.quota":``,
"c318":``,
"c698":``,
"c312":``,
"c110":``,
"c549":``,
"c845":``,
"c282":``,
"c270":``,
"c288":``,
"c878":``,
"c324":``,
"c129":``,
"c339":``,
"c405":``,
"c848":``,
"c345":``,
"c591":``,
"c180":``,
"c126":``,
"c311":``,
"c587":``,
"c37":``,
"c840":``,
"c241":``,
"c141":``,
"obtain.contract.fail":``,
"c945":``,
"c454":``,
"c34":``,
"c243":``,
"c548":``,
"c807":``,
"c590":``,
"c831":``,
"c198":``,
"c977":``,
"c66":``,
"label.twitter.title.setting":``,
"c922":``,
"front-email-payment-Invoice-Tips":``,
"c605":``,
"c403":``,
"c156":``,
"c635":``,
"c753":``,
"c647":``,
"c295":``,
"c915":``,
"front-electronic-signature-signStatus":``,
"c568":``,
"c744":``,
"c464":``,
"c385":``,
"c392":``,
"c418":``,
"c256":``,
"c690":``,
"c261":``,
"c62":``,
"c892":``,
"c909":``,
"c883":``,
"c134":``,
"c896":``,
"c974":``,
"c209":``,
"c185":``,
"c796":``,
"c60":``,
"c866":``,
"c666":``,
"c219":``,
"c732":``,
"c155":``,
"c511":``,
"c240":``,
"c468":``,
"c961":``,
"c404":``,
"c586":``,
"c694":``,
"c297":``,
"c860":``,
"c58":``,
"c920":``,
"c27":``,
"c94":``,
"c1":``,
"c557":``,
"c294":``,
"c970":``,
"c565":``,
"c668":``,
"c972":``,
"c660":``,
"c433":``,
"c443":``,
"c275":``,
"c691":``,
"c956":``,
"c910":``,
"c692":``,
"c355":``,
"c122":``,
"c395":``,
"c689":``,
"c344":``,
"c656":``,
"c943":``,
"front-electronic-signature-outerSinger":``,
"front-generate-v1-invoiceDetail":``,
"front-electronic-signature-open-vertify":``,
"c291":``,
"front-setting-phone-message":``,
"c559":``,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":``,
"c259":``,
"c488":``,
"c6":``,
"front-electronic-signature-signerInfo":``,
"c512":``,
"c507":``,
"c760":``,
"c756":``,
"c321":``,
"c817":``,
"c949":``,
"label.biaoqing.field.relation.tip":``,
"c382":``,
"c265":``,
"c417":``,
"c847":``,
"c494":``,
"c86":``,
"c776":``,
"c709":``,
"label.mobile.orVerificationCode.is.error":``,
"c579":``,
"c413":``,
"c950":``,
"c573":``,
"label.choose.is.tax":``,
"c768":``,
"c604":``,
"c160":``,
"c239":``,
"c834":``,
"c113":``,
"c146":``,
"c313":``,
"c140":``,
"c298":``,
"c681":``,
"c870":``,
"c551":``,
"c88":``,
"c175":``,
"c64":``,
"c319":``,
"label.pay.online":``,
"c941":``,
"c550":``,
"c365":``,
"c908":``,
"c260":``,
"c50":``,
"c869":``,
"c93":``,
"c280":``,
"c23":``,
"front-console-v1-see-contacts":``,
"c607":``,
"c229":``,
"front-filter-v1-filter-by-name":``,
"c125":``,
"c513":``,
"c80":``,
"c648":``,
"c521":``,
"c560":``,
"c973":``,
"c509":``,
"c685":``,
"c178":``,
"c436":``,
"front-electronic-signature-prepareTemplate":``,
"c749":``,
"c114":``,
"c898":``,
"c279":``,
"c232":``,
"c911":``,
"c901":``,
"c663":``,
"c541":``,
"c536":``,
"front-project-v1-batch-deletion-confirmation-information":``,
"c893":``,
"c623":``,
"c493":``,
"c327":``,
"c747":``,
"c728":``,
"front-reportlist-v1-optimizedReport":``,
"c741":``,
"c643":``,
"c537":``,
"front-electronic-signature-add-field":``,
"c626":``,
"c199":``,
"c917":``,
"c159":``,
"c640":``,
"c192":``,
"c978":``,
"c969":``,
"c871":``,
"c814":``,
"c235":``,
"c215":``,
"c425":``,
"c182":``,
"c194":``,
"c657":``,
"c855":``,
"c333":``,
"c338":``,
"c431":``,
"c374":``,
"c506":``,
"font-trade-module-invoice-totalMoney":``,
"c203":``,
"c962":``,
"c786":``,
"c469":``,
"c137":``,
"c483":``,
"c947":``,
"c190":``,
"c386":``,
"c803":``,
"c759":``,
"c823":``,
"c422":``,
"c782":``,
"c416":``,
"c758":``,
"c407":``,
"c51":``,
"c844":``,
"c361":``,
"c602":``,
"c191":``,
"c299":``,
"c432":``,
"c650":``,
"c531":``,
"c13":``,
"c162":``,
"c171":``,
"c230":``,
"c470":``,
"c367":``,
"c26":``,
"c705":``,
"c613":``,
"front-electronic-signature-openSign":``,
"c349":``,
"c683":``,
"c679":``,
"c914":``,
"c224":``,
"c220":``,
"c498":``,
"c566":``,
"front-electronic-signature-ContractTemplate":``,
"c540":``,
"c793":``,
"c293":``,
"front-invoice-online-pay-again":``,
"front-electronic-signature-open-password":``,
"front-v1-partner-background-tooltip":``,
"c449":``,
"c30":``,
"c245":``,
"c923":``,
"c24":``,
"c872":``,
"c886":``,
"c485":``,
"c101":``,
"c816":``,
"c445":``,
"c853":``,
"c398":``,
"c522":``,
"c287":``,
"c578":``,
"c40":``,
"c631":``,
"c489":``,
"c819":``,
"c935":``,
"c625":``,
"c471":``,
"front-electronic-signature-writen":``,
"c889":``,
"c201":``,
"c467":``,
"label.mobile.no.null":``,
"c307":``,
"front-kefu-moudle-wait-calling":``,
"c784":``,
"c490":``,
"c790":``,
"c336":``,
"c453":``,
"c530":``,
"c610":``,
"c359":``,
"c193":``,
"label.mobile.verificationCode.exceeded.times":``,
"c138":``,
"c821":``,
"c381":``,
"c761":``,
"c964":``,
"c585":``,
"c500":``,
"c214":``,
"c714":``,
"c552":``,
"c684":``,
"c54":``,
"c320":``,
"c236":``,
"c123":``,
"c654":``,
"c335":``,
"c267":``,
"c226":``,
"c102":``,
"c637":``,
"c633":``,
"c777":``,
"c223":``,
"c592":``,
"c315":``,
"c89":``,
"c108":``,
"c402":``,
"c748":``,
"c501":``,
"c269":``,
"front-electronic-signature-open-confirm":``,
"c584":``,
"c437":``,
"c738":``,
"c274":``,
"c83":``,
"c206":``,
"c309":``,
"c539":``,
"c304":``,
"c151":``,
"c639":``,
"c720":``,
"c801":``,
"c900":``,
"c695":``,
"c864":``,
"c881":``,
"c794":``,
"c543":``,
"c466":``,
"c867":``,
"c529":``,
"c742":``,
"c430":``,
"c553":``,
"c575":``,
"c124":``,
"c629":``,
"c554":``,
"c547":``,
"c599":``,
"c588":``,
"c703":``,
"c713":``,
"c142":``,
"c153":``,
"c253":``,
"c612":``,
"c400":``,
"c671":``,
"c20":``,
"c514":``,
"c946":``,
"c717":``,
"c174":``,
"c940":``,
"c743":``,
"c441":``,
"c423":``,
"c723":``,
"c664":``,
"c859":``,
"c356":``,
"c221":``,
"front-email-payment-Invoice-Tips1":``,
"c99":``,
"c278":``,
"c364":``,
"c572":``,
"c310":``,
"c247":``,
"c158":``,
"c325":``,
"c877":``,
"front-filter-v1-press":``,
"c505":``,
"c523":``,
"c727":``,
"front-electronic-signature-sended":``,
"c150":``,
"c700":``,
"c824":``,
"c710":``,
"c358":``,
"c544":``,
"c212":``,
"c165":``,
"c932":``,
"c888":``,
"c838":``,
"c98":``,
"c830":``,
"c661":``,
"c818":``,
"c861":``,
"c736":``,
"c204":``,
"c839":``,
"c456":``,
"c341":``,
"c724":``,
"c865":``,
"c332":``,
"c520":``,
"c906":``,
"c482":``,
"c49":``,
"c725":``,
"c76":``,
"c558":``,
"c876":``,
"front-invoices-v1-nofilles-tocreate":``,
"c779":``,
"c603":``,
"c455":``,
"c428":``,
"c55":``,
"c899":``,
"label.facebook.title":``,
"c487":``,
"label.social.posts.info":``,
"c704":``,
"c673":``,
"front-electronic-signature-singed":``,
"c722":``,
"c595":``,
"c120":``,
"c68":``,
"c479":``,
"front-electronic-signature-explain-mainTitle":``,
"c5":``,
"c976":``,
"c812":``,
"c532":``,
"c330":``,
"c249":``,
"c630":``,
"c958":``,
"c170":``,
"c810":``,
"c783":``,
"c968":``,
"c752":``,
"c439":``,
"c67":``,
"front-generate-v1-invoice":``,
"c477":``,
"c966":``,
"c764":``,
"c301":``,
"c61":``,
"c815":``,
"c827":``,
"c688":``,
"c33":``,
"c217":``,
"c721":``,
"c284":``,
"c939":``,
"c503":``,
"c492":``,
"c73":``,
"label.the.peoples.republic.of.china":``,
"c828":``,
"c36":``,
"c954":``,
"front-electronic-signature-innerSinger":``,
"c508":``,
"c833":``,
"c207":``,
"c31":``,
"c71":``,
"c373":``,
"c545":``,
"c77":``,
"label.lastcompiledate":``,
"c119":``,
"c281":``,
"c715":``,
"c127":``,
"c283":``,
"c919":``,
"c82":``,
"front-file-delete-intro":``,
"c606":``,
"c905":``,
"c644":``,
"c75":``,
"c884":``,
"c538":``,
"c322":``,
"c461":``,
"c825":``,
"c56":``,
"c931":``,
"c276":``,
"c334":``,
"c733":``,
"c384":``,
"c139":``,
"c957":``,
"front-electronic-signature-nosign":``,
"c419":``,
"c934":``,
"c677":``,
"c593":``,
"c272":``,
"c811":``,
"c451":``,
"c277":``,
"c244":``,
"c627":``,
"c601":``,
"c251":``,
"c202":``,
"font-social-prohibit-create":``,
"c394":``,
"c323":``,
"front-setting-dialog-title-one":``,
"front-electronic-signature-cancelIntro2":``,
"c353":``,
"c621":``,
"front-v1-partner-image-tooltip":``,
"c772":``,
"c734":``,
"c380":``,
"c979":``,
"c233":``,
"c458":``,
"c697":``,
"c476":``,
"c634":``,
"c144":``,
"c474":``,
"c371":``,
"c420":``,
"c620":``,
"c708":``,
"c100":``,
"c576":``,
"c751":``,
"c252":``,
"c699":``,
"c74":``,
"c805":``,
"c452":``,
"c740":``,
"c596":``,
"c832":``,
"c971":``,
"c262":``,
"c363":``,
"label.singleSignOn.is.invalid":``,
"c72":``,
"c292":``,
"c499":``,
"c574":``,
"c618":``,
"front-setting-phone-format":``,
"c460":``,
"c189":``,
"label.exe.supported.request.rejected":``,
"c835":``,
"c655":``,
"c45":``,
"c43":``,
"c481":``,
"c674":``,
"c266":``,
"c967":``,
"c154":``,
"c841":``,
"c615":``,
"c84":``,
"c401":``,
"c290":``,
"c205":``,
"c928":``,
"c195":``,
"1":``,
"c46":``,
"c459":``,
"c250":``,
"c399":``,
"c518":``,
"c396":``,
"c300":``,
"c789":``,
"c874":``,
"c38":``,
"c228":``,
"c342":``,
"c879":``,
"c173":``,
"c778":``,
"c211":``,
"c496":``,
"c427":``,
"c851":``,
"c32":``,
"c28":``,
"c163":``,
"c225":``,
"c569":``,
"c92":``,
"c412":``,
"c81":``,
"c653":``,
"c516":``,
"c918":``,
"c809":``,
"c181":``,
"c745":``,
"c669":``,
"c929":``,
"c117":``,
"c938":``,
"c112":``,
"c347":``,
"c795":``,
"c17":``,
"c787":``,
"c829":``,
"c161":``,
"c65":``,
"c665":``,
"c767":``,
"c87":``,
"c589":``,
"front-electronic-signature-newTime":``,
"c813":``,
"c85":``,
"c951":``,
"c29":``,
"c210":``,
"c39":``,
"c672":``,
"c97":``,
"c687":``,
"c916":``,
"c475":``,
"c628":``,
"c788":``,
"c177":``,
"c856":``,
"c70":``,
"c546":``,
"c331":``,
"label.order.paidamount.greater.than.total":``,
"c524":``,
"c246":``,
"label.parameter.is.incorrect":``,
"c667":``,
"c737":``,
"c48":``,
"c111":``,
"c755":``,
"c526":``,
"c450":``,
"front-electronic-export-reChoseChimp":``,
"label.invoice.paidamount.greater.than.total":``,
"c222":``,
"c849":``,
"c678":``,
"c502":``,
"c497":``,
"c200":``,
"c658":``,
"c434":``,
"c641":``,
"c944":``,
"c411":``,
"c624":``,
"label.twitter.title":``,
"c791":``,
"c306":``,
"c14":``,
"c176":``,
"c166":``,
"c731":``,
"c237":``,
"c887":``,
"c227":``,
"c257":``,
"c712":``,
"c107":``,
"c370":``,
"c895":``,
"c693":``,
"c763":``,
"c302":``,
"c577":``,
"c258":``,
"c676":``,
"c868":``,
"c53":``,
"c527":``,
"label.facebook.title.setting":``,
"c340":``,
"c706":``,
"label.mobile.used":``,
"c328":``,
"c337":``,
"c642":``
}